'use strict';

/**
 * @ngdoc overview
 * @name app
 * @description
 * # app
 *
 * Main module of the application.
 */

var app = angular
  .module('app', [
    'ngAnimate',
    'ngAria',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngMaterial',
    'ngStorage',
    'ngStore',
    'ui.router',
    // 'ui.utils',
    // 'ui.bootstrap',
    // 'ui.load',
    // 'ui.jp',
    'pascalprecht.translate',
    // 'oc.lazyLoad',
    'angular-loading-bar',
    'angularMoment',
    // 'ui.select2',
    'rd.select2',
    // 'ui.select',
    'angular-bind-html-compile',
    // 'ngQuill',
    'ui.tinymce',
    // 'ui.sortable',
    'imageupload'
  ]);


var DEBUG = true;
if(!DEBUG){
    if(!window.console) window.console = {};
    var methods = ["log", "debug", "warn", "info"];
    for(var i=0;i<methods.length;i++){
        console[methods[i]] = function(){};
    }
}
(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdWindowBox', rdWindowBoxDir)
        .directive('rdWindowBoxHeader', rdWindowBoxHeaderDir)
        .directive('rdWindowBoxBody', rdWindowBoxBodyDir)
        .directive('rdWindowBoxFooter', rdWindowBoxFooterDir)
        .directive('rdWindow', rdWindowDir)
        .run(rdRun);

    function rdRun($rootScope)
    {
        $rootScope.minRdBox = function(event) {
            var rdwindow = angular.element(event.currentTarget.closest(".rdbox"));
            var btn = angular.element(rdwindow.find('.fabtn'));
            var body = angular.element(rdwindow.find(".rdbox-body"));
            var footer = angular.element(rdwindow.find(".rdbox-footer"));
            if(btn.hasClass('fa-minus-square'))
            {
                btn.removeClass('fa-minus-square');
                btn.addClass('fa-plus-square');
            }
            else
            {
                btn.removeClass('fa-plus-square');
                btn.addClass('fa-minus-square');                
            }
            body.toggleClass('animated fadeOut');
            footer.toggleClass('animated fadeOut');
            rdwindow.toggleClass('collapsed-box');
        };
    }

    /** @ngInject */
    function rdWindowBoxDir()
    {
        var data = {
            restrict : "EA",
            replace : true,
            template : genrateWindow,
        };

        function genrateWindow(e,a)
        {
            var wcollapse = a.wcollapse ? a.wcollapse : 'false';
            var s = a.size ? a.size : "col-md-12";
            if(wcollapse === 'true')
            {
                return '<div class="'+s+'"><div class="rdbox collapsed-box">'+e.html()+'</div></div>';
            }
            else
            {
                return '<div class="'+s+'"><div class="rdbox">'+e.html()+'</div></div>';                
            }
        }

        return data;
    }

    function rdWindowBoxHeaderDir()
    {
        var data = {
            restrict : "EA",
            replace : true,
            template : genrateHeader,
        };

        function genrateHeader(e,a)
        {
            var header_translate = a.headertranslate;
            var wcollapse = a.wcollapse ? a.wcollapse : 'false';
            var wcollaspeable = a.wcollaspeable ? a.wcollaspeable : 'false';

            var btn = "";
            var wstart = "";

            if(wcollaspeable === 'true')
            {
                if(wcollapse === 'true')
                {
                    btn = '<a href class="rdbtn btn-rdbox-tool"><i class="fabtn fa fa-plus-square"></i></a>';
                    wstart = '<div class="rdbox-header with-border" ng-click="minRdBox($event)">';
                }
                else
                {
                    btn = '<a href class="rdbtn btn-rdbox-tool"><i class="fabtn fa fa-minus-square"></i></a>';
                    wstart = '<div class="rdbox-header with-border" ng-click="minRdBox($event)">';
                }
            }
            else
            {
                btn = '';
                wstart = '<div class="rdbox-header with-border">';
            }

            var code = "<!--- Header --->";

            code += wstart;

            if(header_translate !== "" && header_translate !== undefined)
            {
                code += '<h3 class="rdbox-title" translate='+header_translate+'>'+e.html()+'</h3>';
                code += '<div class="rdbox-tools pull-right">'+btn+'</div>';
            }
            else
            {
                code += '<h3 class="rdbox-title">'+e.html()+'</h3>';
                code += '<div class="rdbox-tools pull-right">'+btn+'</div>';
            }

            code += '</div>';

            code += "<!--- Header --->";

            return code;
        }

        return data;
    }

    function rdWindowBoxBodyDir()
    {
        var data = {
            restrict : "EA",
            replace : true,
            template : genrateBody,
        };

        function genrateBody(e,a)
        {
            var wcollapse = a.wcollapse ? a.wcollapse : 'false';
            if(wcollapse === 'true')
            {
                return '<div class="rdbox-body animated fadeOut">'+e.html()+'</div>';
            }
            else
            {
                return '<div class="rdbox-body">'+e.html()+'</div>';
            }
        }

        return data;
    }

    function rdWindowBoxFooterDir()
    {
        var data = {
            restrict : "EA",
            replace : true,
            template : genrateFooter,
        };

        function genrateFooter(e,a)
        {
            var footer_translate = a.footertranslate;
            var wcollapse = a.wcollapse ? a.wcollapse : 'false';

            var code = "<!--- Footer --->";

            if(footer_translate !== "" && footer_translate !== undefined)
            {
                if(wcollapse === 'true')
                {
                    code += '<div class="rdbox-footer with-border animated fadeOut" translate='+footer_translate+'>'+e.html()+'</div>';
                }
                else
                {
                    code += '<div class="rdbox-footer with-border" translate='+footer_translate+'>'+e.html()+'</div>';                    
                }
            }
            else
            {
                if(wcollapse === 'true')
                {
                    code += '<div class="rdbox-footer with-border animated fadeOut">'+e.html()+'</div>';
                }
                else
                {
                    code += '<div class="rdbox-footer with-border">'+e.html()+'</div>';
                }
            }

            code += "<!--- Footer --->";

            return code;
        }

        return data;
    }

    function rdWindowDir()
    {
        var data = {
            restrict : "EA",
            replace : false,
            template : genrateWindow,
        };

        function genrateWindow(e,a)
        {
            var header = a.header;
            var footer = a.footer;
            var header_translate = a.headertranslate;
            var footer_translate = a.footertranslate;
            var wcollapse = a.wcollapse ? a.wcollapse : 'false';
            var wcollaspeable = a.wcollaspeable ? a.wcollaspeable : 'false';
            var html = e.html();
            var s = a.size ? a.size : "col-md-12";

            var code = "<!--- Window Box --->";

            code += "<div><rd-window-box wcollaspeable='"+wcollaspeable+"' wcollapse='"+wcollapse+"' size='"+s+"'>";                

            if(header !== undefined)
            {
                if(header_translate !== "" && header_translate !== undefined)
                {
                    code += "<rd-window-box-header wcollaspeable='"+wcollaspeable+"' wcollapse='"+wcollapse+"' headertranslate="+header_translate+">"+header+"</rd-window-box-header>";                
                }
                else
                {
                    code += "<rd-window-box-header wcollaspeable='"+wcollaspeable+"' wcollapse='"+wcollapse+"'>"+header+"</rd-window-box-header>";
                }
            }

            code += "<rd-window-box-body wcollapse='"+wcollapse+"'>"+html+"</rd-window-box-body>";

            if(footer !== undefined)
            {
                if(footer_translate !== "" && footer_translate !== undefined)
                {
                    code += "<rd-window-box-footer wcollapse='"+wcollapse+"' footertranslate="+footer_translate+">"+footer+"</rd-window-box-footer>";
                }
                else
                {
                    code += "<rd-window-box-footer wcollapse='"+wcollapse+"'>"+footer+"</rd-window-box-footer>";
                }
            }

            code += "</rd-window-box></div>";

            code += "<!--- Window Box --->";

            return code;
        }

        return data;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdSelectInput', rdSelectInput);

    /** @ngInject */
    function rdSelectInput($rootScope,$timeout,$interval,$window,$compile)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ngModel) {
                
            }
        };
    }


})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdNumberInput', rdNumberInput)
        .directive('rdNumberCalcInput', rdNumberCalcInput);

    /** @ngInject */
    function rdNumberInput($rootScope,$timeout,$interval,$window,$compile)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ngModel) {
                var decimal = attrs.decimal;
                elem.numericInput({decimal: decimal});

                // elem.TouchSpin($rootScope.defaultSetup.numberInput);
                // elem.mask('99,99,99,999.99');

                if(attrs.calculator !== "" && attrs.calculator !== undefined)
                {
                  if((attrs.calculator.toLowerCase() === 'true'))
                  {
                    
                    elem.bind("focus", function (event) {
                        scope.$apply(function (){
                            var calcelem = angular.element( document.querySelector("#"+attrs.id+"_calc") );
                            calcelem.removeClass('dispnone');
                            calcelem.focus();
                            elem.addClass('dispnone');
                        });

                        event.preventDefault();
                    });

                    scope.$watch(attrs.calcmodel, function (v) {
                        ngModel.$setViewValue(parseFloat(v));
                        ngModel.$render();
                        if(!scope.$$phase) {
                          //$digest or $apply
                          scope.$apply();
                        }
                    });

                  }
                }

            }
        };
    }



    /** @ngInject */
    function rdNumberCalcInput($rootScope,$timeout,$interval,$window,$compile)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ngModel) {

                var decimal = attrs.decimal;
                elem.numericInput({decimal: decimal});

                elem.bind("keydown keypress", function (event) {

                    if(event.which === 13) {
                        scope.$apply(function (){
                            var value = ngModel.$modelValue;
                            if(value !== "" && value !== undefined)
                            {

                                var lastChar = value[value.length -1];
                                if(lastChar !== "+" && lastChar !== "-" && lastChar !== "*" && lastChar !== "/")
                                {
                                    var a = value ? eval(value.replace(/\,/g, ""))===undefined?'':eval(value.replace(/\,/g, "")) : value;
                                    var b = parseInt(a);
                                    ngModel.$setViewValue(a);
                                    ngModel.$viewValue = a;
                                    ngModel.$render(); 
                                }
                                else
                                {
                                    var newval = value.substring(0, value.length-1);
                                    var a = newval ? eval(newval.replace(/\,/g, ""))===undefined?'':eval(newval.replace(/\,/g, "")) : newval;
                                    var b = parseInt(a);
                                    ngModel.$setViewValue(a);
                                    ngModel.$viewValue = a;
                                    ngModel.$render();
                                }
                            }

                        });

                        event.preventDefault();
                    }

                });

                elem.bind("blur", function (event) {
                    scope.$apply(function (){   
                        var value = ngModel.$modelValue;                     
                        var calcelem = angular.element( document.querySelector("#"+attrs.numboxid) );
                        calcelem.removeClass('dispnone');
                        calcelem.blur();
                        elem.addClass('dispnone');
                    });

                    event.preventDefault();
                });
            }
        };
    }


})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdDateTimePicker', rdDateTimePicker);

    /** @ngInject */
    function rdDateTimePicker($rootScope)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs) {
                // elem.datetimepicker($rootScope.defaultSetup.dateTimePicker);
                //elem.mask($rootScope.defaultSetup.dateTimePicker.mask);
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdDatePicker', rdDatePicker);

    /** @ngInject */
    function rdDatePicker($rootScope)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ctrl) {
                var dowd = attrs.disableddays ? attrs.disableddays.split(',') : [];
                var ddates = attrs.disableddates ? attrs.disableddates.split(',') : [];
                var l = ddates.length;
                var ddatesn = [];
                for(var j=0; j<l; j++)
                {
                    ddatesn[j] = moment(ddates[j], $rootScope.defaultSetup.datePicker.dbformat).format();
                }
                var cw = attrs.cweeks ? true : false;
                elem.datetimepicker({
    //                 minDate: moment(), // Current day
    // maxDate: moment().add(30, 'days'), // 30 days from the current day
                    toolbarPlacement: 'top',
                    showClear: true,
                    showClose: true,
                    format: $rootScope.defaultSetup.datePicker.format,
                    useCurrent: false,
                    daysOfWeekDisabled: dowd,
                    calendarWeeks: cw,
                    disabledDates: ddatesn,
                });

                if($rootScope.defaultSetup.datePicker.mask !== "" && $rootScope.defaultSetup.datePicker.mask !== undefined)
                {
                    elem.mask($rootScope.defaultSetup.datePicker.mask);
                }

                scope.$watch(attrs.pickermodel, function (v) {
                    if(ctrl.$modelValue !== $rootScope.dbDateToDate(v))
                    {
                        ctrl.$setViewValue($rootScope.dbDateToDate(v));
                        ctrl.$render();
                        if(!scope.$$phase) {
                          //$digest or $apply
                          scope.$apply();
                        }             
                    }
                });
            }
        };
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdTimePicker', rdTimePicker);

    /** @ngInject */
    function rdTimePicker($rootScope)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ctrl) {
                elem.datetimepicker({
                    toolbarPlacement: 'top',
                    showClear: true,
                    showClose: true,
                    format: $rootScope.defaultSetup.timePicker.format,
                    useCurrent: false,
                });

                if($rootScope.defaultSetup.timePicker.mask !== "" && $rootScope.defaultSetup.timePicker.mask !== undefined)
                {
                    elem.mask($rootScope.defaultSetup.timePicker.mask);
                }

                scope.$watch(attrs.pickermodel, function (v) {
                    if(ctrl.$modelValue !== $rootScope.dbTimeToTime(v))
                    {
                        ctrl.$setViewValue($rootScope.dbTimeToTime(v));
                        ctrl.$render();
                        if(!scope.$$phase) {
                          //$digest or $apply
                          scope.$apply();
                        }             
                    }
                });
            }
        };
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdDateTimePicker', rdDateTimePicker);

    /** @ngInject */
    function rdDateTimePicker($rootScope)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ctrl) {
                var dowd = attrs.disableddays ? attrs.disableddays.split(',') : [];
                var ddates = attrs.disableddates ? attrs.disableddates.split(',') : [];
                var l = ddates.length;
                var ddatesn = [];
                for(var j=0; j<l; j++)
                {
                    ddatesn[j] = moment(ddates[j], $rootScope.defaultSetup.datePicker.dbformat).format();   
                }
                var cw = attrs.cweeks ? true : false;
                elem.datetimepicker({
                    toolbarPlacement: 'top',
                    showClear: true,
                    showClose: true,
                    format: $rootScope.defaultSetup.datePicker.format+" "+$rootScope.defaultSetup.timePicker.format,
                    useCurrent: false,
                    daysOfWeekDisabled: dowd,
                    calendarWeeks: cw,
                    disabledDates: ddatesn,
                });

                if($rootScope.defaultSetup.datePicker.mask !== "" && $rootScope.defaultSetup.datePicker.mask !== undefined && $rootScope.defaultSetup.timePicker.mask !== "" && $rootScope.defaultSetup.timePicker.mask !== undefined)
                {
                    elem.mask($rootScope.defaultSetup.datePicker.mask+" "+$rootScope.defaultSetup.timePicker.mask);
                }

                scope.$watch(attrs.pickermodel, function (v) {
                    if(ctrl.$modelValue !== $rootScope.dbDatetimeToDatetime(v))
                    {
                        ctrl.$setViewValue($rootScope.dbDatetimeToDatetime(v));
                        ctrl.$render();
                        if(!scope.$$phase) {
                          //$digest or $apply
                          scope.$apply();
                        }             
                    }
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdMonthPicker', rdMonthPicker);

    /** @ngInject */
    function rdMonthPicker($rootScope)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ctrl) {
                elem.datetimepicker({
                    toolbarPlacement: 'top',
                    showClear: true,
                    showClose: true,
                    viewMode: 'months',
                    format: $rootScope.defaultSetup.monthPicker.format,
                    useCurrent: false,
                });

                if($rootScope.defaultSetup.monthPicker.mask !== "" && $rootScope.defaultSetup.monthPicker.mask !== undefined)
                {
                    elem.mask($rootScope.defaultSetup.monthPicker.mask);
                }

                scope.$watch(attrs.pickermodel, function (v) {
                    if(ctrl.$modelValue !== $rootScope.dbMonthToMonth(v))
                    {
                        ctrl.$setViewValue($rootScope.dbMonthToMonth(v));
                        ctrl.$render();
                        if(!scope.$$phase) {
                          //$digest or $apply
                          scope.$apply();
                        }             
                    }
                });
            }
        };
    }

})();


(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('rdYearPicker', rdYearPicker);

    /** @ngInject */
    function rdYearPicker($rootScope)
    {
        return {
            require: '?ngModel',
            restrict: 'AE',
            link: function (scope, elem, attrs, ctrl) {
                elem.datetimepicker({
                    toolbarPlacement: 'top',
                    showClear: true,
                    showClose: true,
                    viewMode: 'years',
                    format: $rootScope.defaultSetup.yearPicker.format,
                    useCurrent: false,
                });

                if($rootScope.defaultSetup.yearPicker.mask !== "" && $rootScope.defaultSetup.yearPicker.mask !== undefined)
                {
                    elem.mask($rootScope.defaultSetup.yearPicker.mask);
                }

                scope.$watch(attrs.pickermodel, function (v) {
                    if(ctrl.$modelValue !== v)
                    {
                        ctrl.$setViewValue(v);
                        ctrl.$render();
                        if(!scope.$$phase) {
                          //$digest or $apply
                          scope.$apply();
                        }             
                    }
                });
            }
        };
    }

})();
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('communicationscheduler.listsms', {
            url: '/listsms/:id',
            templateUrl: 'app/projects/rcloudsys/communicationscheduler/sms_scheduler/list_smsscheduler/list_smsscheduler.html',
            controller: 'ListsmsschedulerController',
            data: {
              title: 'List Sms Scheduler',
              folded: false
            },
            resolve: {
              getsmsschedulerlist: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/scheduler/getsmsschedulerlist/' + $stateParams.id);
              },
              getcompanyName: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ListsmsschedulerController', function ($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getsmsschedulerlist,getcompanyName, getServer, $stateParams) {
    var vms = this;

    $scope.cmpName = getcompanyName.result;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.id = $stateParams.id;

    $scope.schedulerlist = getsmsschedulerlist.result;

    var tpltetable = $('#listschedulertable').DataTable({
      'aaData': $scope.schedulerlist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [{
          'swidth': '5%',
          'sTitle': "ID",
          'mData': 'id'
        },
        {
          'sWidth': '30%',
          'sTitle': 'Event Name',
          'mData': 'eventname'
        },
        {
          'sWidth': '30%',
          'sTitle': 'Project Name',
          'mData': 'projectname'
        },
        {
          'sWidth': '30%',
          'sTitle': 'Time',
          'mData': 'nooftime',
          'mRender': function (data, type, full) {
            var html = '';
            if(full.type === 'daily')
            {
              html += full.type + ' @ ' + full.time;
            }
            else if(full.type === 'weekly')
            {
              html += full.type + ' > ' + full.wdays + ' @ ' + full.time;
            }
            else if(full.type === 'monthly')
            {
              html += full.type + ' > ' + full.mdays + ' @ ' + full.time;
            }
            return '<p style="text-transform: capitalize;">'+ html +'</p>';
          }
        },
        {
          'sWidth': '35%',
          'sTitle': 'Status',
          'mData': 'status',
          'mRender': function (data, type, full) {
            if (data === "0") {
              return '<span class="label bg-danger" title="Disabled">Disabled</span>';
            } else {
              return '<span class="label bg-success" title="Enabled">Enabled</span>';
            }
          }
        },
        {
          'sWidth': '15%',
          'sTitle': 'Edit',
          'mData': 'id',
          'mRender': function (data, type, full) {
            return '<a class="btn btn-primary padtb2px" href="communicationscheduler/editsms/' + data + '/' + $scope.id + '">Edit</a>'
          }
        },
        {
          'sWidth': '15%',
          'sTitle': 'Delete',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'listschedulertable'";
            var d = "'" + data + "','" + full.eventname + "'";
            return '<a onClick="angular.element(document.getElementById(' + tid + ')).scope().deleteSmsscheduler(event,' + d + ')" class="btn btn-info padtb2px">Delete</a>';
          }
        }
      ]
    });

    $scope.deleteSmsscheduler = function (event, id, eventname) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure you want to delete ' + eventname + '?')
        .content('All your Modeles will be deleted.')
        .ok('Yes')
        .cancel('No')
        .targetEvent(event);
      $mdDialog.show(confirm).then(function () {
        getServer.getData('rcloudsys/scheduler/deletesmsscheduler/' + id).then(function (data) {
          $state.reload();
        });
      }, function () {
        toastShow.show('info', '', 'smsscheduler_not_deleted');
      });
    };


  });

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('communicationscheduler.editsms', {
          url: '/editsms/:id/:cid',
          templateUrl: 'app/projects/rcloudsys/communicationscheduler/sms_scheduler/edit_smsscheduler/edit_smsscheduler.html',
          controller: 'EditsmsschedulerController',
          data : { title: 'Edit Sms Scheduler', folded: false },
          resolve : {
            getsmsscheduler: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/scheduler/getsmsscheduler/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditsmsschedulerController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getsmsscheduler, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.id;

    $scope.cid = $stateParams.cid;

    $scope.editschedulerData = getsmsscheduler.result;
    
    $scope.editautosmssenderData ={};

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.id+',name,value" rdchange="addschedulerData.templateid = empty()" disableitems="true"></selectbox>';
    };

    $scope.getTemplateBox = function() {
      if(issetnotempty($scope.editschedulerData.company) && issetnotempty($scope.editschedulerData.projectid))
      {
        var c = $scope.editschedulerData.company;
        var p = $scope.editschedulerData.projectid;
        return '<selectbox quickattrs="templateid" dataapiurlformat="rcloudsys/template/getSmsSchTemplatelistSB/'+c+'/'+p+',name,value"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="templateid"></selectbox>';          
      }
    };

    $scope.getLev1Box = function() {
      if($scope.editschedulerData.type === 'daily')
      {
        // $scope.addschedulerData.wdays = '';
        // $scope.addschedulerData.mdays = '';
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.editschedulerData.type === 'weekly')
      {
        // $scope.addschedulerData.mdays = '';
        return '<selectbox quickattrs="wdays"></selectbox>';
      }
      else if($scope.editschedulerData.type === 'monthly')
      {
        // $scope.addschedulerData.wdays = '';
        return '<selectbox quickattrs="mdays"></selectbox>';
      }
    };

    $scope.getLev2Box = function() {
      if($scope.editschedulerData.type === 'weekly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.editschedulerData.type === 'monthly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
    };
    
    $scope.editSmsScheduler = function() {
      var d = angular.copy($scope.editschedulerData,d);
      d = $rootScope.removeObjAttrs(d,'time_picker,created_time,updated_time');
      postServer.postData('rcloudsys/scheduler/editsmsscheduler/'+$stateParams.id,d).then(function(data){
        if(data.type === "success")
        {
          $state.go('communicationscheduler.listsms',{ id : $scope.cid });
        }
      });
    }

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('communicationscheduler.addsms', {
          url: '/addsms/:id',
          templateUrl: 'app/projects/rcloudsys/communicationscheduler/sms_scheduler/add_smsscheduler/add_smsscheduler.html',
          controller: 'AddsmsschedulerController',
          data : { title: 'Create Sms Scheduler', folded: false },
           resolve : {
          },
          authenticate: true
        });
  }
]
)
.controller('AddsmsschedulerController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.id;

    $scope.addschedulerData = {
      projectid : '',
      company: $scope.id
    };

    $scope.addautosmssenderData = {};

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.id+',name,value" rdchange="addschedulerData.templateid = empty()" disableitems="true"></selectbox>';
    };

    $scope.getTemplateBox = function() {
      if(issetnotempty($scope.addschedulerData.company) && issetnotempty($scope.addschedulerData.projectid))
      {
        var c = $scope.addschedulerData.company;
        var p = $scope.addschedulerData.projectid;
        return '<selectbox quickattrs="templateid" dataapiurlformat="rcloudsys/template/getSmsSchTemplatelistSB/'+c+'/'+p+',name,value"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="templateid"></selectbox>';          
      }
    };

    $scope.getLev1Box = function() {
      if($scope.addschedulerData.type === 'daily')
      {
        // $scope.addschedulerData.wdays = '';
        // $scope.addschedulerData.mdays = '';
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.addschedulerData.type === 'weekly')
      {
        // $scope.addschedulerData.mdays = '';
        return '<selectbox quickattrs="wdays"></selectbox>';
      }
      else if($scope.addschedulerData.type === 'monthly')
      {
        // $scope.addschedulerData.wdays = '';
        return '<selectbox quickattrs="mdays"></selectbox>';
      }
    };

    $scope.getLev2Box = function() {
      if($scope.addschedulerData.type === 'weekly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.addschedulerData.type === 'monthly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
    };

    // console.log($rootScope.omitInObj($scope.addautosmssenderData,'password,password_change'));

     $scope.addSmsScheduler = function() {
      var d = angular.copy($scope.addschedulerData);
      d = $rootScope.removeObjAttrs(d,'time_picker');
      postServer.postData('rcloudsys/scheduler/addsmsscheduler',d).then(function(data){
        if(data.type === "success")
        {
          $state.go('communicationscheduler.listsms',{ id : $scope.id });
        }
      });
    }

    
}); 

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('projects.tree', {
          url: '/tree',
          templateUrl: 'app/projects/rcloudsys/projects/projects/project_tree/project_tree.html',
          controller: 'ListProjectTreeController',
          data : { title: 'Projects Tree', folded: false },
          resolve : { },
          authenticate: true
        });
  }
]
)
.controller('ListProjectTreeController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.projecttreeData = {};

    $scope.treeData = {};

    $scope.rData = {};

    $scope.getProjectTree = function() {
      $scope.treeData.ids = JSON.stringify($scope.projecttreeData.projectids);
      postServer.postData('rcloudsys/projects/getCProjects',$scope.treeData).then(function(data){
        if(data.type="success")
        {
          $scope.treeData = {};
          $scope.projecttreeData = {};
          $scope.rData = data.result;
        }
      });
    };
});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('projects.list', {
          url: '/list',
          templateUrl: 'app/projects/rcloudsys/projects/projects/list_project/list_project.html',
          controller: 'ListProjectController',
          data : { title: 'Projects List', folded: false },
          resolve : {
            projectList: function (getServer) {
              return getServer.getData('rcloudsys/projects/listProjects');
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListProjectController', function($scope, $state, $compile, $rootScope, $mdDialog, projectList, toastShow, postServer, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.projectlst = projectList.result;

    var plstable = $('#projectlisttable').DataTable({ 
      'aaData': $scope.projectlst,
      'bProcessing': true,
      'ordering': false,
      'stateSave': true,
      'autoWidth':true,
      'responsive': true,
      'aoColumns': [ 
        { 'sTitle': 'Id', 'mData': 'id' },
        { 'sTitle': 'Status', 'mData': 'status', 'mRender': function ( data, type, full ) { if(data === "0") { return '<span class="label bg-danger" title="Disabled">Disabled</span>'; } else { return '<span class="label bg-success" title="Enabled">Enabled</span>'; } }  },
        { 'sTitle': 'Name', 'mData': 'name', 'mRender': function ( data, type, full ) {  return '<a href="modgroups/list/'+full.id+'"><i class="'+full.icon+'"></i> <b>'+data+'</b> <i>('+full.projectid+')</i></a>'; }  },
        { 'sTitle': 'Manage Packages', 'mData': 'id', 'mRender': function ( data, type, full ) {  return '<a class="btn btn-info padtb2px" href="packages/list/'+data+'">Packages</a>'; } },
        { 'sTitle': 'Edit', 'mData': 'id', 'mRender': function ( data, type, full ) {  return '<a class="btn btn-primary padtb2px" href="projects/edit/'+data+'">Edit</a>'; } },
        { 'sTitle': 'Delete', 'mData': 'id', 'mRender': function ( data, type, full ) { var tid = "'"+"projectlisttable"+"'";  var d = "'"+data+"','"+full.name+"','"+full.projectid+"'"; return '<a onClick="angular.element(document.getElementById('+tid+')).scope().showConfirm(event,'+d+')" class="btn btn-default padtb2px">Delete</a>'; } }
      ]
    });

    $scope.showConfirm = function(ev,id,name,projectid) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete '+name+' Project?')
        .content('All Your Project Modules will be deleted.')
        .ariaLabel('Lucky day')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function() {
        getServer.getData('rcloudsys/projects/deleteProject/'+id).then(function (data) {
          if(data.type === "success")
          {
            $state.reload();            
          }
        });
      }, function() {
        toastShow.show('info','','leave_project');
      });
    };

    $scope.backupDone = false;
    $scope.backupProjects = function() {
      getServer.getData('rcloudsys/projects/exportProjects').then(function(data){
        downloadTextfile('projects.rcloud', data.result);
        $scope.backupDone = true;
      });
    };

    $scope.importProjectsFormData = {};

    $scope.importProjects = function() {
      postServer.postData('rcloudsys/projects/importProjects',$scope.importProjectsFormData).then(function(data){
        $state.reload();
      });
      // console.log($scope.importProjectsFormData);
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('projects.edit', {
          url: '/edit/:pid',
          templateUrl: 'app/projects/rcloudsys/projects/projects/edit_project/edit_project.html',
          controller: 'EditProjectController',
          data : { title: 'Edit Projects', folded: false },
          resolve : {
            getProject: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/projects/getProject/'+$stateParams.pid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EditProjectController', function($scope, $state, $rootScope, $stateParams, getProject, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.pid;

    $scope.editprojectData = getProject.result;

    $scope.getIConBox = function() {
      if($scope.editprojectData.project_fw === 'ts')
      {
        return '<selectbox quickattrs="projecticonts"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="projecticon"></selectbox>';
      }
    };

    $scope.updateProject = function () {
      postServer.postData('rcloudsys/projects/editProject',$scope.editprojectData).then(function(data){
        if(data.type="success")
        {
          $state.transitionTo('projects.list');
        }
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('projects.add', {
          url: '/add',
          templateUrl: 'app/projects/rcloudsys/projects/projects/add_project/add_project.html',
          controller: 'AddProjectController',
          data : { title: 'Create Project', folded: false },
          resolve : {},
          authenticate: true
        });
  }
]
)
.controller('AddProjectController', function($scope, $state, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.addprojectData = {};

    $scope.getIConBox = function() {
      if($scope.addprojectData.project_fw === 'ts')
      {
        return '<selectbox quickattrs="projecticonts"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="projecticon"></selectbox>';
      }
    };

    $scope.addProject = function() {
      postServer.postData('rcloudsys/projects/addProject',$scope.addprojectData).then(function(data){
        if(data.type="success")
        {
          $scope.addprojectData = {};
          $state.transitionTo('projects.list');
        }
      });
    }

});
'use strict';


angular.module('app')
    .config(
        ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
            function ($stateProvider, $urlRouterProvider, $locationProvider ) {
                $stateProvider
                    /* Auth Page List*/
                    .state('packages.manage', {
                        url: '/manage/:projectid/:pid',
                        templateUrl: 'app/projects/rcloudsys/projects/packages/manage_package/manage_package.html',
                        controller: 'ManagePackagesController',
                        data: {
                            title: 'Manage Packages',
                            folded: false
                        },
                        resolve: {
                            getManagePackage: function ($stateParams, getServer) {
                                return getServer.getData('rcloudsys/packages/getManagePackage/' + $stateParams.pid);
                            },
                        },
                        authenticate: true
                    });
            }
        ]
    )
    .controller('ManagePackagesController', function ($scope, $state, $rootScope, $stateParams, getManagePackage, toastShow, postServer) {
        var vms = this;

        $rootScope.vm = {};

        $scope.projectID = $stateParams.projectid;

        $scope.packageid = $stateParams.pid;

        $scope.package = getManagePackage.result;

        $scope.updatePackage = function() {
            var d = {};
            d.value = angular.toJson($scope.package);
            d.pkg_id = $scope.packageid;
            postServer.postData('rcloudsys/packages/updatePackage',d).then(function(data){
                $state.reload();
            });
        };

        $scope.isWholeProjectChecked = function () {
            if(issetnotempty($scope.package.project))
            {
                if($scope.package.project.whole_create || $scope.package.project.whole_edit || $scope.package.project.whole_view || $scope.package.project.whole_delete)
                {
                    if(Boolean($scope.package.project.whole_create) === false && Boolean($scope.package.project.whole_edit) === false && Boolean($scope.package.project.whole_view) === false && Boolean($scope.package.project.whole_delete) === false)
                    {
                        $scope.package.project.whole_models = false;
                    }
                    if(Boolean($scope.package.project.whole_create) === true || Boolean($scope.package.project.whole_edit) === true || Boolean($scope.package.project.whole_view) === true || Boolean($scope.package.project.whole_delete) === true)
                    {
                        $scope.package.project.whole_models = true;
                    }
                }
                else
                {
                    $scope.package.project.whole_models = false;
                }
                return $scope.package.project.whole_models;
            }
            else
            {
                return false;
            }
        };

        $scope.toggleWholeProjectAll = function () {
            if(Boolean($scope.package.project.whole_models))
            {
                $scope.package.project.whole_models = false;
                $scope.package.project.whole_create = false;
                $scope.package.project.whole_edit = false;
                $scope.package.project.whole_view = false;
                $scope.package.project.whole_delete = false;
            }
            else
            {
                $scope.package.project.whole_models = true;
                $scope.package.project.whole_create = true;
                $scope.package.project.whole_edit = true;
                $scope.package.project.whole_view = true;
                $scope.package.project.whole_delete = true;
            }
        };

        $scope.isWholeChecked = function (group) {            
            if(Boolean($scope.package.project.whole_models) === true)
            {
                group.whole_models = true;
                if(Boolean($scope.package.project.whole_create) === true)
                {
                    group.whole_create = true;
                }
                else
                {
                    group.whole_create = false;
                }

                if(Boolean($scope.package.project.whole_edit) === true)
                {
                    group.whole_edit = true;
                }
                else
                {
                    group.whole_edit = false;
                }

                if(Boolean($scope.package.project.whole_view) === true)
                {
                    group.whole_view = true;
                }
                else
                {
                    group.whole_view = false;
                }

                if(Boolean($scope.package.project.whole_delete) === true)
                {
                    group.whole_delete = true;
                }
                else
                {
                    group.whole_delete = false;
                }
            }
            else
            {
                if(group.whole_create || group.whole_edit || group.whole_view || group.whole_delete)
                {
                    if(Boolean(group.whole_create) === false && Boolean(group.whole_edit) === false && Boolean(group.whole_view) === false && Boolean(group.whole_delete) === false)
                    {
                        group.whole_models = false;
                    }
                    if(Boolean(group.whole_create) === true || Boolean(group.whole_edit) === true || Boolean(group.whole_view) === true || Boolean(group.whole_delete) === true)
                    {
                        group.whole_models = true;
                    }
                }
                else
                {
                    group.whole_models = false;
                }
                if(Boolean(group.whole_models))
                {
                    $scope.toggleAll(group);
                }
            }
            return group.whole_models;
        };

        $scope.toggleWholeAll = function (group) {
            if(Boolean(group.whole_models))
            {
                group.whole_models = false;
                group.whole_create = false;
                group.whole_edit = false;
                group.whole_view = false;
                group.whole_delete = false;
            }
            else
            {
                group.whole_models = true;
                group.whole_create = true;
                group.whole_edit = true;
                group.whole_view = true;
                group.whole_delete = true;
            }
        };

        $scope.isIndeterminate = function (group) {
            var i = _.where(group.models,{avail: true}).concat(_.where(group.models,{avail: 1}));
            var r = (i.length !== 0 && Boolean(group.whole_models) === false && i.length !== group.models.length);
            if(r)
            {
                group.avail = true;
                group.avail_all = false;
            }
            return r;
        };

        $scope.isChecked = function (group) {
            var i = _.where(group.models,{avail: true}).concat(_.where(group.models,{avail: 1}));
            var r = (i.length === group.models.length) || (Boolean(group.whole_models));
            if(r)
            {
                group.avail = true;
                group.avail_all = true;
            }
            else
            {
                group.avail = (i.length !== 0);
                group.avail_all = false;
            }
            return r;
        };

        $scope.toggleAll = function (group) {
            var i = _.where(group.models,{avail: true}).concat(_.where(group.models,{avail: 1}));
            if (i.length === group.models.length) {
                group.models.forEach(function(m){
                    m.avail = false;
                });
            } else {
                group.models.forEach(function(m){
                    m.avail = true;
                });
            }
            $scope.toggleCreateAll(group);
            $scope.toggleEditAll(group);
            $scope.toggleViewAll(group);
            $scope.toggleDeleteAll(group);
        };

        $scope.toggleModel = function(model) {
            if(Boolean(model.avail))
            {
                model.avail = false;
                model.m_create = false;
                model.m_edit = false;
                model.m_view = false;
                model.m_delete = false;
            }
            else
            {
                model.avail = true;
                model.m_create = true;
                model.m_edit = true;
                model.m_view = true;
                model.m_delete = true;
            }
        };

        $scope.isModelChecked = function(model) {
            if(model.m_create || model.m_edit || model.m_view || model.m_delete)
            {
                if(Boolean(model.m_create) === false && Boolean(model.m_edit) === false && Boolean(model.m_view) === false && Boolean(model.m_delete) === false)
                {
                    model.avail = false;
                }
                if(Boolean(model.m_create) === true || Boolean(model.m_edit) === true || Boolean(model.m_view) === true || Boolean(model.m_delete) === true)
                {
                    model.avail = true;
                }
            }
            else
            {
                model.avail = false;
            }
            return model.avail;
        };

        

        $scope.checkModel
                
        //for crud checkboxes
        //for crud checkboxes
        //for crud checkboxes
        //for crud checkboxes
        //for crud checkboxes

        $scope.isCreateIndeterminate = function (group) {
            var i = _.where(group.models,{m_create: true}).concat(_.where(group.models,{m_create: 1}));
            var r = (i.length !== 0 && Boolean(group.whole_create) === false && i.length !== group.models.length);
            return r;
        };

        $scope.isCreateChecked = function (group) {
            var i = _.where(group.models,{m_create: true}).concat(_.where(group.models,{m_create: 1}));
            var r = Boolean(group.whole_models) ? Boolean(group.whole_create) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_create)));
            if(r)
            {
                group.mg_create = true;
                group.create_all = true;
            }
            else
            {
                if(Boolean(group.whole_models))
                {
                    group.mg_create = Boolean(group.whole_create);
                }
                else
                {
                    group.mg_create = (i.length !== 0);
                }
                group.create_all = false;
            }
            return r;
        };

        $scope.toggleCreateAll = function (group) {
            var i = _.where(group.models,{m_create: true}).concat(_.where(group.models,{m_create: 1}));
            if (i.length === group.models.length) {
                group.models.forEach(function(m){
                    m.m_create = false;
                });
            } else {
                group.models.forEach(function(m){
                    m.m_create = true;
                });
            }
        };

        $scope.toggleCreateModel = function(model) {
            if(Boolean(model.m_create))
            {
                model.m_create = false;
            }
            else
            {
                model.avail = true;
                model.m_create = true;
            }
        };

        $scope.isEditIndeterminate = function (group) {
            var i = _.where(group.models,{m_edit: true}).concat(_.where(group.models,{m_edit: 1}));
            var r = (i.length !== 0 && Boolean(group.whole_edit) === false && i.length !== group.models.length);
            return r;
        };

        $scope.isEditChecked = function (group) {
            var i = _.where(group.models,{m_edit: true}).concat(_.where(group.models,{m_edit: 1}));
            var r = Boolean(group.whole_models) ? Boolean(group.whole_edit) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_edit)));
            if(r)
            {
                group.mg_edit = true;
                group.edit_all = true;
            }
            else
            {
                if(Boolean(group.whole_models))
                {
                    group.mg_edit = Boolean(group.whole_edit);
                }
                else
                {
                    group.mg_edit = (i.length !== 0);
                }
                group.edit_all = false;
            }
            return r;
        };

        $scope.toggleEditAll = function (group) {
            var i = _.where(group.models,{m_edit: true}).concat(_.where(group.models,{m_edit: 1}));
            if (i.length === group.models.length) {
                group.models.forEach(function(m){
                    m.m_edit = false;
                });
            } else {
                group.models.forEach(function(m){
                    m.m_edit = true;
                });
            }
        };

        $scope.toggleEditModel = function(model) {
            if(Boolean(model.m_edit))
            {
                model.m_edit = false;
            }
            else
            {
                model.avail = true;
                model.m_edit = true;
            }
        };

        $scope.isViewIndeterminate = function (group) {
            var i = _.where(group.models,{m_view: true}).concat(_.where(group.models,{m_view: 1}));
            var r = (i.length !== 0 && Boolean(group.whole_view) === false && i.length !== group.models.length);
            return r;
        };

        $scope.isViewChecked = function (group) {
            var i = _.where(group.models,{m_view: true}).concat(_.where(group.models,{m_view: 1}));
            var r = Boolean(group.whole_models) ? Boolean(group.whole_view) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_view)));
            if(r)
            {
                group.mg_view = true;
                group.view_all = true;
            }
            else
            {
                if(Boolean(group.whole_models))
                {
                    group.mg_view = Boolean(group.whole_view);
                }
                else
                {
                    group.mg_view = (i.length !== 0);
                }
                group.view_all = false;
            }
            return r;
        };

        $scope.toggleViewAll = function (group) {
            var i = _.where(group.models,{m_view: true}).concat(_.where(group.models,{m_view: 1}));
            if (i.length === group.models.length) {
                group.models.forEach(function(m){
                    m.m_view = false;
                });
            } else {
                group.models.forEach(function(m){
                    m.m_view = true;
                });
            }
        };

        $scope.toggleViewModel = function(model) {
            if(Boolean(model.m_view))
            {
                model.m_view = false;
            }
            else
            {
                model.avail = true;
                model.m_view = true;
            }
        };

        $scope.isDeleteIndeterminate = function (group) {
            var i = _.where(group.models,{m_delete: true}).concat(_.where(group.models,{m_delete: 1}));
            var r = (i.length !== 0 && Boolean(group.whole_delete) === false && i.length !== group.models.length);
            return r;
        };

        $scope.isDeleteChecked = function (group) {
            var i = _.where(group.models,{m_delete: true}).concat(_.where(group.models,{m_delete: 1}));
            var r = Boolean(group.whole_models) ? Boolean(group.whole_delete) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_delete)));
            if(r)
            {
                group.mg_delete = true;
                group.delete_all = true;
            }
            else
            {
                if(Boolean(group.whole_models))
                {
                    group.mg_delete = Boolean(group.whole_delete);
                }
                else
                {
                    group.mg_delete = (i.length !== 0);
                }
                group.delete_all = false;
            }
            return r;
        };

        $scope.toggleDeleteAll = function (group) {
            var i = _.where(group.models,{m_delete: true}).concat(_.where(group.models,{m_delete: 1}));
            if (i.length === group.models.length) {
                group.models.forEach(function(m){
                    m.m_delete = false;
                });
            } else {
                group.models.forEach(function(m){
                    m.m_delete = true;
                });
            }
        };

        $scope.toggleDeleteModel = function(model) {
            if(Boolean(model.m_delete))
            {
                model.m_delete = false;
            }
            else
            {
                model.avail = true;
                model.m_delete = true;
            }
        };

        //for crud checkboxes
        //for crud checkboxes
        //for crud checkboxes
        //for crud checkboxes
        //for crud checkboxes

    });
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('packages.list', {
          url: '/list/:projectid',
          templateUrl: 'app/projects/rcloudsys/projects/packages/list_package/list.html',
          controller: 'ListPackageController',
          data : { title: 'Packages List', folded: false },
          resolve : {
            packageList: function (getServer,$stateParams) {
              return getServer.getData('rcloudsys/packages/listPackages/'+$stateParams.projectid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListPackageController', function($scope, $state, $compile, $rootScope, $mdDialog, packageList, toastShow, postServer, getServer, $stateParams) {
    var vms = this;

    $rootScope.vm = {};

    $scope.projectID = $stateParams.projectid;

    $scope.status = '  ';

    $scope.packagelst = packageList.result;

    var plstable = $('#packagelisttable').DataTable({ 
      'aaData': $scope.packagelst,
      'bProcessing': true,
      'ordering': false,
      'stateSave': true,
      'autoWidth':true,
      'responsive': true,
      'aoColumns': [ 
        { 'sTitle': 'Id', 'mData': 'id' },
        { 'sTitle': 'Name', 'mData': 'name'  },
        { 'sTitle': 'Edit', 'mData': 'id', 'mRender': function ( data, type, full ) {  return '<a class="btn btn-primary padtb2px" href="packages/edit/'+$scope.projectID+'/'+data+'">Edit</a>'; } },
        { 'sTitle': 'Manage Modules', 'mData': 'id', 'mRender': function ( data, type, full ) {  return '<a class="btn btn-info padtb2px" href="packages/manage/'+$scope.projectID+'/'+data+'">Manage Modules</a>'; } },
        // { 'sTitle': 'Delete', 'mData': 'id', 'mRender': function ( data, type, full ) { var tid = "'"+"packagelisttable"+"'";  var d = "'"+data+"','"+full.name+"','"+full.packageid+"'"; return '<a onClick="angular.element(document.getElementById('+tid+')).scope().showConfirm(event,'+d+')" class="btn btn-default padtb2px">Delete</a>'; } }
      ]
    });

    $scope.showConfirm = function(ev,id,name,packageid) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete '+name+' Package?')
        .content('All Your Package Modules will be deleted.')
        .ariaLabel('Lucky day')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function() {
        getServer.getData('rcloudsys/packages/deletePackage/'+id).then(function (data) {
          if(data.type === "success")
          {
            $state.reload();            
          }
        });
      }, function() {
        toastShow.show('info','','leave_package');
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('packages.edit', {
          url: '/edit/:projectid/:pid',
          templateUrl: 'app/projects/rcloudsys/projects/packages/edit_package/edit.html',
          controller: 'EditPackagesController',
          data : { title: 'Edit Packages', folded: false },
          resolve : {
            getPackage: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/packages/getPackage/'+$stateParams.pid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EditPackagesController', function($scope, $state, $rootScope, $stateParams, getPackage, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.projectID = $stateParams.projectid;

    $scope.id = $stateParams.pid;

    $scope.editpackageData = getPackage.result;
    
    $scope.editpackageData.project_id = $scope.projectID;

    $scope.updatePackage = function () {
      postServer.postData('rcloudsys/packages/editPackage',$scope.editpackageData).then(function(data){
        if(data.type="success")
        {
          $state.transitionTo('packages.list',{ projectid : $scope.projectID });
        }
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('packages.add', {
          url: '/add/:projectid',
          templateUrl: 'app/projects/rcloudsys/projects/packages/add_package/add.html',
          controller: 'AddPackageController',
          data : { title: 'Create Package', folded: false },
          resolve : {},
          authenticate: true
        });
  }
]
)
.controller('AddPackageController', function($scope, $state, $rootScope, toastShow, postServer, $stateParams) {
    var vms = this;

    $scope.projectID = $stateParams.projectid;

    $rootScope.vm = {};

    $scope.addpackageData = {
      project_id : $scope.projectID
    };

    $scope.addPackage = function() {
      postServer.postData('rcloudsys/packages/addPackage',$scope.addpackageData).then(function(data){
        if(data.type="success")
        {
          $scope.addpackageData = {};
          $state.transitionTo('packages.list', { projectid : $scope.projectID });
        }
      });
    }

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('modgroups.list', {
          url: '/list/:pid',
          templateUrl: 'app/projects/rcloudsys/projects/modelgroups/list_modgroups/list_modgroups.html',
          controller: 'ListModgroupsController',
          data : { title: 'Model Groups List', folded: false },
          resolve : {
            modgroupList: function ($stateParams,getServer) {
              return getServer.getData('rcloudsys/modgroups/listModgroup/'+$stateParams.pid);
            },
            getProject: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/projects/getProject/'+$stateParams.pid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListModgroupsController', function($scope, $stateParams, $state, $compile, $rootScope, $mdDialog, modgroupList, getProject, toastShow, postServer, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.modgroupLst = modgroupList.result;

    $scope.cproject = getProject.result;

    var plstable = $('#modelsgrouplisttable').DataTable({
      'aaData': $scope.modgroupLst,
      'bProcessing': true,
      'ordering': true,
      'stateSave': true,
      'aoColumns': [        
        { 'sTitle': 'Id', 'sWidth': '3%',  'mData': 'id' },
        { 'sTitle': 'Status', 'sWidth': '5%', 'mData': 'status', 'mRender': function ( data, type, full ) { if(data === "0") { return '<span class="label bg-danger" title="Disabled">Disabled</span>'; } else { return '<span class="label bg-success" title="Enabled">Enabled</span>'; } }  },
        { 'sTitle': 'Name', 'sWidth': '30%',  'mData': 'name', 'mRender': function ( data, type, full ) {  return '<a href="models/list/'+full.id+'"><i class="'+full.icon+'"></i> <b>'+data+'</b> <i>('+full.modgrpid+')</i></a>'; }  },
        { 'sTitle': 'Edit', 'sWidth': '15%',  'mData': 'id', 'mRender': function ( data, type, full ) {  return '<a class="btn btn-primary padtb2px" href="modgroups/edit/'+data+'">Edit</a>'; } },
        { 'sTitle': 'Delete', 'sWidth': '15%',  'mData': 'id', 'mRender': function ( data, type, full ) { var tid = "'"+"modelsgrouplisttable"+"'";  var d = "'"+data+"','"+full.name+"','"+full.modgrpid+"'"; return '<a onClick="angular.element(document.getElementById('+tid+')).scope().showConfirm(event,'+d+')" class="btn btn-default padtb2px">Delete</a>'; } }
      ]
    });

    $scope.showConfirm = function(ev,id,name,projectid) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete '+name+' Model Group?')
        .content('All Your Project Modules will be deleted.')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function() {
        getServer.getData('rcloudsys/modgroups/deleteModgroup/'+id).then(function (data) {
          if(data.type === "success")
          {
            $state.reload();            
          }
        });
      }, function() {
        toastShow.show('info','','leave_modgroups');
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('modgroups.edit', {
          url: '/edit/:mgrpid',
          templateUrl: 'app/projects/rcloudsys/projects/modelgroups/edit_modgroups/edit_modgroups.html',
          controller: 'EditModelGroupController',
          data : { title: 'Edit Model Group', folded: false },
          resolve : {
            getModelgroup: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/modgroups/getModgroup/'+$stateParams.mgrpid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EditModelGroupController', function($scope, $state, $rootScope, $stateParams, getModelgroup, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.mgrpid;

    getModelgroup.result.show_order = parseInt(getModelgroup.result.show_order);

    $scope.editmodelgroupData = getModelgroup.result;

    $scope.getIConBox = function() {
      if($scope.editmodelgroupData.project_fw === 'ts')
      {
        return '<selectbox quickattrs="projecticonts"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="projecticon"></selectbox>';
      }
    };

    $scope.updateModelgroup = function () {
      postServer.postData('rcloudsys/modgroups/editModgroup',$scope.editmodelgroupData).then(function(data){
        if(data.type="success")
        {
          $state.go('modgroups.list', {'pid': $scope.editmodelgroupData.project_id});
        }
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('modgroups.add', {
          url: '/add/:pid',
          templateUrl: 'app/projects/rcloudsys/projects/modelgroups/add_modgroups/add_modgroups.html',
          controller: 'AddModelGroupController',
          data : { title: 'Create Model Group', folded: false },
          resolve : {
            getProject: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/projects/getProject/'+$stateParams.pid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('AddModelGroupController', function($scope, $stateParams, $state, $rootScope, getProject, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.pid = $stateParams.pid;

    $scope.cproject = getProject.result;

    $scope.addmodgroupData = {
      project_id: $scope.pid
    };

    $scope.getIConBox = function() {
      if($scope.cproject.project_fw === 'ts')
      {
        return '<selectbox quickattrs="projecticonts"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="projecticon"></selectbox>';
      }
    };

    $scope.addModgroup = function() {
      postServer.postData('rcloudsys/modgroups/addModgroup',$scope.addmodgroupData).then(function(data){
        if(data.type="success")
        {
          $scope.addmodgroupData = {};
          $state.go('modgroups.list', {'pid': $scope.pid});
        }
      });
    }

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('models.list', {
          url: '/list/:mgid',
          templateUrl: 'app/projects/rcloudsys/projects/model/list_model/list_model.html',
          controller: 'ListModController',
          data : { title: 'Model Groups List', folded: false },
          resolve : {
            modList: function ($stateParams,getServer) {
              return getServer.getData('rcloudsys/pmodel/listPmod/'+$stateParams.mgid);
            },
            getModgroup: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/modgroups/getModgroup/'+$stateParams.mgid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListModController', function($scope, $stateParams, $state, $compile, $rootScope, $mdDialog, modList, getModgroup, toastShow, postServer, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.modLst = modList.result;

    $scope.cmgroup = getModgroup.result;

    var plstable = $('#modelslisttable').DataTable({
      'aaData': $scope.modLst,
      'bProcessing': true,
      'ordering': true,
      'stateSave': true,
      'aoColumns': [        
        { 'sTitle': 'Id', 'sWidth': '3%',  'mData': 'id' },
        { 'sTitle': 'Status', 'sWidth': '5%', 'mData': 'status', 'mRender': function ( data, type, full ) { if(data === "0") { return '<span class="label bg-danger" title="Disabled">Disabled</span>'; } else { return '<span class="label bg-success" title="Enabled">Enabled</span>'; } }  },
        { 'sTitle': 'Name', 'sWidth': '30%',  'mData': 'name', 'mRender': function ( data, type, full ) {  return '<i class="'+full.icon+'"></i> <b>'+data+'</b> <i>('+full.modid+')</i>'; }  },
        { 'sTitle': 'Edit', 'sWidth': '15%',  'mData': 'id', 'mRender': function ( data, type, full ) {  return '<a class="btn btn-primary padtb2px" href="models/edit/'+data+'">Edit</a>'; } },
        { 'sTitle': 'Delete', 'sWidth': '15%',  'mData': 'id', 'mRender': function ( data, type, full ) { var tid = "'"+"modelslisttable"+"'";  var d = "'"+data+"','"+full.name+"','"+full.modid+"'"; return '<a onClick="angular.element(document.getElementById('+tid+')).scope().showConfirm(event,'+d+')" class="btn btn-default padtb2px">Delete</a>'; } }
      ]
    });

    $scope.showConfirm = function(ev,id,name,modid) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete '+name+' Model?')
        .content('All Your Module Information will be deleted.')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function() {
        getServer.getData('rcloudsys/pmodel/deletePmod/'+id).then(function (data) {
          if(data.type === "success")
          {
            $state.reload();            
          }
        });
      }, function() {
        toastShow.show('info','','leave_model');
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('models.edit', {
          url: '/edit/:mid',
          templateUrl: 'app/projects/rcloudsys/projects/model/edit_model/edit_model.html',
          controller: 'EditModelController',
          data : { title: 'Edit Model', folded: false },
          resolve : {
            getModel: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/pmodel/getPmod/'+$stateParams.mid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EditModelController', function($scope, $state, $rootScope, $stateParams, getModel, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.mid;

    $scope.editmodelData = {
      modgrp_id: $scope.id
    };

    $scope.getIConBox = function() {
      if($scope.editmodelData.project_fw === 'ts')
      {
        return '<selectbox quickattrs="projecticonts"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="projecticon"></selectbox>';
      }
    };
    getModel.result.show_order = parseInt(getModel.result.show_order);

    $scope.editmodelData = getModel.result;

    $scope.updateModel = function () {
      postServer.postData('rcloudsys/pmodel/editPmod',$scope.editmodelData).then(function(data){
        if(data.type="success")
        {
          $state.go('models.list', {'mgid': $scope.editmodelData.modgrp_id});
        }
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('models.add', {
          url: '/add/:mgid',
          templateUrl: 'app/projects/rcloudsys/projects/model/add_model/add_model.html',
          controller: 'AddModelController',
          data : { title: 'Create Model', folded: false },
          resolve : {
            getMgroup: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/modgroups/getModgroup/'+$stateParams.mgid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('AddModelController', function($scope, $stateParams, $state, $rootScope, getMgroup, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.mgid = $stateParams.mgid;

    $scope.cmgroup = getMgroup.result;

    $scope.addmodelData = {
      modgrp_id: $scope.mgid
    };
    
    $scope.getIConBox = function() {
      if($scope.cmgroup.project_fw === 'ts')
      {
        return '<selectbox quickattrs="projecticonts"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="projecticon"></selectbox>';
      }
    };

    $scope.addModel = function() {
      postServer.postData('rcloudsys/pmodel/addPmod',$scope.addmodelData).then(function(data){
        if(data.type="success")
        {
          $scope.addmodelData = {};
          $state.go('models.list', {'mgid': $scope.mgid});
        }
      });
    }

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.listquery', {
          url: '/listquery/:code',
          templateUrl: 'app/projects/rcloudsys/dbschemes/dbquery/list_query/list_query.html',
          controller: 'ListdatabasequeryController',
          data : { title: 'List Quries', folded: false },
          resolve : {
            getquerylist: function (getServer,$stateParams) {
              return getServer.getData('rcloudsys/dbschemes/getallDBQuery/'+$stateParams.code);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListdatabasequeryController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getquerylist, getServer, $stateParams) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.code = $stateParams.code;

    $scope.querylist = getquerylist.result;

    var tpltetable = $('#listquerytable').DataTable({ 
      'aaData': $scope.querylist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [ 
      { 'swidth': '2%',  'sTitle': "ID", 'mData': 'id'},
      { 'sWidth': '50%', 'sTitle': 'Name', 'mData': 'name', 'mRender':function(data,type,full) { return data+" ( Version "+full.version+")"; }},
      { 'sWidth': '30%', 'sTitle': 'Edit', 'mData': 'id', 'mRender': function (data,type,full) { return '<a class="btn btn-primary padtb2px" href="dbschemes/editquery/'+$scope.code+'/'+data+'">Edit</a>'} }
      // { 'sWidth': '30%', 'sTitle': 'Delete', 'mData': 'id', 'mRender': function (data,type,full) { 
      //   var tid = "'listquerytable'";
      //   var d = "'"+data+"'";
      //   return '<a onClick="angular.element(document.getElementById('+tid+')).scope().deleteQuery(event,'+d+')" class="btn btn-info padtb2px">Delete</a>';} }
       ]
   });

    $scope.deleteQuery = function(ev,id){
      
      var confirm = $mdDialog.confirm()
      .title('Are you sure to delete Query?')
      .content('All Your Module Information will be deleted.')
      .ok('Yes!')
      .cancel('No')
      .targetEvent(event);

      $mdDialog.show(confirm).then(function() {
        getServer.getData('rcloudsys/dbschemes/deleteDBQuery/'+id).then(function (data) {
          if(data.type === "success")
          {
            $state.reload();            
          }
        });
      }, function() {
        toastShow.show('info','','leave_dbtype');
      });
    };


});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.editquery', {
          url: '/editquery/:code/:id',
          templateUrl: 'app/projects/rcloudsys/dbschemes/dbquery/edit_query/edit_query.html',
          controller: 'EditdatabasequeryController',
          data : { title: 'Edit Query', folded: false },
          resolve : {
            getdatabase: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/dbschemes/getDBQuery/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditdatabasequeryController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getdatabase, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.code = $stateParams.code;

    $scope.editqueryData = getdatabase.result;

    $scope.editqueryData.version = round($scope.editqueryData.version,1);
    
    $scope.editAQuery = function() {
      postServer.postData('rcloudsys/dbschemes/editDBQuery/'+$stateParams.id,$scope.editqueryData).then(function(data){
        if(data.type === "success")
        {
          $state.go('dbschemes.listquery', { code: $scope.code });
        }
      });
    }

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.addquery', {
          url: '/addquery/:code',
          templateUrl: 'app/projects/rcloudsys/dbschemes/dbquery/add_query/add_query.html',
          controller: 'AddqueryController',
          data : { title: 'Create Auery', folded: false },
          resolve : {
            getLastVersionQuery: function(getServer,$stateParams) {
              return getServer.getData('rcloudsys/dbschemes/getLastVersionQuery/'+$stateParams.code);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('AddqueryController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getLastVersionQuery) {
    var vms = this;

    $rootScope.vm = {};

    $scope.code = $stateParams.code;

    $scope.minVersion = round((Number(getLastVersionQuery.result[0].version) + 0.1),1);

    $scope.addqueryData = {};
    $scope.addqueryData.version = $scope.minVersion;

     $scope.addNewQuery = function() {
       var d = angular.copy($scope.addqueryData);
       d.db_type = $scope.code;
        postServer.postData('rcloudsys/dbschemes/addDBQuery',d).then(function(data){
        if(data.type === "success")
        {
          $state.go('dbschemes.listquery',{ code: $scope.code });
        }
      });
    }

}); 
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.listdatabase', {
          url: '/listdatabase',
          templateUrl: 'app/projects/rcloudsys/dbschemes/database/list_database/list_database.html',
          controller: 'ListdatabaseController',
          data : { title: 'List Database', folded: false },
          resolve : {
            getdatabaselist: function (getServer) {
              return getServer.getData('rcloudsys/dbschemes/getdatabaselist');
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListdatabaseController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getdatabaselist, getServer, $stateParams) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.databaselist = getdatabaselist.result;

    var tpltetable = $('#listdatabasetable').DataTable({ 
      'aaData': $scope.databaselist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [ 
      { 'swidth': '5%',  'sTitle': "ID", 'mData': 'id'},
      { 'sWidth': '30%', 'sTitle': 'Company Name', 'mData': 'companyName', 'mRender': function(data,type,full){ return data+" ("+full.dbtype+" "+full.lastupdatedid+")" }},
      { 'sWidth': '15%', 'sTitle': 'DB Name', 'mData': 'dbname', 'mRender': function(data,type,full){
        return '<b title="'+full.last_backup+'">' + data + '</b>';
      }},
      { 'sWidth': '15%', 'sTitle': 'User Name', 'mData': 'username'},
      { 'sWidth': '5%', 'sTitle': 'Access', 'mData': 'password', 'mRender': function(data,type,full) {
        var tid = "'listdatabasetable'";
        var d = "'"+data+"'";
        var accessKey = "'"+full.accesskey+"'";
        var html = "";
        html += '<a onClick="angular.element(document.getElementById('+tid+')).scope().copyContent('+d+')" class="bsTooltipTop" title="Copy Password"><i class="fa fa-key"></i></a> &nbsp;&nbsp;';
        html += '<a onClick="angular.element(document.getElementById('+tid+')).scope().copyContent('+accessKey+')" class="bsTooltipTop" title="Copy AcessKey"><i class="fa fa-briefcase"></i></a>';
        return html;
      }},
      { 'sWidth': '5%', 'sTitle': 'Edit', 'mData': 'id', 'mRender': function (data,type,full) { return '<a class="btn btn-primary padtb2px" href="dbschemes/editdatabase/'+data+'">Edit</a>'} },
      { 'sWidth': '5%', 'sTitle': 'Delete', 'mData': 'id', 'mRender': function (data,type,full) { 
        var tid = "'listdatabasetable'";
        var d = "'"+data+"','"+full.dbname+"','"+full.companyName+"','"+full.accesskey+"'";
        return '<a onClick="angular.element(document.getElementById('+tid+')).scope().deleteDatabase(event,'+d+')" class="btn btn-info padtb2px">Delete</a>';} }
       ]
   });

   $scope.copyContent = function(data) {
    $rootScope.copyClipboard(data);
   }

    $scope.deleteDatabase = function(event,id,dbname,companyName,accesskey){
          var dbprompt = prompt('Are you sure you want to delete '+companyName+'('+dbname+') ?', "Enter Access Key");
          
          if (dbprompt === null || dbprompt === "") {
            toastShow.show('info','','database_not_deleted');
          }
          else
          {
            if(dbprompt === accesskey)
            {
              getServer.getData('rcloudsys/dbschemes/deletedatabase/'+id).then(function (data) {   
                  $state.reload();        
              });
            }
            else
            {
              toastShow.show('info','Invalid Access Key','');
            }
          }
      };


});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.editdatabase', {
          url: '/editdatabase/:id',
          templateUrl: 'app/projects/rcloudsys/dbschemes/database/edit_database/edit_database.html',
          controller: 'EditdatabaseController',
          data : { title: 'Edit database', folded: false },
          resolve : {
            getdatabase: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/dbschemes/getdatabase/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditdatabaseController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getdatabase, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.editdatabaseData = getdatabase.result;
    
    $scope.editDatabase = function() {
      postServer.postData('rcloudsys/dbschemes/editdatabase/'+$stateParams.id,$scope.editdatabaseData).then(function(data){
        if(data.type === "success")
        {
          $state.go('dbschemes.listdatabase');
        }
      });
    }

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.adddatabase', {
          url: '/adddatabase',
          templateUrl: 'app/projects/rcloudsys/dbschemes/database/add_database/add_database.html',
          controller: 'AdddatabaseController',
          data : { title: 'Create Database', folded: false },
          resolve : {},
          authenticate: false
        });
  }
]
)
.controller('AdddatabaseController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.id;

    $scope.adddatabaseData = {};

     $scope.addDatabase = function() {
        postServer.postData('rcloudsys/dbschemes/adddatabase',$scope.adddatabaseData).then(function(data){
        if(data.type === "success")
        {
          $state.go('dbschemes.listdatabase');
        }
      });
    }

}); 
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('dbschemes.adddbtype', {
            url: '/adddbtype',
            templateUrl: 'app/projects/rcloudsys/dbschemes/databasetype/add_databasetype/add_databasetype.html',
            controller: 'AdddabtypeController',
            data: {
              title: 'Create DB Type',
              folded: false
            },
            resolve: {},
            authenticate: false
          });
      }
    ]
  )
  .controller('AdddabtypeController', function ($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.id;

    $scope.adddatabasetypeData = {};

    $scope.adddbtype = function () {
      var d = angular.copy($scope.adddatabasetypeData);
      postServer.postData('rcloudsys/dbschemes/adddbtype', d).then(function (data) {
        if (data.type === "success") {
          $state.go('dbschemes.listdbtype');
        }
      });
    }

  });
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('dbschemes.listdbtype', {
          url: '/listdbtype',
          templateUrl: 'app/projects/rcloudsys/dbschemes/databasetype/list_databasetype/list_databasetype.html',
          controller: 'ListdatabasetypeController',
          data : { title: 'List DB Types', folded: false },
          resolve : {
            getdatabasetypelist: function (getServer) {
              return getServer.getData('rcloudsys/dbschemes/getallDBType');
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListdatabasetypeController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getdatabasetypelist, getServer, $stateParams) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.databasetypelist = getdatabasetypelist.result;

    var tpltetable = $('#listdatabasetypetable').DataTable({ 
      'aaData': $scope.databasetypelist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [ 
      { 'swidth': '5%',  'sTitle': "ID", 'mData': 'id'},
      { 'sWidth': '30%', 'sTitle': 'Name', 'mData': 'name'},
      { 'sWidth': '30%', 'sTitle': 'Code', 'mData': 'shortcode', 'mRender': function(data,type,full){
        return '<a href="dbschemes/listquery/'+data+'">'+data+'</a>';
      }},
      { 'sWidth': '30%', 'sTitle': 'Version', 'mData': 'latest_version'},
      { 'sWidth': '15%', 'sTitle': 'Manage', 'mData': 'shortcode', 'mRender': function (data,type,full) {
        return '<a href="dbschemes/listquery/'+data+'" class="btn btn-primary padtb2px">Manage</a>';} },
      { 'sWidth': '15%', 'sTitle': 'Delete', 'mData': 'id', 'mRender': function (data,type,full) { 
        var tid = "'listdatabasetypetable'";
        var d = "'"+data+"','"+full.name+"'";
        return '<a onClick="angular.element(document.getElementById('+tid+')).scope().deleteDatabase(event,'+d+')" class="btn btn-info padtb2px">Delete</a>';} }
       ]
   });

    $scope.deleteDatabase = function(event,id,dbtypename){
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete '+dbtypename+'?')
        .content('All Your Module Information will be deleted.')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(event);

      $mdDialog.show(confirm).then(function() {
        getServer.getData('rcloudsys/dbschemes/deleteDBType/'+id).then(function (data) {
          if(data.type === "success")
          {
            $state.reload();            
          }
        });
      }, function() {
        toastShow.show('info','','leave_dbtype');
      });
    };

    $scope.backupDone = false;
    $scope.backupProjects = function() {
      getServer.getData('rcloudsys/dbschemes/exportDBTypes').then(function(data){
        downloadTextfile('DBTypes.rcloud', data.result);
        $scope.backupDone = true;
      });
    };

    $scope.importProjectsFormData = {};

    $scope.importProjects = function() {
      postServer.postData('rcloudsys/dbschemes/importDBTypes',$scope.importProjectsFormData).then(function(data){
        $state.reload();
      });
      // console.log($scope.importProjectsFormData);
    };


});
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('communicationscheduler.listemail', {
            url: '/listemail/:id',
            templateUrl: 'app/projects/rcloudsys/communicationscheduler/email_scheduler/list_emailscheduler/list_emailscheduler.html',
            controller: 'ListemailschedulerController',
            data: {
              title: 'List Email Scheduler',
              folded: false
            },
            resolve: {
              getemailschedulerlist: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/scheduler/getemailschedulerlist/' + $stateParams.id);
              },
              getcompanyName: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ListemailschedulerController', function ($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getemailschedulerlist,getcompanyName, getServer, $stateParams) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cmpName = getcompanyName.result;

    $scope.status = '  ';

    $scope.id = $stateParams.id;

    $scope.schedulerlist = getemailschedulerlist.result;

    var tpltetable = $('#listschedulertable').DataTable({
      'aaData': $scope.schedulerlist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [{
          'swidth': '5%',
          'sTitle': "ID",
          'mData': 'id'
        },
        {
          'sWidth': '30%',
          'sTitle': 'Event Name',
          'mData': 'eventname'
        },
        {
          'sWidth': '30%',
          'sTitle': 'Project Name',
          'mData': 'projectname'
        },
        {
          'sWidth': '30%',
          'sTitle': 'Time',
          'mData': 'nooftime',
          'mRender': function (data, type, full) {
            var html = '';
            if(full.type === 'daily')
            {
              html += full.type + ' @ ' + full.time;
            }
            else if(full.type === 'weekly')
            {
              html += full.type + ' > ' + full.wdays + ' @ ' + full.time;
            }
            else if(full.type === 'monthly')
            {
              html += full.type + ' > ' + full.mdays + ' @ ' + full.time;
            }
            return '<p style="text-transform: capitalize;">'+ html +'</p>';
          }
        },
        {
          'sWidth': '35%',
          'sTitle': 'Status',
          'mData': 'status',
          'mRender': function (data, type, full) {
            if (data === "0") {
              return '<span class="label bg-danger" title="Disabled">Disabled</span>';
            } else {
              return '<span class="label bg-success" title="Enabled">Enabled</span>';
            }
          }
        },
        {
          'sWidth': '15%',
          'sTitle': 'Edit',
          'mData': 'id',
          'mRender': function (data, type, full) {
            return '<a class="btn btn-primary padtb2px" href="communicationscheduler/editemail/' + data + '/' + $scope.id + '">Edit</a>'
          }
        },
        {
          'sWidth': '15%',
          'sTitle': 'Delete',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'listschedulertable'";
            var d = "'" + data + "','" + full.eventname + "'";
            return '<a onClick="angular.element(document.getElementById(' + tid + ')).scope().deleteEmailscheduler(event,' + d + ')" class="btn btn-info padtb2px">Delete</a>';
          }
        }
      ]
    });

    $scope.deleteEmailscheduler = function (event, id, eventname) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure you want to delete ' + eventname + '?')
        .content('All your Modeles will be deleted.')
        .ok('Yes')
        .cancel('No')
        .targetEvent(event);
      $mdDialog.show(confirm).then(function () {
        getServer.getData('rcloudsys/scheduler/deleteemailscheduler/' + id).then(function (data) {
          $state.reload();
        });
      }, function () {
        toastShow.show('info', '', 'emailscheduler_not_deleted');
      });
    };


  });

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('communicationscheduler.editemail', {
          url: '/editemail/:id/:cid',
          templateUrl: 'app/projects/rcloudsys/communicationscheduler/email_scheduler/edit_emailscheduler/edit_emailscheduler.html',
          controller: 'EditemailschedulerController',
          data : { title: 'Edit Email Scheduler', folded: false },
          resolve : {
            getemailscheduler: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/scheduler/getemailscheduler/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditemailschedulerController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getemailscheduler, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.id;

    $scope.cid = $stateParams.cid;

    $scope.editschedulerData = getemailscheduler.result;
    
    $scope.editautoemailsenderData ={};

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.id+',name,value" rdchange="addschedulerData.templateid = empty()" disableitems="true"></selectbox>';
    };

    $scope.getTemplateBox = function() {
      if(issetnotempty($scope.editschedulerData.company) && issetnotempty($scope.editschedulerData.projectid))
      {
        var c = $scope.editschedulerData.company;
        var p = $scope.editschedulerData.projectid;
        return '<selectbox quickattrs="templateid" dataapiurlformat="rcloudsys/template/getEmailSchTemplatelistSB/'+c+'/'+p+',name,value"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="templateid"></selectbox>';          
      }
    };

    $scope.getLev1Box = function() {
      if($scope.editschedulerData.type === 'daily')
      {
        // $scope.addschedulerData.wdays = '';
        // $scope.addschedulerData.mdays = '';
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.editschedulerData.type === 'weekly')
      {
        // $scope.addschedulerData.mdays = '';
        return '<selectbox quickattrs="wdays"></selectbox>';
      }
      else if($scope.editschedulerData.type === 'monthly')
      {
        // $scope.addschedulerData.wdays = '';
        return '<selectbox quickattrs="mdays"></selectbox>';
      }
    };

    $scope.getLev2Box = function() {
      if($scope.editschedulerData.type === 'weekly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.editschedulerData.type === 'monthly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
    };
    
    $scope.editEmailScheduler = function() {
      var d = angular.copy($scope.editschedulerData,d);
      d = $rootScope.removeObjAttrs(d,'time_picker,created_time,updated_time');
      postServer.postData('rcloudsys/scheduler/editemailscheduler/'+$stateParams.id,d).then(function(data){
        if(data.type === "success")
        {
          $state.go('communicationscheduler.listemail',{ id : $scope.cid });
        }
      });
    }

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('communicationscheduler.addemail', {
          url: '/addemail/:id',
          templateUrl: 'app/projects/rcloudsys/communicationscheduler/email_scheduler/add_emailscheduler/add_emailscheduler.html',
          controller: 'AddemailschedulerController',
          data : { title: 'Create Email Scheduler', folded: false },
           resolve : {
          },
          authenticate: true
        });
  }
]
)
.controller('AddemailschedulerController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.id;

    $scope.addschedulerData = {
      projectid : '',
      company: $scope.id
    };

    $scope.addautoemailsenderData = {};

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.id+',name,value" rdchange="addschedulerData.templateid = empty()" disableitems="true"></selectbox>';
    };

    $scope.getTemplateBox = function() {
      if(issetnotempty($scope.addschedulerData.company) && issetnotempty($scope.addschedulerData.projectid))
      {
        var c = $scope.addschedulerData.company;
        var p = $scope.addschedulerData.projectid;
        return '<selectbox quickattrs="templateid" dataapiurlformat="rcloudsys/template/getEmailSchTemplatelistSB/'+c+'/'+p+',name,value"></selectbox>';
      }
      else
      {
        return '<selectbox quickattrs="templateid"></selectbox>';          
      }
    };

    $scope.getLev1Box = function() {
      if($scope.addschedulerData.type === 'daily')
      {
        // $scope.addschedulerData.wdays = '';
        // $scope.addschedulerData.mdays = '';
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.addschedulerData.type === 'weekly')
      {
        // $scope.addschedulerData.mdays = '';
        return '<selectbox quickattrs="wdays"></selectbox>';
      }
      else if($scope.addschedulerData.type === 'monthly')
      {
        // $scope.addschedulerData.wdays = '';
        return '<selectbox quickattrs="mdays"></selectbox>';
      }
    };

    $scope.getLev2Box = function() {
      if($scope.addschedulerData.type === 'weekly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
      else if($scope.addschedulerData.type === 'monthly')
      {
        return '<datebox quickattrs="time"></datebox>';
      }
    };

    // console.log($rootScope.omitInObj($scope.addautoemailsenderData,'password,password_change'));

     $scope.addEmailScheduler = function() {
      var d = angular.copy($scope.addschedulerData);
      d = $rootScope.removeObjAttrs(d,'time_picker');
      postServer.postData('rcloudsys/scheduler/addemailscheduler',d).then(function(data){
        if(data.type === "success")
        {
          $state.go('communicationscheduler.listemail',{ id : $scope.id });
        }
      });
    }

    
}); 

'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider, MODULE_CONFIG) {
        $stateProvider
          /* Auth Page List*/
          .state('manage.settings', {
            url: '/settings',
            templateUrl: 'app/views/rcloud/manage/settings/settings.html',
            controller: 'SettingsController',
            data: {
              title: 'Your Settings',
              folded: false
            },
            resolve: {
              settings: function (getServer) {
                return getServer.getData('rcloudsys/users/my_settings');
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('SettingsController', function ($scope, $rootScope, settings, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.settings = settings.result;

    $scope.settingsFormData = $rootScope.defaultSetup;

    $scope.updateThisSession = function () {
      angular.extend($scope.defaultSetup,$scope.settingsFormData);
      toastShow.show('success', '', 'session_setting_updated');
    };

    angular.extend($scope.settingsFormData,$scope.settings);


    $scope.updateSettings = function () {
      var d = {};
      d.user_settings = JSON.stringify($scope.settingsFormData);
      postServer.postData('rcloudsys/users/update_my_settings', d).then(function (data) {
        if (data.type = "success") {
          $rootScope.defaultSetup = $scope.settingsFormData;
        }
      });
    }
  });
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider,  MODULE_CONFIG ) {
    $stateProvider
        /* Auth Page List*/
        .state('manage.profile', {
          url: '/profile',
          templateUrl: 'app/views/rcloud/manage/profile/profile.html',
          controller: 'ProfileController',
          data : { title: 'Your Profile', folded: false },
          resolve : {
            profile: function (getServer)
            {
                return getServer.getData('rcloudsys/users/my_info');
            },
            getTwoFactConf: function(getServer) {
              return getServer.getData('rcloudsys/login/getTwoFactConf');
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ProfileController', function($scope, $rootScope, profile, postServer, getServer, $state, getTwoFactConf) {
    var vms = this;

    $rootScope.vm = {};

    $scope.profile = profile.result;

    $scope.profile_formData = {
      display_name: $scope.profile.display_name,
      username: $scope.profile.username,
      mobileno: $scope.profile.mobileno,
      gender: $scope.profile.gender,
      dob: $scope.profile.dob
    };

    $scope.updateInfo = function() {
      postServer.postData('rcloudsys/users/update_my_info',$scope.profile_formData).then(function(data){
      });
    }

    $scope.password_changeData = {};

    $scope.updatePassword = function() {
      postServer.postData('rcloudsys/users/reset_user_password',$scope.password_changeData).then(function(data){
        if(data.type="success")
        {
          $scope.password_changeData = {};
        }
      });
    };

    
    $scope.tow_factData = {};

    $scope.tow_factData = getTwoFactConf.result;

    $scope.codeURL = '';

    $scope.codeURL = getTwoFactConf.result.qrCodeUrl;

    $scope.codeReq = false;

    $scope.getTwoFactCode = function() {
      if(Number($scope.tow_factData.twofact_auth) === 1)
      {
        getServer.getData('rcloudsys/login/getTwoFactQrCode').then(function(data){
          $scope.codeURL = data.result.qr;
          $scope.tow_factData.secret = data.result.secret;
          $scope.codeReq = true;
        });
      }
      else
      {
        $scope.codeURL = '';
        $scope.tow_factData.secret = '';
        $scope.codeReq = false;
      }
    };

    $scope.getReqCodBox = function() {
      return '<textbox quickattrs="twofactcode" ngchange="checkCode()" rdblur="checkCode()" rdrequired="false" size="col-md-6"></textbox>';
    };

    $scope.codeResult = false;

    if(getTwoFactConf.result.qrCodeUrl)
    {
      $scope.codeResult = true;
    }

    $scope.checkCode = function() {
      if(Number($scope.tow_factData.twofact_auth) === 1)
      {
        var c = $scope.tow_factData.secret ? $scope.tow_factData.secret : '';
        var co = $scope.tow_factData.twofactcode.toString().length === 6 ? $scope.tow_factData.twofactcode : '';
        if(co !== '')
        {
          getServer.getData('rcloudsys/login/checkTwoFactCode/'+c+'/'+co).then(function(data){
            if(data.result)
            {
              $scope.codeResult = true;
            }
            else
            {
              $scope.codeResult = false; 
            }
          });
        }
        else
        {
          $scope.codeResult = false;
        }
      }
      else
      {
        $scope.codeResult = true;
      }
    };

    $scope.saveTwoFact = function() {
      var d = angular.copy($scope.tow_factData);
      postServer.postData('rcloudsys/login/updateTwoFactConf',d).then(function(data){
        $state.reload();
      });
    };


});


angular.module('app')
.directive('rdtextbox', rdtextbox);


function rdtextbox($rootScope,$compile){
    var data = {
      restrict : "EA",
      transclude: true,
      link : genrateTextbox,
    };
    function genrateTextbox(s, e, a, ngModel) {

      function getTextBox(e, a) {

        var missedItems = [];

        var s = getSize();
        var formname = getFormName();
        var formData = getFormDataName();
        var itemid = getItemid();
        var modelname = getModel();
        var tlate = getTlate();

        var acitem = "" + formname + "." + itemid + "";

        var placeholder = "placeholder='' translate translate-attr-placeholder='" + tlate + "." + itemid + ".placeholder'";

        var nclass = '{ "has-error": ' + acitem + ".$invalid || " + acitem + '.$pending , "has-success": ' + acitem + '.$valid , "has-pending": ' + acitem + ".$pending}";
        var elms = placeholder + " " + validationGenrator();

        function getFormName() {
          if (getItemType() === "ngform") {
            return e.closest("ng-form").attr("name");
          } else {
            return e.closest("form").attr("id");
          }
        }

        function getFormDataName() {
          if (getItemType() === "ngform") {
            return "";
          } else if (getItemType() === "private") {
            return "";
          } else {
            return getFormName() + "Data.";
          }
        }

        function getItemType() {
          if (a.itemtype !== "" && a.itemtype !== undefined) {
            return a.itemtype;
          }
        }

        function getSize() {
          if (a.size !== "" && a.size !== undefined) {
            return a.size;
          }
          else
          {
            missedItems[missedItems.length] = "Size Not Defined";
          }
        }

        function getItemid() {
          if (a.itemid !== "" && a.itemid !== undefined) {
            return a.itemid;
          } else {
            missedItems[missedItems.length] = "Item Id Not Defined";
          }
        }

        function getModel() {
          if (a.modelname !== "" && a.modelname !== undefined) {
            return a.modelname;
          } else {
            missedItems[missedItems.length] = "Model Name Not Defined";
          }
        }

        function getTlate() {
          if (a.tlate !== "" && a.tlate !== undefined) {
            return a.tlate;
          } else {
            missedItems[missedItems.length] = "Tlate Not Defined";
          }
        }

        function validationGenrator() {
          var v = "";

          if (a.type !== "" && a.type !== undefined) {
            v += " type='" + a.type + "'";
          } else {
            v += " type='text'";
          }

          if (a.autocomplete !== "" && a.autocomplete !== undefined) {
            if (a.autocomplete.toString().toLowerCase() === "true") {
              v += " autocomplete='off'";
            }
          }

          if (a.required !== "" && a.required !== undefined) {
            if (a.required.toString().toLowerCase() === "true") {
              v += " required='true'";
            }
          }

          if (a.readonly !== "" && a.readonly !== undefined) {
            if (a.readonly.toString().toLowerCase() === "true" || a.readonly.toString().toLowerCase() === "readonly") {
              v += " readonly='readonly' tabIndex='-1'";
            }
          }

          if (a.minlength !== "" && a.minlength !== undefined) {
            v += " ng-minlength='" + a.minlength + "'";
          }

          if (a.maxlength !== "" && a.maxlength !== undefined) {
            v += " ng-maxlength='" + a.maxlength + "'";
          }

          if (a.nachar !== "" && a.nachar !== undefined) {
            v += " rdnachar='" + a.nachar + "'";
          }

          if (a.geturlcheck !== "" && a.geturlcheck !== undefined) {
            if (a.geturlcheck.toString().toLowerCase() !== "false") {
              v += " rdgeturlcheck='" + a.geturlcheck + "'";
            }
          }

          if (a.posturlcheck !== "" && a.posturlcheck !== undefined) {
            v += " rdposturlcheck='" + a.posturlcheck + "'";
          }

          if (a.naword !== "" && a.naword !== undefined) {
            v += " rdnaword='" + a.naword + "'";
          }

          if (a.nawords !== "" && a.nawords !== undefined) {
            v += " rdnawords='" + a.nawords + "'";
          }

          if (a.minword !== "" && a.minword !== undefined) {
            v += " rdminword='" + a.minword + "'";
          }

          if (a.maxword !== "" && a.maxword !== undefined) {
            v += " rdmaxword='" + a.maxword + "'";
          }

          if (a.ishtml !== "" && a.ishtml !== undefined) {
            if (a.ishtml.toString().toLowerCase() === "true") {
              v += " rdishtml='true'";
            }
          }

          if (a.isnothtml !== "" && a.isnothtml !== undefined) {
            if (a.isnothtml.toString().toLowerCase() === "true") {
              v += " rdisnothtml='true'";
            }
          }

          if (a.nospace !== "" && a.nospace !== undefined) {
            if (a.nospace.toString().toLowerCase() === "true") {
              v += " rdnospace='true'";
            }
          }

          if (a.uppercase !== "" && a.uppercase !== undefined) {
            if (a.uppercase.toString().toLowerCase() === "true") {
              v += " rduppercase='true'";
            }
          }

          if (a.lowercase !== "" && a.lowercase !== undefined) {
            if (a.lowercase.toString().toLowerCase() === "true") {
              v += " rdlowercase='true'";
            }
          }

          if (a.spellcheck !== "" && a.spellcheck !== undefined) {
            if (a.spellcheck.toString().toLowerCase() === "true") {
              v += " spellcheck='true'";
            } else {
              v += " spellcheck='false'";
            }
          }

          if (a.pattern !== "" && a.pattern !== undefined) {
            v += " ng-pattern='" + a.pattern + "'";
          }

          if (a.rdblur !== "" && a.rdblur !== undefined) {
            v += "ng-blur='" + a.rdblur + "'";
          }
          
          if (a.rdchange !== "" && a.rdchange !== undefined) {
            v += "ng-change='" + a.rdchange + "'";
          }
          
          if (a.rdclick !== "" && a.rdclick !== undefined) {
            v += "ng-click='" + a.rdclick + "'";
          }
          
          if (a.rdcopy !== "" && a.rdcopy !== undefined) {
            v += "ng-copy='" + a.rdcopy + "'";
          }
          
          if (a.rdcut !== "" && a.rdcut !== undefined) {
            v += "ng-cut='" + a.rdcut + "'";
          }
          
          if (a.rdfocus !== "" && a.rdfocus !== undefined) {
            v += "ng-focus='" + a.rdfocus + "'";
          }
          
          if (a.rdkeydown !== "" && a.rdkeydown !== undefined) {
            v += "ng-keydown='" + a.rdkeydown + "'";
          }
          
          if (a.rdkeypress !== "" && a.rdkeypress !== undefined) {
            v += "ng-keypress='" + a.rdkeypress + "'";
          }
          
          if (a.rdkeyup !== "" && a.rdkeyup !== undefined) {
            v += "ng-keyup='" + a.rdkeyup + "'";
          }
          
          if (a.rdmousedown !== "" && a.rdmousedown !== undefined) {
            v += "ng-mousedown='" + a.rdmousedown + "'";
          }
          
          if (a.rdmouseenter !== "" && a.rdmouseenter !== undefined) {
            v += "ng-mouseenter='" + a.rdmouseenter + "'";
          }
          
          if (a.rdmouseleave !== "" && a.rdmouseleave !== undefined) {
            v += "ng-mouseleave='" + a.rdmouseleave + "'";
          }
          
          if (a.rdmousemove !== "" && a.rdmousemove !== undefined) {
            v += "ng-mousemove='" + a.rdmousemove + "'";
          }
          
          if (a.rdmouseover !== "" && a.rdmouseover !== undefined) {
            v += "ng-mouseover='" + a.rdmouseover + "'";
          }
          
          if (a.rdmouseup !== "" && a.rdmouseup !== undefined) {
            v += "ng-mouseup='" + a.rdmouseup + "'";
          }
          
          if (a.rdpaste !== "" && a.rdpaste !== undefined) {
            v += "ng-paste='" + a.rdpaste + "'";
          }

          return v;
        }

        function messageGenrator() {
          var h = "";
          var v = "";
          h += "<div ng-messages='" + acitem + ".$error' ng-show='" + acitem + ".$dirty' role='alert'>";

          if (a.required !== "" && a.required !== undefined) {
            h += "<div ng-message='required'><span class='help-block' translate='" + tlate + "." + itemid + ".required'></span></div>";
          }

          if (a.minlength !== "" && a.minlength !== undefined) {
            h += "<div ng-message='minlength'><span class='help-block' translate='" + tlate + "." + itemid + ".minlength'></span></div>";
          }

          if (a.maxlength !== "" && a.maxlength !== undefined) {
            h += "<div ng-message='maxlength'><span class='help-block' translate='" + tlate + "." + itemid + ".maxlength'></span></div>";
          }

          if (a.nachar !== "" && a.nachar !== undefined) {
            h += "<div ng-message='rdnachar'><span class='help-block' translate='" + tlate + "." + itemid + ".nachar'></span></div>";
          }

          if (a.geturlcheck !== "" && a.geturlcheck !== undefined) {
            h += "<div ng-message='rdgeturlcheck'><span class='help-block' translate='" + tlate + "." + itemid + ".geturlcheck'></span></div>";
          }

          if (a.posturlcheck !== "" && a.posturlcheck !== undefined) {
            h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='" + tlate + "." + itemid + ".posturlcheck'></span></div>";
          }

          if (a.naword !== "" && a.naword !== undefined) {
            h += "<div ng-message='rdnaword'><span class='help-block' translate='" + tlate + "." + itemid + ".naword'></span></div>";
          }

          if (a.nawords !== "" && a.nawords !== undefined) {
            h += "<div ng-message='rdnawords'><span class='help-block' translate='" + tlate + "." + itemid + ".nawords'></span></div>";
          }

          if (a.minword !== "" && a.minword !== undefined) {
            h += "<div ng-message='rdminword'><span class='help-block' translate='" + tlate + "." + itemid + ".minword'></span></div>";
          }

          if (a.maxword !== "" && a.maxword !== undefined) {
            h += "<div ng-message='rdmaxword'><span class='help-block' translate='" + tlate + "." + itemid + ".maxword'></span></div>";
          }

          if (a.ishtml !== "" && a.ishtml !== undefined) {
            h += "<div ng-message='rdishtml'><span class='help-block' translate='" + tlate + "." + itemid + ".ishtml'></span></div>";
          }

          if (a.isnothtml !== "" && a.isnothtml !== undefined) {
            h += "<div ng-message='rdisnothtml'><span class='help-block' translate='" + tlate + "." + itemid + ".isnothtml'></span></div>";
          }

          if (a.nospace !== "" && a.nospace !== undefined) {
            h += "<div ng-message='rdnospace'><span class='help-block' translate='" + tlate + "." + itemid + ".nospace'></span></div>";
          }

          if (a.uppercase !== "" && a.uppercase !== undefined) {
            h += "<div ng-message='rduppercase'><span class='help-block' translate='" + tlate + "." + itemid + ".uppercase'></span></div>";
          }

          if (a.lowercase !== "" && a.lowercase !== undefined) {
            h += "<div ng-message='rdlowercase'><span class='help-block' translate='" + tlate + "." + itemid + ".lowercase'></span></div>";
          }

          if (a.pattern !== "" && a.pattern !== undefined) {
            h += "<div ng-message='pattern'><span class='help-block' translate='" + tlate + "." + itemid + ".pattern'></span></div>";
          }

          h += "</div>";
          return h;
        }

        var html = "";
        if(missedItems.length === 0)
        {
          html += "<div class='" + s + " form-group' ng-class='" + nclass + "'>";
          html += "<label for='" + itemid + "' class='control-label' translate='" + tlate + "." + itemid + ".title'></label><span class='glyphicon itemstatus'></span>";
          html += "<input class='form-control' id='" + itemid + "' name='" + itemid + "' ng-model='" + formData + modelname + "' " + elms + ">";
          html += messageGenrator();
          html += "</div>";
        }
        else
        {
          html += missedItems[0];
        }

        return html;
      }

      function compileBox()
      {
        var newA = angular.copy(a);
        newA.type = s.$eval(newA.type) ? s.$eval(newA.type) : newA.type;
        newA.autocomplete = s.$eval(newA.autocomplete) ? s.$eval(newA.autocomplete) : newA.autocomplete;
        newA.required = s.$eval(newA.required) ? s.$eval(newA.required) : newA.required;
        newA.readonly = s.$eval(newA.readonly) ? s.$eval(newA.readonly) : newA.readonly;
        newA.geturlcheck = s.$eval(newA.geturlcheck) ? s.$eval(newA.geturlcheck) : newA.geturlcheck;
        newA.posturlcheck = s.$eval(newA.posturlcheck) ? s.$eval(newA.posturlcheck) : newA.posturlcheck;
        newA.minlength = s.$eval(newA.minlength) ? s.$eval(newA.minlength) : newA.minlength;
        newA.maxlength = s.$eval(newA.maxlength) ? s.$eval(newA.maxlength) : newA.maxlength;
        newA.minword = s.$eval(newA.minword) ? s.$eval(newA.minword) : newA.minword;
        newA.maxword = s.$eval(newA.maxword) ? s.$eval(newA.maxword) : newA.maxword;
        newA.ishtml = s.$eval(newA.ishtml) ? s.$eval(newA.ishtml) : newA.ishtml;
        newA.isnothtml = s.$eval(newA.isnothtml) ? s.$eval(newA.isnothtml) : newA.isnothtml;
        newA.nospace = s.$eval(newA.nospace) ? s.$eval(newA.nospace) : newA.nospace;
        newA.uppercase = s.$eval(newA.uppercase) ? s.$eval(newA.uppercase) : newA.uppercase;
        newA.lowercase = s.$eval(newA.lowercase) ? s.$eval(newA.lowercase) : newA.lowercase;
        newA.spellcheck = s.$eval(newA.spellcheck) ? s.$eval(newA.spellcheck) : newA.spellcheck;
        e.html(getTextBox(e, newA));
        // If scope is provided use it, otherwise use parent scope
        var compileScope = s;
        $compile(e.contents())(compileScope);
      }

      if (s.$eval(a.type)) {
        s.$watch(a.type, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.required)) {
        s.$watch(a.required, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.autocomplete)) {
        s.$watch(a.autocomplete, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.readonly)) {
        s.$watch(a.readonly, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.geturlcheck)) {
        s.$watch(a.geturlcheck, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.posturlcheck)) {
        s.$watch(a.posturlcheck, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.minlength)) {
        s.$watch(a.minlength, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.maxlength)) {
        s.$watch(a.maxlength, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.minword)) {
        s.$watch(a.minword, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.maxword)) {
        s.$watch(a.maxword, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.ishtml)) {
        s.$watch(a.ishtml, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.isnothtml)) {
        s.$watch(a.isnothtml, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.nospace)) {
        s.$watch(a.nospace, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.uppercase)) {
        s.$watch(a.uppercase, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.lowercase)) {
        s.$watch(a.lowercase, function() {
          compileBox();
        });
      }
      
      if (s.$eval(a.spellcheck)) {
        s.$watch(a.spellcheck, function() {
          compileBox();
        });
      }

      compileBox();

    }


    return data;
}
angular.module('app')
.directive('textbox', textbox).directive("fileread", [function () {
  return {
      scope: {
          fileread: "="
      },
      link: function (scope, element, attributes) {
          element.bind("change", function (changeEvent) {
              var reader = new FileReader();
              reader.onload = function (loadEvent) {
                  scope.$apply(function () {
                      scope.fileread = loadEvent.target.result;
                  });
              }
              reader.readAsDataURL(changeEvent.target.files[0]);
          });
      }
  }
}]);


function textbox($rootScope){
    var data = {
      restrict : "EA",
      transclude: true,
      template : genrateTextbox,
      link: linkFunction
    };

    function linkFunction(scope, element, attributes)
    {
      if(attributes.filepicker !== '' && attributes.filepicker !== undefined)
      {
        element.bind("change", function (changeEvent) {
            var reader = new FileReader();
            reader.onload = function (loadEvent) {
              scope.$apply(function () {
                var a = 'scope.' + attributes.filepicker + " = " + '" '+ loadEvent.target.result +' "';
                  // console.log(a);
                  eval(a);
              });
            }
            reader.readAsDataURL(changeEvent.target.files[0]);
        });
      }
    }

    function genrateTextbox(e,a)
    {
      var qattr = a.quickattrs;

      var qattrs = {};
      var found = false;
      if(a.localelement === undefined)
      {
          qattrs = $rootScope.fbuilderTextbox[qattr] ? $rootScope.fbuilderTextbox[qattr] : {};
          if($rootScope.fbuilderTextbox[qattr] === undefined)
          {
            return "Undefined Item";
          }
      }
      else
      {
        var q = $rootScope.$eval("fbuilderTextbox."+a.localelement);
        if(q === undefined || q[qattr] === undefined)
        {
          return "Undefined Item";
        }
        qattrs = q[qattr];
      }

      var s = getSize();
      var formname = getFormName();
      var formData = getFormDataName();
      var itemid = getItemid();
      var modelname = getModel();
      var tlate = getTlate();
      var labelprefix = getLabelPrefix();
      var labelsuffix = getLabelSuffix();
      var inputprefix = getInputPrefix();
      var inputsufix = getInputSufix();
      var labeltext = getLabelText();
      var showTitle = getShowTitle();
      var cssClass = getCssClass();

      var acitem = ""+formname+"."+itemid+"";

      var placeholder = "placeholder='' translate translate-attr-placeholder='"+tlate+"."+itemid+".placeholder'";

      var nclass = '{ "has-error": '+acitem+'.$invalid || '+acitem+'.$pending , "has-success": '+acitem+'.$valid , "has-pending": '+acitem+'.$pending}';
      var elms = placeholder+" "+validationGenrator();

      function getFormName()
      {
        if(getItemType() === "ngform")
        {
          return e.closest("ng-form").attr('name');
        }
        else
        {
          return e.closest("form").attr('id');
        }
      }

      function getFormPrivateType()
      {
        if(getItemType() !== "ngform")
        {
          var ax = e.closest("form").attr('privatedata');
          if(ax !== undefined)
          {
            return ax;
          }
          else
          {
            return false;
          }
        }
        else
        {
          return false;
        }
      }

      function getFormDataName()
      {
        if(getItemType() === "ngform")
        {
          return "";
        }
        else if(getItemType() === "private")
        {
          return "";
        }
        else
        {
          if(getFormPrivateType() === false)
          { 
            return getFormName()+"Data.";
          }
          else
          {
            return getFormPrivateType() + ".";
          }
        }
      }

      function getLabelPrefix() {
        if(a.labelprefix !== "" && a.labelprefix !== undefined)
        {
          return a.labelprefix;
        }
        else
        {
          return '';
        }
      }

      function getLabelSuffix() {
        if(a.labelsuffix !== "" && a.labelsuffix !== undefined)
        {
          return a.labelsuffix;
        }
        else
        {
          return '';
        }
      }
      
      function getInputPrefix() {
        if(a.inputprefix !== "" && a.inputprefix !== undefined)
        {
          return a.inputprefix;
        }
        else
        {
          return false;
        }
      }
      
      function getInputSufix() {
        if(a.inputsuffix !== "" && a.inputsuffix !== undefined)
        {
          return a.inputsuffix;
        }
        else
        {
          return false;
        }
      }

      // getInputSufix
      // getInputPrefix

      function getLabelText() {
        if(a.labeltext !== "" && a.labeltext !== undefined)
        {
          return a.labeltext;
        }
        else
        {
          return '';
        }
      }

      function getShowTitle()
      {
        if(a.showtitle !== "" && a.showtitle !== undefined)
        {
          return ' ng-show="'+a.showtitle+'" ';
        }
        else
        {
          return '';
        }
      }

      function getCssClass()
      {
        if(a.cssclass !== "" && a.cssclass !== undefined)
        {
          return a.cssclass;
        }
        else
        {
          return '';
        }
      }

      function getItemType() {
        if(a.itemtype !== "" && a.itemtype !== undefined)
        {
          return a.itemtype;
        }
        else
        {
          if(qattrs.itemtype !== "" && qattrs.itemtype !== undefined)
          {
            return qattrs.itemtype;
          }
        }
      }

      function getSize() {
        if(a.size !== "" && a.size !== undefined)
        {
          return a.size;
        }
        else
        {
          if(qattrs.size !== "" && qattrs.size !== undefined)
          {
            return qattrs.size;
          }
        }
      }

      function getItemid() {
        if(a.itemid !== "" && a.itemid !== undefined)
        {
          return a.itemid;
        }
        else
        {
          if(qattrs.itemid !== "" && qattrs.itemid !== undefined)
          {
            return qattrs.itemid;
          }
        }
      }

      function getModel() {
        if(a.modelname !== "" && a.modelname !== undefined)
        {
          return a.modelname;
        }
        else
        {
          if(qattrs.modelname !== "" && qattrs.modelname !== undefined)
          {
            return qattrs.modelname;
          }
        }
      }

      function getTlate() {
        if(a.tlate !== "" && a.tlate !== undefined)
        {
          return a.tlate;
        }
        else
        {
          if(qattrs.tlate !== "" && qattrs.tlate !== undefined)
          {
            return qattrs.tlate;
          }
        }
      }

      function validationGenrator()
      {
        var v = "";


        if(a.type !== "" && a.type !== undefined)
        {
          v += " type='"+a.type+"'";
        }
        else
        {
          if(qattrs.type !== "" && qattrs.type !== undefined)
          {
            v += " type='"+qattrs.type+"'";
          }
          else
          {
            v += " type='text'";            
          }
        }


        if(a.list !== "" && a.list !== undefined)
        {
          v += " list='"+a.list+"'";
        }
        else
        {
          if(qattrs.list !== "" && qattrs.list !== undefined)
          {
            v += " list='"+qattrs.list+"'";
          }
        }

        if(a.accept !== "" && a.accept !== undefined)
        {
          v += " accept='"+a.accept+"'";
        }
        else
        {
          if(qattrs.accept !== "" && qattrs.accept !== undefined)
          {
            v += " accept='"+qattrs.accept+"'";
          }
        }


        if(a.autocomplete !== "" && a.autocomplete !== undefined)
        {
          if((a.autocomplete.toLowerCase() === 'true'))
          {
            v += " autocomplete='off'";
          }
        }
        else
        {
          if(qattrs.autocomplete !== "" && qattrs.autocomplete !== undefined)
          {
            if((qattrs.autocomplete.toLowerCase() === "true"))
            {
              v += " autocomplete='off'";
            }
          }
        }

        if(a.rdrequired === "" || a.rdrequired === undefined)
        {
          if(a.required !== "" && a.required !== undefined)
          {
            if((a.required.toLowerCase() === 'true'))
            {
              v += " required='true'";
            }
          }
          else
          {
            if(qattrs.required !== "" && qattrs.required !== undefined)
            {
              if((qattrs.required.toLowerCase() === "true"))
              {
                v += " required='true'";
              }
            }
          }
        }
        
        if(a.rdrequired !== "" && a.rdrequired !== undefined)
        {
          v += " ng-required='"+a.rdrequired+"'";
        }


        if(a.readonly !== "" && a.readonly !== undefined)
        {
          if((a.readonly.toLowerCase() === 'true') || (a.readonly.toLowerCase() === 'readonly'))
          {
            v += " readonly='readonly' tabIndex='-1'";
          }
        }
        else
        {
          if(qattrs.readonly !== "" && qattrs.readonly !== undefined)
          {
            if((qattrs.readonly.toLowerCase() === "true"))
            {
              v += " readonly='readonly' tabIndex='-1'";
            }
          }
        }




        if(a.rdreadonly !== "" && a.rdreadonly !== undefined)
        {
          v += " ng-readonly='"+a.rdreadonly+"'";
        }



        if(a.minlength !== "" && a.minlength !== undefined)
        {
          v += " ng-minlength='"+a.minlength+"'";
        }
        else
        {
          if(qattrs.minlength !== "" && qattrs.minlength !== undefined)
          {
            v += " ng-minlength='"+qattrs.minlength+"'";
          }
        }



        if(a.maxlength !== "" && a.maxlength !== undefined)
        {
          v += " ng-maxlength='"+a.maxlength+"'";
        }
        else
        {
          if(qattrs.maxlength !== "" && qattrs.maxlength !== undefined)
          {
            v += " ng-maxlength='"+qattrs.maxlength+"'";
          }
        }



        if(a.nachar !== "" && a.nachar !== undefined)
        {
          v += " rdnachar='"+a.nachar+"'";
        }
        else
        {
          if(qattrs.nachar !== "" && qattrs.nachar !== undefined)
          {
            v += " rdnachar='"+qattrs.nachar+"'";
          }
        }



        if(a.geturlcheck !== "" && a.geturlcheck !== undefined)
        {
          if((a.geturlcheck.toLowerCase() !== 'false'))
          {
            console.log(a.geturlcheck);
            v += " rdgeturlcheck='"+a.geturlcheck+"'";
          }
        }
        else
        {
          if(qattrs.geturlcheck !== "" && qattrs.geturlcheck !== undefined)
          {
            if((qattrs.geturlcheck.toLowerCase() !== 'false'))
            {
              v += " rdgeturlcheck='"+qattrs.geturlcheck+"'";
            }
          }
        }



        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          v += " rdposturlcheck='"+a.posturlcheck+"'";
        }
        else
        {
          if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
          {
            v += " rdposturlcheck='"+qattrs.posturlcheck+"'";
          }
        }



        if(a.naword !== "" && a.naword !== undefined)
        {
          v += " rdnaword='"+a.naword+"'";
        }
        else
        {
          if(qattrs.naword !== "" && qattrs.naword !== undefined)
          {
            v += " rdnaword='"+qattrs.naword+"'";
          }
        }



        if(a.nawords !== "" && a.nawords !== undefined)
        {
          v += " rdnawords='"+a.nawords+"'";
        }
        else
        {
          if(qattrs.nawords !== "" && qattrs.nawords !== undefined)
          {
            v += " rdnawords='"+qattrs.nawords+"'";
          }
        }



        if(a.minword !== "" && a.minword !== undefined)
        {
          v += " rdminword='"+a.minword+"'";
        }
        else
        {
          if(qattrs.minword !== "" && qattrs.minword !== undefined)
          {
            v += " rdminword='"+qattrs.minword+"'";
          }
        }



        if(a.maxword !== "" && a.maxword !== undefined)
        {
          v += " rdmaxword='"+a.maxword+"'";
        }
        else
        {
          if(qattrs.maxword !== "" && qattrs.maxword !== undefined)
          {
            v += " rdmaxword='"+qattrs.maxword+"'";
          }
        }



        if(a.ishtml !== "" && a.ishtml !== undefined)
        {
          if((a.ishtml.toLowerCase() === 'true'))
          {
            v += " rdishtml='true'";
          }
        }
        else
        {
          if(qattrs.ishtml !== "" && qattrs.ishtml !== undefined)
          {
            if((qattrs.ishtml.toLowerCase() === 'true'))
            {
              v += " rdishtml='true'";
            }
          }
        }



        if(a.isnothtml !== "" && a.isnothtml !== undefined)
        {
          if((a.isnothtml.toLowerCase() === 'true'))
          {
            v += " rdisnothtml='true'";
          }
        }
        else
        {
          if(qattrs.isnothtml !== "" && qattrs.isnothtml !== undefined)
          {
            if((qattrs.isnothtml.toLowerCase() === 'true'))
            {
              v += " rdisnothtml='true'";
            }
          }
        }



        if(a.nospace !== "" && a.nospace !== undefined)
        {
          if((a.nospace.toLowerCase() === 'true'))
          {
            v += " rdnospace='true'";
          }
        }
        else
        {
          if(qattrs.nospace !== "" && qattrs.nospace !== undefined)
          {
            if((qattrs.nospace.toLowerCase() === 'true'))
            {
              v += " rdnospace='true'";
            }
          }
        }



        if(a.uppercase !== "" && a.uppercase !== undefined)
        {
          if((a.uppercase.toLowerCase() === 'true'))
          {
            v += " rduppercase='true'";
          }
        }
        else
        {
          if(qattrs.uppercase !== "" && qattrs.uppercase !== undefined)
          {
            if((qattrs.uppercase.toLowerCase() === 'true'))
            {
              v += " rduppercase='true'";
            }
          }
        }



        if(a.lowercase !== "" && a.lowercase !== undefined)
        {
          if((a.lowercase.toLowerCase() === 'true'))
          {
            v += " rdlowercase='true'";
          }
        }
        else
        {
          if(qattrs.lowercase !== "" && qattrs.lowercase !== undefined)
          {
            if((qattrs.lowercase.toLowerCase() === 'true'))
            {
              v += " rdlowercase='true'";
            }
          }
        }



        if(a.spellcheck !== "" && a.spellcheck !== undefined)
        {
          if((a.spellcheck.toLowerCase() === 'true'))
          {
            v += " spellcheck='true'";
          }
          else
          {
            v += " spellcheck='false'";            
          }
        }
        else
        {
          if(qattrs.spellcheck !== "" && qattrs.spellcheck !== undefined)
          {
            if((qattrs.spellcheck.toLowerCase() === 'true'))
            {
              v += " spellcheck='true'";
            }
            else
            {
              v += " spellcheck='false'";            
            }
          }
        }



        if(a.pattern !== "" && a.pattern !== undefined)
        {
          v += " ng-pattern='"+a.pattern+"'";
        }
        else
        {
          if(qattrs.pattern !== "" && qattrs.pattern !== undefined)
          {
            v += " ng-pattern='"+qattrs.pattern+"'";
          }
        }

        

        if(a.rdblur !== "" && a.rdblur !== undefined)
        {
          v += "ng-blur='"+a.rdblur+"'";
        }
        else
        {
          if(qattrs.rdblur !== "" && qattrs.rdblur !== undefined)
          {
            v += "ng-blur='"+qattrs.rdblur+"'";
          }
        }


        return v;
      }

      function messageGenrator()
      {
        var h = "";
        var v = "";
        h += "<div ng-messages='"+acitem+".$error' ng-show='"+acitem+".$dirty' role='alert'>";


        if(a.required !== "" && a.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }
        else if(qattrs.required !== "" && qattrs.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }


        if(a.minlength !== "" && a.minlength !== undefined)
        {
          h += "<div ng-message='minlength'><span class='help-block' translate='"+tlate+"."+itemid+".minlength'></span></div>";
        }
        else if(qattrs.minlength !== "" && qattrs.minlength !== undefined)
        {
          h += "<div ng-message='minlength'><span class='help-block' translate='"+tlate+"."+itemid+".minlength'></span></div>";
        }



        if(a.maxlength !== "" && a.maxlength !== undefined)
        {
          h += "<div ng-message='maxlength'><span class='help-block' translate='"+tlate+"."+itemid+".maxlength'></span></div>";
        }
        else if(qattrs.maxlength !== "" && qattrs.maxlength !== undefined)
        {
          h += "<div ng-message='maxlength'><span class='help-block' translate='"+tlate+"."+itemid+".maxlength'></span></div>";
        }



        if(a.nachar !== "" && a.nachar !== undefined)
        {
          h += "<div ng-message='rdnachar'><span class='help-block' translate='"+tlate+"."+itemid+".nachar'></span></div>";
        }
        else if(qattrs.nachar !== "" && qattrs.nachar !== undefined)
        {
          h += "<div ng-message='rdnachar'><span class='help-block' translate='"+tlate+"."+itemid+".nachar'></span></div>";
        }



        if(a.geturlcheck !== "" && a.geturlcheck !== undefined)
        {
          h += "<div ng-message='rdgeturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".geturlcheck'></span></div>";
        }
        else if(qattrs.geturlcheck !== "" && qattrs.geturlcheck !== undefined)
        {
          h += "<div ng-message='rdgeturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".geturlcheck'></span></div>";
        }



        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }
        else if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }



        if(a.naword !== "" && a.naword !== undefined)
        {
          h += "<div ng-message='rdnaword'><span class='help-block' translate='"+tlate+"."+itemid+".naword'></span></div>";
        }
        else if(qattrs.naword !== "" && qattrs.naword !== undefined)
        {
          h += "<div ng-message='rdnaword'><span class='help-block' translate='"+tlate+"."+itemid+".naword'></span></div>";
        }



        if(a.nawords !== "" && a.nawords !== undefined)
        {
          h += "<div ng-message='rdnawords'><span class='help-block' translate='"+tlate+"."+itemid+".nawords'></span></div>";
        }
        else if(qattrs.nawords !== "" && qattrs.nawords !== undefined)
        {
          h += "<div ng-message='rdnawords'><span class='help-block' translate='"+tlate+"."+itemid+".nawords'></span></div>";
        }



        if(a.minword !== "" && a.minword !== undefined)
        {
          h += "<div ng-message='rdminword'><span class='help-block' translate='"+tlate+"."+itemid+".minword'></span></div>";
        }
        else if(qattrs.minword !== "" && qattrs.minword !== undefined)
        {
          h += "<div ng-message='rdminword'><span class='help-block' translate='"+tlate+"."+itemid+".minword'></span></div>";
        }



        if(a.maxword !== "" && a.maxword !== undefined)
        {
          h += "<div ng-message='rdmaxword'><span class='help-block' translate='"+tlate+"."+itemid+".maxword'></span></div>";
        }
        else if(qattrs.maxword !== "" && qattrs.maxword !== undefined)
        {
          h += "<div ng-message='rdmaxword'><span class='help-block' translate='"+tlate+"."+itemid+".maxword'></span></div>";
        }



        if(a.ishtml !== "" && a.ishtml !== undefined)
        {
          h += "<div ng-message='rdishtml'><span class='help-block' translate='"+tlate+"."+itemid+".ishtml'></span></div>";
        }
        else if(qattrs.ishtml !== "" && qattrs.ishtml !== undefined)
        {
          h += "<div ng-message='rdishtml'><span class='help-block' translate='"+tlate+"."+itemid+".ishtml'></span></div>";
        }



        if(a.isnothtml !== "" && a.isnothtml !== undefined)
        {
          h += "<div ng-message='rdisnothtml'><span class='help-block' translate='"+tlate+"."+itemid+".isnothtml'></span></div>";
        }
        else if(qattrs.isnothtml !== "" && qattrs.isnothtml !== undefined)
        {
          h += "<div ng-message='rdisnothtml'><span class='help-block' translate='"+tlate+"."+itemid+".isnothtml'></span></div>";
        }



        if(a.nospace !== "" && a.nospace !== undefined)
        {
          h += "<div ng-message='rdnospace'><span class='help-block' translate='"+tlate+"."+itemid+".nospace'></span></div>";
        }
        else if(qattrs.nospace !== "" && qattrs.nospace !== undefined)
        {
          h += "<div ng-message='rdnospace'><span class='help-block' translate='"+tlate+"."+itemid+".nospace'></span></div>";
        }



        if(a.uppercase !== "" && a.uppercase !== undefined)
        {
          h += "<div ng-message='rduppercase'><span class='help-block' translate='"+tlate+"."+itemid+".uppercase'></span></div>";
        }
        else if(qattrs.uppercase !== "" && qattrs.uppercase !== undefined)
        {
          h += "<div ng-message='rduppercase'><span class='help-block' translate='"+tlate+"."+itemid+".uppercase'></span></div>";
        }



        if(a.lowercase !== "" && a.lowercase !== undefined)
        {
          h += "<div ng-message='rdlowercase'><span class='help-block' translate='"+tlate+"."+itemid+".lowercase'></span></div>";
        }
        else if(qattrs.lowercase !== "" && qattrs.lowercase !== undefined)
        {
          h += "<div ng-message='rdlowercase'><span class='help-block' translate='"+tlate+"."+itemid+".lowercase'></span></div>";
        }



        if(a.pattern !== "" && a.pattern !== undefined)
        {
          h += "<div ng-message='pattern'><span class='help-block' translate='"+tlate+"."+itemid+".pattern'></span></div>";
        }
        else if(qattrs.pattern !== "" && qattrs.pattern !== undefined)
        {
          h += "<div ng-message='pattern'><span class='help-block' translate='"+tlate+"."+itemid+".pattern'></span></div>";
        }



        h += "</div>";
        return h;
      }

      var html = '';
      html += "<div class='"+s+" form-group "+cssClass+"' ng-class='"+nclass+"'>";
      if(labeltext === "")
      {
        html += "<span "+showTitle+"  class='control-label'> "+ labelprefix +"</span><label "+showTitle+"  for='"+itemid+"' class='control-label' translate='"+tlate+"."+itemid+".title'></label><span "+showTitle+"  class='control-label'> "+ labelsuffix +"</span><span class='glyphicon itemstatus' "+showTitle+" ></span>";
      }
      else
      {
        html += "<label "+showTitle+"  for='"+itemid+"' class='control-label'>"+ labeltext +"</label><span class='glyphicon itemstatus' "+showTitle+" ></span>";
      }

      var ng = " ng-model='"+formData+modelname+"' ";

      // if(a.type === "file" || qattrs.type !== "file")
      // {
      //   ng = " fileread='"+formData+modelname+"' ";
      // }

      if(inputsufix !== false || inputprefix !== false)
      {
        html += '<div class="input-group">';
      }

      if(inputprefix !== false)
      {
        html += '<span class="input-group-addon">'+getInputPrefix()+'</span>';
      }

      html += "<input class='form-control' id='"+itemid+"' name='"+itemid+"' "+elms+" "+ ng +" >";

      if(inputsufix !== false)
      {
        html += '<span class="input-group-addon">'+getInputSufix()+'</span>';
      }      

      if(inputsufix !== false || inputprefix !== false)
      {
        html += '</div>';
      }

      html += messageGenrator();
      html += "</div>";

      return html;
    }


    return data;
}
angular.module('app')
.directive('selectbox', selectbox)
.directive('s2Options', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function (value) {
        if(attrs.multiselect === 'true' || attrs.multiselect === true)
        {
          if(typeof value === 'string')
          {
            var a = value.split(',');
            console.log(a);
            return a;
          }
          else
          {
            var v = value.toString();
            console.log(v);
            var a = v.split(',');
            console.log(a);
            return a;
          }
        }
        return value;
      });
      ngModel.$formatters.push(function (value) {
        // if(attrs.multiselect === 'true' || attrs.multiselect === true)
        // {
        //   if(typeof value === 'array')
        //   {
        //     var a = value.join();
        //     return a;
        //   }
        // }
        return value;
      });
    }
  };
});


function selectbox($rootScope,$parse,getServer){
    var data = {
      restrict : "EA",
      transclude: true,
      template : genrateSelectbox,
    };
    function genrateSelectbox(e,a)
    {
      
      var qattr = a.quickattrs;
      
      var qattrs = {};
      var found = false;
      if(a.localelement === undefined)
      {
          qattrs = $rootScope.fbuilderSelectbox[qattr] ? $rootScope.fbuilderSelectbox[qattr] : {};
          if($rootScope.fbuilderSelectbox[qattr] === undefined)
          {
            return "Undefined Item";
          }
      }
      else
      {
        var q = $rootScope.$eval("fbuilderSelectbox."+a.localelement);
        if(q === undefined || q[qattr] === undefined)
        {
          return "Undefined Item";
        }
        qattrs = q[qattr];
      }
      
      // var s = a.size;
      var s = getSize();
      var formname = getFormName();
      var formData = getFormDataName();
      var itemid = getItemid();
      var modelname = getModel();
      var tlate = getTlate();
      var labelsuffix = getLabelSuffix();
      var showTitle = getShowTitle();
      var cssClass = getCssClass();

      var acitem = ""+formname+"."+itemid+"";

      var placeholder = "placeholder='' translate translate-attr-placeholder='"+tlate+"."+itemid+".placeholder'";

      var nclass = '{ "has-error": '+acitem+'.$invalid || '+acitem+'.$pending , "has-success": '+acitem+'.$valid , "has-pending": '+acitem+'.$pending}';
      var elms = placeholder+" "+validationGenrator();


      function getFormName()
      {
        if(getItemType() === "ngform")
        {
          return e.closest("ng-form").attr('name');
        }
        else
        {
          return e.closest("form").attr('id');
        }
      }

      function getFormPrivateType()
      {
        if(getItemType() !== "ngform")
        {
          var ax = e.closest("form").attr('privatedata');
          if(ax !== undefined)
          {
            return ax;
          }
          else
          {
            return false;
          }
        }
        else
        {
          return false;
        }
      }

      function getFormDataName()
      {
        if(getItemType() === "ngform")
        {
          return "";
        }
        else if(getItemType() === "private")
        {
          return "";
        }
        else
        {
          if(getFormPrivateType() === false)
          { 
            return getFormName()+"Data.";
          }
          else
          {
            return getFormPrivateType() + ".";
          }
        }
      }

      function getLabelSuffix() {
        if(a.labelsuffix !== "" && a.labelsuffix !== undefined)
        {
          return a.labelsuffix;
        }
        else
        {
          return '';
        }
      }

      function getShowTitle()
      {
        if(a.showtitle !== "" && a.showtitle !== undefined)
        {
          return ' ng-show="'+a.showtitle+'" ';
        }
        else
        {
          return '';
        }
      }

      function getCssClass()
      {
        if(a.cssclass !== "" && a.cssclass !== undefined)
        {
          return a.cssclass;
        }
        else
        {
          return '';
        }
      }

      function getItemType() {
        if(a.itemtype !== "" && a.itemtype !== undefined)
        {
          return a.itemtype;
        }
        else
        {
          if(qattrs.itemtype !== "" && qattrs.itemtype !== undefined)
          {
            return qattrs.itemtype;
          }
        }
      }


      function getType() {
        if(a.type !== "" && a.type !== undefined)
        {
          return a.type;
        }
        else
        {
          if(qattrs.type !== "" && qattrs.type !== undefined)
          {
            return qattrs.type;
          }
        }
      }

      function getObjRtn() {
        if(a.objectReturn !== "" && a.objectReturn !== undefined)
        {
          if(a.objectReturn === "true")
          {
            return true;
          }
          else
          {
            return false;
          }
        }
        else
        {
          if(qattrs.objectReturn !== "" && qattrs.objectReturn !== undefined)
          {
            if(qattrs.objectReturn === "true")
            {
              return true;
            }
            else
            {
              return false;
            }
          }
          else
          {
            return false;
          }
        }
      }


      function getSize() {
        if(a.size !== "" && a.size !== undefined)
        {
          return a.size;
        }
        else
        {
          if(qattrs.size !== "" && qattrs.size !== undefined)
          {
            return qattrs.size;
          }
        }
      }

      function getItemid() {
        if(a.itemid !== "" && a.itemid !== undefined)
        {
          return a.itemid;
        }
        else
        {
          if(qattrs.itemid !== "" && qattrs.itemid !== undefined)
          {
            return qattrs.itemid;
          }
        }
      }

      function getModel() {
        if(a.modelname !== "" && a.modelname !== undefined)
        {
          return a.modelname;
        }
        else
        {
          if(qattrs.modelname !== "" && qattrs.modelname !== undefined)
          {
            return qattrs.modelname;
          }
        }
      }

      function getTlate() {
        if(a.tlate !== "" && a.tlate !== undefined)
        {
          return a.tlate;
        }
        else
        {
          if(qattrs.tlate !== "" && qattrs.tlate !== undefined)
          {
            return qattrs.tlate;
          }
        }
      }

      function validationGenrator()
      {
        var v = "";

        if(getType() !== "normal")
        {
          v += " data-placeholder='' translate translate-attr-data-placeholder='"+getTlate()+"."+itemid+".placeholder'";          
        }

        if(a.rdrequired === "" || a.rdrequired === undefined)
        {
          if(a.required !== "" && a.required !== undefined)
          {
            if((a.required.toLowerCase() === 'true'))
            {
              v += " ng-required='true'";
            }
          }
          else
          {
            if(qattrs.required !== "" && qattrs.required !== undefined)
            {
              if((qattrs.required.toLowerCase() === "true"))
              {
                v += " ng-required='true'";
              }
            }
          }
        }

        if(a.rdrequired !== "" && a.rdrequired !== undefined)
        {
          v += " ng-required='"+a.rdrequired+"'";
        }


        if(a.required !== "" && a.required !== undefined)
        {
          if((a.required.toLowerCase() === 'true'))
          {
            v += " required='true'";
          }
        }
        else
        {
          if(qattrs.required !== "" && qattrs.required !== undefined)
          {
            if((qattrs.required.toLowerCase() === "true"))
            {
              v += " required='true'";
            }
          }
        }


        if(a.jsonposturlcheck !== "" && a.jsonposturlcheck !== undefined)
        {
          v += " rdjsonposturlcheck='"+a.jsonposturlcheck+"'";
        }
        else
        {
          if(qattrs.jsonposturlcheck !== "" && qattrs.jsonposturlcheck !== undefined)
          {
            v += " rdjsonposturlcheck='"+qattrs.jsonposturlcheck+"'";
          }
        }

        if(a.rdsearchcallback !== "" && a.rdsearchcallback !== undefined)
        {
          v += " searchcallback='"+a.rdsearchcallback+"'";
        }

        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          v += " rdposturlcheck='"+a.posturlcheck+"'";
        }
        else
        {
          if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
          {
            v += " rdposturlcheck='"+qattrs.posturlcheck+"'";
          }
        }

        if(a.multiple !== "" && a.multiple !== undefined)
        {
          if((a.multiple.toLowerCase() === "true"))
          {
            v += " multiselect='"+a.multiple+"'";
          }
        }
        else
        {
          if(qattrs.multiple !== "" && qattrs.multiple !== undefined)
          {
            if((qattrs.multiple.toLowerCase() === "true"))
            {
              v += " multiselect='"+qattrs.multiple+"'";
            }
          }
        }

        if(a.minselect !== "" && a.minselect !== undefined)
        {
          v += " rdminselect='"+a.minselect+"'";
        }
        else
        {
          if(qattrs.minselect !== "" && qattrs.minselect !== undefined)
          {
            v += " rdminselect='"+qattrs.minselect+"'";
          }
        }


        if(a.maxselect !== "" && a.maxselect !== undefined)
        {
          v += " rdmaxselect='"+a.maxselect+"'";
        }
        else
        {
          if(qattrs.maxselect !== "" && qattrs.maxselect !== undefined)
          {
            v += " rdmaxselect='"+qattrs.maxselect+"'";

          }
        }


        if(a.rdchange !== "" && a.rdchange !== undefined)
        {
          v += " ng-change='"+a.rdchange+"'";
        }
        else
        {
          if(qattrs.rdchange !== "" && qattrs.rdchange !== undefined)
          {
            v += " ng-change='"+qattrs.rdchange+"'";

          }
        }

        if(a.rdblur !== "" && a.rdblur !== undefined)
        {
          v += "ng-blur='"+a.rdblur+"'";
        }
        else
        {
          if(qattrs.rdblur !== "" && qattrs.rdblur !== undefined)
          {
            v += "ng-blur='"+qattrs.rdblur+"'";
          }
        }

        
        if(a.readonly !== "" && a.readonly !== undefined)
        {
          if((a.readonly.toLowerCase() === "true") || (a.readonly.toLowerCase() === "readonly"))
          {
            if((a.readonly.toLowerCase() === "readonly"))
            {
              a.readonly = 'true';
            }
            v += " ng-disabled='"+a.readonly+"'  disabled='"+a.readonly+"' tabIndex='-1'";
          }
        }
        else
        {
          if(qattrs.readonly !== "" && qattrs.readonly !== undefined)
          {
            if((qattrs.readonly.toLowerCase() === "true") || (qattrs.readonly.toLowerCase() === "readonly"))
            {
              if((qattrs.readonly.toLowerCase() === "readonly"))
              {
                qattrs.readonly = 'true';
              }
              v += " ng-disabled='"+qattrs.readonly+"'  disabled='"+qattrs.readonly+"' tabIndex='-1'";
            }
          }
        }

        if(a.rdreadonly !== "" && a.rdreadonly !== undefined)
        {
          v += ' ng-disabled="'+a.rdreadonly+'"';
        }

        return v;
      }

      function messageGenrator()
      {
        var h = "";
        var v = "";
        h += "<div ng-messages='"+acitem+".$error' ng-show='"+acitem+".$dirty' role='alert'>";


        if(a.required !== "" && a.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }
        else if(qattrs.required !== "" && qattrs.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }



        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }
        else if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }



        if(a.jsonposturlcheck !== "" && a.jsonposturlcheck !== undefined)
        {
          h += "<div ng-message='rdjsonposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".jsonposturlcheck'></span></div>";
        }
        else if(qattrs.jsonposturlcheck !== "" && qattrs.jsonposturlcheck !== undefined)
        {
          h += "<div ng-message='rdjsonposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".jsonposturlcheck'></span></div>";
        }

        h += "</div>";
        return h;
      }

      var converterAttr = '';


      function options_generator()
      {
        var v = "{";

        if(a.multiple !== "" && a.multiple !== undefined)
        {
          if((a.multiple.toLowerCase() === "true"))
          {
            v += " multiple: "+a.multiple+", ";
            converterAttr = ' string-to-array ';
          }
        }
        else
        {
          if(qattrs.multiple !== "" && qattrs.multiple !== undefined)
          {
            if((qattrs.multiple.toLowerCase() === "true"))
            {
              v += " multiple: "+qattrs.multiple+", ";
              converterAttr = ' string-to-array ';
            }
          }
        }
        
        if(a.tags !== "" && a.tags !== undefined)
        {
          if((a.tags.toLowerCase() === "true"))
          {
            v += " tags: "+a.tags+", ";
          }
        }
        else
        {
          if(qattrs.tags !== "" && qattrs.tags !== undefined)
          {
            if((qattrs.tags.toLowerCase() === "true"))
            {
              v += " tags: "+qattrs.tags+", ";
            }
          }
        }
        
        if(a.allowClear !== "" && a.allowClear !== undefined)
        {
          if((a.allowClear.toLowerCase() === "true"))
          {
            v += " allowClear: "+a.allowClear+", ";
          }
        }
        else
        {
          if(qattrs.allowClear !== "" && qattrs.allowClear !== undefined)
          {
            if((qattrs.allowClear.toLowerCase() === "true"))
            {
              v += " allowClear: "+qattrs.allowClear+", ";
            }
          }
        }

        // v += ' query: function (query) { var data = { results: [ { id: "1", text: "A" }, { id: "2", text: "B" } ] }; query.callback(data); }, ';

        v += "}";
        // console.log(v);
        return v;
      }

      function getDisableBox(lp)
      {
        return '';
        var dbi ='';
        if(a.disableitems !== "" && a.disableitems !== undefined)
        {
          if(a.disableitems === 'true' || a.disableitems === true)
          {
            dbi = " disable when "+lp+"s.disabled ";
          }
        }
        else
        {
          if(qattrs.disableitems !== "" && qattrs.disableitems !== undefined)
          {
            if(qattrs.disableitems === 'true' || a.disableitems === true)
            {
              dbi = " disable when "+lp+"s.disabled ";
            }
          }
        }
        return dbi;
      }

      function s2Options_generator()
      {
        var v = "";

        if(a.localvarformat !== "" && a.localvarformat !== undefined)
        {
          v = ""+a.localvarformat+"";
        }
        else
        {
          if(qattrs.localVarFormat !== "" && qattrs.localVarFormat !== undefined)
          {
            v = ""+qattrs.localVarFormat+"";
          }
        }

        if(a.localvariable !== "" && a.localvariable !== undefined)
        {
          var lp = itemid+'DATA';
          if(getObjRtn())
          {
            v = ""+lp+"s.name " + getDisableBox(lp) + " for "+lp+" in "+a.localvariable+" track by "+lp+"s.value"+"";
          }
          else
          {
            v = ""+lp+"s.value as "+lp+"s.name " + getDisableBox(lp) + " for "+lp+"s in "+a.localvariable+"";
          }
        }
        else
        {
          if(qattrs.localVariable !== "" && qattrs.localVariable !== undefined)
          {            
            var lp = itemid+'DATA';
            if(getObjRtn())
            {
              v = ""+lp+"s.name " + getDisableBox(lp) + " for "+lp+" in "+qattrs.localVariable+" track by "+lp+"s.value"+"";
            }
            else
            {
              v = ""+lp+"s.value as "+lp+"s.name " + getDisableBox(lp) + " for "+lp+"s in "+qattrs.localVariable+"";
            }
          }
        }

        if(a.datalocal !== "" && a.datalocal !== undefined)
        {
            var d = a.datalocal;
            var datacount = function() {
              if(a.dynamicdata === 'yes' || true)
              {
                $rootScope.tempData.tempCount += 1;
                return $rootScope.tempData.tempCount;
              }
              return '';
            };
            var id = itemid+datacount();
            var mode = $parse(id+'DATA');
            if(d !== false)
            {
              var edata = JSON.parse(d);
              mode.assign($rootScope.tempData.fbuilderSelectQuery, edata);
              var localP = "tempData.fbuilderSelectQuery."+id+"DATA";
              var lp = id+'DATA';

              if(getObjRtn())
              {
                v = ""+lp+"s.name " + getDisableBox(lp) + " for "+lp+" in "+localP+" track by "+lp+"s.value"+"";
              }
              else
              {
                v = ""+lp+"s.value as "+lp+"s.name " + getDisableBox(lp) + " for "+lp+"s in "+localP+"";
              }
            }
        }
        else
        {
          if(qattrs.dataLocal !== "" && qattrs.dataLocal !== undefined)
          {
              var d = qattrs.dataLocal;
              var datacount = function() {
                if(a.dynamicdata === 'yes' || true)
                {
                  $rootScope.tempData.tempCount += 1;
                  return $rootScope.tempData.tempCount;
                }
                return '';
              };
              var id = itemid+datacount();
              var mode = $parse(id+'DATA');
              if(d !== false)
              {
                var edata = JSON.parse(d);
                mode.assign($rootScope.tempData.fbuilderSelectQuery, edata);
                var localP = "tempData.fbuilderSelectQuery."+id+"DATA";
                var lp = id+'DATA';

                if(getObjRtn())
                {
                  v = ""+lp+"s.name " + getDisableBox(lp) + " for "+lp+" in "+localP+" track by "+lp+"s.value"+"";
                }
                else
                {
                  v = ""+lp+"s.value as "+lp+"s.name " + getDisableBox(lp) + " for "+lp+"s in "+localP+"";
                }
              }
          }
        }

        if(a.dataapiurl !== "" && a.dataapiurl !== undefined)
        {
            var url = a.dataapiurl;
            var datacount = function() {
              if(a.dynamicdata === 'yes' || true)
              {
                $rootScope.tempData.tempCount += 1;
                return $rootScope.tempData.tempCount;
              }
              return '';
            };
            var id = itemid+datacount();
            var mode = $parse(id+'DATA');
            var edata = [
              {
                "name":"Loading..",
                "value":"Loading.."
              }
            ];
            mode.assign($rootScope.tempData.fbuilderSelectQuery, edata);
            var localP = "tempData.fbuilderSelectQuery."+id+"DATA";
            var lp = id+'DATA';

            if(getObjRtn())
            {
              v = ""+lp+"s.name " + getDisableBox(lp) + " for "+lp+" in "+localP+" track by "+lp+"s.value"+"";
            }
            else
            {
              v = ""+lp+"s.value as "+lp+"s.name " + getDisableBox(lp) + " for "+lp+"s in "+localP+"";
            }


            if(url !== false)
            {
              getServer.getData(url).then(function(data){
                mode.assign($rootScope.tempData.fbuilderSelectQuery, data.result);
              });
            }
        }
        else
        {
          if(qattrs.dataAPIURL !== "" && qattrs.dataAPIURL !== undefined)
          {
              var url = qattrs.dataAPIURL;
              var datacount = function() {
                if(a.dynamicdata === 'yes' || true)
                {
                  $rootScope.tempData.tempCount += 1;
                  return $rootScope.tempData.tempCount;
                }
                return '';
              };
              var id = itemid+datacount();
              var mode = $parse(id+'DATA');
              var edata = [
                {
                  "name":"Loading..",
                  "value":"Loading.."
                }
              ];
              mode.assign($rootScope.tempData.fbuilderSelectQuery, edata);
              var localP = "tempData.fbuilderSelectQuery."+id+"DATA";
              var lp = id+'DATA';

              if(getObjRtn())
              {
                v = ""+lp+"s.name " + getDisableBox(lp) + " for "+lp+" in "+localP+" track by "+lp+"s.value"+"";
              }
              else
              {
                v = ""+lp+"s.value as "+lp+"s.name " + getDisableBox(lp) + " for "+lp+"s in "+localP+"";
              }


              if(url !== false)
              {
                getServer.getData(url).then(function(data){
                  mode.assign($rootScope.tempData.fbuilderSelectQuery, data.result);
                });
              }
          }
        }

        if (a.dataapiurlformat !== "" && a.dataapiurlformat !== undefined) {
          var arrD = a.dataapiurlformat;
          var datacount = function() {
            if(a.dynamicdata === 'yes' || true)
            {
              $rootScope.tempData.tempCount += 1;
              return $rootScope.tempData.tempCount;
            }
            return '';
          };
          var id = itemid+datacount();
          var arr = arrD.split(",");
          var url = arr[0];
          var nameV = arr[1];
          var valueV = arr[2];
          var mode = $parse(id + "DATA");
          var edata = [{ name: "Loading..", value: "Loading.." }];
          mode.assign($rootScope.tempData.fbuilderSelectQuery, edata);
          var localP = "tempData.fbuilderSelectQuery." + id + "DATA";
          var lp = id + "DATA";

          if (getObjRtn()) {
            v = "" + lp + "s." + nameV + " " + getDisableBox(lp) + " for " + lp + " in " + localP + " track by " + lp + "s." + valueV + "" + "";
          } else {
            v = "" + lp + "s." + valueV + " as " + lp + "s." + nameV + " " + getDisableBox(lp) + " for " + lp + "s in " + localP + "";
          }

          if (url !== false) {
            getServer.getData(url).then(function(data) {
              mode.assign($rootScope.tempData.fbuilderSelectQuery, data.result);
            });
          }
        } else {
          if (qattrs.dataAPIURLformat !== "" && qattrs.dataAPIURLformat !== undefined) {
            var arrD = qattrs.dataAPIURLformat;
            var datacount = function() {
              if(a.dynamicdata === 'yes' || true)
              {
                $rootScope.tempData.tempCount += 1;
                return $rootScope.tempData.tempCount;
              }
              return '';
            };
            var id = itemid+datacount();
            var arr = arrD.split(",");
            var url = arr[0];
            var nameV = arr[1];
            var valueV = arr[2];
            var mode = $parse(id + "DATA");
            var edata = [{ name: "Loading..", value: "Loading.." }];
            mode.assign($rootScope.tempData.fbuilderSelectQuery, edata);
            var localP = "tempData.fbuilderSelectQuery." + id + "DATA";
            var lp = id + "DATA";

            if (getObjRtn()) {
              v = "" + lp + "s." + nameV + " " + getDisableBox(lp) + " for " + lp + " in " + localP + " track by " + lp + "s." + valueV + "" + "";
            } else {
              v = "" + lp + "s." + valueV + " as " + lp + "s." + nameV + " " + getDisableBox(lp) + " for " + lp + "s in " + localP + "";
            }

            if (url !== false) {
              getServer.getData(url).then(function(data) {
                mode.assign($rootScope.tempData.fbuilderSelectQuery, data.result);
              });
            }
          }
        }

        return v;
      }   


      var QueryData = {
        multiple: true,
        tags: true,            
        allowClear: true
      };
      

      var html = '';
      html += "<div class='"+s+" form-group "+cssClass+"' ng-class='"+nclass+"'>";
      html += "<label "+showTitle+"  for='"+itemid+"' class='control-label' translate='"+tlate+"."+itemid+".title'></label><span "+showTitle+"  class='control-label'> "+ labelsuffix +"</span><span class='glyphicon itemstatus' "+showTitle+" ></span>";

      if(getType() === "normal")
      {
        html += "<select class='form-control' "+converterAttr+" ng-model='"+formData+modelname+"' name='"+itemid+"' id='"+itemid+"' ng-options='"+s2Options_generator()+"' "+validationGenrator()+"></select>";
      }
      else
      {
        html += "<select2 ng-model='"+formData+modelname+"' "+converterAttr+" name='"+itemid+"' id='"+itemid+"' s2-options='"+s2Options_generator()+"' options='"+options_generator()+"' "+validationGenrator()+" ></select2>";
      }

      // console.log(converterAttr);
      
      html += messageGenrator();
      html += "</div>";
      return html;
    }
    return data;
}

angular.module('app')
.directive('radiobutton', radiobutton);


function radiobutton($rootScope){
    var data = {
      restrict : "EA",
      transclude: true,
      template : genrateRadiobutton,
    };
    function genrateRadiobutton(e,a)
    {
      var qattr = a.quickattrs;
      
      var qattrs = {};
      var found = false;
      if(a.localelement === undefined)
      {
          qattrs = $rootScope.fbuilderRadiobutton[qattr] ? $rootScope.fbuilderRadiobutton[qattr] : {};
          if($rootScope.fbuilderRadiobutton[qattr] === undefined)
          {
            return "Undefined Item";
          }
      }
      else
      {
        var q = $rootScope.$eval("fbuilderRadiobutton."+a.localelement);
        if(q === undefined || q[qattr] === undefined)
        {
          return "Undefined Item";
        }
        qattrs = q[qattr];
      }
      
      // var s = a.size;
      var s = getSize();
      var formname = getFormName();
      var formData = getFormDataName();
      var itemid = getItemid();
      var modelname = getModel();
      var tlate = getTlate();

      var acitem = ""+formname+"."+itemid+"";

      var nclass = '{ "has-error": '+acitem+'.$invalid || '+acitem+'.$pending , "has-success": '+acitem+'.$valid , "has-pending": '+acitem+'.$pending }';

      var elms = validationGenrator();


      function getFormName()
      {
        if(getItemType() === "ngform")
        {
          return e.closest("ng-form").attr('name');
        }
        else
        {
          return e.closest("form").attr('id');
        }
      }

      function getFormPrivateType()
      {
        if(getItemType() !== "ngform")
        {
          var ax = e.closest("form").attr('privatedata');
          if(ax !== undefined)
          {
            return ax;
          }
          else
          {
            return false;
          }
        }
        else
        {
          return false;
        }
      }

      function getFormDataName()
      {
        if(getItemType() === "ngform")
        {
          return "";
        }
        else if(getItemType() === "private")
        {
          return "";
        }
        else
        {
          if(getFormPrivateType() === false)
          { 
            return getFormName()+"Data.";
          }
          else
          {
            return getFormPrivateType() + ".";
          }
        }
      }

      function getItemType() {
        if(a.itemtype !== "" && a.itemtype !== undefined)
        {
          return a.itemtype;
        }
        else
        {
          if(qattrs.itemtype !== "" && qattrs.itemtype !== undefined)
          {
            return qattrs.itemtype;
          }
        }
      }

      function getSize() {
        if(a.size !== "" && a.size !== undefined)
        {
          return a.size;
        }
        else
        {
          if(qattrs.size !== "" && qattrs.size !== undefined)
          {
            return qattrs.size;
          }
        }
      }

      function getItemid() {
        if(a.itemid !== "" && a.itemid !== undefined)
        {
          return a.itemid;
        }
        else
        {
          if(qattrs.itemid !== "" && qattrs.itemid !== undefined)
          {
            return qattrs.itemid;
          }
        }
      }

      function getModel() {
        if(a.modelname !== "" && a.modelname !== undefined)
        {
          return a.modelname;
        }
        else
        {
          if(qattrs.modelname !== "" && qattrs.modelname !== undefined)
          {
            return qattrs.modelname;
          }
        }
      }

      function getTlate() {
        if(a.tlate !== "" && a.tlate !== undefined)
        {
          return a.tlate;
        }
        else
        {
          if(qattrs.tlate !== "" && qattrs.tlate !== undefined)
          {
            return qattrs.tlate;
          }
        }
      }

      function validationGenrator()
      {
        var v = "";


        if(a.required !== "" && a.required !== undefined)
        {
          if((a.required.toLowerCase() === 'true'))
          {
            v += " required='true'";
          }
        }
        else
        {
          if(qattrs.required !== "" && qattrs.required !== undefined)
          {
            if((qattrs.required.toLowerCase() === "true"))
            {
              v += " required='true'";
            }
          }
        }



        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          v += " rdposturlcheck='"+a.posturlcheck+"'";
        }
        else
        {
          if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
          {
            v += " rdposturlcheck='"+qattrs.posturlcheck+"'";
          }
        }

        if(a.rdblur !== "" && a.rdblur !== undefined)
        {
          v += "ng-blur='"+a.rdblur+"'";
        }
        else
        {
          if(qattrs.rdblur !== "" && qattrs.rdblur !== undefined)
          {
            v += "ng-blur='"+qattrs.rdblur+"'";
          }
        }


        return v;
      }

      function messageGenrator()
      {
        var h = "";
        var v = "";
        h += "<div ng-messages='"+acitem+".$error' ng-show='"+acitem+".$dirty' role='alert'>";


        if(a.required !== "" && a.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }
        else if(qattrs.required !== "" && qattrs.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }


        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }
        else if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }


        h += "</div>";
        return h;
      }

      function genrateRadio()
      {
        var html = "";
        var itms = {};

        if(a.items !== "" && a.items !== undefined)
        {
          itms = JSON.parse(a.items);
        }
        else if(qattrs.items !== "" && qattrs.items !== undefined)
        {
          itms = qattrs.items;
        }

        for(var i=0; i<itms.length; i++)
        {
          html += "<div class='"+itms[i].size+"'><input type='radio' class='rdradio-btn' id='"+itemid+i+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+elms+" value='"+itms[i].value+"'> <label for='"+itemid+i+"' translate='"+tlate+"."+itemid+".title."+i+"'></label></div>";
        }

        return html;
      }

      function grouptitle(c)
      {
          var start = "";
          var end = "";
          if(a.grouptitle !== "" && a.grouptitle !== undefined)
          {
            if((a.grouptitle.toLowerCase() === 'true'))
            {
              start += "<fieldset><legend translate='"+tlate+"."+itemid+".title.main'></legend>";
              end += "</fieldset><span class='glyphicon itemstatus'></span>";
            }
            else
            {
              start = "";
              end = "";
            }
          }
          else
          {
            if(qattrs.grouptitle !== "" && qattrs.grouptitle !== undefined)
            {
              if((qattrs.grouptitle.toLowerCase() === "true"))
              {
                start += "<fieldset><legend translate='"+tlate+"."+itemid+".title.main'></legend>";
                end += "</fieldset><span class='glyphicon itemstatus'></span>";
              }
              else
              {
                start = "";
                end = "";
              }
            }
          }

          if(c === 0)
          {
            return start;
          }
          else
          {
            return end;
          }
      }

      var html = '';
      html += "<div class='"+s+" form-group' ng-class='"+nclass+"'>";
      html += grouptitle(0);
      html += genrateRadio();
      html += messageGenrator();
      html += grouptitle(1);
      html += "</div>";

      return html;
    }
    return data;
}

angular.module('app')
  .directive('numberbox', numberbox)
  .directive('stringToNumber', function () {
    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (value) {
          return Number(value);
        });
        ngModel.$formatters.push(function (value) {
          return Number(value);
        });
      }
    };
  });


function numberbox($rootScope) {
  var data = {
    restrict: "EA",
    transclude: true,
    template: genrateNumberbox,
  };

  function genrateNumberbox(e, a) {
    var qattr = a.quickattrs;

    var qattrs = {};
    var found = false;
    if (a.localelement === undefined) {
      qattrs = $rootScope.fbuilderNumberbox[qattr] ? $rootScope.fbuilderNumberbox[qattr] : {};
      if ($rootScope.fbuilderNumberbox[qattr] === undefined) {
        return "Undefined Item";
      }
    } else {
      var q = $rootScope.$eval("fbuilderNumberbox." + a.localelement);
      if (q === undefined || q[qattr] === undefined) {
        return "Undefined Item";
      }
      qattrs = q[qattr];
    }

    // var s = a.size;
    var s = getSize();
    var formname = getFormName();
    var formData = getFormDataName();
    var itemid = getItemid();
    var modelname = getModel();
    var tlate = getTlate();
    var labelprefix = getLabelPrefix();
    var labelsuffix = getLabelSuffix();
    var inputprefix = getInputPrefix();
    var inputsufix = getInputSufix();
    var labeltext = getLabelText();
    var showTitle = getShowTitle();
    var cssClass = getCssClass();

    var acitem = "" + formname + "." + itemid + "";

    var placeholder = "placeholder='' translate translate-attr-placeholder='" + tlate + "." + itemid + ".placeholder'";

    var nclass = '{ "has-error": ' + acitem + '.$invalid || ' + acitem + '.$pending , "has-success": ' + acitem + '.$valid , "has-pending": ' + acitem + '.$pending }';
    var elms = placeholder + " " + validationGenrator();

    function getFormName() {
      if (getItemType() === "ngform") {
        return e.closest("ng-form").attr('name');
      } else {
        return e.closest("form").attr('id');
      }
    }

    function getFormPrivateType() {
      if (getItemType() !== "ngform") {
        var ax = e.closest("form").attr('privatedata');
        if (ax !== undefined) {
          return ax;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function getFormDataName() {
      if (getItemType() === "ngform") {
        return "";
      } else if (getItemType() === "private") {
        return "";
      } else {
        if (getFormPrivateType() === false) {
          return getFormName() + "Data.";
        } else {
          return getFormPrivateType() + ".";
        }
      }
    }

    function getLabelPrefix() {
      if (a.labelprefix !== "" && a.labelprefix !== undefined) {
        return a.labelprefix;
      } else {
        return '';
      }
    }

    function getLabelSuffix() {
      if (a.labelsuffix !== "" && a.labelsuffix !== undefined) {
        return a.labelsuffix;
      } else {
        return '';
      }
    }
      
    function getInputPrefix() {
      if(a.inputprefix !== "" && a.inputprefix !== undefined)
      {
        return a.inputprefix;
      }
      else
      {
        return false;
      }
    }
    
    function getInputSufix() {
      if(a.inputsuffix !== "" && a.inputsuffix !== undefined)
      {
        return a.inputsuffix;
      }
      else
      {
        return false;
      }
    }

    // getInputSufix
    // getInputPrefix

    function getLabelText() {
      if (a.labeltext !== "" && a.labeltext !== undefined) {
        return a.labeltext;
      } else {
        return '';
      }
    }

    function getShowTitle() {
      if (a.showtitle !== "" && a.showtitle !== undefined) {
        return ' ng-show="' + a.showtitle + '" ';
      } else {
        return '';
      }
    }

    function getCssClass() {
      if (a.cssclass !== "" && a.cssclass !== undefined) {
        return a.cssclass;
      } else {
        return '';
      }
    }

    function getItemType() {
      if (a.itemtype !== "" && a.itemtype !== undefined) {
        return a.itemtype;
      } else {
        if (qattrs.itemtype !== "" && qattrs.itemtype !== undefined) {
          return qattrs.itemtype;
        }
      }
    }

    function getSize() {
      if (a.size !== "" && a.size !== undefined) {
        return a.size;
      } else {
        if (qattrs.size !== "" && qattrs.size !== undefined) {
          return qattrs.size;
        }
      }
    }

    function getItemid() {
      if (a.itemid !== "" && a.itemid !== undefined) {
        return a.itemid;
      } else {
        if (qattrs.itemid !== "" && qattrs.itemid !== undefined) {
          return qattrs.itemid;
        }
      }
    }

    function getModel() {
      if (a.modelname !== "" && a.modelname !== undefined) {
        return a.modelname;
      } else {
        if (qattrs.modelname !== "" && qattrs.modelname !== undefined) {
          return qattrs.modelname;
        }
      }
    }

    function getTlate() {
      if (a.tlate !== "" && a.tlate !== undefined) {
        return a.tlate;
      } else {
        if (qattrs.tlate !== "" && qattrs.tlate !== undefined) {
          return qattrs.tlate;
        }
      }
    }

    function calc_validator() {
      var v = placeholder + " ";

      if (a.decimal !== "" && a.decimal !== undefined) {
        v += " decimal='" + a.decimal + "'";
      } else {
        if (qattrs.decimal !== "" && qattrs.decimal !== undefined) {
          v += " decimal='" + qattrs.decimal + "'";
        }
      }

      return v;
    }

    function validationGenrator() {
      var v = "";

      if (a.ngchange !== "" && a.ngchange !== undefined) {
        v += "ng-change='" + a.ngchange + "'";
      } else {
        if (qattrs.ngchange !== "" && qattrs.ngchange !== undefined) {
          v += "ng-change='" + qattrs.ngchange + "'";
        }
      }

      if (a.rdblur !== "" && a.rdblur !== undefined) {
        v += "ng-blur='" + a.rdblur + "'";
      } else {
        if (qattrs.rdblur !== "" && qattrs.rdblur !== undefined) {
          v += "ng-blur='" + qattrs.rdblur + "'";
        }
      }

      if (a.readonly !== "" && a.readonly !== undefined) {
        if ((a.readonly.toLowerCase() === 'true') || (a.readonly.toLowerCase() === 'readonly')) {
          v += " readonly='readonly' tabIndex='-1'";
        }
      } else {
        if (qattrs.readonly !== "" && qattrs.readonly !== undefined) {
          if ((qattrs.readonly.toLowerCase() === "true")) {
            v += " readonly='readonly' tabIndex='-1'";
          }
        }
      }


      if (a.autocomplete !== "" && a.autocomplete !== undefined) {
        if ((a.autocomplete.toLowerCase() === 'true')) {
          v += " autocomplete='off'";
        }
      } else {
        if (qattrs.autocomplete !== "" && qattrs.autocomplete !== undefined) {
          if ((qattrs.autocomplete.toLowerCase() === "true")) {
            v += " autocomplete='off'";
          }
        }
      }

      if (a.rdrequired === "" || a.rdrequired === undefined) {
        if (a.required !== "" && a.required !== undefined) {
          if ((a.required.toLowerCase() === 'true')) {
            v += " required='true'";
          } else {
            v += " required='false'";
          }
        } else {
          if (qattrs.required !== "" && qattrs.required !== undefined) {
            if ((qattrs.required.toLowerCase() === "true")) {
              v += " required='true'";
            } else {
              v += " required='false'";
            }
          }
        }
      }



      if (a.rdreadonly !== "" && a.rdreadonly !== undefined) {
        v += " ng-readonly='" + a.rdreadonly + "'";
      }


      if (a.rdrequired !== "" && a.rdrequired !== undefined) {
        v += " ng-required='" + a.rdrequired + "'";
      }


      if (a.calculator !== "" && a.calculator !== undefined) {
        if ((a.calculator.toLowerCase() === 'true')) {
          v += " calculator='true'";
        }
      } else {
        if (qattrs.calculator !== "" && qattrs.calculator !== undefined) {
          if ((qattrs.calculator.toLowerCase() === "true")) {
            v += " calculator='true'";
          }
        }
      }


      if (a.decimal !== "" && a.decimal !== undefined) {
        v += " decimal='" + a.decimal + "'";
      } else {
        if (qattrs.decimal !== "" && qattrs.decimal !== undefined) {
          v += " decimal='" + qattrs.decimal + "'";
        }
      }

      if (a.step !== "" && a.step !== undefined) {
        v += " step='" + a.step + "'";
      } else {
        if (qattrs.step !== "" && qattrs.step !== undefined) {
          v += " step='" + qattrs.step + "'";
        }
      }

      if (a.minnumber !== "" && a.minnumber !== undefined) {
        v += " rdminnumber='" + a.minnumber + "'";
      } else {
        if (qattrs.minnumber !== "" && qattrs.minnumber !== undefined) {
          v += " rdminnumber='" + qattrs.minnumber + "'";
        }
      }

      if (a.maxnumber !== "" && a.maxnumber !== undefined) {
        v += " rdmaxnumber='" + a.maxnumber + "'";
      } else {
        if (qattrs.maxnumber !== "" && qattrs.maxnumber !== undefined) {
          v += " rdmaxnumber='" + qattrs.maxnumber + "'";
        }
      }

      if (a.minnumber2 !== "" && a.minnumber2 !== undefined) {
        v += " rdminnumber2='" + a.minnumber2 + "'";
      } else {
        if (qattrs.minnumber2 !== "" && qattrs.minnumber2 !== undefined) {
          v += " rdminnumber2='" + qattrs.minnumber2 + "'";
        }
      }

      if (a.maxnumber2 !== "" && a.maxnumber2 !== undefined) {
        v += " rdmaxnumber2='" + a.maxnumber2 + "'";
      } else {
        if (qattrs.maxnumber2 !== "" && qattrs.maxnumber2 !== undefined) {
          v += " rdmaxnumber2='" + qattrs.maxnumber2 + "'";
        }
      }

      if (a.posturlcheck !== "" && a.posturlcheck !== undefined) {
        v += " rdposturlcheck='" + a.posturlcheck + "'";
      } else {
        if (qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined) {
          v += " rdposturlcheck='" + qattrs.posturlcheck + "'";
        }
      }

      return v;
    }

    function messageGenrator() {
      var h = "";
      var v = "";
      h += "<div ng-messages='" + acitem + ".$error' ng-show='" + acitem + ".$dirty' role='alert'>";


      if (a.required !== "" && a.required !== undefined) {
        h += "<div ng-message='required'><span class='help-block' translate='" + tlate + "." + itemid + ".required'></span></div>";
      } else if (qattrs.required !== "" && qattrs.required !== undefined) {
        h += "<div ng-message='required'><span class='help-block' translate='" + tlate + "." + itemid + ".required'></span></div>";
      }


      if (a.minnumber !== "" && a.minnumber !== undefined) {
        h += "<div ng-message='rdminnumber'><span class='help-block' translate='" + tlate + "." + itemid + ".minnumber'></span></div>";
      } else if (qattrs.minnumber !== "" && qattrs.minnumber !== undefined) {
        h += "<div ng-message='rdminnumber'><span class='help-block' translate='" + tlate + "." + itemid + ".minnumber'></span></div>";
      }


      if (a.maxnumber !== "" && a.maxnumber !== undefined) {
        h += "<div ng-message='rdmaxnumber'><span class='help-block' translate='" + tlate + "." + itemid + ".maxnumber'></span></div>";
      } else if (qattrs.maxnumber !== "" && qattrs.maxnumber !== undefined) {
        h += "<div ng-message='rdmaxnumber'><span class='help-block' translate='" + tlate + "." + itemid + ".maxnumber'></span></div>";
      }


      if (a.minnumber2 !== "" && a.minnumber2 !== undefined) {
        h += "<div ng-message='rdminnumber2'><span class='help-block' translate='" + tlate + "." + itemid + ".minnumber2'></span></div>";
      } else if (qattrs.minnumber2 !== "" && qattrs.minnumber2 !== undefined) {
        h += "<div ng-message='rdminnumber2'><span class='help-block' translate='" + tlate + "." + itemid + ".minnumber2'></span></div>";
      }


      if (a.maxnumber2 !== "" && a.maxnumber2 !== undefined) {
        h += "<div ng-message='rdmaxnumber2'><span class='help-block' translate='" + tlate + "." + itemid + ".maxnumber2'></span></div>";
      } else if (qattrs.maxnumber2 !== "" && qattrs.maxnumber2 !== undefined) {
        h += "<div ng-message='rdmaxnumber2'><span class='help-block' translate='" + tlate + "." + itemid + ".maxnumber2'></span></div>";
      }



      if (a.posturlcheck !== "" && a.posturlcheck !== undefined) {
        h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='" + tlate + "." + itemid + ".posturlcheck'></span></div>";
      } else if (qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined) {
        h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='" + tlate + "." + itemid + ".posturlcheck'></span></div>";
      }

      h += "</div>";
      return h;
    }

    function get_input() {
      var html = "";
      if (a.calculator !== "" && a.calculator !== undefined) {
        if ((a.calculator.toLowerCase() === 'true')) {
          html += "<input type='number' rd-number-input string-to-number class='form-control' id='" + itemid + "' calcmodel='" + formData + modelname + "_calc' name='" + itemid + "' ng-model='" + formData + modelname + "' " + elms + ">";
          html += "<input type='text' rd-number-calc-input class='form-control dispnone' " + calc_validator() + " numboxmodel='" + formData + modelname + "' numboxid='" + itemid + "' id='" + itemid + "_calc' name='" + itemid + "_calc' ng-model='" + formData + modelname + "_calc'>";
        } else {
          html += "<input type='number' rd-number-input string-to-number class='form-control' id='" + itemid + "' calcmodel='" + formData + modelname + "_calc' name='" + itemid + "' ng-model='" + formData + modelname + "' " + elms + ">";
        }
      } else {
        if (qattrs.calculator !== "" && qattrs.calculator !== undefined) {
          if ((qattrs.calculator.toLowerCase() === 'true')) {
            html += "<input type='number' rd-number-input string-to-number class='form-control' id='" + itemid + "' calcmodel='" + formData + modelname + "_calc' name='" + itemid + "' ng-model='" + formData + modelname + "' " + elms + ">";
            html += "<input type='text' rd-number-calc-input class='form-control dispnone' " + calc_validator() + " numboxmodel='" + formData + modelname + "' numboxid='" + itemid + "' id='" + itemid + "_calc' name='" + itemid + "_calc' ng-model='" + formData + modelname + "_calc'>";
          } else {
            html += "<input type='number' rd-number-input string-to-number class='form-control' id='" + itemid + "' calcmodel='" + formData + modelname + "_calc' name='" + itemid + "' ng-model='" + formData + modelname + "' " + elms + ">";
          }
        } else {
          html += "<input type='number' rd-number-input string-to-number class='form-control' id='" + itemid + "' calcmodel='" + formData + modelname + "_calc' name='" + itemid + "' ng-model='" + formData + modelname + "' " + elms + ">";
        }
      }
      return html;
    }

    // console.log(elms);

    var html = '';
    html += "<div class='" + s + " form-group " + cssClass + "' ng-class='" + nclass + "'>";
    if(labeltext === "")
    {
      html += "<span " + showTitle + " class='control-label'> " + labelprefix + "</span><label " + showTitle + " for='" + itemid + "' class='control-label' translate='" + tlate + "." + itemid + ".title'></label><span " + showTitle + " class='control-label'> " + labelsuffix + "</span><span  " + showTitle + " class='glyphicon itemstatus'></span>";
    }
    else
    {
      html += "<label " + showTitle + " for='" + itemid + "' class='control-label'>"+ labeltext +"</label><span  " + showTitle + " class='glyphicon itemstatus'></span>"; 
    }
    
    
    if(inputsufix !== false || inputprefix !== false)
    {
      html += '<div class="input-group">';
    }

    if(inputprefix !== false)
    {
      html += '<span class="input-group-addon">'+getInputPrefix()+'</span>';
    }

    html += get_input();

    if(inputsufix !== false)
    {
      html += '<span class="input-group-addon">'+getInputSufix()+'</span>';
    }      

    if(inputsufix !== false || inputprefix !== false)
    {
      html += '</div>';
    }

    html += messageGenrator();
    html += "</div>";
    return html;
  }
  return data;
}

angular.module('app')
.directive('rdgeturlcheck', rdgeturlcheck)
.directive('rdposturlcheck', rdposturlcheck)
.directive('rdjsonposturlcheck', rdjsonposturlcheck)
.directive('rdnachar', rdnachar)
.directive('rdnaword', rdnaword)
.directive('rdnawords', rdnawords)
.directive('rdminword', rdminword)
.directive('rdmaxword', rdmaxword)
.directive('rdishtml', rdishtml)
.directive('rdisnothtml', rdisnothtml)
.directive('rdnospace', rdnospace)
.directive('rduppercase', rduppercase)
.directive('rdlowercase', rdlowercase)
.directive('rdmindate', rdmindate)
.directive('rdmaxdate', rdmaxdate)
.directive('rdmindatetime', rdmindatetime)
.directive('rdmaxdatetime', rdmaxdatetime)
.directive('rdmintime', rdmintime)
.directive('rdmaxtime', rdmaxtime)
.directive('rdminmonth', rdminmonth)
.directive('rdmaxmonth', rdmaxmonth)
.directive('rdminyear', rdminyear)
.directive('rdmaxyear', rdmaxyear)
.directive('disableddates', disableddates)
.directive('disableddays', disableddays)
.directive('rdminnumber', rdminnumber)
.directive('rdmaxnumber', rdmaxnumber)
.directive('rdminnumber2', rdminnumber2)
.directive('rdmaxnumber2', rdmaxnumber2)
.directive('rdminselect', rdminselect)
.directive('rdmaxselect', rdmaxselect);



function rdnachar(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {

        var chlist = attributes.rdnachar;

        var check = function(value) {
          var alar = chlist.split("");
          var val = value ? value.toString() : "";
          var l = alar.length;
          var found = 0;
          for(var j=0; j<l; j++)
          {
            if(val !== "")
            {
              if (val.indexOf(alar[j]) > -1) {
                found += 1;
              }
            }
            else
            {
              found = 0;
            }
          }
          if(found === 0)
          {
            return true;
          }
          else
          {
            return false;
          }
        }

      ngModel.$validators.rdnachar = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}

function rdgeturlcheck(getServer,$http,$q,$rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link:function($scope,element,attributes,ngModel) {
      var url = attributes.rdgeturlcheck;
      ngModel.$asyncValidators.rdgeturlcheck = function(modelValue , viewValue) {
        var value = modelValue || viewValue;
        return getServer.getData(url + value).then(function resolved(data) {
            if(data.result)
            { 
              return true;
            }
            else
            {           
             return $q.reject('exists');
            }
        });
      }
    }
  }
}

function rdposturlcheck(postServer,$http,$q,$rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link:function($scope,element,attributes,ngModel) {
      var url = attributes.rdposturlcheck;
      ngModel.$asyncValidators.rdposturlcheck = function(modelValue , viewValue) {
        var value = modelValue || viewValue;
        var data = { val: value };

        return postServer.postData(url,data)
          .then(function resolved(data) {            
            if(data.result)
            {
              return true;
            }
            else
            {           
             return $q.reject('exists');
            }
          
          });
      }
    }
  }
}

function rdjsonposturlcheck(postServer,$http,$q,$rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link:function($scope,element,attributes,ngModel) {
      var url = attributes.rdjsonposturlcheck;
      ngModel.$asyncValidators.rdjsonposturlcheck = function(modelValue , viewValue) {
        var value = modelValue || viewValue;
        value = JSON.stringify(value);
        var data = { val: value };

        return postServer.postData(url,data)
          .then(function resolved(data) {
            
            if(data.result)
            { 
              return true;
            }
            else
            {           
             return $q.reject('exists');
            }
          
          });
      }
    }
  }
}

function rdnaword(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {

        var chlist = attributes.rdnaword;
        var check = function(value) {

        var alar = chlist.split(",");
        var l = alar.length;

        var val = value ? value : "";
        val = val.toString();

        var found = 0;

        for(var j=0; j<l; j++)
        {
          if(val !== "")
          {
            if (val.indexOf(alar[j]) > -1) {
              found += 1;
            }
          }
          else
          {
            found = 0;
          }
        }

        if(found === 0)
        {
          return true;
        }
        else
        {
          return false;
        }

      }

      ngModel.$validators.rdnaword = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}




function rdnawords(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {

        var chlist = attributes.rdnawords;
        var check = function(value) {

        var alar = chlist.split(",");
        var l = alar.length;

        var val = value ? value : "";
        var vary = val.split(" ");
        var vl = vary.length;

        var found = 0;

        for(var j=0; j<l; j++)
        {
          for(var k=0; k<vl; k++)
          {
            if(vary[k] === alar[j])
            {
              found += 1;
            }
          }
        }

        if(found === 0)
        {
          return true;
        }
        else
        {
          return false;
        }

      }

      ngModel.$validators.rdnawords = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}


function rdminword(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {

        var eva = scope.$eval(attributes.rdminword);
        var minwords = eva ? eva : attributes.rdminword;

          scope.$watch(attributes.rdminword, function(newVal, oldVal) {
            ngModel.$setValidity("rdminword", check(ngModel.$viewValue));
          });

        var check = function(value) {          
          var eva = scope.$eval(attributes.rdminword);
          var minwords = eva ? eva : attributes.rdminword;
          var val = value ? value : "";
          var alar = val.split(" ");
          var l = alar.length;
          if(minwords <= l)
          {
            return true;
          }
          else
          {
            return false;
          }
        }

      ngModel.$validators.rdminword = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}



function rdmaxword(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {
        
        var eva = scope.$eval(attributes.rdmaxword);
        var maxwords = eva ? eva : attributes.rdmaxword;


        scope.$watch(attributes.rdmaxword, function(newVal, oldVal) {
          ngModel.$setValidity("rdmaxword", check(ngModel.$viewValue));
        });

        var check = function(value) {        
          var eva = scope.$eval(attributes.rdmaxword);
          var maxwords = eva ? eva : attributes.rdmaxword;          
          var val = value ? value : "";
          var alar = val.split(" ");
          var l = alar.length;
          if(maxwords >= l)
          {
            return true;
          }
          else
          {
            return false;
          }
        }

      ngModel.$validators.rdmaxword = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}



function rdishtml(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {

        var html = attributes.rdishtml;

        var check = function(value) {
          
          var val = value ? value : "";

          if(html)
          {
            if(isHTML(val))
            {
              return true;
            }
            else
            {
              return false;
            }

          }

        }

      function isHTML(str) {
        var a = document.createElement('div');
        a.innerHTML = str;
        for (var c = a.childNodes, i = c.length; i--; ) {
            if (c[i].nodeType == 1) return true; 
        }
        return false;
      }

      ngModel.$validators.rdishtml = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}



function rdisnothtml(){
  return {

      restrict: "A",
        
      require: "ngModel",
        
      link: function(scope, element, attributes, ngModel) {

        var html = attributes.rdisnothtml;

        var check = function(value) {
          
          var val = value ? value : "";

          if(html)
          {
            if(isHTML(val))
            {
              return false;
            }
            else
            {
              return true;
            }

          }

        }

      function isHTML(str) {
        var a = document.createElement('div');
        a.innerHTML = str;
        for (var c = a.childNodes, i = c.length; i--; ) {
            if (c[i].nodeType == 1) return true; 
        }
        return false;
      }

      ngModel.$validators.rdisnothtml = function(modelValue) {  
        return check(modelValue);
      }

    }

  };
}


function rdnospace() {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var rdnospace = attributes.rdnospace;

        var check = function(value) {
          
          var val = value ? value : "";

          if(rdnospace)
          {
            if(isNoSpace(val))
            {
              return false;
            }
            else
            {
              return true;
            }

          }

        }

      function isNoSpace(str) {
        return str.indexOf(' ') >= 0;
      }

      ngModel.$validators.rdnospace = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}

function rduppercase() {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var rduppercase = attributes.rduppercase;

        var check = function(value) {
          
          var val = value ? value : "";

          if(rduppercase)
          {
            if(isUpperCase(val))
            {
              return false;
            }
            else
            {
              return true;
            }

          }

        }

      function isUpperCase(str) {
        return (/[a-z]/.test(str));
      }

      ngModel.$validators.rduppercase = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}

function rdlowercase() {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var rdlowercase = attributes.rdlowercase;

        var check = function(value) {
          
          var val = value ? value : "";

          if(rdlowercase)
          {
            if(isLowerCase(val))
            {
              return false;
            }
            else
            {
              return true;
            }

          }

        }

      function isLowerCase(str) {
        return (/[A-Z]/.test(str));
      }

      ngModel.$validators.rdlowercase = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmindate($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {
      
        var dbformat =  $rootScope.getDFormat('date',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmindate);
        var mindate = eva ? moment(eva, dbformat).format() : moment(attributes.rdmindate, dbformat).format();
        
        scope.$watch(attributes.rdmindate, function(newVal, oldVal) {
          ngModel.$setValidity("rdmindate", check(ngModel.$viewValue));
        });

        var check = function(value) {

          var dbformat =  $rootScope.getDFormat('date',false);
          var format =  $rootScope.getDFormat(attributes.pck,true);      
          var eva = scope.$eval(attributes.rdmindate);
          var mindate = eva ? moment(eva, dbformat).format() : moment(attributes.rdmindate, dbformat).format();

          if(value !== "" || value !== undefined)
          {
            var val = value ? value : moment().format(format);
            var v = moment(val, format).format();
            var m = moment(mindate).isSameOrBefore(v);    
            return m;   
          }

        }

      ngModel.$validators.rdmindate = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmaxdate($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var dbformat =  $rootScope.getDFormat('date',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);        
        var eva = scope.$eval(attributes.rdmaxdate);
        var maxdate = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxdate, dbformat).format();

        scope.$watch(attributes.rdmaxdate, function(newVal, oldVal) {
          ngModel.$setValidity("rdmaxdate", check(ngModel.$viewValue));
        });

        var check = function(value) {
          var dbformat =  $rootScope.getDFormat('date',false);
          var format =  $rootScope.getDFormat(attributes.pck,true);        
          var eva = scope.$eval(attributes.rdmaxdate);
          var maxdate = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxdate, dbformat).format();

          if(value !== "" || value !== undefined)
          {
            var val = value ? value : moment().format(format);
            var v = moment(val, format).format();
            var m = moment(maxdate).isSameOrAfter(v);    
            return m;   
          }
        }

      ngModel.$validators.rdmaxdate = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmindatetime($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var dbformat =  $rootScope.getDFormat('datetime',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdmindatetime);
      var mindatetime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmindatetime, dbformat).format();

      scope.$watch(attributes.rdmindatetime, function(newVal, oldVal) {
        ngModel.$setValidity("rdmindatetime", check(ngModel.$viewValue));
      });

      var check = function(value) {
        var dbformat =  $rootScope.getDFormat('datetime',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmindatetime);
        var mindatetime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmindatetime, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(mindatetime).isSameOrBefore(v);   
          return m;   
        }
      }

      ngModel.$validators.rdmindatetime = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmaxdatetime($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var dbformat =  $rootScope.getDFormat('datetime',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmaxdatetime);
        var maxdatetime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxdatetime, dbformat).format();
        
        scope.$watch(attributes.rdmaxdatetime, function(newVal, oldVal) {
          ngModel.$setValidity("rdmaxdatetime", check(ngModel.$viewValue));
        });

      var check = function(value) {

        var dbformat =  $rootScope.getDFormat('datetime',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmaxdatetime);
        var maxdatetime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxdatetime, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(maxdatetime).isSameOrAfter(v);  
          return m;   
        }

      }

      ngModel.$validators.rdmaxdatetime = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}




function rdmintime($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel', 
    link: function(scope, element, attributes, ngModel) {
      
      var dbformat =  $rootScope.getDFormat('time',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdmintime);
      var mintime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmintime, dbformat).format();
      
      scope.$watch(attributes.rdmintime, function(newVal, oldVal) {
        ngModel.$setValidity("rdmintime", check(ngModel.$viewValue));
      });

      var check = function(value) {
        var dbformat =  $rootScope.getDFormat('time',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmintime);
        var mintime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmintime, dbformat).format();
        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(mintime).isSameOrBefore(v);
          //console.log("Min Date : "+mindate+" Value : "+v+" Result :"+m);     
          return m;   
        }
      }

      ngModel.$validators.rdmintime = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmaxtime($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var dbformat =  $rootScope.getDFormat('time',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdmaxtime);
      var maxtime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxtime, dbformat).format();
      
      scope.$watch(attributes.rdmaxtime, function(newVal, oldVal) {
        ngModel.$setValidity("rdmaxtime", check(ngModel.$viewValue));
      });

      var check = function(value) {
  
        var dbformat =  $rootScope.getDFormat('time',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmaxtime);
        var maxtime = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxtime, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(maxtime).isSameOrAfter(v);
          //console.log("Max Date : "+maxdate+" Value : "+v+" Result :"+m);     
          return m;   
        }

      }

      ngModel.$validators.rdmaxtime = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}






function rdminmonth($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var dbformat =  $rootScope.getDFormat('month',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdminmonth);
      var minmonth = eva ? moment(eva, dbformat).format() : moment(attributes.rdminmonth, dbformat).format();
      
      scope.$watch(attributes.rdminmonth, function(newVal, oldVal) {
        ngModel.$setValidity("rdminmonth", check(ngModel.$viewValue));
      });

      var check = function(value) {

        var dbformat =  $rootScope.getDFormat('month',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdminmonth);
        var minmonth = eva ? moment(eva, dbformat).format() : moment(attributes.rdminmonth, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(minmonth).isSameOrBefore(v, 'month');
          //console.log("Min Date : "+mindate+" Value : "+v+" Result :"+m);     
          return m;   
        }

      }

      ngModel.$validators.rdminmonth = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmaxmonth($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var dbformat =  $rootScope.getDFormat('month',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdmaxmonth);
      var maxmonth = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxmonth, dbformat).format();
      
      scope.$watch(attributes.rdmaxmonth, function(newVal, oldVal) {
        ngModel.$setValidity("rdmaxmonth", check(ngModel.$viewValue));
      });

      var check = function(value) {

        var dbformat =  $rootScope.getDFormat('month',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmaxmonth);
        var maxmonth = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxmonth, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(maxmonth).isSameOrAfter(v, 'month');
          //console.log("Max Date : "+maxdate+" Value : "+v+" Result :"+m);     
          return m;   
        }

      }

      ngModel.$validators.rdmaxmonth = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}






function rdminyear($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var dbformat =  $rootScope.getDFormat('year',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdminyear);
      var minyear = eva ? moment(eva, dbformat).format() : moment(attributes.rdminyear, dbformat).format();
      
      scope.$watch(attributes.rdminyear, function(newVal, oldVal) {
        ngModel.$setValidity("rdminyear", check(ngModel.$viewValue));
      });

      var check = function(value) {
  
        var dbformat =  $rootScope.getDFormat('year',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdminyear);
        var minyear = eva ? moment(eva, dbformat).format() : moment(attributes.rdminyear, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(minyear).isSameOrBefore(v, 'year');    
          return m;   
        }

      }

      ngModel.$validators.rdminyear = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmaxyear($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var dbformat =  $rootScope.getDFormat('year',false);
      var format =  $rootScope.getDFormat(attributes.pck,true);
      var eva = scope.$eval(attributes.rdmaxyear);
      var maxyear = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxyear, dbformat).format();
      
      scope.$watch(attributes.rdmaxyear, function(newVal, oldVal) {
        ngModel.$setValidity("rdmaxyear", check(ngModel.$viewValue));
      });

      var check = function(value) {
        
        var dbformat =  $rootScope.getDFormat('year',false);
        var format =  $rootScope.getDFormat(attributes.pck,true);
        var eva = scope.$eval(attributes.rdmaxyear);
        var maxyear = eva ? moment(eva, dbformat).format() : moment(attributes.rdmaxyear, dbformat).format();

        if(value !== "" || value !== undefined)
        {
          var val = value ? value : moment().format(format);
          var v = moment(val, format).format();
          var m = moment(maxyear).isSameOrAfter(v, 'year');     
          return m;   
        }

      }

      ngModel.$validators.rdmaxyear = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function disableddates($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var pck = attributes.pck;
      var ddates = attributes.disableddates;
      var ddate = ddates.split(',');
      var dl = ddate.length;

      var dbformat =  $rootScope.getDFormat(pck,false);
      var format =  $rootScope.getDFormat(pck,true);

      var check = function(value) {
        if(value !== "" && value !== undefined)
        {
          var d = moment(value, format).format();
          var result = true;
          for(var j=0; j<dl; j++)
          {
              var a = moment(ddate[j],dbformat).isSame(d,'day');
              if(a)
              {
                result = false;
                break;
              }
          }
          return result;     
        }
        else
        {
          return true;
        }
      }

      ngModel.$validators.disableddates = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function disableddays($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var pck = attributes.pck;
      var ddates = attributes.disableddays;
      var ddays = ddates.split(',');
      var dl = ddays.length;

      var dbformat =  $rootScope.getDFormat(pck,false);
      var format =  $rootScope.getDFormat(pck,true);

      var check = function(value) {
        if(value !== "" && value !== undefined)
        {
          var d = moment(value, format).format();
          var day = moment(d).weekday();
          var result = true;
          for(var j=0; j<dl; j++)
          {
              if(day === parseInt(ddays[j]))
              {
                result = false;
                break;
              }
          }
          return result;     
        }
        else
        {
          return true;
        }
      }

      ngModel.$validators.disableddays = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}



function rdminnumber($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var eva = scope.$eval(attributes.rdminnumber);
      var min = eva ? eva : attributes.rdminnumber;

      if(eva) 
      {
        scope.$watch(attributes.rdminnumber, function(newVal, oldVal) {
          ngModel.$setValidity("rdminnumber", check(ngModel.$viewValue));
        });
      }

      var check = function(value) {
        var eva = scope.$eval(attributes.rdminnumber);
        var min = eva ? eva : attributes.rdminnumber;
        if(value === "")
        {
          return true;
        }
        if(min > value)
        {
          return false;
        }
        else
        {
          return true;
        }
      }

      ngModel.$validators.rdminnumber = function(modelValue) {  
        return check(modelValue);
      }
    }
  }
}


function rdmaxnumber($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var eva = scope.$eval(attributes.rdmaxnumber);
      var max = eva ? eva : attributes.rdmaxnumber;

      scope.$watch(attributes.rdmaxnumber, function(newVal, oldVal) {
        ngModel.$setValidity("rdmaxnumber", check(ngModel.$viewValue));
      });

      var check = function(value) {
        var eva = scope.$eval(attributes.rdmaxnumber);
        var max = (eva !== "") ? eva : attributes.rdmaxnumber;
          // check eveal not equal to considering 0 as false , so check for ~!==~
        if(value === "")
        {
          return true;
        }
        if(max < value)
        {
          return false;
        }
        else
        {
          return true;
        }
      }

      ngModel.$validators.rdmaxnumber = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}

function rdminnumber2($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var eva = scope.$eval(attributes.rdminnumber2);
      var min = eva ? eva : attributes.rdminnumber2;

      if(eva) 
      {
        scope.$watch(attributes.rdminnumber2, function(newVal, oldVal) {
          ngModel.$setValidity("rdminnumber2", check(ngModel.$viewValue));
        });
      }

      var check = function(value) {
        var eva = scope.$eval(attributes.rdminnumber2);
        var min = eva ? eva : attributes.rdminnumber2;
        if(min > value)
        {
          return false;
        }
        else
        {
          return true;
        }
      }

      ngModel.$validators.rdminnumber2 = function(modelValue) {  
        return check(modelValue);
      }
    }
  }
}


function rdmaxnumber2($rootScope) {
  return {    
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

      var eva = scope.$eval(attributes.rdmaxnumber2);
      var max = eva ? eva : attributes.rdmaxnumber2;

      scope.$watch(attributes.rdmaxnumber2, function(newVal, oldVal) {
        ngModel.$setValidity("rdmaxnumber2", check(ngModel.$viewValue));
      });

      var check = function(value) {
        var eva = scope.$eval(attributes.rdmaxnumber2);
        var max = eva ? eva : attributes.rdmaxnumber2;
        if(max < value)
        {
          return false;
        }
        else
        {
          return true;
        }
      }

      ngModel.$validators.rdmaxnumber2 = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdminselect()
{
  return {
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var eva = scope.$eval(attributes.rdminselect);
        var min = eva ? eva : attributes.rdminselect;

        scope.$watch(attributes.rdminselect, function(newVal, oldVal) {
          ngModel.$setValidity("rdminselect", check(ngModel.$viewValue));
        });

        var check = function(value) {
          var multiple = attributes.multiselect;
          var eva = scope.$eval(attributes.rdminselect);
          var min = eva ? eva : attributes.rdminselect;
          if(multiple === "true")
          {
            var l = (value !== undefined && value !== "") ? value.length : 0;
            if(min > l)
            {
              return false;
            }
            else
            {
              return true;
            }
          }
          else
          {
            return true;
          }
        }

      ngModel.$validators.rdminselect = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}


function rdmaxselect()
{
  return {
    restrict: "A",
    require:'ngModel',
    link: function(scope, element, attributes, ngModel) {

        var eva = scope.$eval(attributes.rdmaxselect);
        var max = eva ? eva : attributes.rdmaxselect;

        scope.$watch(attributes.rdmaxselect, function(newVal, oldVal) {
          ngModel.$setValidity("rdmaxselect", check(ngModel.$viewValue));
        });

        var check = function(value) {
          var multiple = attributes.multiselect;
          var eva = scope.$eval(attributes.rdmaxselect);
          var max = eva ? eva : attributes.rdmaxselect;
          if(multiple === "true")
          {
            var l = (value !== undefined && value !== "") ? value.length : 0;
            if(max < l)
            {
              return false;
            }
            else
            {
              return true;
            }
          }
          else
          {
            return true;
          }
        }

      ngModel.$validators.rdmaxselect = function(modelValue) {  
        return check(modelValue);
      }

    }
  }
}







// function test(){
//   return {
//         restrict: "A",
         
//         require: "ngModel",
         
//         link: function(scope, element, attributes, ngModel) {

//           var atval = attributes.test;

//           var check = function(value) {
//             return true;
//           }

//             ngModel.$validators.test = function(modelValue) {  
//                 return check(modelValue);
//             }
//         }
//     };
// }
angular.module('app')
.directive('datebox', datebox);


function datebox($rootScope){
    var data = {
      restrict : "EA",
      transclude: true,
      template : genrateDatebox,
    };
    function genrateDatebox(e,a)
    {
      var qattr = a.quickattrs;
      
      var qattrs = {};
      var found = false;
      if(a.localelement === undefined)
      {
          qattrs = $rootScope.fbuilderDatebox[qattr] ? $rootScope.fbuilderDatebox[qattr] : {};
          if($rootScope.fbuilderDatebox[qattr] === undefined)
          {
            return "Undefined Item";
          }
      }
      else
      {
        var q = $rootScope.$eval("fbuilderDatebox."+a.localelement);
        if(q === undefined || q[qattr] === undefined)
        {
          return "Undefined Item";
        }
        qattrs = q[qattr];
      }

      var s = getSize();
      var formname = getFormName();
      var formData = getFormDataName();
      var itemid = getItemid();
      var modelname = getModel();
      var tlate = getTlate();
      var labelsuffix = getLabelSuffix();
      var inputprefix = getInputPrefix();
      var inputsufix = getInputSufix();
      var showTitle = getShowTitle();
      var cssClass = getCssClass();

      var acitem = ""+formname+"."+itemid+"";

      var placeholder = "placeholder='' translate translate-attr-placeholder='"+tlate+"."+itemid+".placeholder'";

      var nclass = '{ "has-error": '+acitem+'_picker.$invalid || '+acitem+'_picker.$pending || '+acitem+'.$invalid || '+acitem+'.$pending , "has-success": '+acitem+'.$valid , "has-pending": '+acitem+'.$pending || '+acitem+'_picker.$pending }';

      var elms = placeholder+" "+validationGenrator();


      function getFormName()
      {
        if(getItemType() === "ngform")
        {
          return e.closest("ng-form").attr('name');
        }
        else
        {
          return e.closest("form").attr('id');
        }
      }

      function getFormPrivateType()
      {
        if(getItemType() !== "ngform")
        {
          var ax = e.closest("form").attr('privatedata');
          if(ax !== undefined)
          {
            return ax;
          }
          else
          {
            return false;
          }
        }
        else
        {
          return false;
        }
      }

      function getFormDataName()
      {
        if(getItemType() === "ngform")
        {
          return "";
        }
        else if(getItemType() === "private")
        {
          return "";
        }
        else
        {
          if(getFormPrivateType() === false)
          { 
            return getFormName()+"Data.";
          }
          else
          {
            return getFormPrivateType() + ".";
          }
        }
      }

      function getLabelSuffix() {
        if(a.labelsuffix !== "" && a.labelsuffix !== undefined)
        {
          return a.labelsuffix;
        }
        else
        {
          return '';
        }
      }
      
      function getInputPrefix() {
        if(a.inputprefix !== "" && a.inputprefix !== undefined)
        {
          return a.inputprefix;
        }
        else
        {
          return false;
        }
      }
      
      function getInputSufix() {
        if(a.inputsuffix !== "" && a.inputsuffix !== undefined)
        {
          return a.inputsuffix;
        }
        else
        {
          return false;
        }
      }

      // getInputSufix
      // getInputPrefix

      function getShowTitle()
      {
        if(a.showtitle !== "" && a.showtitle !== undefined)
        {
          return ' ng-show="'+a.showtitle+'" ';
        }
        else
        {
          return '';
        }
      }

      function getCssClass()
      {
        if(a.cssclass !== "" && a.cssclass !== undefined)
        {
          return a.cssclass;
        }
        else
        {
          return '';
        }
      }

      function getItemType() {
        if(a.itemtype !== "" && a.itemtype !== undefined)
        {
          return a.itemtype;
        }
        else
        {
          if(qattrs.itemtype !== "" && qattrs.itemtype !== undefined)
          {
            return qattrs.itemtype;
          }
        }
      }

      function getSize() {
        if(a.size !== "" && a.size !== undefined)
        {
          return a.size;
        }
        else
        {
          if(qattrs.size !== "" && qattrs.size !== undefined)
          {
            return qattrs.size;
          }
        }
      }

      function getItemid() {
        if(a.itemid !== "" && a.itemid !== undefined)
        {
          return a.itemid;
        }
        else
        {
          if(qattrs.itemid !== "" && qattrs.itemid !== undefined)
          {
            return qattrs.itemid;
          }
        }
      }

      function getModel() {
        if(a.modelname !== "" && a.modelname !== undefined)
        {
          return a.modelname;
        }
        else
        {
          if(qattrs.modelname !== "" && qattrs.modelname !== undefined)
          {
            return qattrs.modelname;
          }
        }
      }

      function getTlate() {
        if(a.tlate !== "" && a.tlate !== undefined)
        {
          return a.tlate;
        }
        else
        {
          if(qattrs.tlate !== "" && qattrs.tlate !== undefined)
          {
            return qattrs.tlate;
          }
        }
      }

      function validationGenrator()
      {
        var v = "";

        if(a.rdrequired === "" || a.rdrequired === undefined)
        {
          if(a.required !== "" && a.required !== undefined)
          {
            if((a.required.toLowerCase() === 'true'))
            {
              v += " required='true'";
            }
          }
          else
          {
            if(qattrs.required !== "" && qattrs.required !== undefined)
            {
              if((qattrs.required.toLowerCase() === "true"))
              {
                v += " required='true'";
              }
            }
          }
        }

        if(a.rdrequired !== "" && a.rdrequired !== undefined)
        {
          v += " ng-required='"+a.rdrequired+"'";
        }

        if(a.readonly !== "" && a.readonly !== undefined)
        {
          if((a.readonly.toLowerCase() === 'true') || (a.readonly.toLowerCase() === 'readonly'))
          {
            v += " readonly='readonly' tabIndex='-1'";
          }
        }
        else
        {
          if(qattrs.readonly !== "" && qattrs.readonly !== undefined)
          {
            if((qattrs.readonly.toLowerCase() === "true"))
            {
              v += " readonly='readonly'  tabIndex='-1'";
            }
          }
        }

        if(a.rdreadonly !== "" && a.rdreadonly !== undefined)
        {
          v += " ng-readonly='"+a.rdreadonly+"'";
        }

        if(a.picker !== "" && a.picker !== undefined)
        {
          if(a.picker === "datetime")
          {
            v += " pck='datetime' rd-date-time-picker ng-change='"+formData+modelname+"=datetimeToDbDatetime("+formData+modelname+"_picker)'";
          }

          if(a.picker === "date")
          {
            v += " pck='date' rd-date-picker ng-change='"+formData+modelname+"=dateToDbDate("+formData+modelname+"_picker)'";
          }

          if(a.picker === "time")
          {
            v += " pck='time' rd-time-picker ng-change='"+formData+modelname+"=timeToDbTime("+formData+modelname+"_picker)'";
          }

          if(a.picker === "month")
          {
            v += " pck='month'  rd-month-picker ng-change='"+formData+modelname+"=monthToDbMonth("+formData+modelname+"_picker)'";
          }

          if(a.picker === "year")
          {
            v += " pck='year' rd-year-picker ng-change='"+formData+modelname+"="+formData+modelname+"_picker'";
          }
        }
        else
        {
          if(qattrs.picker !== "" && qattrs.picker !== undefined)
          {
            if(qattrs.picker === "datetime")
            {
              v += " pck='datetime' rd-date-time-picker ng-change='"+formData+modelname+"=datetimeToDbDatetime("+formData+modelname+"_picker)'";
            }

            if(qattrs.picker === "date")
            {
              v += " pck='date' rd-date-picker ng-change='"+formData+modelname+"=dateToDbDate("+formData+modelname+"_picker)'";
            }

            if(qattrs.picker === "time")
            {
              v += " pck='time' rd-time-picker ng-change='"+formData+modelname+"=timeToDbTime("+formData+modelname+"_picker)'";
            }

            if(qattrs.picker === "month")
            {
              v += " pck='month' rd-month-picker ng-change='"+formData+modelname+"=monthToDbMonth("+formData+modelname+"_picker)'";
            }

            if(qattrs.picker === "year")
            {
              v += " pck='year' rd-year-picker ng-change='"+formData+modelname+"="+formData+modelname+"_picker'";
            }
          }
        }

        if(a.mindate !== "" && a.mindate !== undefined)
        {
          v += " rdmindate='"+a.mindate+"'";
        }
        else
        {
          if(qattrs.mindate !== "" && qattrs.mindate !== undefined)
          {
            v += " rdmindate='"+qattrs.mindate+"'";
          }
        }

        if(a.maxdate !== "" && a.maxdate !== undefined)
        {
          v += " rdmaxdate='"+a.maxdate+"'";
        }
        else
        {
          if(qattrs.maxdate !== "" && qattrs.maxdate !== undefined)
          {
            v += " rdmaxdate='"+qattrs.maxdate+"'";
          }
        }

        if(a.mindatetime !== "" && a.mindatetime !== undefined)
        {
          v += " rdmindatetime='"+a.mindatetime+"'";
        }
        else
        {
          if(qattrs.mindatetime !== "" && qattrs.mindatetime !== undefined)
          {
            v += " rdmindatetime='"+qattrs.mindatetime+"'";
          }
        }

        if(a.maxdatetime !== "" && a.maxdatetime !== undefined)
        {
          v += " rdmaxdatetime='"+a.maxdatetime+"'";
        }
        else
        {
          if(qattrs.maxdatetime !== "" && qattrs.maxdatetime !== undefined)
          {
            v += " rdmaxdatetime='"+qattrs.maxdatetime+"'";
          }
        }

        if(a.mintime !== "" && a.mintime !== undefined)
        {
          v += " rdmintime='"+a.mintime+"'";
        }
        else
        {
          if(qattrs.mintime !== "" && qattrs.mintime !== undefined)
          {
            v += " rdmintime='"+qattrs.mintime+"'";
          }
        }

        if(a.maxtime !== "" && a.maxtime !== undefined)
        {
          v += " rdmaxtime='"+a.maxtime+"'";
        }
        else
        {
          if(qattrs.maxtime !== "" && qattrs.maxtime !== undefined)
          {
            v += " rdmaxtime='"+qattrs.maxtime+"'";
          }
        }

        if(a.minmonth !== "" && a.minmonth !== undefined)
        {
          v += " rdminmonth='"+a.minmonth+"'";
        }
        else
        {
          if(qattrs.minmonth !== "" && qattrs.minmonth !== undefined)
          {
            v += " rdminmonth='"+qattrs.minmonth+"'";
          }
        }

        if(a.maxmonth !== "" && a.maxmonth !== undefined)
        {
          v += " rdmaxmonth='"+a.maxmonth+"'";
        }
        else
        {
          if(qattrs.maxmonth !== "" && qattrs.maxmonth !== undefined)
          {
            v += " rdmaxmonth='"+qattrs.maxmonth+"'";
          }
        }

        if(a.minyear !== "" && a.minyear !== undefined)
        {
          v += " rdminyear='"+a.minyear+"'";
        }
        else
        {
          if(qattrs.minyear !== "" && qattrs.minyear !== undefined)
          {
            v += " rdminyear='"+qattrs.minyear+"'";
          }
        }

        if(a.maxyear !== "" && a.maxyear !== undefined)
        {
          v += " rdmaxyear='"+a.maxyear+"'";
        }
        else
        {
          if(qattrs.maxyear !== "" && qattrs.maxyear !== undefined)
          {
            v += " rdmaxyear='"+qattrs.maxyear+"'";
          }
        }

        

        if(a.rdblur !== "" && a.rdblur !== undefined)
        {
          v += "ng-blur='"+a.rdblur+"'";
        }
        else
        {
          if(qattrs.rdblur !== "" && qattrs.rdblur !== undefined)
          {
            v += "ng-blur='"+qattrs.rdblur+"'";
          }
        }        
        
        if(a.rdchange !== "" && a.rdchange !== undefined)
        {
          v += " ng-change='"+a.rdchange+"'";
        }
        else
        {
          if(qattrs.rdchange !== "" && qattrs.rdchange !== undefined)
          {
            v += " ng-change='"+qattrs.rdchange+"'";

          }
        }

        return v;
      }

      function getMessages()
      {
        var h = "";
        if(a.required !== "" && a.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }
        else if(qattrs.required !== "" && qattrs.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }

        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }
        else if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }

        if(a.mindate !== "" && a.mindate !== undefined)
        {
          h += "<div ng-message='rdmindate'><span class='help-block' translate='"+tlate+"."+itemid+".mindate'></span></div>";
        }
        else if(qattrs.mindate !== "" && qattrs.mindate !== undefined)
        {
          h += "<div ng-message='rdmindate'><span class='help-block' translate='"+tlate+"."+itemid+".mindate'></span></div>";
        }

        if(a.maxdate !== "" && a.maxdate !== undefined)
        {
          h += "<div ng-message='rdmaxdate'><span class='help-block' translate='"+tlate+"."+itemid+".maxdate'></span></div>";
        }
        else if(qattrs.maxdate !== "" && qattrs.maxdate !== undefined)
        {
          h += "<div ng-message='rdmaxdate'><span class='help-block' translate='"+tlate+"."+itemid+".maxdate'></span></div>";
        }

        if(a.mindatetime !== "" && a.mindatetime !== undefined)
        {
          h += "<div ng-message='rdmindatetime'><span class='help-block' translate='"+tlate+"."+itemid+".mindatetime'></span></div>";
        }
        else if(qattrs.mindatetime !== "" && qattrs.mindatetime !== undefined)
        {
          h += "<div ng-message='rdmindatetime'><span class='help-block' translate='"+tlate+"."+itemid+".mindatetime'></span></div>";
        }

        if(a.maxdatetime !== "" && a.maxdatetime !== undefined)
        {
          h += "<div ng-message='rdmaxdatetime'><span class='help-block' translate='"+tlate+"."+itemid+".maxdatetime'></span></div>";
        }
        else if(qattrs.maxdatetime !== "" && qattrs.maxdatetime !== undefined)
        {
          h += "<div ng-message='rdmaxdatetime'><span class='help-block' translate='"+tlate+"."+itemid+".maxdatetime'></span></div>";
        }

        if(a.mintime !== "" && a.mintime !== undefined)
        {
          h += "<div ng-message='rdmintime'><span class='help-block' translate='"+tlate+"."+itemid+".mintime'></span></div>";
        }
        else if(qattrs.mintime !== "" && qattrs.mintime !== undefined)
        {
          h += "<div ng-message='rdmintime'><span class='help-block' translate='"+tlate+"."+itemid+".mintime'></span></div>";
        }

        if(a.maxtime !== "" && a.maxtime !== undefined)
        {
          h += "<div ng-message='rdmaxtime'><span class='help-block' translate='"+tlate+"."+itemid+".maxtime'></span></div>";
        }
        else if(qattrs.maxtime !== "" && qattrs.maxtime !== undefined)
        {
          h += "<div ng-message='rdmaxtime'><span class='help-block' translate='"+tlate+"."+itemid+".maxtime'></span></div>";
        }

        if(a.minmonth !== "" && a.minmonth !== undefined)
        {
          h += "<div ng-message='rdminmonth'><span class='help-block' translate='"+tlate+"."+itemid+".minmonth'></span></div>";
        }
        else if(qattrs.minmonth !== "" && qattrs.minmonth !== undefined)
        {
          h += "<div ng-message='rdminmonth'><span class='help-block' translate='"+tlate+"."+itemid+".minmonth'></span></div>";
        }

        if(a.maxmonth !== "" && a.maxmonth !== undefined)
        {
          h += "<div ng-message='rdmaxmonth'><span class='help-block' translate='"+tlate+"."+itemid+".maxmonth'></span></div>";
        }
        else if(qattrs.maxmonth !== "" && qattrs.maxmonth !== undefined)
        {
          h += "<div ng-message='rdmaxmonth'><span class='help-block' translate='"+tlate+"."+itemid+".maxmonth'></span></div>";
        }

        if(a.minyear !== "" && a.minyear !== undefined)
        {
          h += "<div ng-message='rdminyear'><span class='help-block' translate='"+tlate+"."+itemid+".minyear'></span></div>";
        }
        else if(qattrs.minyear !== "" && qattrs.minyear !== undefined)
        {
          h += "<div ng-message='rdminyear'><span class='help-block' translate='"+tlate+"."+itemid+".minyear'></span></div>";
        }

        if(a.maxyear !== "" && a.maxyear !== undefined)
        {
          h += "<div ng-message='rdmaxyear'><span class='help-block' translate='"+tlate+"."+itemid+".maxyear'></span></div>";
        }
        else if(qattrs.maxyear !== "" && qattrs.maxyear !== undefined)
        {
          h += "<div ng-message='rdmaxyear'><span class='help-block' translate='"+tlate+"."+itemid+".maxyear'></span></div>";
        }

        if(a.disableddates !== "" && a.disableddates !== undefined)
        {
          h += "<div ng-message='disableddates'><span class='help-block' translate='"+tlate+"."+itemid+".disableddates'></span></div>";
        }
        else if(qattrs.disableddates !== "" && qattrs.disableddates !== undefined)
        {
          h += "<div ng-message='disableddates'><span class='help-block' translate='"+tlate+"."+itemid+".disableddates'></span></div>";
        }

        if(a.disableddays !== "" && a.disableddays !== undefined)
        {
          h += "<div ng-message='disableddays'><span class='help-block' translate='"+tlate+"."+itemid+".disableddays'></span></div>";
        }
        else if(qattrs.disableddays !== "" && qattrs.disableddays !== undefined)
        {
          h += "<div ng-message='disableddays'><span class='help-block' translate='"+tlate+"."+itemid+".disableddays'></span></div>";
        }
        return h;
      }

      function messageGenrator()
      {
        var v = "";
        v += "<div ng-messages='"+acitem+"_picker.$error' ng-show='"+acitem+"_picker.$dirty' role='alert'>";
        v += getMessages();
        v += "</div>";
        v += "<div ng-messages='"+acitem+".$error' ng-show='"+acitem+"_picker.$dirty' role='alert'>";
        v += getMessages();
        v += "</div>";
        return v;
      }

      function dbformat()
      {
        var v = "";
        var settings = "";

        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          settings += " rdposturlcheck='"+a.posturlcheck+"'";
        }
        else
        {
          if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
          {
            settings += " rdposturlcheck='"+qattrs.posturlcheck+"'";
          }
        }
        

        if(a.picker !== "" && a.picker !== undefined)
        {
          if(a.picker === "datetime")
          {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+settings+" />";
          }

          if(a.picker === "date")
          {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+settings+" />";
          }

          if(a.picker === "time")
          {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+settings+" />";
          }

          if(a.picker === "month")
          {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+settings+" />";
          }

          if(a.picker === "year")
          {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+settings+" />";
          }
        }
        else
        {
          if(qattrs.picker !== "" && qattrs.picker !== undefined)
          {
            if(qattrs.picker === "datetime")
            {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"'  "+settings+" />";
            }

            if(qattrs.picker === "date")
            {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"'  "+settings+" />";
            }

            if(qattrs.picker === "time")
            {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"'  "+settings+" />";
            }

            if(qattrs.picker === "month")
            {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"'  "+settings+" />";
            }

            if(qattrs.picker === "year")
            {
            v += " <input type='hidden' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"'  "+settings+" />";
            }
          }
        }
        return v;
      }

      function controlmaker()
      {
        var v = "";

        if(a.disableddates !== "" && a.disableddates !== undefined)
        {
          v += " disableddates='"+a.disableddates+"'";
        }
        else
        {
          if(qattrs.disableddates !== "" && qattrs.disableddates !== undefined)
          {
            v += " disableddates='"+qattrs.disableddates+"'";
          }
        }

        if(a.disableddays !== "" && a.disableddays !== undefined)
        {
          v += " disableddays='"+a.disableddays+"'";
        }
        else
        {
          if(qattrs.disableddays !== "" && qattrs.disableddays !== undefined)
          {
            v += " disableddays='"+qattrs.disableddays+"'";
          }
        }
        
        if(a.calendarweeks !== "" && a.calendarweeks !== undefined)
        {
          v += " cweeks='"+a.calendarweeks+"'";
        }
        else
        {
          if(qattrs.calendarweeks !== "" && qattrs.calendarweeks !== undefined)
          {
            v += " cweeks='"+qattrs.calendarweeks+"'";
          }
        }

        return v;
      }

      var control = controlmaker();

      var html = '';
      html += "<div class='"+s+" form-group "+cssClass+"' ng-class='"+nclass+"'>";
      html += "<label  "+showTitle+" for='"+itemid+"_picker' class='control-label' translate='"+tlate+"."+itemid+".title'></label><span "+showTitle+"  class='control-label'> "+ labelsuffix +"</span><span "+showTitle+"  class='glyphicon itemstatus'></span>";
      
      if(inputsufix !== false || inputprefix !== false)
      {
        html += '<div class="input-group">';
      }

      if(inputprefix !== false)
      {
        html += '<span class="input-group-addon">'+getInputPrefix()+'</span>';
      }

      html += "<input type='text' class='form-control' id='"+itemid+"_picker' name='"+itemid+"_picker' pickermodel='"+formData+modelname+"' ng-model='"+formData+modelname+"_picker' "+elms+" "+control+">";

      
      if(inputsufix !== false)
      {
        html += '<span class="input-group-addon">'+getInputSufix()+'</span>';
      }      

      if(inputsufix !== false || inputprefix !== false)
      {
        html += '</div>';
      }

      html += dbformat();
      html += messageGenrator();
      html += "</div>";
      return html;
    }
    return data;
}

// "autocomplete": {
//   "title":"autocomplete='[ true OR false ]'",
//   "description":"Autocomplete TextBox (If True Its Disabled)"
// },
// "size": {
//    "title":"size='[Boot Strap Col-Md Sizes]'",
//    "description":"For Size of the Textbox. Values are Bootstrap Col-Md-1 - Col-Md-12."
// },
// "itemid": {
//   "title":"itemid='[Your Id]'",
//   "description":"ID & Name for Accessing this Element."
// },
// "modelname": {
//   "title":"modelname='[Model Name]'",
//   "description":"Model Name to Get a Field Value in Angular"
// },
// "tlate": {
//   "title":"tlate='[Translate Array Name]'",
//   "description":"From this value, Translator variable is accessed via Item ID"
// },
// "spellcheck": {
//   "title":"spellcheck='[ true OR false ]'",
//   "description":"Control Spell Check and Correction Hint in This Field"
// },
// "required": {
//   "title":"required='[ true OR false ]'",
//   "description":"This is field is Manditory or Not"
// },
// "geturlcheck": {
//   "title":"geturlcheck='[URL Location of API Server to Access Via GET]'",
//   "description":"Field value check with the Given URL in every keypressed."
// },
// "posturlcheck": {
//   "title":"posturlcheck='[URL Location of API Server to Access Via POST]'",
//   "description":"Field value check with the Given URL in every keypressed."
// },
// "nachar": {
//   "title":"nachar='[List of Characters]'",
//   "description":"The Given Characters are Not Allowed in this Field"
// },
// "naword": {
//   "title":"naword='[List of Words Seprated By Comma]'",
//   "description":"Finds the exact match in whole value of the field."
// },
// "nawords": {
//   "title":"nawords='[List of Words Seprated By Comma]'",
//   "description":"Finds the word in value of the field."
// },
// "minword": {
//   "title":"minword='[Number of Minimun Words to Allowed]'",
//   "description":"Minimum Requirements of Given Words Count"
// },
// "maxword": {
//   "title":"maxword='[Number of Maximum Words to Allowed]'",
//   "description":"Maximum Requirements of Given Words Count"
// },
// "ishtml": {
//   "title":"ishtml='[ true OR false ]'",
//   "description":"Check for the HTML Tags in the Value"
// },
// "isnothtml": {
//   "title":"isnothtml='[ true OR false ]'",
//   "description":"Check for the HTML Tags are Not Allowed in the Value"
// },
// "nospace": {
//   "title":"nospace='[ true OR false ]'",
//   "description":"Controll this filed to accept Space or Not"
// },
// "uppercase": {
//   "title":"uppercase='[ true OR false ]'",
//   "description":"Only Uppercase Value to be Allowed"
// },
// "lowercase": {
//   "title":"lowercase='[ true OR false ]'",
//   "description":"Only Lowercase Value to Allowed"
// }



(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderTextbox = {
            "loginEmail" : {
                "type":"email",
                "size": "col-md-12",
                "itemid": "loginEmail",
                "modelname": "username",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "lowercase": "ture",
                "nawords": "test,demo"
            },
            "loginPassword" : {
                "type":"password",
                "size": "col-md-12",
                "itemid": "loginPassword",
                "modelname": "password",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/="
            },
            "oneTimePassword" : {
                "type":"password",
                "size": "col-md-12",
                "itemid": "oneTimePassword",
                "modelname": "otp",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "6",
                "maxlength": "6",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
            "machine_name": {
                "type":"text",
                "size": "col-md-12",
                "itemid": "machine_name",
                "modelname": "machine_name",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4"
            },
            "machine_id": {
                "type":"text",
                "size": "col-md-12",
                "itemid": "machine_id",
                "modelname": "machine_id",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "rdlowercase": "true",
                "rdnospace": "true",
                "required": "true",
                "minlength": "4"                
            },
            "displayname" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "displayname",
                "modelname": "display_name",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4"
            },
            "userrole" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "userrole",
                "modelname": "user_role",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "2"
            },
            "mobileno" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "mobileno",
                "modelname": "mobileno",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "12",
                "maxlength": "12",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
            "projectname" : {                
                "type":"text",
                "size": "col-md-6",
                "itemid": "projectname",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "maxlength": "20",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=!@#$%^*())_+=-"
            },
            "projectid" : {                
                "type":"text",
                "size": "col-md-6",
                "itemid": "projectid",
                "modelname": "projectid",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "maxlength": "20",
                "autocomplete": "false",
                "nachar": "^*()-{[}]|\:;<,>?/=!@#$%^*())+=-.",
                "nospace": "true",
                "lowercase": "true",
                "geturlcheck": "rcloudsys/projects/pDupCheck/"
            },
            "uref" : {                
                "type":"text",
                "size": "col-md-6",
                "itemid": "uref",
                "modelname": "uref",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "maxlength": "35",
                "autocomplete": "false",
                "nachar": "^*()-{[}]|\:;<,>?/=!@#$%^*())+=-",
                "nospace": "true",
                "lowercase": "true"
            },
            "href" : {                
                "type":"text",
                "size": "col-md-6",
                "itemid": "href",
                "modelname": "href",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "maxlength": "35",
                "autocomplete": "false",
                "nachar": "^*()-{[}]|\:;<,>?=!@#$%^*())+=-.",
                "nospace": "true",
                "lowercase": "true"
            },
            "submodules" : {                
                "type":"text",
                "size": "col-md-6",
                "itemid": "submodules",
                "modelname": "submodules",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "maxlength": "3000",
                "autocomplete": "false",
                "nachar": "^*()-{[}]|\:;<>?=!@#$%^*())+=-",
                "nospace": "true",
                "lowercase": "true"
            },
            "companyname" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companyname",
                "modelname": "name",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
            },
            "companyuniquename" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companyuniquename",
                "modelname": "uniquename",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
                "lowercase": "true",                
                "nachar": "^*()-{[}]|\:;<,>?/=!@#$%^*())+=-",
                "geturlcheck": "rcloudsys/companies/cDupCheck/"
            },
            "companydisc" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companydisc",
                "modelname": "disc",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "10"
            },
            "address" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "address",
                "modelname": "address",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "15"
            },
            "companyemail" : {
                "type":"email",
                "size": "col-md-6",
                "itemid": "companyemail",
                "modelname": "emailid",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "lowercase": "true"
            },
            "companyphone" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companyphone",
                "modelname": "phoneno",
                "tlate": "commonForms.textbox",
                "minlength": "6",
                "maxlength": "15",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
            "companymobile" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companymobile",
                "modelname": "mobileno",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "12",
                "maxlength": "12",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
            "ip" : {
                "type": "text",
                "size": "col-md-6",
                "itemid": "ip",
                "modelname": "ip",
                "tlate": "commonForms.textbox",
                "required": "true",
                "pattern": "/^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$/"
            },
            "testerurl" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "testerurl",
                "modelname": "testerurl",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true"
            }
        };

    }
        
})();
// "autocomplete": {
//   "title":"autocomplete='[ true OR false ]'",
//   "description":"Autocomplete TextBox (If True Its Disabled)"
// },
// "size": {
//    "title":"size='[Boot Strap Col-Md Sizes]'",
//    "description":"For Size of the Textbox. Values are Bootstrap Col-Md-1 - Col-Md-12."
// },
// "itemid": {
//   "title":"itemid='[Your Id]'",
//   "description":"ID & Name for Accessing this Element."
// },
// "modelname": {
//   "title":"modelname='[Model Name]'",
//   "description":"Model Name to Get a Field Value in Angular"
// },
// "tlate": {
//   "title":"tlate='[Translate Array Name]'",
//   "description":"From this value, Translator variable is accessed via Item ID"
// },
// "required": {
//   "title":"required='[ true OR false ]'",
//   "description":"This is field is Manditory or Not"
// },
// "posturlcheck": {
//   "title":"posturlcheck='[URL Location of API Server to Access Via POST]'",
//   "description":"Field value check with the Given URL in every keypressed."
// },
// "localVariable": {
//   "title":"localVariable='[Select List Option Variable]'",
//   "description":"Field should return a complete values of checkbox"
// },
// "localVarFormat": {
//   "title":"localVarFormat='[Select List Option Variable Format]'",
//   "description":"Field should return a complete values of checkbox"
// },
// "dataAPIURL": {
//   "title":"dataAPIURL='[API URL]'",
//   "description":"Field should return a complete values of checkbox from a given API URL"              
// },
// "dataAPIURLformat": {
//   "title":"dataAPIURL='[API URL,name_id,value_id]'",
//   "description":"Field should return a complete values of checkbox from a given API URL"              
// },
// "multiple": {
//   "title":"multiple='[true OR false]'",
//   "description":"Multi Select Enable or Disable"              
// },
// "tags": {
//   "title":"tags='[true OR false]'",
//   "description":"Tags Enable or Disable"              
// },
// "allowClear": {
//   "title":"allowClear='[true OR false]'",
//   "description":"Clear Selection Enable or Disable"              
// },
// "minselect": {
//   "title":"minselect='[Numeric Value only works if multiselect enabled]'",
//   "description":"Minimum Length of multiple selection"              
// },
// "maxselect": {
//   "title":"maxselect='[Numeric Value only works if multiselect enabled]'",
//   "description":"Maximum Length of multiple selection"             
// }


(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderSelectbox = {
            "user" : {
                "size": "col-md-6",
                "itemid": "user",
                "modelname": "user",
                "tlate": "commonForms.selectbox",
                "required": "true"
            },
            "status" : {
                "size": "col-md-12",
                "itemid": "status",
                "modelname": "status",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "dataLocal": '[ { "name":"Enabled", "value":"1" },{ "name":"Disabled", "value":"0" } ]'
            },
            "gender" : {
                "size": "col-md-12",
                "itemid": "gender",
                "modelname": "gender",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Male", "value":"m" },{ "name":"Female", "value":"f" } ]'
            },
            "toastposition" : {
                "size": "col-md-6",
                "itemid": "toastposition",
                "modelname": "toastData.position",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Bottom Right", "value":"bottom right" },{ "name":"Bottom Left", "value":"bottom left" },{ "name":"Top Right", "value":"top right" },{ "name":"Top Left", "value":"top left" } ]'
            },
            "datepickerSetting" : {
                "size": "col-md-6",
                "itemid": "datepicker",
                "modelname": "datePicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in datepickerformats track by option.format"
            },
            "timepickerSetting" : {
                "size": "col-md-6",
                "itemid": "timepicker",
                "modelname": "timePicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in timepickerformats track by option.format"
            },
            "monthpickerSetting" : {
                "size": "col-md-6",
                "itemid": "monthpicker",
                "modelname": "monthPicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in monthpickerformats track by option.format"
            },
            "projectstatus" : {
                "size": "col-md-6",
                "itemid": "projectstatus",
                "modelname": "status",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Enabled", "value":"1" },{ "name":"Disabled", "value":"0" } ]'
            },
            "projecticon" : {
                "size": "col-md-6",
                "itemid": "projecticon",
                "modelname": "icon",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataAPIURL": 'rcloudsys/selectdata/icons'
            },
            "listprojects" : {
                "size": "col-md-6",
                "itemid": "projectlist",
                "modelname": "projectids",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURL": 'rcloudsys/projects/slistProjects'
            },
            "listcompanyprojects" : {
                "size": "col-md-6",
                "itemid": "projectlist",
                "modelname": "projectids",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURL": 'rcloudsys/projects/slistProjects'
            },
            "reporttype" : {
                "size": "col-md-6",
                "itemid": "reporttype",
                "modelname": "reporttype",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Male", "value":"m" },{ "name":"Female", "value":"f" } ]'
            },
            "buyer" : {
                "size": "col-md-4",
                "itemid": "buyer",
                "modelname": "buyer",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURLformat": "rcloudsys/wbs/getBuyersList,BuyerNAme,BuyerID"
            },
            "department" : {
                "size": "col-md-4",
                "itemid": "department",
                "modelname": "department",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURLformat": "rcloudsys/wbs/getBuyerDept,BuyerDeptDesc,ID"
            },
             "factory" : {
                "size": "col-md-4",
                "itemid": "factory",
                "modelname": "factory",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURLformat": "rcloudsys/wbs/getFactoryList,ExporterName,ExpID"
            },
            "orderno" : {
                "size": "col-md-4",
                "itemid": "orderno",
                "modelname": "orderno",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURLformat": "rcloudsys/wbs/getListOrders,IONO,OrdId"
            },
             "assignee" : {
                "size": "col-md-4",
                "itemid": "assignee",
                "modelname": "assignee",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURLformat": "rcloudsys/wbs/getAssigneeList,UserName,UserID"
            },
             "operation" : {
                "size": "col-md-4",
                "itemid": "operation",
                "modelname": "operation",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURLformat": "rcloudsys/wbs/getOperationList,OpName,OpCode"
            },
            "scan_cameras" : {
                "size": "col-md-6",
                "itemid": "scan_cameras",
                "modelname": "scan_cameras",
                "tlate": "commonForms.selectbox",
                "required": "true"
            }
        };

    }
        
})();
// "autocomplete": {
//   "title":"autocomplete='[ true OR false ]'",
//   "description":"Autocomplete TextBox (If True Its Disabled)"
// },
// "size": {
//    "title":"size='[Boot Strap Col-Md Sizes]'",
//    "description":"For Size of the Textbox. Values are Bootstrap Col-Md-1 - Col-Md-12."
// },
// "itemid": {
//   "title":"itemid='[Your Id]'",
//   "description":"ID & Name for Accessing this Element."
// },
// "modelname": {
//   "title":"modelname='[Model Name]'",
//   "description":"Model Name to Get a Field Value in Angular"
// },
// "tlate": {
//   "title":"tlate='[Translate Array Name]'",
//   "description":"From this value, Translator variable is accessed via Item ID"
// },
// "required": {
//   "title":"required='[ true OR false ]'",
//   "description":"This is field is Manditory or Not"
// },
// "posturlcheck": {
//   "title":"posturlcheck='[URL Location of API Server to Access Via POST]'",
//   "description":"Field value check with the Given URL in every keypressed."
// },
// "grouptitle": {
//   "title":"grouptitle='[ true OR false ]'",
//   "description":"Group Title need to displayed or not."
// },
// "items": {
//   "title":"items='[ JSON Array ]'",
//   "description":"JSON Array for No. of Radio Buttons. <br>  Example : <b>[{'size': 'col-md-4','value': 'male'}]</b> "
// }

(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderRadiobutton = {
            "morf" : {
                "size": "col-md-2",
                "itemid": "morf",
                "modelname": "morf",
                "tlate": "commonForms.radiobutton",
                "required": "true",
                "grouptitle": "true",
                "posturlcheck": "rcloudsys/welcome/posttestcheck",
                "items": [
                    {
                        "size": "col-md-6",
                        "value": "male"
                    },
                    {
                        "size": "col-md-6",
                        "value": "female"
                    }
                ]
            },
        };

    }
        
})();
// "autocomplete": {
//   "title":"autocomplete='[ true OR false ]'",
//   "description":"Autocomplete TextBox (If True Its Disabled)"
// },
// "size": {
//    "title":"size='[Boot Strap Col-Md Sizes]'",
//    "description":"For Size of the Textbox. Values are Bootstrap Col-Md-1 - Col-Md-12."
// },
// "itemid": {
//   "title":"itemid='[Your Id]'",
//   "description":"ID & Name for Accessing this Element."
// },
// "modelname": {
//   "title":"modelname='[Model Name]'",
//   "description":"Model Name to Get a Field Value in Angular"
// },
// "tlate": {
//   "title":"tlate='[Translate Array Name]'",
//   "description":"From this value, Translator variable is accessed via Item ID"
// },
// "decimal": {
//   "title":"decimal='[ Number of Decimal Points ]'",
//   "description":"Chnage the Number of Decimal Points"
// },
// "step": {
//   "title":"step='[ Increment or Decrement Step Value ]'",
//   "description":"Value for Step Increment or Decrement"
// },
// "calculator": {
//   "title":"calculator='[ true OR false ]'",
//   "description":"To Enable or Disable Inline Calculator"
// },
// "minnumber": {
//   "title":"minnumber='[ Numeric Value ]'",
//   "description":"Minimum Number Should be greater than minnumber"
// },
// "maxnumber": {
//   "title":"maxnumber='[ Numeric Value ]'",
//   "description":"Maximum Number Should be less than maxnumber"
// },
// "posturlcheck": {
//   "title":"posturlcheck='[ API Server URL ]'",
//   "description":"URL to POST and Check the Field Value"
// }


            
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderNumberbox = {
            "toasttiming" : {
                "size": "col-md-6",
                "itemid": "toasttiming",
                "modelname": "toastData.delay",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "100",
                "minnumber": "3000",
                "maxnumber": "15000",
                "calculator": "false"
            },
            "show_order" : {
                "size": "col-md-6",
                "itemid": "show_order",
                "modelname": "show_order",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "1000",
                "calculator": "false"
            },
            "portno" : {
                "size": "col-md-6",
                "itemid": "portno",
                "modelname": "portno",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1000",
                "maxnumber": "99999",
                "calculator": "false"
            },
            "nofuser" : {
                "size": "col-md-6",
                "itemid": "nofuser",
                "modelname": "nofuser",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1",
                "maxnumber": "1000",
                "calculator": "false"
            },
            "days" : {
                "size": "col-md-6",
                "itemid": "days",
                "modelname": "days",
                "tlate": "commonForms.numberbox",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1",
                "maxnumber": "1000",
                "calculator": "false"
            },
            "runningnokp" : {
                "size": "col-md-6",
                "itemid": "runningnokp",
                "modelname": "runningnokp",
                "tlate": "commonForms.numberbox",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1",
                "calculator": "false"
            }
        };

    }
        
})();
// "size": {
//    "title":"size='[Boot Strap Col-Md Sizes]'",
//    "description":"For Size of the Textbox. Values are Bootstrap Col-Md-1 - Col-Md-12."
// },
// "itemid": {
//   "title":"itemid='[Your Id]'",
//   "description":"ID & Name for Accessing this Element."
// },
// "modelname": {
//   "title":"modelname='[Model Name]'",
//   "description":"Model Name to Get a Field Value in Angular"
// },
// "tlate": {
//   "title":"tlate='[Translate Array Name]'",
//   "description":"From this value, Translator variable is accessed via Item ID"
// },
// "required": {
//   "title":"required='[ true OR false ]'",
//   "description":"This is field is Manditory or Not"
// },
// "picker": {
//   "title":"picker='[ datetime OR date OR time OR month OR year ]'",
//   "description":"This field is Manditory, For Which Picker You Need"
// },
// "posturlcheck": {
//   "title":"posturlcheck='[URL Location of API Server to Access Via POST]'",
//   "description":"Field value check with the Given URL in every keypressed."
// },
// "mindate": {
//   "title":"mindate='[Minimun Date to Select]'",
//   "description":"Minimum Date to be Selected"
// },
// "maxdate": {
//   "title":"maxdate='[Maximum Date to Select]'",
//   "description":"Maximum Date to be Selected"
// },
// "mindatetime": {
//   "title":"mindatetime='[Minimun DateTime to Select]'",
//   "description":"Minimum DateTime to be Selected"
// },
// "maxdatetime": {
//   "title":"maxdatetime='[Maximum DateTime to Select]'",
//   "description":"Maximum DateTime to be Selected"
// },
// "mintime": {
//   "title":"mintime='[Minimun Time to Select]'",
//   "description":"Minimum Time to be Selected"
// },
// "maxtime": {
//   "title":"maxtime='[Maximum Time to Select]'",
//   "description":"Maximum Time to be Selected"
// },
// "minmonth": {
//   "title":"minmonth='[Minimun Month to Select]'",
//   "description":"Minimum Month to be Selected"
// },
// "maxmonth": {
//   "title":"maxmonth='[Maximum Month to Select]'",
//   "description":"Maximum Month to be Selected"
// },
// "minyear": {
//   "title":"minyear='[Minimun Year to Select]'",
//   "description":"Minimum Year to be Selected"
// },
// "maxyear": {
//   "title":"maxyear='[Maximum Year to Select]'",
//   "description":"Maximum Year to be Selected"
// },
// "disableddates": {
//   "title":"disableddates='[List of Dates]'",
//   "description":"List of Date or DateTime to be Disabled from Selection"
// },
// "disableddays": {
//   "title":"disableddays='[List of Days Between 0 and 6, Sunday = 0, Saturday = 6]'",
//   "description":"List of Days to be Disabled from Selection"
// },
// "calendarweeks": {
//   "title":"calendarweeks='[true OR false]'",
//   "description":"Week No Want to Show or Not"
// }


(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderDatebox = {
            "datebox" : {
                "size": "col-md-6",
                "itemid": "testAdd",
                "modelname": "tadd",
                "tlate": "fdatebox.form",
                "required": "true",
                "picker": "date",
                "mindate": "2017-03-01",
                "maxdate": "2017-06-30",
                "minmonth":"2017-01-01",
                "maxmonth":"2017-05-01",
                "disableddates": "2017-05-15",
                "disableddays": "0,6",
                "calendarweeks": true,
                "posturlcheck": 'welcome/postdatecheck'
            },            
            "datetimebox" : {
                "size":"col-md-6",
                "itemid":"testAdd1",
                "modelname":"tadd1",
                "tlate":"fdatebox.form",
                "required":"true",
                "picker":"datetime",
                "mindatetime":"2017-01-01 09:00:00",
                "maxdatetime":"2017-06-30 20:00:00",
                "calendarweeks": true
            },
            "timebox" : {
                "size":"col-md-6",
                "itemid":"testAdd2",
                "modelname":"tadd2",
                "tlate":"fdatebox.form",
                "required":"true",
                "picker":"time",
                "mintime":"09:00:00",
                "maxtime":"20:00:00"
            },
            "monthbox" : {
                "size":"col-md-6",
                "itemid":"testAdd3",
                "modelname":"tadd3",
                "tlate":"fdatebox.form",
                "required":"true",
                "picker":"month",
                "minmonth":"2017-01-01",
                "maxmonth":"2017-12-01"
            },
            "yearbox" : {
                "size":"col-md-6",
                "itemid":"testAdd4",
                "modelname":"tadd4",
                "tlate":"fdatebox.form",
                "required":"true",
                "picker":"year",
                "minyear":"2015",
                "maxyear":"2017"
            },           
            "validtill" : {
                "size":"col-md-6",
                "itemid":"validtill",
                "modelname":"valid_till",
                "tlate":"commonForms.datebox",
                "required":"true",
                "picker":"datetime"
            },
            "todate" : {
                "size": "col-md-6",
                "itemid": "todate",
                "modelname": "todate",
                "tlate": "commonForms.datebox",
                "picker": "date"
            }
        };

    }
        
})();
// "autocomplete": {
//   "title":"autocomplete='[ true OR false ]'",
//   "description":"Autocomplete TextBox (If True Its Disabled)"
// },
// "size": {
//    "title":"size='[Boot Strap Col-Md Sizes]'",
//    "description":"For Size of the Textbox. Values are Bootstrap Col-Md-1 - Col-Md-12."
// },
// "itemid": {
//   "title":"itemid='[Your Id]'",
//   "description":"ID & Name for Accessing this Element."
// },
// "modelname": {
//   "title":"modelname='[Model Name]'",
//   "description":"Model Name to Get a Field Value in Angular"
// },
// "tlate": {
//   "title":"tlate='[Translate Array Name]'",
//   "description":"From this value, Translator variable is accessed via Item ID"
// },
// "required": {
//   "title":"required='[ true OR false ]'",
//   "description":"This is field is Manditory or Not"
// },
// "posturlcheck": {
//   "title":"posturlcheck='[URL Location of API Server to Access Via POST]'",
//   "description":"Field value check with the Given URL in every keypressed."
// }


(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderCheckbox = {
            "yesorno" : {
                "size": "col-md-2",
                "itemid": "yesorno",
                "modelname": "yesno",
                "tlate": "commonForms.checkbox",
                "required": "true",
            },            
            "yesorno1" : {
                "size": "col-md-2",
                "itemid": "yesorno1",
                "modelname": "yesno1",
                "tlate": "commonForms.checkbox"
            },            
            "access" : {
                "size": "col-md-2",
                "itemid": "access",
                "modelname": "access",
                "tlate": "commonForms.checkbox"
            }
        };

    }
        
})();
angular.module('app')
.directive('checkbox', checkbox);


function checkbox($rootScope){
    var data = {
      restrict : "EA",
      transclude: true,
      template : genrateCheckbox,
    };
    function genrateCheckbox(e,a)
    {
      var qattr = a.quickattrs;
      
      var qattrs = {};
      var found = false;
      if(a.localelement === undefined)
      {
        if($rootScope.fbuilderCheckbox[qattr] === undefined)
        {
          return "Undefined Item";
        }
        qattrs = $rootScope.fbuilderCheckbox[qattr] ? $rootScope.fbuilderCheckbox[qattr] : {};
      }
      else
      {
        if(q === undefined || q[qattr] === undefined)
        {
          return "Undefined Item";
        }
        var q = $rootScope.$eval("fbuilderCheckbox."+a.localelement);
        qattrs = q[qattr];
      }

      
      // var s = a.size;
      var s = getSize();
      var formname = getFormName();
      var formData = getFormDataName();
      var itemid = getItemid();
      var modelname = getModel();
      var tlate = getTlate();

      var acitem = ""+formname+"."+itemid+"";

      var nclass = '{ "has-error": '+acitem+'.$invalid || '+acitem+'.$pending , "has-success": '+acitem+'.$valid , "has-pending": '+acitem+'.$pending }';

      var elms = validationGenrator();

      function getFormName()
      {
        if(getItemType() === "ngform")
        {
          return e.closest("ng-form").attr('name');
        }
        else
        {
          return e.closest("form").attr('id');
        }
      }

      function getFormPrivateType()
      {
        if(getItemType() !== "ngform")
        {
          var ax = e.closest("form").attr('privatedata');
          if(ax !== undefined)
          {
            return ax;
          }
          else
          {
            return false;
          }
        }
        else
        {
          return false;
        }
      }

      function getFormDataName()
      {
        if(getItemType() === "ngform")
        {
          return "";
        }
        else if(getItemType() === "private")
        {
          return "";
        }
        else
        {
          if(getFormPrivateType() === false)
          { 
            return getFormName()+"Data.";
          }
          else
          {
            return getFormPrivateType() + ".";
          }
        }
      }

      function getItemType() {
        if(a.itemtype !== "" && a.itemtype !== undefined)
        {
          return a.itemtype;
        }
        else
        {
          if(qattrs.itemtype !== "" && qattrs.itemtype !== undefined)
          {
            return qattrs.itemtype;
          }
        }
      }

      function getTitle() {
        if(a.title !== "" && a.title !== undefined)
        {
          if((a.title.toLowerCase() === 'true'))
          {
            return true;
          }
          else
          {
            return false;
          }
        }
        else
        {
          if(qattrs.title !== "" && qattrs.title !== undefined)
          {            
            if((qattrs.title.toLowerCase() === 'true'))
            {
              return true;
            }
            else
            {
              return false;
            }
          }
        }
      }

      function getSize() {
        if(a.size !== "" && a.size !== undefined)
        {
          return a.size;
        }
        else
        {
          if(qattrs.size !== "" && qattrs.size !== undefined)
          {
            return qattrs.size;
          }
        }
      }

      function getItemid() {
        if(a.itemid !== "" && a.itemid !== undefined)
        {
          return a.itemid;
        }
        else
        {
          if(qattrs.itemid !== "" && qattrs.itemid !== undefined)
          {
            return qattrs.itemid;
          }
        }
      }

      function getModel() {
        if(a.modelname !== "" && a.modelname !== undefined)
        {
          return a.modelname;
        }
        else
        {
          if(qattrs.modelname !== "" && qattrs.modelname !== undefined)
          {
            return qattrs.modelname;
          }
        }
      }

      function getTlate() {
        if(a.tlate !== "" && a.tlate !== undefined)
        {
          return a.tlate;
        }
        else
        {
          if(qattrs.tlate !== "" && qattrs.tlate !== undefined)
          {
            return qattrs.tlate;
          }
        }
      }

      function validationGenrator()
      {
        var v = "";


        if(a.required !== "" && a.required !== undefined)
        {
          if((a.required.toLowerCase() === 'true'))
          {
            v += " required='true'";
          }
        }
        else
        {
          if(qattrs.required !== "" && qattrs.required !== undefined)
          {
            if((qattrs.required.toLowerCase() === "true"))
            {
              v += " required='true'";
            }
          }
        }



        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          v += " rdposturlcheck='"+a.posturlcheck+"'";
        }
        else
        {
          if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
          {
            v += " rdposturlcheck='"+qattrs.posturlcheck+"'";
          }
        }


        if(a.rdblur !== "" && a.rdblur !== undefined)
        {
          v += "ng-blur='"+a.rdblur+"'";
        }
        else
        {
          if(qattrs.rdblur !== "" && qattrs.rdblur !== undefined)
          {
            v += "ng-blur='"+qattrs.rdblur+"'";
          }
        }


        if(a.rdchange !== "" && a.rdchange !== undefined)
        {
          v += "ng-change='"+a.rdchange+"'";
        }
        else
        {
          if(qattrs.rdchange !== "" && qattrs.rdchange !== undefined)
          {
            v += "ng-change='"+qattrs.rdchange+"'";
          }
        }


        return v;
      }

      function messageGenrator()
      {
        var h = "";
        var v = "";
        h += "<div ng-messages='"+acitem+".$error' ng-show='"+acitem+".$dirty' role='alert'>";


        if(a.required !== "" && a.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }
        else if(qattrs.required !== "" && qattrs.required !== undefined)
        {
          h += "<div ng-message='required'><span class='help-block' translate='"+tlate+"."+itemid+".required'></span></div>";
        }


        if(a.posturlcheck !== "" && a.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }
        else if(qattrs.posturlcheck !== "" && qattrs.posturlcheck !== undefined)
        {
          h += "<div ng-message='rdposturlcheck'><span class='help-block' translate='"+tlate+"."+itemid+".posturlcheck'></span></div>";
        }


        h += "</div>";
        return h;
      }

      var html = '';
      html += getTitle() ? "<div class='"+s+" form-group' ng-class='"+nclass+"'>" : "";
      html += "<input type='checkbox' class='rdcheck-box' id='"+itemid+"' name='"+itemid+"' ng-model='"+formData+modelname+"' "+elms+">";
      html += getTitle() ? "<label for='"+itemid+"' translate='"+tlate+"."+itemid+".title'></label>" : "";
      html += getTitle() ? messageGenrator() : "";
      html += getTitle() ? "</div>" : "";

      return html;
    }
    return data;
}


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('smstemplate.sms_sett_self', {
          url: '/sms_sett_self',
          templateUrl: 'app/projects/rcloudsys/smstemplate/temp_sett/temp_sett.html',
          controller: 'TempSettController',
          data : { title: 'Notification Settings', folded: false },
          resolve : {
            getNotificationSett: function (getServer,$rootScope) {
              return getServer.getData('rcloudsys/template/getSmsTempsett/'+$rootScope.userSession.session.company);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('TempSettController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getNotificationSett, getServer, $stateParams) {
  $rootScope.vm = {};


  $scope.cid = issetnotempty($stateParams.id) ? $stateParams.id : $rootScope.userSession.session.company;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.temp_settData = {
    setting:[]
  };

  $scope.addSetting = function() {
    var d = {};
    d.value = angular.copy($scope.temp_settData);
    postServer.postData('rcloudsys/template/addSmsTempSett',$scope.temp_settData).then(function(data){
      if(data.type="success")
      {
        $state.reload();
      }
    });
  }

  $scope.temp_settData.setting = getNotificationSett.result;

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('smstemplate.list', {
          url: '/list/:id',
          templateUrl: 'app/projects/rcloudsys/smstemplate/list_smstemplate/list_smstemplate.html',
          controller: 'ListtemplateController',
          data : { title: 'List Template', folded: false },
          resolve : {
            getsmstemplatelist: function (getServer,$stateParams) {
              return getServer.getData('rcloudsys/template/getsmstemplatelist/'+$stateParams.id);
            },
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListtemplateController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getsmstemplatelist,getcompanyName, getServer, $stateParams) {
    var vms = this;

    $scope.cmpName = getcompanyName.result;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.cid = $stateParams.id;

    $scope.templatelist = getsmstemplatelist.result;

    var tpltetable = $('#listtemplatetable').DataTable({ 
      'aaData': $scope.templatelist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [ 
      { 'swidth': '5%',  'sTitle': "ID", 'mData': 'id'},
      {
        'sTitle': 'Project',
        'sWidth': '10%',
        "sClass": "selectfilter",
        'mData': 'project_name',
        'mRender': function (data, type, full) {
          if (full.status === "0") {
            return '<span class="label bg-danger" title="Disabled">'+full.project_name+'</span>';
          } else {
            return '<span class="label bg-success" title="Enabled">'+full.project_name+'</span>';
          }
        }
      },
      // { 'sWidth': '30%', 'sTitle': 'Project', 'mData': 'project_name', "sClass": "selectfilter"},
      { 'sWidth': '30%', 'sTitle': 'Template Name', 'mData': 'templatename'},
      // { 'sWidth': '30%', 'sTitle': 'Sms Template', 'mData': 'smstemplate'},
      { 'sWidth': '30%', 'sTitle': 'Access Variable', 'mData': 'accessvariable'},
      { 'sWidth': '15%', 'sTitle': 'Edit', 'mData': 'id', 'mRender': function (data,type,full) { return '<a class="btn btn-primary padtb2px" href="smstemplate/edit/'+data+'/'+$scope.cid+'">Edit</a>'} },
      { 'sWidth': '15%', 'sTitle': 'Delete', 'mData': 'id', 'mRender': function (data,type,full) { 
      var tid = "'listtemplatetable'";
        var d = "'"+data+"','"+full.templatename+"'";
        return '<a onClick="angular.element(document.getElementById('+tid+')).scope().deleteSmsTemplate(event,'+d+')" class="btn btn-info padtb2px">Delete</a>';} }
       ]
   });

    $scope.deleteSmsTemplate = function(event,id,templatename){
          var confirm = $mdDialog.confirm()
                        .title('Are you sure you want to delete '+templatename+'?')
                        .content('All your Modeles will be deleted.')
                        .ok('Yes')
                        .cancel('No')
                        .targetEvent(event);
          $mdDialog.show(confirm).then(function(){
              getServer.getData('rcloudsys/template/deletesmstemplate/'+id).then(function (data) {   
                  $state.reload();        
              });
          },function() {
              toastShow.show('info','','template_not_deleted');
          });
      };


});



'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('smstemplate.list_sms_log_self', {
          url: '/list_sms_log_self',
          templateUrl: 'app/projects/rcloudsys/smstemplate/list_sms_log/sms_log.html',
          controller: 'ListSmsLogController',
          data : { title: 'List Sms Log', folded: false },
          resolve : {
            getsmstemplatelist: function (getServer,$rootScope) {
              // return getServer.getData('rcloudsys/template/getsmstemplatelist/'+$stateParams.id);
            },
            getcompanyName: function (getServer, $rootScope) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('smstemplate.list_sms_log', {
          url: '/list_sms_log/:id',
          templateUrl: 'app/projects/rcloudsys/smstemplate/list_sms_log/sms_log.html',
          controller: 'ListSmsLogController',
          data : { title: 'List Sms Log', folded: false },
          resolve : {
            getsmstemplatelist: function (getServer,$stateParams) {
              // return getServer.getData('rcloudsys/template/getsmstemplatelist/'+$stateParams.id);
            },
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListSmsLogController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getsmstemplatelist, getServer,getcompanyName, $stateParams) {

  $rootScope.vm = {};

  $scope.cmpName = getcompanyName.result;
  
  $scope.cid = issetnotempty($stateParams.id) ? $stateParams.id : $rootScope.userSession.session.company;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.companyFilterData = {
    cmp_id : $scope.cid 
  };

  // $scope.CompanyfilterData = {
  //   companymas_id: $rootScope.getKnitpackFirstompany()
  // };

  var getVars = issetnotempty($scope.companyFilterData) ? $rootScope.fromatGetVars($scope.companyFilterData) : '';
  var url = $rootScope.processPostServerURL() + "rcloudsys/hub/getSmsLogDatatables" + getVars;
  

  // $scope.inwardDt.ajax.url(url).load()

  // $scope.getData = function(){

  //     $scope.inwardDt.ajax.url(url).load()

  // };

  // $scope.getData();



  var smsCountConfig = {
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": url,
      "type": "POST",
      "headers": $rootScope.postHeaders,
      "data": function (d) {
        return d.result;
      },
      "xhrFields": {
        "withCredentials": true
      }
    },
    'bProcessing': true,
    'ordering': true,
    'stateSave': false,
    'autowidth': false,
    "bAutoWidth": false,
    "aaSorting": [
      [3, 'desc']
    ],
    'aoColumns': [{
        'sTitle': 'Number',
        'mData': 'number',
        'sWidth': '10%'
      },
      {
        'sTitle': 'Msg',
        'mData': 'msg',
        'sWidth': '45%',
        'mRender': function(data, type, full) {
          return '<p title="'+ full.full_msg +'">'+ data +'...</p>';
        }
      },
      { 'sWidth': '10%',  'sTitle': 'Sent Status','mData': 'sent_status', 
      'mRender': function ( data, type, full )
      {
       if(data === "0") { return '<span class="btn btn-primary " title=" In Queue ">In Queue</span>'; }
       else if(data === "-1" )
        { return '<span class="label bg-danger" title="Failed">Failed</span>'; }
       else 
       { return '<span class="label bg-success" title="Success">Success</span>'; } } },
      {
        'sTitle': 'Sent Time',
        'mData': 'sent_time',
        'sWidth': '15%',
        'mRender': function (data, type, full) {
          return $rootScope.dbDatetimeToDatetime(data);
        }
      }
    ]
  };

  $scope.inwardDt = $('#smslist').DataTable(smsCountConfig);


});

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('smstemplate.edit', {
          url: '/edit/:id/:cid',
          templateUrl: 'app/projects/rcloudsys/smstemplate/edit_smstemplate/edit_smstemplate.html',
          controller: 'EditsmstemplateController',
          data : { title: 'Edit Template', folded: false },
          resolve : {
            getsmstemplate: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/template/getsmstemplate/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditsmstemplateController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getsmstemplate, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.cid;

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+',name,value" disableitems="true"></selectbox>';
    };

    $scope.getAccVarBox = function() {
      return '<textbox quickattrs="accessvariable" size="col-md-6" posturlcheck="rcloudsys/template/checkDupSmsTempId/'+$scope.cid+'/'+$stateParams.id+'"></textbox>';
    };

    $scope.edittemplateBData = getsmstemplate.result;
    
    $scope.editSmsTemplate = function() {
      postServer.postData('rcloudsys/template/editsmstemplate/'+$stateParams.id,$scope.edittemplateBData).then(function(data){
        if(data.type === "success")
        {
          $state.go('smstemplate.list',{id: $scope.cid });
        }
      });
    }

});


'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider',
      function ($stateProvider, $urlRouterProvider, $locationProvider) {
        $stateProvider
          /* Auth Page List*/
          .state('smstemplate.add', {
            url: '/add/:id',
            templateUrl: 'app/projects/rcloudsys/smstemplate/add_smstemplate/add_smstemplate.html',
            controller: 'AddtemplateController',
            data: {
              title: 'Create Template',
              folded: false
            },
            resolve: {},
            authenticate: false
          });
      }
    ]
  )
  .controller('AddtemplateController', function ($scope, $stateParams, $state, $rootScope, getServer, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cloneShow = $stateParams.id !== '1' ? true : false;

    $scope.cid = $stateParams.id;

    $scope.cloneReadonly = false;

    $scope.getProjectBox = function () {
      return '<selectbox quickattrs="companyprojects" rdreadonly="cloneReadonly" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/' + $scope.cid + ',name,value" disableitems="true"></selectbox>';
    };

    $scope.getAccVarBox = function () {
      return '<textbox quickattrs="accessvariable" rdreadonly="cloneReadonly" size="col-md-6" posturlcheck="rcloudsys/template/checkDupSmsTempId/' + $scope.cid + '/"></textbox>';
    };

    $scope.getTempBox = function () {
      if (issetnotempty($scope.cloneTempData.projectid)) {
        return '<selectbox quickattrs="temp_sb" modelname="parent_id" dataAPIURL="rcloudsys/template/getSmsTempForFirstCmp/' + $scope.cloneTempData.projectid + ' " size="col-md-4"></selectbox>';
      }
      return ' <selectbox quickattrs="temp_sb" modelname="parent_id" size="col-md-4"></selectbox>';
    };

    $scope.addtemplateBData = {
      company_id: $scope.cid,
      temptype: 'event'
    };
    $scope.cloneTempData = {};

    $scope.getDataForClone = function () {
      getServer.getData('rcloudsys/template/getSmsTempForClone/' + $scope.cloneTempData.parent_id).then(function (data) {
        $scope.addtemplateBData = angular.extend($scope.addtemplateBData, data.result);
        $scope.cloneReadonly = true;
        if ($scope.addtemplateBData.sms_desc === '') {
          $scope.addtemplateBData.sms_desc = '------';
        }
      });
    }

    $scope.addSmsTemplate = function () {
      $scope.addtemplateBData.parent_id = issetnotempty($scope.cloneTempData.parent_id) ? $scope.cloneTempData.parent_id : '0';
      var d = angular.copy($scope.addtemplateBData);
      d.company_id = $scope.cid;
      postServer.postData('rcloudsys/template/addsmstemplate', d).then(function (data) {
        if (data.type === "success") {
          $state.go('smstemplate.list', {
            id: $scope.cid
          });
        }
      });
    }

  });

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('emailtemplate.email_sett_self', {
          url: '/email_sett_self',
          templateUrl: 'app/projects/rcloudsys/emailtemplate/temp_sett/temp_sett.html',
          controller: 'EmailTempSettController',
          data : { title: 'Notification Settings', folded: false },
          resolve : {
            getNotificationSett: function (getServer,$rootScope) {
              return getServer.getData('rcloudsys/template/getEmailTempsett/'+$rootScope.userSession.session.company);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EmailTempSettController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getNotificationSett, getServer, $stateParams) {
  $rootScope.vm = {};


  $scope.cid = issetnotempty($stateParams.id) ? $stateParams.id : $rootScope.userSession.session.company;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.temp_settData = {
    setting:[]
  };

  $scope.addEmailTempSett = function() {
    var d = {};
    d.value = angular.copy($scope.temp_settData);
    postServer.postData('rcloudsys/template/addEmailTempSett',$scope.temp_settData).then(function(data){
      if(data.type="success")
      {
        $state.reload();
      }
    });
  }

  $scope.temp_settData.setting = getNotificationSett.result;

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('emailtemplate.list', {
          url: '/list/:id',
          templateUrl: 'app/projects/rcloudsys/emailtemplate/list_emailtemplate/list_emailtemplate.html',
          controller: 'ListemailtemplateController',
          data : { title: 'List Email Template', folded: false },
          resolve : {
            getemailtemplatelist: function (getServer,$stateParams) {
              return getServer.getData('rcloudsys/template/getemailtemplatelist/'+$stateParams.id);
            },
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListemailtemplateController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getemailtemplatelist, getServer,getcompanyName, $stateParams) {
    var vms = this;

    $scope.cmpName = getcompanyName.result;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.cid = $stateParams.id;

    $scope.templatelist = getemailtemplatelist.result;

    var tpltetable = $('#listtemplatetable').DataTable({ 
      'aaData': $scope.templatelist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [ 
      { 'swidth': '5%',  'sTitle': "ID", 'mData': 'id'},
      {
        'sTitle': 'Project',
        'sWidth': '10%',
        "sClass": "selectfilter",
        'mData': 'project_name',
        'mRender': function (data, type, full) {
          if (full.status === "0") {
            return '<span class="label bg-danger" title="Disabled">'+full.project_name+'</span>';
          } else {
            return '<span class="label bg-success" title="Enabled">'+full.project_name+'</span>';
          }
        }
      },
      // { 'sWidth': '30%', 'sTitle': 'Project', 'mData': 'project_name', "sClass": "selectfilter"},
      { 'sWidth': '30%', 'sTitle': 'Name', 'mData': 'templatename'},
      { 'sWidth': '30%', 'sTitle': 'Subject', 'mData': 'subject'},
      { 'sWidth': '15%', 'sTitle': 'Edit', 'mData': 'id', 'mRender': function (data,type,full) { return '<a class="btn btn-primary padtb2px" href="emailtemplate/edit/'+data+'/'+$scope.cid+'">Edit</a>'} },
      { 'sWidth': '15%', 'sTitle': 'Delete', 'mData': 'id', 'mRender': function (data,type,full) { 
      var tid = "'listtemplatetable'";
        var d = "'"+data+"','"+full.templatename+"'";
        return '<a onClick="angular.element(document.getElementById('+tid+')).scope().deleteEmailtemplate(event,'+d+')" class="btn btn-info padtb2px">Delete</a>';} }
       ]
   });

    $scope.deleteEmailtemplate = function(event,id,templatename){
          var confirm = $mdDialog.confirm()
                        .title('Are you sure you want to delete '+templatename+'?')
                        .content('All your Modeles will be deleted.')
                        .ok('Yes')
                        .cancel('No')
                        .targetEvent(event);
          $mdDialog.show(confirm).then(function(){
              getServer.getData('rcloudsys/template/deleteemailtemplate/'+id).then(function (data) {   
                  $state.reload();        
              });
          },function() {
              toastShow.show('info','','template_not_deleted');
          });
      };


});



'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('emailtemplate.list_email_log_self', {
          url: '/list_email_log_self',
          templateUrl: 'app/projects/rcloudsys/emailtemplate/list_email_log/email_log.html',
          controller: 'ListEmailLogController',
          data : { title: 'List Email Log', folded: false },
          resolve : {
            getcompanyName: function (getServer, $rootScope) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('emailtemplate.list_email_log', {
          url: '/list_email_log/:id',
          templateUrl: 'app/projects/rcloudsys/emailtemplate/list_email_log/email_log.html',
          controller: 'ListEmailLogController',
          data : { title: 'List Email Log', folded: false },
          resolve : {
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
            }
          },
          authenticate: true
        });
        
  }
]
)
.controller('ListEmailLogController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getcompanyName, getServer, $stateParams) {
  $rootScope.vm = {};

  $scope.cmpName = getcompanyName.result;

  $scope.cid = issetnotempty($stateParams.id) ? $stateParams.id : $rootScope.userSession.session.company;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.companyFilterData = {
    cmp_id : $scope.cid 
  };


  var getVars = issetnotempty($scope.companyFilterData) ? $rootScope.fromatGetVars($scope.companyFilterData) : '';
  var url = $rootScope.processPostServerURL() + "rcloudsys/hub/getEmailLogDatatables" + getVars;
  

  var emailCountConfig = {
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": url,
      "type": "POST",
      "headers": $rootScope.postHeaders,
      "data": function (d) {
        return d.result;
      },
      "xhrFields": {
        "withCredentials": true
      }
    },
    'bProcessing': true,
    'ordering': true,
    'stateSave': false,
    'autowidth': false,
    "bAutoWidth": false,
    "aaSorting": [
      [3, 'desc']
    ],
    'aoColumns': [{
        'sTitle': 'Mail To',
        'mData': 'mail_to',
        'sWidth': '20%'
      },
      {
        'sTitle': 'CC',
        'mData': 'cc',
        'sWidth': '20%',
        // 'mRender': function(data, type, full) {
        //   return '<p title="'+ full.full_msg +'">'+ data +'...</p>';
        // }
      },
      {
        'sTitle': 'Subject',
        'mData': 'sub',
        'sWidth': '20%',
        // 'mRender': function(data, type, full) {
        //   return '<p title="'+ full.full_msg +'">'+ data +'...</p>';
        // }
      },
      { 'sWidth': '10%',  'sTitle': 'Sent Status','mData': 'sent_status',
      'mRender': function ( data, type, full )
       {
        if(data === "0") { return '<span class="btn btn-primary " title=" In Queue ">In Queue</span>'; }
        else if(data === "-1" )
         { return '<span class="label bg-danger" title="Failed">Failed</span>'; }
        else 
        { return '<span class="label bg-success" title="Success">Success</span>'; } } },
      {
        'sTitle': 'Sent Time',
        'mData': 'sent_time',
        'sWidth': '15%',
        'mRender': function (data, type, full) {
          return $rootScope.dbDatetimeToDatetime(data);
        }
      }
    ]
  };

  $scope.inwardDt = $('#email_list').DataTable(emailCountConfig);


});

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('emailtemplate.edit', {
          url: '/edit/:id/:cid',
          templateUrl: 'app/projects/rcloudsys/emailtemplate/edit_emailtemplate/edit_emailtemplate.html',
          controller: 'EditemailtemplateController',
          data : { title: 'Edit Email Template', folded: false },
          resolve : {
            getemailtemplate: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/template/getemailtemplate/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditemailtemplateController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getemailtemplate, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.cid;

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+',name,value" disableitems="true"></selectbox>';
    };

    $scope.getAccVarBox = function() {
      return '<textbox quickattrs="accessvariable" size="col-md-6" posturlcheck="rcloudsys/template/checkDupEmailTempId/'+$scope.cid+'/'+$stateParams.id+'"></textbox>';
    };

    $scope.edittemplateBData = getemailtemplate.result;
    
    $scope.editEmailTemplate = function() {
      postServer.postData('rcloudsys/template/editemailtemplate/'+$stateParams.id,$scope.edittemplateBData).then(function(data){
        if(data.type === "success")
        {
          $state.go('emailtemplate.list',{id: $scope.cid });
        }
      });
    }

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('emailtemplate.add', {
          url: '/add/:id',
          templateUrl: 'app/projects/rcloudsys/emailtemplate/add_emailtemplate/add_emailtemplate.html',
          controller: 'AddemailtemplateController',
          data : { title: 'Create Email Template', folded: false },
          resolve : {},
          authenticate: false
        });
  }
]
)
.controller('AddemailtemplateController', function($scope,getServer, $stateParams, $state, $rootScope, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.id;
    
    $scope.cloneShow = $stateParams.id !== '1' ? true : false;

    $scope.getProjectBox = function() {
      return '<selectbox quickattrs="companyprojects" modelname="projectid" dataapiurlformat="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+',name,value" disableitems="true"></selectbox>';
    };

    $scope.getAccVarBox = function() {
      return '<textbox quickattrs="accessvariable" size="col-md-6" posturlcheck="rcloudsys/template/checkDupEmailTempId/'+$scope.cid+'/"></textbox>';
    };

    $scope.getTempBox = function () {
      if (issetnotempty($scope.cloneTempData.projectid)) {
        return '<selectbox quickattrs="temp_sb" modelname="parent_id" dataAPIURL="rcloudsys/template/getEmailTempForFirstCmp/' + $scope.cloneTempData.projectid + ' " size="col-md-4"></selectbox>';
      }
      return ' <selectbox quickattrs="temp_sb" modelname="parent_id" size="col-md-4"></selectbox>';
    };

    $scope.addtemplateBData = {
      company_id: $scope.cid
    };

    $scope.cloneTempData = {};

    $scope.getDataForClone = function () {
      getServer.getData('rcloudsys/template/getEmailTempForClone/' + $scope.cloneTempData.parent_id).then(function (data) {
        $scope.addtemplateBData = angular.extend($scope.addtemplateBData, data.result);
        $scope.cloneReadonly = true;
        if($scope.addtemplateBData.email_desc === '')
        {
          $scope.addtemplateBData.email_desc = '------';
        }
      });
    }

     $scope.addEmailTemplate = function() {
      $scope.addtemplateBData.parent_id = issetnotempty($scope.cloneTempData.parent_id) ? $scope.cloneTempData.parent_id : '0' ;
      var d = angular.copy($scope.addtemplateBData);
      d.company_id =  $scope.cid;
      postServer.postData('rcloudsys/template/addemailtemplate',d).then(function(data){
        if(data.type === "success")
        {
          $state.go('emailtemplate.list',{id: $scope.cid });
        }
      });
    }

    
}); 


'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('dbschemes.updates', {
            url: '/updates',
            templateUrl: 'app/projects/rcloudsys/dbschemes/dbupdates/list_dbupdates.html',
            controller: 'ListdatabaseupdatesController',
            data: {
              title: 'List Updates',
              folded: false
            },
            resolve: {},
            authenticate: true
          });
      }
    ]
  )
  .controller('ListdatabaseupdatesController', function ($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getServer, $stateParams, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.checkingGoingon = false;

    $scope.scheme_selectionData = {};

    $scope.querylist = [];

    $scope.showList = false;

    $scope.dbs = [];

    $scope.latestVersion = 0;

    // getDatabaseTypelist

    var tpltetable = $('#listquerytable').DataTable({
      'aaData': $scope.querylist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [
        { 'sWidth': '10px', 'sTitle': '<input type="checkbox" ng-click="checkAll()">', 'mData': 'id', 'mRender': function (data, type, full) { 
          if (full.lastupdatedid !== $scope.latestVersion) {
          return '<input type="checkbox" name="id[]" value="'+data+'">';
          }
          else
          {
            return '#';
          }
        }},
        {
          'swidth': '40%',
          'sTitle': "Company Name",
          'mData': 'companyName'
        },
        {
          'sWidth': '40%',
          'sTitle': 'Current Version',
          'mData': 'lastupdatedid',
          'mRender': function (data, type, full) {
            return "Version " + data + "";
          }
        },
        {
          'sWidth': '20%',
          'sTitle': 'Updates',
          'mData': 'id',
          'mRender': function (data, type, full) {
            if (full.lastupdatedid !== $scope.latestVersion) {
              var tid = "'" + "listquerytable" + "'";
              var d = "'" + data + "'";
              var fun = 'onClick="angular.element(document.getElementById(' + tid + ')).scope().update_dabase(event,' + d + ')"';
              return '<a ' + fun + ' class="btn btn-primary padtb2px">Update</a>';
            } else {
              return "<b>Latest Version!</b>";
            }
          }
        },
        {
          'sWidth': '20%',
          'sTitle': 'Backup',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'" + "listquerytable" + "'";
            var d = "'" + data + "'";
            var fun = 'onClick="angular.element(document.getElementById(' + tid + ')).scope().backupdb(event,' + d + ')"';
            return '<a ' + fun + ' class="btn btn-info padtb2px">Backup</a>';
          }
        }
      ],
      'headerCallback': function (thead, data, start, end, display) {
        if(!vms.headerCompiled)
        {
          $compile(angular.element(thead).contents())($scope);
          vms.headerCompiled = true;
        }
      }
    });

    $scope.checkAll = function () {
      if(vms.allchecked)
      {
        tpltetable.$('input[type="checkbox"]').each(function(){
            this.checked = false;
            vms.allchecked = false;
        });
      }
      else
      {
        tpltetable.$('input[type="checkbox"]').each(function(){
            this.checked = true;
            vms.allchecked = true;
        });
      }
    };

    $scope.sDbs = [];
    var updateDb = 0;

    $scope.getSelectedDbs = function() {      
      $scope.sDbs = [];
      var s = 0;
      tpltetable.$('input[type="checkbox"]').each(function(){
        if(this.checked){
          $scope.sDbs[s] = this.value;
          s++;
        }
      });
    };

    $scope.updateAllDatabases = function(ev) {
      if($scope.sDbs.length === 0)
      {
        $scope.getSelectedDbs();
      }
      if($scope.sDbs[updateDb] !== undefined)
      {
        $scope.update_dabase(ev, $scope.sDbs[updateDb], true);
      }
      // $scope.sDbs.forEach(function(v,index){
      //   updateDb += 1;
      //   $scope.update_dabase(ev, v, true);
      // },this);
      // console.log($scope.sDbs);
    };

    $scope.getDBList = function () {
      $scope.checkingGoingon = true;
      getServer.getData('rcloudsys/dbschemes/getLastVersionQuery/' + $scope.scheme_selectionData.dbtype).then(function (data) {
        $scope.latestVersion = data.result[0].version;
      });
      getServer.getData('rcloudsys/dbschemes/getDatabaseTypelist/' + $scope.scheme_selectionData.dbtype).then(function (data) {
        $scope.showList = true;
        $scope.dbs = data.result;
        tpltetable.clear();
        tpltetable.rows.add($scope.dbs);
        tpltetable.draw();
        $scope.checkingGoingon = false;
      });
    };

    $scope.backupdb = function(ev, id) {
      getServer.getData('rcloudsys/dbschemes/backupdb/' + id).then(function (data) {
        console.log(data);
      });
    };

    $scope.backupAll = function(ev) {
      getServer.getData('rcloudsys/dbschemes/backupall').then(function (data) {
        console.log(data);
      });
    };

    $scope.update_dabase = function (ev, id, updateall) {
      // $state.go('dbschemes.updater',{ 'did' : id});
      $mdDialog.show({
        locals: {
          data: id,
        },
        controller: UpdaterController,
        scope: $scope,
        preserveScope: true,
        templateUrl: 'app/projects/rcloudsys/dbschemes/dbupdates/updater.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        // clickOutsideToClose: true,
        fullscreen: false,
        onRemoving: function (event, removePromise) {
          if(updateDb !== $scope.sDbs.length)
          {
            updateDb += 1;
            $scope.updateAllDatabases();
          }
          else
          {
            $scope.sDbs = [];
            $scope.getDBList();
          }
        }
      });
    };

    function UpdaterController($rootScope, $scope, $mdDialog, data) {
        $scope.theme = $rootScope.getThemeColor();

      $scope.loading = false;

      $scope.did = data;

      $scope.data = {};

      $scope.loading = true;
      getServer.getData('rcloudsys/dbschemes/getDBStatus/' + $scope.did).then(function (data) {
        $scope.loading = false;
        $scope.data = data.result;
        $scope.startUpdater();
      });

      $scope.needtoUpdate = 0;
      $scope.updateStarted = false;
      $scope.currentStatus = "Started";
      $scope.currentlyUpdating = 0;

      $scope.startUpdater = function () {
        $scope.updateStarted = true;
        $scope.needtoUpdate = parseInt((($scope.data.types.latest_version - $scope.data.dbs.lastupdatedid) * 10));
        $scope.updateNext();
      };

      $scope.updateNext = function () {
        if ($scope.currentlyUpdating <= $scope.needtoUpdate) {
            $scope.currentStatus = "Started";
            $scope.currentlyUpdating += 1;
            getServer.getData('rcloudsys/dbschemes/updatetoNext/' + $scope.did).then(function (data) {
              if(data.msg.type !== 'success')
              {
                $scope.currentStatus = "Finished";
                $timeout(function () {
                    $scope.updateNext();
                }, 300);
              }
              else
              {
                $scope.updateFinished();
              }
            });
        } else {
          $scope.updateFinished();
        }
      };

      $scope.updateFinished = function () {
        $scope.cancel();
        $scope.getDBList();
      };

      $scope.cancel = function () {
        $mdDialog.cancel();
      };

    }


  });

'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('companyreport.list', {
            url: '/list/:id',
            templateUrl: 'app/projects/rcloudsys/companyreport/list_companyreport/list_companyreport.html',
            controller: 'ListcompanyreportController',
            data: {
              title: 'List Company Report',
              folded: false
            },
            resolve: {
              getcompanyreportlist: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/reports/getcompanyreportlist/' + $stateParams.id);
              },
              getcompanyName: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ListcompanyreportController', function ($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getcompanyreportlist,getcompanyName, getServer, $stateParams) {
    var vms = this;

    $scope.cmpName = getcompanyName.result;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.cid = $stateParams.id;

    $scope.reportlist = getcompanyreportlist.result.mclist;

    // console.log($scope.reportlist);

    var tpltetable = $('#listreporttable').DataTable({
      'aaData': $scope.reportlist,
      'bProcessing': true,
      'ordering': true,
      'responsive': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [{
          'sWidth': '10%',
          'sTitle': 'Project',
          'mData': 'project_name'
        },
        {
          'sWidth': '20%',
          'sTitle': 'Name',
          'mData': 'name'
        },
        {
          'sWidth': '15%',
          'sTitle': 'Report ID',
          'mData': 'rid'
        },
        {
          'sWidth': '15%',
          'sTitle': 'Report Type',
          'mData': 'rtype'
        },
        {
          'sWidth': '35%',
          'sTitle': 'Status',
          'mData': 'status',
          'mRender': function (data, type, full) {
            if (data === "0") {
              return '<span class="label bg-danger" title="Disabled">Disabled</span>';
            } else {
              return '<span class="label bg-success" title="Enabled">Enabled</span>';
            }
          }
        },
        {
          'orderable': false,
          'sWidth': '25px',
          'sTitle': '<i class="fa fa-pencil"></i>',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'listreporttable'";
            var d = "'" + data + "','" + full.name + "'";
            var html = "";
            html += "<div class='btn-group'>";
            html += "<button type='button' class='btn btn-default dropdown-toggle linkdropDown padall2px' data-toggle='dropdown' aria-expanded='false'>";
            html += "Options ";
            html += "<span class='caret'></span>";
            html += "<span class='sr-only'>Toggle Dropdown</span>";
            html += "</button>";
            html += "<ul class='dropdown-menu' role='menu'>";
            // html += "<li class='divider'></li>";.
            html += '<li> <a href="companyreport/edit/' + data + '/' + $scope.cid + '">Edit</a></li>';
            html += '<li> <a href="designer/stdesigner/' + data + '/' + $scope.cid + '">Designer</a></li>';
            html += '<li> <a  onClick="angular.element(document.getElementById(' + tid + ')).scope().downloadReport(event,' + d + ')">Download</a></li>';
            html += '<li> <a onClick="angular.element(document.getElementById(' + tid + ')).scope().deleteReport(event,' + d + ')">Delete</a></li>';
            html += "</ul>";
            html += "</div>";
            return html;
          }
        }
      ]
    });

    $scope.downloadReport = function (event, id, name) {
      getServer.getData('rcloudsys/reports/getReportData/' + id).then(function (data) {
        if(data.result.data !== '')
        {
          downloadTextfile(name + '.mrt', data.result.data);
        }
      });
    };

    $scope.deleteReport = function (event, id, name) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure you want to delete ' + name + '?')
        .content('All your Modeles will be deleted.')
        .ok('Yes')
        .cancel('No')
        .targetEvent(event);
      $mdDialog.show(confirm).then(function () {
        getServer.getData('rcloudsys/reports/deleteCompanyReport/' + id).then(function (data) {
          $state.reload();
        });
      }, function () {
        toastShow.show('info', '', 'report_not_deleted');
      });
    };


  });
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companyreport.edit', {
          url: '/edit/:id/:cid',
          templateUrl: 'app/projects/rcloudsys/companyreport/edit_companyreport/edit_companyreport.html',
          controller: 'EditCompanyReportController',
          data : { title: 'Edit Company Report', folded: false },
          resolve : {
            getcompanyreport: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/reports/getcompanyreport/'+$stateParams.id);
            }
          },
          authenticate: false
        });
  }
]
)
.controller('EditCompanyReportController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getcompanyreport, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.cid;

    $scope.editcompanyreportData = getcompanyreport.result;

    $scope.getProjectBox = function() {
      var html = '';
      html += '<selectbox quickattrs="listprojects" dataapiurl="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+'" multiple="false" modelname="project_id" disableitems="true"></selectbox>';
      return html;
    };
    
    $scope.editCompanyReport = function() {
      postServer.postData('rcloudsys/reports/editcompanyreport/'+$stateParams.id,$scope.editcompanyreportData).then(function(data){
        if(data.type === "success")
        {
          $state.go('companyreport.list',{id: $scope.cid });
        }
      });
    }

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companyreport.add', {
          url: '/add/:id',
          templateUrl: 'app/projects/rcloudsys/companyreport/add_companyreport/add_companyreport.html',
          controller: 'AddCompanyreportController',
          data : { title: 'Create Company Report', folded: false },
          resolve : {},
          authenticate: false
        });
  }
]
)
.controller('AddCompanyreportController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.id;

    $scope.addcompanyreportData = {};

    $scope.getProjectBox = function() {
      var html = '';
      html += '<selectbox quickattrs="listprojects" dataapiurl="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+'" multiple="false" modelname="project_id" disableitems="true"></selectbox>';
      return html;
    };

     $scope.addCompanyReport = function() {
      var d =angular.copy($scope.addcompanyreportData);
      d.company_id =  $scope.cid;
      postServer.postData('rcloudsys/reports/addcompanyreport',d).then(function(data){
        if(data.type === "success")
        {
          $state.go('companyreport.list',{id: $scope.cid });
        }
      });
    }

}); 


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.viewreports', {
          url: '/viewreports',
          templateUrl: 'app/projects/rcloudsys/companies/viewreports/viewreports.html',
          controller: 'ListViewReportsController',
          data : { title: 'View Report List', folded: false },
          resolve : {
            companiesList: function (getServer) {
              return getServer.getData('rcloudsys/reports/getReportDataList');
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListViewReportsController', function($scope, $state, $compile, $rootScope, $mdDialog, companiesList, toastShow, postServer, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.companieslst = companiesList.result;

    console.log($scope.companieslst);

    var plstable = $('#viewreporttable').DataTable({ 
      'aaData': $scope.companieslst,
      'bProcessing': true,
      'ordering': true,
      'autoWidth': false,
      'stateSave': true,
      'aoColumns': [
        { 'sTitle': 'Company Name', 'sWidth': '25%', 'mData': 'company_name' },
        { 'sTitle': 'Project', 'sWidth': '25%',  'mData': 'project_name' },
        { 'sTitle': 'Report ID', 'sWidth': '10%',  'mData': 'rid' },
        { 'sTitle': 'Report Type', 'sWidth': '7%', 'mData': 'rtype' },
        { 'sTitle': 'Status', 'sWidth': '7%', 'mData': 'status', 'mRender': function ( data, type, full ) { if(data === "0") { return '<span class="label bg-danger" title="Disabled">Disabled</span>'; } else { return '<span class="label bg-success" title="Enabled">Enabled</span>'; } }  },
        {
          'orderable': false,
          'sWidth': '25px',
          'sTitle': '<i class="fa fa-pencil"></i>',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'viewreporttable'";
            var d = "'" + data + "','" + full.name + "'";
            var html = "";
            html += "<div class='btn-group'>";
            html += "<button type='button' class='btn btn-default dropdown-toggle linkdropDown padall2px' data-toggle='dropdown' aria-expanded='false'>";
            html += "Options ";
            html += "<span class='caret'></span>";
            html += "<span class='sr-only'>Toggle Dropdown</span>";
            html += "</button>";
            html += "<ul class='dropdown-menu' role='menu'>";
            // html += "<li class='divider'></li>";.
            html += '<li> <a href="companyreport/edit/' + data + '/-1">Edit</a></li>';
            html += '<li> <a href="designer/stdesigner/' + data + '/-1">Designer</a></li>';
            html += '<li> <a  onClick="angular.element(document.getElementById(' + tid + ')).scope().downloadReport(event,' + d + ')">Download</a></li>';
            html += '<li> <a onClick="angular.element(document.getElementById(' + tid + ')).scope().deleteReport(event,' + d + ')">Delete</a></li>';
            html += "</ul>";
            html += "</div>";
            return html;
          }
        }
    ]
    });

    

    $scope.downloadReport = function (event, id, name) {
      getServer.getData('rcloudsys/reports/getReportData/' + id).then(function (data) {
        if(data.result.data !== '')
        {
          downloadTextfile(name + '.mrt', data.result.data);
        }
      });
    };

    $scope.deleteReport = function (event, id, name) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure you want to delete ' + name + '?')
        .content('All your Modeles will be deleted.')
        .ok('Yes')
        .cancel('No')
        .targetEvent(event);
      $mdDialog.show(confirm).then(function () {
        getServer.getData('rcloudsys/reports/deleteCompanyReport/' + id).then(function (data) {
          $state.reload();
        });
      }, function () {
        toastShow.show('info', '', 'report_not_deleted');
      });
    };

});

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.list_user_log_self', {
          url: '/list_user_log_self',
          templateUrl: 'app/projects/rcloudsys/companies/user_log/user_log.html',
          controller: 'ListUserLogController',
          data : { title: 'List User Log', folded: false },
          resolve : {
            getcompanyName: function (getServer, $rootScope) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('companies.list_user_log', {
          url: '/list_user_log/:id',
          templateUrl: 'app/projects/rcloudsys/companies/user_log/user_log.html',
          controller: 'ListUserLogController',
          data : { title: 'List User Log', folded: false },
          resolve : {
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.id);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListUserLogController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer,  getServer,getcompanyName, $stateParams) {

  $rootScope.vm = {};

  $scope.cmpName = getcompanyName.result;
  
  $scope.cid = issetnotempty($stateParams.id) ? $stateParams.id : $rootScope.userSession.session.company;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.ViewData = {
    cmp_id : $scope.cid, 
    user_id : ''
  };


  $scope.UserBox = function(){
    var html = '';

    if($scope.ViewData.cmp_id !== '')
    {
      html += '<selectbox required="false" modelname="user_id" dataAPIURL = "rcloudsys/users/usersSB/' + $scope.ViewData.cmp_id +' " quickattrs="usersb" ></selectbox>';
    }
    return html;
  }


  var getVars = issetnotempty($scope.ViewData) ? $rootScope.fromatGetVars($scope.ViewData) : '';
  var url = $rootScope.processPostServerURL() + "rcloudsys/companies/getUserLogDatatables" + getVars;
  
  
  $scope.userFilter = function(){

    var getVars = issetnotempty($scope.ViewData) ? $rootScope.fromatGetVars($scope.ViewData) : '';
    var url = $rootScope.processPostServerURL() + "rcloudsys/companies/getUserLogDatatables" + getVars;

     $scope.inwardDt.ajax.url(url).load();

  }

  var userListConfig = {
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": url,
      "type": "POST",
      "headers": $rootScope.postHeaders,
      "data": function (d) {
        return d.result;
      },
      "xhrFields": {
        "withCredentials": true
      }
    },
    'bProcessing': true,
    'ordering': true,
    'stateSave': false,
    'autowidth': false,
    "bAutoWidth": false,
    "aaSorting": [
      [1, 'desc']
    ],
    'aoColumns': [{
        'sTitle': 'User Name',
        'mData': 'display_name',
        'sWidth': '25%'
      },
      {
        'sTitle': 'Login Time',
        'mData': 'login_time',
        'sWidth': '25%', 
        'mRender': function (data, type, full) {
          return $rootScope.dbDatetimeToDatetime(data);
        }
      },
      {
        'sTitle': 'Logout Time',
        'mData': 'logout_time',
        'sWidth': '25%',
        'mRender': function (data, type, full) {
          return $rootScope.dbDatetimeToDatetime(data);
        }
      },
      {
        'sTitle': 'Info',
        'mData': 'info',
        'sWidth': '25%',
      },
      
    ]
  };

  var editItem = {
    'sTitle': 'Details',
    "sWidth": "7%",
    'mData': 'session_id',
    'mRender': function (data, type, full) {
      return '<a class="btn btn-primary padtb2px" href="companies/list_user_log_det/' + data + '/'+ $scope.cid+'">Details</a>';
    }
  };
  userListConfig.aoColumns.push(editItem);

  $scope.inwardDt = $('#userlist').DataTable(userListConfig);


});

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.server_status_self', {
          url: '/server_status_self',
          templateUrl: 'app/projects/rcloudsys/companies/server_status/server_status.html',
          controller: 'CServerStatusProjectController',
          data : { title: 'Server Status', folded: false },
          resolve : {
            getServerStatus: function($rootScope,getServer) {
              return getServer.getData('rcloudsys/companies/getServerStatus/'+$rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('companies.server_status', {
          url: '/server_status/:cid',
          templateUrl: 'app/projects/rcloudsys/companies/server_status/server_status.html',
          controller: 'CServerStatusProjectController',
          data : { title: 'Server Status', folded: false },
          resolve : {
            getServerStatus: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/companies/getServerStatus/'+$stateParams.cid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('CServerStatusProjectController', function($scope, $state, $stateParams, getServer, $mdDialog, getServerStatus, $rootScope, toastShow, postServer) {
  var vms = this;

  $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

  $scope.self = issetnotempty($stateParams.cid) ? false : true;

  $scope.cmpData = getServerStatus.result;

  $scope.getProgress = function(size,limit) {
    var a = [];
    var perc = round((size / limit * 100),2);
    if(Number(size) >= Number(limit))
    {
      a[0] = 25;
      a[1] = 25;
      a[2] = 25;
      a[3] = 25;
    }
    else
    {
      a[0] = perc > 25 ? 25 : perc;
      a[1] = perc > 50 ? 25 : perc - 25;
      a[2] = perc > 75 ? 25 : perc - 50;
      a[3] = perc >= 100 ? 25 : perc - 75;
    }
    // console.log(size,limit,perc,a);
    var html = '';
    html += '<div class="progress-bar bg-info progress-bar-striped progress-bar-animated" role="progressbar" style="width: '+a[0]+'%" aria-valuenow="'+a[0]+'" aria-valuemin="0" aria-valuemax="100"></div>';
    html += '<div class="progress-bar bg-success progress-bar-striped progress-bar-animated" role="progressbar" style="width: '+a[1]+'%" aria-valuenow="'+a[1]+'" aria-valuemin="0" aria-valuemax="100"></div>';
    html += '<div class="progress-bar bg-warning progress-bar-striped progress-bar-animated" role="progressbar" style="width: '+a[2]+'%" aria-valuenow="'+a[2]+'" aria-valuemin="0" aria-valuemax="100"></div>';
    html += '<div class="progress-bar bg-danger progress-bar-striped progress-bar-animated" role="progressbar" style="width: '+a[3]+'%" aria-valuenow="'+a[3]+'" aria-valuemin="0" aria-valuemax="100"></div>';
    return html;
  };

});

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.notify_sett_self', {
          url: '/notify_sett_self',
          templateUrl: 'app/projects/rcloudsys/companies/notify_sett/notify_sett.html',
          controller: 'NotifySettController',
          data : { title: 'Notification Settings', folded: false },
          resolve : {
            getNotificationSett: function (getServer,$rootScope) {
              return getServer.getData('rcloudsys/companies/getNotification/'+$rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('companies.notify_sett', {
          url: '/notify_sett/:id',
          templateUrl: 'app/projects/rcloudsys/companies/notify_sett/notify_sett.html',
          controller: 'NotifySettController',
          data : { title: 'Notification Settings', folded: false },
          resolve : {
            getNotificationSett: function (getServer,$stateParams) {
              return getServer.getData('rcloudsys/companies/getNotification/'+ $stateParams.id);
            }
          },
          authenticate: true
        });
        
  }
]
)
.controller('NotifySettController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer, getNotificationSett, getServer, $stateParams) {
  $rootScope.vm = {};


  $scope.cid = issetnotempty($stateParams.id) ? $stateParams.id : $rootScope.userSession.session.company;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.notify_settData = {
    cmp_id : $scope.cid,
    id:'',
    login_notify:"Login Notification ",
    login_notify_status:'0',
    login_notify_number:'',
    password_notify:"Password Change Notification",
    password_notify_status:'0',
    password_notify_number:''
  };

  $scope.loginNumberRequired = false;
  $scope.passNumberRequired = false;

  $scope.setLoginRequired = function(){
    if($scope.notify_settData.login_notify_status === '1')
    {
      $scope.loginNumberRequired=true;
    }
    else
    {
      $scope.loginNumberRequired=false;
    }
  };

  $scope.setPassRequired = function(){
    if($scope.notify_settData.password_notify_status === '1')
    {
      $scope.passNumberRequired = true;
    }
    else
    {
      $scope.passNumberRequired = false;
    }
  }



  $scope.addNotification = function() {
    postServer.postData('rcloudsys/companies/addNotification',$scope.notify_settData).then(function(data){
      if(data.type="success")
      {
        $state.reload();
      }
    });
  }

  angular.extend($scope.notify_settData,getNotificationSett.result);

});

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.manageserver', {
          url: '/manageserver/:cid',
          templateUrl: 'app/projects/rcloudsys/companies/manageserver/manageserver_companies.html',
          controller: 'ManageServerCompaniesController',
          data : { title: 'Manage Servers', folded: false },
          resolve : {
            getProjects: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/companies/getCompanyServerSettings/'+$stateParams.cid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ManageServerCompaniesController', function($scope, $state, $stateParams, getProjects, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = $stateParams.cid;

    $scope.cmpanyData = getProjects.result;

    $scope.getPackageBox = function(project) {
      var html = '';
      html = '<selectbox quickattrs="listpackages" dynamicdata="yes" dataapiurl="rcloudsys/packages/packagesSB/'+project.project_id+'" size="col-md-4" itemtype="ngform" modelname="project.setting.package"></selectbox>';
      return html;
    };

    $scope.getServerField = function(pid,project) {
      var html = "";
      if(project.projectype === 'commondb')
      {
        html = '';
      }
      else if(project.projectype === 'privatedb')
      {
        // html = '<textbox quickattrs="accesskey" itemtype="ngform" modelname="project.setting.accesskey"></textbox>';
        html = '<selectbox quickattrs="listdatabase" dynamicdata="yes" dataapiurl="rcloudsys/dbschemes/getDBListforCmpProject/'+$scope.cid+'/'+project.project_id+'" itemtype="ngform" modelname="project.setting.accesskey"></selectbox>';
      }
      else if(project.projectype === 'locallinked')
      {
        html += '<div class="row"><checkbox quickattrs="tunnalaccess" itemtype="ngform" title="true" modelname="project.setting.tunnel"></checkbox>';
        html += '<checkbox quickattrs="tunnalmultidb" itemtype="ngform" title="true" modelname="project.setting.tunnelmultidb"></checkbox></div>';
        html += '<div class="row" bind-html-compile="getLocalLinkedFields(project)"></div>';
      }
      else
      {
        html = '';
      }
      return html;
    };

    $scope.getLocalLinkedFields = function(project) {
      if(issetnotempty(project.setting))
      {
        if(project.setting.tunnel === true) {
          if(project.setting.tunnelmultidb === true) {
            var html = "";
            html += '<textbox quickattrs="accesskey" itemtype="ngform" modelname="project.setting.accesskey" size="col-md-6"></textbox>';
            html += '<textbox quickattrs="accesskey" itemtype="ngform" itemid="multidbkey" modelname="project.setting.multidbkey" size="col-md-6"></textbox>';
            return html;
          }
          else
          {
            var html = "";
            html += '<textbox quickattrs="accesskey" itemtype="ngform" modelname="project.setting.accesskey" size="col-md-12"></textbox>';
            return html;
          }
        }
        else
        {
          var html = "";
          html += '<textbox quickattrs="ip" itemtype="ngform" modelname="project.setting.ip"></textbox>';
          html += '<numberbox quickattrs="portno" size="col-md-6" itemtype="ngform" modelname="project.setting.portno"></numberbox>';
          return html;
        }
      }
      else
      {
        var html = "";
        html += '<textbox quickattrs="ip" itemtype="ngform" modelname="project.setting.ip"></textbox>';
        html += '<numberbox quickattrs="portno" size="col-md-6" itemtype="ngform" modelname="project.setting.portno"></numberbox>';
        return html;
      }
    };

    $scope.checkProjectSetup = function() {
      var result = false;
      $scope.cmpanyData.projects_list.forEach(function(p){
        if(p.projectype === 'commondb')
        {
          p.setting.ip = '';
          p.setting.portno = '';
          p.setting.accesskey = '';
          p.setting.multidbkey = '';
          p.setting.tunnel = '';
          p.setting.tunnelmultidb = '';
          if(issetnotempty(p.setting))
          {
            if(!issetnotempty(p.setting.nofuser) || !issetnotempty(p.setting.validtill) || !issetnotempty(p.setting.package))
            {
              result = true;
            }
          }
          else
          {
            result = true;
          }
        }
        else if(p.projectype === 'privatedb')
        {
          p.setting.ip = '';
          p.setting.portno = '';
          p.setting.multidbkey = '';
          p.setting.tunnel = '';
          p.setting.tunnelmultidb = '';
          if(issetnotempty(p.setting))
          {
            if(!issetnotempty(p.setting.nofuser) || !issetnotempty(p.setting.validtill) || !issetnotempty(p.setting.accesskey) || !issetnotempty(p.setting.package))
            {
              result = true;
            }
          }
          else
          {
            result = true;
          }
        }
        else if(p.projectype === 'locallinked')
        {
          if(issetnotempty(p.setting))
          {
            if(!issetnotempty(p.setting.nofuser) || !issetnotempty(p.setting.validtill) || !issetnotempty(p.setting.package))
            {
              result = true;
            }
            else
            {
              if(issetnotempty(p.setting.tunnel))
              {
                if(p.setting.tunnel === true) {
                  if(!issetnotempty(p.setting.accesskey))
                  {
                    result = true;
                  }
                  if(p.setting.tunnelmultidb === true) {
                    if(!issetnotempty(p.setting.multidbkey))
                    {
                      result = true;
                    }
                  }
                }
                else
                {
                  if(!issetnotempty(p.setting.ip) || !issetnotempty(p.setting.portno))
                  {
                    result = true;
                  }
                }
              }
              else
              {
                if(!issetnotempty(p.setting.ip) || !issetnotempty(p.setting.portno))
                {
                  result = true;
                }
              }
            }
          }
          else
          {
            result = true;
          }
        }
        if(result === true)
        {
          p.entry = 'f';
        }
        else
        {
          p.entry = 't';
        }
      });
      return result;
    };

    $scope.saveSetup = function() {    
      var sentData = {};
      sentData.value = angular.toJson($scope.cmpanyData);
      sentData.cid = $stateParams.cid;
      postServer.postData('rcloudsys/companies/updateCompanyServerSettings',sentData).then(function(data){
        if(data.type == "success")
        {                
          $state.go('companies.list');
        }
      });
    };

});
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('users.manage_self', {
            url: '/manage_self/:uid/:pid',
            templateUrl: 'app/projects/rcloudsys/companies/manage_user/manage_user.html',
            controller: 'ManageUserController',
            data: {
              title: 'Manage User',
              folded: false
            },
            resolve: {
              getmanageUserRights: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/users/manageUserRights/' + $stateParams.uid + '/' + $stateParams.pid);
              }
            },
            authenticate: true
          })
          .state('users.manage', {
            url: '/manage/:cid/:uid/:pid',
            templateUrl: 'app/projects/rcloudsys/companies/manage_user/manage_user.html',
            controller: 'ManageUserController',
            data: {
              title: 'Manage User',
              folded: false
            },
            resolve: {
              getmanageUserRights: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/users/manageUserRights/' + $stateParams.uid + '/' + $stateParams.pid);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ManageUserController', function ($scope, $stateParams, $state, $rootScope, toastShow, postServer, $interval, getmanageUserRights, getServer) {
    var vms = this;
    $rootScope.vm = {};

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self = issetnotempty($stateParams.cid) ? false : true;

    $scope.pid = $stateParams.pid;

    $scope.uid = $stateParams.uid;

    $scope.package = getmanageUserRights.result;

    $scope.updatePackage = function () {
      var d = {};
      d.value = angular.toJson($scope.package);
      d.user_id = $scope.uid;
      postServer.postData('rcloudsys/users/updateUserRights', d).then(function (data) {
        $state.reload();
      });
    };

    $scope.isWholeProjectChecked = function () {
      if ($scope.package.project.whole_create || $scope.package.project.whole_edit || $scope.package.project.whole_view || $scope.package.project.whole_delete) {
        if (Boolean($scope.package.project.whole_create) === false && Boolean($scope.package.project.whole_edit) === false && Boolean($scope.package.project.whole_view) === false && Boolean($scope.package.project.whole_delete) === false) {
          $scope.package.project.whole_models = false;
        }
        if (Boolean($scope.package.project.whole_create) === true || Boolean($scope.package.project.whole_edit) === true || Boolean($scope.package.project.whole_view) === true || Boolean($scope.package.project.whole_delete) === true) {
          $scope.package.project.whole_models = true;
        }
      } else {
        $scope.package.project.whole_models = false;
      }
      return $scope.package.project.whole_models;
    };

    $scope.toggleWholeProjectAll = function () {
      if (Boolean($scope.package.project.whole_models)) {
        $scope.package.project.whole_models = false;
        $scope.package.project.whole_create = false;
        $scope.package.project.whole_edit = false;
        $scope.package.project.whole_view = false;
        $scope.package.project.whole_delete = false;
      } else {
        if(Boolean($scope.package.project.cmp_whole_models))
        {
          $scope.package.project.whole_create = Boolean($scope.package.project.cmp_whole_create);
          $scope.package.project.whole_edit = Boolean($scope.package.project.cmp_whole_edit);
          $scope.package.project.whole_view = Boolean($scope.package.project.cmp_whole_view);
          $scope.package.project.whole_delete = Boolean($scope.package.project.cmp_whole_delete);
          if($scope.package.project.whole_create || $scope.package.project.whole_edit || $scope.package.project.whole_view || $scope.package.project.whole_delete)
          {
            $scope.package.project.whole_models = true;
          }
        }
        else
        {
          $scope.package.project.whole_models = true;
          $scope.package.project.whole_create = true;
          $scope.package.project.whole_edit = true;
          $scope.package.project.whole_view = true;
          $scope.package.project.whole_delete = true;
        }
      }
    };
    
    $scope.isDisabledOverAllCreate = function() {
      if(Boolean($scope.package.project.cmp_whole_models))
      {
        if(Boolean($scope.package.project.cmp_whole_create))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };
    
    $scope.isDisabledOverAllEdit = function() {
      if(Boolean($scope.package.project.cmp_whole_models))
      {
        if(Boolean($scope.package.project.cmp_whole_edit))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };
    
    $scope.isDisabledOverAllView = function() {
      if(Boolean($scope.package.project.cmp_whole_models))
      {
        if(Boolean($scope.package.project.cmp_whole_view))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };
    
    $scope.isDisabledOverAllDelete = function() {
      if(Boolean($scope.package.project.cmp_whole_models))
      {
        if(Boolean($scope.package.project.cmp_whole_delete))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };

    $scope.isWholeChecked = function (group) {
      if (Boolean($scope.package.project.whole_models) === true) {
        group.whole_models = true;
        if (Boolean($scope.package.project.whole_create) === true) {
          group.whole_create = true;
        } else {
          group.whole_create = false;
        }

        if (Boolean($scope.package.project.whole_edit) === true) {
          group.whole_edit = true;
        } else {
          group.whole_edit = false;
        }

        if (Boolean($scope.package.project.whole_view) === true) {
          group.whole_view = true;
        } else {
          group.whole_view = false;
        }

        if (Boolean($scope.package.project.whole_delete) === true) {
          group.whole_delete = true;
        } else {
          group.whole_delete = false;
        }
      } else {
        if (group.whole_create || group.whole_edit || group.whole_view || group.whole_delete) {
          if (Boolean(group.whole_create) === false && Boolean(group.whole_edit) === false && Boolean(group.whole_view) === false && Boolean(group.whole_delete) === false) {
            group.whole_models = false;
          }
          if (Boolean(group.whole_create) === true || Boolean(group.whole_edit) === true || Boolean(group.whole_view) === true || Boolean(group.whole_delete) === true) {
            group.whole_models = true;
          }
        } else {
          group.whole_models = false;
        }
        if (Boolean(group.whole_models)) {
          $scope.toggleAll(group);
        }
      }
      return group.whole_models;
    };

    $scope.toggleWholeAll = function (group) {
      if (Boolean(group.whole_models)) {
        group.whole_models = false;
        group.whole_create = false;
        group.whole_edit = false;
        group.whole_view = false;
        group.whole_delete = false;
      } else {
        group.whole_models = true;
        if(Boolean(group.cmp_whole_models))
        {
          group.whole_create = Boolean(group.cmp_whole_create);
          group.whole_edit = Boolean(group.cmp_whole_edit);
          group.whole_view = Boolean(group.cmp_whole_view);
          group.whole_delete = Boolean(group.cmp_whole_delete);
        }
        else
        {
          group.whole_create = true;
          group.whole_edit = true;
          group.whole_view = true;
          group.whole_delete = true;
        }
      }
    };

    $scope.isGroupCreateDisabled = function(group) {
      if(Boolean(group.cmp_whole_models))
      {
        if(Boolean(group.cmp_whole_create))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };
    
    $scope.isGroupEditDisabled = function(group) {
      if(Boolean(group.cmp_whole_models))
      {
        if(Boolean(group.cmp_whole_edit))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };
    
    $scope.isGroupViewDisabled = function(group) {
      if(Boolean(group.cmp_whole_models))
      {
        if(Boolean(group.cmp_whole_view))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };
    
    $scope.isGroupDeleteDisabled = function(group) {
      if(Boolean(group.cmp_whole_models))
      {
        if(Boolean(group.cmp_whole_delete))
        {
          return false;
        }
        else
        {
          return true;
        }
      }
      else
      {
        return false;
      }
    };

    $scope.isIndeterminate = function (group) {
      var i = _.where(group.models, {
        avail: true
      }).concat(_.where(group.models, {
        avail: 1
      }));
      i = i.length > 0 ? i.concat(_.where(group.models, { avail_disabled: true })) : i;
      var r = (i.length !== 0 && Boolean(group.whole_models) === false && i.length !== group.models.length);
      if (r) {
        group.avail = true;
        group.avail_all = false;
      }
      return r;
    };

    $scope.isChecked = function (group) {
      var i = _.where(group.models, {
        avail: true
      }).concat(_.where(group.models, {
        avail: 1
      })).concat(_.where(group.models, {
        avail_disabled: true
      }));
      var r = (i.length === group.models.length) || (Boolean(group.whole_models));
      if (r) {
        group.avail = true;
        group.avail_all = true;
      } else {
        group.avail = (i.length !== 0);
        group.avail_all = false;
      }
      return r;
    };

    $scope.toggleAll = function (group) {
      var i = _.where(group.models, {
        avail: true
      }).concat(_.where(group.models, {
        avail: 1
      })).concat(_.where(group.models, {
        avail_disabled: true
      }));
      if (i.length === group.models.length) {
        group.models.forEach(function (m) {
          m.avail = false;
        });
      } else {
        group.models.forEach(function (m) {
          if (Boolean(Number(m.cmp_avail))) {
            m.avail = true;
          } else {
            m.avail = false;
          }
        });
      }
      $scope.toggleCreateAll(group);
      $scope.toggleEditAll(group);
      $scope.toggleViewAll(group);
      $scope.toggleDeleteAll(group);
    };

    $scope.toggleModel = function (model) {
      if (Boolean(model.avail)) {
        model.avail = false;
        model.m_create = false;
        model.m_edit = false;
        model.m_view = false;
        model.m_delete = false;
      } else {
        if(Boolean(model.cmp_avail))
        {
          model.m_create = Boolean(model.cmp_m_create);
          model.m_edit = Boolean(model.cmp_m_edit);
          model.m_view = Boolean(model.cmp_m_view);
          model.m_delete = Boolean(model.cmp_m_delete);
          if(model.m_create || model.m_edit || model.m_view || model.m_delete)
          {
            model.avail = true;
          }
          else
          {
            model.avail = false;
          }
        }
        else
        {
          model.avail = false;
          model.m_create = false;
          model.m_edit = false;
          model.m_view = false;
          model.m_delete = false;
        }
      }
    };

    $scope.isModelChecked = function (model) {
      if (model.m_create || model.m_edit || model.m_view || model.m_delete) {
        if (Boolean(model.m_create) === false && Boolean(model.m_edit) === false && Boolean(model.m_view) === false && Boolean(model.m_delete) === false) {
          model.avail = false;
        }
        if (Boolean(model.m_create) === true || Boolean(model.m_edit) === true || Boolean(model.m_view) === true || Boolean(model.m_delete) === true) {
          model.avail = true;
        }
      } else {
        model.avail = false;
      }
      return model.avail;
    };



    $scope.checkModel

    //for crud checkboxes
    //for crud checkboxes
    //for crud checkboxes
    //for crud checkboxes
    //for crud checkboxes

    $scope.isCreateIndeterminate = function (group) {
      var i = _.where(group.models, {
        m_create: true
      }).concat(_.where(group.models, {
        m_create: 1
      }));
      i = i.length > 0 ? i.concat(_.where(group.models, { m_create_disabled: true })) : i;
      var r = (i.length !== 0 && Boolean(group.whole_create) === false && i.length !== group.models.length);
      return r;
    };

    $scope.isCreateChecked = function (group) {
      var i = _.where(group.models, {
        m_create: true
      }).concat(_.where(group.models, {
        m_create: 1
      })).concat(_.where(group.models, {
        m_create_disabled: true
      }));
      var r = Boolean(group.whole_models) ? Boolean(group.whole_create) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_create)));
      if (r) {
        group.mg_create = true;
        group.create_all = true;
      } else {
        if (Boolean(group.whole_models)) {
          group.mg_create = Boolean(group.whole_create);
        } else {
          group.mg_create = (i.length !== 0);
        }
        group.create_all = false;
      }
      return r;
    };

    $scope.toggleCreateAll = function (group) {
      var i = _.where(group.models, {
        m_create: true
      }).concat(_.where(group.models, {
        m_create: 1
      })).concat(_.where(group.models, {
        m_create_disabled: true
      }));
      if (i.length === group.models.length) {
        group.models.forEach(function (m) {
          m.m_create = false;
        });
      } else {
        group.models.forEach(function (m) {
          if (Boolean(Number(m.cmp_m_create))) {
            m.m_create = true;
          } else {
            m.m_create = false;
          }
        });
      }
    };

    $scope.toggleCreateModel = function (model) {
      if (Boolean(model.m_create)) {
        model.m_create = false;
      } else {
        model.avail = true;
        model.m_create = true;
      }
    };

    $scope.isEditIndeterminate = function (group) {
      var i = _.where(group.models, {
        m_edit: true
      }).concat(_.where(group.models, {
        m_edit: 1
      }));
      i = i.length > 0 ? i.concat(_.where(group.models, { m_edit_disabled: true })) : i;
      var r = (i.length !== 0 && Boolean(group.whole_edit) === false && i.length !== group.models.length);
      return r;
    };

    $scope.isEditChecked = function (group) {
      var i = _.where(group.models, {
        m_edit: true
      }).concat(_.where(group.models, {
        m_edit: 1
      })).concat(_.where(group.models, {
        m_edit_disabled: true
      }));
      var r = Boolean(group.whole_models) ? Boolean(group.whole_edit) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_edit)));
      if (r) {
        group.mg_edit = true;
        group.edit_all = true;
      } else {
        if (Boolean(group.whole_models)) {
          group.mg_edit = Boolean(group.whole_edit);
        } else {
          group.mg_edit = (i.length !== 0);
        }
        group.edit_all = false;
      }
      return r;
    };

    $scope.toggleEditAll = function (group) {
      var i = _.where(group.models, {
        m_edit: true
      }).concat(_.where(group.models, {
        m_edit: 1
      })).concat(_.where(group.models, {
        m_edit_disabled: true
      }));
      if (i.length === group.models.length) {
        group.models.forEach(function (m) {
          m.m_edit = false;
        });
      } else {
        group.models.forEach(function (m) {
          if (Boolean(Number(m.cmp_m_edit))) {
            m.m_edit = true;
          } else {
            m.m_edit = false;
          }
        });
      }
    };

    $scope.toggleEditModel = function (model) {
      if (Boolean(model.m_edit)) {
        model.m_edit = false;
      } else {
        model.avail = true;
        model.m_edit = true;
      }
    };

    $scope.isViewIndeterminate = function (group) {
      var i = _.where(group.models, {
        m_view: true
      }).concat(_.where(group.models, {
        m_view: 1
      }));
      i = i.length > 0 ? i.concat(_.where(group.models, { m_view_disabled: true })) : i;
      var r = (i.length !== 0 && Boolean(group.whole_view) === false && i.length !== group.models.length);
      return r;
    };

    $scope.isViewChecked = function (group) {
      var i = _.where(group.models, {
        m_view: true
      }).concat(_.where(group.models, {
        m_view: 1
      })).concat(_.where(group.models, {
        m_view_disabled: true
      }));
      var r = Boolean(group.whole_models) ? Boolean(group.whole_view) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_view)));
      if (r) {
        group.mg_view = true;
        group.view_all = true;
      } else {
        if (Boolean(group.whole_models)) {
          group.mg_view = Boolean(group.whole_view);
        } else {
          group.mg_view = (i.length !== 0);
        }
        group.view_all = false;
      }
      return r;
    };

    $scope.toggleViewAll = function (group) {
      var i = _.where(group.models, {
        m_view: true
      }).concat(_.where(group.models, {
        m_view: 1
      })).concat(_.where(group.models, {
        m_view_disabled: true
      }));
      if (i.length === group.models.length) {
        group.models.forEach(function (m) {
          m.m_view = false;
        });
      } else {
        group.models.forEach(function (m) {
          if (Boolean(Number(m.cmp_m_view))) {
            m.m_view = true;
          } else {
            m.m_view = false;
          }
        });
      }
    };

    $scope.toggleViewModel = function (model) {
      if (Boolean(model.m_view)) {
        model.m_view = false;
      } else {
        model.avail = true;
        model.m_view = true;
      }
    };

    $scope.isDeleteIndeterminate = function (group) {
      var i = _.where(group.models, {
        m_delete: true
      }).concat(_.where(group.models, {
        m_delete: 1
      }));
      i = i.length > 0 ? i.concat(_.where(group.models, { m_delete_disabled: true })) : i;
      var r = (i.length !== 0 && Boolean(group.whole_delete) === false && i.length !== group.models.length);
      return r;
    };

    $scope.isDeleteChecked = function (group) {
      var i = _.where(group.models, {
        m_delete: true
      }).concat(_.where(group.models, {
        m_delete: 1
      })).concat(_.where(group.models, {
        m_delete_disabled: true
      }));
      var r = Boolean(group.whole_models) ? Boolean(group.whole_delete) : ((i.length !== 0 && i.length === group.models.length) || (Boolean(group.whole_delete)));
      if (r) {
        group.mg_delete = true;
        group.delete_all = true;
      } else {
        if (Boolean(group.whole_models)) {
          group.mg_delete = Boolean(group.whole_delete);
        } else {
          group.mg_delete = (i.length !== 0);
        }
        group.delete_all = false;
      }
      return r;
    };

    $scope.toggleDeleteAll = function (group) {
      var i = _.where(group.models, {
        m_delete: true
      }).concat(_.where(group.models, {
        m_delete: 1
      })).concat(_.where(group.models, {
        m_delete_disabled: true
      }));
      if (i.length === group.models.length) {
        group.models.forEach(function (m) {
          m.m_delete = false;
        });
      } else {
        group.models.forEach(function (m) {
          if (Boolean(Number(m.cmp_m_delete))) {
            m.m_delete = true;
          } else {
            m.m_delete = false;
          }
        });
      }
    };

    $scope.toggleDeleteModel = function (model) {
      if (Boolean(model.m_delete)) {
        model.m_delete = false;
      } else {
        model.avail = true;
        model.m_delete = true;
      }
    };




    $scope.isModelDisabled = function (model) {
      if (Boolean(Number(model.cmp_avail))) {
        model.avail_disabled = false;
        return false;
      } else {
        model.avail = false;
        model.avail_disabled = true;
        return true;
      }
    };

    $scope.isModelCreateDisabled = function (model) {
      if (Boolean(Number(model.cmp_m_create))) {
        model.m_create_disabled = false;
        return false;
      } else {
        model.m_create = false;
        model.m_create_disabled = true;
        return true;
      }
    };

    $scope.isModelEditDisabled = function (model) {
      if (Boolean(Number(model.cmp_m_edit))) {
        model.m_edit_disabled = false;
        return false;
      } else {
        model.m_edit = false;
        model.m_edit_disabled = true;
        return true;
      }
    };

    $scope.isModelViewDisabled = function (model) {
      if (Boolean(Number(model.cmp_m_view))) {
        model.m_view_disabled = false;
        return false;
      } else {
        model.m_view = false;
        model.m_view_disabled = true;
        return true;
      }
    };

    $scope.isModelDeleteDisabled = function (model) {
      if (Boolean(Number(model.cmp_m_delete))) {
        model.m_delete_disabled = false;
        return false;
      } else {
        model.m_delete = false;
        model.m_delete_disabled = true;
        return true;
      }
    };

    //for crud checkboxes
    //for crud checkboxes
    //for crud checkboxes
    //for crud checkboxes
    //for crud checkboxes


  });
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.manageproject_self', {
          url: '/manageproject_self',
          templateUrl: 'app/projects/rcloudsys/companies/manage_project_companies/manage_project_companies.html',
          controller: 'ManageCompaniesProjectController',
          data : { title: 'Manage Company Project', folded: false },
          resolve : {
            getProjects: function($rootScope,getServer) {
              return getServer.getData('rcloudsys/companies/getCompanyProjcetsInfo/'+$rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('companies.manageproject', {
          url: '/manageproject/:cid',
          templateUrl: 'app/projects/rcloudsys/companies/manage_project_companies/manage_project_companies.html',
          controller: 'ManageCompaniesProjectController',
          data : { title: 'Manage Company Project', folded: false },
          resolve : {
            getProjects: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/companies/getCompanyProjcetsInfo/'+$stateParams.cid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ManageCompaniesProjectController', function($scope, $state, $stateParams, getServer, $mdDialog, getProjects, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self = issetnotempty($stateParams.cid) ? false : true;

    $scope.projectData = getProjects.result;

    var plstable = $('#projectslisttable').DataTable({ 
      'aaData': $scope.projectData.projects,
      'bProcessing': true,
      'ordering': true,
      'stateSave': true,
      'autoWidth': true,
      'aoColumns': [        
        { 'sTitle': 'Name', 'mData': 'name', 'mRender': function ( data, type, full ) {  return '<i class="'+full.icon+'"></i> <b>'+data+'</b> <i>('+full.projectid+')</i>'; }  },
        { 'sTitle': 'Usage', 'mData': 'nofuser', 'mRender': function ( data, type, full ) {  return full.setting.current_user+'/'+full.setting.nofuser+' Users'; }  },
        { 'sTitle': 'Expiry', 'mData': 'validtill', 'mRender': function ( data, type, full ) {  return "<strong><time class='time' datetime='"+full.setting.validtill+"'>"+full.setting.validtill+"</time></strong>";  }}
      ],
      'initComplete': function() {
      }
    });

});
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('companies.manage_project', {
            url: '/manage_project/:cid/:pid',
            templateUrl: 'app/projects/rcloudsys/companies/manage_company/manage_company.html',
            controller: 'ManageCompanyController',
            data: {
              title: 'Manage Company',
              folded: false
            },
            resolve: {
              getmanageCompanyRights: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/companies/getManageCompanyProject/' + $stateParams.cid + '/' + $stateParams.pid);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ManageCompanyController', function ($scope, $stateParams, $state, $rootScope, toastShow, postServer, $interval, getmanageCompanyRights, getServer) {
    var vms = this;
    $rootScope.vm = {};

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self = issetnotempty($stateParams.cid) ? false : true;

    $scope.pid = $stateParams.pid;

    $scope.package = getmanageCompanyRights.result;

    $scope.updateSettings = function() {
      var d = {};
      d.value = angular.toJson($scope.package);
      d.cmp_id = $scope.cid;
      postServer.postData('rcloudsys/companies/updateCompanySettings', d).then(function (data) {
        $state.reload();
      });
    };


  });
(function ()
{

'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('companies.manage_self', {
            url: '/manage_self',
            templateUrl: 'app/projects/rcloudsys/companies/manage_companies/manage_companies.html',
            controller: 'ManageCompaniesController',
            data: {
              title: 'Manage Company',
              folded: false
            },
            resolve: {
              getProjects: function ($stateParams, getServer, $rootScope) {
                return getServer.getData('rcloudsys/companies/getManageCompanyUsers/' + $rootScope.userSession.session.company);
              }
            },
            authenticate: true
          })
          .state('companies.manage', {
            url: '/manage/:cid',
            templateUrl: 'app/projects/rcloudsys/companies/manage_companies/manage_companies.html',
            controller: 'ManageCompaniesController',
            data: {
              title: 'Manage Company',
              folded: false
            },
            resolve: {
              getProjects: function ($stateParams, getServer) {
                return getServer.getData('rcloudsys/companies/getManageCompanyUsers/' + $stateParams.cid);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ManageCompaniesController', function ($scope, $state, $stateParams, getServer, $mdDialog, getProjects, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self = issetnotempty($stateParams.cid) ? false : true;

    $scope.cmpanyData = getProjects.result;

    var plstable = $('#userslisttable').DataTable({
      'aaData': $scope.cmpanyData.users,
      'bProcessing': true,
      'ordering': true,
      'stateSave': true,
      'autoWidth': true,
      'aoColumns': [{
          'sTitle': 'Id',
          'mData': 'id'
        },
        {
          'sTitle': 'Name',
          'mData': 'display_name',
          'mRender': function (data, type, full) {
            var tid = "'" + "#userslisttable" + "'";
            var d = "'" + full.password + "'";
            var nd = "'" + full.emailid + "'";
            var nds = "'" + full.two_fact_code + "'";
            var html = '';
            if(full.id !== '1' && full.id !== 1)
            {
              html += '<a onClick="angular.element(' + tid + ').scope().copyPassword(' + nd + ')"><i class="fa fa-user"></i></a> &nbsp; ';
              html += '<a onClick="angular.element(' + tid + ').scope().copyPassword(' + d + ')"><i class="fa fa-key"></i></a> &nbsp; ';
              if(Boolean(Number(full.twofact_auth)))
              {
                html += '<a onClick="angular.element(' + tid + ').scope().copyPassword(' + nds + ')"><i class="fa fa-magic"></i></a> &nbsp; ';
              }
            }
            html += '<a href="#"><b>' + data + '</b> <i>(' + full.emailid + ')</i></a>';
            return html;
          }
        },
        {
          'orderable': false,
          'sWidth': '10%',
          'sTitle': 'Projects',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var html = "";
            html += "<div class='btn-group'>";
            html += "<button type='button' class='btn btn-primary dropdown-toggle linkdropDown padall2px' data-toggle='dropdown' aria-expanded='false'>";
            html += "Projects ";
            html += "<span class='caret'></span>";
            html += "<span class='sr-only'>Toggle Dropdown</span>";
            html += "</button>";
            html += "<ul class='dropdown-menu' role='menu'>";
            // html += "<li class='divider'></li>";

            full.projects_list.forEach(function(p){
              if($scope.self)
              {
                html += '<li><a tabindex="-1" href="users/manage_self/'+ full.id + '/'+p.project_id+'">'+p.name+'</a></li>';
              }
              else
              {
                html += '<li><a tabindex="-1" href="users/manage/'+ full.company +'/' + full.id + '/'+p.project_id+'">'+p.name+'</a></li>';
              }
            });

            html += "</ul>";
            html += "</div>";
            return html;
          }
        },
        {
          'sTitle': 'Last Active',
          'mData': 'last_login',
          'mRender': function (data, type, full) {
            if (data) {
              return "<strong><time class='time' datetime='" + data + "'>" + data + "</time></strong>";
            } else {
              return "Not Logged In";
            }
          }
        },
        {
          'sTitle': 'Edit',
          'mData': 'id',
          'mRender': function (data, type, full) {
            if($scope.self)
            {
              return '<a class="btn btn-primary padtb2px" href="users/edit_self/' + data + '">Edit</a>';
            }
            else
            {
              return '<a class="btn btn-primary padtb2px" href="users/edit/'+ full.company +'/' + data + '">Edit</a>';
            }
          }
        },
        {
          'sTitle': 'Delete',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'" + "#userslisttable" + "'";
            var d = "'" + data + "','" + full.display_name + "'";
            if($scope.self)
            {
              if($scope.cmpanyData.users.length <= 1)
              {
                return '';
              }
            }
            return '<a onClick="angular.element(' + tid + ').scope().showConfirm(event,' + d + ')" class="btn btn-default padtb2px">Delete</a>';
          }
        }
      ],
      'initComplete': function () {}
    });

    $scope.copyPassword = function (data) {
      $rootScope.copyClipboard(data);
    };

    $scope.showConfirm = function (ev, id, name) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete ' + name + '?')
        .content('All Your Users and Data will be deleted.')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function () {
        getServer.getData('rcloudsys/users/deleteUser/' + id).then(function (data) {
          if (data.type === "success") {
            $state.reload();
          }
        });
      }, function () {
        toastShow.show('info', '', 'leave_user');
      });
    };

  });


})();

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.list_user_log_det_self', {
          url: '/list_user_log_det_self',
          templateUrl: 'app/projects/rcloudsys/companies/login_details/log_details.html',
          controller: 'ListUserLogDetController',
          data : { title: 'List Log Details', folded: false },
          resolve : {
            getcompanyName: function (getServer, $rootScope) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('companies.list_user_log_det', {
          url: '/list_user_log_det/:id/:cid',
          templateUrl: 'app/projects/rcloudsys/companies/login_details/log_details.html',
          controller: 'ListUserLogDetController',
          data : { title: 'List Log Details', folded: false },
          resolve : {
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.cid);
            },
            getUserData: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getUserDet/' + $stateParams.id);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('ListUserLogDetController', function($scope, $state, $compile, $rootScope, $mdDialog, toastShow, postServer,  getServer,getcompanyName, $stateParams,getUserData) {

  $rootScope.vm = {};

  $scope.cid = $stateParams.cid;

  $scope.userInfo = getUserData.result;

  $scope.cmpName = getcompanyName.result;
  
  $scope.session_id =  $stateParams.id ;

  $scope.self_page = issetnotempty($stateParams.id) ? false : true;

  $scope.ViewData = {
    session_id : $scope.session_id, 
  };

  var getVars = issetnotempty($scope.ViewData) ? $rootScope.fromatGetVars($scope.ViewData) : '';
  var url = $rootScope.processPostServerURL() + "rcloudsys/companies/getUserLogDetailsDatatables" + getVars;
  

  var userListConfig = {
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": url,
      "type": "POST",
      "headers": $rootScope.postHeaders,
      "data": function (d) {
        return d.result;
      },
      "xhrFields": {
        "withCredentials": true
      }
    },
    'bProcessing': true,
    'ordering': true,
    'stateSave': false,
    'autowidth': false,
    "bAutoWidth": false,
    "aaSorting": [
      [1, 'desc']
    ],
    'aoColumns': [{
        'sTitle': 'URL',
        'mData': 'url',
        'sWidth': '25%'
      },
      {
        'sTitle': 'Browser',
        'mData': 'browser',
        'sWidth': '25%', 
      },
      {
        'sTitle': 'Version',
        'mData': 'version',
        'sWidth': '25%',
      },
      {
        'sTitle': 'Plat Form',
        'mData': 'platform',
        'sWidth': '25%',
      },
      
    ]
  };

  $scope.inwardDt = $('#userlist').DataTable(userListConfig);
});

'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('companies.list', {
            url: '/list',
            templateUrl: 'app/projects/rcloudsys/companies/list_companies/list_companies.html',
            controller: 'ListCompaniesController',
            data: {
              title: 'Companies List',
              folded: false
            },
            resolve: {
              companiesList: function (getServer) {
                return getServer.getData('rcloudsys/companies/managelistPageCompanies');
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('ListCompaniesController', function ($scope, $state, $compile, $rootScope, $mdDialog, companiesList, toastShow, postServer, getServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.status = '  ';

    $scope.companieslst = companiesList.result;

    var plstable = $('#companieslisttable').DataTable({
      'aaData': $scope.companieslst,
      'bProcessing': true,
      'ordering': true,
      'stateSave': true,
      "order": [[ 0, "desc" ]],
      'aoColumns': [
        {
          'sTitle': 'Status',
          'sWidth': '5%',
          'mData': 'status',
          'mRender': function (data, type, full) {
            if (data === "0") {
              return '<span class="label bg-danger" title="Disabled">Disabled</span>';
            } else {
              return '<span class="label bg-success" title="Enabled">Enabled</span>';
            }
          }
        },
        {
          'sTitle': 'Name',
          'sWidth': '40%',
          'mData': 'name',
          'mRender': function (data, type, full) {
            var settingStatus = '';
            if (full.settingStatus !== true) {
              settingStatus = '<b>*</b>';
            }
            return '<a href="companies/manage/' + full.id + '"><i class="' + full.icon + '"></i> <b>' + data + '</b> <i>(' + full.uniquename + ')</i> ' + settingStatus + ' </a>';
            // return '<a href="companies/manage_self"><i class="' + full.icon + '"></i> <b>' + data + '</b> <i>(' + full.uniquename + ')</i> ' + settingStatus + ' </a>';
          }
        },
        {
          'orderable': false,
          'sWidth': '10%',
          'sTitle': 'Projects',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var html = "";
            html += "<div class='btn-group'>";
            html += "<button type='button' class='btn btn-primary dropdown-toggle linkdropDown padall2px' data-toggle='dropdown' aria-expanded='false'>";
            html += "Projects ";
            html += "<span class='caret'></span>";
            html += "<span class='sr-only'>Toggle Dropdown</span>";
            html += "</button>";
            html += "<ul class='dropdown-menu' role='menu'>";
            // html += "<li class='divider'></li>";

            full.projects_list.forEach(function(p){
               html += '<li class="dropdown-submenu">';
                html += '<a tabindex="-1" href="#"><i class="'+p.icon+'"></i> '+p.name+'</a>';            
                html += '<ul class="dropdown-menu">';
                html += "<li> <a href='#'>No Of Users : "+p.setting.current_user+" / "+p.setting.nofuser+"</a></li>";
                html += "<li> <a href='#'>Valid Till : <strong><time class='time' datetime='"+p.setting.validtill+"'>"+p.setting.validtill+"</time></strong></a></li>";
                html += '<li> <a href="companies/manage_project/' + full.id + '/' + p.project_id + '">Manage Settings</li>';
                html += '</ul>';
                html += '</li>';
            });

            html += "</ul>";
            html += "</div>";
            return html;
          }
        },
        {
          'sTitle': 'Active',
          'sWidth': '5%',
          'mData': 'expired_status',
          'mRender': function (data, type, full) {
            if (data === "1") {
              return '<span class="label bg-danger" title="Expired">Expired</span>';
            } else {
              return '<span class="label bg-success" title="Active">Active</span>';
            }
          }
        },
        {
          'orderable': false,
          'sWidth': '10%',
          'sTitle': '<i class="fa fa-pencil"></i>',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var html = "";
            html += "<div class='btn-group'>";
            html += "<button type='button' class='btn btn-default dropdown-toggle linkdropDown padall2px' data-toggle='dropdown' aria-expanded='false'>";
            html += "Options ";
            html += "<span class='caret'></span>";
            html += "<span class='sr-only'>Toggle Dropdown</span>";
            html += "</button>";
            html += "<ul class='dropdown-menu' role='menu'>";
            // html += "<li class='divider'></li>";.
            html += "<li> <a href='companies/manageproject/" + full.id + "'>Project Lisences</a></li>";

            html += '<li class="dropdown-submenu">';
            html += '<a tabindex="-1" href="#">Configuration</a>';            
            html += '<ul class="dropdown-menu">';
            html += "<li> <a href='companies/manageserver/" + full.id + "'>Server</a></li>";
            html += "<li> <a href='companyreport/list/" + full.id + "'>Reports</a></li>";
            html += "<li> <a href='companies/server_status/" + full.id + "'>Usage Status</a></li>";
            html += "<li> <a href='companies/notify_sett/" + full.id + "'>Notifications</a></li>";
            html += "<li> <a href='companies/list_user_log/" + full.id + "'>Users Log</a></li>";
            html += '</ul>';
            html += '</li>';

            html += '<li class="dropdown-submenu">';
            html += '<a tabindex="-1" href="#">SMS</a>';            
            html += '<ul class="dropdown-menu">';
            html += "<li> <a href='smstemplate/list/" + full.id + "'>Templates</a></li>";
            html += "<li> <a href='communicationscheduler/listsms/" + full.id + "'>Scheduler</a></li>";
            html += "<li> <a href='commhub/sms/" + full.id + "'>Hub</a></li>";
            html += "<li> <a href='smstemplate/list_sms_log/" + full.id + "'>Log</a></li>";
            html += '</ul>';
            html += '</li>';

            html += '<li class="dropdown-submenu">';
            html += '<a tabindex="-1" href="#">Email</a>';            
            html += '<ul class="dropdown-menu">';
            html += "<li> <a href='emailtemplate/list/" + full.id + "'>Templates</a></li>";
            html += "<li> <a href='communicationscheduler/listemail/" + full.id + "'>Scheduler</a></li>";
            html += "<li> <a href='commhub/email/" + full.id + "'>Hub</a></li>";
            html += "<li> <a href='emailtemplate/list_email_log/" + full.id + "'>Log</a></li>";
            html += '</ul>';
            html += '</li>';

            html += "</ul>";
            html += "</div>";
            return html;
          }
        },
        {
          'sTitle': 'Edit',
          'sWidth': '15%',
          'mData': 'id',
          'mRender': function (data, type, full) {
            return '<a class="btn btn-primary padtb2px" href="companies/edit/' + data + '">Edit</a>';
          }
        },
        {
          'sTitle': 'Delete',
          'sWidth': '15%',
          'mData': 'id',
          'mRender': function (data, type, full) {
            var tid = "'" + "#companieslisttable" + "'";
            var d = "'" + data + "','" + full.name + "','" + full.uniquename + "'";
            return '<a onClick="angular.element(' + tid + ').scope().showConfirm(event,' + d + ')" class="btn btn-default padtb2px">Delete</a>';
          }
        }
      ]
    });

    $scope.showConfirm = function (ev, id, name, projectid) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure to delete ' + name + '?')
        .content('All Your Company Users and Data will be deleted.')
        .ok('Yes!')
        .cancel('No')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function () {
        getServer.getData('rcloudsys/companies/deleteCompany/' + id).then(function (data) {
          if (data.type === "success") {
            $state.reload();
          }
        });
      }, function () {
        toastShow.show('info', '', 'leave_company');
      });
    };

  });

'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('users.edit_self', {
          url: '/edit_self/:uid',
          templateUrl: 'app/projects/rcloudsys/companies/edit_user/edit_user.html',
          controller: 'EditUserController',
          data : { title: 'Edit User', folded: false },
          resolve : {
            getUser: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/users/getUser/'+$stateParams.uid);
            }
          },
          authenticate: true
        })
        .state('users.edit', {
          url: '/edit/:cid/:uid',
          templateUrl: 'app/projects/rcloudsys/companies/edit_user/edit_user.html',
          controller: 'EditUserController',
          data : { title: 'Edit User', folded: false },
          resolve : {
            getUser: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/users/getUser/'+$stateParams.uid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EditUserController', function($scope, $stateParams, getUser, $state, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.uid = $stateParams.uid;

    $scope.editUserData = getUser.result;

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self = issetnotempty($stateParams.cid) ? false : true;

    $scope.projectBox = function() {
      var html = '';
      html = '<selectbox quickattrs="listprojects" dataapiurl="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+'" jsonposturlcheck="rcloudsys/users/checkProjectUsage/'+$scope.cid+'/'+$scope.uid+'"></selectbox>';
      return html;
    };

    $scope.updateUser = function() {
      var d = {};
      angular.copy($scope.editUserData,d);
      d.emailid = d.username;
      d.company = $scope.cid;
      d.projects = $rootScope.processMultiSelectValue(d.projects);
      postServer.postData('rcloudsys/users/editUser/'+$scope.uid,d).then(function(data){
        if(data.type="success")
        {
          $scope.addUserData = {};
          $state.go('companies.manage', {'cid': $scope.cid});
        }
      });
    }

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.add', {
          url: '/add',
          templateUrl: 'app/projects/rcloudsys/companies/add_companies/add_companies.html',
          controller: 'AddCompaniesController',
          data : { title: 'Create Company', folded: false },
          resolve : {},
          authenticate: true
        });
  }
]
)
.controller('AddCompaniesController', function($scope, $state, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.addcompanyData = {};

    $scope.addCompany = function() {
      $scope.addcompanyData.projects = $rootScope.processMultiSelectValue($scope.addcompanyData.projects);
      postServer.postData('rcloudsys/companies/addCompany',$scope.addcompanyData).then(function(data){
        if(data.type="success")
        {
          $scope.addcompanyData = {};
          $state.transitionTo('companies.list');
        }
      });
    }

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('companies.edit', {
          url: '/edit/:cid',
          templateUrl: 'app/projects/rcloudsys/companies/edit_companies/edit_companies.html',
          controller: 'EditCompaniesController',
          data : { title: 'Edit Company', folded: false },
          resolve : {
            getCompany: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/companies/getCompany/'+$stateParams.cid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('EditCompaniesController', function($scope, $state, $rootScope, $stateParams, getCompany, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.id = $stateParams.cid;

    $scope.editcompanyData = getCompany.result;

    $scope.updateCompany = function () {
      var d = angular.copy($scope.editcompanyData,d);
      d.projects = $rootScope.processMultiSelectValue(d.projects);
      d = $rootScope.removeObjAttrs(d,'projectids,valid_till_picker,project_settings,last_updated,created_time,expired_status,final_status,project_modules,final_status,expired_status,wbs_fields');
      d.id = $scope.id;
      // console.log(d);
      postServer.postData('rcloudsys/companies/editCompany',d).then(function(data){
        if(data.type="success")
        {
          $state.transitionTo('companies.list');
        }
      });
    };

});
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('users.add_self', {
          url: '/add_self',
          templateUrl: 'app/projects/rcloudsys/companies/add_user/add_user.html',
          controller: 'AddUserController',
          data : { title: 'Create User', folded: false },
          resolve : {
            getCompany: function($rootScope,getServer) {
              return getServer.getData('rcloudsys/companies/getCompany/'+$rootScope.userSession.session.company);
            }
          },
          authenticate: true
        })
        .state('users.add', {
          url: '/add/:cid',
          templateUrl: 'app/projects/rcloudsys/companies/add_user/add_user.html',
          controller: 'AddUserController',
          data : { title: 'Create User', folded: false },
          resolve : {
            getCompany: function($stateParams,getServer) {
              return getServer.getData('rcloudsys/companies/getCompany/'+$stateParams.cid);
            }
          },
          authenticate: true
        });
  }
]
)
.controller('AddUserController', function($scope, $stateParams, getCompany, $state, $rootScope, toastShow, postServer) {
    var vms = this;

    $rootScope.vm = {};

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self = issetnotempty($stateParams.cid) ? false : true;

    $scope.companyData = getCompany.result;

    $scope.addUserData = {};

    $scope.projectBox = function() {
      var html = '';
      html = '<selectbox quickattrs="listprojects" dataapiurl="rcloudsys/companies/getCmpConfDoneProjects/'+$scope.cid+'" jsonposturlcheck="rcloudsys/users/checkProjectUsage/'+$scope.cid+'"></selectbox>';
      return html;
    };

    $scope.createUser = function() {
      var d = {};
      angular.copy($scope.addUserData,d);
      d.emailid = d.username;
      d.company = $scope.cid;
      d.projects = $rootScope.processMultiSelectValue(d.projects);
      postServer.postData('rcloudsys/users/addUser',d).then(function(data){
        if(data.type="success")
        {
          $scope.addUserData = {};
          $state.go('companies.manage', {'cid': $scope.cid});
        }
      });
    }

});
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('commhub.sms_self', {
            url: '/sms_self',
            templateUrl: 'app/projects/rcloudsys/commhub/sms/sms.html',
            controller: 'CommHubSmsController',
            data: {
              title: 'Sms Hub',
              folded: false
            },
            resolve: {
              getSetts: function (getServer, $rootScope) {
                console.log('test');
                return getServer.getData('rcloudsys/hub/getsmshubsettings/' + $rootScope.userSession.session.company);
              },
              getcompanyName: function (getServer, $rootScope) {
                return getServer.getData('rcloudsys/companies/getCompanyname/' + $rootScope.userSession.session.company);
              }
            },
            authenticate: true
          })
          .state('commhub.sms', {
            url: '/sms/:cid',
            templateUrl: 'app/projects/rcloudsys/commhub/sms/sms.html',
            controller: 'CommHubSmsController',
            data: {
              title: 'Sms Hub',
              folded: false
            },
            resolve: {
              getSetts: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/hub/getsmshubsettings/' + $stateParams.cid);
              },
              getcompanyName: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.cid);
              }
            },
            authenticate: true
          });
      }
    ]
  )
  .controller('CommHubSmsController', function ($scope, $stateParams, $state, $rootScope, toastShow, postServer, getServer, $timeout,getcompanyName, getSetts) {
    var vms = this;
    $scope.cmpName = getcompanyName.result;

    $scope.smsSettingsData = {};

    $scope.checkStatus = false;

    $scope.availableBalance = 0;

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;
    
    $scope.self_page = issetnotempty($stateParams.cid) ? false : true;
    

    if (Number(getSetts.result.sms_enabled) === 1) {
      $scope.checkStatus = true;
      $scope.smsSettingsData = getSetts.result;
      getServer.getData('rcloudsys/hub/getSmsAccountBalance/' + $scope.cid).then(function (data) {
        $scope.availableBalance = round(Number(data.result),0);
      });
    } else {
      $scope.smsSettingsData.sms_enabled = '0';
    }

    $scope.getSettingsBox = function () {
      if ($scope.smsSettingsData.sms_enabled === '1') {
        return '<selectbox quickattrs="sms_server" modelname="sms_server"></selectbox><textbox quickattrs="smskey" modelname="sms_apikey"></textbox><textbox quickattrs="smssenderid" modelname="sms_senderid"></textbox>';
      } else {
        return '';
      }
    };

    $scope.saveSMSHubSettings = function () {      
      postServer.postData('rcloudsys/hub/savesmshubsettings/' + $scope.cid, $scope.smsSettingsData).then(function (data) {
        if (data.type === 'success') {
          $state.reload();
        }
      });
    };

    $scope.smsHubData = {};

    $scope.smsHubSettings = function () {
      getServer.getData('rcloudsys/hub/sendSms/' + $scope.cid + '/' + $scope.smsHubData.companymobile + '/' + $scope.smsHubData.smskey).then(function (data) {
        toastShow.show('info', data.result.ErrorMessage, '');
        $scope.smsHubData.companymobile = '';
        $scope.smsHubData.smskey = '';
      });
    };

  });
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('commhub.email_self', {
          url: '/email_self',
          templateUrl: 'app/projects/rcloudsys/commhub/email/email.html',
          controller: 'CommHubEmailController',
          data : { title: 'Email Hub', folded: false },
          resolve : {
            getSetts: function (getServer,$rootScope) {
              return getServer.getData('rcloudsys/hub/getemailhubsettings/'+$rootScope.userSession.session.company);
            },
            getcompanyName: function (getServer, $rootScope) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $rootScope.userSession.session.company);
            }
          },
          authenticate: true
      })
      .state('commhub.email', {
          url: '/email/:cid',
          templateUrl: 'app/projects/rcloudsys/commhub/email/email.html',
          controller: 'CommHubEmailController',
          data : { title: 'Email Hub', folded: false },
          resolve : {
            getSetts: function (getServer,$stateParams) {
              return getServer.getData('rcloudsys/hub/getemailhubsettings/'+$stateParams.cid);
            },
            getcompanyName: function (getServer, $stateParams) {
              return getServer.getData('rcloudsys/companies/getCompanyname/' + $stateParams.cid);
            }
          },
          authenticate: true
      });
  }
]
)
.controller('CommHubEmailController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, getServer, $timeout,getcompanyName, getSetts) {
    var vms = this;

    $scope.cmpName = getcompanyName.result;

    $scope.emailSettingsData = {};

    $scope.cid = issetnotempty($stateParams.cid) ? $stateParams.cid : $rootScope.userSession.session.company;

    $scope.self_page = issetnotempty($stateParams.cid) ? false : true;

    $scope.checkStatus = false;

    $scope.totalCount = 0;
    $scope.usedCount = 0;

    if(Number(getSetts.result.mail_enabled) === 1)
    {
      $scope.checkStatus = true;
      $scope.emailSettingsData = getSetts.result;
      getServer.getData('rcloudsys/hub/getEmailAccountBalance/'+$scope.cid).then(function(data){
        $scope.totalCount = Number(data.result.totalCount);
        $scope.usedCount = Number(data.result.usedCount);
      });
    }
    else
    {
      $scope.emailSettingsData.mail_enabled = '0';
    }

    $scope.getSettingsBox = function() {
      if(Number($scope.emailSettingsData.mail_enabled) === 1)
      {
        var html = '';

        html += '<div class="row">';
        html += '<selectbox quickattrs="email_server" modelname="email_server"></selectbox>';
        html += '</div>';

        if($scope.emailSettingsData.email_server === 'rcloudmail')
        {
          html += '<div class="row">';
          html += '<textbox quickattrs="emailsender" modelname="mail_sender"></textbox>';
          html += '<textbox quickattrs="emailreplayto" modelname="mail_replayto"></textbox>';
          html += '</div>';
        }
        else if($scope.emailSettingsData.email_server === 'smtp' || $scope.emailSettingsData.email_server === 'rcloudsmtp')
        {
          html += '<div class="row">';
          html += '<textbox quickattrs="emailsender_name" modelname="mail_sender_name"></textbox>';
          html += '<textbox quickattrs="emailsender" modelname="mail_sender"></textbox>';
          html += '</div>';

          html += '<div class="row">';
          html += '<textbox quickattrs="emailreplayto_name" modelname="mail_replayto_name"></textbox>';
          html += '<textbox quickattrs="emailreplayto" modelname="mail_replayto"></textbox>';
          html += '</div>';

          html += '<div class="row">';
          html += '<selectbox quickattrs="smtp_auth" modelname="smtp_auth" size="col-md-4"></selectbox>';
          html += '<textbox quickattrs="smtp_host" modelname="smtp_host" size="col-md-4"></textbox>';
          html += '<numberbox quickattrs="smtp_port" modelname="smtp_port" size="col-md-2"></numberbox>';
          html += '<selectbox quickattrs="smtp_auth_type" modelname="smtp_auth_type" size="col-md-2"></selectbox>';
          html += '</div>';

          if(Number($scope.emailSettingsData.smtp_auth) === 1)
          {
            html += '<div class="row">';
            html += '<textbox quickattrs="smtp_username" modelname="smtp_username" size="col-md-4"></textbox>';
            html += '<textbox quickattrs="smtp_password" modelname="smtp_password" size="col-md-4"></textbox>';
            html += '</div>';
          }

        }

        return html;
      }
      else
      {
        return '';
      }
    };

    $scope.saveEmailHubSettings = function() {
      postServer.postData('rcloudsys/hub/saveemailhubsettings/'+$scope.cid,$scope.emailSettingsData).then(function(data){
        if(data.type === 'success')
        {
          $state.reload();
        }
      });
    };

    $scope.showMailDebug = false;
    $scope.mailDebugData = {
      msg: 'No Data!'
    };

    $scope.emailHubTestSettings = function() {
      postServer.postData('rcloudsys/hub/sendTestConf/'+$scope.cid,$scope.emailSettingsData).then(function(data){
        $scope.mailDebugData = data.result;
        $scope.showMailDebug = true;
      });
    };

    $scope.emailHubData = {};

    $scope.emailHubSettings = function() {
      postServer.postData('rcloudsys/hub/sendEmail/'+$scope.cid,$scope.emailHubData).then(function(data){
        toastShow.show('info',data.result,'');
        $scope.emailHubData.toaddress = '';
        $scope.emailHubData.subject = '';
        $scope.emailHubData.mail = '';
      });
    };

}); 

(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "displayname" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "displayname",
                "modelname": "display_name",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4"
            },
            "mobileno" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "mobileno",
                "modelname": "mobileno",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "12",
                "maxlength": "12",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
             "loginEmail" : {
                "type":"email",
                "size": "col-md-12",
                "itemid": "loginEmail",
                "modelname": "username",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "lowercase": "ture",
                "nawords": "test,demo"
            },
             "loginPassword" : {
                "type":"password",
                "size": "col-md-12",
                "itemid": "loginPassword",
                "modelname": "password",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/="
            },
            "twofactcode" : {
               "type":"text",
               "size": "col-md-12",
               "itemid": "twofactcode",
               "modelname": "twofactcode",
               "tlate": "commonForms.textbox",
               "pattern": "/^[0-9]{6}$/"
           }

        };

        var fbuilderSelectbox = {
            "gender" : {
                "size": "col-md-12",
                "itemid": "gender",
                "modelname": "gender",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Male", "value":"m" },{ "name":"Female", "value":"f" } ]'
            },
             "toastposition" : {
                "size": "col-md-6",
                "itemid": "toastposition",
                "modelname": "toastData.position",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Bottom Right", "value":"bottom right" },{ "name":"Bottom Left", "value":"bottom left" },{ "name":"Top Right", "value":"top right" },{ "name":"Top Left", "value":"top left" } ]'
            },
            "datepickerSetting" : {
                "size": "col-md-6",
                "itemid": "datepicker",
                "modelname": "datePicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in datepickerformats track by option.format"
            },
            "timepickerSetting" : {
                "size": "col-md-6",
                "itemid": "timepicker",
                "modelname": "timePicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in timepickerformats track by option.format"
            },
            "monthpickerSetting" : {
                "size": "col-md-6",
                "itemid": "monthpicker",
                "modelname": "monthPicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in monthpickerformats track by option.format"
            },
            "twofact_auth" : {
                "size": "col-md-12",
                "itemid": "twofact_auth",
                "modelname": "twofact_auth",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Enabled", "value":"1" },{ "name":"Disabled", "value":"0" } ]'
            }
        };
        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "toasttiming" : {
                "size": "col-md-6",
                "itemid": "toasttiming",
                "modelname": "toastData.delay",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "100",
                "minnumber": "3000",
                "maxnumber": "15000",
                "calculator": "false"
            },
            "screenlocktiming" : {
                "size": "col-md-6",
                "itemid": "screenlocktiming",
                "modelname": "screenLockTime",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1",
                "maxnumber": "15",
                "calculator": "false"
            },
            "autoLogoutTime" : {
                "size": "col-md-6",
                "itemid": "autoLogoutTime",
                "modelname": "autoLogoutMin",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "15",
                "maxnumber": "120",
                "calculator": "false"
            }
        };
        var fbuilderDatebox = {
            "dob" : {
                "size":"col-md-6",
                "itemid":"dob",
                "modelname":"dob",
                "tlate":"commonForms.datebox",
                "required":"true",
                "picker":"date"
            }
        };

        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,   $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('manage', {
              abstract: true,
              url: '/manage',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

        $translatePartialLoaderProvider.addPart('app/views/rcloud/manage');
      }
    ]
  );
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider,  MODULE_CONFIG ) {
    $stateProvider
        /* Auth Page List*/
        .state('app.home', {
          url: '/home',
          templateUrl: 'app/views/rcloud/home/home.html',
          controller: 'HomeController',
          data : { title: 'Home', folded: false, bgclass: 'homebg' },
          resolve : { },
          authenticate: true
        });
  }
]
)
.controller('HomeController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, getServer, $timeout) {
    var vms = this;

    $rootScope.vm = {};

    $scope.selected_projectid = '';

    $scope.allowedprojects = $rootScope.userSession.session.projects;

    $scope.getAllowedProjects = function() {
      var d = [];
      $scope.allowedprojects.forEach(function(dr){
        if($rootScope.isMobileAppUser === true)
        {
          var url = dr.project_main_url;
          if(url.indexOf(location.host) >= 0)
          {
            d.push(dr);
          }
        }
        else
        {
          d.push(dr);
        }
      });
      return d;
    };

    $rootScope.loadDominProject();

    $scope.selectProject = function(project) {

      console.log(project)
      
      var id = project.project_id;
      var pid = project.projectid;
      var p = project;
      var from_page = window.location.host.toString().indexOf('localhost') || (project.project_main_url.toString().indexOf(window.location.host) || project.project_other_url.toString().indexOf(window.location.host));
      var project_fw = project.project_fw;

      $rootScope.menu_settings = [];
      
      var pr = {
        projectid: project.projectid,
        project_fw: project.project_fw,
        project_main_url: project.project_main_url,
        project_other_url: project.project_other_url
      };
      $scope.selected_projectid = project.projectid;
      sessionStorage.rcloud_project = JSON.stringify(pr);

      if($scope.isProjectDisabled(p))
      {
        toastShow.show('warning','Project Expired!','');
      }
      else
      {
        if(($rootScope.loadedProject !== pid && $rootScope.loadedProject !== 'all' && Number(from_page) === 1) || project_fw === 'ts')
        {
          window.location = p.project_main_url;
        }
        else
        {
          getServer.getData('rcloudsys/login/selectProject/0/'+pid).then(function(data){
            if(data.msg.type === 'warning')
            {
              $rootScope.menu_settings = [];
            }
            else
            {
              setTimeout(function(){
                $('.picto').toggleClass('picOpen');
              },1500);
            }
          });
        }
      }
    };

    $scope.isProjectDisabled = function(p) {
      if(p !== false)
      {
        return Boolean(Number(p.expired));
      }
      else
      {
        return false;
      }
    };

    $scope.ifSelected = function(p) {
      if($scope.selected_projectid === p.projectid)
      {
        return true;
      }
      else
      {
        return false;
      }
    };


    if(sessionStorage.rcloud_project !== undefined)
    {
        $scope.selectProject(JSON.parse(sessionStorage.rcloud_project));
    }
    else
    {
      $rootScope.loadDominProject();
    }

});
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider',
      function ($stateProvider, $urlRouterProvider, $locationProvider, MODULE_CONFIG) {
        $stateProvider
          /* Auth Page List*/
          .state('auth.signin', {
            url: '/signin',
            data: {
              title: 'Signin',
              folded: false
            },
            controller: 'SigninController',
            templateUrl: 'app/views/auth/signin/signin.html',
            notAuthenticate: true,
            resolve: {}
          });
      }
    ]
  )
  .controller('SigninController', ['$scope', '$translate', '$localStorage', '$window', '$document', '$location', '$interval', '$rootScope', '$timeout', '$mdSidenav', '$mdColorPalette', '$anchorScroll', '$http', 'postServer', 'getServer', '$mdToast', 'toastShow',
    function ($scope, $translate, $localStorage, $window, $document, $location, $rootScope, $timeout, $interval, $mdSidenav, $mdColorPalette, $anchorScroll, $http, postServer, getServer, $mdToast, toastShow) {


      var vms = this;

      $scope.loginFormData = {};

      var listSysStatus = [
        "Downloading App Files",
        "Starting Translate Engine",
        "Starting rCloud FW",
        "Starting rCloud Forms",
        "Caching Application Files",
        "Checking for Update",
        "Application Started",
      ];
      var x = document.referrer;
      $scope.showLoading = false;
      $rootScope.loadedFromDomain = '';
      if((x.indexOf('rcloudsoftwares.com') >= 0 || x.indexOf('rcloudsoft.app') >= 0) && x.indexOf(window.location.hostname) < 0 && $rootScope.loadedFromDomain !== window.location.hostname)
      {
        $rootScope.loadedFromDomain = window.location.hostname;
        if($rootScope.loadedProject !== false && $rootScope.loadedProject !== 'login' && $rootScope.loadedProject !== 'all')
        {
          $scope.showLoading = true;
          setTimeout(function(){
            $scope.showLoading = false;
          },5000);
        }
      }

      if($rootScope.signinTimeoutDone)
      {
        // console.log($(".rcloud-splash-screen-load"));
        setTimeout(function(){
          // console.log($(".rcloud-splash-screen-load"));
          $(".rcloud-splash-screen-load").fadeOut("slow");
          $rootScope.signinTimeoutDone = true;
        },1000);
        $scope.appStatus = 'Checking for Update';
      }
      else
      {
        var posMsg = 0;
        $scope.appStatus = listSysStatus[posMsg];

        setInterval(function(){
          posMsg = listSysStatus.length <= (posMsg + 1) ? listSysStatus.length - 1 : posMsg + 1;
          // console.log(posMsg);
          $scope.appStatus = listSysStatus[posMsg];
        },700);

        getServer.getData('rcloudsys/login/isLogin').then(function(data){
          // console.log(data);
          // setTimeout(function(){
          //   $(".rcloud-splash-screen-load").fadeOut("slow");
          //   $rootScope.signinTimeoutDone = true;
          // },2500);
          $scope.checkSyncStart();
        });
      }

      $scope.checkSyncStart = function() {
        var inter = setTimeout(function(){
          if(issetnotempty(sessionStorage.syncStarted))
          {
            // console.log('cleared loading');            
            setTimeout(function(){
              $(".rcloud-splash-screen-load").fadeOut("slow");
              $rootScope.signinTimeoutDone = true;
            },1000);
            clearInterval(inter);
          }
        },500);
      };

      $scope.showTwoFact = false;

      $scope.doLogin = function () {
        postServer.postData('rcloudsys/login/index/1', $scope.loginFormData).then(function (data) {
          if (data.msg.type === 'success') {
            if(data.result === 'two_step_atuh_req')
            {
              $scope.showTwoFact = true;
            }
            else
            {
              if(!issetnotempty($rootScope.userSession))
              {
                $rootScope.userSession = {};
                $rootScope.puserSession = {};
              }
              $rootScope.userSession.data = true;
              $rootScope.userSession.session = data.rc_session;
              $scope.vm.loginformData = {};
              if(issetnotempty($rootScope.defaultSetup))
              {
                $location.path($rootScope.defaultSetup.homePage);
              }
              else
              {
                $location.path('/app/home');
              }
            }
          }
        });
      }

    }
  ]);
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider,  MODULE_CONFIG ) {
    $stateProvider
        /* Auth Page List*/
        .state('auth.lockme', {
          url: '/lockme',
          data : { title: 'Locked', folded: false },
          controller: 'LockmeController',
          templateUrl: 'app/views/auth/lockme/lockme.html',
          authenticate: true
        });
  }
]
)
.controller('LockmeController', ['$scope', '$translate', '$localStorage', '$window', '$document', '$location', '$rootScope', '$timeout', '$mdSidenav', '$mdColorPalette', '$anchorScroll', '$http', 'postServer', 'getServer', '$mdToast', 'toastShow',
    function (             $scope,   $translate,   $localStorage,   $window,   $document,   $location,   $rootScope,   $timeout,   $mdSidenav,   $mdColorPalette,   $anchorScroll, $http, postServer, getServer, $mdToast, toastShow) {


      var vms = this;

      $rootScope.vm = {};

      /*lock me */



    }
  ]);


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider,  MODULE_CONFIG ) {
    $stateProvider
        /* Auth Page List*/
        .state('load.app', {
          url: '/app',
          data : { title: 'Loading App', folded: false },
          controller: 'LoadAppController',
          templateUrl: 'app/views/auth/load/load.html',
          notAuthenticate: true,
          resolve: {
          }
        });
  }
]
)
.controller('LoadAppController', ['$scope', '$translate', '$localStorage', '$window', '$document', '$location', '$rootScope', '$timeout', '$mdSidenav', '$mdColorPalette', '$anchorScroll', '$http', 'postServer', 'getServer', '$mdToast', 'toastShow', 
    function ($scope,   $translate,   $localStorage,   $window,   $document,   $location,   $rootScope,   $timeout,   $mdSidenav,   $mdColorPalette,   $anchorScroll, $http, postServer, getServer, $mdToast, toastShow) {


      var vms = this;

    }
  ]);


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider,  MODULE_CONFIG ) {
    $stateProvider
        /* Auth Page List*/
        .state('auth.forgot-password', {
          url: '/forgot-password',
          controller: 'ForgotController',
          data : { title: 'Forgot Password', folded: false },
          templateUrl: 'app/views/auth/forgot-password/forgot-password.html',
          notAuthenticate: true
        });
  }
]
)
.controller('ForgotController', ['$scope', '$translate', '$localStorage', '$window', '$document', '$location', '$rootScope', '$timeout', '$mdSidenav', '$mdColorPalette', '$anchorScroll', '$http', 'postServer', 'getServer', '$mdToast', 'toastShow',
    function (             $scope,   $translate,   $localStorage,   $window,   $document,   $location,   $rootScope,   $timeout,   $mdSidenav,   $mdColorPalette,   $anchorScroll, $http, postServer, getServer, $mdToast, toastShow) {


      var vms = this;

      $rootScope.vm = {};

      /*forget password */

      $rootScope.vm.fogetPassword = true;
      $rootScope.vm.resetPassword = false;
      $rootScope.vm.resetNewPassword = false;
      $rootScope.vm.resetPasswordSuccess = false;
      $rootScope.vm.resetPassResentOTP = false;
      $rootScope.vm.resetPassResentOTPLimit = false;
      $rootScope.vm.fpass = {};
      $rootScope.vm.fpass.resentLimit = 3;
      $rootScope.vm.fpass.resentCount = 1;

      $scope.forgetPasswordData = {};      

      $scope.doForgetPassword = function() {
        postServer.postData('rcloudsys/login/forget_password',$scope.forgetPasswordData).then(function(data){
            if(data.msg.type == "success")
            {
              $rootScope.vm.fogetPassword = false;
              $rootScope.vm.resetPassword = true;
              $rootScope.vm.fpass.mobile = data.result.user_info.mobileno;
              enable_resend_otp();
            }
        });
      }

      $scope.resetData = {};    

      $scope.doResetPassword = function() {
        postServer.postData('rcloudsys/login/verify_forget_password',$scope.resetData).then(function(data){
            if(data.msg.type == "success")
            {
              $rootScope.vm.fogetPassword = false;
              $rootScope.vm.resetPassword = false;
              $rootScope.vm.resetNewPassword = true;
            }
        });
      }

      $scope.resetPasswordData = {};

      $scope.doResetNewPassword = function() {
        postServer.postData('rcloudsys/login/reset_user_password',$scope.resetPasswordData).then(function(data){
            if(data.msg.type == "success")
            {
              $rootScope.vm.fogetPassword = false;
              $rootScope.vm.resetPassword = false;
              $rootScope.vm.resetNewPassword = false;
              $rootScope.vm.resetPasswordSuccess = true;
            }
            else
            {
              $scope.resetPasswordData = {};
            }
        });
      }

      $scope.doResendOTP = function() {
        if($rootScope.vm.fpass.resentLimit < $rootScope.vm.fpass.resentCount)
        {
          $rootScope.vm.resetPassResentOTP = false;
          $rootScope.vm.resetPassResentOTPLimit = true;
        }
        else
        {
          $scope.doForgetPassword();
          $rootScope.vm.resetPassResentOTP = false;
          $rootScope.vm.fpass.resentCount += 1;
          enable_resend_otp();
        }
      }

      function enable_resend_otp()
      {
        $timeout(function() {
          $rootScope.vm.resetPassResentOTP = true;
        }, 60000);
      }

    }
  ]);


(function($) {
  'use strict';

  $.fn.numericInput = function(options) {

  	this.each(function(){

  		$(this).blur(function(event) {
  			/* Act on the event */
        	var decimal = options.decimal;
        	var value = $(this).val() ? $(this).val() : 0;
        	var rvalue = parseFloat(value).toFixed(decimal);

        	$(this).val(rvalue);
        	$(this).change();
  		});

      $(this).change(function(event) {
        /* Act on the event */
          var decimal = options.decimal;
          var value = $(this).val() ? $(this).val() : 0;
          var rvalue = parseFloat(value).toFixed(decimal);

          $(this).val(rvalue);
      });

    });
  };


  $.fn.formCalculate = function(options) {

    function getVal(id)
    {
      return $('#'+id).val();
    }

    this.each(function(){

      $(this).blur(function(event) {
        /* Act on the event */
          var formula = options.formula;
          var ar = formula.split(',');
          var total = getVal(formula);
          $(this).val(total);
      });

    });
  };

})(jQuery);

(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $document)
    {        

        $rootScope.disabledKeys = [91,112,113,114,115,116,117,118,119,120,121,122,123];
        $rootScope.disabledCtrlKeys = [83,70,9,72,74];

        var array = $rootScope.disabledKeys;
        var ctrlarray = $rootScope.disabledCtrlKeys;
        function check(key)
        {
            var r = false;
            for(var i=0; i<array.length; i++)
            {
                if(array[i] === key)
                {
                    r = true;
                }
            }
            return r;
        }
        function checkCtrl(key)
        {
            var r = false;
            for(var i=0; i<ctrlarray.length; i++)
            {
                if(ctrlarray[i] === key)
                {
                    r = true;
                }
            }
            return r;
        }

        $document.bind('keydown', function (e) {

            var charCode = e.which || e.keyCode;

            var c = e.ctrlKey ? 'ctrl+' : '';
            var s = e.altKey ? 'alt+' : '';
            var a = e.shiftKey ? 'shift+' : '';

            $rootScope.shortCutFunction(c+s+a+charCode);


            if (check(charCode))
            {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            if(e.ctrlKey && (checkCtrl(charCode))) {
                $rootScope.shortCutFunction('ctrl+'+charCode);
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

        });


    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .directive('networkDetector', networkDetector)
        .run(networkDetectorRun);

    /** @ngInject */

    function networkDetector()
    {
        var data = {
            restrict : "EA",
            replace : true,
            template : genrateBody,
        };

        function genrateBody(e,a)
        {
            var html = "";
            html += '<div id="networkdetector">';
            html += '<div ng-if="networkStatus.networkDisconnected" class="network-disconnected network-popup animated infinite bounce"><i class="fa fa-cloud network-popup-icon" aria-hidden="true"></i><span class="network-popup-msg">Network Disconnected</span></div>';
            html += '<div ng-if="networkStatus.networkConnectedSession" class="network-connectedsession network-popup animated infinite bounce"><i class="fa fa-clock-o network-popup-icon" aria-hidden="true"></i><span class="network-popup-msg">Looking for a Session</span></div>';
            html += '<div style="width: 400px;" ng-if="networkStatus.networkSessionUpdating" class="network-connectedsession network-popup animated infinite bounce"><i class="fa fa-download network-popup-icon" aria-hidden="true"></i><span class="network-popup-msg">Application Updating!... Wait a moment!</span></div>';
            html += '</div>';
            return html;
        }

        return data;
    }

    function networkDetectorRun($rootScope, $state, getServer, toastShow, $timeout, $location, $interval, $window, $mdDialog)
    {
        $rootScope.networkStatus = {
            networkDisconnected : false,
            blurBlock : false,
            blurClass : '',
            networkConnectedSession : false,
        };
        function detectNetwork()
        {
            if(!navigator.onLine && $rootScope.projectInfo.runningMode !== 'development')
            {
                $rootScope.networkStatus.networkDisconnected = true;
                $rootScope.networkStatus.blurBlock = true;
                $rootScope.networkStatus.blurClass = 'blurBlock';
                $rootScope.networkStatus.networkConnectedSession = false;
                $mdDialog.cancel();
            }
            else
            {
                if($rootScope.networkStatus.networkDisconnected)
                {
                    $rootScope.networkStatus.networkDisconnected = false;
                    $timeout(function() {
                        $rootScope.networkStatus.networkConnectedSession = true;
                    }, 1000);
                    $timeout(function() {
                        $rootScope.networkStatus.networkConnectedSession = false;
                        $rootScope.networkStatus.blurBlock = false;
                        $rootScope.networkStatus.blurClass = '';
                    }, 5000);

                    
                }
            }
        }
        $interval(detectNetwork, 500);
    }

})();
'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider   ) {
    $stateProvider
        /* Auth Page List*/
        .state('app.tester', {
          url: '/tester',
          templateUrl: 'app/projects/rcloudsys/tester/tester.html',
          controller: 'testerController',
          data : { title: 'API Tester', folded: false },
          resolve : {},
          authenticate: false
        });
  }
]
)
.controller('testerController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $timeout, getServer) {
    var vms = this;

    $scope.testerData = {};

    $scope.data = {};

     $scope.result = function(type) {
      getServer.getData($scope.testerData.testerurl).then(function(data){
        $scope.data = data;
      });
    }

});


'use strict';


angular.module('app')
.config(
['$stateProvider', '$urlRouterProvider', '$locationProvider', 
  function ( $stateProvider,   $urlRouterProvider, $locationProvider ) {
    $stateProvider
        /* Auth Page List*/
        .state('designer.stdesigner', {
          url: '/stdesigner/:uid/:cid',
          templateUrl: 'app/projects/rcloudsys/st_designer/st_designer.html',
          controller: 'StDesignersController',
          data : { title: 'St Deigners', folded: true, nomargin: true },
          resolve : {
            getReportData: function($stateParams,getServer) {
              if($stateParams.uid !== "")
              {
                return getServer.getData('rcloudsys/reports/getReportData/'+$stateParams.uid);
              }
              else
              {
                return false;
              }
            }
          },
          authenticate: true
        });
  }
]
)
.controller('StDesignersController', function($scope, $stateParams, $state, $rootScope, toastShow, postServer, $interval, $window, getReportData) {
    var vms = this;

    $scope.cid = $stateParams.cid;

    $rootScope.designData = '';

    if(getReportData !== false)
    {
      $scope.design = getReportData.result.data;
    }
    else
    {
      $scope.design = "";
    }
    // console.log($scope.design);

    $rootScope.vm = {};

    $scope.init = function () {
      // console.log('Loading Designer view');

      // console.log('Set full screen mode for the designer');
      var options = new window.Stimulsoft.Designer.StiDesignerOptions();
      options.appearance.fullScreenMode = true;
      options.appearance.showSaveDialog = true;

      // console.log('Create the report designer with specified options');
      var designer = new window.Stimulsoft.Designer.StiDesigner(options, 'StiDesigner', false);

      // console.log('Create a new report instance');
      var report = new window.Stimulsoft.Report.StiReport();

      // console.log('Load report from url');
      // report.loadFile('/reports/SimpleList.mrt');
      if($scope.design !== "")
      {
        report.load($scope.design);
      }

      // console.log('Edit report template in the designer');
      designer.report = report;

      // console.log('Rendering the viewer to selected element');
      designer.renderHtml('designer');

      if(getReportData !== false)
      {
        designer.onSaveReport = function (event) {
          var jsonStr = event.report.saveToJsonString();
          $rootScope.designData = jsonStr;
        }
      }


      // console.log('Loading completed successfully!');
  };

  $scope.$watch('designData',function(){
    // console.log($rootScope.designData);
    if($rootScope.designData !== "")
    {
      var d = {
        val: $rootScope.designData
      };
      postServer.postData('rcloudsys/reports/saveReportData/'+$stateParams.uid,d).then(function(data){
        if(data.type === 'success')
        {
        }
      });
    }
  });

    
});
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "templatename" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "templatename",
                "modelname": "templatename",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
              "templateid" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "templateid",
                "modelname": "templateid",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "60",
                "nachar": "^*()-{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZ!@#$%^*())+=-"
            },
           "smstemplate" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "smstemplate",
                "modelname": "smstemplate",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "accessvariable" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "accessvariable",
                "modelname": "accessvariable",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50",
                "nospace": "true",
                "lowercase": "true"
            },
            "user_info_query" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "user_info_query",
                "modelname": "user_info_query",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "50",
            },

        };

        var fbuilderSelectbox = {
            "temptype" : {
                "size": "col-md-6",
                "itemid": "temptype",
                "modelname": "temptype",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"On Event", "value":"event" }, { "name":"Schedule", "value":"schedule" } ]'
            },
            "temp_sb" : {
                "size": "col-md-6",
                "itemid": "temp_sb",
                "modelname": "temp_sb",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataAPIURL": "rcloudsys/template/getSmsTempForFirstCmp"
            },
        };
        var fbuilderRadiobutton = {};
        var fbuilderNumberbox = {};    
        var fbuilderDatebox = {};        
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('smstemplate', {
              abstract: true,
              url: '/smstemplate',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/smstemplate');
      }
    ]
  );
'use strict';


angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ($stateProvider, $urlRouterProvider, $locationProvider ) {
        $stateProvider
          /* Auth Page List*/
          .state('companies.listcompaniesdetail', {
            url: '/listcompaniesdetail',
            templateUrl: 'app/projects/rcloudsys/installation_report/listcompaniesdetail.html',
            controller: 'InstalltionReportController',
            data: {
              title: 'Installation Report',
              folded: true,
              nomargin: true
            },
            resolve: {
              getReport: function (getServer, $stateParams) {
                return getServer.getData('rcloudsys/companies/getPrintReportData/installation_details');
              }
            },
            authenticate: true
          });
      }
    ]
  ).controller('InstalltionReportController', function ($scope, $state, $mdDialog, $rootScope, $log, toastShow, postServer, getServer, $timeout, getReport, $window, $stateParams) {
    var vm = this;

    $scope.viewCardData = {
      statusrunning :'1'
    };

    $scope.getVars = '';
    $scope.reportViewer = '';

    $scope.showPrint = function () {
        $scope.reportViewer = '';
        $timeout(function(){
            $scope.reportViewer = '<div ng-init="init()" style="margin: 20px;"><div id="viewer"></div>';
        },500);        
    };

    $scope.design = getReport.result.data;
    $scope.init = function () {      
      $scope.getVars = '?' + Object.keys($scope.viewCardData).map(function(key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent($scope.viewCardData[key])
      }).join('&');
      $rootScope.stimulReport($scope.design,"Stiviewer","getProjectCompanyReport","viewer",$scope.getVars,[]);    
    };
  


  });

(function () {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        var fbuilderTextbox = {
            "projectname": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "projectname",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "100",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=!@#$%^*())_+="
            },
            "projectid": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "projectid",
                "modelname": "projectid",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "100",
                "autocomplete": "false",
                "nachar": "^*(){[}]|\:;<,>?/=!@#$%^*())+=.",
                "nospace": "true",
                "lowercase": "true",
                "geturlcheck": "rcloudsys/projects/pDupCheck/"
            },
            "projecturl": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "projecturl",
                "modelname": "projecturl",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "999998",
                "autocomplete": "false",
                "nospace": "true",
                "lowercase": "true"
            },
            "packagename": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "packagename",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "100",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=!@#$%^*())_+="
            },
            "packageid": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "packageid",
                "modelname": "packageid",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "100",
                "autocomplete": "false",
                "nachar": "^*(){[}]|\:;<,>?/=!@#$%^*())+=.",
                "nospace": "true",
                "lowercase": "true",
                "geturlcheck": "rcloudsys/packages/pDupCheck/"
            },
            "uref": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "uref",
                "modelname": "uref",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "100",
                "autocomplete": "false",
                "nachar": "^*(){[}]|\:;<,>?/=!@#$%^*())+=",
                "nospace": "true",
                "lowercase": "true"
            },
            "href": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "href",
                "modelname": "href",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "100",
                "autocomplete": "false",
                "nachar": "^*(){[}]|\:;<,>?=!@#$%^*())+=.",
                "nospace": "true",
                "lowercase": "true"
            },
            "submodules": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "submodules",
                "modelname": "submodules",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "3",
                "maxlength": "3000",
                "autocomplete": "false",
                "nachar": "^*()-{[}]|\:;<>?=!@#$%^*())+=",
                "nospace": "true",
                "lowercase": "true"
            }
        };

        var fbuilderSelectbox = {
            "projectstatus": {
                "size": "col-md-6",
                "itemid": "projectstatus",
                "modelname": "status",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"Enabled", "value":"1" },{ "name":"Disabled", "value":"0" } ]'
            },
            "projectype": {
                "size": "col-md-6",
                "itemid": "projectype",
                "modelname": "projectype",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"Common DB", "value":"commondb" },{ "name":"Private DB", "value":"privatedb" },{ "name":"Local Linked", "value":"locallinked" } ]'
            },
            "product_category": {
                "size": "col-md-6",
                "itemid": "product_category",
                "modelname": "product_category",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"Cloud Product", "value":"cloud" },{ "name":"Local Product", "value":"local" } ]'
            },
            "product_fw": {
                "size": "col-md-6",
                "itemid": "product_fw",
                "modelname": "project_fw",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"rCloud JS", "value":"js" },{ "name":"rCloud TS", "value":"ts" } ]'
            },
            "projecticon": {
                "size": "col-md-6",
                "itemid": "projecticon",
                "modelname": "icon",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataAPIURL": 'rcloudsys/selectdata/icons/js'
            },
            "projecticonts": {
                "size": "col-md-6",
                "itemid": "projecticonts",
                "modelname": "icon",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataAPIURL": 'rcloudsys/selectdata/icons/ts'
            }
        };

        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "show_order": {
                "size": "col-md-6",
                "itemid": "show_order",
                "modelname": "show_order",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "1000",
                "calculator": "false"
            },
            "data_transfer_limit": {
                "size": "col-md-6",
                "itemid": "data_transfer_limit",
                "modelname": "data_transfer_limit",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "99999",
                "calculator": "false"
            },
            "storage_transfer_limit": {
                "size": "col-md-6",
                "itemid": "storage_transfer_limit",
                "modelname": "storage_transfer_limit",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "99999",
                "calculator": "false"
            },
            "email_transfer_limit": {
                "size": "col-md-6",
                "itemid": "email_transfer_limit",
                "modelname": "email_transfer_limit",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "99999999999",
                "calculator": "false"
            }
        };
        var fbuilderDatebox = {};

        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox, fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox, fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton, fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox, fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox, fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox, fbuilderCheckbox);

    }

})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',   '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,   $translatePartialLoaderProvider) {
        $stateProvider

            /* Dashboard Page List*/

            .state('projects', {
              abstract: true,
              url: '/projects',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          })
          .state('packages', {
              abstract: true,
              url: '/packages',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          })
          .state('modgroups', {
              abstract: true,
              url: '/modgroups',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          })
          .state('models', {
              abstract: true,
              url: '/models',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });
          
           $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/projects');
      }
    ]
  );
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "name" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "name",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "templateid" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "templateid",
                "modelname": "templateid",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "60",
                "nachar": "^*()-{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZ!@#$%^*())+=-"
            },
           "subject" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "subject",
                "modelname": "subject",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "mailtemplate" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "mailtemplate",
                "modelname": "mail",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "mailaccessvariable" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "mailaccessvariable",
                "modelname": "mailaccessvariable",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "subjectaccessvariable" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "subjectaccessvariable",
                "modelname": "subjectaccessvariable",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            }

        };

        var fbuilderSelectbox = {};
        var fbuilderRadiobutton = {};
        var fbuilderNumberbox = {};    
        var fbuilderDatebox = {};        
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('emailtemplate', {
              abstract: true,
              url: '/emailtemplate',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/emailtemplate');
      }
    ]
  );
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "dbname" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "dbname",
                "modelname": "dbname",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "60",
                "nachar": "^*()-{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZ!@#$%^*())+=-"
            },
           "username" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "username",
                "modelname": "username",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "password" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "password",
                "modelname": "password",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "dbtypename" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "name",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
            "shortcode" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "shortcode",
                "modelname": "shortcode",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "10",
                "nachar": "^*()-{[}]|\:;<,>?/=abcdefghijklmnopqrstuvwxyz!@#$%^*())+=-"
            }

        };

        var fbuilderSelectbox = {
            "companyid" : {
                "size": "col-md-6",
                "itemid": "companyid",
                "modelname": "companyid",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataAPIURLformat": 'rcloudsys/companies/cListforSelect,name,id'
            },
            "dbtype" : {
                "size": "col-md-6",
                "itemid": "dbtype",
                "modelname": "dbtype",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                'dataAPIURLformat': 'rcloudsys/dbschemes/getallDBType,name,shortcode'
            }
        };
        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {            
            "version" : {
                "size": "col-md-6",
                "itemid": "version",
                "modelname": "version",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "1",
                "step": "0.1",
                "maxnumber": "15000",
                "calculator": "false"
            }
        };
        var fbuilderDatebox = {};

        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('dbschemes', {
              abstract: true,
              url: '/dbschemes',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/dbschemes');
      }
    ]
  );
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "report_name" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "report_name",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "naword": "000",
                "minlength": "3",
                "maxlength": "50"
            },
              "report_id" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "report_id",
                "modelname": "rid",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "naword": "000",
                "lowercase": "true",
                "maxlength": "60",
                "nachar": "^*()-{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZ!@#$%^*())+=-"
            },
           "report_type" :
            {
                "type": "text",
                "size": "col-md-12",
                "itemid": "report_type",
                "modelname": "rtype",
                "tlate": "commonForms.textbox",
                "required": "true",                
                "naword": "000", 
                "minlength": "3",
                "maxlength": "50"
            },
            

        };

        var fbuilderSelectbox = {
            "status" : {
                "size": "col-md-6",
                "itemid": "status",
                "modelname": "status",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Enable", "value":"1" },{ "name":"Disable", "value":"0" }]'
            }
        };
        var fbuilderRadiobutton = {};
        var fbuilderNumberbox = {};    
        var fbuilderDatebox = {};        
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('companyreport', {
              abstract: true,
              url: '/companyreport',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/companyreport');
      }
    ]
  );
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "sett_textbox": {
                "type":"text",
                "size": "col-md-6",
                "itemid": "sett_textbox",
                "modelname": "sett_textbox",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "1",
                "maxlength": "200"
            },
           "companyname" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companyname",
                "modelname": "name",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
            },
            "companyuniquename" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companyuniquename",
                "modelname": "uniquename",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
                "lowercase": "true",                
                "nachar": "^*()-{[}]|\:;<,>?/=!@#$%^*())+=-",
                "geturlcheck": "rcloudsys/companies/cDupCheck/"
            },
            "companydisc" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companydisc",
                "modelname": "disc",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "10"
            },
            "address" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "address",
                "modelname": "address",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "15"
            },
            "companyemail" : {
                "type":"email",
                "size": "col-md-6",
                "itemid": "companyemail",
                "modelname": "emailid",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "lowercase": "true"
            },
            "companyphone" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companyphone",
                "modelname": "phoneno",
                "tlate": "commonForms.textbox",
                "minlength": "6",
                "maxlength": "15",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
            "companymobile" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companymobile",
                "modelname": "mobileno",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "12",
                "maxlength": "12",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
            "companystaticiplist" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "companystaticiplist",
                "modelname": "staticip",
                "tlate": "commonForms.textbox",
                "required": "false",
                "minlength": "6",
                "maxlength": "500",
                "autocomplete": "false",
                "nachar": "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()_+-={}[]|\:;/?<>"
            },
            "loginEmail" : {
                "type":"email",
                "size": "col-md-12",
                "itemid": "loginEmail",
                "modelname": "username",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "lowercase": "ture",
                "nawords": "test,demo"
            },
            "loginPassword" : {
                "type":"password",
                "size": "col-md-12",
                "itemid": "loginPassword",
                "modelname": "password",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/="
            },
             "displayname" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "displayname",
                "modelname": "display_name",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4"
            },
             "mobileno" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "mobileno",
                "modelname": "mobileno",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "12",
                "maxlength": "12",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            },
             "userrole" : {
                "type":"text",
                "size": "col-md-12",
                "itemid": "userrole",
                "modelname": "user_role",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "2"
            },
             "ip" : {
                "type": "text",
                "size": "col-md-6",
                "itemid": "ip",
                "modelname": "ip",
                "tlate": "commonForms.textbox",
                "required": "true",
                "pattern": "/^([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.([01]?\\d\\d?|2[0-4]\\d|25[0-5])$/"
            },
            "accesskey" : {
               "type": "text",
               "size": "col-md-12",
               "itemid": "accesskey",
               "modelname": "accesskey",
               "tlate": "commonForms.textbox",
               "required": "true"
           },
           "contenttitle" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "contenttitle",
                "modelname": "title",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
            },
            "description" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "description",
                "modelname": "desc",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
            },
            "hint" : {
                "type":"text",
                "size": "col-md-6",
                "itemid": "hint",
                "modelname": "val_hint",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "minlength": "4",
                "maxlength": "100",
            },
        "colname" : {
            "type":"text",
            "size": "col-md-6",
            "itemid": "colname",
            "modelname": "col_name",
            "tlate": "commonForms.textbox",         
            "spellcheck": "false",
            "autocomplete": "true",
            "required": "true",
            "minlength": "4",
            "maxlength": "100",
            "nachar":"!@#$%^&*()-=+[{]}\|;:?,<.>/",
            "lowercase": "true",
            "nospace":"true"
        },
        
        "values" : {
            "type":"text",
            "size": "col-md-6",
            "itemid": "values",
            "modelname": "values",
            "tlate": "commonForms.textbox",         
            "spellcheck": "false",
            "autocomplete": "true",
            "required": "false",
            "minlength": "4",
            "maxlength": "100",
        },
        "def_values" : {
            "type":"text",
            "size": "col-md-6",
            "itemid": "def_values",
            "modelname": "def_value",
            "tlate": "commonForms.textbox",         
            "spellcheck": "false",
            "autocomplete": "true",
            "required": "true",
            "minlength": "1",
            "maxlength": "600",
        },
        "login_notify" : {
            "type":"text",
            "size": "col-md-6",
            "itemid": "login_notify",
            "modelname": "login_notify",
            "tlate": "commonForms.textbox",         
            "spellcheck": "false",
            "autocomplete": "true",
            "required": "true",
            "minlength": "1",
            "maxlength": "600",
        },
        "password_notify" : {
            "type":"text",
            "size": "col-md-6",
            "itemid": "password_notify",
            "modelname": "password_notify",
            "tlate": "commonForms.textbox",         
            "spellcheck": "false",
            "autocomplete": "true",
            "required": "true",
            "minlength": "1",
            "maxlength": "600",
        }

        };

        var fbuilderSelectbox = {
            "sett_selectbox" : {
                "size": "col-md-6",
                "itemid": "sett_selectbox",
                "modelname": "sett_selectbox",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false"
            },
            "enabledordisabled" : {
                "size": "col-md-6",
                "itemid": "enabledordisabled",
                "modelname": "enabledordisabled",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Enabled", "value":"1" },{ "name":"Disabled", "value":"0" } ]'
            },
            "pripubuser" : {
                "size": "col-md-6",
                "itemid": "pripubuser",
                "modelname": "usertype",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Public User", "value":"public" },{ "name":"Private User", "value":"private" } ]'
            },
            "qrorrfid" : {
                "size": "col-md-6",
                "itemid": "qrorrfid",
                "modelname": "qrorrfid",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Manual", "value":"manual" },{ "name":"QR Code", "value":"qr" },{ "name":"RFID Card", "value":"rfid" } ]'
            },
            "projectstatus" : {
                "size": "col-md-6",
                "itemid": "projectstatus",
                "modelname": "status",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Enabled", "value":"1" },{ "name":"Disabled", "value":"0" } ]'
            },
            "listprojects" : {
                "size": "col-md-6",
                "itemid": "projectlist",
                "modelname": "projects",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "multiple": "true",
                "dataAPIURL": 'rcloudsys/projects/slistProjects'
            },
            "listpackages" : {
                "size": "col-md-6",
                "itemid": "listpackages",
                "modelname": "listpackages",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "multiple": "false",
                "dataAPIURL": 'rcloudsys/packages/packagesSB'
            },
            "listdatabase" : {
                "size": "col-md-12",
                "itemid": "listdatabase",
                "modelname": "listdatabase",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "multiple": "false"
            },
            "gender" : {
                "size": "col-md-12",
                "itemid": "gender",
                "modelname": "gender",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Male", "value":"m" },{ "name":"Female", "value":"f" } ]'
            },
            "projectmap" : {
                "size": "col-md-6",
                "itemid": "projectmap",
                "modelname": "map",
                "type": "normal",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "dataAPIURLformat": "rcloudsys/gkits/mapdata/wbs"
            },
            "knitpack_automation" : {
                "size": "col-md-12",
                "itemid": "knitpack_automation",
                "modelname": "knitpack_automation",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Yes", "value":"yes" },{ "name":"No", "value":"no" } ]'
            },
            "knitpack_companies" : {
                "size": "col-md-6",
                "itemid": "knitpack_companies",
                "modelname": "selected_companies",
                "required": "true",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true"
            },
            "knitpack_godowns" : {
                "size": "col-md-6",
                "itemid": "knitpack_godowns",
                "modelname": "selected_godowns",
                "required": "true",
                "tlate": "commonForms.selectbox",
                "allowClear": "false",
                "multiple": "true"
            },
            "knitpack_def_godown" : {
                "size": "col-md-6",
                "itemid": "knitpack_def_godown",
                "modelname": "default_godown",
                "required": "true",
                "tlate": "commonForms.selectbox",
                "allowClear": "false"
            },
            "workbsprojectmap" : {
                "size": "col-md-6",
                "itemid": "projectmap",
                "modelname": "map",
                "type": "normal",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataAPIURLformat": "rcloudsys/wbs/getWbsMapList,UserName,UserID"
            },
            "manageCompanyAccess" : {
                "size": "col-md-6",
                "itemid": "manageCompanyAccess",
                "modelname": "manageCompanyAccess",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"All", "value":"all" },{ "name":"Selected", "value":"selected" } ]'
            },
            "manageProjectCompanyList" : {
                "size": "col-md-6",
                "itemid": "manageProjectCompanyList",
                "modelname": "manageProjectCompanyList",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "multiple": "true"
            },
            "supsysusertype" : {
                "size": "col-md-6",
                "itemid": "supsysusertype",
                "modelname": "usertype",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Customer", "value":"user" },{ "name":"Online Support Engineer", "value":"onlinesupport" },{ "name":"Customer Support Executive", "value":"suppotexecutive" },{ "name":"Ticket Manager", "value":"ticketmanager" },{ "name":"Programmer", "value":"programmer" },{ "name":"Project Manager", "value":"Project Manager" } ]'
            },
            "project" : {
                "size": "col-md-6",
                "itemid": "project",
                "modelname": "projectid",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataAPIURL": 'rcloudsys/projects/slistProjects'
            },
            "type" : {
                "size": "col-md-6",
                "itemid": "type",
                "modelname": "type",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"Textbox", "value":"tb" }, { "name":"Numberbox", "value":"nb" }, { "name":"Combobox", "value":"cb" } ]'
            },
            "status" : {
                "size": "col-md-6",
                "itemid": "status",
                "modelname": "status",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"Enable", "value":"1" },{ "name":"Disable", "value":"0" } ]'
            },
            "statusrunning" : {
                "size": "col-md-6",
                "itemid": "statusrunning",
                "modelname": "statusrunning",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false",
                "dataLocal": '[ { "name":"All", "value":"all" },{ "name":"Trial", "value":"trial" },{ "name":"Current Users", "value":"1" },{ "name":"Past Users", "value":"0" } ]'
            },
            "usersb" : {
                "size": "col-md-6",
                "itemid": "usersb",
                "modelname": "usersb",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "allowClear": "false"
            },
        };

        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "sett_numbox" : {
                "size": "col-md-6",
                "itemid": "sett_numbox",
                "modelname": "sett_numbox",
                "tlate": "commonForms.numberbox",
                "autocomplete": "false",
                "step": "1",
                "required": "true", 
                "calculator": "false"
            },
            "dec" : {
                "size": "col-md-6",
                "itemid": "dec",
                "modelname": "ord",
                "tlate": "commonForms.numberbox",
                "autocomplete": "false",
                "step": "1",
                "required": "true", 
                "calculator": "false"
            }
        };    
        var fbuilderDatebox = {
            "validtill" : {
                "size":"col-md-6",
                "itemid":"validtill",
                "modelname":"valid_till",
                "tlate":"commonForms.datebox",
                "required":"true",
                "picker":"date"
            },
            "portno" : {
                "size": "col-md-6",
                "itemid": "portno",
                "modelname": "portno",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1000",
                "maxnumber": "99999",
                "calculator": "false"
            },
            "nofuser" : {
                "size": "col-md-6",
                "itemid": "nofuser",
                "modelname": "nofuser",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "1",
                "maxnumber": "1000",
                "calculator": "false"
            }
        };
            
        var fbuilderCheckbox = {
            "access" : {
                "size": "col-md-2",
                "itemid": "access",
                "modelname": "access",
                "tlate": "commonForms.checkbox"
            },
            "tunnalaccess" : {
               "size": "col-md-6",
               "itemid": "tunnalaccess",
               "modelname": "tunnalaccess",
               "tlate": "commonForms.checkbox"
           },
           "tunnalmultidb" : {
              "size": "col-md-6",
              "itemid": "tunnalmultidb",
              "modelname": "tunnalmultidb",
              "tlate": "commonForms.checkbox"
          }
        };

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ($stateProvider, $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider) {
        $stateProvider

          /* Dashboard Page List*/

          .state('companies', {
            abstract: true,
            url: '/companies',
            views: {
              '': {
                templateUrl: 'app/views/partials/layout.html'
              },
              'aside': {
                templateUrl: 'app/views/partials/aside.html'
              },
              'content': {
                templateUrl: 'app/views/partials/content.html'
              }
            },
            authenticate: true
          })
          .state('productsettings', {
            abstract: true,
            url: '/productsettings',
            views: {
              '': {
                templateUrl: 'app/views/partials/layout.html'
              },
              'aside': {
                templateUrl: 'app/views/partials/aside.html'
              },
              'content': {
                templateUrl: 'app/views/partials/content.html'
              }
            },
            authenticate: true
          })
          .state('users', {
            abstract: true,
            url: '/users',
            views: {
              '': {
                templateUrl: 'app/views/partials/layout.html'
              },
              'aside': {
                templateUrl: 'app/views/partials/aside.html'
              },
              'content': {
                templateUrl: 'app/views/partials/content.html'
              }
            },
            authenticate: true
          })
          .state('designer', {
            abstract: true,
            url: '/designer',
            views: {
              '': {
                templateUrl: 'app/views/partials/full_screen_layout.html'
              },
              'content': {
                templateUrl: 'app/views/partials/full_screen_content.html'
              }
            },
            authenticate: true
          });
        $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/companies');
      }
    ]
  );

(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "eventname" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "eventname",
                "modelname": "eventname",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            },
             "name" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "name",
                "modelname": "name",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "50"
            }
        };

        var fbuilderSelectbox = {
            "companyprojects": {
                "size": "col-md-6",
                "itemid": "companyprojects",
                "modelname": "companyprojects",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataAPIURLformat": "rcloudsys/companies/getCompanyProjcetSelectBox,name,id"
            },
            "templateid" : {
                "size": "col-md-6",
                "itemid": "templateid",
                "modelname": "templateid",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[]'
            },
             "schtype" : {
                "size": "col-md-6",
                "itemid": "type",
                "modelname": "type",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Daily", "value":"daily" },{ "name":"Weekly", "value":"weekly" },{ "name":"Monthly", "value":"monthly" } ]'
            },
             "wdays" : {
                "size": "col-md-6",
                "itemid": "wdays",
                "modelname": "wdays",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"Sunday", "value":"sunday" },{ "name":"Monday", "value":"monday" },{ "name":"Tuesday", "value":"tuesday" },{ "name":"Wednesday", "value":"wednesday" },{ "name":"Thursday", "value":"3" },{ "name":"Friday", "value":"friday" },{ "name":"Saturday", "value":"saturday" } ]'
            },
             "mdays" : {
                "size": "col-md-6",
                "itemid": "mdays",
                "modelname": "mdays",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"1", "value":"1" },{ "name":"2", "value":"2" },{ "name":"3", "value":"3" },{ "name":"4", "value":"4" },{ "name":"5", "value":"5" },{ "name":"6", "value":"6" },{ "name":"7", "value":"7" },{ "name":"8", "value":"8" },{ "name":"9", "value":"9" },{ "name":"10", "value":"10" },{ "name":"11", "value":"11" },{ "name":"12", "value":"12" },{ "name":"13", "value":"13" },{ "name":"14", "value":"14" },{ "name":"15", "value":"15" },{ "name":"16", "value":"16" },{ "name":"17", "value":"17" },{ "name":"18", "value":"18" },{ "name":"19", "value":"19" },{ "name":"20", "value":"20" },{ "name":"21", "value":"21" },{ "name":"21", "value":"21" },{ "name":"22", "value":"22" },{ "name":"23", "value":"23" },{ "name":"24", "value":"24" },{ "name":"25", "value":"25" },{ "name":"26", "value":"26" },{ "name":"27", "value":"27" },{ "name":"28", "value":"28" },{ "name":"29", "value":"29" },{ "name":"30", "value":"30" },{ "name":"31", "value":"31" } ]'
            },
            "usersselection" : {
                "size": "col-md-6",
                "itemid": "usersselection",
                "modelname": "usersselection",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"All", "value":"all" },{ "name":"Select", "value":"select" }]'
            },
            "contactselection" : {
                "size": "col-md-6",
                "itemid": "contactselection",
                "modelname": "contactselection",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[ { "name":"All", "value":"all" },{ "name":"Select", "value":"select" }]'
            }
        };
        var fbuilderRadiobutton = {};
        var fbuilderNumberbox = {};    
        var fbuilderDatebox = {
             "time" : {
                "size":"col-md-6",
                "itemid":"time",
                "modelname":"time",
                "tlate":"commonForms.datebox",
                "required":"true",
                "picker":"time"
            }
        };        
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('communicationscheduler', {
              abstract: true,
              url: '/communicationscheduler',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/communicationscheduler');
      }
    ]
  );
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "smssenderid" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "smssenderid",
                "modelname": "smssenderid",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "6",
                "maxlength": "6",
                "nospace": "true"
            },
            "smskey" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "smskey",
                "modelname": "smskey",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "80",
                "nospace": "true"
            },
            "textmsg" :
            {
                "type": "text",
                "size": "col-md-6",
                "itemid": "textmsg",
                "modelname": "textmsg",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "2",
                "maxlength": "150"
            },
            "emailsender": {
                "type": "email",
                "size": "col-md-6",
                "itemid": "emailsender",
                "modelname": "emailsender",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "emailsender_name": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "emailsender_name",
                "modelname": "emailsender_name",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "multiemailsender": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "multiemailsender",
                "modelname": "multiemailsender",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "99999999",
                "pattern": "/^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/"
            },
            "emailreplayto": {
                "type": "email",
                "size": "col-md-6",
                "itemid": "emailreplayto",
                "modelname": "emailreplayto",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "emailreplayto_name": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "emailreplayto_name",
                "modelname": "emailreplayto_name",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "smtp_host": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "smtp_host",
                "modelname": "smtp_host",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "smtp_username": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "smtp_username",
                "modelname": "smtp_username",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "smtp_password": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "smtp_password",
                "modelname": "smtp_password",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "2",
                "maxlength": "150"
            }
        };

        var fbuilderSelectbox = {
            "companyprojects": {
                "size": "col-md-6",
                "itemid": "companyprojects",
                "modelname": "companyprojects",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataAPIURLformat": "rcloudsys/companies/getCompanyProjcetSelectBox,name,id"
            },
            "sms_server": {
                "size": "col-md-6",
                "itemid": "sms_server",
                "modelname": "sms_server",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[{ "name":"rCloud V2", "value": "rcloudv2" },{ "name":"rCloud V1", "value": "rcloud" },{ "name":"rCloud V1.5 SMIT", "value": "smit" }]'
            },
            "email_server": {
                "size": "col-md-6",
                "itemid": "email_server",
                "modelname": "email_server",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[{ "name":"rCloud Mail", "value": "rcloudmail" },{ "name":"rCloud (SMTP)", "value": "rcloudsmtp" },{ "name":"SMTP Server", "value": "smtp" }]'
            },
            "smtp_auth": {
                "size": "col-md-6",
                "itemid": "smtp_auth",
                "modelname": "smtp_auth",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[{ "name":"Required", "value": "1" },{ "name":"Not Required", "value": "0" }]'
            },
            "smtp_auth_type": {
                "size": "col-md-6",
                "itemid": "smtp_auth_type",
                "modelname": "smtp_auth_type",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "false",
                "dataLocal": '[{ "name":"Auto", "value": "auto" },{ "name":"TLS", "value": "tls" },{ "name":"SSL", "value": "ssl" }]'
            },
            "email_address_list": {
                "size": "col-md-6",
                "itemid": "email_address_list",
                "modelname": "email_address_list",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "multiple": "true",
                "allowClear": "false",
            }
        };

        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "smtp_port" : {
                "size": "col-md-6",
                "itemid": "smtp_port",
                "modelname": "smtp_port",
                "tlate": "commonForms.numberbox",
                "autocomplete": "false",
                "step": "1",
                "required": "true", 
                "calculator": "false"
            }
        };

        var fbuilderDatebox = {};        
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('commhub', {
              abstract: true,
              url: '/commhub',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/projects/rcloudsys/commhub');
      }
    ]
  );
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runProject1Forms)
        .config(
            ['$translatePartialLoaderProvider',
              function ($translatePartialLoaderProvider) {
        
                $translatePartialLoaderProvider.addPart('app/projects/rcloud_rc_settings/storemgmt');
              }
            ]
        );
    
    /** @ngInject */
    function runProject1Forms($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderTextbox.storemgmt_package_forms = {};
        $rootScope.fbuilderSelectbox.storemgmt_package_forms = {};
        $rootScope.fbuilderRadiobutton.storemgmt_package_forms = {};
        $rootScope.fbuilderNumberbox.storemgmt_package_forms = {};
        $rootScope.fbuilderDatebox.storemgmt_package_forms = {};
        $rootScope.fbuilderCheckbox.storemgmt_package_forms = {};

        var fbuilderTextbox = {};

        var fbuilderSelectbox = {
            "def_company": {
                "size": "col-md-6",
                "itemid": "def_company",
                "modelname": "def_company",
                "tlate": "storemgmt.package_forms.selectbox",
                "required": "true",
                "multiple": "false",
                "allowClear": "false",
                "dataAPIURL": 'cmaster/masters/getCompanySB'
            },
            "def_godown": {
                "size": "col-md-6",
                "itemid": "def_godown",
                "modelname": "def_godown",
                "tlate": "storemgmt.package_forms.selectbox",
                "required": "true",
                "multiple": "false",
                "allowClear": "false",
                "dataAPIURL": 'cmaster/masters/getGodownSB'
            }
        };

        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "total_companies_limit": {
                "size": "col-md-6",
                "itemid": "total_companies_limit",
                "modelname": "total_companies_limit",
                "tlate": "storemgmt.package_forms.numberbox",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "999",
                "required": "true",
                "calculator": "false"
            }
        };
            
        var fbuilderDatebox = {};
            
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox.storemgmt_package_forms,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox.storemgmt_package_forms,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton.storemgmt_package_forms,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox.storemgmt_package_forms,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox.storemgmt_package_forms,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox.storemgmt_package_forms,fbuilderCheckbox);

    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runProject1Forms)
        .config(
            ['$translatePartialLoaderProvider',
              function ($translatePartialLoaderProvider) {
        
                $translatePartialLoaderProvider.addPart('app/projects/rcloud_rc_settings/logisticsmgmt');
              }
            ]
        );
    
    /** @ngInject */
    function runProject1Forms($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderTextbox.logisticsmgmt_package_forms = {};
        $rootScope.fbuilderSelectbox.logisticsmgmt_package_forms = {};
        $rootScope.fbuilderRadiobutton.logisticsmgmt_package_forms = {};
        $rootScope.fbuilderNumberbox.logisticsmgmt_package_forms = {};
        $rootScope.fbuilderDatebox.logisticsmgmt_package_forms = {};
        $rootScope.fbuilderCheckbox.logisticsmgmt_package_forms = {};

        var fbuilderTextbox = {};

        var fbuilderSelectbox = {
            "def_company": {
                "size": "col-md-6",
                "itemid": "def_company",
                "modelname": "def_company",
                "tlate": "logisticsmgmt.package_forms.selectbox",
                "required": "true",
                "multiple": "false",
                "allowClear": "false",
                "dataAPIURL": 'logisticsmgmt/masters/getCompanyListSB'
            },
            "def_agent": {
                "size": "col-md-6",
                "itemid": "def_agent",
                "modelname": "def_agent",
                "tlate": "logisticsmgmt.package_forms.selectbox",
                "required": "true",
                "multiple": "false",
                "allowClear": "false",
                "dataAPIURL": 'logisticsmgmt/masters/getPartyListSB/true'
            }
        };

        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "total_companies_limit": {
                "size": "col-md-6",
                "itemid": "total_companies_limit",
                "modelname": "total_companies_limit",
                "tlate": "logisticsmgmt.package_forms.numberbox",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "999",
                "required": "true",
                "calculator": "false"
            }
        };
            
        var fbuilderDatebox = {};
            
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox.logisticsmgmt_package_forms,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox.logisticsmgmt_package_forms,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton.logisticsmgmt_package_forms,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox.logisticsmgmt_package_forms,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox.logisticsmgmt_package_forms,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox.logisticsmgmt_package_forms,fbuilderCheckbox);

    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(dairyMGMTProjectForms)
        .config(
            ['$translatePartialLoaderProvider',
              function ($translatePartialLoaderProvider) {
        
                $translatePartialLoaderProvider.addPart('app/projects/rcloud_rc_settings/dairymgmt');
              }
            ]
        );
    
    /** @ngInject */
    function dairyMGMTProjectForms($rootScope, $timeout, $state)
    {
        $rootScope.fbuilderTextbox.dairymgmt_package_forms = {};
        $rootScope.fbuilderSelectbox.dairymgmt_package_forms = {};
        $rootScope.fbuilderRadiobutton.dairymgmt_package_forms = {};
        $rootScope.fbuilderNumberbox.dairymgmt_package_forms = {};
        $rootScope.fbuilderDatebox.dairymgmt_package_forms = {};
        $rootScope.fbuilderCheckbox.dairymgmt_package_forms = {};

        var fbuilderTextbox = {};

        var fbuilderSelectbox = {
            "def_company": {
                "size": "col-md-6",
                "itemid": "def_company",
                "modelname": "def_company",
                "tlate": "dairymgmt.package_forms.selectbox",
                "required": "true",
                "multiple": "false",
                "allowClear": "false",
                "dataAPIURL": 'dairymgmt/masters/getCompanyListSB'
            }
        };

        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "total_companies_limit": {
                "size": "col-md-6",
                "itemid": "total_companies_limit",
                "modelname": "total_companies_limit",
                "tlate": "dairymgmt.package_forms.numberbox",
                "autocomplete": "false",
                "decimal": "0",
                "step": "1",
                "minnumber": "0",
                "maxnumber": "999",
                "required": "true",
                "calculator": "false"
            }
        };
            
        var fbuilderDatebox = {};
            
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox.dairymgmt_package_forms,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox.dairymgmt_package_forms,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton.dairymgmt_package_forms,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox.dairymgmt_package_forms,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox.dairymgmt_package_forms,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox.dairymgmt_package_forms,fbuilderCheckbox);

    }
        
})();
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
            "emailsender": {
                "type": "email",
                "size": "col-md-6",
                "itemid": "emailsender",
                "modelname": "emailsender",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "5",
                "maxlength": "150"
            },
            "multiemailsender": {
                "type": "text",
                "size": "col-md-6",
                "itemid": "multiemailsender",
                "modelname": "multiemailsender",
                "tlate": "commonForms.textbox",
                "required": "true",  
                "minlength": "3",
                "maxlength": "99999999",
                "pattern": "/^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/"
            },
            "subject" :
             {
                 "type": "text",
                 "size": "col-md-12",
                 "itemid": "subject",
                 "modelname": "subject",
                 "tlate": "commonForms.textbox",
                 "required": "true",  
                 "minlength": "3",
                 "maxlength": "200"
             }
        };

        var fbuilderSelectbox = {
            "email_address_list": {
                "size": "col-md-6",
                "itemid": "email_address_list",
                "modelname": "email_address_list",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "multiple": "true",
                "allowClear": "false",
            }
        };
        var fbuilderRadiobutton = {};
        var fbuilderNumberbox = {};    
        var fbuilderDatebox = {};        
        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider',  '$translatePartialLoaderProvider',
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  $translatePartialLoaderProvider ) {
        $stateProvider

            /* Dashboard Page List*/

          .state('common', {
              abstract: true,
              url: '/common',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/views/rcloud');
      }
    ]
  );
function pwPromptController($rootScope, $scope, $mdDialog, options, $timeout, $window, postServer) {
    $scope.theme = $rootScope.getThemeColor();

    $scope.options = options;

    $scope.del_password = '';

    $timeout(function(){
        var input = document.getElementById('delete_pass_pw');
        angular.element(input).focus();
        angular.element(input).keyup(function(e){
            if (e.keyCode == 13)
            {
                $scope.submit();
            }
        });
    },500);

    $scope.submit = function() {
        $scope.options.callback($scope.del_password);
        $mdDialog.cancel();
    };

    $scope.cancel = function() {
        $scope.options.callback(null);
        $mdDialog.cancel();
    };
  }
  
(function ()
{
    'use strict';

    angular
        .module('app')
        .run(runBlock);
    
    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        var fbuilderTextbox = {
           
             "loginEmail" : {
                "type":"email",
                "size": "col-md-12",
                "itemid": "loginEmail",
                "modelname": "username",
                "tlate": "commonForms.textbox",         
                "spellcheck": "false",
                "autocomplete": "true",
                "required": "true",
                "lowercase": "ture",
                "nawords": "test,demo"
            },
             "loginPassword" : {
                "type":"password",
                "size": "col-md-12",
                "itemid": "loginPassword",
                "modelname": "password",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "5",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/="
            },
             "oneTimePassword" : {
                "type":"password",
                "size": "col-md-12",
                "itemid": "oneTimePassword",
                "modelname": "otp",
                "tlate": "commonForms.textbox",
                "required": "true",
                "minlength": "6",
                "maxlength": "6",
                "autocomplete": "false",
                "nachar": "^*()_{[}]|\:;<,>?/=ABCDENGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^*())_+=-"
            }

        };

        var fbuilderSelectbox = {
            "gender" : {
                "size": "col-md-12",
                "itemid": "gender",
                "modelname": "gender",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Male", "value":"m" },{ "name":"Female", "value":"f" } ]'
            },
             "toastposition" : {
                "size": "col-md-6",
                "itemid": "toastposition",
                "modelname": "toastData.position",
                "tlate": "commonForms.selectbox",
                "required": "true",     
                "allowClear": "true",
                "dataLocal": '[ { "name":"Bottom Right", "value":"bottom right" },{ "name":"Bottom Left", "value":"bottom left" },{ "name":"Top Right", "value":"top right" },{ "name":"Top Left", "value":"top left" } ]'
            },
            "datepickerSetting" : {
                "size": "col-md-6",
                "itemid": "datepicker",
                "modelname": "datePicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in datepickerformats track by option.format"
            },
            "timepickerSetting" : {
                "size": "col-md-6",
                "itemid": "timepicker",
                "modelname": "timePicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in timepickerformats track by option.format"
            },
            "monthpickerSetting" : {
                "size": "col-md-6",
                "itemid": "monthpicker",
                "modelname": "monthPicker",
                "tlate": "commonForms.selectbox",
                "required": "true",
                "type": "normal",
                "localVarFormat": "option.name for option in monthpickerformats track by option.format"
            }
        };
        var fbuilderRadiobutton = {};

        var fbuilderNumberbox = {
            "toasttiming" : {
                "size": "col-md-6",
                "itemid": "toasttiming",
                "modelname": "toastData.delay",
                "tlate": "commonForms.numberbox",
                "required": "true",
                "autocomplete": "false",
                "decimal": "0",
                "step": "100",
                "minnumber": "3000",
                "maxnumber": "15000",
                "calculator": "false"
            }
        };
        var fbuilderDatebox = {};

        var fbuilderCheckbox = {};

        angular.extend($rootScope.fbuilderTextbox,fbuilderTextbox);
        angular.extend($rootScope.fbuilderSelectbox,fbuilderSelectbox);
        angular.extend($rootScope.fbuilderRadiobutton,fbuilderRadiobutton);
        angular.extend($rootScope.fbuilderNumberbox,fbuilderNumberbox);
        angular.extend($rootScope.fbuilderDatebox,fbuilderDatebox);
        angular.extend($rootScope.fbuilderCheckbox,fbuilderCheckbox);

    }
        
})();
'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .config(
    ['$stateProvider', '$urlRouterProvider', '$locationProvider', '$translatePartialLoaderProvider',
      function ($stateProvider, $urlRouterProvider, $locationProvider, $translatePartialLoaderProvider) {
        $stateProvider
          /* Auth Page List*/
          .state('load', {
            abstract: true,
            url: '/load',
            views: {
              '': {
                templateUrl: 'app/views/partials/full_screen_layout.html'
              },
              'content': {
                templateUrl: 'app/views/partials/full_screen_content.html'
              }
            },
            authenticate: true
          })
          .state('auth', {
            url: '/auth',
            template: '<div class="login-bg bg-big"><div ui-view class="fade-in-down smooth"></div></div>',
            notAuthenticate: true
          });
        $translatePartialLoaderProvider.addPart('app/views/auth');
      }
    ]
  );
'use strict';

/**
 * 0.1.1
 * Deferred load js/css file, used for ui-jq.js and Lazy Loading.
 * 
 * @ flatfull.com All Rights Reserved.
 * Author url: http://themeforest.net/user/flatfull
 */

angular.module('ui.load', [])
	.service('uiLoad', ['$document', '$q', '$timeout', function ($document, $q, $timeout) {

		var loaded = [];
		var promise = false;
		var deferred = $q.defer();

		/**
		 * Chain loads the given sources
		 * @param srcs array, script or css
		 * @returns {*} Promise that will be resolved once the sources has been loaded.
		 */
		this.load = function (srcs) {
			srcs = angular.isArray(srcs) ? srcs : srcs.split(/\s+/);
			var self = this;
			if(!promise){
				promise = deferred.promise;
			}
			angular.forEach(srcs, function(src) {
				promise = promise.then( function(){
					return src.indexOf('.css') >=0 ? self.loadCSS(src) : self.loadScript(src);
				} );
			});
			deferred.resolve();
			return promise;
		}

		/**
		 * Dynamically loads the given script
		 * @param src The url of the script to load dynamically
		 * @returns {*} Promise that will be resolved once the script has been loaded.
		 */
		this.loadScript = function (src) {
			if(loaded[src]) return loaded[src].promise;

			var deferred = $q.defer();
			var script = $document[0].createElement('script');
			script.src = src;
			script.onload = function (e) {
				$timeout(function () {
					deferred.resolve(e);
				});
			};
			script.onerror = function (e) {
				$timeout(function () {
					deferred.reject(e);
				});
			};
			$document[0].body.appendChild(script);
			loaded[src] = deferred;

			return deferred.promise;
		};

		/**
		 * Dynamically loads the given CSS file
		 * @param href The url of the CSS to load dynamically
		 * @returns {*} Promise that will be resolved once the CSS file has been loaded.
		 */
		this.loadCSS = function (href) {
			if(loaded[href]) return loaded[href].promise;

			var deferred = $q.defer();
			var style = $document[0].createElement('link');
			style.rel = 'stylesheet';
			style.type = 'text/css';
			style.href = href;
			style.onload = function (e) {
				$timeout(function () {
					deferred.resolve(e);
				});
			};
			style.onerror = function (e) {
				$timeout(function () {
					deferred.reject(e);
				});
			};
			$document[0].head.appendChild(style);
			loaded[href] = deferred;

			return deferred.promise;
		};
}]);

//Get Data Service
(function ()
{
    'use strict';

    angular
        .module('app')
        .provider('toastShow', toastShowProvider);

    /** @ngInject */
    function toastShowProvider()
    {
       return {

        $get: function($mdToast,$window,$rootScope,$filter){

          $rootScope.toastData = {
            type : '',
            msg : '',
            translate : ''
          };

          return {

            show: function(type, msg, translate){
              var tnlate = '';
              if(translate !== false)
              {
                tnlate = translate ? "translate='toastData."+translate+"'" : '';
              }
              if($rootScope.toastData.type !== type && ($rootScope.toastData.msg !== msg || $rootScope.toastData.translate !== translate))
              {
                var notification;
                if(!this.tabStatus())
                {
                  if ($window.Notification.permission !== "granted")
                  {
                    $window.Notification.requestPermission();
                  }
                  else 
                  {
                    $rootScope.toastData.type = type;
                    $rootScope.toastData.msg = msg;
                    $rootScope.toastData.translate = translate;

                    var browserMsg = translate ? $filter('translate')('toastData.'+translate) : msg;

                    notification = new $window.Notification(browserMsg, {
                      icon: $rootScope.projectInfo.apiServer + 'pics/rdweb.png',
                      iconUrl: $rootScope.projectInfo.apiServer + 'pics/rdweb.png',
                      body: '',
                    });
                  
                    notification.onclick = function () {
                      notification.close();
                      window.focus(); 
                    };

                    notification.onclose = function () {
                      $rootScope.toastData.type = '';
                      $rootScope.toastData.msg = '';
                    };
                  }
                }
              }

              var temp = '<md-toast class="md-toast animated slideInLeft ' + type +'"><div class="md-toast-content" '+ tnlate +'>' + msg + '</div></md-toast>';

              // console.log(temp);

              $mdToast.show({
                  template: temp,
                  hideDelay: $rootScope.defaultSetup.toastData.delay,
                  position: $rootScope.defaultSetup.toastData.position
              });
            },

            tabStatus: function()
            {
              var hidden, state; 
              if (typeof document.hidden !== "undefined") {
                state = "visibilityState";
              } else if (typeof document.mozHidden !== "undefined") {
                state = "mozVisibilityState";
              } else if (typeof document.msHidden !== "undefined") {
                state = "msVisibilityState";
              } else if (typeof document.webkitHidden !== "undefined") {
                state = "webkitVisibilityState";
              }

              if(document[state] === "hidden") {
                return false;
              }
              else {
                return true;
              }
            },

          }

        }

       }
    }
})();
//Get Data Service

(function ()
{
    'use strict';

    angular
        .module('app')
        .factory('httpRequestInterceptor', function () {
          return {
            request: function (config) {
        
              config.headers['rCloudKey'] = 'rCloudKEY';
              config.headers['rCloudFE'] = 'JS';

              if(sessionStorage.rcloud_project !== undefined)
              {
                var project = JSON.parse(sessionStorage.rcloud_project);
                config.headers['rCloudProject'] = project.projectid;
              }
        
              return config;
            }
          };
        })
        .config(function ($httpProvider) {
          $httpProvider.interceptors.push('httpRequestInterceptor');
        });

})();
/*! Quill Editor v0.20.1
 *  https://quilljs.com/
 *  Copyright (c) 2014, Jason Chen
 *  Copyright (c) 2013, salesforce.com
 */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Quill = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
  (function (global){
  /**
   * @license
   * lodash 3.9.3 (Custom Build) <https://lodash.com/>
   * Build: `lodash modern include="difference,intersection,last,all,each,find,invoke,map,reduce,partition,bind,defer,partial,clone,extend,defaults,omit,values,isElement,isEqual,isFunction,isNumber,isObject,isString,uniqueId" --development --output .build/lodash.js`
   * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   * Available under MIT license <https://lodash.com/license>
   */
  ;(function() {
  
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */
    var undefined;
  
    /** Used as the semantic version number. */
    var VERSION = '3.9.3';
  
    /** Used to compose bitmasks for wrapper metadata. */
    var BIND_FLAG = 1,
        BIND_KEY_FLAG = 2,
        CURRY_BOUND_FLAG = 4,
        CURRY_FLAG = 8,
        CURRY_RIGHT_FLAG = 16,
        PARTIAL_FLAG = 32,
        PARTIAL_RIGHT_FLAG = 64,
        ARY_FLAG = 128,
        REARG_FLAG = 256;
  
    /** Used to detect when a function becomes hot. */
    var HOT_COUNT = 150,
        HOT_SPAN = 16;
  
    /** Used as the `TypeError` message for "Functions" methods. */
    var FUNC_ERROR_TEXT = 'Expected a function';
  
    /** Used as the internal argument placeholder. */
    var PLACEHOLDER = '__lodash_placeholder__';
  
    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        objectTag = '[object Object]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        weakMapTag = '[object WeakMap]';
  
    var arrayBufferTag = '[object ArrayBuffer]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';
  
    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/,
        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
  
    /**
     * Used to match `RegExp` [special characters](http://www.regular-expressions.info/characters.html#special).
     * In addition to special characters the forward slash is escaped to allow for
     * easier `eval` use and `Function` compilation.
     */
    var reRegExpChars = /[.*+?^${}()|[\]\/\\]/g,
        reHasRegExpChars = RegExp(reRegExpChars.source);
  
    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;
  
    /** Used to match `RegExp` flags from their coerced string values. */
    var reFlags = /\w*$/;
  
    /** Used to detect host constructors (Safari > 5). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
  
    /** Used to detect unsigned integer values. */
    var reIsUint = /^\d+$/;
  
    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
    typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
    typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
    typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
    typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
    typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
    typedArrayTags[dateTag] = typedArrayTags[errorTag] =
    typedArrayTags[funcTag] = typedArrayTags[mapTag] =
    typedArrayTags[numberTag] = typedArrayTags[objectTag] =
    typedArrayTags[regexpTag] = typedArrayTags[setTag] =
    typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
  
    /** Used to identify `toStringTag` values supported by `_.clone`. */
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] =
    cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
    cloneableTags[dateTag] = cloneableTags[float32Tag] =
    cloneableTags[float64Tag] = cloneableTags[int8Tag] =
    cloneableTags[int16Tag] = cloneableTags[int32Tag] =
    cloneableTags[numberTag] = cloneableTags[objectTag] =
    cloneableTags[regexpTag] = cloneableTags[stringTag] =
    cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
    cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] =
    cloneableTags[mapTag] = cloneableTags[setTag] =
    cloneableTags[weakMapTag] = false;
  
    /** Used to determine if values are of the language type `Object`. */
    var objectTypes = {
      'function': true,
      'object': true
    };
  
    /** Detect free variable `exports`. */
    var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
  
    /** Detect free variable `module`. */
    var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
  
    /** Detect free variable `global` from Node.js. */
    var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
  
    /** Detect free variable `self`. */
    var freeSelf = objectTypes[typeof self] && self && self.Object && self;
  
    /** Detect free variable `window`. */
    var freeWindow = objectTypes[typeof window] && window && window.Object && window;
  
    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
  
    /**
     * Used as a reference to the global object.
     *
     * The `this` value is used if it's the global object to avoid Greasemonkey's
     * restricted `window` object, otherwise the `window` object is used.
     */
    var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
  
    /*--------------------------------------------------------------------------*/
  
    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;
  
      while ((fromRight ? index-- : ++index < length)) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
  
    /**
     * The base implementation of `_.indexOf` without support for binary searches.
     *
     * @private
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOf(array, value, fromIndex) {
      if (value !== value) {
        return indexOfNaN(array, fromIndex);
      }
      var index = fromIndex - 1,
          length = array.length;
  
      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
  
    /**
     * The base implementation of `_.isFunction` without support for environments
     * with incorrect `typeof` results.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     */
    function baseIsFunction(value) {
      // Avoid a Chakra JIT bug in compatibility modes of IE 11.
      // See https://github.com/jashkenas/underscore/issues/1621 for more details.
      return typeof value == 'function' || false;
    }
  
    /**
     * Converts `value` to a string if it's not one. An empty string is returned
     * for `null` or `undefined` values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      if (typeof value == 'string') {
        return value;
      }
      return value == null ? '' : (value + '');
    }
  
    /**
     * Gets the index at which the first occurrence of `NaN` is found in `array`.
     *
     * @private
     * @param {Array} array The array to search.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched `NaN`, else `-1`.
     */
    function indexOfNaN(array, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 0 : -1);
  
      while ((fromRight ? index-- : ++index < length)) {
        var other = array[index];
        if (other !== other) {
          return index;
        }
      }
      return -1;
    }
  
    /**
     * Checks if `value` is object-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     */
    function isObjectLike(value) {
      return !!value && typeof value == 'object';
    }
  
    /**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */
    function replaceHolders(array, placeholder) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];
  
      while (++index < length) {
        if (array[index] === placeholder) {
          array[index] = PLACEHOLDER;
          result[++resIndex] = index;
        }
      }
      return result;
    }
  
    /*--------------------------------------------------------------------------*/
  
    /** Used for native method references. */
    var objectProto = Object.prototype;
  
    /** Used to detect DOM support. */
    var document = (document = root.window) ? document.document : null;
  
    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;
  
    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;
  
    /** Used to generate unique IDs. */
    var idCounter = 0;
  
    /**
     * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;
  
    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      escapeRegExp(fnToString.call(hasOwnProperty))
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );
  
    /** Native method references. */
    var ArrayBuffer = getNative(root, 'ArrayBuffer'),
        bufferSlice = getNative(ArrayBuffer && new ArrayBuffer(0), 'slice'),
        floor = Math.floor,
        getPrototypeOf = getNative(Object, 'getPrototypeOf'),
        Set = getNative(root, 'Set'),
        Uint8Array = getNative(root, 'Uint8Array'),
        WeakMap = getNative(root, 'WeakMap');
  
    /** Used to clone array buffers. */
    var Float64Array = (function() {
      // Safari 5 errors when using an array buffer to initialize a typed array
      // where the array buffer's `byteLength` is not a multiple of the typed
      // array's `BYTES_PER_ELEMENT`.
      try {
        var func = getNative(root, 'Float64Array'),
            result = new func(new ArrayBuffer(10), 0, 1) && func;
      } catch(e) {}
      return result || null;
    }());
  
    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCreate = getNative(Object, 'create'),
        nativeIsArray = getNative(Array, 'isArray'),
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now');
  
    /** Used as references for `-Infinity` and `Infinity`. */
    var POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
  
    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
  
    /** Used as the size, in bytes, of each `Float64Array` element. */
    var FLOAT64_BYTES_PER_ELEMENT = Float64Array ? Float64Array.BYTES_PER_ELEMENT : 0;
  
    /**
     * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;
  
    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;
  
    /** Used to lookup unminified function names. */
    var realNames = {};
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that return a boolean or single value will
     * automatically end the chain returning the unwrapped value. Explicit chaining
     * may be enabled using `_.chain`. The execution of chained methods is lazy,
     * that is, execution is deferred until `_#value` is implicitly or explicitly
     * called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization that merges iteratees to avoid creating intermediate
     * arrays and reduce the number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defer`, `delay`,
     * `difference`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `fill`,
     * `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`, `forEach`,
     * `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `functions`,
     * `groupBy`, `indexBy`, `initial`, `intersection`, `invert`, `invoke`, `keys`,
     * `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `method`, `methodOf`, `mixin`, `negate`, `omit`, `once`,
     * `pairs`, `partial`, `partialRight`, `partition`, `pick`, `plant`, `pluck`,
     * `property`, `propertyOf`, `pull`, `pullAt`, `push`, `range`, `rearg`,
     * `reject`, `remove`, `rest`, `restParam`, `reverse`, `set`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `sortByAll`, `sortByOrder`, `splice`, `spread`,
     * `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `tap`, `throttle`,
     * `thru`, `times`, `toArray`, `toPlainObject`, `transform`, `union`, `uniq`,
     * `unshift`, `unzip`, `unzipWith`, `values`, `valuesIn`, `where`, `without`,
     * `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `clone`, `cloneDeep`, `deburr`,
     * `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`,
     * `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`, `get`,
     * `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`, `inRange`, `isArguments`,
     * `isArray`, `isBoolean`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isError`,
     * `isFinite` `isFunction`, `isMatch`, `isNative`, `isNaN`, `isNull`, `isNumber`,
     * `isObject`, `isPlainObject`, `isRegExp`, `isString`, `isUndefined`,
     * `isTypedArray`, `join`, `kebabCase`, `last`, `lastIndexOf`, `lt`, `lte`,
     * `max`, `min`, `noConflict`, `noop`, `now`, `pad`, `padLeft`, `padRight`,
     * `parseInt`, `pop`, `random`, `reduce`, `reduceRight`, `repeat`, `result`,
     * `runInContext`, `shift`, `size`, `snakeCase`, `some`, `sortedIndex`,
     * `sortedLastIndex`, `startCase`, `startsWith`, `sum`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash() {
      // No operation performed.
    }
  
    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }
  
    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};
  
    (function(x) {
      var Ctor = function() { this.x = x; },
          object = { '0': x, 'length': x },
          props = [];
  
      Ctor.prototype = { 'valueOf': x, 'y': x };
      for (var key in new Ctor) { props.push(key); }
  
      /**
       * Detect if the DOM is supported.
       *
       * @memberOf _.support
       * @type boolean
       */
      try {
        support.dom = document.createDocumentFragment().nodeType === 11;
      } catch(e) {
        support.dom = false;
      }
    }(1, 0));
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = null;
      this.__dir__ = 1;
      this.__dropCount__ = 0;
      this.__filtered__ = false;
      this.__iteratees__ = null;
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = null;
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;
  
      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }
  
    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
  
      return result ? 0 : -1;
    }
  
    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;
  
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
  
    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;
  
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
  
    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;
  
      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }
  
    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);
  
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
  
    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;
  
      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }
  
    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;
  
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
  
    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }
  
    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;
  
      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);
  
        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }
  
    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }
  
    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});
  
      var index = -1,
          length = props.length;
  
      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }
  
    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }
  
    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;
  
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);
  
      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);
  
      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }
  
    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = null;
        }
        return result || {};
      };
    }());
  
    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }
  
    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];
  
      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= 200) ? createCache(values) : null,
          valuesLength = values.length;
  
      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];
  
        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }
  
    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);
  
    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }
  
    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }
  
    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            value = baseFlatten(value, isDeep, isStrict);
          }
          var valIndex = -1,
              valLength = value.length;
  
          while (++valIndex < valLength) {
            result[++resIndex] = value[valIndex];
          }
        } else if (!isStrict) {
          result[++resIndex] = value;
        }
      }
      return result;
    }
  
    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();
  
    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }
  
    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }
  
    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;
  
      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }
  
    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }
  
    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;
  
      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;
  
      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
  
        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);
  
      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);
  
      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
  
      stackA.pop();
      stackB.pop();
  
      return result;
    }
  
    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;
  
      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];
  
        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }
  
    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];
  
      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }
  
    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];
  
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }
  
    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');
  
      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }
  
    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }
  
    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }
  
    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }
  
    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };
  
    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;
  
      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;
  
      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }
  
    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);
  
      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }
  
    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;
  
      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];
  
          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }
  
    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);
  
      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;
  
      while (low < high) {
        var mid = floor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;
  
        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }
  
    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }
  
    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      return bufferSlice.call(buffer, 0);
    }
    if (!bufferSlice) {
      // PhantomJS has `ArrayBuffer` and `Uint8Array` but not `Float64Array`.
      bufferClone = !(ArrayBuffer && Uint8Array) ? constant(null) : function(buffer) {
        var byteLength = buffer.byteLength,
            floatLength = Float64Array ? floor(byteLength / FLOAT64_BYTES_PER_ELEMENT) : 0,
            offset = floatLength * FLOAT64_BYTES_PER_ELEMENT,
            result = new ArrayBuffer(byteLength);
  
        if (floatLength) {
          var view = new Float64Array(result, 0, floatLength);
          view.set(new Float64Array(buffer, 0, floatLength));
        }
        if (byteLength != offset) {
          view = new Uint8Array(result, offset);
          view.set(new Uint8Array(buffer, offset));
        }
        return result;
      };
    }
  
    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(argsLength + leftLength);
  
      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }
  
    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);
  
      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }
  
    /**
     * Creates a function that aggregates a collection, creating an accumulator
     * object composed from the results of running each element in the collection
     * through an iteratee.
     *
     * **Note:** This function is used to create `_.countBy`, `_.groupBy`, `_.indexBy`,
     * and `_.partition`.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);
  
        if (isArray(collection)) {
          var index = -1,
              length = collection.length;
  
          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }
  
    /**
     * Creates a function that assigns properties of source object(s) to a given
     * destination object.
     *
     * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;
  
        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }
  
    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);
  
        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }
  
    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;
  
        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
  
    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);
  
      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }
  
    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    var createCache = !(nativeCreate && Set) ? constant(null) : function(values) {
      return new SetCache(values);
    };
  
    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);
  
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }
  
    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }
  
    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }
  
    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, null, partials, holders);
      });
      return partialFunc;
    }
  
    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }
  
    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? null : createCtorWrapper(func);
  
      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);
  
        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);
  
          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : null,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : null,
                newHoldersRight = isCurry ? null : argsHolders,
                newPartials = isCurry ? args : null,
                newPartialsRight = isCurry ? null : args;
  
            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
  
            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);
  
            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;
  
        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }
  
    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);
  
      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(argsLength + leftLength);
  
        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }
  
    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = null;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;
  
        partials = holders = null;
      }
      var data = isBindKey ? null : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
  
      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);
  
      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }
  
    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;
  
      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
  
        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }
  
    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} value The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;
  
        case errorTag:
          return object.name == other.name && object.message == other.message;
  
        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;
  
        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }
  
    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;
  
      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
  
        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;
  
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }
  
    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }
  
    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };
  
    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;
  
      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }
  
    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }
  
    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');
  
    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;
  
      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }
  
    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }
  
    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);
  
      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }
  
    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }
  
    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);
  
        case boolTag:
        case dateTag:
          return new Ctor(+object);
  
        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
  
        case numberTag:
        case stringTag:
          return new Ctor(object);
  
        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }
  
    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }
  
    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }
  
    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }
  
    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }
  
    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }
  
    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }
  
    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
  
    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }
  
    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;
  
      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
  
      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;
  
      return data;
    }
  
    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);
  
      var index = -1,
          length = props.length,
          result = {};
  
      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }
  
    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }
  
    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);
  
      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }
  
    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;
  
      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);
  
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());
  
    /**
     * A fallback implementation of `_.isPlainObject` which checks if `value`
     * is an object created by the `Object` constructor or has a `[[Prototype]]`
     * of `null`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     */
    function shimIsPlainObject(value) {
      var Ctor,
          support = lodash.support;
  
      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag) ||
          (!hasOwnProperty.call(value, 'constructor') &&
            (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }
  
    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;
  
      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));
  
      var index = -1,
          result = [];
  
      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }
  
    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }
  
    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });
  
    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value),
            other = array[index];
  
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }
  
    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];
  
      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];
  
      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });
  
    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = null;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }
  
    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);
  
    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);
  
    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];
  
      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : null);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });
  
    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }
  
    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });
  
    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `includes`, `merge`, `sortByAll`, and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });
  
    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });
  
    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);
  
    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);
  
        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }
  
    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) && objToString.call(value) == argsTag;
    }
  
    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };
  
    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) &&
        (objToString.call(value).indexOf('Element') > -1);
    }
    // Fallback for environments without DOM support.
    if (!support.dom) {
      isElement = function(value) {
        return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
      };
    }
  
    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }
  
    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    var isFunction = !(baseIsFunction(/x/) || (Uint8Array && !baseIsFunction(Uint8Array))) ? baseIsFunction : function(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return objToString.call(value) == funcTag;
    };
  
    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }
  
    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (objToString.call(value) == funcTag) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }
  
    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }
  
    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
      if (!(value && objToString.call(value) == objectTag)) {
        return false;
      }
      var valueOf = getNative(value, 'valueOf'),
          objProto = valueOf && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
  
      return objProto
        ? (value == objProto || getPrototypeOf(value) == objProto)
        : shimIsPlainObject(value);
    };
  
    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }
  
    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });
  
    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = restParam(function(args) {
      var object = args[0];
      if (object == null) {
        return object;
      }
      args.push(assignDefaults);
      return assign.apply(undefined, args);
    });
  
    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? null : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };
  
    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;
  
      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;
  
      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
  
    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });
  
    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);
  
      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);
  
      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }
  
    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, '\\$&')
        : string;
    }
  
    /*------------------------------------------------------------------------*/
  
    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = null;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }
  
    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }
  
    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }
  
    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }
  
    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }
  
    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }
  
    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }
  
    /*------------------------------------------------------------------------*/
  
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;
  
    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;
  
    // Add functions that return wrapped values when chaining.
    lodash.assign = assign;
    lodash.bind = bind;
    lodash.callback = callback;
    lodash.constant = constant;
    lodash.defaults = defaults;
    lodash.defer = defer;
    lodash.difference = difference;
    lodash.forEach = forEach;
    lodash.intersection = intersection;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.matches = matches;
    lodash.omit = omit;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partition = partition;
    lodash.property = property;
    lodash.restParam = restParam;
    lodash.values = values;
  
    // Add aliases.
    lodash.collect = map;
    lodash.each = forEach;
    lodash.extend = assign;
    lodash.iteratee = callback;
  
    /*------------------------------------------------------------------------*/
  
    // Add functions that return unwrapped values when chaining.
    lodash.clone = clone;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.identity = identity;
    lodash.indexOf = indexOf;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isElement = isElement;
    lodash.isEqual = isEqual;
    lodash.isFunction = isFunction;
    lodash.isNative = isNative;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.last = last;
    lodash.noop = noop;
    lodash.now = now;
    lodash.reduce = reduce;
    lodash.uniqueId = uniqueId;
  
    // Add aliases.
    lodash.all = every;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.inject = reduce;
  
    /*------------------------------------------------------------------------*/
  
    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;
  
    // Assign default placeholders.
    arrayEach(['bind', 'partial'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });
  
    /*--------------------------------------------------------------------------*/
  
    // Some AMD build optimizers like r.js check for condition patterns like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
      // Expose lodash to the global object when an AMD loader is present to avoid
      // errors in cases where lodash is loaded by a script tag and not intended
      // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
      // more details.
      root._ = lodash;
  
      // Define as an anonymous module so, through path mapping, it can be
      // referenced as the "underscore" module.
      define(function() {
        return lodash;
      });
    }
    // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
    else if (freeExports && freeModule) {
      // Export for Node.js or RingoJS.
      if (moduleExports) {
        (freeModule.exports = lodash)._ = lodash;
      }
      // Export for Rhino with CommonJS support.
      else {
        freeExports._ = lodash;
      }
    }
    else {
      // Export for a browser or Rhino.
      root._ = lodash;
    }
  }.call(this));
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{}],2:[function(_dereq_,module,exports){
  /*!
   * EventEmitter2
   * https://github.com/hij1nx/EventEmitter2
   *
   * Copyright (c) 2013 hij1nx
   * Licensed under the MIT license.
   */
  ;!function(undefined) {
  
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
      return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
  
    function init() {
      this._events = {};
      if (this._conf) {
        configure.call(this, this._conf);
      }
    }
  
    function configure(conf) {
      if (conf) {
  
        this._conf = conf;
  
        conf.delimiter && (this.delimiter = conf.delimiter);
        conf.maxListeners && (this._events.maxListeners = conf.maxListeners);
        conf.wildcard && (this.wildcard = conf.wildcard);
        conf.newListener && (this.newListener = conf.newListener);
  
        if (this.wildcard) {
          this.listenerTree = {};
        }
      }
    }
  
    function EventEmitter(conf) {
      this._events = {};
      this.newListener = false;
      configure.call(this, conf);
    }
  
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
      if (!tree) {
        return [];
      }
      var listeners=[], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached,
          typeLength = type.length, currentType = type[i], nextType = type[i+1];
      if (i === typeLength && tree._listeners) {
        //
        // If at the end of the event(s) list and the tree has listeners
        // invoke those listeners.
        //
        if (typeof tree._listeners === 'function') {
          handlers && handlers.push(tree._listeners);
          return [tree];
        } else {
          for (leaf = 0, len = tree._listeners.length; leaf < len; leaf++) {
            handlers && handlers.push(tree._listeners[leaf]);
          }
          return [tree];
        }
      }
  
      if ((currentType === '*' || currentType === '**') || tree[currentType]) {
        //
        // If the event emitted is '*' at this part
        // or there is a concrete match at this patch
        //
        if (currentType === '*') {
          for (branch in tree) {
            if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
              listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+1));
            }
          }
          return listeners;
        } else if(currentType === '**') {
          endReached = (i+1 === typeLength || (i+2 === typeLength && nextType === '*'));
          if(endReached && tree._listeners) {
            // The next element has a _listeners, add it to the handlers.
            listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
          }
  
          for (branch in tree) {
            if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
              if(branch === '*' || branch === '**') {
                if(tree[branch]._listeners && !endReached) {
                  listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                }
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
              } else if(branch === nextType) {
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i+2));
              } else {
                // No match on this one, shift into the tree but not in the type array.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
              }
            }
          }
          return listeners;
        }
  
        listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i+1));
      }
  
      xTree = tree['*'];
      if (xTree) {
        //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i+1);
      }
  
      xxTree = tree['**'];
      if(xxTree) {
        if(i < typeLength) {
          if(xxTree._listeners) {
            // If we have a listener on a '**', it will catch all, so add its handler.
            searchListenerTree(handlers, type, xxTree, typeLength);
          }
  
          // Build arrays of matching next branches and others.
          for(branch in xxTree) {
            if(branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
              if(branch === nextType) {
                // We know the next element will match, so jump twice.
                searchListenerTree(handlers, type, xxTree[branch], i+2);
              } else if(branch === currentType) {
                // Current node matches, move into the tree.
                searchListenerTree(handlers, type, xxTree[branch], i+1);
              } else {
                isolatedBranch = {};
                isolatedBranch[branch] = xxTree[branch];
                searchListenerTree(handlers, type, { '**': isolatedBranch }, i+1);
              }
            }
          }
        } else if(xxTree._listeners) {
          // We have reached the end and still on a '**'
          searchListenerTree(handlers, type, xxTree, typeLength);
        } else if(xxTree['*'] && xxTree['*']._listeners) {
          searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
      }
  
      return listeners;
    }
  
    function growListenerTree(type, listener) {
  
      type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
  
      //
      // Looks for two consecutive '**', if so, don't add the event at all.
      //
      for(var i = 0, len = type.length; i+1 < len; i++) {
        if(type[i] === '**' && type[i+1] === '**') {
          return;
        }
      }
  
      var tree = this.listenerTree;
      var name = type.shift();
  
      while (name) {
  
        if (!tree[name]) {
          tree[name] = {};
        }
  
        tree = tree[name];
  
        if (type.length === 0) {
  
          if (!tree._listeners) {
            tree._listeners = listener;
          }
          else if(typeof tree._listeners === 'function') {
            tree._listeners = [tree._listeners, listener];
          }
          else if (isArray(tree._listeners)) {
  
            tree._listeners.push(listener);
  
            if (!tree._listeners.warned) {
  
              var m = defaultMaxListeners;
  
              if (typeof this._events.maxListeners !== 'undefined') {
                m = this._events.maxListeners;
              }
  
              if (m > 0 && tree._listeners.length > m) {
  
                tree._listeners.warned = true;
                console.error('(node) warning: possible EventEmitter memory ' +
                              'leak detected. %d listeners added. ' +
                              'Use emitter.setMaxListeners() to increase limit.',
                              tree._listeners.length);
                console.trace();
              }
            }
          }
          return true;
        }
        name = type.shift();
      }
      return true;
    }
  
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
  
    EventEmitter.prototype.delimiter = '.';
  
    EventEmitter.prototype.setMaxListeners = function(n) {
      this._events || init.call(this);
      this._events.maxListeners = n;
      if (!this._conf) this._conf = {};
      this._conf.maxListeners = n;
    };
  
    EventEmitter.prototype.event = '';
  
    EventEmitter.prototype.once = function(event, fn) {
      this.many(event, 1, fn);
      return this;
    };
  
    EventEmitter.prototype.many = function(event, ttl, fn) {
      var self = this;
  
      if (typeof fn !== 'function') {
        throw new Error('many only accepts instances of Function');
      }
  
      function listener() {
        if (--ttl === 0) {
          self.off(event, listener);
        }
        fn.apply(this, arguments);
      }
  
      listener._origin = fn;
  
      this.on(event, listener);
  
      return self;
    };
  
    EventEmitter.prototype.emit = function() {
  
      this._events || init.call(this);
  
      var type = arguments[0];
  
      if (type === 'newListener' && !this.newListener) {
        if (!this._events.newListener) { return false; }
      }
  
      // Loop through the *_all* functions and invoke them.
      if (this._all) {
        var l = arguments.length;
        var args = new Array(l - 1);
        for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
        for (i = 0, l = this._all.length; i < l; i++) {
          this.event = type;
          this._all[i].apply(this, args);
        }
      }
  
      // If there is no 'error' event listener then throw.
      if (type === 'error') {
  
        if (!this._all &&
          !this._events.error &&
          !(this.wildcard && this.listenerTree.error)) {
  
          if (arguments[1] instanceof Error) {
            throw arguments[1]; // Unhandled 'error' event
          } else {
            throw new Error("Uncaught, unspecified 'error' event.");
          }
          return false;
        }
      }
  
      var handler;
  
      if(this.wildcard) {
        handler = [];
        var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
      }
      else {
        handler = this._events[type];
      }
  
      if (typeof handler === 'function') {
        this.event = type;
        if (arguments.length === 1) {
          handler.call(this);
        }
        else if (arguments.length > 1)
          switch (arguments.length) {
            case 2:
              handler.call(this, arguments[1]);
              break;
            case 3:
              handler.call(this, arguments[1], arguments[2]);
              break;
            // slower
            default:
              var l = arguments.length;
              var args = new Array(l - 1);
              for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
              handler.apply(this, args);
          }
        return true;
      }
      else if (handler) {
        var l = arguments.length;
        var args = new Array(l - 1);
        for (var i = 1; i < l; i++) args[i - 1] = arguments[i];
  
        var listeners = handler.slice();
        for (var i = 0, l = listeners.length; i < l; i++) {
          this.event = type;
          listeners[i].apply(this, args);
        }
        return (listeners.length > 0) || !!this._all;
      }
      else {
        return !!this._all;
      }
  
    };
  
    EventEmitter.prototype.on = function(type, listener) {
  
      if (typeof type === 'function') {
        this.onAny(type);
        return this;
      }
  
      if (typeof listener !== 'function') {
        throw new Error('on only accepts instances of Function');
      }
      this._events || init.call(this);
  
      // To avoid recursion in the case that type == "newListeners"! Before
      // adding it to the listeners, first emit "newListeners".
      this.emit('newListener', type, listener);
  
      if(this.wildcard) {
        growListenerTree.call(this, type, listener);
        return this;
      }
  
      if (!this._events[type]) {
        // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
      }
      else if(typeof this._events[type] === 'function') {
        // Adding the second element, need to change to array.
        this._events[type] = [this._events[type], listener];
      }
      else if (isArray(this._events[type])) {
        // If we've already got an array, just append.
        this._events[type].push(listener);
  
        // Check for listener leak
        if (!this._events[type].warned) {
  
          var m = defaultMaxListeners;
  
          if (typeof this._events.maxListeners !== 'undefined') {
            m = this._events.maxListeners;
          }
  
          if (m > 0 && this._events[type].length > m) {
  
            this._events[type].warned = true;
            console.error('(node) warning: possible EventEmitter memory ' +
                          'leak detected. %d listeners added. ' +
                          'Use emitter.setMaxListeners() to increase limit.',
                          this._events[type].length);
            console.trace();
          }
        }
      }
      return this;
    };
  
    EventEmitter.prototype.onAny = function(fn) {
  
      if (typeof fn !== 'function') {
        throw new Error('onAny only accepts instances of Function');
      }
  
      if(!this._all) {
        this._all = [];
      }
  
      // Add the function to the event listener collection.
      this._all.push(fn);
      return this;
    };
  
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
  
    EventEmitter.prototype.off = function(type, listener) {
      if (typeof listener !== 'function') {
        throw new Error('removeListener only takes instances of Function');
      }
  
      var handlers,leafs=[];
  
      if(this.wildcard) {
        var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
      }
      else {
        // does not use listeners(), so no side effect of creating _events[type]
        if (!this._events[type]) return this;
        handlers = this._events[type];
        leafs.push({_listeners:handlers});
      }
  
      for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
        var leaf = leafs[iLeaf];
        handlers = leaf._listeners;
        if (isArray(handlers)) {
  
          var position = -1;
  
          for (var i = 0, length = handlers.length; i < length; i++) {
            if (handlers[i] === listener ||
              (handlers[i].listener && handlers[i].listener === listener) ||
              (handlers[i]._origin && handlers[i]._origin === listener)) {
              position = i;
              break;
            }
          }
  
          if (position < 0) {
            continue;
          }
  
          if(this.wildcard) {
            leaf._listeners.splice(position, 1);
          }
          else {
            this._events[type].splice(position, 1);
          }
  
          if (handlers.length === 0) {
            if(this.wildcard) {
              delete leaf._listeners;
            }
            else {
              delete this._events[type];
            }
          }
          return this;
        }
        else if (handlers === listener ||
          (handlers.listener && handlers.listener === listener) ||
          (handlers._origin && handlers._origin === listener)) {
          if(this.wildcard) {
            delete leaf._listeners;
          }
          else {
            delete this._events[type];
          }
        }
      }
  
      return this;
    };
  
    EventEmitter.prototype.offAny = function(fn) {
      var i = 0, l = 0, fns;
      if (fn && this._all && this._all.length > 0) {
        fns = this._all;
        for(i = 0, l = fns.length; i < l; i++) {
          if(fn === fns[i]) {
            fns.splice(i, 1);
            return this;
          }
        }
      } else {
        this._all = [];
      }
      return this;
    };
  
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
  
    EventEmitter.prototype.removeAllListeners = function(type) {
      if (arguments.length === 0) {
        !this._events || init.call(this);
        return this;
      }
  
      if(this.wildcard) {
        var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
  
        for (var iLeaf=0; iLeaf<leafs.length; iLeaf++) {
          var leaf = leafs[iLeaf];
          leaf._listeners = null;
        }
      }
      else {
        if (!this._events[type]) return this;
        this._events[type] = null;
      }
      return this;
    };
  
    EventEmitter.prototype.listeners = function(type) {
      if(this.wildcard) {
        var handlers = [];
        var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
        return handlers;
      }
  
      this._events || init.call(this);
  
      if (!this._events[type]) this._events[type] = [];
      if (!isArray(this._events[type])) {
        this._events[type] = [this._events[type]];
      }
      return this._events[type];
    };
  
    EventEmitter.prototype.listenersAny = function() {
  
      if(this._all) {
        return this._all;
      }
      else {
        return [];
      }
  
    };
  
    if (typeof define === 'function' && define.amd) {
       // AMD. Register as an anonymous module.
      define(function() {
        return EventEmitter;
      });
    } else if (typeof exports === 'object') {
      // CommonJS
      exports.EventEmitter2 = EventEmitter;
    }
    else {
      // Browser global.
      window.EventEmitter2 = EventEmitter;
    }
  }();
  
  },{}],3:[function(_dereq_,module,exports){
  var diff = _dereq_('fast-diff');
  var is = _dereq_('./is');
  var op = _dereq_('./op');
  
  
  var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
  
  
  var Delta = function (ops) {
    // Assume we are given a well formed ops
    if (is.array(ops)) {
      this.ops = ops;
    } else if (is.object(ops) && is.array(ops.ops)) {
      this.ops = ops.ops;
    } else {
      this.ops = [];
    }
  };
  
  
  Delta.prototype.insert = function (text, attributes) {
    var newOp = {};
    if (text.length === 0) return this;
    newOp.insert = text;
    if (is.object(attributes) && Object.keys(attributes).length > 0) newOp.attributes = attributes;
    return this.push(newOp);
  };
  
  Delta.prototype['delete'] = function (length) {
    if (length <= 0) return this;
    return this.push({ 'delete': length });
  };
  
  Delta.prototype.retain = function (length, attributes) {
    if (length <= 0) return this;
    var newOp = { retain: length };
    if (is.object(attributes) && Object.keys(attributes).length > 0) newOp.attributes = attributes;
    return this.push(newOp);
  };
  
  Delta.prototype.push = function (newOp) {
    var index = this.ops.length;
    var lastOp = this.ops[index - 1];
    newOp = op.clone(newOp);
    if (is.object(lastOp)) {
      if (is.number(newOp['delete']) && is.number(lastOp['delete'])) {
        this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
        return this;
      }
      // Since it does not matter if we insert before or after deleting at the same index,
      // always prefer to insert first
      if (is.number(lastOp['delete']) && newOp.insert != null) {
        index -= 1;
        lastOp = this.ops[index - 1];
        if (!is.object(lastOp)) {
          this.ops.unshift(newOp);
          return this;
        }
      }
      if (is.equal(newOp.attributes, lastOp.attributes)) {
        if (is.string(newOp.insert) && is.string(lastOp.insert)) {
          this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
          if (is.object(newOp.attributes)) this.ops[index - 1].attributes = newOp.attributes
          return this;
        } else if (is.number(newOp.retain) && is.number(lastOp.retain)) {
          this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
          if (is.object(newOp.attributes)) this.ops[index - 1].attributes = newOp.attributes
          return this;
        }
      }
    }
    if (index === this.ops.length) {
      this.ops.push(newOp);
    } else {
      this.ops.splice(index, 0, newOp);
    }
    return this;
  };
  
  Delta.prototype.chop = function () {
    var lastOp = this.ops[this.ops.length - 1];
    if (lastOp && lastOp.retain && !lastOp.attributes) {
      this.ops.pop();
    }
    return this;
  };
  
  Delta.prototype.length = function () {
    return this.ops.reduce(function (length, elem) {
      return length + op.length(elem);
    }, 0);
  };
  
  Delta.prototype.slice = function (start, end) {
    start = start || 0;
    if (!is.number(end)) end = Infinity;
    var delta = new Delta();
    var iter = op.iterator(this.ops);
    var index = 0;
    while (index < end && iter.hasNext()) {
      var nextOp;
      if (index < start) {
        nextOp = iter.next(start - index);
      } else {
        nextOp = iter.next(end - index);
        delta.push(nextOp);
      }
      index += op.length(nextOp);
    }
    return delta;
  };
  
  
  Delta.prototype.compose = function (other) {
    var thisIter = op.iterator(this.ops);
    var otherIter = op.iterator(other.ops);
    var delta = new Delta();
    while (thisIter.hasNext() || otherIter.hasNext()) {
      if (otherIter.peekType() === 'insert') {
        delta.push(otherIter.next());
      } else if (thisIter.peekType() === 'delete') {
        delta.push(thisIter.next());
      } else {
        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
        var thisOp = thisIter.next(length);
        var otherOp = otherIter.next(length);
        if (is.number(otherOp.retain)) {
          var newOp = {};
          if (is.number(thisOp.retain)) {
            newOp.retain = length;
          } else {
            newOp.insert = thisOp.insert;
          }
          // Preserve null when composing with a retain, otherwise remove it for inserts
          var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, is.number(thisOp.retain));
          if (attributes) newOp.attributes = attributes;
          delta.push(newOp);
        // Other op should be delete, we could be an insert or retain
        // Insert + delete cancels out
        } else if (is.number(otherOp['delete']) && is.number(thisOp.retain)) {
          delta.push(otherOp);
        }
      }
    }
    return delta.chop();
  };
  
  Delta.prototype.concat = function (other) {
    var delta = this.slice();
    if (other.ops.length > 0) {
      delta.push(other.ops[0]);
      delta.ops = delta.ops.concat(other.ops.slice(1));
    }
    return delta;
  };
  
  Delta.prototype.diff = function (other) {
    var delta = new Delta();
    if (this.ops === other.ops) {
      return delta;
    }
    var strings = [this.ops, other.ops].map(function (ops) {
      return ops.map(function (op) {
        if (op.insert != null) {
          return is.string(op.insert) ? op.insert : NULL_CHARACTER;
        }
        var prep = (ops === other.ops) ? 'on' : 'with';
        throw new Error('diff() called ' + prep + ' non-document');
      }).join('');
    });
    var diffResult = diff(strings[0], strings[1]);
    var thisIter = op.iterator(this.ops);
    var otherIter = op.iterator(other.ops);
    diffResult.forEach(function (component) {
      var length = component[1].length;
      while (length > 0) {
        var opLength = 0;
        switch (component[0]) {
          case diff.INSERT:
            opLength = Math.min(otherIter.peekLength(), length);
            delta.push(otherIter.next(opLength));
            break;
          case diff.DELETE:
            opLength = Math.min(length, thisIter.peekLength());
            thisIter.next(opLength);
            delta['delete'](opLength);
            break;
          case diff.EQUAL:
            opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
            var thisOp = thisIter.next(opLength);
            var otherOp = otherIter.next(opLength);
            if (is.equal(thisOp.insert, otherOp.insert)) {
              delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
            } else {
              delta.push(otherOp)['delete'](opLength);
            }
            break;
        }
        length -= opLength;
      }
    });
    return delta.chop();
  };
  
  Delta.prototype.transform = function (other, priority) {
    priority = !!priority;
    if (is.number(other)) {
      return this.transformPosition(other, priority);
    }
    var thisIter = op.iterator(this.ops);
    var otherIter = op.iterator(other.ops);
    var delta = new Delta();
    while (thisIter.hasNext() || otherIter.hasNext()) {
      if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
        delta.retain(op.length(thisIter.next()));
      } else if (otherIter.peekType() === 'insert') {
        delta.push(otherIter.next());
      } else {
        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
        var thisOp = thisIter.next(length);
        var otherOp = otherIter.next(length);
        if (thisOp['delete']) {
          // Our delete either makes their delete redundant or removes their retain
          continue;
        } else if (otherOp['delete']) {
          delta.push(otherOp);
        } else {
          // We retain either their retain or insert
          delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
        }
      }
    }
    return delta.chop();
  };
  
  Delta.prototype.transformPosition = function (index, priority) {
    priority = !!priority;
    var thisIter = op.iterator(this.ops);
    var offset = 0;
    while (thisIter.hasNext() && offset <= index) {
      var length = thisIter.peekLength();
      var nextType = thisIter.peekType();
      thisIter.next();
      if (nextType === 'delete') {
        index -= Math.min(length, index - offset);
        continue;
      } else if (nextType === 'insert' && (offset < index || !priority)) {
        index += length;
      }
      offset += length;
    }
    return index;
  };
  
  
  module.exports = Delta;
  
  },{"./is":4,"./op":5,"fast-diff":6}],4:[function(_dereq_,module,exports){
  module.exports = {
    equal: function (a, b) {
      if (a === b) return true;
      if (a == null && b == null) return true;
      if (a == null || b == null) return false;
      if (!this.object(a) || !this.object(b)) return false;
      if (Object.keys(a).length != Object.keys(b).length) return false;
      for(var key in a) {
        // Only compare one level deep
        if (a[key] !== b[key]) return false;
      }
      return true;
    },
  
    array: function (value) {
      return Array.isArray(value);
    },
  
    number: function (value) {
      if (typeof value === 'number') return true;
      if (typeof value === 'object' && Object.prototype.toString.call(value) === '[object Number]') return true;
      return false;
    },
  
    object: function (value) {
      if (!value) return false;
      return (typeof value === 'function' || typeof value === 'object');
    },
  
    string: function (value) {
      if (typeof value === 'string') return true;
      if (typeof value === 'object' && Object.prototype.toString.call(value) === '[object String]') return true;
      return false;
    }
  };
  
  },{}],5:[function(_dereq_,module,exports){
  var is = _dereq_('./is');
  
  
  var lib = {
    attributes: {
      clone: function (attributes, keepNull) {
        if (!is.object(attributes)) return {};
        return Object.keys(attributes).reduce(function (memo, key) {
          if (attributes[key] !== undefined && (attributes[key] !== null || keepNull)) {
            memo[key] = attributes[key];
          }
          return memo;
        }, {});
      },
  
      compose: function (a, b, keepNull) {
        if (!is.object(a)) a = {};
        if (!is.object(b)) b = {};
        var attributes = this.clone(b, keepNull);
        for (var key in a) {
          if (a[key] !== undefined && b[key] === undefined) {
            attributes[key] = a[key];
          }
        }
        return Object.keys(attributes).length > 0 ? attributes : undefined;
      },
  
      diff: function(a, b) {
        if (!is.object(a)) a = {};
        if (!is.object(b)) b = {};
        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
          if (a[key] !== b[key]) {
            attributes[key] = b[key] === undefined ? null : b[key];
          }
          return attributes;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
      },
  
      transform: function (a, b, priority) {
        if (!is.object(a)) return b;
        if (!is.object(b)) return undefined;
        if (!priority) return b;  // b simply overwrites us without priority
        var attributes = Object.keys(b).reduce(function (attributes, key) {
          if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
          return attributes;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
      }
    },
  
    clone: function (op) {
      var newOp = this.attributes.clone(op);
      if (is.object(newOp.attributes)) {
        newOp.attributes = this.attributes.clone(newOp.attributes, true);
      }
      return newOp;
    },
  
    iterator: function (ops) {
      return new Iterator(ops);
    },
  
    length: function (op) {
      if (is.number(op['delete'])) {
        return op['delete'];
      } else if (is.number(op.retain)) {
        return op.retain;
      } else {
        return is.string(op.insert) ? op.insert.length : 1;
      }
    }
  };
  
  
  function Iterator(ops) {
    this.ops = ops;
    this.index = 0;
    this.offset = 0;
  };
  
  Iterator.prototype.hasNext = function () {
    return this.peekLength() < Infinity;
  };
  
  Iterator.prototype.next = function (length) {
    if (!length) length = Infinity;
    var nextOp = this.ops[this.index];
    if (nextOp) {
      var offset = this.offset;
      var opLength = lib.length(nextOp)
      if (length >= opLength - offset) {
        length = opLength - offset;
        this.index += 1;
        this.offset = 0;
      } else {
        this.offset += length;
      }
      if (is.number(nextOp['delete'])) {
        return { 'delete': length };
      } else {
        var retOp = {};
        if (nextOp.attributes) {
          retOp.attributes = nextOp.attributes;
        }
        if (is.number(nextOp.retain)) {
          retOp.retain = length;
        } else if (is.string(nextOp.insert)) {
          retOp.insert = nextOp.insert.substr(offset, length);
        } else {
          // offset should === 0, length should === 1
          retOp.insert = nextOp.insert;
        }
        return retOp;
      }
    } else {
      return { retain: Infinity };
    }
  };
  
  Iterator.prototype.peekLength = function () {
    if (this.ops[this.index]) {
      // Should never return 0 if our index is being managed correctly
      return lib.length(this.ops[this.index]) - this.offset;
    } else {
      return Infinity;
    }
  };
  
  Iterator.prototype.peekType = function () {
    if (this.ops[this.index]) {
      if (is.number(this.ops[this.index]['delete'])) {
        return 'delete';
      } else if (is.number(this.ops[this.index].retain)) {
        return 'retain';
      } else {
        return 'insert';
      }
    }
    return 'retain';
  };
  
  
  module.exports = lib;
  
  },{"./is":4}],6:[function(_dereq_,module,exports){
  /**
   * This library modifies the diff-patch-match library by Neil Fraser
   * by removing the patch and match functionality and certain advanced
   * options in the diff function. The original license is as follows:
   *
   * ===
   *
   * Diff Match and Patch
   *
   * Copyright 2006 Google Inc.
   * http://code.google.com/p/google-diff-match-patch/
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  
  
  /**
   * The data structure representing a diff is an array of tuples:
   * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
   * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
   */
  var DIFF_DELETE = -1;
  var DIFF_INSERT = 1;
  var DIFF_EQUAL = 0;
  
  
  /**
   * Find the differences between two texts.  Simplifies the problem by stripping
   * any common prefix or suffix off the texts before diffing.
   * @param {string} text1 Old string to be diffed.
   * @param {string} text2 New string to be diffed.
   * @return {Array} Array of diff tuples.
   */
  function diff_main(text1, text2) {
    // Check for equality (speedup).
    if (text1 == text2) {
      if (text1) {
        return [[DIFF_EQUAL, text1]];
      }
      return [];
    }
  
    // Trim off common prefix (speedup).
    var commonlength = diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
  
    // Trim off common suffix (speedup).
    commonlength = diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
  
    // Compute the diff on the middle block.
    var diffs = diff_compute_(text1, text2);
  
    // Restore the prefix and suffix.
    if (commonprefix) {
      diffs.unshift([DIFF_EQUAL, commonprefix]);
    }
    if (commonsuffix) {
      diffs.push([DIFF_EQUAL, commonsuffix]);
    }
    diff_cleanupMerge(diffs);
    return diffs;
  };
  
  
  /**
   * Find the differences between two texts.  Assumes that the texts do not
   * have any common prefix or suffix.
   * @param {string} text1 Old string to be diffed.
   * @param {string} text2 New string to be diffed.
   * @return {Array} Array of diff tuples.
   */
  function diff_compute_(text1, text2) {
    var diffs;
  
    if (!text1) {
      // Just add some text (speedup).
      return [[DIFF_INSERT, text2]];
    }
  
    if (!text2) {
      // Just delete some text (speedup).
      return [[DIFF_DELETE, text1]];
    }
  
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i != -1) {
      // Shorter text is inside the longer text (speedup).
      diffs = [[DIFF_INSERT, longtext.substring(0, i)],
               [DIFF_EQUAL, shorttext],
               [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
      // Swap insertions for deletions if diff is reversed.
      if (text1.length > text2.length) {
        diffs[0][0] = diffs[2][0] = DIFF_DELETE;
      }
      return diffs;
    }
  
    if (shorttext.length == 1) {
      // Single character string.
      // After the previous speedup, the character can't be an equality.
      return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
    }
  
    // Check to see if the problem can be split in two.
    var hm = diff_halfMatch_(text1, text2);
    if (hm) {
      // A half-match was found, sort out the return data.
      var text1_a = hm[0];
      var text1_b = hm[1];
      var text2_a = hm[2];
      var text2_b = hm[3];
      var mid_common = hm[4];
      // Send both pairs off for separate processing.
      var diffs_a = diff_main(text1_a, text2_a);
      var diffs_b = diff_main(text1_b, text2_b);
      // Merge the results.
      return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
    }
  
    return diff_bisect_(text1, text2);
  };
  
  
  /**
   * Find the 'middle snake' of a diff, split the problem in two
   * and return the recursively constructed diff.
   * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
   * @param {string} text1 Old string to be diffed.
   * @param {string} text2 New string to be diffed.
   * @return {Array} Array of diff tuples.
   * @private
   */
  function diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for (var x = 0; x < v_length; x++) {
      v1[x] = -1;
      v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = (delta % 2 != 0);
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for (var d = 0; d < max_d; d++) {
      // Walk the front path one step.
      for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
        var k1_offset = v_offset + k1;
        var x1;
        if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
          x1 = v1[k1_offset + 1];
        } else {
          x1 = v1[k1_offset - 1] + 1;
        }
        var y1 = x1 - k1;
        while (x1 < text1_length && y1 < text2_length &&
               text1.charAt(x1) == text2.charAt(y1)) {
          x1++;
          y1++;
        }
        v1[k1_offset] = x1;
        if (x1 > text1_length) {
          // Ran off the right of the graph.
          k1end += 2;
        } else if (y1 > text2_length) {
          // Ran off the bottom of the graph.
          k1start += 2;
        } else if (front) {
          var k2_offset = v_offset + delta - k1;
          if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
            // Mirror x2 onto top-left coordinate system.
            var x2 = text1_length - v2[k2_offset];
            if (x1 >= x2) {
              // Overlap detected.
              return diff_bisectSplit_(text1, text2, x1, y1);
            }
          }
        }
      }
  
      // Walk the reverse path one step.
      for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
        var k2_offset = v_offset + k2;
        var x2;
        if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
          x2 = v2[k2_offset + 1];
        } else {
          x2 = v2[k2_offset - 1] + 1;
        }
        var y2 = x2 - k2;
        while (x2 < text1_length && y2 < text2_length &&
               text1.charAt(text1_length - x2 - 1) ==
               text2.charAt(text2_length - y2 - 1)) {
          x2++;
          y2++;
        }
        v2[k2_offset] = x2;
        if (x2 > text1_length) {
          // Ran off the left of the graph.
          k2end += 2;
        } else if (y2 > text2_length) {
          // Ran off the top of the graph.
          k2start += 2;
        } else if (!front) {
          var k1_offset = v_offset + delta - k2;
          if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
            var x1 = v1[k1_offset];
            var y1 = v_offset + x1 - k1_offset;
            // Mirror x2 onto top-left coordinate system.
            x2 = text1_length - x2;
            if (x1 >= x2) {
              // Overlap detected.
              return diff_bisectSplit_(text1, text2, x1, y1);
            }
          }
        }
      }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  };
  
  
  /**
   * Given the location of the 'middle snake', split the diff in two parts
   * and recurse.
   * @param {string} text1 Old string to be diffed.
   * @param {string} text2 New string to be diffed.
   * @param {number} x Index of split point in text1.
   * @param {number} y Index of split point in text2.
   * @return {Array} Array of diff tuples.
   */
  function diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
  
    // Compute both diffs serially.
    var diffs = diff_main(text1a, text2a);
    var diffsb = diff_main(text1b, text2b);
  
    return diffs.concat(diffsb);
  };
  
  
  /**
   * Determine the common prefix of two strings.
   * @param {string} text1 First string.
   * @param {string} text2 Second string.
   * @return {number} The number of characters common to the start of each
   *     string.
   */
  function diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
      return 0;
    }
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while (pointermin < pointermid) {
      if (text1.substring(pointerstart, pointermid) ==
          text2.substring(pointerstart, pointermid)) {
        pointermin = pointermid;
        pointerstart = pointermin;
      } else {
        pointermax = pointermid;
      }
      pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
  };
  
  
  /**
   * Determine the common suffix of two strings.
   * @param {string} text1 First string.
   * @param {string} text2 Second string.
   * @return {number} The number of characters common to the end of each string.
   */
  function diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 ||
        text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
      return 0;
    }
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while (pointermin < pointermid) {
      if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
          text2.substring(text2.length - pointermid, text2.length - pointerend)) {
        pointermin = pointermid;
        pointerend = pointermin;
      } else {
        pointermax = pointermid;
      }
      pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
  };
  
  
  /**
   * Do the two texts share a substring which is at least half the length of the
   * longer text?
   * This speedup can produce non-minimal diffs.
   * @param {string} text1 First string.
   * @param {string} text2 Second string.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     text1, the suffix of text1, the prefix of text2, the suffix of
   *     text2 and the common middle.  Or null if there was no match.
   */
  function diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
      return null;  // Pointless.
    }
  
    /**
     * Does a substring of shorttext exist within longtext such that the substring
     * is at least half the length of longtext?
     * Closure, but does not reference any external variables.
     * @param {string} longtext Longer string.
     * @param {string} shorttext Shorter string.
     * @param {number} i Start index of quarter length substring within longtext.
     * @return {Array.<string>} Five element Array, containing the prefix of
     *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
     *     of shorttext and the common middle.  Or null if there was no match.
     * @private
     */
    function diff_halfMatchI_(longtext, shorttext, i) {
      // Start with a 1/4 length substring at position i as a seed.
      var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
      var j = -1;
      var best_common = '';
      var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
      while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
        var prefixLength = diff_commonPrefix(longtext.substring(i),
                                             shorttext.substring(j));
        var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                             shorttext.substring(0, j));
        if (best_common.length < suffixLength + prefixLength) {
          best_common = shorttext.substring(j - suffixLength, j) +
              shorttext.substring(j, j + prefixLength);
          best_longtext_a = longtext.substring(0, i - suffixLength);
          best_longtext_b = longtext.substring(i + prefixLength);
          best_shorttext_a = shorttext.substring(0, j - suffixLength);
          best_shorttext_b = shorttext.substring(j + prefixLength);
        }
      }
      if (best_common.length * 2 >= longtext.length) {
        return [best_longtext_a, best_longtext_b,
                best_shorttext_a, best_shorttext_b, best_common];
      } else {
        return null;
      }
    }
  
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext,
                               Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext,
                               Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) {
      return null;
    } else if (!hm2) {
      hm = hm1;
    } else if (!hm1) {
      hm = hm2;
    } else {
      // Both matched.  Select the longest.
      hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    }
  
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
      text1_a = hm[0];
      text1_b = hm[1];
      text2_a = hm[2];
      text2_b = hm[3];
    } else {
      text2_a = hm[0];
      text2_b = hm[1];
      text1_a = hm[2];
      text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [text1_a, text1_b, text2_a, text2_b, mid_common];
  };
  
  
  /**
   * Reorder and merge like edit sections.  Merge equalities.
   * Any edit section can move as long as it doesn't cross an equality.
   * @param {Array} diffs Array of diff tuples.
   */
  function diff_cleanupMerge(diffs) {
    diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = '';
    var text_insert = '';
    var commonlength;
    while (pointer < diffs.length) {
      switch (diffs[pointer][0]) {
        case DIFF_INSERT:
          count_insert++;
          text_insert += diffs[pointer][1];
          pointer++;
          break;
        case DIFF_DELETE:
          count_delete++;
          text_delete += diffs[pointer][1];
          pointer++;
          break;
        case DIFF_EQUAL:
          // Upon reaching an equality, check for prior redundancies.
          if (count_delete + count_insert > 1) {
            if (count_delete !== 0 && count_insert !== 0) {
              // Factor out any common prefixies.
              commonlength = diff_commonPrefix(text_insert, text_delete);
              if (commonlength !== 0) {
                if ((pointer - count_delete - count_insert) > 0 &&
                    diffs[pointer - count_delete - count_insert - 1][0] ==
                    DIFF_EQUAL) {
                  diffs[pointer - count_delete - count_insert - 1][1] +=
                      text_insert.substring(0, commonlength);
                } else {
                  diffs.splice(0, 0, [DIFF_EQUAL,
                                      text_insert.substring(0, commonlength)]);
                  pointer++;
                }
                text_insert = text_insert.substring(commonlength);
                text_delete = text_delete.substring(commonlength);
              }
              // Factor out any common suffixies.
              commonlength = diff_commonSuffix(text_insert, text_delete);
              if (commonlength !== 0) {
                diffs[pointer][1] = text_insert.substring(text_insert.length -
                    commonlength) + diffs[pointer][1];
                text_insert = text_insert.substring(0, text_insert.length -
                    commonlength);
                text_delete = text_delete.substring(0, text_delete.length -
                    commonlength);
              }
            }
            // Delete the offending records and add the merged ones.
            if (count_delete === 0) {
              diffs.splice(pointer - count_insert,
                  count_delete + count_insert, [DIFF_INSERT, text_insert]);
            } else if (count_insert === 0) {
              diffs.splice(pointer - count_delete,
                  count_delete + count_insert, [DIFF_DELETE, text_delete]);
            } else {
              diffs.splice(pointer - count_delete - count_insert,
                  count_delete + count_insert, [DIFF_DELETE, text_delete],
                  [DIFF_INSERT, text_insert]);
            }
            pointer = pointer - count_delete - count_insert +
                      (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
          } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
            // Merge this equality with the previous one.
            diffs[pointer - 1][1] += diffs[pointer][1];
            diffs.splice(pointer, 1);
          } else {
            pointer++;
          }
          count_insert = 0;
          count_delete = 0;
          text_delete = '';
          text_insert = '';
          break;
      }
    }
    if (diffs[diffs.length - 1][1] === '') {
      diffs.pop();  // Remove the dummy entry at the end.
    }
  
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while (pointer < diffs.length - 1) {
      if (diffs[pointer - 1][0] == DIFF_EQUAL &&
          diffs[pointer + 1][0] == DIFF_EQUAL) {
        // This is a single edit surrounded by equalities.
        if (diffs[pointer][1].substring(diffs[pointer][1].length -
            diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
          // Shift the edit over the previous equality.
          diffs[pointer][1] = diffs[pointer - 1][1] +
              diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                          diffs[pointer - 1][1].length);
          diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
          diffs.splice(pointer - 1, 1);
          changes = true;
        } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
            diffs[pointer + 1][1]) {
          // Shift the edit over the next equality.
          diffs[pointer - 1][1] += diffs[pointer + 1][1];
          diffs[pointer][1] =
              diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
              diffs[pointer + 1][1];
          diffs.splice(pointer + 1, 1);
          changes = true;
        }
      }
      pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) {
      diff_cleanupMerge(diffs);
    }
  };
  
  
  var diff = diff_main;
  diff.INSERT = DIFF_INSERT;
  diff.DELETE = DIFF_DELETE;
  diff.EQUAL = DIFF_EQUAL;
  
  
  module.exports = diff;
  
  },{}],7:[function(_dereq_,module,exports){
  module.exports={"version":"0.20.1"}
  },{}],8:[function(_dereq_,module,exports){
  var Delta, Document, Format, Line, LinkedList, Normalizer, _, dom;
  
  _ = _dereq_('lodash');
  
  Delta = _dereq_('rich-text/lib/delta');
  
  dom = _dereq_('../lib/dom');
  
  Format = _dereq_('./format');
  
  Line = _dereq_('./line');
  
  LinkedList = _dereq_('../lib/linked-list');
  
  Normalizer = _dereq_('./normalizer');
  
  Document = (function() {
    function Document(root, options) {
      this.root = root;
      if (options == null) {
        options = {};
      }
      this.normalizer = new Normalizer();
      this.formats = {};
      _.each(options.formats, _.bind(this.addFormat, this));
      this.setHTML(this.root.innerHTML);
    }
  
    Document.prototype.addFormat = function(name, config) {
      if (!_.isObject(config)) {
        config = Format.FORMATS[name];
      }
      if (this.formats[name] != null) {
        console.warn('Overwriting format', name, this.formats[name]);
      }
      this.formats[name] = new Format(config);
      return this.normalizer.addFormat(config);
    };
  
    Document.prototype.appendLine = function(lineNode) {
      return this.insertLineBefore(lineNode, null);
    };
  
    Document.prototype.findLeafAt = function(index, inclusive) {
      var line, offset, ref;
      ref = this.findLineAt(index), line = ref[0], offset = ref[1];
      if (line != null) {
        return line.findLeafAt(offset, inclusive);
      } else {
        return [void 0, offset];
      }
    };
  
    Document.prototype.findLine = function(node) {
      var line;
      while ((node != null) && (dom.BLOCK_TAGS[node.tagName] == null)) {
        node = node.parentNode;
      }
      line = node != null ? dom(node).data(Line.DATA_KEY) : void 0;
      if ((line != null ? line.node : void 0) === node) {
        return line;
      } else {
        return void 0;
      }
    };
  
    Document.prototype.findLineAt = function(index) {
      var curLine, length;
      if (!(this.lines.length > 0)) {
        return [void 0, index];
      }
      length = this.toDelta().length();
      if (index === length) {
        return [this.lines.last, this.lines.last.length];
      }
      if (index > length) {
        return [void 0, index - length];
      }
      curLine = this.lines.first;
      while (curLine != null) {
        if (index < curLine.length) {
          return [curLine, index];
        }
        index -= curLine.length;
        curLine = curLine.next;
      }
      return [void 0, index];
    };
  
    Document.prototype.getHTML = function() {
      return this.root.innerHTML.replace(/\>\s+\</g, '>&nbsp;<');
    };
  
    Document.prototype.insertLineBefore = function(newLineNode, refLine) {
      var line;
      line = new Line(this, newLineNode);
      if (refLine != null) {
        if (!dom(newLineNode.parentNode).isElement()) {
          this.root.insertBefore(newLineNode, refLine.node);
        }
        this.lines.insertAfter(refLine.prev, line);
      } else {
        if (!dom(newLineNode.parentNode).isElement()) {
          this.root.appendChild(newLineNode);
        }
        this.lines.append(line);
      }
      return line;
    };
  
    Document.prototype.mergeLines = function(line, lineToMerge) {
      if (lineToMerge.length > 1) {
        if (line.length === 1) {
          dom(line.leaves.last.node).remove();
        }
        _.each(dom(lineToMerge.node).childNodes(), function(child) {
          if (child.tagName !== dom.DEFAULT_BREAK_TAG) {
            return line.node.appendChild(child);
          }
        });
      }
      this.removeLine(lineToMerge);
      return line.rebuild();
    };
  
    Document.prototype.optimizeLines = function() {
      return _.each(this.lines.toArray(), function(line, i) {
        line.optimize();
        return true;
      });
    };
  
    Document.prototype.rebuild = function() {
      var lineNode, lines, results;
      lines = this.lines.toArray();
      lineNode = this.root.firstChild;
      if ((lineNode != null) && (dom.LIST_TAGS[lineNode.tagName] != null)) {
        lineNode = lineNode.firstChild;
      }
      _.each(lines, (function(_this) {
        return function(line, index) {
          var newLine, ref;
          while (line.node !== lineNode) {
            if (line.node.parentNode === _this.root || ((ref = line.node.parentNode) != null ? ref.parentNode : void 0) === _this.root) {
              lineNode = _this.normalizer.normalizeLine(lineNode);
              newLine = _this.insertLineBefore(lineNode, line);
              lineNode = dom(lineNode).nextLineNode(_this.root);
            } else {
              return _this.removeLine(line);
            }
          }
          if (line.outerHTML !== lineNode.outerHTML) {
            line.node = _this.normalizer.normalizeLine(line.node);
            line.rebuild();
          }
          return lineNode = dom(lineNode).nextLineNode(_this.root);
        };
      })(this));
      results = [];
      while (lineNode != null) {
        lineNode = this.normalizer.normalizeLine(lineNode);
        this.appendLine(lineNode);
        results.push(lineNode = dom(lineNode).nextLineNode(this.root));
      }
      return results;
    };
  
    Document.prototype.removeLine = function(line) {
      if (line.node.parentNode != null) {
        if (dom.LIST_TAGS[line.node.parentNode.tagName] && line.node.parentNode.childNodes.length === 1) {
          dom(line.node.parentNode).remove();
        } else {
          dom(line.node).remove();
        }
      }
      return this.lines.remove(line);
    };
  
    Document.prototype.setHTML = function(html) {
      html = Normalizer.stripComments(html);
      html = Normalizer.stripWhitespace(html);
      this.root.innerHTML = html;
      this.lines = new LinkedList();
      return this.rebuild();
    };
  
    Document.prototype.splitLine = function(line, offset) {
      var lineNode1, lineNode2, newLine, ref;
      offset = Math.min(offset, line.length - 1);
      ref = dom(line.node).split(offset, true), lineNode1 = ref[0], lineNode2 = ref[1];
      line.node = lineNode1;
      line.rebuild();
      newLine = this.insertLineBefore(lineNode2, line.next);
      newLine.formats = _.clone(line.formats);
      newLine.resetContent();
      return newLine;
    };
  
    Document.prototype.toDelta = function() {
      var delta, lines;
      lines = this.lines.toArray();
      delta = new Delta();
      _.each(lines, function(line) {
        return _.each(line.delta.ops, function(op) {
          return delta.push(op);
        });
      });
      return delta;
    };
  
    return Document;
  
  })();
  
  module.exports = Document;
  
  
  },{"../lib/dom":17,"../lib/linked-list":18,"./format":10,"./line":12,"./normalizer":13,"lodash":1,"rich-text/lib/delta":3}],9:[function(_dereq_,module,exports){
  var Delta, Document, Editor, Line, Selection, _, dom;
  
  _ = _dereq_('lodash');
  
  Delta = _dereq_('rich-text/lib/delta');
  
  dom = _dereq_('../lib/dom');
  
  Document = _dereq_('./document');
  
  Line = _dereq_('./line');
  
  Selection = _dereq_('./selection');
  
  Editor = (function() {
    Editor.sources = {
      API: 'api',
      SILENT: 'silent',
      USER: 'user'
    };
  
    function Editor(root, quill, options) {
      this.root = root;
      this.quill = quill;
      this.options = options != null ? options : {};
      this.root.setAttribute('id', this.options.id);
      this.doc = new Document(this.root, this.options);
      this.delta = this.doc.toDelta();
      this.length = this.delta.length();
      this.selection = new Selection(this.doc, this.quill);
      this.timer = setInterval(_.bind(this.checkUpdate, this), this.options.pollInterval);
      this.savedRange = null;
      this.quill.on("selection-change", (function(_this) {
        return function(range) {
          return _this.savedRange = range;
        };
      })(this));
      if (!this.options.readOnly) {
        this.enable();
      }
    }
  
    Editor.prototype.destroy = function() {
      return clearInterval(this.timer);
    };
  
    Editor.prototype.disable = function() {
      return this.enable(false);
    };
  
    Editor.prototype.enable = function(enabled) {
      if (enabled == null) {
        enabled = true;
      }
      return this.root.setAttribute('contenteditable', enabled);
    };
  
    Editor.prototype.applyDelta = function(delta, source) {
      var localDelta;
      localDelta = this._update();
      if (localDelta) {
        delta = localDelta.transform(delta, true);
        localDelta = delta.transform(localDelta, false);
      }
      if (delta.ops.length > 0) {
        delta = this._trackDelta((function(_this) {
          return function() {
            var index;
            index = 0;
            _.each(delta.ops, function(op) {
              if (_.isString(op.insert)) {
                _this._insertAt(index, op.insert, op.attributes);
                return index += op.insert.length;
              } else if (_.isNumber(op.insert)) {
                _this._insertEmbed(index, op.attributes);
                return index += 1;
              } else if (_.isNumber(op["delete"])) {
                return _this._deleteAt(index, op["delete"]);
              } else if (_.isNumber(op.retain)) {
                _.each(op.attributes, function(value, name) {
                  return _this._formatAt(index, op.retain, name, value);
                });
                return index += op.retain;
              }
            });
            return _this.selection.shiftAfter(0, 0, _.bind(_this.doc.optimizeLines, _this.doc));
          };
        })(this));
        this.delta = this.doc.toDelta();
        this.length = this.delta.length();
        this.innerHTML = this.root.innerHTML;
        if (delta && source !== Editor.sources.SILENT) {
          this.quill.emit(this.quill.constructor.events.TEXT_CHANGE, delta, source);
        }
      }
      if (localDelta && localDelta.ops.length > 0 && source !== Editor.sources.SILENT) {
        return this.quill.emit(this.quill.constructor.events.TEXT_CHANGE, localDelta, Editor.sources.USER);
      }
    };
  
    Editor.prototype.checkUpdate = function(source) {
      var delta;
      if (source == null) {
        source = 'user';
      }
      if (this.root.parentNode == null) {
        return clearInterval(this.timer);
      }
      delta = this._update();
      if (delta) {
        this.delta = this.delta.compose(delta);
        this.length = this.delta.length();
        this.quill.emit(this.quill.constructor.events.TEXT_CHANGE, delta, source);
      }
      if (delta) {
        source = Editor.sources.SILENT;
      }
      return this.selection.update(source);
    };
  
    Editor.prototype.focus = function() {
      if (this.selection.range != null) {
        return this.selection.setRange(this.selection.range);
      } else {
        return this.root.focus();
      }
    };
  
    Editor.prototype.getBounds = function(index) {
      var bounds, containerBounds, leaf, offset, range, ref, side;
      this.checkUpdate();
      ref = this.doc.findLeafAt(index, true), leaf = ref[0], offset = ref[1];
      if (leaf == null) {
        return null;
      }
      containerBounds = this.root.parentNode.getBoundingClientRect();
      side = 'left';
      if (leaf.length === 0) {
        bounds = leaf.node.parentNode.getBoundingClientRect();
      } else if (dom.VOID_TAGS[leaf.node.tagName]) {
        bounds = leaf.node.getBoundingClientRect();
        if (offset === 1) {
          side = 'right';
        }
      } else {
        range = document.createRange();
        if (offset < leaf.length) {
          range.setStart(leaf.node, offset);
          range.setEnd(leaf.node, offset + 1);
        } else {
          range.setStart(leaf.node, offset - 1);
          range.setEnd(leaf.node, offset);
          side = 'right';
        }
        bounds = range.getBoundingClientRect();
      }
      return {
        height: bounds.height,
        left: bounds[side] - containerBounds.left,
        top: bounds.top - containerBounds.top
      };
    };
  
    Editor.prototype._deleteAt = function(index, length) {
      if (length <= 0) {
        return;
      }
      return this.selection.shiftAfter(index, -1 * length, (function(_this) {
        return function() {
          var curLine, deleteLength, firstLine, mergeFirstLine, nextLine, offset, ref;
          ref = _this.doc.findLineAt(index), firstLine = ref[0], offset = ref[1];
          curLine = firstLine;
          mergeFirstLine = firstLine.length - offset <= length && offset > 0;
          while ((curLine != null) && length > 0) {
            nextLine = curLine.next;
            deleteLength = Math.min(curLine.length - offset, length);
            if (offset === 0 && length >= curLine.length) {
              _this.doc.removeLine(curLine);
            } else {
              curLine.deleteText(offset, deleteLength);
            }
            length -= deleteLength;
            curLine = nextLine;
            offset = 0;
          }
          if (mergeFirstLine && firstLine.next) {
            return _this.doc.mergeLines(firstLine, firstLine.next);
          }
        };
      })(this));
    };
  
    Editor.prototype._formatAt = function(index, length, name, value) {
      return this.selection.shiftAfter(index, 0, (function(_this) {
        return function() {
          var formatLength, line, offset, ref, results;
          ref = _this.doc.findLineAt(index), line = ref[0], offset = ref[1];
          results = [];
          while ((line != null) && length > 0) {
            formatLength = Math.min(length, line.length - offset - 1);
            line.formatText(offset, formatLength, name, value);
            length -= formatLength;
            if (length > 0) {
              line.format(name, value);
            }
            length -= 1;
            offset = 0;
            results.push(line = line.next);
          }
          return results;
        };
      })(this));
    };
  
    Editor.prototype._insertEmbed = function(index, attributes) {
      return this.selection.shiftAfter(index, 1, (function(_this) {
        return function() {
          var line, offset, ref;
          ref = _this.doc.findLineAt(index), line = ref[0], offset = ref[1];
          return line.insertEmbed(offset, attributes);
        };
      })(this));
    };
  
    Editor.prototype._insertAt = function(index, text, formatting) {
      if (formatting == null) {
        formatting = {};
      }
      return this.selection.shiftAfter(index, text.length, (function(_this) {
        return function() {
          var line, lineTexts, offset, ref;
          text = text.replace(/\r\n?/g, '\n');
          lineTexts = text.split('\n');
          ref = _this.doc.findLineAt(index), line = ref[0], offset = ref[1];
          return _.each(lineTexts, function(lineText, i) {
            var nextLine;
            if ((line == null) || line.length <= offset) {
              if (i < lineTexts.length - 1 || lineText.length > 0) {
                line = _this.doc.appendLine(document.createElement(dom.DEFAULT_BLOCK_TAG));
                offset = 0;
                line.insertText(offset, lineText, formatting);
                line.format(formatting);
                nextLine = null;
              }
            } else {
              line.insertText(offset, lineText, formatting);
              if (i < lineTexts.length - 1) {
                nextLine = _this.doc.splitLine(line, offset + lineText.length);
                _.each(_.defaults({}, formatting, line.formats), function(value, format) {
                  return line.format(format, formatting[format]);
                });
                offset = 0;
              }
            }
            return line = nextLine;
          });
        };
      })(this));
    };
  
    Editor.prototype._trackDelta = function(fn) {
      var ignored, newDelta, newIndex, newLeftDelta, newRightDelta, oldIndex, oldLeftDelta, oldRightDelta, ref, ref1;
      oldIndex = (ref = this.savedRange) != null ? ref.start : void 0;
      fn();
      newDelta = this.doc.toDelta();
      this.savedRange = this.selection.getRange();
      newIndex = (ref1 = this.savedRange) != null ? ref1.start : void 0;
      try {
        if ((oldIndex != null) && (newIndex != null) && oldIndex <= this.delta.length() && newIndex <= newDelta.length()) {
          oldRightDelta = this.delta.slice(oldIndex);
          newRightDelta = newDelta.slice(newIndex);
          if (_.isEqual(oldRightDelta.ops, newRightDelta.ops)) {
            oldLeftDelta = this.delta.slice(0, oldIndex);
            newLeftDelta = newDelta.slice(0, newIndex);
            return oldLeftDelta.diff(newLeftDelta);
          }
        }
      } catch (_error) {
        ignored = _error;
      }
      return this.delta.diff(newDelta);
    };
  
    Editor.prototype._update = function() {
      var delta;
      if (this.innerHTML === this.root.innerHTML) {
        return false;
      }
      delta = this._trackDelta((function(_this) {
        return function() {
          _this.selection.preserve(_.bind(_this.doc.rebuild, _this.doc));
          return _this.selection.shiftAfter(0, 0, _.bind(_this.doc.optimizeLines, _this.doc));
        };
      })(this));
      this.innerHTML = this.root.innerHTML;
      if (delta.ops.length > 0) {
        return delta;
      } else {
        return false;
      }
    };
  
    return Editor;
  
  })();
  
  module.exports = Editor;
  
  
  },{"../lib/dom":17,"./document":8,"./line":12,"./selection":14,"lodash":1,"rich-text/lib/delta":3}],10:[function(_dereq_,module,exports){
  var Format, _, dom;
  
  _ = _dereq_('lodash');
  
  dom = _dereq_('../lib/dom');
  
  Format = (function() {
    Format.types = {
      LINE: 'line',
      EMBED: 'embed'
    };
  
    Format.FORMATS = {
      bold: {
        tag: 'B',
        prepare: 'bold'
      },
      italic: {
        tag: 'I',
        prepare: 'italic'
      },
      underline: {
        tag: 'U',
        prepare: 'underline'
      },
      strike: {
        tag: 'S',
        prepare: 'strikeThrough'
      },
      color: {
        style: 'color',
        "default": 'rgb(0, 0, 0)',
        prepare: 'foreColor'
      },
      background: {
        style: 'backgroundColor',
        "default": 'rgb(255, 255, 255)',
        prepare: 'backColor'
      },
      font: {
        style: 'fontFamily',
        "default": "'Helvetica', 'Arial', sans-serif",
        prepare: 'fontName'
      },
      size: {
        style: 'fontSize',
        "default": '13px',
        prepare: function(value) {
          return document.execCommand('fontSize', false, dom.convertFontSize(value));
        }
      },
      link: {
        tag: 'A',
        add: function(node, value) {
          node.setAttribute('href', value);
          return node;
        },
        remove: function(node) {
          node.removeAttribute('href');
          return node;
        },
        value: function(node) {
          return node.getAttribute('href');
        }
      },
      image: {
        type: Format.types.EMBED,
        tag: 'IMG',
        attribute: 'src'
      },
      align: {
        type: Format.types.LINE,
        style: 'textAlign',
        "default": 'left'
      },
      bullet: {
        type: Format.types.LINE,
        exclude: 'list',
        parentTag: 'UL',
        tag: 'LI'
      },
      list: {
        type: Format.types.LINE,
        exclude: 'bullet',
        parentTag: 'OL',
        tag: 'LI'
      }
    };
  
    function Format(config) {
      this.config = config;
    }
  
    Format.prototype.add = function(node, value) {
      var formatNode, inline, parentNode, ref, ref1;
      if (!value) {
        return this.remove(node);
      }
      if (this.value(node) === value) {
        return node;
      }
      if (_.isString(this.config.parentTag)) {
        parentNode = node.parentNode;
        if (parentNode.tagName !== this.config.parentTag) {
          parentNode = document.createElement(this.config.parentTag);
          dom(node).wrap(parentNode);
        }
        if (node.parentNode.tagName === ((ref = node.parentNode.previousSibling) != null ? ref.tagName : void 0)) {
          dom(node.parentNode.previousSibling).merge(node.parentNode);
        }
        if (node.parentNode.tagName === ((ref1 = node.parentNode.nextSibling) != null ? ref1.tagName : void 0)) {
          dom(node.parentNode).merge(node.parentNode.nextSibling);
        }
      }
      if (_.isString(this.config.tag) && node.tagName !== this.config.tag) {
        formatNode = document.createElement(this.config.tag);
        if (dom.VOID_TAGS[formatNode.tagName] != null) {
          if (node.parentNode != null) {
            dom(node).replace(formatNode);
          }
          node = formatNode;
        } else if (this.isType(Format.types.LINE)) {
          node = dom(node).switchTag(this.config.tag).get();
        } else {
          dom(node).wrap(formatNode);
          node = formatNode;
        }
      }
      if (_.isString(this.config.style) || _.isString(this.config.attribute) || _.isString(this.config["class"])) {
        if (_.isString(this.config["class"])) {
          node = this.remove(node);
        }
        if (dom(node).isTextNode()) {
          inline = document.createElement(dom.DEFAULT_INLINE_TAG);
          dom(node).wrap(inline);
          node = inline;
        }
        if (_.isString(this.config.style)) {
          if (value !== this.config["default"]) {
            node.style[this.config.style] = value;
          }
        }
        if (_.isString(this.config.attribute)) {
          node.setAttribute(this.config.attribute, value);
        }
        if (_.isString(this.config["class"])) {
          dom(node).addClass(this.config["class"] + value);
        }
      }
      if (_.isFunction(this.config.add)) {
        node = this.config.add(node, value);
      }
      return node;
    };
  
    Format.prototype.isType = function(type) {
      return type === this.config.type;
    };
  
    Format.prototype.match = function(node) {
      var c, i, len, ref, ref1;
      if (!dom(node).isElement()) {
        return false;
      }
      if (_.isString(this.config.parentTag) && ((ref = node.parentNode) != null ? ref.tagName : void 0) !== this.config.parentTag) {
        return false;
      }
      if (_.isString(this.config.tag) && node.tagName !== this.config.tag) {
        return false;
      }
      if (_.isString(this.config.style) && (!node.style[this.config.style] || node.style[this.config.style] === this.config["default"])) {
        return false;
      }
      if (_.isString(this.config.attribute) && !node.hasAttribute(this.config.attribute)) {
        return false;
      }
      if (_.isString(this.config["class"])) {
        ref1 = dom(node).classes();
        for (i = 0, len = ref1.length; i < len; i++) {
          c = ref1[i];
          if (c.indexOf(this.config["class"]) === 0) {
            return true;
          }
        }
        return false;
      }
      return true;
    };
  
    Format.prototype.prepare = function(value) {
      if (_.isString(this.config.prepare)) {
        return document.execCommand(this.config.prepare, false, value);
      } else if (_.isFunction(this.config.prepare)) {
        return this.config.prepare(value);
      }
    };
  
    Format.prototype.remove = function(node) {
      var c, i, len, ref;
      if (!this.match(node)) {
        return node;
      }
      if (_.isString(this.config.style)) {
        node.style[this.config.style] = '';
        if (!node.getAttribute('style')) {
          node.removeAttribute('style');
        }
      }
      if (_.isString(this.config.attribute)) {
        node.removeAttribute(this.config.attribute);
      }
      if (_.isString(this.config["class"])) {
        ref = dom(node).classes();
        for (i = 0, len = ref.length; i < len; i++) {
          c = ref[i];
          if (c.indexOf(this.config["class"]) === 0) {
            dom(node).removeClass(c);
          }
        }
      }
      if (_.isString(this.config.tag)) {
        if (this.isType(Format.types.LINE)) {
          if (_.isString(this.config.parentTag)) {
            if (node.previousSibling != null) {
              dom(node).splitBefore(node.parentNode.parentNode);
            }
            if (node.nextSibling != null) {
              dom(node.nextSibling).splitBefore(node.parentNode.parentNode);
            }
          }
          node = dom(node).switchTag(dom.DEFAULT_BLOCK_TAG).get();
        } else if (this.isType(Format.types.EMBED)) {
          dom(node).remove();
          return void 0;
        } else {
          node = dom(node).switchTag(dom.DEFAULT_INLINE_TAG).get();
        }
      }
      if (_.isString(this.config.parentTag)) {
        dom(node.parentNode).unwrap();
      }
      if (_.isFunction(this.config.remove)) {
        node = this.config.remove(node);
      }
      if (node.tagName === dom.DEFAULT_INLINE_TAG && !node.hasAttributes()) {
        node = dom(node).unwrap();
      }
      return node;
    };
  
    Format.prototype.value = function(node) {
      var c, i, len, ref;
      if (!this.match(node)) {
        return void 0;
      }
      if (this.config.value) {
        return this.config.value(node);
      }
      if (_.isString(this.config.attribute)) {
        return node.getAttribute(this.config.attribute) || void 0;
      } else if (_.isString(this.config.style)) {
        return node.style[this.config.style] || void 0;
      } else if (_.isString(this.config["class"])) {
        ref = dom(node).classes();
        for (i = 0, len = ref.length; i < len; i++) {
          c = ref[i];
          if (c.indexOf(this.config["class"]) === 0) {
            return c.slice(this.config["class"].length);
          }
        }
      } else if (_.isString(this.config.tag)) {
        return true;
      }
      return void 0;
    };
  
    return Format;
  
  })();
  
  module.exports = Format;
  
  
  },{"../lib/dom":17,"lodash":1}],11:[function(_dereq_,module,exports){
  var Format, Leaf, LinkedList, _, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  _ = _dereq_('lodash');
  
  dom = _dereq_('../lib/dom');
  
  Format = _dereq_('./format');
  
  LinkedList = _dereq_('../lib/linked-list');
  
  Leaf = (function(superClass) {
    extend(Leaf, superClass);
  
    Leaf.DATA_KEY = 'leaf';
  
    Leaf.isLeafNode = function(node) {
      return dom(node).isTextNode() || (node.firstChild == null);
    };
  
    function Leaf(node1, formats) {
      this.node = node1;
      this.formats = _.clone(formats);
      this.text = dom(this.node).text();
      this.length = this.text.length;
      dom(this.node).data(Leaf.DATA_KEY, this);
    }
  
    Leaf.prototype.deleteText = function(offset, length) {
      var textNode;
      if (!(length > 0)) {
        return;
      }
      this.text = this.text.slice(0, offset) + this.text.slice(offset + length);
      this.length = this.text.length;
      if (dom.EMBED_TAGS[this.node.tagName] != null) {
        textNode = document.createTextNode(this.text);
        dom(textNode).data(Leaf.DATA_KEY, this);
        return this.node = dom(this.node).replace(textNode).get();
      } else {
        return dom(this.node).text(this.text);
      }
    };
  
    Leaf.prototype.insertText = function(offset, text) {
      var textNode;
      this.text = this.text.slice(0, offset) + text + this.text.slice(offset);
      if (dom(this.node).isTextNode()) {
        dom(this.node).text(this.text);
      } else {
        textNode = document.createTextNode(text);
        dom(textNode).data(Leaf.DATA_KEY, this);
        if (this.node.tagName === dom.DEFAULT_BREAK_TAG) {
          this.node = dom(this.node).replace(textNode).get();
        } else {
          this.node.appendChild(textNode);
          this.node = textNode;
        }
      }
      return this.length = this.text.length;
    };
  
    return Leaf;
  
  })(LinkedList.Node);
  
  module.exports = Leaf;
  
  
  },{"../lib/dom":17,"../lib/linked-list":18,"./format":10,"lodash":1}],12:[function(_dereq_,module,exports){
  var Delta, Format, Leaf, Line, LinkedList, Normalizer, _, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  _ = _dereq_('lodash');
  
  Delta = _dereq_('rich-text/lib/delta');
  
  dom = _dereq_('../lib/dom');
  
  Format = _dereq_('./format');
  
  Leaf = _dereq_('./leaf');
  
  Line = _dereq_('./line');
  
  LinkedList = _dereq_('../lib/linked-list');
  
  Normalizer = _dereq_('./normalizer');
  
  Line = (function(superClass) {
    extend(Line, superClass);
  
    Line.DATA_KEY = 'line';
  
    function Line(doc, node1) {
      this.doc = doc;
      this.node = node1;
      this.formats = {};
      this.rebuild();
      Line.__super__.constructor.call(this, this.node);
    }
  
    Line.prototype.buildLeaves = function(node, formats) {
      return _.each(dom(node).childNodes(), (function(_this) {
        return function(node) {
          var nodeFormats;
          node = _this.doc.normalizer.normalizeNode(node);
          nodeFormats = _.clone(formats);
          _.each(_this.doc.formats, function(format, name) {
            if (!format.isType(Format.types.LINE) && format.match(node)) {
              return nodeFormats[name] = format.value(node);
            }
          });
          if (Leaf.isLeafNode(node)) {
            return _this.leaves.append(new Leaf(node, nodeFormats));
          } else {
            return _this.buildLeaves(node, nodeFormats);
          }
        };
      })(this));
    };
  
    Line.prototype.deleteText = function(offset, length) {
      var deleteLength, leaf, ref;
      if (!(length > 0)) {
        return;
      }
      ref = this.findLeafAt(offset), leaf = ref[0], offset = ref[1];
      while ((leaf != null) && length > 0) {
        deleteLength = Math.min(length, leaf.length - offset);
        leaf.deleteText(offset, deleteLength);
        length -= deleteLength;
        leaf = leaf.next;
        offset = 0;
      }
      return this.rebuild();
    };
  
    Line.prototype.findLeaf = function(leafNode) {
      if (leafNode != null) {
        return dom(leafNode).data(Leaf.DATA_KEY);
      } else {
        return void 0;
      }
    };
  
    Line.prototype.findLeafAt = function(offset, inclusive) {
      var leaf;
      if (inclusive == null) {
        inclusive = false;
      }
      if (offset >= this.length - 1) {
        return [this.leaves.last, this.leaves.last.length];
      }
      leaf = this.leaves.first;
      while (leaf != null) {
        if (offset < leaf.length || (offset === leaf.length && inclusive)) {
          return [leaf, offset];
        }
        offset -= leaf.length;
        leaf = leaf.next;
      }
      return [this.leaves.last, offset - this.leaves.last.length];
    };
  
    Line.prototype.format = function(name, value) {
      var formats;
      if (_.isObject(name)) {
        formats = name;
      } else {
        formats = {};
        formats[name] = value;
      }
      _.each(formats, (function(_this) {
        return function(value, name) {
          var excludeFormat, format;
          format = _this.doc.formats[name];
          if (format == null) {
            return;
          }
          if (format.isType(Format.types.LINE)) {
            if (format.config.exclude && _this.formats[format.config.exclude]) {
              excludeFormat = _this.doc.formats[format.config.exclude];
              if (excludeFormat != null) {
                _this.node = excludeFormat.remove(_this.node);
                delete _this.formats[format.config.exclude];
              }
            }
            _this.node = format.add(_this.node, value);
          }
          if (value) {
            return _this.formats[name] = value;
          } else {
            return delete _this.formats[name];
          }
        };
      })(this));
      return this.resetContent();
    };
  
    Line.prototype.formatText = function(offset, length, name, value) {
      var format, leaf, leafOffset, leftNode, nextLeaf, ref, ref1, ref2, rightNode, targetNode;
      ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
      format = this.doc.formats[name];
      if (!((format != null) && format.config.type !== Format.types.LINE)) {
        return;
      }
      while ((leaf != null) && length > 0) {
        nextLeaf = leaf.next;
        if ((value && leaf.formats[name] !== value) || (!value && (leaf.formats[name] != null))) {
          targetNode = leaf.node;
          if (leaf.formats[name] != null) {
            dom(targetNode).splitBefore(this.node);
            while (!format.match(targetNode)) {
              targetNode = targetNode.parentNode;
            }
            dom(targetNode).split(leaf.length);
          }
          if (leafOffset > 0) {
            ref1 = dom(targetNode).split(leafOffset), leftNode = ref1[0], targetNode = ref1[1];
          }
          if (leaf.length > leafOffset + length) {
            ref2 = dom(targetNode).split(length), targetNode = ref2[0], rightNode = ref2[1];
          }
          format.add(targetNode, value);
        }
        length -= leaf.length - leafOffset;
        leafOffset = 0;
        leaf = nextLeaf;
      }
      return this.rebuild();
    };
  
    Line.prototype._insert = function(offset, node, formats) {
      var leaf, leafOffset, nextNode, prevNode, ref, ref1;
      ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
      node = _.reduce(formats, (function(_this) {
        return function(node, value, name) {
          var format;
          format = _this.doc.formats[name];
          if ((format != null) && !format.isType(Format.types.LINE)) {
            node = format.add(node, value);
          }
          return node;
        };
      })(this), node);
      ref1 = dom(leaf.node).split(leafOffset), prevNode = ref1[0], nextNode = ref1[1];
      if (nextNode) {
        nextNode = dom(nextNode).splitBefore(this.node).get();
      }
      this.node.insertBefore(node, nextNode);
      return this.rebuild();
    };
  
    Line.prototype.insertEmbed = function(offset, attributes) {
      var formatName, leaf, leafOffset, nextNode, node, prevNode, ref, ref1;
      ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
      ref1 = dom(leaf.node).split(leafOffset), prevNode = ref1[0], nextNode = ref1[1];
      formatName = _.find(Object.keys(attributes), (function(_this) {
        return function(name) {
          return _this.doc.formats[name].isType(Format.types.EMBED);
        };
      })(this));
      node = this.doc.formats[formatName].add({}, attributes[formatName]);
      attributes = _.clone(attributes);
      delete attributes[formatName];
      return this._insert(offset, node, attributes);
    };
  
    Line.prototype.insertText = function(offset, text, formats) {
      var leaf, leafOffset, ref;
      if (formats == null) {
        formats = {};
      }
      if (!(text.length > 0)) {
        return;
      }
      ref = this.findLeafAt(offset), leaf = ref[0], leafOffset = ref[1];
      if (_.isEqual(leaf.formats, formats)) {
        leaf.insertText(leafOffset, text);
        return this.resetContent();
      } else {
        return this._insert(offset, document.createTextNode(text), formats);
      }
    };
  
    Line.prototype.optimize = function() {
      Normalizer.optimizeLine(this.node);
      return this.rebuild();
    };
  
    Line.prototype.rebuild = function(force) {
      if (force == null) {
        force = false;
      }
      if (!force && (this.outerHTML != null) && this.outerHTML === this.node.outerHTML) {
        if (_.all(this.leaves.toArray(), (function(_this) {
          return function(leaf) {
            return dom(leaf.node).isAncestor(_this.node);
          };
        })(this))) {
          return false;
        }
      }
      this.node = this.doc.normalizer.normalizeNode(this.node);
      if (dom(this.node).length() === 0 && !this.node.querySelector(dom.DEFAULT_BREAK_TAG)) {
        this.node.appendChild(document.createElement(dom.DEFAULT_BREAK_TAG));
      }
      this.leaves = new LinkedList();
      this.formats = _.reduce(this.doc.formats, (function(_this) {
        return function(formats, format, name) {
          if (format.isType(Format.types.LINE)) {
            if (format.match(_this.node)) {
              formats[name] = format.value(_this.node);
            } else {
              delete formats[name];
            }
          }
          return formats;
        };
      })(this), this.formats);
      this.buildLeaves(this.node, {});
      this.resetContent();
      return true;
    };
  
    Line.prototype.resetContent = function() {
      dom(this.node).data(Line.DATA_KEY, this);
      this.outerHTML = this.node.outerHTML;
      this.length = 1;
      this.delta = new Delta();
      _.each(this.leaves.toArray(), (function(_this) {
        return function(leaf) {
          _this.length += leaf.length;
          if (dom.EMBED_TAGS[leaf.node.tagName] != null) {
            return _this.delta.insert(1, leaf.formats);
          } else {
            return _this.delta.insert(leaf.text, leaf.formats);
          }
        };
      })(this));
      return this.delta.insert('\n', this.formats);
    };
  
    return Line;
  
  })(LinkedList.Node);
  
  module.exports = Line;
  
  
  },{"../lib/dom":17,"../lib/linked-list":18,"./format":10,"./leaf":11,"./line":12,"./normalizer":13,"lodash":1,"rich-text/lib/delta":3}],13:[function(_dereq_,module,exports){
  var Normalizer, _, camelize, dom;
  
  _ = _dereq_('lodash');
  
  dom = _dereq_('../lib/dom');
  
  camelize = function(str) {
    str = str.replace(/(?:^|[-_])(\w)/g, function(i, c) {
      if (c) {
        return c.toUpperCase();
      } else {
        return '';
      }
    });
    return str.charAt(0).toLowerCase() + str.slice(1);
  };
  
  Normalizer = (function() {
    Normalizer.ALIASES = {
      'STRONG': 'B',
      'EM': 'I',
      'DEL': 'S',
      'STRIKE': 'S'
    };
  
    Normalizer.ATTRIBUTES = {
      'color': 'color',
      'face': 'fontFamily',
      'size': 'fontSize'
    };
  
    function Normalizer() {
      this.whitelist = {
        styles: {},
        tags: {}
      };
      this.whitelist.tags[dom.DEFAULT_BREAK_TAG] = true;
      this.whitelist.tags[dom.DEFAULT_BLOCK_TAG] = true;
      this.whitelist.tags[dom.DEFAULT_INLINE_TAG] = true;
    }
  
    Normalizer.prototype.addFormat = function(config) {
      if (config.tag != null) {
        this.whitelist.tags[config.tag] = true;
      }
      if (config.parentTag != null) {
        this.whitelist.tags[config.parentTag] = true;
      }
      if (config.style != null) {
        return this.whitelist.styles[config.style] = true;
      }
    };
  
    Normalizer.prototype.normalizeLine = function(lineNode) {
      lineNode = Normalizer.wrapInline(lineNode);
      lineNode = Normalizer.handleBreaks(lineNode);
      if (lineNode.tagName === 'LI') {
        Normalizer.flattenList(lineNode);
      }
      lineNode = Normalizer.pullBlocks(lineNode);
      lineNode = this.normalizeNode(lineNode);
      Normalizer.unwrapText(lineNode);
      if ((lineNode != null) && (dom.LIST_TAGS[lineNode.tagName] != null)) {
        lineNode = lineNode.firstChild;
      }
      return lineNode;
    };
  
    Normalizer.prototype.normalizeNode = function(node) {
      if (dom(node).isTextNode()) {
        return node;
      }
      _.each(Normalizer.ATTRIBUTES, function(style, attribute) {
        var value;
        if (node.hasAttribute(attribute)) {
          value = node.getAttribute(attribute);
          if (attribute === 'size') {
            value = dom.convertFontSize(value);
          }
          node.style[style] = value;
          return node.removeAttribute(attribute);
        }
      });
      if (node.style.fontWeight === 'bold' || node.style.fontWeight > 500) {
        node.style.fontWeight = '';
        dom(node).wrap(document.createElement('b'));
        node = node.parentNode;
      }
      this.whitelistStyles(node);
      return this.whitelistTags(node);
    };
  
    Normalizer.prototype.whitelistStyles = function(node) {
      var original, styles;
      original = dom(node).styles();
      styles = _.omit(original, (function(_this) {
        return function(value, key) {
          return _this.whitelist.styles[camelize(key)] == null;
        };
      })(this));
      if (Object.keys(styles).length < Object.keys(original).length) {
        if (Object.keys(styles).length > 0) {
          return dom(node).styles(styles, true);
        } else {
          return node.removeAttribute('style');
        }
      }
    };
  
    Normalizer.prototype.whitelistTags = function(node) {
      if (!dom(node).isElement()) {
        return node;
      }
      if (Normalizer.ALIASES[node.tagName] != null) {
        node = dom(node).switchTag(Normalizer.ALIASES[node.tagName]).get();
      } else if (this.whitelist.tags[node.tagName] == null) {
        if (dom.BLOCK_TAGS[node.tagName] != null) {
          node = dom(node).switchTag(dom.DEFAULT_BLOCK_TAG).get();
        } else if (!node.hasAttributes() && (node.firstChild != null)) {
          node = dom(node).unwrap();
        } else {
          node = dom(node).switchTag(dom.DEFAULT_INLINE_TAG).get();
        }
      }
      return node;
    };
  
    Normalizer.flattenList = function(listNode) {
      var innerItems, innerLists, ref;
      ref = listNode.nextSibling;
      innerItems = _.map(listNode.querySelectorAll('li'));
      innerItems.forEach(function(item) {
        listNode.parentNode.insertBefore(item, ref);
        return ref = item.nextSibling;
      });
      innerLists = _.map(listNode.querySelectorAll(Object.keys(dom.LIST_TAGS).join(',')));
      return innerLists.forEach(function(list) {
        return dom(list).remove();
      });
    };
  
    Normalizer.handleBreaks = function(lineNode) {
      var breaks;
      breaks = _.map(lineNode.querySelectorAll(dom.DEFAULT_BREAK_TAG));
      _.each(breaks, (function(_this) {
        return function(br) {
          if ((br.nextSibling != null) && (!dom.isIE(10) || (br.previousSibling != null))) {
            return dom(br.nextSibling).splitBefore(lineNode.parentNode);
          }
        };
      })(this));
      return lineNode;
    };
  
    Normalizer.optimizeLine = function(lineNode) {
      var lineNodeLength, node, nodes, results;
      lineNode.normalize();
      lineNodeLength = dom(lineNode).length();
      nodes = dom(lineNode).descendants();
      results = [];
      while (nodes.length > 0) {
        node = nodes.pop();
        if ((node != null ? node.parentNode : void 0) == null) {
          continue;
        }
        if (dom.EMBED_TAGS[node.tagName] != null) {
          continue;
        }
        if (node.tagName === dom.DEFAULT_BREAK_TAG) {
          if (lineNodeLength !== 0) {
            results.push(dom(node).remove());
          } else {
            results.push(void 0);
          }
        } else if (dom(node).length() === 0) {
          nodes.push(node.nextSibling);
          results.push(dom(node).unwrap());
        } else if ((node.previousSibling != null) && node.tagName === node.previousSibling.tagName) {
          if (_.isEqual(dom(node).attributes(), dom(node.previousSibling).attributes())) {
            nodes.push(node.firstChild);
            results.push(dom(node.previousSibling).merge(node));
          } else {
            results.push(void 0);
          }
        } else {
          results.push(void 0);
        }
      }
      return results;
    };
  
    Normalizer.pullBlocks = function(lineNode) {
      var curNode;
      curNode = lineNode.firstChild;
      while (curNode != null) {
        if ((dom.BLOCK_TAGS[curNode.tagName] != null) && curNode.tagName !== 'LI') {
          dom(curNode).isolate(lineNode.parentNode);
          if ((dom.LIST_TAGS[curNode.tagName] == null) || !curNode.firstChild) {
            dom(curNode).unwrap();
            Normalizer.pullBlocks(lineNode);
          } else {
            dom(curNode.parentNode).unwrap();
            if (lineNode.parentNode == null) {
              lineNode = curNode;
            }
          }
          break;
        }
        curNode = curNode.nextSibling;
      }
      return lineNode;
    };
  
    Normalizer.stripComments = function(html) {
      return html.replace(/<!--[\s\S]*?-->/g, '');
    };
  
    Normalizer.stripWhitespace = function(html) {
      html = html.trim();
      html = html.replace(/(\r?\n|\r)+/g, ' ');
      html = html.replace(/\>\s+\</g, '><');
      return html;
    };
  
    Normalizer.wrapInline = function(lineNode) {
      var blockNode, nextNode;
      if (dom.BLOCK_TAGS[lineNode.tagName] != null) {
        return lineNode;
      }
      blockNode = document.createElement(dom.DEFAULT_BLOCK_TAG);
      lineNode.parentNode.insertBefore(blockNode, lineNode);
      while ((lineNode != null) && (dom.BLOCK_TAGS[lineNode.tagName] == null)) {
        nextNode = lineNode.nextSibling;
        blockNode.appendChild(lineNode);
        lineNode = nextNode;
      }
      return blockNode;
    };
  
    Normalizer.unwrapText = function(lineNode) {
      var spans;
      spans = _.map(lineNode.querySelectorAll(dom.DEFAULT_INLINE_TAG));
      return _.each(spans, function(span) {
        if (!span.hasAttributes()) {
          return dom(span).unwrap();
        }
      });
    };
  
    return Normalizer;
  
  })();
  
  module.exports = Normalizer;
  
  
  },{"../lib/dom":17,"lodash":1}],14:[function(_dereq_,module,exports){
  var Leaf, Normalizer, Range, Selection, _, dom;
  
  _ = _dereq_('lodash');
  
  dom = _dereq_('../lib/dom');
  
  Leaf = _dereq_('./leaf');
  
  Normalizer = _dereq_('./normalizer');
  
  Range = _dereq_('../lib/range');
  
  Selection = (function() {
    function Selection(doc, emitter) {
      this.doc = doc;
      this.emitter = emitter;
      this.focus = false;
      this.range = new Range(0, 0);
      this.nullDelay = false;
      this.update('silent');
    }
  
    Selection.prototype.checkFocus = function() {
      return document.activeElement === this.doc.root;
    };
  
    Selection.prototype.getRange = function(ignoreFocus) {
      var end, nativeRange, start;
      if (ignoreFocus == null) {
        ignoreFocus = false;
      }
      if (this.checkFocus()) {
        nativeRange = this._getNativeRange();
        if (nativeRange == null) {
          return null;
        }
        start = this._positionToIndex(nativeRange.startContainer, nativeRange.startOffset);
        if (nativeRange.startContainer === nativeRange.endContainer && nativeRange.startOffset === nativeRange.endOffset) {
          end = start;
        } else {
          end = this._positionToIndex(nativeRange.endContainer, nativeRange.endOffset);
        }
        return new Range(Math.min(start, end), Math.max(start, end));
      } else if (ignoreFocus) {
        return this.range;
      } else {
        return null;
      }
    };
  
    Selection.prototype.preserve = function(fn) {
      var endNode, endOffset, nativeRange, ref, ref1, ref2, ref3, startNode, startOffset;
      nativeRange = this._getNativeRange();
      if ((nativeRange != null) && this.checkFocus()) {
        ref = this._encodePosition(nativeRange.startContainer, nativeRange.startOffset), startNode = ref[0], startOffset = ref[1];
        ref1 = this._encodePosition(nativeRange.endContainer, nativeRange.endOffset), endNode = ref1[0], endOffset = ref1[1];
        fn();
        ref2 = this._decodePosition(startNode, startOffset), startNode = ref2[0], startOffset = ref2[1];
        ref3 = this._decodePosition(endNode, endOffset), endNode = ref3[0], endOffset = ref3[1];
        return this._setNativeRange(startNode, startOffset, endNode, endOffset);
      } else {
        return fn();
      }
    };
  
    Selection.prototype.scrollIntoView = function() {
      var containerBounds, containerHeight, editor, endBounds, line, offset, ref, ref1, startBounds;
      if (!this.range) {
        return;
      }
      editor = this.emitter.editor;
      startBounds = editor.getBounds(this.range.start);
      endBounds = this.range.isCollapsed() ? startBounds : editor.getBounds(this.range.end);
      containerBounds = editor.root.parentNode.getBoundingClientRect();
      containerHeight = containerBounds.bottom - containerBounds.top;
      if (containerHeight < endBounds.top + endBounds.height) {
        ref = editor.doc.findLineAt(this.range.end), line = ref[0], offset = ref[1];
        return line.node.scrollIntoView(false);
      } else if (startBounds.top < 0) {
        ref1 = editor.doc.findLineAt(this.range.start), line = ref1[0], offset = ref1[1];
        return line.node.scrollIntoView();
      }
    };
  
    Selection.prototype.setRange = function(range, source) {
      var endNode, endOffset, ref, ref1, ref2, startNode, startOffset;
      if (range != null) {
        ref = this._indexToPosition(range.start), startNode = ref[0], startOffset = ref[1];
        if (range.isCollapsed()) {
          ref1 = [startNode, startOffset], endNode = ref1[0], endOffset = ref1[1];
        } else {
          ref2 = this._indexToPosition(range.end), endNode = ref2[0], endOffset = ref2[1];
        }
        this._setNativeRange(startNode, startOffset, endNode, endOffset);
      } else {
        this._setNativeRange(null);
      }
      return this.update(source);
    };
  
    Selection.prototype.shiftAfter = function(index, length, fn) {
      var range;
      range = this.getRange();
      fn();
      if (range != null) {
        range.shift(index, length);
        return this.setRange(range, 'silent');
      }
    };
  
    Selection.prototype.update = function(source) {
      var emit, focus, range, toEmit;
      focus = this.checkFocus();
      range = this.getRange(true);
      emit = source !== 'silent' && (!Range.compare(range, this.range) || focus !== this.focus);
      toEmit = focus ? range : null;
      if (toEmit === null && source === 'user' && !this.nullDelay) {
        return this.nullDelay = true;
      } else {
        this.nullDelay = false;
        this.range = range;
        this.focus = focus;
        if (emit) {
          return this.emitter.emit(this.emitter.constructor.events.SELECTION_CHANGE, toEmit, source);
        }
      }
    };
  
    Selection.prototype._decodePosition = function(node, offset) {
      var childIndex;
      if (dom(node).isElement()) {
        childIndex = dom(node.parentNode).childNodes().indexOf(node);
        offset += childIndex;
        node = node.parentNode;
      }
      return [node, offset];
    };
  
    Selection.prototype._encodePosition = function(node, offset) {
      var text;
      while (true) {
        if (dom(node).isTextNode() || node.tagName === dom.DEFAULT_BREAK_TAG || (dom.EMBED_TAGS[node.tagName] != null)) {
          return [node, offset];
        } else if (offset < node.childNodes.length) {
          node = node.childNodes[offset];
          offset = 0;
        } else if (node.childNodes.length === 0) {
          if (this.doc.normalizer.whitelist.tags[node.tagName] == null) {
            text = document.createTextNode('');
            node.appendChild(text);
            node = text;
          }
          return [node, 0];
        } else {
          node = node.lastChild;
          if (dom(node).isElement()) {
            if (node.tagName === dom.DEFAULT_BREAK_TAG || (dom.EMBED_TAGS[node.tagName] != null)) {
              return [node, 1];
            } else {
              offset = node.childNodes.length;
            }
          } else {
            return [node, dom(node).length()];
          }
        }
      }
    };
  
    Selection.prototype._getNativeRange = function() {
      var range, selection;
      selection = document.getSelection();
      if ((selection != null ? selection.rangeCount : void 0) > 0) {
        range = selection.getRangeAt(0);
        if (dom(range.startContainer).isAncestor(this.doc.root, true)) {
          if (range.startContainer === range.endContainer || dom(range.endContainer).isAncestor(this.doc.root, true)) {
            return range;
          }
        }
      }
      return null;
    };
  
    Selection.prototype._indexToPosition = function(index) {
      var leaf, offset, ref;
      if (this.doc.lines.length === 0) {
        return [this.doc.root, 0];
      }
      ref = this.doc.findLeafAt(index, true), leaf = ref[0], offset = ref[1];
      return this._decodePosition(leaf.node, offset);
    };
  
    Selection.prototype._positionToIndex = function(node, offset) {
      var leaf, leafNode, leafOffset, line, lineOffset, ref;
      if (dom.isIE(10) && node.tagName === 'BR' && offset === 1) {
        offset = 0;
      }
      ref = this._encodePosition(node, offset), leafNode = ref[0], offset = ref[1];
      line = this.doc.findLine(leafNode);
      if (line == null) {
        return 0;
      }
      leaf = line.findLeaf(leafNode);
      lineOffset = 0;
      while (line.prev != null) {
        line = line.prev;
        lineOffset += line.length;
      }
      if (leaf == null) {
        return lineOffset;
      }
      leafOffset = 0;
      while (leaf.prev != null) {
        leaf = leaf.prev;
        leafOffset += leaf.length;
      }
      return lineOffset + leafOffset + offset;
    };
  
    Selection.prototype._setNativeRange = function(startNode, startOffset, endNode, endOffset) {
      var nativeRange, selection;
      selection = document.getSelection();
      if (!selection) {
        return;
      }
      if (startNode != null) {
        if (!this.checkFocus()) {
          this.doc.root.focus();
        }
        nativeRange = this._getNativeRange();
        if ((nativeRange == null) || startNode !== nativeRange.startContainer || startOffset !== nativeRange.startOffset || endNode !== nativeRange.endContainer || endOffset !== nativeRange.endOffset) {
          selection.removeAllRanges();
          nativeRange = document.createRange();
          nativeRange.setStart(startNode, startOffset);
          nativeRange.setEnd(endNode, endOffset);
          return selection.addRange(nativeRange);
        }
      } else {
        selection.removeAllRanges();
        this.doc.root.blur();
        if (dom.isIE(11) && !dom.isIE(9)) {
          return document.body.focus();
        }
      }
    };
  
    return Selection;
  
  })();
  
  module.exports = Selection;
  
  
  },{"../lib/dom":17,"../lib/range":20,"./leaf":11,"./normalizer":13,"lodash":1}],15:[function(_dereq_,module,exports){
  _dereq_('./modules/authorship');
  
  _dereq_('./modules/image-tooltip');
  
  _dereq_('./modules/keyboard');
  
  _dereq_('./modules/link-tooltip');
  
  _dereq_('./modules/multi-cursor');
  
  _dereq_('./modules/paste-manager');
  
  _dereq_('./modules/toolbar');
  
  _dereq_('./modules/tooltip');
  
  _dereq_('./modules/undo-manager');
  
  module.exports = _dereq_('./quill');
  
  
  },{"./modules/authorship":21,"./modules/image-tooltip":22,"./modules/keyboard":23,"./modules/link-tooltip":24,"./modules/multi-cursor":25,"./modules/paste-manager":26,"./modules/toolbar":27,"./modules/tooltip":28,"./modules/undo-manager":29,"./quill":30}],16:[function(_dereq_,module,exports){
  var ColorPicker, Picker, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  dom = _dereq_('./dom');
  
  Picker = _dereq_('./picker');
  
  ColorPicker = (function(superClass) {
    extend(ColorPicker, superClass);
  
    function ColorPicker() {
      ColorPicker.__super__.constructor.apply(this, arguments);
      dom(this.container).addClass('ql-color-picker');
    }
  
    ColorPicker.prototype.buildItem = function(picker, option, index) {
      var item;
      item = ColorPicker.__super__.buildItem.call(this, picker, option, index);
      item.style.backgroundColor = option.value;
      return item;
    };
  
    return ColorPicker;
  
  })(Picker);
  
  module.exports = ColorPicker;
  
  
  },{"./dom":17,"./picker":19}],17:[function(_dereq_,module,exports){
  var SelectWrapper, Wrapper, _, dom, lastKeyEvent,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  _ = _dereq_('lodash');
  
  lastKeyEvent = null;
  
  Wrapper = (function() {
    function Wrapper(node1) {
      this.node = node1;
      this.trigger = bind(this.trigger, this);
    }
  
    Wrapper.prototype.addClass = function(cssClass) {
      if (this.hasClass(cssClass)) {
        return;
      }
      if (this.node.classList != null) {
        this.node.classList.add(cssClass);
      } else if (this.node.className != null) {
        this.node.className = (this.node.className + ' ' + cssClass).trim();
      }
      return this;
    };
  
    Wrapper.prototype.attributes = function(attributes) {
      var attr, i, j, len, ref, value;
      if (attributes) {
        _.each(attributes, (function(_this) {
          return function(value, name) {
            return _this.node.setAttribute(name, value);
          };
        })(this));
        return this;
      } else {
        if (this.node.attributes == null) {
          return {};
        }
        attributes = {};
        ref = this.node.attributes;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          value = ref[i];
          attr = this.node.attributes[i];
          attributes[attr.name] = attr.value;
        }
        return attributes;
      }
    };
  
    Wrapper.prototype.child = function(offset) {
      var child, length;
      child = this.node.firstChild;
      length = dom(child).length();
      while (child != null) {
        if (offset < length) {
          break;
        }
        offset -= length;
        child = child.nextSibling;
        length = dom(child).length();
      }
      if (child == null) {
        child = this.node.lastChild;
        offset = dom(child).length();
      }
      return [child, offset];
    };
  
    Wrapper.prototype.childNodes = function() {
      return _.map(this.node.childNodes);
    };
  
    Wrapper.prototype.classes = function() {
      return this.node.className.split(/\s+/);
    };
  
    Wrapper.prototype.data = function(key, value) {
      var ref;
      if (value != null) {
        if (this.node['ql-data'] == null) {
          this.node['ql-data'] = {};
        }
        this.node['ql-data'][key] = value;
        return this;
      } else {
        return (ref = this.node['ql-data']) != null ? ref[key] : void 0;
      }
    };
  
    Wrapper.prototype.descendants = function() {
      return _.map(this.node.getElementsByTagName('*'));
    };
  
    Wrapper.prototype.get = function() {
      return this.node;
    };
  
    Wrapper.prototype.hasClass = function(cssClass) {
      if (this.node.classList != null) {
        return this.node.classList.contains(cssClass);
      } else if (this.node.className != null) {
        return this.classes().indexOf(cssClass) > -1;
      }
      return false;
    };
  
    Wrapper.prototype.isAncestor = function(ancestor, inclusive) {
      var node;
      if (inclusive == null) {
        inclusive = false;
      }
      if (ancestor === this.node) {
        return inclusive;
      }
      node = this.node;
      while (node) {
        if (node === ancestor) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };
  
    Wrapper.prototype.isElement = function() {
      var ref;
      return ((ref = this.node) != null ? ref.nodeType : void 0) === dom.ELEMENT_NODE;
    };
  
    Wrapper.prototype.isTextNode = function() {
      var ref;
      return ((ref = this.node) != null ? ref.nodeType : void 0) === dom.TEXT_NODE;
    };
  
    Wrapper.prototype.isolate = function(root) {
      if (this.node.nextSibling != null) {
        dom(this.node.nextSibling).splitBefore(root);
      }
      this.splitBefore(root);
      return this;
    };
  
    Wrapper.prototype.length = function() {
      var length;
      if (this.node == null) {
        return 0;
      }
      length = this.text().length;
      if (this.isElement()) {
        length += this.node.querySelectorAll(Object.keys(dom.EMBED_TAGS).join(',')).length;
      }
      return length;
    };
  
    Wrapper.prototype.merge = function(node) {
      var $node;
      $node = dom(node);
      if (this.isElement()) {
        $node.moveChildren(this.node);
        this.normalize();
      } else {
        this.text(this.text() + $node.text());
      }
      $node.remove();
      return this;
    };
  
    Wrapper.prototype.moveChildren = function(newParent) {
      _.each(this.childNodes(), function(child) {
        return newParent.appendChild(child);
      });
      return this;
    };
  
    Wrapper.prototype.nextLineNode = function(root) {
      var nextNode;
      nextNode = this.node.nextSibling;
      if ((nextNode == null) && this.node.parentNode !== root) {
        nextNode = this.node.parentNode.nextSibling;
      }
      if ((nextNode != null) && (dom.LIST_TAGS[nextNode.tagName] != null)) {
        nextNode = nextNode.firstChild;
      }
      return nextNode;
    };
  
    Wrapper.prototype.normalize = function() {
      var $node, curNode, followingNode, nextNode;
      curNode = this.node.firstChild;
      while (curNode != null) {
        nextNode = curNode.nextSibling;
        $node = dom(curNode);
        if ((nextNode != null) && dom(nextNode).isTextNode()) {
          if ($node.text().length === 0) {
            $node.remove();
          } else if ($node.isTextNode()) {
            followingNode = nextNode.nextSibling;
            $node.merge(nextNode);
            nextNode = followingNode;
          }
        }
        curNode = nextNode;
      }
      return this;
    };
  
    Wrapper.prototype.on = function(eventName, listener) {
      this.node.addEventListener(eventName, (function(_this) {
        return function(event) {
          var arg, propagate;
          arg = lastKeyEvent && (eventName === 'keydown' || eventName === 'keyup') ? lastKeyEvent : event;
          propagate = listener.call(_this.node, arg);
          if (!propagate) {
            event.preventDefault();
            event.stopPropagation();
          }
          return propagate;
        };
      })(this));
      return this;
    };
  
    Wrapper.prototype.remove = function() {
      var ref;
      if ((ref = this.node.parentNode) != null) {
        ref.removeChild(this.node);
      }
      this.node = null;
      return null;
    };
  
    Wrapper.prototype.removeClass = function(cssClass) {
      var classArray;
      if (!this.hasClass(cssClass)) {
        return;
      }
      if (this.node.classList != null) {
        this.node.classList.remove(cssClass);
      } else if (this.node.className != null) {
        classArray = this.classes();
        classArray.splice(classArray.indexOf(cssClass), 1);
        this.node.className = classArray.join(' ');
      }
      if (!this.node.getAttribute('class')) {
        this.node.removeAttribute('class');
      }
      return this;
    };
  
    Wrapper.prototype.replace = function(newNode) {
      this.node.parentNode.replaceChild(newNode, this.node);
      this.node = newNode;
      return this;
    };
  
    Wrapper.prototype.splitBefore = function(root, force) {
      var nextNode, parentClone, parentNode, refNode;
      if (force == null) {
        force = false;
      }
      if (this.node === root || this.node.parentNode === root) {
        return this;
      }
      if ((this.node.previousSibling != null) || force) {
        parentNode = this.node.parentNode;
        parentClone = parentNode.cloneNode(false);
        parentNode.parentNode.insertBefore(parentClone, parentNode.nextSibling);
        refNode = this.node;
        while (refNode != null) {
          nextNode = refNode.nextSibling;
          parentClone.appendChild(refNode);
          refNode = nextNode;
        }
        return dom(parentClone).splitBefore(root);
      } else {
        return dom(this.node.parentNode).splitBefore(root);
      }
    };
  
    Wrapper.prototype.split = function(offset, force) {
      var after, child, childLeft, childRight, left, nextRight, nodeLength, ref, ref1, right;
      if (force == null) {
        force = false;
      }
      nodeLength = this.length();
      offset = Math.max(0, offset);
      offset = Math.min(offset, nodeLength);
      if (!(force || offset !== 0)) {
        return [this.node.previousSibling, this.node, false];
      }
      if (!(force || offset !== nodeLength)) {
        return [this.node, this.node.nextSibling, false];
      }
      if (this.node.nodeType === dom.TEXT_NODE) {
        after = this.node.splitText(offset);
        return [this.node, after, true];
      } else {
        left = this.node;
        right = this.node.cloneNode(false);
        this.node.parentNode.insertBefore(right, left.nextSibling);
        ref = this.child(offset), child = ref[0], offset = ref[1];
        ref1 = dom(child).split(offset), childLeft = ref1[0], childRight = ref1[1];
        while (childRight !== null) {
          nextRight = childRight.nextSibling;
          right.appendChild(childRight);
          childRight = nextRight;
        }
        return [left, right, true];
      }
    };
  
    Wrapper.prototype.styles = function(styles, overwrite) {
      var obj, styleString;
      if (overwrite == null) {
        overwrite = false;
      }
      if (styles) {
        if (!overwrite) {
          styles = _.defaults(styles, this.styles());
        }
        styleString = _.map(styles, function(style, name) {
          return name + ": " + style;
        }).join('; ') + ';';
        this.node.setAttribute('style', styleString);
        return this;
      } else {
        styleString = this.node.getAttribute('style') || '';
        obj = _.reduce(styleString.split(';'), function(styles, str) {
          var name, ref, value;
          ref = str.split(':'), name = ref[0], value = ref[1];
          if (name && value) {
            name = name.trim();
            value = value.trim();
            styles[name.toLowerCase()] = value;
          }
          return styles;
        }, {});
        return obj;
      }
    };
  
    Wrapper.prototype.switchTag = function(newTag) {
      var attributes, newNode;
      newTag = newTag.toUpperCase();
      if (this.node.tagName === newTag) {
        return this;
      }
      newNode = document.createElement(newTag);
      attributes = this.attributes();
      if (dom.VOID_TAGS[newTag] == null) {
        this.moveChildren(newNode);
      }
      this.replace(newNode);
      this.node = newNode;
      return this.attributes(attributes);
    };
  
    Wrapper.prototype.text = function(text) {
      if (text != null) {
        switch (this.node.nodeType) {
          case dom.ELEMENT_NODE:
            this.node.textContent = text;
            break;
          case dom.TEXT_NODE:
            this.node.data = text;
        }
        return this;
      } else {
        switch (this.node.nodeType) {
          case dom.ELEMENT_NODE:
            if (this.node.tagName === dom.DEFAULT_BREAK_TAG) {
              return "";
            }
            if (dom.EMBED_TAGS[this.node.tagName] != null) {
              return dom.EMBED_TEXT;
            }
            if (this.node.textContent != null) {
              return this.node.textContent;
            }
            return "";
          case dom.TEXT_NODE:
            return this.node.data || "";
          default:
            return "";
        }
      }
    };
  
    Wrapper.prototype.textNodes = function() {
      var textNode, textNodes, walker;
      walker = document.createTreeWalker(this.node, NodeFilter.SHOW_TEXT, null, false);
      textNodes = [];
      while (textNode = walker.nextNode()) {
        textNodes.push(textNode);
      }
      return textNodes;
    };
  
    Wrapper.prototype.toggleClass = function(className, state) {
      if (state == null) {
        state = !this.hasClass(className);
      }
      if (state) {
        this.addClass(className);
      } else {
        this.removeClass(className);
      }
      return this;
    };
  
    Wrapper.prototype.trigger = function(eventName, options) {
      var event, initFn, modifiers;
      if (options == null) {
        options = {};
      }
      if (['keypress', 'keydown', 'keyup'].indexOf(eventName) < 0) {
        event = document.createEvent('Event');
        event.initEvent(eventName, options.bubbles, options.cancelable);
      } else {
        event = document.createEvent('KeyboardEvent');
        lastKeyEvent = _.clone(options);
        if (_.isNumber(options.key)) {
          lastKeyEvent.which = options.key;
        } else if (_.isString(options.key)) {
          lastKeyEvent.which = options.key.toUpperCase().charCodeAt(0);
        } else {
          lastKeyEvent.which = 0;
        }
        if (dom.isIE(10)) {
          modifiers = [];
          if (options.altKey) {
            modifiers.push('Alt');
          }
          if (options.ctrlKey) {
            modifiers.push('Control');
          }
          if (options.metaKey) {
            modifiers.push('Meta');
          }
          if (options.shiftKey) {
            modifiers.push('Shift');
          }
          event.initKeyboardEvent(eventName, options.bubbles, options.cancelable, window, 0, 0, modifiers.join(' '), null, null);
        } else {
          initFn = _.isFunction(event.initKeyboardEvent) ? 'initKeyboardEvent' : 'initKeyEvent';
          event[initFn](eventName, options.bubbles, options.cancelable, window, options.ctrlKey, options.altKey, options.shiftKey, options.metaKey, 0, 0);
        }
      }
      this.node.dispatchEvent(event);
      lastKeyEvent = null;
      return this;
    };
  
    Wrapper.prototype.unwrap = function() {
      var next, ret;
      ret = this.node.firstChild;
      next = this.node.nextSibling;
      _.each(this.childNodes(), (function(_this) {
        return function(child) {
          return _this.node.parentNode.insertBefore(child, next);
        };
      })(this));
      this.remove();
      return ret;
    };
  
    Wrapper.prototype.wrap = function(wrapper) {
      var parent;
      if (this.node.parentNode != null) {
        this.node.parentNode.insertBefore(wrapper, this.node);
      }
      parent = wrapper;
      while (parent.firstChild != null) {
        parent = wrapper.firstChild;
      }
      parent.appendChild(this.node);
      return this;
    };
  
    return Wrapper;
  
  })();
  
  SelectWrapper = (function(superClass) {
    extend(SelectWrapper, superClass);
  
    function SelectWrapper() {
      return SelectWrapper.__super__.constructor.apply(this, arguments);
    }
  
    SelectWrapper.prototype["default"] = function() {
      return this.node.querySelector('option[selected]');
    };
  
    SelectWrapper.prototype.option = function(option, trigger) {
      var child, i, j, len, ref, value;
      if (trigger == null) {
        trigger = true;
      }
      value = _.isElement(option) ? option.value : option;
      if (value) {
        value = value.replace(/[^\w]+/g, '');
        ref = this.node.children;
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          child = ref[i];
          if (child.value.replace(/[^\w]+/g, '') === value) {
            this.node.selectedIndex = i;
            break;
          }
        }
      } else {
        this.node.selectedIndex = -1;
      }
      if (trigger) {
        this.trigger('change');
      }
      return this;
    };
  
    SelectWrapper.prototype.reset = function(trigger) {
      var option;
      if (trigger == null) {
        trigger = true;
      }
      option = this["default"]();
      if (option != null) {
        option.selected = true;
      } else {
        this.node.selectedIndex = 0;
      }
      if (trigger) {
        this.trigger('change');
      }
      return this;
    };
  
    SelectWrapper.prototype.value = function() {
      if (this.node.selectedIndex > -1) {
        return this.node.options[this.node.selectedIndex].value;
      } else {
        return '';
      }
    };
  
    return SelectWrapper;
  
  })(Wrapper);
  
  dom = function(node) {
    if ((node != null ? node.tagName : void 0) === 'SELECT') {
      return new SelectWrapper(node);
    } else {
      return new Wrapper(node);
    }
  };
  
  dom = _.extend(dom, {
    ELEMENT_NODE: 1,
    NOBREAK_SPACE: "&nbsp;",
    TEXT_NODE: 3,
    ZERO_WIDTH_NOBREAK_SPACE: "\uFEFF",
    DEFAULT_BLOCK_TAG: 'DIV',
    DEFAULT_BREAK_TAG: 'BR',
    DEFAULT_INLINE_TAG: 'SPAN',
    EMBED_TEXT: '!',
    FONT_SIZES: {
      '10px': 1,
      '13px': 2,
      '16px': 3,
      '18px': 4,
      '24px': 5,
      '32px': 6,
      '48px': 7
    },
    KEYS: {
      BACKSPACE: 8,
      TAB: 9,
      ENTER: 13,
      ESCAPE: 27,
      LEFT: 37,
      UP: 38,
      RIGHT: 39,
      DOWN: 40,
      DELETE: 46
    },
    BLOCK_TAGS: {
      'ADDRESS': 'ADDRESS',
      'ARTICLE': 'ARTICLE',
      'ASIDE': 'ASIDE',
      'AUDIO': 'AUDIO',
      'BLOCKQUOTE': 'BLOCKQUOTE',
      'CANVAS': 'CANVAS',
      'DD': 'DD',
      'DIV': 'DIV',
      'DL': 'DL',
      'FIGCAPTION': 'FIGCAPTION',
      'FIGURE': 'FIGURE',
      'FOOTER': 'FOOTER',
      'FORM': 'FORM',
      'H1': 'H1',
      'H2': 'H2',
      'H3': 'H3',
      'H4': 'H4',
      'H5': 'H5',
      'H6': 'H6',
      'HEADER': 'HEADER',
      'HGROUP': 'HGROUP',
      'LI': 'LI',
      'OL': 'OL',
      'OUTPUT': 'OUTPUT',
      'P': 'P',
      'PRE': 'PRE',
      'SECTION': 'SECTION',
      'TABLE': 'TABLE',
      'TBODY': 'TBODY',
      'TD': 'TD',
      'TFOOT': 'TFOOT',
      'TH': 'TH',
      'THEAD': 'THEAD',
      'TR': 'TR',
      'UL': 'UL',
      'VIDEO': 'VIDEO'
    },
    EMBED_TAGS: {
      'IMG': 'IMG'
    },
    LINE_TAGS: {
      'DIV': 'DIV',
      'LI': 'LI'
    },
    LIST_TAGS: {
      'OL': 'OL',
      'UL': 'UL'
    },
    VOID_TAGS: {
      'AREA': 'AREA',
      'BASE': 'BASE',
      'BR': 'BR',
      'COL': 'COL',
      'COMMAND': 'COMMAND',
      'EMBED': 'EMBED',
      'HR': 'HR',
      'IMG': 'IMG',
      'INPUT': 'INPUT',
      'KEYGEN': 'KEYGEN',
      'LINK': 'LINK',
      'META': 'META',
      'PARAM': 'PARAM',
      'SOURCE': 'SOURCE',
      'TRACK': 'TRACK',
      'WBR': 'WBR'
    },
    convertFontSize: function(size) {
      var i, s, sources, targets;
      if (_.isString(size) && size.indexOf('px') > -1) {
        sources = Object.keys(dom.FONT_SIZES);
        targets = _.values(dom.FONT_SIZES);
      } else {
        targets = Object.keys(dom.FONT_SIZES);
        sources = _.values(dom.FONT_SIZES);
      }
      for (i in sources) {
        s = sources[i];
        if (parseInt(size) <= parseInt(s)) {
          return targets[i];
        }
      }
      return _.last(targets);
    },
    isIE: function(maxVersion) {
      var version;
      version = document.documentMode;
      return version && maxVersion >= version;
    },
    isIOS: function() {
      return /iPhone|iPad/i.test(navigator.userAgent);
    },
    isMac: function() {
      return /Mac/i.test(navigator.platform);
    }
  });
  
  module.exports = dom;
  
  
  },{"lodash":1}],18:[function(_dereq_,module,exports){
  var LinkedList, Node;
  
  Node = (function() {
    function Node(data) {
      this.data = data;
      this.prev = this.next = null;
    }
  
    return Node;
  
  })();
  
  LinkedList = (function() {
    LinkedList.Node = Node;
  
    function LinkedList() {
      this.length = 0;
      this.first = this.last = null;
    }
  
    LinkedList.prototype.append = function(node) {
      if (this.first != null) {
        node.next = null;
        this.last.next = node;
      } else {
        this.first = node;
      }
      node.prev = this.last;
      this.last = node;
      return this.length += 1;
    };
  
    LinkedList.prototype.insertAfter = function(refNode, newNode) {
      newNode.prev = refNode;
      if (refNode != null) {
        newNode.next = refNode.next;
        if (refNode.next != null) {
          refNode.next.prev = newNode;
        }
        refNode.next = newNode;
        if (refNode === this.last) {
          this.last = newNode;
        }
      } else {
        newNode.next = this.first;
        this.first.prev = newNode;
        this.first = newNode;
      }
      return this.length += 1;
    };
  
    LinkedList.prototype.remove = function(node) {
      if (this.length > 1) {
        if (node.prev != null) {
          node.prev.next = node.next;
        }
        if (node.next != null) {
          node.next.prev = node.prev;
        }
        if (node === this.first) {
          this.first = node.next;
        }
        if (node === this.last) {
          this.last = node.prev;
        }
      } else {
        this.first = this.last = null;
      }
      node.prev = node.next = null;
      return this.length -= 1;
    };
  
    LinkedList.prototype.toArray = function() {
      var arr, cur;
      arr = [];
      cur = this.first;
      while (cur != null) {
        arr.push(cur);
        cur = cur.next;
      }
      return arr;
    };
  
    return LinkedList;
  
  })();
  
  module.exports = LinkedList;
  
  
  },{}],19:[function(_dereq_,module,exports){
  var Picker, _, dom;
  
  _ = _dereq_('lodash');
  
  dom = _dereq_('./dom');
  
  Picker = (function() {
    Picker.TEMPLATE = '<span class="ql-picker-label"></span><span class="ql-picker-options"></span>';
  
    function Picker(select) {
      this.select = select;
      this.container = document.createElement('span');
      this.buildPicker();
      dom(this.container).addClass('ql-picker');
      this.select.style.display = 'none';
      this.select.parentNode.insertBefore(this.container, this.select);
      dom(document).on('click', (function(_this) {
        return function() {
          _this.close();
          return true;
        };
      })(this));
      dom(this.label).on('click', (function(_this) {
        return function() {
          _.defer(function() {
            return dom(_this.container).toggleClass('ql-expanded');
          });
          return false;
        };
      })(this));
      dom(this.select).on('change', (function(_this) {
        return function() {
          var item, option;
          if (_this.select.selectedIndex > -1) {
            item = _this.container.querySelectorAll('.ql-picker-item')[_this.select.selectedIndex];
            option = _this.select.options[_this.select.selectedIndex];
          }
          _this.selectItem(item, false);
          return dom(_this.label).toggleClass('ql-active', option !== dom(_this.select)["default"]());
        };
      })(this));
    }
  
    Picker.prototype.buildItem = function(picker, option, index) {
      var item;
      item = document.createElement('span');
      item.setAttribute('data-value', option.getAttribute('value'));
      dom(item).addClass('ql-picker-item').text(dom(option).text()).on('click', (function(_this) {
        return function() {
          _this.selectItem(item, true);
          return _this.close();
        };
      })(this));
      if (this.select.selectedIndex === index) {
        this.selectItem(item, false);
      }
      return item;
    };
  
    Picker.prototype.buildPicker = function() {
      var picker;
      _.each(dom(this.select).attributes(), (function(_this) {
        return function(value, name) {
          return _this.container.setAttribute(name, value);
        };
      })(this));
      this.container.innerHTML = Picker.TEMPLATE;
      this.label = this.container.querySelector('.ql-picker-label');
      picker = this.container.querySelector('.ql-picker-options');
      return _.each(this.select.options, (function(_this) {
        return function(option, i) {
          var item;
          item = _this.buildItem(picker, option, i);
          return picker.appendChild(item);
        };
      })(this));
    };
  
    Picker.prototype.close = function() {
      return dom(this.container).removeClass('ql-expanded');
    };
  
    Picker.prototype.selectItem = function(item, trigger) {
      var selected, value;
      selected = this.container.querySelector('.ql-selected');
      if (selected != null) {
        dom(selected).removeClass('ql-selected');
      }
      if (item != null) {
        value = item.getAttribute('data-value');
        dom(item).addClass('ql-selected');
        dom(this.label).text(dom(item).text());
        dom(this.select).option(value, trigger);
        return this.label.setAttribute('data-value', value);
      } else {
        this.label.innerHTML = '&nbsp;';
        return this.label.removeAttribute('data-value');
      }
    };
  
    return Picker;
  
  })();
  
  module.exports = Picker;
  
  
  },{"./dom":17,"lodash":1}],20:[function(_dereq_,module,exports){
  var Range, _;
  
  _ = _dereq_('lodash');
  
  Range = (function() {
    Range.compare = function(r1, r2) {
      if (r1 === r2) {
        return true;
      }
      if (!((r1 != null) && (r2 != null))) {
        return false;
      }
      return r1.equals(r2);
    };
  
    function Range(start, end) {
      this.start = start;
      this.end = end;
    }
  
    Range.prototype.equals = function(range) {
      if (range == null) {
        return false;
      }
      return this.start === range.start && this.end === range.end;
    };
  
    Range.prototype.shift = function(index, length) {
      var ref;
      return ref = _.map([this.start, this.end], function(pos) {
        if (index > pos) {
          return pos;
        }
        if (length >= 0) {
          return pos + length;
        } else {
          return Math.max(index, pos + length);
        }
      }), this.start = ref[0], this.end = ref[1], ref;
    };
  
    Range.prototype.isCollapsed = function() {
      return this.start === this.end;
    };
  
    return Range;
  
  })();
  
  module.exports = Range;
  
  
  },{"lodash":1}],21:[function(_dereq_,module,exports){
  var Authorship, Delta, Quill, _, dom;
  
  Quill = _dereq_('../quill');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  Delta = Quill.require('delta');
  
  Authorship = (function() {
    Authorship.DEFAULTS = {
      authorId: null,
      color: 'transparent',
      enabled: false
    };
  
    function Authorship(quill, options) {
      this.quill = quill;
      this.options = options;
      if (this.options.button != null) {
        this.attachButton(this.options.button);
      }
      if (this.options.enabled) {
        this.enable();
      }
      this.quill.addFormat('author', {
        "class": 'author-'
      });
      if (this.options.authorId == null) {
        return;
      }
      this.quill.on(this.quill.constructor.events.PRE_EVENT, (function(_this) {
        return function(eventName, delta, origin) {
          var authorDelta, authorFormat;
          if (eventName === _this.quill.constructor.events.TEXT_CHANGE && origin === 'user') {
            authorDelta = new Delta();
            authorFormat = {
              author: _this.options.authorId
            };
            _.each(delta.ops, function(op) {
              if (op["delete"] != null) {
                return;
              }
              if ((op.insert != null) || ((op.retain != null) && (op.attributes != null))) {
                op.attributes || (op.attributes = {});
                op.attributes.author = _this.options.authorId;
                return authorDelta.retain(op.retain || op.insert.length || 1, authorFormat);
              } else {
                return authorDelta.retain(op.retain);
              }
            });
            return _this.quill.updateContents(authorDelta, Quill.sources.SILENT);
          }
        };
      })(this));
      this.addAuthor(this.options.authorId, this.options.color);
    }
  
    Authorship.prototype.addAuthor = function(id, color) {
      var styles;
      styles = {};
      styles[".authorship .author-" + id] = {
        "background-color": "" + color
      };
      return this.quill.theme.addStyles(styles);
    };
  
    Authorship.prototype.attachButton = function(button) {
      var $button;
      $button = dom(button);
      return $button.on('click', (function(_this) {
        return function() {
          $button.toggleClass('ql-on');
          return _this.enable($dom.hasClass('ql-on'));
        };
      })(this));
    };
  
    Authorship.prototype.enable = function(enabled) {
      if (enabled == null) {
        enabled = true;
      }
      return dom(this.quill.root).toggleClass('authorship', enabled);
    };
  
    Authorship.prototype.disable = function() {
      return this.enable(false);
    };
  
    return Authorship;
  
  })();
  
  Quill.registerModule('authorship', Authorship);
  
  module.exports = Authorship;
  
  
  },{"../quill":30}],22:[function(_dereq_,module,exports){
  var Delta, ImageTooltip, Quill, Range, Tooltip, _, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  Quill = _dereq_('../quill');
  
  Tooltip = _dereq_('./tooltip');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  Delta = Quill.require('delta');
  
  Range = Quill.require('range');
  
  ImageTooltip = (function(superClass) {
    extend(ImageTooltip, superClass);
  
    ImageTooltip.DEFAULTS = {
      template: '<input class="input" type="textbox"> <div class="preview"> <span>Preview</span> </div> <a href="javascript:;" class="cancel">Cancel</a> <a href="javascript:;" class="insert">Insert</a>'
    };
  
    function ImageTooltip(quill, options) {
      this.quill = quill;
      this.options = options;
      this.options = _.defaults(this.options, Tooltip.DEFAULTS);
      ImageTooltip.__super__.constructor.call(this, this.quill, this.options);
      this.preview = this.container.querySelector('.preview');
      this.textbox = this.container.querySelector('.input');
      dom(this.container).addClass('ql-image-tooltip');
      this.initListeners();
    }
  
    ImageTooltip.prototype.initListeners = function() {
      dom(this.quill.root).on('focus', _.bind(this.hide, this));
      dom(this.container.querySelector('.insert')).on('click', _.bind(this.insertImage, this));
      dom(this.container.querySelector('.cancel')).on('click', _.bind(this.hide, this));
      dom(this.textbox).on('input', _.bind(this._preview, this));
      this.initTextbox(this.textbox, this.insertImage, this.hide);
      return this.quill.onModuleLoad('toolbar', (function(_this) {
        return function(toolbar) {
          _this.toolbar = toolbar;
          return toolbar.initFormat('image', _.bind(_this._onToolbar, _this));
        };
      })(this));
    };
  
    ImageTooltip.prototype.insertImage = function() {
      var index, url;
      url = this._normalizeURL(this.textbox.value);
      if (this.range == null) {
        this.range = new Range(0, 0);
      }
      if (this.range) {
        this.preview.innerHTML = '<span>Preview</span>';
        this.textbox.value = '';
        index = this.range.end;
        this.quill.insertEmbed(index, 'image', url, 'user');
        this.quill.setSelection(index + 1, index + 1);
      }
      return this.hide();
    };
  
    ImageTooltip.prototype._onToolbar = function(range, value) {
      if (value) {
        if (!this.textbox.value) {
          this.textbox.value = 'http://';
        }
        this.show();
        this.textbox.focus();
        return _.defer((function(_this) {
          return function() {
            return _this.textbox.setSelectionRange(_this.textbox.value.length, _this.textbox.value.length);
          };
        })(this));
      } else {
        this.quill.deleteText(range, 'user');
        return this.toolbar.setActive('image', false);
      }
    };
  
    ImageTooltip.prototype._preview = function() {
      var img;
      if (!this._matchImageURL(this.textbox.value)) {
        return;
      }
      if (this.preview.firstChild.tagName === 'IMG') {
        return this.preview.firstChild.setAttribute('src', this.textbox.value);
      } else {
        img = document.createElement('img');
        img.setAttribute('src', this.textbox.value);
        return this.preview.replaceChild(img, this.preview.firstChild);
      }
    };
  
    ImageTooltip.prototype._matchImageURL = function(url) {
      return /^https?:\/\/.+\.(jpe?g|gif|png)$/.test(url);
    };
  
    ImageTooltip.prototype._normalizeURL = function(url) {
      if (!/^https?:\/\//.test(url)) {
        url = 'http://' + url;
      }
      return url;
    };
  
    return ImageTooltip;
  
  })(Tooltip);
  
  Quill.registerModule('image-tooltip', ImageTooltip);
  
  module.exports = ImageTooltip;
  
  
  },{"../quill":30,"./tooltip":28}],23:[function(_dereq_,module,exports){
  var Delta, Keyboard, Quill, _, dom;
  
  Quill = _dereq_('../quill');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  Delta = Quill.require('delta');
  
  Keyboard = (function() {
    Keyboard.hotkeys = {
      BOLD: {
        key: 'B',
        metaKey: true
      },
      INDENT: {
        key: dom.KEYS.TAB
      },
      ITALIC: {
        key: 'I',
        metaKey: true
      },
      OUTDENT: {
        key: dom.KEYS.TAB,
        shiftKey: true
      },
      UNDERLINE: {
        key: 'U',
        metaKey: true
      }
    };
  
    function Keyboard(quill, options) {
      this.quill = quill;
      this.hotkeys = {};
      this._initListeners();
      this._initHotkeys();
      this.quill.onModuleLoad('toolbar', (function(_this) {
        return function(toolbar) {
          return _this.toolbar = toolbar;
        };
      })(this));
    }
  
    Keyboard.prototype.addHotkey = function(hotkeys, callback) {
      if (!Array.isArray(hotkeys)) {
        hotkeys = [hotkeys];
      }
      return _.each(hotkeys, (function(_this) {
        return function(hotkey) {
          var base, which;
          hotkey = _.isObject(hotkey) ? _.clone(hotkey) : {
            key: hotkey
          };
          hotkey.callback = callback;
          which = _.isNumber(hotkey.key) ? hotkey.key : hotkey.key.toUpperCase().charCodeAt(0);
          if ((base = _this.hotkeys)[which] == null) {
            base[which] = [];
          }
          return _this.hotkeys[which].push(hotkey);
        };
      })(this));
    };
  
    Keyboard.prototype.removeHotkeys = function(hotkey, callback) {
      var base, kept, ref, removed, which;
      hotkey = _.isString(hotkey) ? hotkey.toUpperCase() : hotkey;
      hotkey = Keyboard.hotkeys[hotkey] ? Keyboard.hotkeys[hotkey] : hotkey;
      hotkey = _.isObject(hotkey) ? hotkey : {
        key: hotkey
      };
      which = _.isNumber(hotkey.key) ? hotkey.key : hotkey.key.charCodeAt(0);
      if ((base = this.hotkeys)[which] == null) {
        base[which] = [];
      }
      ref = _.partition(this.hotkeys[which], function(handler) {
        return _.isEqual(hotkey, _.omit(handler, 'callback')) && (!callback || callback === handler.callback);
      }), removed = ref[0], kept = ref[1];
      this.hotkeys[which] = kept;
      return _.map(removed, 'callback');
    };
  
    Keyboard.prototype.toggleFormat = function(range, format) {
      var delta, value;
      if (range.isCollapsed()) {
        delta = this.quill.getContents(Math.max(0, range.start - 1), range.end);
      } else {
        delta = this.quill.getContents(range);
      }
      value = delta.ops.length === 0 || !_.all(delta.ops, function(op) {
        var ref;
        return (ref = op.attributes) != null ? ref[format] : void 0;
      });
      if (range.isCollapsed()) {
        this.quill.prepareFormat(format, value, Quill.sources.USER);
      } else {
        this.quill.formatText(range, format, value, Quill.sources.USER);
      }
      if (this.toolbar != null) {
        return this.toolbar.setActive(format, value);
      }
    };
  
    Keyboard.prototype._initEnter = function() {
      var keys;
      keys = [
        {
          key: dom.KEYS.ENTER
        }, {
          key: dom.KEYS.ENTER,
          shiftKey: true
        }
      ];
      return this.addHotkey(keys, (function(_this) {
        return function(range, hotkey) {
          var delta, leaf, line, offset, ref, ref1;
          if (range == null) {
            return true;
          }
          ref = _this.quill.editor.doc.findLineAt(range.start), line = ref[0], offset = ref[1];
          ref1 = line.findLeafAt(offset), leaf = ref1[0], offset = ref1[1];
          delta = new Delta().retain(range.start).insert('\n', line.formats)["delete"](range.end - range.start);
          _this.quill.updateContents(delta, Quill.sources.USER);
          _.each(leaf.formats, function(value, format) {
            _this.quill.prepareFormat(format, value);
            if (_this.toolbar != null) {
              _this.toolbar.setActive(format, value);
            }
          });
          _this.quill.editor.selection.scrollIntoView();
          return false;
        };
      })(this));
    };
  
    Keyboard.prototype._initDeletes = function() {
      return this.addHotkey([dom.KEYS.DELETE, dom.KEYS.BACKSPACE], (function(_this) {
        return function(range, hotkey) {
          var format, line, offset, ref;
          if ((range != null) && _this.quill.getLength() > 0) {
            if (range.start !== range.end) {
              _this.quill.deleteText(range.start, range.end, Quill.sources.USER);
            } else {
              if (hotkey.key === dom.KEYS.BACKSPACE) {
                ref = _this.quill.editor.doc.findLineAt(range.start), line = ref[0], offset = ref[1];
                if (offset === 0 && (line.formats.bullet || line.formats.list)) {
                  format = line.formats.bullet ? 'bullet' : 'list';
                  _this.quill.formatLine(range.start, range.start, format, false, Quill.sources.USER);
                } else if (range.start > 0) {
                  _this.quill.deleteText(range.start - 1, range.start, Quill.sources.USER);
                }
              } else if (range.start < _this.quill.getLength() - 1) {
                _this.quill.deleteText(range.start, range.start + 1, Quill.sources.USER);
              }
            }
          }
          _this.quill.editor.selection.scrollIntoView();
          return false;
        };
      })(this));
    };
  
    Keyboard.prototype._initHotkeys = function() {
      this.addHotkey(Keyboard.hotkeys.INDENT, (function(_this) {
        return function(range) {
          _this._onTab(range, false);
          return false;
        };
      })(this));
      this.addHotkey(Keyboard.hotkeys.OUTDENT, (function(_this) {
        return function(range) {
          return false;
        };
      })(this));
      _.each(['bold', 'italic', 'underline'], (function(_this) {
        return function(format) {
          return _this.addHotkey(Keyboard.hotkeys[format.toUpperCase()], function(range) {
            if (_this.quill.editor.doc.formats[format]) {
              _this.toggleFormat(range, format);
            }
            return false;
          });
        };
      })(this));
      this._initDeletes();
      return this._initEnter();
    };
  
    Keyboard.prototype._initListeners = function() {
      return dom(this.quill.root).on('keydown', (function(_this) {
        return function(event) {
          var prevent;
          prevent = false;
          _.each(_this.hotkeys[event.which], function(hotkey) {
            var metaKey;
            metaKey = dom.isMac() ? event.metaKey : event.metaKey || event.ctrlKey;
            if (!!hotkey.metaKey !== !!metaKey) {
              return;
            }
            if (!!hotkey.shiftKey !== !!event.shiftKey) {
              return;
            }
            if (!!hotkey.altKey !== !!event.altKey) {
              return;
            }
            prevent = hotkey.callback(_this.quill.getSelection(), hotkey, event) === false || prevent;
            return true;
          });
          return !prevent;
        };
      })(this));
    };
  
    Keyboard.prototype._onTab = function(range, shift) {
      var delta;
      if (shift == null) {
        shift = false;
      }
      delta = new Delta().retain(range.start).insert("\t")["delete"](range.end - range.start).retain(this.quill.getLength() - range.end);
      this.quill.updateContents(delta, Quill.sources.USER);
      return this.quill.setSelection(range.start + 1, range.start + 1);
    };
  
    return Keyboard;
  
  })();
  
  Quill.registerModule('keyboard', Keyboard);
  
  module.exports = Keyboard;
  
  
  },{"../quill":30}],24:[function(_dereq_,module,exports){
  var LinkTooltip, Quill, Tooltip, _, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  Quill = _dereq_('../quill');
  
  Tooltip = _dereq_('./tooltip');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  LinkTooltip = (function(superClass) {
    extend(LinkTooltip, superClass);
  
    LinkTooltip.DEFAULTS = {
      maxLength: 50,
      template: '<span class="title">Visit URL:&nbsp;</span> <a href="#" class="url" target="_blank" href="about:blank"></a> <input class="input" type="text"> <span>&nbsp;&#45;&nbsp;</span> <a href="javascript:;" class="change">Change</a> <a href="javascript:;" class="remove">Remove</a> <a href="javascript:;" class="done">Done</a>'
    };
  
    LinkTooltip.hotkeys = {
      LINK: {
        key: 'K',
        metaKey: true
      }
    };
  
    function LinkTooltip(quill, options) {
      this.quill = quill;
      this.options = options;
      this.options = _.defaults(this.options, Tooltip.DEFAULTS);
      LinkTooltip.__super__.constructor.call(this, this.quill, this.options);
      dom(this.container).addClass('ql-link-tooltip');
      this.textbox = this.container.querySelector('.input');
      this.link = this.container.querySelector('.url');
      this.initListeners();
    }
  
    LinkTooltip.prototype.initListeners = function() {
      this.quill.on(this.quill.constructor.events.SELECTION_CHANGE, (function(_this) {
        return function(range) {
          var anchor;
          if (!((range != null) && range.isCollapsed())) {
            return;
          }
          anchor = _this._findAnchor(range);
          if (anchor) {
            _this.setMode(anchor.href, false);
            return _this.show(anchor);
          } else if (_this.container.style.left !== Tooltip.HIDE_MARGIN) {
            _this.range = null;
            return _this.hide();
          }
        };
      })(this));
      dom(this.container.querySelector('.done')).on('click', _.bind(this.saveLink, this));
      dom(this.container.querySelector('.remove')).on('click', (function(_this) {
        return function() {
          return _this.removeLink(_this.range);
        };
      })(this));
      dom(this.container.querySelector('.change')).on('click', (function(_this) {
        return function() {
          return _this.setMode(_this.link.href, true);
        };
      })(this));
      this.initTextbox(this.textbox, this.saveLink, this.hide);
      this.quill.onModuleLoad('toolbar', (function(_this) {
        return function(toolbar) {
          _this.toolbar = toolbar;
          return toolbar.initFormat('link', _.bind(_this._onToolbar, _this));
        };
      })(this));
      return this.quill.onModuleLoad('keyboard', (function(_this) {
        return function(keyboard) {
          return keyboard.addHotkey(LinkTooltip.hotkeys.LINK, _.bind(_this._onKeyboard, _this));
        };
      })(this));
    };
  
    LinkTooltip.prototype.saveLink = function() {
      var anchor, end, url;
      url = this._normalizeURL(this.textbox.value);
      if (this.range != null) {
        end = this.range.end;
        if (this.range.isCollapsed()) {
          anchor = this._findAnchor(this.range);
          if (anchor != null) {
            anchor.href = url;
          }
        } else {
          this.quill.formatText(this.range, 'link', url, 'user');
        }
        this.quill.setSelection(end, end);
      }
      return this.setMode(url, false);
    };
  
    LinkTooltip.prototype.removeLink = function(range) {
      if (range.isCollapsed()) {
        range = this._expandRange(range);
      }
      this.hide();
      this.quill.formatText(range, 'link', false, 'user');
      if (this.toolbar != null) {
        return this.toolbar.setActive('link', false);
      }
    };
  
    LinkTooltip.prototype.setMode = function(url, edit) {
      var text;
      if (edit == null) {
        edit = false;
      }
      if (edit) {
        this.textbox.value = url;
        _.defer((function(_this) {
          return function() {
            _this.textbox.focus();
            return _this.textbox.setSelectionRange(0, url.length);
          };
        })(this));
      } else {
        this.link.href = url;
        url = this.link.href;
        text = url.length > this.options.maxLength ? url.slice(0, this.options.maxLength) + '...' : url;
        dom(this.link).text(text);
      }
      return dom(this.container).toggleClass('editing', edit);
    };
  
    LinkTooltip.prototype._findAnchor = function(range) {
      var leaf, node, offset, ref;
      ref = this.quill.editor.doc.findLeafAt(range.start, true), leaf = ref[0], offset = ref[1];
      if (leaf != null) {
        node = leaf.node;
      }
      while ((node != null) && node !== this.quill.root) {
        if (node.tagName === 'A') {
          return node;
        }
        node = node.parentNode;
      }
      return null;
    };
  
    LinkTooltip.prototype._expandRange = function(range) {
      var end, leaf, offset, ref, start;
      ref = this.quill.editor.doc.findLeafAt(range.start, true), leaf = ref[0], offset = ref[1];
      start = range.start - offset;
      end = start + leaf.length;
      return {
        start: start,
        end: end
      };
    };
  
    LinkTooltip.prototype._onToolbar = function(range, value) {
      return this._toggle(range, value);
    };
  
    LinkTooltip.prototype._onKeyboard = function() {
      var range;
      range = this.quill.getSelection();
      return this._toggle(range, !this._findAnchor(range));
    };
  
    LinkTooltip.prototype._toggle = function(range, value) {
      var nativeRange;
      if (!range) {
        return;
      }
      if (!value) {
        return this.removeLink(range);
      } else if (!range.isCollapsed()) {
        this.setMode(this._suggestURL(range), true);
        nativeRange = this.quill.editor.selection._getNativeRange();
        return this.show(nativeRange);
      }
    };
  
    LinkTooltip.prototype._normalizeURL = function(url) {
      if (!/^(https?:\/\/|mailto:)/.test(url)) {
        url = 'http://' + url;
      }
      return url;
    };
  
    LinkTooltip.prototype._suggestURL = function(range) {
      var text;
      text = this.quill.getText(range);
      return this._normalizeURL(text);
    };
  
    return LinkTooltip;
  
  })(Tooltip);
  
  Quill.registerModule('link-tooltip', LinkTooltip);
  
  module.exports = LinkTooltip;
  
  
  },{"../quill":30,"./tooltip":28}],25:[function(_dereq_,module,exports){
  var EventEmitter2, MultiCursor, Quill, _, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  Quill = _dereq_('../quill');
  
  EventEmitter2 = _dereq_('eventemitter2').EventEmitter2;
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  MultiCursor = (function(superClass) {
    extend(MultiCursor, superClass);
  
    MultiCursor.DEFAULTS = {
      template: '<span class="cursor-flag"> <span class="cursor-name"></span> </span> <span class="cursor-caret"></span>',
      timeout: 2500
    };
  
    MultiCursor.events = {
      CURSOR_ADDED: 'cursor-addded',
      CURSOR_MOVED: 'cursor-moved',
      CURSOR_REMOVED: 'cursor-removed'
    };
  
    function MultiCursor(quill, options) {
      this.quill = quill;
      this.options = options;
      this.cursors = {};
      this.container = this.quill.addContainer('ql-multi-cursor', true);
      this.quill.on(this.quill.constructor.events.TEXT_CHANGE, _.bind(this._applyDelta, this));
    }
  
    MultiCursor.prototype.clearCursors = function() {
      _.each(Object.keys(this.cursors), _.bind(this.removeCursor, this));
      return this.cursors = {};
    };
  
    MultiCursor.prototype.moveCursor = function(userId, index) {
      var cursor;
      cursor = this.cursors[userId];
      if (cursor == null) {
        return;
      }
      cursor.index = index;
      dom(cursor.elem).removeClass('hidden');
      clearTimeout(cursor.timer);
      cursor.timer = setTimeout((function(_this) {
        return function() {
          dom(cursor.elem).addClass('hidden');
          return cursor.timer = null;
        };
      })(this), this.options.timeout);
      this._updateCursor(cursor);
      return cursor;
    };
  
    MultiCursor.prototype.removeCursor = function(userId) {
      var cursor;
      cursor = this.cursors[userId];
      this.emit(MultiCursor.events.CURSOR_REMOVED, cursor);
      if (cursor != null) {
        cursor.elem.parentNode.removeChild(cursor.elem);
      }
      return delete this.cursors[userId];
    };
  
    MultiCursor.prototype.setCursor = function(userId, index, name, color) {
      var cursor;
      if (this.cursors[userId] == null) {
        this.cursors[userId] = cursor = {
          userId: userId,
          index: index,
          color: color,
          elem: this._buildCursor(name, color)
        };
        this.emit(MultiCursor.events.CURSOR_ADDED, cursor);
      }
      _.defer((function(_this) {
        return function() {
          return _this.moveCursor(userId, index);
        };
      })(this));
      return this.cursors[userId];
    };
  
    MultiCursor.prototype.shiftCursors = function(index, length, authorId) {
      if (authorId == null) {
        authorId = null;
      }
      return _.each(this.cursors, (function(_this) {
        return function(cursor, id) {
          var shift;
          if (!cursor) {
            return;
          }
          shift = Math.max(length, index - cursor.index);
          if (cursor.userId === authorId) {
            return _this.moveCursor(authorId, cursor.index + shift);
          } else if (cursor.index > index) {
            return cursor.index += shift;
          }
        };
      })(this));
    };
  
    MultiCursor.prototype.update = function() {
      return _.each(this.cursors, (function(_this) {
        return function(cursor, id) {
          if (cursor == null) {
            return;
          }
          _this._updateCursor(cursor);
          return true;
        };
      })(this));
    };
  
    MultiCursor.prototype._applyDelta = function(delta) {
      var index;
      index = 0;
      _.each(delta.ops, (function(_this) {
        return function(op) {
          var length, ref;
          length = 0;
          if (op.insert != null) {
            length = op.insert.length || 1;
            _this.shiftCursors(index, length, (ref = op.attributes) != null ? ref['author'] : void 0);
          } else if (op["delete"] != null) {
            _this.shiftCursors(index, -1 * op["delete"], null);
          } else if (op.retain != null) {
            _this.shiftCursors(index, 0, null);
            length = op.retain;
          }
          return index += length;
        };
      })(this));
      return this.update();
    };
  
    MultiCursor.prototype._buildCursor = function(name, color) {
      var cursor, cursorCaret, cursorFlag, cursorName;
      cursor = document.createElement('span');
      dom(cursor).addClass('cursor');
      cursor.innerHTML = this.options.template;
      cursorFlag = cursor.querySelector('.cursor-flag');
      cursorName = cursor.querySelector('.cursor-name');
      dom(cursorName).text(name);
      cursorCaret = cursor.querySelector('.cursor-caret');
      cursorCaret.style.backgroundColor = cursorName.style.backgroundColor = color;
      this.container.appendChild(cursor);
      return cursor;
    };
  
    MultiCursor.prototype._updateCursor = function(cursor) {
      var bounds, flag;
      bounds = this.quill.getBounds(cursor.index);
      if (bounds == null) {
        return this.removeCursor(cursor.userId);
      }
      cursor.elem.style.top = (bounds.top + this.quill.container.scrollTop) + 'px';
      cursor.elem.style.left = bounds.left + 'px';
      cursor.elem.style.height = bounds.height + 'px';
      flag = cursor.elem.querySelector('.cursor-flag');
      dom(cursor.elem).toggleClass('top', parseInt(cursor.elem.style.top) <= flag.offsetHeight).toggleClass('left', parseInt(cursor.elem.style.left) <= flag.offsetWidth).toggleClass('right', this.quill.root.offsetWidth - parseInt(cursor.elem.style.left) <= flag.offsetWidth);
      return this.emit(MultiCursor.events.CURSOR_MOVED, cursor);
    };
  
    return MultiCursor;
  
  })(EventEmitter2);
  
  Quill.registerModule('multi-cursor', MultiCursor);
  
  module.exports = MultiCursor;
  
  
  },{"../quill":30,"eventemitter2":2}],26:[function(_dereq_,module,exports){
  var Delta, Document, PasteManager, Quill, _, dom,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
  
  Quill = _dereq_('../quill');
  
  Document = _dereq_('../core/document');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  Delta = Quill.require('delta');
  
  PasteManager = (function() {
    PasteManager.DEFAULTS = {
      onConvert: null
    };
  
    function PasteManager(quill, options) {
      var base;
      this.quill = quill;
      this._onConvert = bind(this._onConvert, this);
      this.container = this.quill.addContainer('ql-paste-manager');
      this.container.setAttribute('contenteditable', true);
      this.container.setAttribute('tabindex', '-1');
      dom(this.quill.root).on('paste', _.bind(this._paste, this));
      this.options = _.defaults(options, PasteManager.DEFAULTS);
      if ((base = this.options).onConvert == null) {
        base.onConvert = this._onConvert;
      }
    }
  
    PasteManager.prototype._onConvert = function(container) {
      var delta, doc, lengthAdded;
      doc = new Document(container, this.quill.options);
      delta = doc.toDelta();
      lengthAdded = delta.length();
      if (lengthAdded === 0) {
        return delta;
      }
      return delta.compose(new Delta().retain(lengthAdded - 1)["delete"](1));
    };
  
    PasteManager.prototype._paste = function() {
      var oldDocLength, range;
      oldDocLength = this.quill.getLength();
      range = this.quill.getSelection();
      if (range == null) {
        return;
      }
      this.container.focus();
      return _.defer((function(_this) {
        return function() {
          var delta, lengthAdded;
          delta = _this.options.onConvert(_this.container);
          lengthAdded = delta.length();
          if (lengthAdded > 0) {
            if (range.start > 0) {
              delta.ops.unshift({
                retain: range.start
              });
            }
            delta["delete"](range.end - range.start);
            _this.quill.updateContents(delta, 'user');
          }
          _this.quill.setSelection(range.start + lengthAdded, range.start + lengthAdded);
          _this.quill.editor.selection.scrollIntoView();
          return _this.container.innerHTML = "";
        };
      })(this));
    };
  
    return PasteManager;
  
  })();
  
  Quill.registerModule('paste-manager', PasteManager);
  
  module.exports = PasteManager;
  
  
  },{"../core/document":8,"../quill":30}],27:[function(_dereq_,module,exports){
  var Quill, Toolbar, _, dom;
  
  Quill = _dereq_('../quill');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  Toolbar = (function() {
    Toolbar.DEFAULTS = {
      container: null
    };
  
    Toolbar.formats = {
      LINE: {
        'align': 'align',
        'bullet': 'bullet',
        'list': 'list'
      },
      SELECT: {
        'align': 'align',
        'background': 'background',
        'color': 'color',
        'font': 'font',
        'size': 'size'
      },
      TOGGLE: {
        'bold': 'bold',
        'bullet': 'bullet',
        'image': 'image',
        'italic': 'italic',
        'link': 'link',
        'list': 'list',
        'strike': 'strike',
        'underline': 'underline'
      },
      TOOLTIP: {
        'image': 'image',
        'link': 'link'
      }
    };
  
    function Toolbar(quill, options) {
      this.quill = quill;
      this.options = options;
      if (_.isString(this.options) || _.isElement(this.options)) {
        this.options = {
          container: this.options
        };
      }
      if (this.options.container == null) {
        throw new Error('container required for toolbar', this.options);
      }
      this.container = _.isString(this.options.container) ? document.querySelector(this.options.container) : this.options.container;
      this.inputs = {};
      this.preventUpdate = false;
      this.triggering = false;
      _.each(this.quill.options.formats, (function(_this) {
        return function(name) {
          if (Toolbar.formats.TOOLTIP[name] != null) {
            return;
          }
          return _this.initFormat(name, _.bind(_this._applyFormat, _this, name));
        };
      })(this));
      this.quill.on(Quill.events.FORMAT_INIT, (function(_this) {
        return function(name) {
          if (Toolbar.formats.TOOLTIP[name] != null) {
            return;
          }
          return _this.initFormat(name, _.bind(_this._applyFormat, _this, name));
        };
      })(this));
      this.quill.on(Quill.events.SELECTION_CHANGE, (function(_this) {
        return function(range) {
          if (range != null) {
            return _this.updateActive(range);
          }
        };
      })(this));
      this.quill.on(Quill.events.TEXT_CHANGE, (function(_this) {
        return function() {
          return _this.updateActive();
        };
      })(this));
      this.quill.onModuleLoad('keyboard', (function(_this) {
        return function(keyboard) {
          return keyboard.addHotkey([dom.KEYS.BACKSPACE, dom.KEYS.DELETE], function() {
            return _.defer(_.bind(_this.updateActive, _this));
          });
        };
      })(this));
      dom(this.container).addClass('ql-toolbar');
      if (dom.isIOS()) {
        dom(this.container).addClass('ios');
      }
    }
  
    Toolbar.prototype.initFormat = function(format, callback) {
      var eventName, input, selector;
      selector = ".ql-" + format;
      if (Toolbar.formats.SELECT[format] != null) {
        selector = "select" + selector;
        eventName = 'change';
      } else {
        eventName = 'click';
      }
      input = this.container.querySelector(selector);
      if (input == null) {
        return;
      }
      this.inputs[format] = input;
      return dom(input).on(eventName, (function(_this) {
        return function() {
          var range, value;
          value = eventName === 'change' ? dom(input).value() : !dom(input).hasClass('ql-active');
          _this.preventUpdate = true;
          _this.quill.focus();
          range = _this.quill.getSelection();
          if (range != null) {
            callback(range, value);
          }
          if (dom.isIE(11)) {
            _this.quill.editor.selection.scrollIntoView();
          }
          _this.preventUpdate = false;
          return false;
        };
      })(this));
    };
  
    Toolbar.prototype.setActive = function(format, value) {
      var $input, input, ref, selectValue;
      if (format === 'image') {
        value = false;
      }
      input = this.inputs[format];
      if (input == null) {
        return;
      }
      $input = dom(input);
      if (input.tagName === 'SELECT') {
        this.triggering = true;
        selectValue = $input.value(input);
        if (value == null) {
          value = (ref = $input["default"]()) != null ? ref.value : void 0;
        }
        if (Array.isArray(value)) {
          value = '';
        }
        if (value !== selectValue) {
          if (value != null) {
            $input.option(value);
          } else {
            $input.reset();
          }
        }
        return this.triggering = false;
      } else {
        return $input.toggleClass('ql-active', value || false);
      }
    };
  
    Toolbar.prototype.updateActive = function(range, formats) {
      var activeFormats;
      if (formats == null) {
        formats = null;
      }
      range || (range = this.quill.getSelection());
      if (!((range != null) && !this.preventUpdate)) {
        return;
      }
      activeFormats = this._getActive(range);
      return _.each(this.inputs, (function(_this) {
        return function(input, format) {
          if (!Array.isArray(formats) || formats.indexOf(format) > -1) {
            _this.setActive(format, activeFormats[format]);
          }
          return true;
        };
      })(this));
    };
  
    Toolbar.prototype._applyFormat = function(format, range, value) {
      if (this.triggering) {
        return;
      }
      if (range.isCollapsed()) {
        this.quill.prepareFormat(format, value, 'user');
      } else if (Toolbar.formats.LINE[format] != null) {
        this.quill.formatLine(range, format, value, 'user');
      } else {
        this.quill.formatText(range, format, value, 'user');
      }
      return _.defer((function(_this) {
        return function() {
          _this.updateActive(range, ['bullet', 'list']);
          return _this.setActive(format, value);
        };
      })(this));
    };
  
    Toolbar.prototype._getActive = function(range) {
      var leafFormats, lineFormats;
      leafFormats = this._getLeafActive(range);
      lineFormats = this._getLineActive(range);
      return _.defaults({}, leafFormats, lineFormats);
    };
  
    Toolbar.prototype._getLeafActive = function(range) {
      var contents, formatsArr, line, offset, ref;
      if (range.isCollapsed()) {
        ref = this.quill.editor.doc.findLineAt(range.start), line = ref[0], offset = ref[1];
        if (offset === 0) {
          contents = this.quill.getContents(range.start, range.end + 1);
        } else {
          contents = this.quill.getContents(range.start - 1, range.end);
        }
      } else {
        contents = this.quill.getContents(range);
      }
      formatsArr = _.map(contents.ops, 'attributes');
      return this._intersectFormats(formatsArr);
    };
  
    Toolbar.prototype._getLineActive = function(range) {
      var firstLine, formatsArr, lastLine, offset, ref, ref1;
      formatsArr = [];
      ref = this.quill.editor.doc.findLineAt(range.start), firstLine = ref[0], offset = ref[1];
      ref1 = this.quill.editor.doc.findLineAt(range.end), lastLine = ref1[0], offset = ref1[1];
      if ((lastLine != null) && lastLine === firstLine) {
        lastLine = lastLine.next;
      }
      while ((firstLine != null) && firstLine !== lastLine) {
        formatsArr.push(_.clone(firstLine.formats));
        firstLine = firstLine.next;
      }
      return this._intersectFormats(formatsArr);
    };
  
    Toolbar.prototype._intersectFormats = function(formatsArr) {
      return _.reduce(formatsArr.slice(1), function(activeFormats, formats) {
        var activeKeys, added, formatKeys, intersection, missing;
        if (formats == null) {
          formats = {};
        }
        activeKeys = Object.keys(activeFormats);
        formatKeys = formats != null ? Object.keys(formats) : {};
        intersection = _.intersection(activeKeys, formatKeys);
        missing = _.difference(activeKeys, formatKeys);
        added = _.difference(formatKeys, activeKeys);
        _.each(intersection, function(name) {
          if (Toolbar.formats.SELECT[name] != null) {
            if (Array.isArray(activeFormats[name])) {
              if (activeFormats[name].indexOf(formats[name]) < 0) {
                return activeFormats[name].push(formats[name]);
              }
            } else if (activeFormats[name] !== formats[name]) {
              return activeFormats[name] = [activeFormats[name], formats[name]];
            }
          }
        });
        _.each(missing, function(name) {
          if (Toolbar.formats.TOGGLE[name] != null) {
            return delete activeFormats[name];
          } else if ((Toolbar.formats.SELECT[name] != null) && !Array.isArray(activeFormats[name])) {
            return activeFormats[name] = [activeFormats[name]];
          }
        });
        _.each(added, function(name) {
          if (Toolbar.formats.SELECT[name] != null) {
            return activeFormats[name] = [formats[name]];
          }
        });
        return activeFormats;
      }, formatsArr[0] || {});
    };
  
    return Toolbar;
  
  })();
  
  Quill.registerModule('toolbar', Toolbar);
  
  module.exports = Toolbar;
  
  
  },{"../quill":30}],28:[function(_dereq_,module,exports){
  var Quill, Tooltip, _, dom;
  
  Quill = _dereq_('../quill');
  
  _ = Quill.require('lodash');
  
  dom = Quill.require('dom');
  
  Tooltip = (function() {
    Tooltip.DEFAULTS = {
      offset: 10,
      template: ''
    };
  
    Tooltip.HIDE_MARGIN = '-10000px';
  
    function Tooltip(quill, options) {
      this.quill = quill;
      this.options = options;
      this.container = this.quill.addContainer('ql-tooltip');
      this.container.innerHTML = this.options.template;
      this.hide();
      this.quill.on(this.quill.constructor.events.TEXT_CHANGE, (function(_this) {
        return function(delta, source) {
          if (_this.container.style.left !== Tooltip.HIDE_MARGIN) {
            _this.range = null;
            return _this.hide();
          }
        };
      })(this));
    }
  
    Tooltip.prototype.initTextbox = function(textbox, enterCallback, escapeCallback) {
      return dom(textbox).on('keydown', (function(_this) {
        return function(event) {
          switch (event.which) {
            case dom.KEYS.ENTER:
              event.preventDefault();
              return enterCallback.call(_this);
            case dom.KEYS.ESCAPE:
              event.preventDefault();
              return escapeCallback.call(_this);
            default:
              return true;
          }
        };
      })(this));
    };
  
    Tooltip.prototype.hide = function() {
      this.container.style.left = Tooltip.HIDE_MARGIN;
      if (this.range) {
        this.quill.setSelection(this.range);
      }
      return this.range = null;
    };
  
    Tooltip.prototype.position = function(reference) {
      var left, offsetBottom, offsetLeft, offsetTop, parentBounds, referenceBounds, top;
      if (reference != null) {
        referenceBounds = reference.getBoundingClientRect();
        parentBounds = this.quill.container.getBoundingClientRect();
        offsetLeft = referenceBounds.left - parentBounds.left;
        offsetTop = referenceBounds.top - parentBounds.top;
        offsetBottom = referenceBounds.bottom - parentBounds.bottom;
        left = offsetLeft + referenceBounds.width / 2 - this.container.offsetWidth / 2;
        top = offsetTop + referenceBounds.height + this.options.offset;
        if (top + this.container.offsetHeight > this.quill.container.offsetHeight) {
          top = offsetTop - this.container.offsetHeight - this.options.offset;
        }
        left = Math.max(0, Math.min(left, this.quill.container.offsetWidth - this.container.offsetWidth));
        top = Math.max(0, Math.min(top, this.quill.container.offsetHeight - this.container.offsetHeight));
      } else {
        left = this.quill.container.offsetWidth / 2 - this.container.offsetWidth / 2;
        top = this.quill.container.offsetHeight / 2 - this.container.offsetHeight / 2;
      }
      top += this.quill.container.scrollTop;
      return [left, top];
    };
  
    Tooltip.prototype.show = function(reference) {
      var left, ref, top;
      this.range = this.quill.getSelection();
      ref = this.position(reference), left = ref[0], top = ref[1];
      this.container.style.left = left + "px";
      this.container.style.top = top + "px";
      return this.container.focus();
    };
  
    return Tooltip;
  
  })();
  
  Quill.registerModule('tooltip', Tooltip);
  
  module.exports = Tooltip;
  
  
  },{"../quill":30}],29:[function(_dereq_,module,exports){
  var Delta, Quill, UndoManager, _;
  
  Quill = _dereq_('../quill');
  
  _ = Quill.require('lodash');
  
  Delta = Quill.require('delta');
  
  UndoManager = (function() {
    UndoManager.DEFAULTS = {
      delay: 1000,
      maxStack: 100,
      userOnly: false
    };
  
    UndoManager.hotkeys = {
      UNDO: {
        key: 'Z',
        metaKey: true
      },
      REDO: {
        key: 'Z',
        metaKey: true,
        shiftKey: true
      }
    };
  
    function UndoManager(quill, options) {
      this.quill = quill;
      this.options = options != null ? options : {};
      this.lastRecorded = 0;
      this.ignoreChange = false;
      this.clear();
      this.initListeners();
    }
  
    UndoManager.prototype.initListeners = function() {
      this.quill.onModuleLoad('keyboard', (function(_this) {
        return function(keyboard) {
          var redoKey;
          keyboard.addHotkey(UndoManager.hotkeys.UNDO, function() {
            _this.quill.editor.checkUpdate();
            _this.undo();
            return false;
          });
          redoKey = [UndoManager.hotkeys.REDO];
          if (navigator.platform.indexOf('Win') > -1) {
            redoKey.push({
              key: 'Y',
              metaKey: true
            });
          }
          return keyboard.addHotkey(redoKey, function() {
            _this.quill.editor.checkUpdate();
            _this.redo();
            return false;
          });
        };
      })(this));
      return this.quill.on(this.quill.constructor.events.TEXT_CHANGE, (function(_this) {
        return function(delta, source) {
          if (_this.ignoreChange) {
            return;
          }
          if (!_this.options.userOnly || source === Quill.sources.USER) {
            _this.record(delta, _this.oldDelta);
          } else {
            _this._transform(delta);
          }
          return _this.oldDelta = _this.quill.getContents();
        };
      })(this));
    };
  
    UndoManager.prototype.clear = function() {
      this.stack = {
        undo: [],
        redo: []
      };
      return this.oldDelta = this.quill.getContents();
    };
  
    UndoManager.prototype.record = function(changeDelta, oldDelta) {
      var change, ignored, timestamp, undoDelta;
      if (!(changeDelta.ops.length > 0)) {
        return;
      }
      this.stack.redo = [];
      try {
        undoDelta = this.quill.getContents().diff(this.oldDelta);
        timestamp = new Date().getTime();
        if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
          change = this.stack.undo.pop();
          undoDelta = undoDelta.compose(change.undo);
          changeDelta = change.redo.compose(changeDelta);
        } else {
          this.lastRecorded = timestamp;
        }
        this.stack.undo.push({
          redo: changeDelta,
          undo: undoDelta
        });
        if (this.stack.undo.length > this.options.maxStack) {
          return this.stack.undo.unshift();
        }
      } catch (_error) {
        ignored = _error;
        console.warn('Could not record change... clearing undo stack.');
        return this.clear();
      }
    };
  
    UndoManager.prototype.redo = function() {
      return this._change('redo', 'undo');
    };
  
    UndoManager.prototype.undo = function() {
      return this._change('undo', 'redo');
    };
  
    UndoManager.prototype._getLastChangeIndex = function(delta) {
      var index, lastIndex;
      lastIndex = 0;
      index = 0;
      _.each(delta.ops, function(op) {
        if (op.insert != null) {
          return lastIndex = Math.max(index + (op.insert.length || 1), lastIndex);
        } else if (op["delete"] != null) {
          return lastIndex = Math.max(index, lastIndex);
        } else if (op.retain != null) {
          if (op.attributes != null) {
            lastIndex = Math.max(index + op.retain, lastIndex);
          }
          return index += op.retain;
        }
      });
      return lastIndex;
    };
  
    UndoManager.prototype._change = function(source, dest) {
      var change, index;
      if (this.stack[source].length > 0) {
        change = this.stack[source].pop();
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(change[source], Quill.sources.USER);
        this.ignoreChange = false;
        index = this._getLastChangeIndex(change[source]);
        this.quill.setSelection(index, index);
        this.oldDelta = this.quill.getContents();
        return this.stack[dest].push(change);
      }
    };
  
    UndoManager.prototype._transform = function(delta) {
      var change, i, j, len, len1, ref, ref1, results;
      this.oldDelta = delta.transform(this.oldDelta, true);
      ref = this.stack.undo;
      for (i = 0, len = ref.length; i < len; i++) {
        change = ref[i];
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      }
      ref1 = this.stack.redo;
      results = [];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        change = ref1[j];
        change.undo = delta.transform(change.undo, true);
        results.push(change.redo = delta.transform(change.redo, true));
      }
      return results;
    };
  
    return UndoManager;
  
  })();
  
  Quill.registerModule('undo-manager', UndoManager);
  
  module.exports = UndoManager;
  
  
  },{"../quill":30}],30:[function(_dereq_,module,exports){
  var Delta, Document, Editor, EventEmitter2, Format, Normalizer, Quill, Range, _, dom, pkg,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice;
  
  _ = _dereq_('lodash');
  
  pkg = _dereq_('../package.json');
  
  Delta = _dereq_('rich-text/lib/delta');
  
  EventEmitter2 = _dereq_('eventemitter2').EventEmitter2;
  
  dom = _dereq_('./lib/dom');
  
  Document = _dereq_('./core/document');
  
  Editor = _dereq_('./core/editor');
  
  Format = _dereq_('./core/format');
  
  Normalizer = _dereq_('./core/normalizer');
  
  Range = _dereq_('./lib/range');
  
  Quill = (function(superClass) {
    extend(Quill, superClass);
  
    Quill.version = pkg.version;
  
    Quill.editors = [];
  
    Quill.modules = [];
  
    Quill.themes = [];
  
    Quill.DEFAULTS = {
      formats: ['align', 'bold', 'italic', 'strike', 'underline', 'color', 'background', 'font', 'size', 'link', 'image', 'bullet', 'list'],
      modules: {
        'keyboard': true,
        'paste-manager': true,
        'undo-manager': true
      },
      pollInterval: 100,
      readOnly: false,
      styles: {},
      theme: 'base'
    };
  
    Quill.events = {
      FORMAT_INIT: 'format-init',
      MODULE_INIT: 'module-init',
      POST_EVENT: 'post-event',
      PRE_EVENT: 'pre-event',
      SELECTION_CHANGE: 'selection-change',
      TEXT_CHANGE: 'text-change'
    };
  
    Quill.sources = Editor.sources;
  
    Quill.registerModule = function(name, module) {
      if (Quill.modules[name] != null) {
        console.warn("Overwriting " + name + " module");
      }
      return Quill.modules[name] = module;
    };
  
    Quill.registerTheme = function(name, theme) {
      if (Quill.themes[name] != null) {
        console.warn("Overwriting " + name + " theme");
      }
      return Quill.themes[name] = theme;
    };
  
    Quill.require = function(name) {
      switch (name) {
        case 'lodash':
          return _;
        case 'delta':
          return Delta;
        case 'format':
          return Format;
        case 'normalizer':
          return Normalizer;
        case 'dom':
          return dom;
        case 'document':
          return Document;
        case 'range':
          return Range;
        default:
          return null;
      }
    };
  
    function Quill(container1, options) {
      var html, moduleOptions, themeClass;
      this.container = container1;
      if (options == null) {
        options = {};
      }
      if (_.isString(this.container)) {
        this.container = document.querySelector(this.container);
      }
      if (this.container == null) {
        throw new Error('Invalid Quill container');
      }
      moduleOptions = _.defaults(options.modules || {}, Quill.DEFAULTS.modules);
      html = this.container.innerHTML;
      this.container.innerHTML = '';
      this.options = _.defaults(options, Quill.DEFAULTS);
      this.options.modules = moduleOptions;
      this.options.id = this.id = "ql-editor-" + (Quill.editors.length + 1);
      this.modules = {};
      this.root = this.addContainer('ql-editor');
      this.editor = new Editor(this.root, this, this.options);
      Quill.editors.push(this);
      this.setHTML(html, Quill.sources.SILENT);
      themeClass = Quill.themes[this.options.theme];
      if (themeClass == null) {
        throw new Error("Cannot load " + this.options.theme + " theme. Are you sure you registered it?");
      }
      this.theme = new themeClass(this, this.options);
      _.each(this.options.modules, (function(_this) {
        return function(option, name) {
          return _this.addModule(name, option);
        };
      })(this));
    }
  
    Quill.prototype.destroy = function() {
      var html;
      html = this.getHTML();
      _.each(this.modules, function(module, name) {
        if (_.isFunction(module.destroy)) {
          return module.destroy();
        }
      });
      this.editor.destroy();
      this.removeAllListeners();
      Quill.editors.splice(_.indexOf(Quill.editors, this), 1);
      return this.container.innerHTML = html;
    };
  
    Quill.prototype.addContainer = function(className, before) {
      var container, refNode;
      if (before == null) {
        before = false;
      }
      refNode = before ? this.root : null;
      container = document.createElement('div');
      dom(container).addClass(className);
      this.container.insertBefore(container, refNode);
      return container;
    };
  
    Quill.prototype.addFormat = function(name, config) {
      this.editor.doc.addFormat(name, config);
      return this.emit(Quill.events.FORMAT_INIT, name);
    };
  
    Quill.prototype.addModule = function(name, options) {
      var moduleClass;
      moduleClass = Quill.modules[name];
      if (moduleClass == null) {
        throw new Error("Cannot load " + name + " module. Are you sure you registered it?");
      }
      if (options === true) {
        options = {};
      }
      options = _.defaults(options, this.theme.constructor.OPTIONS[name] || {}, moduleClass.DEFAULTS || {});
      this.modules[name] = new moduleClass(this, options);
      this.emit(Quill.events.MODULE_INIT, name, this.modules[name]);
      return this.modules[name];
    };
  
    Quill.prototype.deleteText = function(start, end, source) {
      var delta, formats, ref;
      if (source == null) {
        source = Quill.sources.API;
      }
      ref = this._buildParams(start, end, {}, source), start = ref[0], end = ref[1], formats = ref[2], source = ref[3];
      if (!(end > start)) {
        return;
      }
      delta = new Delta().retain(start)["delete"](end - start);
      return this.editor.applyDelta(delta, source);
    };
  
    Quill.prototype.emit = function() {
      var args, eventName;
      eventName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
      Quill.__super__.emit.apply(this, [Quill.events.PRE_EVENT, eventName].concat(slice.call(args)));
      Quill.__super__.emit.apply(this, [eventName].concat(slice.call(args)));
      return Quill.__super__.emit.apply(this, [Quill.events.POST_EVENT, eventName].concat(slice.call(args)));
    };
  
    Quill.prototype.focus = function() {
      return this.editor.focus();
    };
  
    Quill.prototype.formatLine = function(start, end, name, value, source) {
      var formats, line, offset, ref, ref1;
      ref = this._buildParams(start, end, name, value, source), start = ref[0], end = ref[1], formats = ref[2], source = ref[3];
      ref1 = this.editor.doc.findLineAt(end), line = ref1[0], offset = ref1[1];
      if (line != null) {
        end += line.length - offset;
      }
      return this.formatText(start, end, formats, source);
    };
  
    Quill.prototype.formatText = function(start, end, name, value, source) {
      var delta, formats, ref;
      ref = this._buildParams(start, end, name, value, source), start = ref[0], end = ref[1], formats = ref[2], source = ref[3];
      formats = _.reduce(formats, (function(_this) {
        return function(formats, value, name) {
          var format;
          format = _this.editor.doc.formats[name];
          if (!(value && value !== format.config["default"])) {
            formats[name] = null;
          }
          return formats;
        };
      })(this), formats);
      delta = new Delta().retain(start).retain(end - start, formats);
      return this.editor.applyDelta(delta, source);
    };
  
    Quill.prototype.getBounds = function(index) {
      return this.editor.getBounds(index);
    };
  
    Quill.prototype.getContents = function(start, end) {
      if (start == null) {
        start = 0;
      }
      if (end == null) {
        end = null;
      }
      if (_.isObject(start)) {
        end = start.end;
        start = start.start;
      }
      return this.editor.delta.slice(start, end);
    };
  
    Quill.prototype.getHTML = function() {
      return this.editor.doc.getHTML();
    };
  
    Quill.prototype.getLength = function() {
      return this.editor.length;
    };
  
    Quill.prototype.getModule = function(name) {
      return this.modules[name];
    };
  
    Quill.prototype.getSelection = function() {
      this.editor.checkUpdate();
      return this.editor.selection.getRange();
    };
  
    Quill.prototype.getText = function(start, end) {
      if (start == null) {
        start = 0;
      }
      if (end == null) {
        end = null;
      }
      return _.map(this.getContents(start, end).ops, function(op) {
        if (_.isString(op.insert)) {
          return op.insert;
        } else {
          return '';
        }
      }).join('');
    };
  
    Quill.prototype.insertEmbed = function(index, type, url, source) {
      var delta, end, formats, ref;
      ref = this._buildParams(index, 0, type, url, source), index = ref[0], end = ref[1], formats = ref[2], source = ref[3];
      delta = new Delta().retain(index).insert(1, formats);
      return this.editor.applyDelta(delta, source);
    };
  
    Quill.prototype.insertText = function(index, text, name, value, source) {
      var delta, end, formats, ref;
      ref = this._buildParams(index, 0, name, value, source), index = ref[0], end = ref[1], formats = ref[2], source = ref[3];
      if (!(text.length > 0)) {
        return;
      }
      delta = new Delta().retain(index).insert(text, formats);
      return this.editor.applyDelta(delta, source);
    };
  
    Quill.prototype.onModuleLoad = function(name, callback) {
      if (this.modules[name]) {
        return callback(this.modules[name]);
      }
      return this.on(Quill.events.MODULE_INIT, function(moduleName, module) {
        if (moduleName === name) {
          return callback(module);
        }
      });
    };
  
    Quill.prototype.prepareFormat = function(name, value, source) {
      var format, range;
      if (source == null) {
        source = Quill.sources.API;
      }
      format = this.editor.doc.formats[name];
      if (format == null) {
        return;
      }
      range = this.getSelection();
      if (!(range != null ? range.isCollapsed() : void 0)) {
        return;
      }
      if (format.isType(Format.types.LINE)) {
        return this.formatLine(range, name, value, source);
      } else {
        return format.prepare(value);
      }
    };
  
    Quill.prototype.setContents = function(delta, source) {
      var lastOp;
      if (source == null) {
        source = Quill.sources.API;
      }
      if (Array.isArray(delta)) {
        delta = new Delta(delta.slice());
      } else {
        delta = new Delta(delta.ops.slice());
      }
      lastOp = _.last(delta.slice(delta.length() - 1).ops);
      delta["delete"](this.getLength() - 1);
      if ((lastOp != null) && _.isString(lastOp.insert) && _.last(lastOp.insert) === '\n') {
        delta["delete"](1);
      }
      return this.updateContents(delta, source);
    };
  
    Quill.prototype.setHTML = function(html, source) {
      if (source == null) {
        source = Quill.sources.API;
      }
      if (!html.trim()) {
        html = "<" + dom.DEFAULT_BLOCK_TAG + "><" + dom.DEFAULT_BREAK_TAG + "></" + dom.DEFAULT_BLOCK_TAG + ">";
      }
      this.editor.doc.setHTML(html);
      return this.editor.checkUpdate(source);
    };
  
    Quill.prototype.setSelection = function(start, end, source) {
      var range;
      if (source == null) {
        source = Quill.sources.API;
      }
      if (_.isNumber(start) && _.isNumber(end)) {
        range = new Range(start, end);
      } else {
        range = start;
        source = end || source;
      }
      return this.editor.selection.setRange(range, source);
    };
  
    Quill.prototype.setText = function(text, source) {
      var delta;
      if (source == null) {
        source = Quill.sources.API;
      }
      delta = new Delta().insert(text);
      return this.setContents(delta, source);
    };
  
    Quill.prototype.updateContents = function(delta, source) {
      if (source == null) {
        source = Quill.sources.API;
      }
      if (Array.isArray(delta)) {
        delta = {
          ops: delta
        };
      }
      return this.editor.applyDelta(delta, source);
    };
  
    Quill.prototype._buildParams = function() {
      var formats, params;
      params = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      if (_.isObject(params[0])) {
        params.splice(0, 1, params[0].start, params[0].end);
      }
      if (_.isString(params[2])) {
        formats = {};
        formats[params[2]] = params[3];
        params.splice(2, 2, formats);
      }
      if (params[3] == null) {
        params[3] = Quill.sources.API;
      }
      return params;
    };
  
    return Quill;
  
  })(EventEmitter2);
  
  Quill.registerTheme('base', _dereq_('./themes/base'));
  
  Quill.registerTheme('snow', _dereq_('./themes/snow'));
  
  module.exports = Quill;
  
  
  },{"../package.json":7,"./core/document":8,"./core/editor":9,"./core/format":10,"./core/normalizer":13,"./lib/dom":17,"./lib/range":20,"./themes/base":32,"./themes/snow":33,"eventemitter2":2,"lodash":1,"rich-text/lib/delta":3}],31:[function(_dereq_,module,exports){
  module.exports = ".ql-image-tooltip{padding:10px;width:300px}.ql-image-tooltip:after{clear:both;content:\"\";display:table}.ql-image-tooltip a{border:1px solid #000;box-sizing:border-box;display:inline-block;float:left;padding:5px;text-align:center;width:50%}.ql-image-tooltip img{bottom:0;left:0;margin:auto;max-height:100%;max-width:100%;position:absolute;right:0;top:0}.ql-image-tooltip .input{box-sizing:border-box;width:100%}.ql-image-tooltip .preview{margin:10px 0;position:relative;border:1px dashed #000;height:200px}.ql-image-tooltip .preview span{display:inline-block;position:absolute;text-align:center;top:40%;width:100%}.ql-link-tooltip{padding:5px 10px}.ql-link-tooltip input.input{width:170px}.ql-link-tooltip a.done,.ql-link-tooltip input.input{display:none}.ql-link-tooltip a.change{margin-right:4px}.ql-link-tooltip.editing a.done,.ql-link-tooltip.editing input.input{display:inline-block}.ql-link-tooltip.editing a.change,.ql-link-tooltip.editing a.remove,.ql-link-tooltip.editing a.url{display:none}.ql-multi-cursor{position:absolute;left:0;top:0;z-index:1000}.ql-multi-cursor .cursor{margin-left:-1px;position:absolute}.ql-multi-cursor .cursor-flag{bottom:100%;position:absolute;white-space:nowrap}.ql-multi-cursor .cursor-name{display:inline-block;color:#fff;padding:2px 8px}.ql-multi-cursor .cursor-caret{height:100%;position:absolute;width:2px}.ql-multi-cursor .cursor.hidden .cursor-flag{display:none}.ql-multi-cursor .cursor.top .cursor-flag{bottom:auto;top:100%}.ql-multi-cursor .cursor.right .cursor-flag{right:-2px}.ql-paste-manager{left:-100000px;position:absolute;top:50%}.ql-toolbar{box-sizing:border-box}.ql-tooltip{background-color:#fff;border:1px solid #000;box-sizing:border-box;position:absolute;top:0;white-space:nowrap;z-index:2000}.ql-tooltip a{cursor:pointer;text-decoration:none}.ql-container{box-sizing:border-box;cursor:text;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;line-height:1.42;margin:0;overflow-x:hidden;overflow-y:auto;padding:12px 15px;position:relative}.ql-editor{box-sizing:border-box;min-height:100%;outline:0;tab-size:4;white-space:pre-wrap}.ql-editor div{margin:0;padding:0}.ql-editor a{text-decoration:underline}.ql-editor b{font-weight:700}.ql-editor i{font-style:italic}.ql-editor s{text-decoration:line-through}.ql-editor u{text-decoration:underline}.ql-editor a,.ql-editor b,.ql-editor i,.ql-editor s,.ql-editor span,.ql-editor u{background-color:inherit}.ql-editor img{max-width:100%}.ql-editor blockquote,.ql-editor ol,.ql-editor ul{margin:0 0 0 2em;padding:0}.ql-editor ol{list-style-type:decimal}.ql-editor ul{list-style-type:disc}.ql-editor.ql-ie-10 br,.ql-editor.ql-ie-9 br{display:none}";
  },{}],32:[function(_dereq_,module,exports){
  var BaseTheme, _, baseStyles, dom;
  
  _ = _dereq_('lodash');
  
  dom = _dereq_('../../lib/dom');
  
  baseStyles = _dereq_('./base.styl');
  
  BaseTheme = (function() {
    BaseTheme.OPTIONS = {};
  
    BaseTheme.objToCss = function(obj) {
      return _.map(obj, function(value, key) {
        var innerStr;
        innerStr = _.map(value, function(innerValue, innerKey) {
          return innerKey + ": " + innerValue + ";";
        }).join(' ');
        return key + " { " + innerStr + " }";
      }).join("\n");
    };
  
    function BaseTheme(quill, options) {
      var version;
      this.quill = quill;
      this.options = options;
      dom(this.quill.container).addClass('ql-container');
      if (this.options.styles) {
        this.addStyles(baseStyles + BaseTheme.objToCss(this.options.styles));
      }
      if (dom.isIE(10)) {
        version = dom.isIE(9) ? '9' : '10';
        dom(this.quill.root).addClass('ql-ie-' + version);
      }
    }
  
    BaseTheme.prototype.addStyles = function(css) {
      var style;
      if (_.isObject(css)) {
        css = BaseTheme.objToCss(css);
      }
      style = document.createElement('style');
      style.type = 'text/css';
      style.appendChild(document.createTextNode(css));
      return document.head.appendChild(style);
    };
  
    return BaseTheme;
  
  })();
  
  module.exports = BaseTheme;
  
  
  },{"../../lib/dom":17,"./base.styl":31,"lodash":1}],33:[function(_dereq_,module,exports){
  var BaseTheme, ColorPicker, Picker, SnowTheme, _, dom,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;
  
  _ = _dereq_('lodash');
  
  ColorPicker = _dereq_('../../lib/color-picker');
  
  BaseTheme = _dereq_('../base');
  
  dom = _dereq_('../../lib/dom');
  
  Picker = _dereq_('../../lib/picker');
  
  SnowTheme = (function(superClass) {
    extend(SnowTheme, superClass);
  
    SnowTheme.COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008A00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
  
    SnowTheme.OPTIONS = {
      'multi-cursor': {
        template: '<span class="cursor-flag"> <span class="cursor-triangle top"></span> <span class="cursor-name"></span> <span class="cursor-triangle bottom"></span> </span> <span class="cursor-caret"></span>'
      }
    };
  
    function SnowTheme(quill, options) {
      this.quill = quill;
      this.options = options;
      SnowTheme.__super__.constructor.apply(this, arguments);
      dom(this.quill.container).addClass('ql-snow');
      this.pickers = [];
      this.quill.on(this.quill.constructor.events.SELECTION_CHANGE, (function(_this) {
        return function(range) {
          if (range != null) {
            return _.invoke(_this.pickers, 'close');
          }
        };
      })(this));
      this.quill.onModuleLoad('multi-cursor', _.bind(this.extendMultiCursor, this));
      this.quill.onModuleLoad('toolbar', _.bind(this.extendToolbar, this));
    }
  
    SnowTheme.prototype.extendMultiCursor = function(module) {
      return module.on(module.constructor.events.CURSOR_ADDED, function(cursor) {
        var bottomTriangle, topTriangle;
        bottomTriangle = cursor.elem.querySelector('.cursor-triangle.bottom');
        topTriangle = cursor.elem.querySelector('.cursor-triangle.top');
        return bottomTriangle.style.borderTopColor = topTriangle.style.borderBottomColor = cursor.color;
      });
    };
  
    SnowTheme.prototype.extendToolbar = function(module) {
      dom(module.container).addClass('ql-snow');
      _.each(['color', 'background', 'font', 'size', 'align'], (function(_this) {
        return function(format) {
          var picker, select;
          select = module.container.querySelector(".ql-" + format);
          if (select == null) {
            return;
          }
          switch (format) {
            case 'font':
            case 'size':
            case 'align':
              picker = new Picker(select);
              break;
            case 'color':
            case 'background':
              picker = new ColorPicker(select);
              _.each(picker.container.querySelectorAll('.ql-picker-item'), function(item, i) {
                if (i < 7) {
                  return dom(item).addClass('ql-primary-color');
                }
              });
          }
          if (picker != null) {
            return _this.pickers.push(picker);
          }
        };
      })(this));
      return _.each(dom(module.container).textNodes(), function(node) {
        if (dom(node).text().trim().length === 0) {
          return dom(node).remove();
        }
      });
    };
  
    return SnowTheme;
  
  })(BaseTheme);
  
  module.exports = SnowTheme;
  
  
  },{"../../lib/color-picker":16,"../../lib/dom":17,"../../lib/picker":19,"../base":32,"lodash":1}]},{},[15])(15)
  });

//Get Data Service

(function ()
{
    'use strict';

    angular
        .module('app')
        .provider('postServer', postDataProvider);
    
    function processPostServerURL(url,cprotocol)
    {
      var newUrl = cprotocol + url;
      return newUrl;
    }

    /** @ngInject */
    function postDataProvider()
    {
       return {

       	$get: function($http,$q,toastShow,$rootScope,$timeout,$location,$window){

       		return {

            postData: function(postUrl,postData){

              if(navigator.onLine || $rootScope.projectInfo.runningMode === 'development')
              {

                $rootScope.loadingProgress = true;
                var data = {};
                var url = processPostServerURL($rootScope.projectInfo.apiServer,window.location.protocol);
                var defer = $q.defer();

                var promise = $http({
                    method  : 'POST',
                    url     : url+postUrl.toLowerCase(),
                    withCredentials: true,
                    async: true,
                    data    : $.param(postData),  // pass in data as strings
                    headers : $rootScope.postHeaders
                })
                .then(function(response) {

                    var d = response.data;
                    var status = response.status;
                    var statusText = response.statusText;
                    var h = response.headers;
                    var config = response.config;

                    if(d.app_updating === true || d.app_updating === 'true')
                    {
                      $rootScope.initUpdate();
                    }
                    else
                    {
                      $rootScope.closeUpdate();
                    }

                    $rootScope.changeRunningMode(d.mode);

                    $rootScope.tempData.apiFailPost = 0;
                    //For Login Purpose
                    if(d.isLogin !== undefined && d.rc_session !== undefined && d.rc_session !== "")
                    {
                      $rootScope.updateSession(d.isLogin,d.rc_session);
                    }
                    //For Login Purpose
                    //For Toast Show Purpose
                    if(d.msg)
                      {
                        if(d.msg.type !== '' && (d.msg.message !== "" || d.msg.translate !== ''))
                        {                    
                        toastShow.show(d.msg.type,d.msg.message,d.msg.translate);
                      }
                    }
                    //For Toast Show Purpose
                    defer.resolve(d);
                    $rootScope.reqErrorFound(response,'post');
                },
                function(data){
                    $rootScope.tempData.apiFailPost += 1;
                    defer.resolve(data);
                    $rootScope.reqErrorFound(data,'post');
                    // toastShow.show('warning','','post_data_server_error');
                    return data;
                });
                $timeout(function() { $rootScope.loadingProgress = false; }, 1000);
                return defer.promise;  

              }  
              else
              {
                toastShow.show('info','', 'network_problem_reload');
                $timeout(function() { $rootScope.loadingProgress = false; }, 1000);

                $rootScope.updateSession(false,false);
                  
                var defer = $q.defer();
                defer.resolve(false);
                return defer.promise;
              }

            }

       		}

       	}

       }
    }

})();
'use strict';

/**
 * 0.0.1
 * local storage
 * 
 * @ flatfull.com All Rights Reserved.
 * Author url: http://themeforest.net/user/flatfull
 */

angular.module('ngStore', []).
provider('ngStore', [function(){
  return {
    $get: ['NSModelFactory', function($NSMF) {
      return {
        model: function(name) {
          var model = new $NSMF(name);
          return model;
        }
      };
    }]
  };
}])
.factory('NSModelFactory', ['$log', function($log){

  function Store(name, serializer) {
    if( !this.localStorage ) {
      throw "localStorage: Environment does not support localStorage."
    }
    this.name = name;
    this.serializer = serializer || {
      serialize: function(item) {
        return isObject(item) ? JSON.stringify(item) : item;
      },
      // fix for "illegal access" error on Android when JSON.parse is passed null
      deserialize: function (data) {
        return data && JSON.parse(data);
      }
    };
    var store = this.localStorage().getItem(this.name);
    this.records = (store && store.split(",")) || [];
  };

  Store.prototype = {

    // Save the current state of the **Store** to *localStorage*.
    save: function() {
      this.localStorage().setItem(this.name, this.records.join(","));
    },

    // Add a model, giving it a (hopefully)-unique GUID, if it doesn't already
    // have an id of it's own.
    create: function(model) {
      if (!model.id && model.id !== 0) {
        model.id = guid();
        model.set(model.idAttribute, model.id);
      }
      this.localStorage().setItem(this._itemName(model.id), this.serializer.serialize(model));
      this.records.push(model.id.toString());
      this.save();
      return this.find(model);
    },

    // Update a model by replacing its copy in `this.data`.
    update: function(model) {
      this.localStorage().setItem(this._itemName(model.id), this.serializer.serialize(model));
      var modelId = model.id.toString();
      if (!contains(this.records, modelId)) {
        this.records.push(modelId);
        this.save();
      }
      return this.find(model);
    },

    // Retrieve a model from `this.data` by id.
    find: function(model) {
      return this.serializer.deserialize(this.localStorage().getItem(this._itemName(model.id)));
    },

    // Return the array of all models currently in storage.
    findAll: function() {
      var result = [];
      for (var i = 0, id, data; i < this.records.length; i++) {
        id = this.records[i];
        data = this.serializer.deserialize(this.localStorage().getItem(this._itemName(id)));
        if (data != null) result.push(data);
      }
      return result;
    },

    // Delete a model from `this.data`, returning it.
    destroy: function(model) {
      this.localStorage().removeItem(this._itemName(model.id));
      var modelId = model.id.toString();
      for (var i = 0, id; i < this.records.length; i++) {
        if (this.records[i] === modelId) {
          this.records.splice(i, 1);
        }
      }
      this.save();
      return model;
    },

    nextId: function(){
      return this.records.length == 0 ? 1 : Number(this.records[this.records.length - 1]) + 1;
    },

    localStorage: function() {
      return localStorage;
    },

    // Clear localStorage for specific collection.
    _clear: function() {
      var local = this.localStorage(),
        itemRe = new RegExp("^" + this.name + "-");

      // Remove id-tracking item (e.g., "foo").
      local.removeItem(this.name);

      // Match all data items (e.g., "foo-ID") and remove.
      for (var k in local) {
        if (itemRe.test(k)) {
          local.removeItem(k);
        }
      }

      this.records.length = 0;
    },

    // Size of localStorage.
    _storageSize: function() {
      return this.localStorage().length;
    },

    _itemName: function(id) {
      return this.name+"-"+id;
    }

  };

  return Store;

  // Generate four random hex digits.
  function S4() {
     return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };

  // Generate a pseudo-GUID by concatenating random hexadecimal.
  function guid() {
     return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
  };

  function isObject(item) {
    return item === Object(item);
  }

  function contains(array, item) {
    var i = array.length;
    while (i--) if (array[i] === item) return true;
    return false;
  }
}]);

/*global Quill*/
(function () {
    'use strict';
    var app;
    // declare ngQuill module
    app = angular.module('ngQuill', []);

    app.provider('ngQuillConfig', function () {
        var config = {
            // default fontFamilies
            fontSizes: [{
                size: '10px',
                alias: 'small'
            }, {
                size: '13px',
                alias: 'normal'
            }, {
                size: '18px',
                alias: 'large'
            }, {
                size: '32px',
                alias: 'huge'
            }],
            // default fontFamilies
            fontFamilies: [{
                label: 'Sans Serif',
                alias: 'sans-serif'
            }, {
                label: 'Serif',
                alias: 'serif'
            }, {
                label: 'Monospace',
                alias: 'monospace'
            }],
            // formats list
            formats: [
                'link',
                'image',
                'bold',
                'italic',
                'underline',
                'strike',
                'color',
                'background',
                'align',
                'font',
                'size',
                'bullet',
                'list'
            ],
            // default translations
            translations: {
                font: 'Font',
                size: 'Size',
                small: 'Small',
                normal: 'Normal',
                large: 'Large',
                huge: 'Huge',
                bold: 'Bold',
                italic: 'Italic',
                underline: 'Underline',
                strike: 'Strikethrough',
                textColor: 'Text Color',
                backgroundColor: 'Background Color',
                list: 'List',
                bullet: 'Bullet',
                textAlign: 'Text Align',
                left: 'Left',
                center: 'Center',
                right: 'Right',
                justify: 'Justify',
                link: 'Link',
                image: 'Image',
                visitURL: 'Visit URL',
                change: 'Change',
                done: 'Done',
                cancel: 'Cancel',
                remove: 'Remove',
                insert: 'Insert',
                preview: 'Preview'
            }
        };

        this.set = function (fontSizes, fontFamilies) {
            if (fontSizes) {
                config.fontSizes = fontSizes;
            }
            if (fontFamilies) {
                config.fontFamilies = fontFamilies;
            }
        };

        this.$get = function () {
            return config;
        };
    });

    app.service('ngQuillService', ['ngQuillConfig', function (ngQuillConfig) {
        // validate formats
        this.validateFormats = function (checkFormats) {
            var correctFormats = [],
                i = 0;

            for (i; i < checkFormats.length; i = i + 1) {
                if (ngQuillConfig.formats.indexOf(checkFormats[i]) !== -1) {
                    correctFormats.push(checkFormats[i]);
                }
            }

            return correctFormats;
        };
    }]);

    app.directive('ngQuillEditor', [
        '$timeout',
        'ngQuillService',
        'ngQuillConfig',
        function ($timeout, ngQuillService, ngQuillConfig) {
            return {
                scope: {
                    'toolbarEntries': '@?',
                    'toolbar': '@?',
                    'showToolbar': '=?',
                    'fontfamilyOptions': '=?',
                    'fontsizeOptions': '=?',
                    'linkTooltip': '@?',
                    'imageTooltip': '@?',
                    'theme': '@?',
                    'save': '@?',
                    'translations': '=?',
                    'required': '@?editorRequired',
                    'readOnly': '&?',
                    'errorClass': '@?',
                    'ngModel': '=',
                    'callback': '&?',
                    'name': '@?',
                    'editorStyles': '=?'
                },
                require: 'ngModel',
                restrict: 'E',
                templateUrl: 'ngQuill/template.html',
                link: function ($scope, element, attr, ngModel) {
                    var config = {
                            theme: $scope.theme || 'snow',
                            save: $scope.save || 'html',
                            readOnly: $scope.readOnly || false,
                            formats: $scope.toolbarEntries ? ngQuillService.validateFormats($scope.toolbarEntries.split(' ')) : ngQuillConfig.formats,
                            modules: {},
                            styles: $scope.editorStyles || false
                        },
                        changed = false,
                        editor,
                        setClass = function () {
                            // if editor content length <= 1 and content is required -> add custom error clas and ng-invalid
                            if ($scope.required && (!$scope.modelLength || $scope.modelLength <= 1)) {
                                element.addClass('ng-invalid');
                                element.removeClass('ng-valid');
                                // if form was reseted and input field set to empty
                                if ($scope.errorClass && changed && element.hasClass('ng-dirty')) {
                                    element.children().addClass($scope.errorClass);
                                }
                            } else { // set to valid
                                element.removeClass('ng-invalid');
                                element.addClass('ng-valid');
                                if ($scope.errorClass) {
                                    element.children().removeClass($scope.errorClass);
                                }
                            }
                        };

                    // set required flag (if text editor is required)
                    if ($scope.required && $scope.required === 'true') {
                        $scope.required = true;
                    } else {
                        $scope.required = false;
                    }

                    // overwrite global settings dynamically
                    $scope.fontsizeOptions = $scope.fontsizeOptions || ngQuillConfig.fontSizes;
                    $scope.fontfamilyOptions = $scope.fontfamilyOptions || ngQuillConfig.fontFamilies;

                    // default translations
                    $scope.dict = ngQuillConfig.translations;

                    $scope.shouldShow = function (formats) {
                        var okay = false,
                            i = 0;
                        for (i; i < formats.length; i = i + 1) {
                            if (config.formats.indexOf(formats[i]) !== -1) {
                                okay = true;
                                break;
                            }
                        }

                        return okay;
                    };

                    // if there are custom translations
                    if ($scope.translations) {
                        $scope.dict = $scope.translations;
                    }

                    // add tooltip modules
                    if ($scope.linkTooltip && $scope.linkTooltip === 'true') {
                        config.modules['link-tooltip'] = {
                            template: '<span class="title">' + $scope.dict.visitURL + ':&nbsp;</span>'
                                        + '<a href="#" class="url" target="_blank" href="about:blank"></a>'
                                        + '<input class="input" type="text">'
                                        + '<span>&nbsp;&#45;&nbsp;</span>'
                                        + '<a href="javascript:;" class="change">' + $scope.dict.change + '</a>'
                                        + '<a href="javascript:;" class="remove">' + $scope.dict.remove + '</a>'
                                        + '<a href="javascript:;" class="done">' + $scope.dict.done + '</a>'
                        };
                    }
                    if ($scope.imageTooltip && $scope.imageTooltip === 'true') {
                        config.modules['image-tooltip'] = {
                            template: '<input class="input" type="textbox">'
                                        + '<div class="preview">'
                                        + '    <span>' + $scope.dict.preview + '</span>'
                                        + '</div>'
                                        + '<a href="javascript:;" class="cancel">' + $scope.dict.cancel + '</a>'
                                        + '<a href="javascript:;" class="insert">' + $scope.dict.insert + '</a>'
                        };
                    }

                    // init editor
                    editor = new Quill(element[0].querySelector('.advanced-wrapper .editor-container'), config);

                    // mark model as touched if editor lost focus
                    editor.on('selection-change', function (range) {
                        if (range) {
                            return;
                        }
                        $timeout(function () {
                            ngModel.$setTouched();
                        });
                    });

                    // add toolbar afterwards with a timeout to be sure that translations has replaced.
                    if ($scope.toolbar && $scope.toolbar === 'true') {
                        $timeout(function () {
                            editor.addModule('toolbar', {
                                container: element[0].querySelector('.advanced-wrapper .toolbar-container')
                            });
                            $scope.toolbarCreated = true;
                            $scope.showToolbar = $scope.hasOwnProperty('showToolbar') ? $scope.showToolbar : true;
                        }, 0);
                    }

                    // provide event to get recognized when editor is created -> pass editor object.
                    $timeout(function(){
                        $scope.$emit('editorCreated', editor, $scope.name);

                        if ($scope.callback) {
                            $scope.callback({
                               editor: editor,
                               name: $scope.name
                            });
                        }

                        // clear history of undo manager to avoid removing inital model value via ctrl + z
                        editor.getModule('undo-manager').clear();
                    });

                    var updateFromPlugin = false;
                    var updateInPlugin = false;

                    // set initial value
                    $scope.$watch(function () {
                        return $scope.ngModel;
                    }, function (newText) {
                        if (updateFromPlugin) {
                            return;
                        }

                        if (newText) {
                            updateInPlugin = true;
                            if (config.save === 'text') {
                                editor.setText(newText);
                            } else if (config.save === 'contents') {
                                editor.setContents(newText);
                            } else {
                                editor.setHTML(newText);
                            }
                        }
                    });

                    // toggle readOnly
                    if ($scope.readOnly) {
                        $scope.$watch(function () {
                            return $scope.readOnly();
                        }, function (readOnly) {
                            editor.editor[readOnly ? 'disable' : 'enable']();
                        });
                    }

                    $scope.regEx = /^([2-9]|[1-9][0-9]+)$/;

                    // Update model on textchange
                    editor.on('text-change', function () {
                        var oldChange = changed;
                        changed = true;
                        updateFromPlugin = true;
                        if (!updateInPlugin) {
                            $scope.$apply(function () {
                                // Calculate content length
                                $scope.modelLength = editor.getLength();
                                // Check if error class should be set
                                if (oldChange) {
                                    setClass();
                                }
                                var setValue;
                                if (config.save === 'text') {
                                    setValue = editor.getText();
                                } else if (config.save === 'contents') {
                                    setValue = editor.getContents();
                                } else {
                                    setValue = editor.getHTML();
                                }
                                // Set new model value
                                if(editor.getLength() <= 1) {
                                    ngModel.$setViewValue('');
                                } else {
                                    ngModel.$setViewValue(setValue);
                                }
                            });
                        }
                        updateInPlugin = false;
                        updateFromPlugin = false;
                    });

                    // Clean-up
                    element.on('$destroy', function () {
                        editor.destroy();
                    });
                }
            };
        }
    ]);

    app.run([
        '$templateCache',
        '$rootScope',
        '$window',
        function ($templateCache) {
            // put template in template cache
            return $templateCache.put('ngQuill/template.html',
                '<div id="content-container">' +
                    '<div class="advanced-wrapper">' +
                        '<div class="toolbar toolbar-container" ng-if="toolbar" ng-show="toolbarCreated && showToolbar">' +
                            '<span class="ql-format-group" ng-if="shouldShow([\'font\', \'size\'])">' +
                                '<select title="{{dict.font}}" class="ql-font" ng-if="shouldShow([\'font\'])">' +
                                    '<option ng-repeat="option in fontfamilyOptions" value="{{option.alias}}">{{option.label}}</option>' +
                                '</select>' +
                                '<select title="{{dict.size}}" class="ql-size" ng-if="shouldShow([\'size\'])">' +
                                    '<option ng-repeat="option in fontsizeOptions" ng-selected="$index === 1" value="{{option.size}}">{{dict[option.alias] || option.alias}}</option>' +
                                '</select>' +
                            '</span>' +
                            '<span class="ql-format-group" ng-if="shouldShow([\'bold\', \'italic\', \'underline\', \'strike\'])">' +
                                '<span title="{{dict.bold}}" class="ql-format-button ql-bold" ng-if="shouldShow([\'bold\'])"></span>' +
                                '<span title="{{dict.italic}}" class="ql-format-button ql-italic" ng-if="shouldShow([\'italic\'])"></span>' +
                                '<span title="{{dict.underline}}" class="ql-format-button ql-underline" ng-if="shouldShow([\'underline\'])"></span>' +
                                '<span title="{{dict.strike}}" class="ql-format-button ql-strike" ng-if="shouldShow([\'strike\'])"></span>' +
                            '</span>' +
                            '<span class="ql-format-group" ng-if="shouldShow([\'color\', \'background\'])">' +
                                '<select title="{{dict.textColor}}" class="ql-color" ng-if="shouldShow([\'color\'])">' +
                                    '<option value="rgb(0, 0, 0)" label="rgb(0, 0, 0)" selected=""></option>' +
                                    '<option value="rgb(230, 0, 0)" label="rgb(230, 0, 0)"></option>' +
                                    '<option value="rgb(255, 153, 0)" label="rgb(255, 153, 0)"></option>' +
                                    '<option value="rgb(255, 255, 0)" label="rgb(255, 255, 0)"></option>' +
                                    '<option value="rgb(0, 138, 0)" label="rgb(0, 138, 0)"></option>' +
                                    '<option value="rgb(0, 102, 204)" label="rgb(0, 102, 204)"></option>' +
                                    '<option value="rgb(153, 51, 255)" label="rgb(153, 51, 255)"></option>' +
                                    '<option value="rgb(255, 255, 255)" label="rgb(255, 255, 255)"></option>' +
                                    '<option value="rgb(250, 204, 204)" label="rgb(250, 204, 204)"></option>' +
                                    '<option value="rgb(255, 235, 204)" label="rgb(255, 235, 204)"></option>' +
                                    '<option value="rgb(255, 255, 204)" label="rgb(255, 255, 204)"></option>' +
                                    '<option value="rgb(204, 232, 204)" label="rgb(204, 232, 204)"></option>' +
                                    '<option value="rgb(204, 224, 245)" label="rgb(204, 224, 245)"></option>' +
                                    '<option value="rgb(235, 214, 255)" label="rgb(235, 214, 255)"></option>' +
                                    '<option value="rgb(187, 187, 187)" label="rgb(187, 187, 187)"></option>' +
                                    '<option value="rgb(240, 102, 102)" label="rgb(240, 102, 102)"></option>' +
                                    '<option value="rgb(255, 194, 102)" label="rgb(255, 194, 102)"></option>' +
                                    '<option value="rgb(255, 255, 102)" label="rgb(255, 255, 102)"></option>' +
                                    '<option value="rgb(102, 185, 102)" label="rgb(102, 185, 102)"></option>' +
                                    '<option value="rgb(102, 163, 224)" label="rgb(102, 163, 224)"></option>' +
                                    '<option value="rgb(194, 133, 255)" label="rgb(194, 133, 255)"></option>' +
                                    '<option value="rgb(136, 136, 136)" label="rgb(136, 136, 136)"></option>' +
                                    '<option value="rgb(161, 0, 0)" label="rgb(161, 0, 0)"></option>' +
                                    '<option value="rgb(178, 107, 0)" label="rgb(178, 107, 0)"></option>' +
                                    '<option value="rgb(178, 178, 0)" label="rgb(178, 178, 0)"></option>' +
                                    '<option value="rgb(0, 97, 0)" label="rgb(0, 97, 0)"></option>' +
                                    '<option value="rgb(0, 71, 178)" label="rgb(0, 71, 178)"></option>' +
                                    '<option value="rgb(107, 36, 178)" label="rgb(107, 36, 178)"></option>' +
                                    '<option value="rgb(68, 68, 68)" label="rgb(68, 68, 68)"></option>' +
                                    '<option value="rgb(92, 0, 0)" label="rgb(92, 0, 0)"></option>' +
                                    '<option value="rgb(102, 61, 0)" label="rgb(102, 61, 0)"></option>' +
                                    '<option value="rgb(102, 102, 0)" label="rgb(102, 102, 0)"></option>' +
                                    '<option value="rgb(0, 55, 0)" label="rgb(0, 55, 0)"></option>' +
                                    '<option value="rgb(0, 41, 102)" label="rgb(0, 41, 102)"></option>' +
                                    '<option value="rgb(61, 20, 102)" label="rgb(61, 20, 102)"></option>' +
                                '</select>' +
                                '<select title="{{dict.backgroundColor}}" class="ql-background" ng-if="shouldShow([\'background\'])">' +
                                    '<option value="rgb(0, 0, 0)" label="rgb(0, 0, 0)"></option>' +
                                    '<option value="rgb(230, 0, 0)" label="rgb(230, 0, 0)"></option>' +
                                    '<option value="rgb(255, 153, 0)" label="rgb(255, 153, 0)"></option>' +
                                    '<option value="rgb(255, 255, 0)" label="rgb(255, 255, 0)"></option>' +
                                    '<option value="rgb(0, 138, 0)" label="rgb(0, 138, 0)"></option>' +
                                    '<option value="rgb(0, 102, 204)" label="rgb(0, 102, 204)"></option>' +
                                    '<option value="rgb(153, 51, 255)" label="rgb(153, 51, 255)"></option>' +
                                    '<option value="rgb(255, 255, 255)" label="rgb(255, 255, 255)" selected=""></option>' +
                                    '<option value="rgb(250, 204, 204)" label="rgb(250, 204, 204)"></option>' +
                                    '<option value="rgb(255, 235, 204)" label="rgb(255, 235, 204)"></option>' +
                                    '<option value="rgb(255, 255, 204)" label="rgb(255, 255, 204)"></option>' +
                                    '<option value="rgb(204, 232, 204)" label="rgb(204, 232, 204)"></option>' +
                                    '<option value="rgb(204, 224, 245)" label="rgb(204, 224, 245)"></option>' +
                                    '<option value="rgb(235, 214, 255)" label="rgb(235, 214, 255)"></option>' +
                                    '<option value="rgb(187, 187, 187)" label="rgb(187, 187, 187)"></option>' +
                                    '<option value="rgb(240, 102, 102)" label="rgb(240, 102, 102)"></option>' +
                                    '<option value="rgb(255, 194, 102)" label="rgb(255, 194, 102)"></option>' +
                                    '<option value="rgb(255, 255, 102)" label="rgb(255, 255, 102)"></option>' +
                                    '<option value="rgb(102, 185, 102)" label="rgb(102, 185, 102)"></option>' +
                                    '<option value="rgb(102, 163, 224)" label="rgb(102, 163, 224)"></option>' +
                                    '<option value="rgb(194, 133, 255)" label="rgb(194, 133, 255)"></option>' +
                                    '<option value="rgb(136, 136, 136)" label="rgb(136, 136, 136)"></option>' +
                                    '<option value="rgb(161, 0, 0)" label="rgb(161, 0, 0)"></option>' +
                                    '<option value="rgb(178, 107, 0)" label="rgb(178, 107, 0)"></option>' +
                                    '<option value="rgb(178, 178, 0)" label="rgb(178, 178, 0)"></option>' +
                                    '<option value="rgb(0, 97, 0)" label="rgb(0, 97, 0)"></option>' +
                                    '<option value="rgb(0, 71, 178)" label="rgb(0, 71, 178)"></option>' +
                                    '<option value="rgb(107, 36, 178)" label="rgb(107, 36, 178)"></option>' +
                                    '<option value="rgb(68, 68, 68)" label="rgb(68, 68, 68)"></option>' +
                                    '<option value="rgb(92, 0, 0)" label="rgb(92, 0, 0)"></option>' +
                                    '<option value="rgb(102, 61, 0)" label="rgb(102, 61, 0)"></option>' +
                                    '<option value="rgb(102, 102, 0)" label="rgb(102, 102, 0)"></option>' +
                                    '<option value="rgb(0, 55, 0)" label="rgb(0, 55, 0)"></option>' +
                                    '<option value="rgb(0, 41, 102)" label="rgb(0, 41, 102)"></option>' +
                                    '<option value="rgb(61, 20, 102)" label="rgb(61, 20, 102)"></option>' +
                                '</select>' +
                            '</span>' +
                            '<span class="ql-format-group" ng-if="shouldShow([\'list\', \'bullet\'])">' +
                                '<span title="{{dict.list}}" class="ql-format-button ql-list" ng-if="shouldShow([\'list\'])"></span>' +
                                '<span title="{{dict.bullet}}" class="ql-format-button ql-bullet" ng-if="shouldShow([\'bullet\'])"></span>' +
                            '</span>' +
                            '<span class="ql-format-group" ng-if="shouldShow([\'align\'])">' +
                                '<select title="{{dict.textAlign}}" class="ql-align">' +
                                    '<option value="left" label="{{dict.left}}" selected=""></option>' +
                                    '<option value="center" label="{{dict.center}}"></option>' +
                                    '<option value="right" label="{{dict.right}}"></option>' +
                                    '<option value="justify" label="{{dict.justify}}"></option>' +
                                '</select>' +
                            '</span>' +
                            '<span class="ql-format-group" ng-if="shouldShow([\'link\', \'image\'])">' +
                                '<span title="{{dict.link}}" class="ql-format-button ql-link" ng-if="shouldShow([\'link\'])"></span>' +
                                '<span title="{{dict.image}}" class="ql-format-button ql-image" ng-if="shouldShow([\'image\'])"></span>' +
                            '</span>' +
                        '</div>' +
                        '<div class="editor-container"></div>' +
                        '<input type="text" ng-model="modelLength" ng-if="required" ng-hide="true" ng-pattern="/^([2-9]|[1-9][0-9]+)$/">' +
                    '</div>' +
                '</div>');
        }
    ]);
}).call(this);
/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
angular.module('ui.tinymce', [])
  .value('uiTinymceConfig', {})
  .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', 'uiTinymceService', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig, uiTinymceService) {
    uiTinymceConfig = uiTinymceConfig || {};

    if (uiTinymceConfig.baseUrl) {
      tinymce.baseURL = uiTinymceConfig.baseUrl;
    }

    return {
      require: ['ngModel', '^?form'],
      priority: 599,
      link: function(scope, element, attrs, ctrls) {
        if (!$window.tinymce) {
          return;
        }

        var ngModel = ctrls[0],
          form = ctrls[1] || null;

        var expression, options = {
          debounce: true
        }, tinyInstance,
          updateView = function(editor) {
            var content = editor.getContent({format: options.format}).trim();
            content = $sce.trustAsHtml(content);

            ngModel.$setViewValue(content);
            if (!$rootScope.$$phase) {
              scope.$digest();
            }
          };

        function toggleDisable(disabled) {
          if (disabled) {
            ensureInstance();

            if (tinyInstance) {
              tinyInstance.getBody().setAttribute('contenteditable', false);
            }
          } else {
            ensureInstance();

            if (tinyInstance && !tinyInstance.settings.readonly && tinyInstance.getDoc()) {
              tinyInstance.getBody().setAttribute('contenteditable', true);
            }
          }
        }

        // fetch a unique ID from the service
        var uniqueId = uiTinymceService.getUniqueId();
        attrs.$set('id', uniqueId);

        expression = {};

        angular.extend(expression, scope.$eval(attrs.uiTinymce));

        //Debounce update and save action
        var debouncedUpdate = (function(debouncedUpdateDelay) {
          var debouncedUpdateTimer;
          return function(ed) {
	        $timeout.cancel(debouncedUpdateTimer);
	         debouncedUpdateTimer = $timeout(function() {
              return (function(ed) {
                if (ed.isDirty()) {
                  ed.save();
                  updateView(ed);
                }
              })(ed);
            }, debouncedUpdateDelay);
          };
        })(400);

        var setupOptions = {
          // Update model when calling setContent
          // (such as from the source editor popup)
          setup: function(ed) {
            ed.on('init', function() {
              ngModel.$render();
              ngModel.$setPristine();
                ngModel.$setUntouched();
              if (form) {
                form.$setPristine();
              }
            });

            // Update model when:
            // - a button has been clicked [ExecCommand]
            // - the editor content has been modified [change]
            // - the node has changed [NodeChange]
            // - an object has been resized (table, image) [ObjectResized]
            ed.on('ExecCommand change NodeChange ObjectResized', function() {
              if (!options.debounce) {
                ed.save();
                updateView(ed);
              	return;
              }
              debouncedUpdate(ed);
            });

            ed.on('blur', function() {
              element[0].blur();
              ngModel.$setTouched();
              if (!$rootScope.$$phase) {
                scope.$digest();
              }
            });

            ed.on('remove', function() {
              element.remove();
            });

            if (uiTinymceConfig.setup) {
              uiTinymceConfig.setup(ed, {
                updateView: updateView
              });
            }

            if (expression.setup) {
              expression.setup(ed, {
                updateView: updateView
              });
            }
          },
          format: expression.format || 'html',
          selector: '#' + attrs.id
        };
        // extend options with initial uiTinymceConfig and
        // options from directive attribute value
        angular.extend(options, uiTinymceConfig, expression, setupOptions);
        // Wrapped in $timeout due to $tinymce:refresh implementation, requires
        // element to be present in DOM before instantiating editor when
        // re-rendering directive
        $timeout(function() {
          if (options.baseURL){
            tinymce.baseURL = options.baseURL;
          }
          var maybeInitPromise = tinymce.init(options);
          if(maybeInitPromise && typeof maybeInitPromise.then === 'function') {
            maybeInitPromise.then(function() {
              toggleDisable(scope.$eval(attrs.ngDisabled));
            });
          } else {
            toggleDisable(scope.$eval(attrs.ngDisabled));
          }
        });

        ngModel.$formatters.unshift(function(modelValue) {
          return modelValue ? $sce.trustAsHtml(modelValue) : '';
        });

        ngModel.$parsers.unshift(function(viewValue) {
          return viewValue ? $sce.getTrustedHtml(viewValue) : '';
        });

        ngModel.$render = function() {
          ensureInstance();

          var viewValue = ngModel.$viewValue ?
            $sce.getTrustedHtml(ngModel.$viewValue) : '';

          // instance.getDoc() check is a guard against null value
          // when destruction & recreation of instances happen
          if (tinyInstance &&
            tinyInstance.getDoc()
          ) {
            tinyInstance.setContent(viewValue);
            // Triggering change event due to TinyMCE not firing event &
            // becoming out of sync for change callbacks
            tinyInstance.fire('change');
          }
        };

        attrs.$observe('disabled', toggleDisable);

        // This block is because of TinyMCE not playing well with removal and
        // recreation of instances, requiring instances to have different
        // selectors in order to render new instances properly
        var unbindEventListener = scope.$on('$tinymce:refresh', function(e, id) {
          var eid = attrs.id;
          if (angular.isUndefined(id) || id === eid) {
            var parentElement = element.parent();
            var clonedElement = element.clone();
            clonedElement.removeAttr('id');
            clonedElement.removeAttr('style');
            clonedElement.removeAttr('aria-hidden');
            tinymce.execCommand('mceRemoveEditor', false, eid);
            parentElement.append($compile(clonedElement)(scope));
            unbindEventListener();
          }
        });

        scope.$on('$destroy', function() {
          ensureInstance();

          if (tinyInstance) {
            tinyInstance.remove();
            tinyInstance = null;
          }
        });

        function ensureInstance() {
          if (!tinyInstance) {
            tinyInstance = tinymce.get(attrs.id);
          }
        }
      }
    };
  }])
  .service('uiTinymceService', [
    /**
     * A service is used to create unique ID's, this prevents duplicate ID's if there are multiple editors on screen.
     */
    function() {
      var UITinymceService = function() {
   	    var ID_ATTR = 'ui-tinymce';
    	// uniqueId keeps track of the latest assigned ID
    	var uniqueId = 0;
        // getUniqueId returns a unique ID
    	var getUniqueId = function() {
          uniqueId ++;
          return ID_ATTR + '-' + uniqueId;
        };
        // return the function as a public method of the service
        return {
        	getUniqueId: getUniqueId
        };
      };
      // return a new instance of the service
      return new UITinymceService();
    }
  ]);

//Get Data Service

(function ()
{
    'use strict';

    angular
        .module('app')
        .provider('getServer', getDataProvider);

    function processGetServerURL(url,cprotocol)
    {
      var newUrl = cprotocol + url;
      return newUrl;
    }
        

    /** @ngInject */
    function getDataProvider()
    {
       return {

       	$get: function($http,$q,toastShow, $rootScope, $timeout, $location, $window){

       		return {

       			getData: function(geturl){
              if(navigator.onLine || $rootScope.projectInfo.runningMode === 'development')
                {
                  
                  $rootScope.loadingProgress = true;
                  $rootScope.loadingProgress = true;
                  var data = {};
                  var url = processGetServerURL($rootScope.projectInfo.apiServer,window.location.protocol);
                  var defer = $q.defer();

                  var promise = $http({
                      method  : 'GET',
                      url     : url+geturl.toLowerCase(),
                      withCredentials: true,
                      async:true,
                      // headers: {"RamDesigners-APP-Code": $rootScope.projectInfo.projectCode, "RamDesigners-APP-Response-Type": 'json', "RamDesigners-APP-State": $rootScope.tempData.toState.name },
                  })
                  .then(function(response) {                    

                    var d = response.data;
                    var status = response.status;
                    var statusText = response.statusText;
                    var h = response.headers;
                    var config = response.config;
                    
                      if(d.app_updating === true || d.app_updating === 'true')
                      {
                        $rootScope.initUpdate();
                      }
                      else
                      {
                        $rootScope.closeUpdate();
                      }
                      
                      $rootScope.changeRunningMode(d.mode);

                      $rootScope.tempData.apiFailGet = 0;
                      //For Login Purpose
                      if(d.isLogin !== undefined && d.rc_session !== undefined && d.rc_session !== "")
                      {
                        $rootScope.updateSession(d.isLogin,d.rc_session);
                      }
                      //For Login Purpose
                      //For Toast Show Purpose
                      if(d.msg)
                      {
                        if(d.msg.type !== '' && (d.msg.message !== "" || d.msg.translate !== ''))
                        {                    
                          toastShow.show(d.msg.type,d.msg.message,d.msg.translate);
                        }
                      }
                      //For Toast Show Purpose
                      defer.resolve(d);
                      $rootScope.reqErrorFound(response,'get');
                  }, 
                  function(data){
                      $rootScope.tempData.apiFailGet += 1;
                      defer.resolve(data);
                      $rootScope.reqErrorFound(data,'get');
                      // toastShow.show('warning','','get_data_server_error');
                      return data;
                  });
                  $timeout(function() { $rootScope.loadingProgress = false; }, 1000);
                  return defer.promise;

                }  
                else
                {
                  toastShow.show('info','', 'network_problem_reload');
                  $timeout(function() { $rootScope.loadingProgress = false; }, 1000);

                  $rootScope.updateSession(false,false);

                  var defer = $q.defer();
                  defer.resolve(false);
                  return defer.promise;
                }
              
       			}

       		}

       	}

       }
    }

})();
(function (angular) {
    'use strict';

    var bindHtmlCompile = angular.module('angular-bind-html-compile', []);

    bindHtmlCompile.directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    // In case value is a TrustedValueHolderType, sometimes it
                    // needs to be explicitly called into a string in order to
                    // get the HTML string.
                    element.html(value && value.toString());
                    // If scope is provided use it, otherwise use parent scope
                    var compileScope = scope;
                    if (attrs.bindHtmlScope) {
                        compileScope = scope.$eval(attrs.bindHtmlScope);
                    }
                    $compile(element.contents())(compileScope);
                });
            }
        };
    }]);

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = bindHtmlCompile.name;
    }
}(window.angular));
$(document).ready(function() {

    $(document).on("mouseenter", ".bsTooltip", function() {
        $(this).data('placement','right');
        if($(this).is(':ui-tooltip')){
            $(this).tooltip('close');
        }
        $(this).tooltip('show');
    });

    $(document).on("mouseenter", ".bsTooltipRight", function() {
        $(this).data('placement','right');
        if($(this).is(':ui-tooltip')){
            $(this).tooltip('close');
        }
        $(this).tooltip('show');
    });

    $(document).on("mouseenter", ".bsTooltipLeft", function() {
        $(this).data('placement','left');
        if($(this).is(':ui-tooltip')){
            $(this).tooltip('show');
        }
        $(this).tooltip('close');
    });

    $(document).on("mouseenter", ".bsTooltipTop", function() {
        $(this).data('placement','top');
        if($(this).is(':ui-tooltip')){
            $(this).tooltip('show');
        }
        $(this).tooltip('close');
    });

    $(document).on("mouseenter", ".bsTooltipBottom", function() {
        $(this).data('placement','bottom');
        if($(this).is(':ui-tooltip')){
            $(this).tooltip('close');
        }
        $(this).tooltip('show');
    });

    $(document).on("mouseenter", ".bsTooltipAll", function() {
        if($(this).is(':ui-tooltip')){
            $(this).tooltip('close');
        }
        $(this).tooltip('show');
    });

});


// for touch events

!function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);
function lableTitle() {
    $('input').each(function() {
        var label = $("label[for='"+$(this).attr('id')+"']");
        var labelHtml = $("label[for='"+$(this).attr('id')+"']").html();
        var attr = $(this).attr('s2-options');
        if(attr !== undefined)
        {
            var c = $(this).prev();
            var choice = $(c).children();
            var choosen = $(choice).children('.select2-chosen');
            var v = $(choosen).html();
            if(v !== undefined)
            {
                $(label).attr('title',v);
                $(this).attr('title',v);
                $(c).attr('title',v);
            }
        }
        else
        {
            if(labelHtml !== undefined)
            {
                // console.log(labelHtml);
                if($(this).attr('type') !== 'password')
                {
                    $(label).attr('title',$(this).val());
                    $(this).attr('title',$(this).val());
                }
            }
        }
    });
}
function round(value, decimals) {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

function abs(v) {
    return Math.abs(v);
}
function removeMDTabindex() 
{
    $(".md-default-theme").each(function() {
        var mdd = $(this);
        mdd.removeAttr('tabindex');
    });
}

setInterval(removeMDTabindex,2000);
var Colors = {};
var ColorsArray = [];
Colors.names = {
    aqua: "#00ffff",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    black: "#000000",
    blue: "#0000ff",
    brown: "#a52a2a",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgrey: "#a9a9a9",
    darkgreen: "#006400",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkviolet: "#9400d3",
    fuchsia: "#ff00ff",
    gold: "#ffd700",
    green: "#008000",
    indigo: "#4b0082",
    khaki: "#f0e68c",
    lightblue: "#add8e6",
    lightcyan: "#e0ffff",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightyellow: "#ffffe0",
    lime: "#00ff00",
    magenta: "#ff00ff",
    maroon: "#800000",
    navy: "#000080",
    olive: "#808000",
    orange: "#ffa500",
    pink: "#ffc0cb",
    purple: "#800080",
    violet: "#800080",
    red: "#ff0000",
    silver: "#c0c0c0",
    white: "#ffffff",
    yellow: "#ffff00"
};

Colors.random = function() {
    var result;
    var count = 0;
    for (var prop in this.names)
        if (Math.random() < 1/++count)
           result = prop;
    return result;
};

ColorsArray.random = function(length) {
    if(length > 12)
    {        
        var data = [];
        for(var a=0; a<length; a++)
        {
          data[a] = Colors.random();
        }
        return data;
    }
    else
    {
        return paletteRandom(12);
    }
}





/** @license
 *
 *     Colour Palette Generator script.
 *     Copyright (c) 2014 Google Inc.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License"); you may
 *     not use this file except in compliance with the License.  You may
 *     obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 *     implied.  See the License for the specific language governing
 *     permissions and limitations under the License.
 *
 * Furthermore, ColorBrewer colour schemes are covered by the following:
 *
 *     Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and
 *                        The Pennsylvania State University.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License"); you may
 *     not use this file except in compliance with the License. You may obtain
 *     a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 *     implied. See the License for the specific language governing
 *     permissions and limitations under the License.
 *
 *     Redistribution and use in source and binary forms, with or without
 *     modification, are permitted provided that the following conditions are
 *     met:
 *
 *     1. Redistributions as source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *
 *     2. The end-user documentation included with the redistribution, if any,
 *     must include the following acknowledgment: "This product includes color
 *     specifications and designs developed by Cynthia Brewer
 *     (http://colorbrewer.org/)." Alternately, this acknowledgment may appear
 *     in the software itself, if and wherever such third-party
 *     acknowledgments normally appear.
 *
 *     4. The name "ColorBrewer" must not be used to endorse or promote products
 *     derived from this software without prior written permission. For written
 *     permission, please contact Cynthia Brewer at cbrewer@psu.edu.
 *
 *     5. Products derived from this software may not be called "ColorBrewer",
 *     nor may "ColorBrewer" appear in their name, without prior written
 *     permission of Cynthia Brewer.
 *
 * Furthermore, Solarized colour schemes are covered by the following:
 *
 *     Copyright (c) 2011 Ethan Schoonover
 *
 *     Permission is hereby granted, free of charge, to any person obtaining
 *     a copy of this software and associated documentation files (the
 *     "Software"), to deal in the Software without restriction, including
 *     without limitation the rights to use, copy, modify, merge, publish,
 *     distribute, sublicense, and/or sell copies of the Software, and to
 *     permit persons to whom the Software is furnished to do so, subject to
 *     the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included
 *     in all copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 *     OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *     MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 *     LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 *     OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 *     WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

'use strict';

var palette = (function() {

  var proto = Array.prototype;
  var slice = function(arr, opt_begin, opt_end) {
    return proto.slice.apply(arr, proto.slice.call(arguments, 1));
  };

  var extend = function(arr, arr2) {
    return proto.push.apply(arr, arr2);
  };

  var function_type = typeof function() {};

  var INF = 1000000000;  // As far as we're concerned, that's infinity. ;)


  /**
   * Generate a colour palette from given scheme.
   *
   * If scheme argument is not a function it is passed to palettes.listSchemes
   * function (along with the number argument).  This may result in an array
   * of more than one available scheme.  If that is the case, scheme at
   * opt_index position is taken.
   *
   * This allows using different palettes for different data without having to
   * name the schemes specifically, for example:
   *
   *     palette_for_foo = palette('sequential', 10, 0);
   *     palette_for_bar = palette('sequential', 10, 1);
   *     palette_for_baz = palette('sequential', 10, 2);
   *
   * @param {!palette.SchemeType|string|palette.Palette} scheme Scheme to
   *     generate palette for.  Either a function constructed with
   *     palette.Scheme object, or anything that palette.listSchemes accepts
   *     as name argument.
   * @param {number} number Number of colours to return.  If negative, absolute
   *     value is taken and colours will be returned in reverse order.
   * @param {number=} opt_index If scheme is a name of a group or an array and
   *     results in more than one scheme, index of the scheme to use.  The
   *     index wraps around.
   * @param {...*} varargs Additional arguments to pass to palette or colour
   *     generator (if the chosen scheme uses those).
   * @return {Array<string>} Array of abs(number) 'RRGGBB' strings or null if
   *     no matching scheme was found.
   */
  var palette = function(scheme, number, opt_index, varargs) {
    number |= 0;
    if (number == 0) {
      return [];
    }

    if (typeof scheme !== function_type) {
      var arr = palette.listSchemes(
          /** @type {string|palette.Palette} */ (scheme), number);
      if (!arr.length) {
        return null;
      }
      scheme = arr[(opt_index || 0) % arr.length];
    }

    var args = slice(arguments, 2);
    args[0] = number;
    return scheme.apply(scheme, args);
  };


  /**
   * Returns a callable colour scheme object.
   *
   * Just after being created, the scheme has no colour palettes and no way of
   * generating any, thus generate method will return null.  To turn scheme
   * into a useful object, addPalette, addPalettes or setColorFunction methods
   * need to be used.
   *
   * To generate a colour palette with given number colours using function
   * returned by this method, just call it with desired number of colours.
   *
   * Since this function *returns* a callable object, it must *not* be used
   * with the new operator.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>=} opt_groups A group name or list of
   *     groups the scheme should be categorised under.  Three typical groups
   *     to use are 'qualitative', 'sequential' and 'diverging', but any
   *     groups may be created.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */
  palette.Scheme = function(name, opt_groups) {
    /**
     * A map from a number to a colour palettes with given number of colours.
     * @type {!Object<number, palette.Palette>}
     */
    var palettes = {};

    /**
     * The biggest palette in palettes map.
     * @type {number}
     */
    var palettes_max = 0;

    /**
     * The smallest palette in palettes map.
     * @type {number}
     */
    var palettes_min = INF;

    var makeGenerator = function() {
      if (arguments.length <= 1) {
        return self.color_func.bind(self);
      } else {
        var args = slice(arguments);
        return function(x) {
          args[0] = x;
          return self.color_func.apply(self, args);
        };
      }
    };

    /**
     * Generate a colour palette from the scheme.
     *
     * If there was a palette added with addPalette (or addPalettes) with
     * enough colours, that palette will be used.  Otherwise, if colour
     * function has been set using setColorFunction method, that function will
     * be used to generate the palette.  Otherwise null is returned.
     *
     * @param {number} number Number of colours to return.  If negative,
     *     absolute value is taken and colours will be returned in reverse
     *     order.
     * @param {...*} varargs Additional arguments to pass to palette or colour
     *     generator (if the chosen scheme uses those).
     */
    var self = function(number, varargs) {
      number |= 0;
      if (!number) {
        return [];
      }

      var _number = number;
      number = Math.abs(number);

      if (number <= palettes_max) {
        for (var i = Math.max(number, palettes_min); !(i in palettes); ++i) {
          /* nop */
        }
        var colors = palettes[i];
        if (i > number) {
          var take_head =
              'shrinking_takes_head' in colors ?
              colors.shrinking_takes_head : self.shrinking_takes_head;
          if (take_head) {
            colors = colors.slice(0, number);
            i = number;
          } else {
            return palette.generate(
                function(x) { return colors[Math.round(x)]; },
                _number, 0, colors.length - 1);
          }
        }
        colors = colors.slice();
        if (_number < 0) {
          colors.reverse();
        }
        return colors;

      } else if (self.color_func) {
        return palette.generate(makeGenerator.apply(self, arguments),
                                _number, 0, 1, self.color_func_cyclic);

      } else {
        return null;
      }
    };

    /**
     * The name of the palette.
     * @type {string}
     */
    self.scheme_name = name;

    /**
     * A list of groups the palette belongs to.
     * @type {!Array<string>}
     */
    self.groups = opt_groups ?
      typeof opt_groups === 'string' ? [opt_groups] : opt_groups : [];

    /**
     * The biggest palette this scheme can generate.
     * @type {number}
     */
    self.max = 0;

    /**
     * The biggest palette this scheme can generate that is colour-blind
     * friendly.
     * @type {number}
     */
    self.cbf_max = INF;


    /**
     * Adds a colour palette to the colour scheme.
     *
     * @param {palette.Palette} palette An array of 'RRGGBB' strings
     *     representing the palette to add.
     * @param {boolean=} opt_is_cbf Whether the palette is colourblind friendly.
     */
    self.addPalette = function(palette, opt_is_cbf) {
      var len = palette.length;
      if (len) {
        palettes[len] = palette;
        palettes_min = Math.min(palettes_min, len);
        palettes_max = Math.max(palettes_max, len);
        self.max = Math.max(self.max, len);
        if (!opt_is_cbf && len != 1) {
          self.cbf_max = Math.min(self.cbf_max, len - 1);
        }
      }
    };

    /**
     * Adds number of colour palettes to the colour scheme.
     *
     * @param {palette.PalettesList} palettes A map or an array of colour
     *     palettes to add.  If map, i.e.  object, is used, properties should
     *     use integer property names.
     * @param {number=} opt_max Size of the biggest palette in palettes set.
     *     If not set, palettes must have a length property which will be used.
     * @param {number=} opt_cbf_max Size of the biggest palette which is still
     *     colourblind friendly.  1 by default.
     */
    self.addPalettes = function(palettes, opt_max, opt_cbf_max) {
      opt_max = opt_max || palettes.length;
      for (var i = 0; i < opt_max; ++i) {
        if (i in palettes) {
          self.addPalette(palettes[i], true);
        }
      }
      self.cbf_max = Math.min(self.cbf_max, opt_cbf_max || 1);
    };

    /**
     * Enable shrinking palettes taking head of the list of colours.
     *
     * When user requests n-colour palette but the smallest palette added with
     * addPalette (or addPalettes) is m-colour one (where n < m), n colours
     * across the palette will be returned.  For example:
     *     var ex = palette.Scheme('ex');
     *     ex.addPalette(['000000', 'bcbcbc', 'ffffff']);
     *     var pal = ex(2);
     *     // pal == ['000000', 'ffffff']
     *
     * This works for palettes where the distance between colours is
     * correlated to distance in the palette array, which is true in gradients
     * such as the one above.
     *
     * To turn this feature off shrinkByTakingHead can be set to true either
     * for all palettes in the scheme (if opt_idx is not given) or for palette
     * with given number of colours only.  In general, setting the option for
     * given palette overwrites whatever has been set for the scheme.  The
     * default, as described above, is false.
     *
     * Alternatively, the feature can be enabled by setting shrinking_takes_head
     * property for the palette Array or the scheme object.
     *
     * For example, all of the below give equivalent results:
     *     var pal = ['ff0000', '00ff00', '0000ff'];
     *
     *     var ex = palette.Scheme('ex');
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     ex.shrinkByTakingHead(true);      // ex(2) == ['ff0000', '00ff00']
     *
     *     ex = palette.Scheme('ex');
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     ex.shrinkByTakingHead(true, 3);   // ex(2) == ['ff0000', '00ff00']
     *
     *     ex = palette.Scheme('ex');
     *     ex.addPalette(pal);
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     pal.shrinking_takes_head = true;  // ex(2) == ['ff0000', '00ff00']
     *
     * @param {boolean} enabled Whether to enable or disable the “shrinking
     *     takes head” feature.  It is disabled by default.
     * @param {number=} opt_idx If given, the “shrinking takes head” option
     *     for palette with given number of colours is set.  If such palette
     *     does not exist, nothing happens.
     */
    self.shrinkByTakingHead = function(enabled, opt_idx) {
      if (opt_idx !== void(0)) {
        if (opt_idx in palettes) {
          palettes[opt_idx].shrinking_takes_head = !!enabled;
        }
      } else {
        self.shrinking_takes_head = !!enabled;
      }
    };

    /**
     * Sets a colour generation function of the colour scheme.
     *
     * The function must accept a singe number argument whose value can be from
     * 0.0 to 1.0, and return a colour as an 'RRGGBB' string.  This function
     * will be used when generating palettes, i.e. if 11-colour palette is
     * requested, this function will be called with arguments 0.0, 0.1, …, 1.0.
     *
     * If the palette generated by the function is colourblind friendly,
     * opt_is_cbf should be set to true.
     *
     * In some cases, it is not desirable to reach 1.0 when generating
     * a palette.  This happens for hue-rainbows where the 0–1 range corresponds
     * to a 0°–360° range in hues, and since hue at 0° is the same as at 360°,
     * it's desired to stop short the end of the range when generating
     * a palette.  To accomplish this, opt_cyclic should be set to true.
     *
     * @param {palette.ColorFunction} func A colour generator function.
     * @param {boolean=} opt_is_cbf Whether palette generate with the function
     *     is colour-blind friendly.
     * @param {boolean=} opt_cyclic Whether colour at 0.0 is the same as the
     *     one at 1.0.
     */
    self.setColorFunction = function(func, opt_is_cbf, opt_cyclic) {
      self.color_func = func;
      self.color_func_cyclic = !!opt_cyclic;
      self.max = INF;
      if (!opt_is_cbf && self.cbf_max === INF) {
        self.cbf_max = 1;
      }
    };

    self.color = function(x, varargs) {
      if (self.color_func) {
        return self.color_func.apply(this, arguments);
      } else {
        return null;
      }
    };

    return self;
  };


  /**
   * Creates a new palette.Scheme and initialises it by calling addPalettes
   * method with the rest of the arguments.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>} groups A group name or list of group
   *     names the scheme belongs to.
   * @param {!Object<number, palette.Palette>|!Array<palette.Palette>}
   *     palettes A map or an array of colour palettes to add.  If map, i.e.
   *     object, is used, properties should use integer property names.
   * @param {number=} opt_max Size of the biggest palette in palettes set.
   *     If not set, palettes must have a length property which will be used.
   * @param {number=} opt_cbf_max Size of the biggest palette which is still
   *     colourblind friendly.  1 by default.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */
  palette.Scheme.fromPalettes = function(name, groups,
                                         palettes, opt_max, opt_cbf_max) {
    var scheme = palette.Scheme(name, groups);
    scheme.addPalettes.apply(scheme, slice(arguments, 2));
    return scheme;
  };


  /**
   * Creates a new palette.Scheme and initialises it by calling
   * setColorFunction method with the rest of the arguments.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>} groups A group name or list of group
   *     names the scheme belongs to.
   * @param {palette.ColorFunction} func A colour generator function.
   * @param {boolean=} opt_is_cbf Whether palette generate with the function
   *     is colour-blind friendly.
   * @param {boolean=} opt_cyclic Whether colour at 0.0 is the same as the
   *     one at 1.0.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */
  palette.Scheme.withColorFunction = function(name, groups,
                                              func, opt_is_cbf, opt_cyclic) {
    var scheme = palette.Scheme(name, groups);
    scheme.setColorFunction.apply(scheme, slice(arguments, 2));
    return scheme;
  };


  /**
   * A map of registered schemes.  Maps a scheme or group name to a list of
   * scheme objects.  Property name is either 'n-<name>' for single scheme
   * names or 'g-<name>' for scheme group names.
   *
   * @type {!Object<string, !Array<!Object>>}
   */
  var registered_schemes = {};


  /**
   * Registers a new colour scheme.
   *
   * @param {!palette.SchemeType} scheme The scheme to add.
   */
  palette.register = function(scheme) {
    registered_schemes['n-' + scheme.scheme_name] = [scheme];
    scheme.groups.forEach(function(g) {
      (registered_schemes['g-' + g] =
       registered_schemes['g-' + g] || []).push(scheme);
    });
    (registered_schemes['g-all'] =
       registered_schemes['g-all'] || []).push(scheme);
  };


  /**
   * List all schemes that match given name and number of colours.
   *
   * name argument can be either a string or an array of strings.  In the
   * former case, the function acts as if the argument was an array with name
   * as a single argument (i.e. “palette.listSchemes('foo')” is exactly the same
   * as “palette.listSchemes(['foo'])”).
   *
   * Each name can be either name of a palette (e.g. 'tol-sq' for Paul Tol's
   * sequential palette), or a name of a group (e.g. 'sequential' for all
   * sequential palettes).  Name can therefore map to a single scheme or
   * several schemes.
   *
   * Furthermore, name can be suffixed with '-cbf' to indicate that only
   * schemes that are colourblind friendly should be returned.  For example,
   * 'rainbow' returns a HSV rainbow scheme, but because it is not colourblind
   * friendly, 'rainbow-cbf' returns no schemes.
   *
   * Some schemes may produce colourblind friendly palettes for some number of
   * colours.  For example ColorBrewer's Dark2 scheme is colourblind friendly
   * if no more than 3 colours are generated.  If opt_number is not specified,
   * 'qualitative-cbf' will include 'cb-Dark2' but if opt_number is given as,
   * say, 5 it won't.
   *
   * Name can also be 'all' which will return all registered schemes.
   * Naturally, 'all-cbf' will return all colourblind friendly schemes.
   *
   * Schemes are added to the library using palette.register.  Schemes are
   * created using palette.Scheme function.  By default, the following schemes
   * are available:
   *
   *     Name            Description
   *     --------------  -----------------------------------------------------
   *     tol             Paul Tol's qualitative scheme, cbf, max 12 colours.
   *     tol-dv          Paul Tol's diverging scheme, cbf.
   *     tol-sq          Paul Tol's sequential scheme, cbf.
   *     tol-rainbow     Paul Tol's qualitative scheme, cbf.
   *
   *     rainbow         A rainbow palette.
   *
   *     cb-YlGn         ColorBrewer sequential schemes.
   *     cb-YlGnBu
   *     cb-GnBu
   *     cb-BuGn
   *     cb-PuBuGn
   *     cb-PuBu
   *     cb-BuPu
   *     cb-RdPu
   *     cb-PuRd
   *     cb-OrRd
   *     cb-YlOrRd
   *     cb-YlOrBr
   *     cb-Purples
   *     cb-Blues
   *     cb-Greens
   *     cb-Oranges
   *     cb-Reds
   *     cb-Greys
   *
   *     cb-PuOr         ColorBrewer diverging schemes.
   *     cb-BrBG
   *     cb-PRGn
   *     cb-PiYG
   *     cb-RdBu
   *     cb-RdGy
   *     cb-RdYlBu
   *     cb-Spectral
   *     cb-RdYlGn
   *
   *     cb-Accent       ColorBrewer qualitative schemes.
   *     cb-Dark2
   *     cb-Paired
   *     cb-Pastel1
   *     cb-Pastel2
   *     cb-Set1
   *     cb-Set2
   *     cb-Set3
   *
   *     sol-base        Solarized base colours.
   *     sol-accent      Solarized accent colours.
   *
   * The following groups are also available by default:
   *
   *     Name            Description
   *     --------------  -----------------------------------------------------
   *     all             All registered schemes.
   *     sequential      All sequential schemes.
   *     diverging       All diverging schemes.
   *     qualitative     All qualitative schemes.
   *     cb-sequential   All ColorBrewer sequential schemes.
   *     cb-diverging    All ColorBrewer diverging schemes.
   *     cb-qualitative  All ColorBrewer qualitative schemes.
   *
   * You can read more about Paul Tol's palettes at http://www.sron.nl/~pault/.
   * You can read more about ColorBrewer at http://colorbrewer2.org.
   *
   * @param {string|!Array<string>} name A name of a colour scheme, of
   *     a group of colour schemes, or an array of any of those.
   * @param {number=} opt_number When requesting only colourblind friendly
   *     schemes, number of colours the scheme must provide generating such
   *     that the palette is still colourblind friendly.  2 by default.
   * @return {!Array<!palette.SchemeType>} An array of colour scheme objects
   *     matching the criteria.  Sorted by scheme name.
   */
  palette.listSchemes = function(name, opt_number) {
    if (!opt_number) {
      opt_number = 2;
    } else if (opt_number < 0) {
      opt_number = -opt_number;
    }

    var ret = [];
    (typeof name === 'string' ? [name] : name).forEach(function(n) {
      var cbf = n.substring(n.length - 4) === '-cbf';
      if (cbf) {
        n = n.substring(0, n.length - 4);
      }
      var schemes =
          registered_schemes['g-' + n] ||
          registered_schemes['n-' + n] ||
          [];
      for (var i = 0, scheme; (scheme = schemes[i]); ++i) {
        if ((cbf ? scheme.cbf : scheme.max) >= opt_number) {
          ret.push(scheme);
        }
      }
    });

    ret.sort(function(a, b) {
      return a.scheme_name >= b.scheme_name ?
        a.scheme_name > b.scheme_name ? 1 : 0 : -1;
    });
    return ret;
  };


  /**
   * Generates a palette using given colour generating function.
   *
   * The color_func callback must accept a singe number argument whose value
   * can vary from 0.0 to 1.0 (or in general from opt_start to opt_end), and
   * return a colour as an 'RRGGBB' string.  This function will be used when
   * generating palettes, i.e. if 11-colour palette is requested, this
   * function will be called with arguments 0.0, 0.1, …, 1.0.
   *
   * In some cases, it is not desirable to reach 1.0 when generating
   * a palette.  This happens for hue-rainbows where the 0–1 range corresponds
   * to a 0°–360° range in hues, and since hue at 0° is the same as at 360°,
   * it's desired to stop short the end of the range when generating
   * a palette.  To accomplish this, opt_cyclic should be set to true.
   *
   * opt_start and opt_end may be used to change the range the colour
   * generation function is called with.  opt_end may be less than opt_start
   * which will case to traverse the range in reverse.  Another way to reverse
   * the palette is requesting negative number of colours.  The two methods do
   * not always lead to the same results (especially if opt_cyclic is set).
   *
   * @param {palette.ColorFunction} color_func A colours generating callback
   *     function.
   * @param {number} number Number of colours to generate in the palette.  If
   *     number is negative, colours in the palette will be reversed.  If only
   *     one colour is requested, colour at opt_start will be returned.
   * @param {number=} opt_start Optional starting point for the palette
   *     generation function.  Zero by default.
   * @param {number=} opt_end Optional ending point for the palette generation
   *     function.  One by default.
   * @param {boolean=} opt_cyclic If true, function will assume colour at
   *     point opt_start is the same as one at opt_end.
   * @return {palette.Palette} An array of 'RRGGBB' colours.
   */
  palette.generate = function(color_func, number, opt_start, opt_end,
                              opt_cyclic) {
    if (Math.abs(number) < 1) {
      return [];
    }

    opt_start = opt_start === void(0) ? 0 : opt_start;
    opt_end = opt_end === void(0) ? 1 : opt_end;

    if (Math.abs(number) < 2) {
      return [color_func(opt_start)];
    }

    var i = Math.abs(number);
    var x = opt_start;
    var ret = [];
    var step = (opt_end - opt_start) / (opt_cyclic ? i : (i - 1));

    for (; --i >= 0; x += step) {
      ret.push(color_func(x));
    }
    if (number < 0) {
      ret.reverse();
    }
    return ret;
  };


  /**
   * Clamps value to [0, 1] range.
   * @param {number} v Number to limit value of.
   * @return {number} If v is inside of [0, 1] range returns v, otherwise
   *     returns 0 or 1 depending which side of the range v is closer to.
   */
  var clamp = function(v) {
    return v > 0 ? (v < 1 ? v : 1) : 0;
  };

  /**
   * Converts r, g, b triple into RRGGBB hex representation.
   * @param {number} r Red value of the colour in the range [0, 1].
   * @param {number} g Green value of the colour in the range [0, 1].
   * @param {number} b Blue value of the colour in the range [0, 1].
   * @return {string} A lower-case RRGGBB representation of the colour.
   */
  palette.rgbColor = function(r, g, b) {
    return [r, g, b].map(function(v) {
      v = Number(Math.round(clamp(v) * 255)).toString(16);
      return v.length == 1 ? '0' + v : v;
    }).join('');
  };

  /**
   * Converts a linear r, g, b triple into RRGGBB hex representation.
   * @param {number} r Linear red value of the colour in the range [0, 1].
   * @param {number} g Linear green value of the colour in the range [0, 1].
   * @param {number} b Linear blue value of the colour in the range [0, 1].
   * @return {string} A lower-case RRGGBB representation of the colour.
   */
  palette.linearRgbColor = function(r, g, b) {
    // http://www.brucelindbloom.com/index.html?Eqn_XYZ_to_RGB.html
    return [r, g, b].map(function(v) {
      v = clamp(v);
      if (v <= 0.0031308) {
        v = 12.92 * v;
      } else {
        v = 1.055 * Math.pow(v, 1 / 2.4) - 0.055;
      }
      v = Number(Math.round(v * 255)).toString(16);
      return v.length == 1 ? '0' + v : v;
    }).join('');
  };

  /**
   * Converts an HSV colours to RRGGBB hex representation.
   * @param {number} h Hue in the range [0, 1].
   * @param {number=} opt_s Saturation in the range [0, 1].  One by default.
   * @param {number=} opt_v Value in the range [0, 1].  One by default.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.hsvColor = function(h, opt_s, opt_v) {
    h *= 6;
    var s = opt_s === void(0) ? 1 : clamp(opt_s);
    var v = opt_v === void(0) ? 1 : clamp(opt_v);
    var x = v * (1 - s * Math.abs(h % 2 - 1));
    var m = v * (1 - s);
    switch (Math.floor(h) % 6) {
    case 0: return palette.rgbColor(v, x, m);
    case 1: return palette.rgbColor(x, v, m);
    case 2: return palette.rgbColor(m, v, x);
    case 3: return palette.rgbColor(m, x, v);
    case 4: return palette.rgbColor(x, m, v);
    default: return palette.rgbColor(v, m, x);
    }
  };

  palette.register(palette.Scheme.withColorFunction(
    'rainbow', 'qualitative', palette.hsvColor, false, true));

  return palette;
})();


/** @typedef {function(number): string} */
palette.ColorFunction;

/** @typedef {!Array<string>} */
palette.Palette;

/** @typedef {!Object<number, palette.Palette>|!Array<palette.Palette>} */
palette.PalettesList;

/**
 * @typedef {
 *   function(number, ...?): Array<string>|
 *   {
 *     scheme_name: string,
 *     groups: !Array<string>,
 *     max: number,
 *     cbf_max: number,
 *     addPalette: function(!Array<string>, boolean=),
 *     addPalettes: function(palette.PalettesList, number=, number=),
 *     shrinkByTakingHead: function(boolean, number=),
 *     setColorFunction: function(palette.ColorFunction, boolean=, boolean=),
 *     color: function(number, ...?): ?string}}
 */
palette.SchemeType;


/* Paul Tol's schemes start here. *******************************************/
/* See http://www.sron.nl/~pault/ */

(function() {
  var rgb = palette.rgbColor;

  /**
   * Calculates value of a polynomial at given point.
   * For example, poly(x, 1, 2, 3) calculates value of “1 + 2*x + 2*X^2”.
   * @param {number} x Value to calculate polynomial for.
   * @param {...number} varargs Coefficients of the polynomial specified in
   *     the order of rising powers of x including constant as the first
   *     variable argument.
   */
  var poly = function(x, varargs) {
    var i = arguments.length - 1, n = arguments[i];
    while (i > 1) {
      n = n * x + arguments[--i];
    }
    return n;
  };

  /**
   * Calculate approximate value of error function with maximum error of 0.0005.
   * See <https://en.wikipedia.org/wiki/Error_function>.
   * @param {number} x Argument of the error function.
   * @return {number} Value of error function for x.
   */
  var erf = function(x) {
    // https://en.wikipedia.org/wiki/Error_function#Approximation_with_elementary_functions
    // This produces a maximum error of 0.0005 which is more then we need.  In
    // the worst case, that error is multiplied by four and then divided by two
    // before being multiplied by 255, so in the end, the error is multiplied by
    // 510 which produces 0.255 which is less than a single colour step.
    var y = poly(Math.abs(x), 1, 0.278393, 0.230389, 0.000972, 0.078108);
    y *= y; // y^2
    y *= y; // y^4
    y = 1 - 1 / y;
    return x < 0 ? -y : y;
  };

  palette.register(palette.Scheme.fromPalettes('tol', 'qualitative', [
    ['4477aa'],
    ['4477aa', 'cc6677'],
    ['4477aa', 'ddcc77', 'cc6677'],
    ['4477aa', '117733', 'ddcc77', 'cc6677'],
    ['332288', '88ccee', '117733', 'ddcc77', 'cc6677'],
    ['332288', '88ccee', '117733', 'ddcc77', 'cc6677', 'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', 'ddcc77', 'cc6677', 'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', '999933', 'ddcc77', 'cc6677',
     'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', '999933', 'ddcc77', 'cc6677',
     '882255', 'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', '999933', 'ddcc77', '661100',
     'cc6677', '882255', 'aa4499'],
    ['332288', '6699cc', '88ccee', '44aa99', '117733', '999933', 'ddcc77',
     '661100', 'cc6677', '882255', 'aa4499'],
    ['332288', '6699cc', '88ccee', '44aa99', '117733', '999933', 'ddcc77',
     '661100', 'cc6677', 'aa4466', '882255', 'aa4499']
  ], 12, 12));

  /**
   * Calculates a colour along Paul Tol's sequential colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 7 and equation 1.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.tolSequentialColor = function(x) {
    return rgb(1 - 0.392 * (1 + erf((x - 0.869) / 0.255)),
               1.021 - 0.456 * (1 + erf((x - 0.527) / 0.376)),
               1 - 0.493 * (1 + erf((x - 0.272) / 0.309)));
  };

  palette.register(palette.Scheme.withColorFunction(
    'tol-sq', 'sequential', palette.tolSequentialColor, true));

  /**
   * Calculates a colour along Paul Tol's diverging colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 8 and equation 2.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.tolDivergingColor = function(x) {
    var g = poly(x, 0.572, 1.524, -1.811) / poly(x, 1, -0.291, 0.1574);
    return rgb(poly(x, 0.235, -2.13, 26.92, -65.5, 63.5, -22.36),
               g * g,
               1 / poly(x, 1.579, -4.03, 12.92, -31.4, 48.6, -23.36));
  };

  palette.register(palette.Scheme.withColorFunction(
    'tol-dv', 'diverging', palette.tolDivergingColor, true));

  /**
   * Calculates a colour along Paul Tol's rainbow colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 13 and equation 3.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.tolRainbowColor = function(x) {
    return rgb(poly(x, 0.472, -0.567, 4.05) / poly(x, 1, 8.72, -19.17, 14.1),
               poly(x, 0.108932, -1.22635, 27.284, -98.577, 163.3, -131.395,
                    40.634),
               1 / poly(x, 1.97, 3.54, -68.5, 243, -297, 125));
  };

  palette.register(palette.Scheme.withColorFunction(
    'tol-rainbow', 'qualitative', palette.tolRainbowColor, true));
})();


/* Solarized colour schemes start here. *************************************/
/* See http://ethanschoonover.com/solarized */

(function() {
  /*
   * Those are not really designed to be used in graphs, but we're keeping
   * them here in case someone cares.
   */
  palette.register(palette.Scheme.fromPalettes('sol-base', 'sequential', [
    ['002b36', '073642', '586e75', '657b83', '839496', '93a1a1', 'eee8d5',
     'fdf6e3']
  ], 1, 8));
  palette.register(palette.Scheme.fromPalettes('sol-accent', 'qualitative', [
    ['b58900', 'cb4b16', 'dc322f', 'd33682', '6c71c4', '268bd2', '2aa198',
     '859900']
  ]));
})();


/* ColorBrewer colour schemes start here. ***********************************/
/* See http://colorbrewer2.org/ */

(function() {
  var schemes = {
    YlGn: {
      type: 'sequential',
      cbf: 42,
      3: ['f7fcb9', 'addd8e', '31a354'],
      4: ['ffffcc', 'c2e699', '78c679', '238443'],
      5: ['ffffcc', 'c2e699', '78c679', '31a354', '006837'],
      6: ['ffffcc', 'd9f0a3', 'addd8e', '78c679', '31a354', '006837'],
      7: ['ffffcc', 'd9f0a3', 'addd8e', '78c679', '41ab5d', '238443',
          '005a32'],
      8: ['ffffe5', 'f7fcb9', 'd9f0a3', 'addd8e', '78c679', '41ab5d',
          '238443', '005a32'],
      9: ['ffffe5', 'f7fcb9', 'd9f0a3', 'addd8e', '78c679', '41ab5d',
          '238443', '006837', '004529']
    },
    YlGnBu: {
      type: 'sequential',
      cbf: 42,
      3: ['edf8b1', '7fcdbb', '2c7fb8'],
      4: ['ffffcc', 'a1dab4', '41b6c4', '225ea8'],
      5: ['ffffcc', 'a1dab4', '41b6c4', '2c7fb8', '253494'],
      6: ['ffffcc', 'c7e9b4', '7fcdbb', '41b6c4', '2c7fb8', '253494'],
      7: ['ffffcc', 'c7e9b4', '7fcdbb', '41b6c4', '1d91c0', '225ea8',
          '0c2c84'],
      8: ['ffffd9', 'edf8b1', 'c7e9b4', '7fcdbb', '41b6c4', '1d91c0',
          '225ea8', '0c2c84'],
      9: ['ffffd9', 'edf8b1', 'c7e9b4', '7fcdbb', '41b6c4', '1d91c0',
          '225ea8', '253494', '081d58']
    },
    GnBu: {
      type: 'sequential',
      cbf: 42,
      3: ['e0f3db', 'a8ddb5', '43a2ca'],
      4: ['f0f9e8', 'bae4bc', '7bccc4', '2b8cbe'],
      5: ['f0f9e8', 'bae4bc', '7bccc4', '43a2ca', '0868ac'],
      6: ['f0f9e8', 'ccebc5', 'a8ddb5', '7bccc4', '43a2ca', '0868ac'],
      7: ['f0f9e8', 'ccebc5', 'a8ddb5', '7bccc4', '4eb3d3', '2b8cbe',
          '08589e'],
      8: ['f7fcf0', 'e0f3db', 'ccebc5', 'a8ddb5', '7bccc4', '4eb3d3',
          '2b8cbe', '08589e'],
      9: ['f7fcf0', 'e0f3db', 'ccebc5', 'a8ddb5', '7bccc4', '4eb3d3',
          '2b8cbe', '0868ac', '084081']
    },
    BuGn: {
      type: 'sequential',
      cbf: 42,
      3: ['e5f5f9', '99d8c9', '2ca25f'],
      4: ['edf8fb', 'b2e2e2', '66c2a4', '238b45'],
      5: ['edf8fb', 'b2e2e2', '66c2a4', '2ca25f', '006d2c'],
      6: ['edf8fb', 'ccece6', '99d8c9', '66c2a4', '2ca25f', '006d2c'],
      7: ['edf8fb', 'ccece6', '99d8c9', '66c2a4', '41ae76', '238b45',
          '005824'],
      8: ['f7fcfd', 'e5f5f9', 'ccece6', '99d8c9', '66c2a4', '41ae76',
          '238b45', '005824'],
      9: ['f7fcfd', 'e5f5f9', 'ccece6', '99d8c9', '66c2a4', '41ae76',
          '238b45', '006d2c', '00441b']
    },
    PuBuGn: {
      type: 'sequential',
      cbf: 42,
      3: ['ece2f0', 'a6bddb', '1c9099'],
      4: ['f6eff7', 'bdc9e1', '67a9cf', '02818a'],
      5: ['f6eff7', 'bdc9e1', '67a9cf', '1c9099', '016c59'],
      6: ['f6eff7', 'd0d1e6', 'a6bddb', '67a9cf', '1c9099', '016c59'],
      7: ['f6eff7', 'd0d1e6', 'a6bddb', '67a9cf', '3690c0', '02818a',
          '016450'],
      8: ['fff7fb', 'ece2f0', 'd0d1e6', 'a6bddb', '67a9cf', '3690c0',
          '02818a', '016450'],
      9: ['fff7fb', 'ece2f0', 'd0d1e6', 'a6bddb', '67a9cf', '3690c0',
          '02818a', '016c59', '014636']
    },
    PuBu: {
      type: 'sequential',
      cbf: 42,
      3: ['ece7f2', 'a6bddb', '2b8cbe'],
      4: ['f1eef6', 'bdc9e1', '74a9cf', '0570b0'],
      5: ['f1eef6', 'bdc9e1', '74a9cf', '2b8cbe', '045a8d'],
      6: ['f1eef6', 'd0d1e6', 'a6bddb', '74a9cf', '2b8cbe', '045a8d'],
      7: ['f1eef6', 'd0d1e6', 'a6bddb', '74a9cf', '3690c0', '0570b0',
          '034e7b'],
      8: ['fff7fb', 'ece7f2', 'd0d1e6', 'a6bddb', '74a9cf', '3690c0',
          '0570b0', '034e7b'],
      9: ['fff7fb', 'ece7f2', 'd0d1e6', 'a6bddb', '74a9cf', '3690c0',
          '0570b0', '045a8d', '023858']
    },
    BuPu: {
      type: 'sequential',
      cbf: 42,
      3: ['e0ecf4', '9ebcda', '8856a7'],
      4: ['edf8fb', 'b3cde3', '8c96c6', '88419d'],
      5: ['edf8fb', 'b3cde3', '8c96c6', '8856a7', '810f7c'],
      6: ['edf8fb', 'bfd3e6', '9ebcda', '8c96c6', '8856a7', '810f7c'],
      7: ['edf8fb', 'bfd3e6', '9ebcda', '8c96c6', '8c6bb1', '88419d',
          '6e016b'],
      8: ['f7fcfd', 'e0ecf4', 'bfd3e6', '9ebcda', '8c96c6', '8c6bb1',
          '88419d', '6e016b'],
      9: ['f7fcfd', 'e0ecf4', 'bfd3e6', '9ebcda', '8c96c6', '8c6bb1',
          '88419d', '810f7c', '4d004b']
    },
    RdPu: {
      type: 'sequential',
      cbf: 42,
      3: ['fde0dd', 'fa9fb5', 'c51b8a'],
      4: ['feebe2', 'fbb4b9', 'f768a1', 'ae017e'],
      5: ['feebe2', 'fbb4b9', 'f768a1', 'c51b8a', '7a0177'],
      6: ['feebe2', 'fcc5c0', 'fa9fb5', 'f768a1', 'c51b8a', '7a0177'],
      7: ['feebe2', 'fcc5c0', 'fa9fb5', 'f768a1', 'dd3497', 'ae017e',
          '7a0177'],
      8: ['fff7f3', 'fde0dd', 'fcc5c0', 'fa9fb5', 'f768a1', 'dd3497',
          'ae017e', '7a0177'],
      9: ['fff7f3', 'fde0dd', 'fcc5c0', 'fa9fb5', 'f768a1', 'dd3497',
          'ae017e', '7a0177', '49006a']
    },
    PuRd: {
      type: 'sequential',
      cbf: 42,
      3: ['e7e1ef', 'c994c7', 'dd1c77'],
      4: ['f1eef6', 'd7b5d8', 'df65b0', 'ce1256'],
      5: ['f1eef6', 'd7b5d8', 'df65b0', 'dd1c77', '980043'],
      6: ['f1eef6', 'd4b9da', 'c994c7', 'df65b0', 'dd1c77', '980043'],
      7: ['f1eef6', 'd4b9da', 'c994c7', 'df65b0', 'e7298a', 'ce1256',
          '91003f'],
      8: ['f7f4f9', 'e7e1ef', 'd4b9da', 'c994c7', 'df65b0', 'e7298a',
          'ce1256', '91003f'],
      9: ['f7f4f9', 'e7e1ef', 'd4b9da', 'c994c7', 'df65b0', 'e7298a',
          'ce1256', '980043', '67001f']
    },
    OrRd: {
      type: 'sequential',
      cbf: 42,
      3: ['fee8c8', 'fdbb84', 'e34a33'],
      4: ['fef0d9', 'fdcc8a', 'fc8d59', 'd7301f'],
      5: ['fef0d9', 'fdcc8a', 'fc8d59', 'e34a33', 'b30000'],
      6: ['fef0d9', 'fdd49e', 'fdbb84', 'fc8d59', 'e34a33', 'b30000'],
      7: ['fef0d9', 'fdd49e', 'fdbb84', 'fc8d59', 'ef6548', 'd7301f',
          '990000'],
      8: ['fff7ec', 'fee8c8', 'fdd49e', 'fdbb84', 'fc8d59', 'ef6548',
          'd7301f', '990000'],
      9: ['fff7ec', 'fee8c8', 'fdd49e', 'fdbb84', 'fc8d59', 'ef6548',
          'd7301f', 'b30000', '7f0000']
    },
    YlOrRd: {
      type: 'sequential',
      cbf: 42,
      3: ['ffeda0', 'feb24c', 'f03b20'],
      4: ['ffffb2', 'fecc5c', 'fd8d3c', 'e31a1c'],
      5: ['ffffb2', 'fecc5c', 'fd8d3c', 'f03b20', 'bd0026'],
      6: ['ffffb2', 'fed976', 'feb24c', 'fd8d3c', 'f03b20', 'bd0026'],
      7: ['ffffb2', 'fed976', 'feb24c', 'fd8d3c', 'fc4e2a', 'e31a1c',
          'b10026'],
      8: ['ffffcc', 'ffeda0', 'fed976', 'feb24c', 'fd8d3c', 'fc4e2a',
          'e31a1c', 'b10026'],
      9: ['ffffcc', 'ffeda0', 'fed976', 'feb24c', 'fd8d3c', 'fc4e2a',
          'e31a1c', 'bd0026', '800026']
    },
    YlOrBr: {
      type: 'sequential',
      cbf: 42,
      3: ['fff7bc', 'fec44f', 'd95f0e'],
      4: ['ffffd4', 'fed98e', 'fe9929', 'cc4c02'],
      5: ['ffffd4', 'fed98e', 'fe9929', 'd95f0e', '993404'],
      6: ['ffffd4', 'fee391', 'fec44f', 'fe9929', 'd95f0e', '993404'],
      7: ['ffffd4', 'fee391', 'fec44f', 'fe9929', 'ec7014', 'cc4c02',
          '8c2d04'],
      8: ['ffffe5', 'fff7bc', 'fee391', 'fec44f', 'fe9929', 'ec7014',
          'cc4c02', '8c2d04'],
      9: ['ffffe5', 'fff7bc', 'fee391', 'fec44f', 'fe9929', 'ec7014',
          'cc4c02', '993404', '662506']
    },
    Purples: {
      type: 'sequential',
      cbf: 42,
      3: ['efedf5', 'bcbddc', '756bb1'],
      4: ['f2f0f7', 'cbc9e2', '9e9ac8', '6a51a3'],
      5: ['f2f0f7', 'cbc9e2', '9e9ac8', '756bb1', '54278f'],
      6: ['f2f0f7', 'dadaeb', 'bcbddc', '9e9ac8', '756bb1', '54278f'],
      7: ['f2f0f7', 'dadaeb', 'bcbddc', '9e9ac8', '807dba', '6a51a3',
          '4a1486'],
      8: ['fcfbfd', 'efedf5', 'dadaeb', 'bcbddc', '9e9ac8', '807dba',
          '6a51a3', '4a1486'],
      9: ['fcfbfd', 'efedf5', 'dadaeb', 'bcbddc', '9e9ac8', '807dba',
          '6a51a3', '54278f', '3f007d']
    },
    Blues: {
      type: 'sequential',
      cbf: 42,
      3: ['deebf7', '9ecae1', '3182bd'],
      4: ['eff3ff', 'bdd7e7', '6baed6', '2171b5'],
      5: ['eff3ff', 'bdd7e7', '6baed6', '3182bd', '08519c'],
      6: ['eff3ff', 'c6dbef', '9ecae1', '6baed6', '3182bd', '08519c'],
      7: ['eff3ff', 'c6dbef', '9ecae1', '6baed6', '4292c6', '2171b5',
          '084594'],
      8: ['f7fbff', 'deebf7', 'c6dbef', '9ecae1', '6baed6', '4292c6',
          '2171b5', '084594'],
      9: ['f7fbff', 'deebf7', 'c6dbef', '9ecae1', '6baed6', '4292c6',
          '2171b5', '08519c', '08306b']
    },
    Greens: {
      type: 'sequential',
      cbf: 42,
      3: ['e5f5e0', 'a1d99b', '31a354'],
      4: ['edf8e9', 'bae4b3', '74c476', '238b45'],
      5: ['edf8e9', 'bae4b3', '74c476', '31a354', '006d2c'],
      6: ['edf8e9', 'c7e9c0', 'a1d99b', '74c476', '31a354', '006d2c'],
      7: ['edf8e9', 'c7e9c0', 'a1d99b', '74c476', '41ab5d', '238b45',
          '005a32'],
      8: ['f7fcf5', 'e5f5e0', 'c7e9c0', 'a1d99b', '74c476', '41ab5d',
          '238b45', '005a32'],
      9: ['f7fcf5', 'e5f5e0', 'c7e9c0', 'a1d99b', '74c476', '41ab5d',
          '238b45', '006d2c', '00441b']
    },
    Oranges: {
      type: 'sequential',
      cbf: 42,
      3: ['fee6ce', 'fdae6b', 'e6550d'],
      4: ['feedde', 'fdbe85', 'fd8d3c', 'd94701'],
      5: ['feedde', 'fdbe85', 'fd8d3c', 'e6550d', 'a63603'],
      6: ['feedde', 'fdd0a2', 'fdae6b', 'fd8d3c', 'e6550d', 'a63603'],
      7: ['feedde', 'fdd0a2', 'fdae6b', 'fd8d3c', 'f16913', 'd94801',
          '8c2d04'],
      8: ['fff5eb', 'fee6ce', 'fdd0a2', 'fdae6b', 'fd8d3c', 'f16913',
          'd94801', '8c2d04'],
      9: ['fff5eb', 'fee6ce', 'fdd0a2', 'fdae6b', 'fd8d3c', 'f16913',
          'd94801', 'a63603', '7f2704']
    },
    Reds: {
      type: 'sequential',
      cbf: 42,
      3: ['fee0d2', 'fc9272', 'de2d26'],
      4: ['fee5d9', 'fcae91', 'fb6a4a', 'cb181d'],
      5: ['fee5d9', 'fcae91', 'fb6a4a', 'de2d26', 'a50f15'],
      6: ['fee5d9', 'fcbba1', 'fc9272', 'fb6a4a', 'de2d26', 'a50f15'],
      7: ['fee5d9', 'fcbba1', 'fc9272', 'fb6a4a', 'ef3b2c', 'cb181d',
          '99000d'],
      8: ['fff5f0', 'fee0d2', 'fcbba1', 'fc9272', 'fb6a4a', 'ef3b2c',
          'cb181d', '99000d'],
      9: ['fff5f0', 'fee0d2', 'fcbba1', 'fc9272', 'fb6a4a', 'ef3b2c',
          'cb181d', 'a50f15', '67000d']
    },
    Greys: {
      type: 'sequential',
      cbf: 42,
      3: ['f0f0f0', 'bdbdbd', '636363'],
      4: ['f7f7f7', 'cccccc', '969696', '525252'],
      5: ['f7f7f7', 'cccccc', '969696', '636363', '252525'],
      6: ['f7f7f7', 'd9d9d9', 'bdbdbd', '969696', '636363', '252525'],
      7: ['f7f7f7', 'd9d9d9', 'bdbdbd', '969696', '737373', '525252',
          '252525'],
      8: ['ffffff', 'f0f0f0', 'd9d9d9', 'bdbdbd', '969696', '737373',
          '525252', '252525'],
      9: ['ffffff', 'f0f0f0', 'd9d9d9', 'bdbdbd', '969696', '737373',
          '525252', '252525', '000000']
    },
    PuOr: {
      type: 'diverging',
      cbf: 42,
      3: ['f1a340', 'f7f7f7', '998ec3'],
      4: ['e66101', 'fdb863', 'b2abd2', '5e3c99'],
      5: ['e66101', 'fdb863', 'f7f7f7', 'b2abd2', '5e3c99'],
      6: ['b35806', 'f1a340', 'fee0b6', 'd8daeb', '998ec3', '542788'],
      7: ['b35806', 'f1a340', 'fee0b6', 'f7f7f7', 'd8daeb', '998ec3',
          '542788'],
      8: ['b35806', 'e08214', 'fdb863', 'fee0b6', 'd8daeb', 'b2abd2',
          '8073ac', '542788'],
      9: ['b35806', 'e08214', 'fdb863', 'fee0b6', 'f7f7f7', 'd8daeb',
          'b2abd2', '8073ac', '542788'],
      10: ['7f3b08', 'b35806', 'e08214', 'fdb863', 'fee0b6', 'd8daeb',
           'b2abd2', '8073ac', '542788', '2d004b'],
      11: ['7f3b08', 'b35806', 'e08214', 'fdb863', 'fee0b6', 'f7f7f7',
           'd8daeb', 'b2abd2', '8073ac', '542788', '2d004b']
    },
    BrBG: {
      type: 'diverging',
      cbf: 42,
      3: ['d8b365', 'f5f5f5', '5ab4ac'],
      4: ['a6611a', 'dfc27d', '80cdc1', '018571'],
      5: ['a6611a', 'dfc27d', 'f5f5f5', '80cdc1', '018571'],
      6: ['8c510a', 'd8b365', 'f6e8c3', 'c7eae5', '5ab4ac', '01665e'],
      7: ['8c510a', 'd8b365', 'f6e8c3', 'f5f5f5', 'c7eae5', '5ab4ac',
          '01665e'],
      8: ['8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'c7eae5', '80cdc1',
          '35978f', '01665e'],
      9: ['8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'f5f5f5', 'c7eae5',
          '80cdc1', '35978f', '01665e'],
      10: ['543005', '8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'c7eae5',
           '80cdc1', '35978f', '01665e', '003c30'],
      11: ['543005', '8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'f5f5f5',
           'c7eae5', '80cdc1', '35978f', '01665e', '003c30']
    },
    PRGn: {
      type: 'diverging',
      cbf: 42,
      3: ['af8dc3', 'f7f7f7', '7fbf7b'],
      4: ['7b3294', 'c2a5cf', 'a6dba0', '008837'],
      5: ['7b3294', 'c2a5cf', 'f7f7f7', 'a6dba0', '008837'],
      6: ['762a83', 'af8dc3', 'e7d4e8', 'd9f0d3', '7fbf7b', '1b7837'],
      7: ['762a83', 'af8dc3', 'e7d4e8', 'f7f7f7', 'd9f0d3', '7fbf7b',
          '1b7837'],
      8: ['762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'd9f0d3', 'a6dba0',
          '5aae61', '1b7837'],
      9: ['762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'f7f7f7', 'd9f0d3',
          'a6dba0', '5aae61', '1b7837'],
      10: ['40004b', '762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'd9f0d3',
           'a6dba0', '5aae61', '1b7837', '00441b'],
      11: ['40004b', '762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'f7f7f7',
           'd9f0d3', 'a6dba0', '5aae61', '1b7837', '00441b']
    },
    PiYG: {
      type: 'diverging',
      cbf: 42,
      3: ['e9a3c9', 'f7f7f7', 'a1d76a'],
      4: ['d01c8b', 'f1b6da', 'b8e186', '4dac26'],
      5: ['d01c8b', 'f1b6da', 'f7f7f7', 'b8e186', '4dac26'],
      6: ['c51b7d', 'e9a3c9', 'fde0ef', 'e6f5d0', 'a1d76a', '4d9221'],
      7: ['c51b7d', 'e9a3c9', 'fde0ef', 'f7f7f7', 'e6f5d0', 'a1d76a',
          '4d9221'],
      8: ['c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'e6f5d0', 'b8e186',
          '7fbc41', '4d9221'],
      9: ['c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'f7f7f7', 'e6f5d0',
          'b8e186', '7fbc41', '4d9221'],
      10: ['8e0152', 'c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'e6f5d0',
           'b8e186', '7fbc41', '4d9221', '276419'],
      11: ['8e0152', 'c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'f7f7f7',
           'e6f5d0', 'b8e186', '7fbc41', '4d9221', '276419']
    },
    RdBu: {
      type: 'diverging',
      cbf: 42,
      3: ['ef8a62', 'f7f7f7', '67a9cf'],
      4: ['ca0020', 'f4a582', '92c5de', '0571b0'],
      5: ['ca0020', 'f4a582', 'f7f7f7', '92c5de', '0571b0'],
      6: ['b2182b', 'ef8a62', 'fddbc7', 'd1e5f0', '67a9cf', '2166ac'],
      7: ['b2182b', 'ef8a62', 'fddbc7', 'f7f7f7', 'd1e5f0', '67a9cf',
          '2166ac'],
      8: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'd1e5f0', '92c5de',
          '4393c3', '2166ac'],
      9: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'f7f7f7', 'd1e5f0',
          '92c5de', '4393c3', '2166ac'],
      10: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'd1e5f0',
           '92c5de', '4393c3', '2166ac', '053061'],
      11: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'f7f7f7',
           'd1e5f0', '92c5de', '4393c3', '2166ac', '053061']
    },
    RdGy: {
      type: 'diverging',
      cbf: 42,
      3: ['ef8a62', 'ffffff', '999999'],
      4: ['ca0020', 'f4a582', 'bababa', '404040'],
      5: ['ca0020', 'f4a582', 'ffffff', 'bababa', '404040'],
      6: ['b2182b', 'ef8a62', 'fddbc7', 'e0e0e0', '999999', '4d4d4d'],
      7: ['b2182b', 'ef8a62', 'fddbc7', 'ffffff', 'e0e0e0', '999999',
          '4d4d4d'],
      8: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'e0e0e0', 'bababa',
          '878787', '4d4d4d'],
      9: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'ffffff', 'e0e0e0',
          'bababa', '878787', '4d4d4d'],
      10: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'e0e0e0',
           'bababa', '878787', '4d4d4d', '1a1a1a'],
      11: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'ffffff',
           'e0e0e0', 'bababa', '878787', '4d4d4d', '1a1a1a']
    },
    RdYlBu: {
      type: 'diverging',
      cbf: 42,
      3: ['fc8d59', 'ffffbf', '91bfdb'],
      4: ['d7191c', 'fdae61', 'abd9e9', '2c7bb6'],
      5: ['d7191c', 'fdae61', 'ffffbf', 'abd9e9', '2c7bb6'],
      6: ['d73027', 'fc8d59', 'fee090', 'e0f3f8', '91bfdb', '4575b4'],
      7: ['d73027', 'fc8d59', 'fee090', 'ffffbf', 'e0f3f8', '91bfdb',
          '4575b4'],
      8: ['d73027', 'f46d43', 'fdae61', 'fee090', 'e0f3f8', 'abd9e9',
          '74add1', '4575b4'],
      9: ['d73027', 'f46d43', 'fdae61', 'fee090', 'ffffbf', 'e0f3f8',
          'abd9e9', '74add1', '4575b4'],
      10: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee090', 'e0f3f8',
           'abd9e9', '74add1', '4575b4', '313695'],
      11: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee090', 'ffffbf',
           'e0f3f8', 'abd9e9', '74add1', '4575b4', '313695']
    },
    Spectral: {
      type: 'diverging',
      cbf: 0,
      3: ['fc8d59', 'ffffbf', '99d594'],
      4: ['d7191c', 'fdae61', 'abdda4', '2b83ba'],
      5: ['d7191c', 'fdae61', 'ffffbf', 'abdda4', '2b83ba'],
      6: ['d53e4f', 'fc8d59', 'fee08b', 'e6f598', '99d594', '3288bd'],
      7: ['d53e4f', 'fc8d59', 'fee08b', 'ffffbf', 'e6f598', '99d594',
          '3288bd'],
      8: ['d53e4f', 'f46d43', 'fdae61', 'fee08b', 'e6f598', 'abdda4',
          '66c2a5', '3288bd'],
      9: ['d53e4f', 'f46d43', 'fdae61', 'fee08b', 'ffffbf', 'e6f598',
          'abdda4', '66c2a5', '3288bd'],
      10: ['9e0142', 'd53e4f', 'f46d43', 'fdae61', 'fee08b', 'e6f598',
           'abdda4', '66c2a5', '3288bd', '5e4fa2'],
      11: ['9e0142', 'd53e4f', 'f46d43', 'fdae61', 'fee08b', 'ffffbf',
           'e6f598', 'abdda4', '66c2a5', '3288bd', '5e4fa2']
    },
    RdYlGn: {
      type: 'diverging',
      cbf: 0,
      3: ['fc8d59', 'ffffbf', '91cf60'],
      4: ['d7191c', 'fdae61', 'a6d96a', '1a9641'],
      5: ['d7191c', 'fdae61', 'ffffbf', 'a6d96a', '1a9641'],
      6: ['d73027', 'fc8d59', 'fee08b', 'd9ef8b', '91cf60', '1a9850'],
      7: ['d73027', 'fc8d59', 'fee08b', 'ffffbf', 'd9ef8b', '91cf60',
          '1a9850'],
      8: ['d73027', 'f46d43', 'fdae61', 'fee08b', 'd9ef8b', 'a6d96a',
          '66bd63', '1a9850'],
      9: ['d73027', 'f46d43', 'fdae61', 'fee08b', 'ffffbf', 'd9ef8b',
          'a6d96a', '66bd63', '1a9850'],
      10: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee08b', 'd9ef8b',
           'a6d96a', '66bd63', '1a9850', '006837'],
      11: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee08b', 'ffffbf',
           'd9ef8b', 'a6d96a', '66bd63', '1a9850', '006837']
    },
    Accent: {
      type: 'qualitative',
      cbf: 0,
      3: ['7fc97f', 'beaed4', 'fdc086'],
      4: ['7fc97f', 'beaed4', 'fdc086', 'ffff99'],
      5: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0'],
      6: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0', 'f0027f'],
      7: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0', 'f0027f',
          'bf5b17'],
      8: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0', 'f0027f',
          'bf5b17', '666666']
    },
    Dark2: {
      type: 'qualitative',
      cbf: 3,
      3: ['1b9e77', 'd95f02', '7570b3'],
      4: ['1b9e77', 'd95f02', '7570b3', 'e7298a'],
      5: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e'],
      6: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e', 'e6ab02'],
      7: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e', 'e6ab02',
          'a6761d'],
      8: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e', 'e6ab02',
          'a6761d', '666666']
    },
    Paired: {
      type: 'qualitative',
      cbf: 4,
      3: ['a6cee3', '1f78b4', 'b2df8a'],
      4: ['a6cee3', '1f78b4', 'b2df8a', '33a02c'],
      5: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99'],
      6: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c'],
      7: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
          'fdbf6f'],
      8: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
          'fdbf6f', 'ff7f00'],
      9: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
          'fdbf6f', 'ff7f00', 'cab2d6'],
      10: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
           'fdbf6f', 'ff7f00', 'cab2d6', '6a3d9a'],
      11: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
           'fdbf6f', 'ff7f00', 'cab2d6', '6a3d9a', 'ffff99'],
      12: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
           'fdbf6f', 'ff7f00', 'cab2d6', '6a3d9a', 'ffff99', 'b15928']
    },
    Pastel1: {
      type: 'qualitative',
      cbf: 0,
      3: ['fbb4ae', 'b3cde3', 'ccebc5'],
      4: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4'],
      5: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6'],
      6: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc'],
      7: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc',
          'e5d8bd'],
      8: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc',
          'e5d8bd', 'fddaec'],
      9: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc',
          'e5d8bd', 'fddaec', 'f2f2f2']
    },
    Pastel2: {
      type: 'qualitative',
      cbf: 0,
      3: ['b3e2cd', 'fdcdac', 'cbd5e8'],
      4: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4'],
      5: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9'],
      6: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9', 'fff2ae'],
      7: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9', 'fff2ae',
          'f1e2cc'],
      8: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9', 'fff2ae',
          'f1e2cc', 'cccccc']
    },
    Set1: {
      type: 'qualitative',
      cbf: 0,
      3: ['e41a1c', '377eb8', '4daf4a'],
      4: ['e41a1c', '377eb8', '4daf4a', '984ea3'],
      5: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00'],
      6: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33'],
      7: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33',
          'a65628'],
      8: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33',
          'a65628', 'f781bf'],
      9: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33',
          'a65628', 'f781bf', '999999']
    },
    Set2: {
      type: 'qualitative',
      cbf: 3,
      3: ['66c2a5', 'fc8d62', '8da0cb'],
      4: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3'],
      5: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854'],
      6: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854', 'ffd92f'],
      7: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854', 'ffd92f',
          'e5c494'],
      8: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854', 'ffd92f',
          'e5c494', 'b3b3b3']
    },
    Set3: {
      type: 'qualitative',
      cbf: 0,
      3: ['8dd3c7', 'ffffb3', 'bebada'],
      4: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072'],
      5: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3'],
      6: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462'],
      7: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
          'b3de69'],
      8: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
          'b3de69', 'fccde5'],
      9: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
          'b3de69', 'fccde5', 'd9d9d9'],
      10: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
           'b3de69', 'fccde5', 'd9d9d9', 'bc80bd'],
      11: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
           'b3de69', 'fccde5', 'd9d9d9', 'bc80bd', 'ccebc5'],
      12: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
           'b3de69', 'fccde5', 'd9d9d9', 'bc80bd', 'ccebc5', 'ffed6f']
    }
  };

  for (var name in schemes) {
    var scheme = schemes[name];
    scheme = palette.Scheme.fromPalettes(
      'cb-' + name, [scheme.type, 'cb-' + scheme.type], scheme, 12, scheme.cbf);
    palette.register(scheme);
  }
})();

var paletteRandom = function(length)
{
    if(length > 12)
    {
        var data = [];
        var times = Math.floor(length / 12);
        var remain = length % 12;
        for(var a=0; a<times; a++)
        {
            var d = palette('tol', 12);
            for(var b=0; b<12; b++)
            {
                data.push('#'+d[b]);
            }
        }
        if(remain > 0)
        {
            var d = palette('tol', remain);
            for(var b=0; b<d.length; b++)
            {
                data.push('#'+d[b]);
            }
        }
        return data;
    }
    else
    {
        var data = palette('tol', length)
        for(var a=0; a<length; a++)
        {
            if (data[a] !== null)
            {
                data[a] = "#"+data[a];
            }
        }
        return data;
    }
}

// console.log(palette('tol', 12));
// console.log(paletteRandom(25));
$(document).on("click touchend", ".pictoButton", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
    $('.picto').toggleClass('picOpen');
});
 
$(document).on("click touchend", ".picto", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
});

$(document).on("click touchend", ".pictoLink", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
    // $('.picto').toggleClass('picOpen');
});

$(document).on("click touchend", ".pictoGroupButton", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
    $('.modelsPicto').toggleClass('showModelsPicto');
    $('.modelsGroupPicto').toggleClass('hideModelsGroupPicto');
});

$(document).on("click touchend", ".modelBackButton", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
    $('.modelsPicto').removeClass('showModelsPicto');
    $('.modelsGroupPicto').removeClass('hideModelsGroupPicto');
    // $('.picto').toggleClass('picOpen');
});

$(document).click(function() {
    $('.picto').removeClass('picOpen');
});

$(document).on("click touchend", ".projectselectbutton", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
    $('.picto').removeClass('picOpen');
    $('.picto').toggleClass('picOpen');
});

$(document).on("click touchend", ".pictoitembut", function(evt) {
    evt.preventDefault();
    evt.stopPropagation(); //stops the document click action
    $('.picto').removeClass('picOpen');
});

var a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];

function inWords (num,only) {
    if ((num = num.toString()).length > 9) return 'overflow';
    var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + ( only ? 'only ' : '') : '';
    return str;
}

function deciInWords(num)
{
    num = num.toFixed(2);
    var n = num.split('.');
    var mainWord = inWords(n[0],false);
    if(Number(n[1]) > 1)
    {
        var paisaWord = inWords(n[1],false);
        var str = mainWord + ' and ' + paisaWord + 'paisa only';
        return str;
    }
    else
    {
        var paisaWord = inWords(n[1],false);
        var str = mainWord + ' only';
        return str;
    }
}


function issetnotempy(e) {
  return void 0 !== e && "" !== e ? !0 : !1
}

function issetnotempty(e) {
  return void 0 !== e && "" !== e ? !0 : !1
}

function isset(e)
{
  return (e !== undefined) ? true : false;
}

function empty() {
  return "";
}

function emptyarray()
{
  var a = [];
  return a;
}
function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
function iniFirstFocus()
{
    // $('#name').focus();
}

// setInterval(function(){
//     iniFirstFocus();
// },500);

// app.directive('tabMan', function() { ///directive
//     return {
//       restrict: 'A', /// accessible only by attribute
//       scope: {}, /// scope is not needed

//       link: function(scope, element, attrs) { ///link function to add key-down event on the target element

//         var gotoElement = function(grp, idx) {
//           /// get next element
//           var nextElement = $("input[tab-group='" + grp + "'][tab-index='" + idx + "']")[0];

//           /// if there is not next element then go to the 0 index
//           if (nextElement == undefined) {
//             if (idx != 0) { /// if the index is 0 then do not do any thing
//               gotoElement(grp, 0); /// restart the cycle
//             }
//           } else {
//             nextElement.focus(); /// succesfully give focus to the next
//           }

//         };

//         var tabIndex = attrs.tabIndex;
//         var tabGroup = attrs.tabGroup;

//         $(element).keydown(function(event) {

//           if (event.keyCode == 9) { /// go inside if tab key is pressed

//             var tIdx = $(event.target).attr("tab-index"); /// get the current index of element
//             var nextTid = parseInt(tIdx.toString()) + 1; /// get the next index of element
//             nextTid = Number(nextTid); /// turn the index into number

//             var tGrp = $(event.target).attr("tab-group"); /// get the group of the element

//             gotoElement(tGrp, nextTid); /// go to the next element

//             /// the work of tab is done by the directive so remove the default and stop the bubbeling
//             event.stopPropagation()
//             event.preventDefault();
//           }

//         });
//       }
//     };
//   });
function exportToExcel(item)
{
    var url='data:application/vnd.ms-excel,' + encodeURIComponent($(item).html());
    location.href=url;
    return false;
}
// register jQuery extension
jQuery.extend(jQuery.expr[':'], {
    focusable: function (el, index, selector) {
        return $(el).is('a, button, :input, [tabindex]');
    }
});

$(document).on('keypress', 'input,select', function (e) {
    if (e.which == 13) {
        e.preventDefault();
        // Get all focusable elements on the page
        var $canfocus = $(':focusable');
        if(e.shiftKey)
        {
            var index = $canfocus.index(document.activeElement) - 1;
        }
        else
        {
            var index = $canfocus.index(document.activeElement) + 1;
        }

        if($canfocus.eq(index)[0].readOnly === true)
        {
            do {
                index += 1;
            }
            while ($canfocus.eq(index)[0].readOnly === true);
        }

        if (index >= $canfocus.length) index = 0;
        $canfocus.eq(index).focus();
    }
});

// $(document).on('keypress', 'input,select', focusToRCNext);

// $(document).on("select2-close", focusToRCNext);

// function focusToRCNext(e) {

//     if (e.which == 13 || e.type === 'select2-close') {

//         e.preventDefault();
//         // Get all focusable elements on the page
//         var $canfocus = $(':focusable').filter(':visible');

//         var canFIndex = $canfocus.index(document.activeElement);

//         if($(document.activeElement).hasClass('select2-input'))
//         {
//             var labelId = $(document.activeElement).attr('id').replace('_search','');
//             var cfE = $("#"+labelId);
//             var ti = $canfocus.index(cfE);
//             canFIndex = ti;
//         }


//         if(e.shiftKey)
//         {
//             var index = canFIndex - 1;
//         }
//         else
//         {
//             var index = canFIndex + 1;
//         }        

//         if($canfocus.eq(index)[0].readOnly === true)
//         {
//             do {
//                 index += 1;
//             }
//             while ($canfocus.eq(index)[0].readOnly === true);
//         }

//         if (index >= $canfocus.length) index = 0;


//         if($canfocus.eq(index).hasClass('select2-choice'))
//         {
//             var nid = $canfocus.eq(index).parent().attr('id');
//             setTimeout(function(){
//                 $('#'+nid).select2('focus');
//             },100);
//         }
//         else
//         {
//             setTimeout(function(){
//                 $canfocus.eq(index).focus();
//             },100);
//         }

//     }
// }


// $(document).on('keypress', '.select2-input', function (e) {
//     console.log(e);
// });

// $(document).on('select2:closing', function(e) {
//     console.log(e);
// });
$(document).on("click", ".linkdropDown", function() {
  $(this).closest('div.btn-group').toggleClass('open');
});
function downloadTextfile(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function changeDTFilters()
{
  $('.dataTable').each(function(){
    if(!$(this).hasClass('rdFilterEnabled'))
    {
      var id = this.getAttribute('id');
      var table = $('#'+id).DataTable();
      $(this).addClass('rdFilterEnabled');
      $("#"+id+" thead th").each(function (i) {
        var title = $('#'+id+' thead th').eq($(this).index()).text();
        if ($(this).hasClass('selectfilter')) {
          $('<br>').appendTo(this);
          var select = $('<select><option value=""></option></select>')
            .appendTo(this)
            .on('click', function (e) {
              e.stopPropagation();
            })
            .on('change', function () {
              table.column(i)
                .search($(this).val())
                .draw();
            });

            table.column(i).data().unique().each(function (d, j) {
            select.append('<option value="' + d + '">' + d + '</option>')
          });
        } else if ($(this).hasClass('textfilter')) {
          $('<br>').appendTo(this);
          var text = $('<input type="text" style="height: 21px; width: 100%; display: block;" data-index="'+i+'" />')
            .appendTo(this)
            .on('click', function (e) {
              e.stopPropagation();
            })
            .on('keyup', function () {
              table.column(i)
                .search($(this).val())
                .draw();
            });
        }
      });
    }
  });
}

setInterval(changeDTFilters,1000);
function convertToHHMM(timenum)
{
  var decimalTimeString = timenum;
  var decimalTime = parseFloat(decimalTimeString);
  decimalTime = decimalTime * 60 * 60;
  var hours = Math.floor((decimalTime / (60 * 60)));
  decimalTime = decimalTime - (hours * 60 * 60);
  var minutes = Math.floor((decimalTime / 60));
  decimalTime = decimalTime - (minutes * 60);
  var seconds = Math.round(decimalTime);
  if(hours < 10)
  {
    hours = "0" + hours;
  }
  if(minutes < 10)
  {
    minutes = "0" + minutes;
  }
  if(seconds < 10)
  {
    seconds = "0" + seconds;
  }
  return "" + hours + " Hours " + minutes + " Minutes";
}

function convertToHM(timenum)
{
  var decimalTimeString = timenum;
  var decimalTime = parseFloat(decimalTimeString);
  decimalTime = decimalTime * 60 * 60;
  var hours = Math.floor((decimalTime / (60 * 60)));
  decimalTime = decimalTime - (hours * 60 * 60);
  var minutes = Math.floor((decimalTime / 60));
  decimalTime = decimalTime - (minutes * 60);
  var seconds = Math.round(decimalTime);
  if(hours < 10)
  {
    hours = "0" + hours;
  }
  if(minutes < 10)
  {
    minutes = "0" + minutes;
  }
  if(seconds < 10)
  {
    seconds = "0" + seconds;
  }
  return { hours : hours, minutes: minutes};
}
function offAutoComplete() {
    $('input').attr('autocomplete', 'off');
    $('select').attr('autocomplete', 'off');
    $('form').attr('autocomplete', 'off');
}

setInterval(offAutoComplete, 1000);


function dataTableClear() {
    $('.dataTable').each(function () {
        var id = this.getAttribute('id');
        var table = $('#' + id).DataTable();
        table.search( '' ).columns().search( '' ).draw();
    });
}

// function testF() {
//     var ar = document.querySelectorAll('input[type=search]');
//     for(var x=0; x<ar.length; x++)
//     {
//         var a = ar[x];
//         for(var key in a){
//             if(key.search('on') === 0) {
//                 a.addEventListener(key.slice(2), myFunction)
//             }
//         }
//     }
// }
// setInterval(testF, 100);

// function myFunction(e) { console.log(e); }
app.filter('slice', function() {
    return function(arr, start, end) {
        return (arr || []).slice(start, end);
    };
});
'use strict';


angular.module('app').filter('roundup', function () {
  return function (value) {
    if(value === 0 || value === '0')
    {
      return 1;
    }
    else
    {
      return Math.ceil(value);
    }
  };
});
'use strict';

/* Filters */
// need load the moment.js to use this filter. 
angular.module('app')
  .filter('fromNow', function() {
    return function(date) {
      return moment(date).fromNow();
    }
  }).filter('makePositive', function() {
    return function(num) { return Math.abs(Number(Math.round(num+'e2')+'e-2')); }
});

Array.prototype.sum = function (prop) {
    var total = 0
    for ( var i = 0, _len = this.length; i < _len; i++ ) {
        total += this[i][prop]
    }
    return total
};


app.filter('array_sum', function() {
    return function(arr, prop) {
        var total = 0
        for ( var i = 0, _len = arr.length; i < _len; i++ ) {
            total += arr[i][prop]
        }
        return total;
    };
});
angular.module('app')
  .directive('uiToggleClass', ['$timeout', '$document', function($timeout, $document) {
    return {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.on('click', function(e) {
          e.preventDefault();
          var classes = attr.uiToggleClass.split(','),
              targets = (attr.target && attr.target.split(',')) || Array(el),
              key = 0;
          angular.forEach(classes, function( _class ) {
            var target = targets[(targets.length && key)];
            $( target ).toggleClass(_class);
            key ++;
          });
          el.toggleClass('active');

        });
      }
    };
  }]);

'use strict';

/**
 * @ngdoc function
 * @name app.directive:uiScroll
 * @description
 * # uiScroll
 * Directive of the app
 */
angular.module('app')
  .directive('uiScroll', ['$location', '$anchorScroll', function($location, $anchorScroll) {
    return {
      restrict: 'AC',
      replace: true,
      link: function(scope, el, attr) {
        el.bind('click', function(e) {
          $location.hash(attr.uiScroll);
          $anchorScroll();
        });
      }
    };
  }]);
'use strict';

/**
 * @ngdoc function
 * @name app.directive:uiNav
 * @description
 * # uiScroll
 * Directive of the app
 */
angular.module('app')
  .directive('uiNav', ['$timeout', function($timeout) {
    return {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.find('a').bind('click', function(e) {
          var li = angular.element(this).parent();
          var active = li.parent()[0].querySelectorAll('.active');
          li.toggleClass('active');
          angular.element(active).removeClass('active');
        });
      }
    };
  }]);

'use strict';

angular.module('ui.jp', ['ui.load']).
  value('uiJpConfig', {}).
  directive('uiJp', ['uiJpConfig',  'uiLoad', '$timeout', function uiJpInjectingFunction(uiJpConfig,  uiLoad, $timeout) {

  return {
    restrict: 'A',
    compile: function uiJpCompilingFunction(tElm, tAttrs) {

      var options = uiJpConfig && uiJpConfig[tAttrs.uiJp];

      return function uiJpLinkingFunction(scope, elm, attrs) {

        function getOptions(){
          var linkOptions = [];

          // If ui-options are passed, merge (or override) them onto global defaults and pass to the jQuery method
          if (attrs.uiOptions) {
            linkOptions = scope.$eval('[' + attrs.uiOptions + ']');
            if (angular.isObject(options) && angular.isObject(linkOptions[0])) {
              linkOptions[0] = angular.extend({}, options, linkOptions[0]);
            }
          } else if (options) {
            linkOptions = [options];
          }
          return linkOptions;
        }

        // If change compatibility is enabled, the form input's "change" event will trigger an "input" event
        if (attrs.ngModel && elm.is('select,input,textarea')) {
          elm.bind('change', function() {
            elm.trigger('input');
          });
        }

        // Call jQuery method and pass relevant options
        function callPlugin() {
          $timeout(function() {
            $(elm)[attrs.uiJp].apply($(elm), getOptions());
          }, 0, false);
        }

        function refresh(){
          // If ui-refresh is used, re-fire the the method upon every change
          if (attrs.uiRefresh) {
            scope.$watch(attrs.uiRefresh, function() {
              callPlugin();
            });
          }
        }

        var jp = false;
        angular.forEach( function(module) {
          if( module.name == attrs.uiJp){
            jp = module.files;
          }
        });

        if ( jp ) {
          uiLoad.load(jp).then(function() {
            callPlugin();
            refresh();
          }).catch(function() {
            
          });
        } else {
          callPlugin();
          refresh();
        }
      };
    }
  };
}]);

'use strict';

/**
 * @ngdoc function
 * @name app.directive:uiFullscreen
 * @description
 * # uiFullscreen
 * Directive of the app
 */
angular.module('app')
  .directive('uiFullscreen', ['$document', function($document) {
    return {
      restrict: 'AC',
      link: function(scope, el, attr) {
        el.addClass('hide');
          if (screenfull.enabled) {
            el.removeClass('hide');
          } else{
            return;
          }
          el.bind('click', function(){
            var target;
            attr.target && ( target = angular.element(attr.target)[0] );
            screenfull.toggle(target);
          });

          var body = angular.element($document[0].body);
          $document.on(screenfull.raw.fullscreenchange, function () {
            if(screenfull.isFullscreen){
              body.addClass('fullscreen');
            }else{
              body.removeClass('fullscreen');
            }
          });
      }
    };
  }]);

// 'use strict';

// /**
//  * @ngdoc function
//  * @name app.directive:lazyload
//  * @description
//  * # uiScroll
//  * Directive of the app
//  */
// angular.module('app')
//   .directive('lazyLoad', ['$ocLazyLoad', '$compile', function( $ocLazyLoad, $compile) {
//     return {
//       restrict: 'A',
//       compile: function (el, attrs) {
//         var contents = el.contents().remove(), name;
//         return function(scope, el, attrs){
//           angular.forEach( function(module) {
//             if( module.name == attrs.lazyLoad){
//               if(!module.module){
//                 name = module.files;
//               }else{
//                 name = module.name;
//               }
//             }
//           });
//           $ocLazyLoad.load(name)
//           .then(function(){
//             $compile(contents)(scope, function(clonedElement, scope) {
//               el.append(clonedElement);
//             });
//           });
//         }
//       }
//     };
//   }])

angular.module('imageupload', [])
    .directive('image', function($q) {
        'use strict'

        var URL = window.URL || window.webkitURL;

        var getResizeArea = function () {
            var resizeAreaId = 'fileupload-resize-area';

            var resizeArea = document.getElementById(resizeAreaId);

            if (!resizeArea) {
                resizeArea = document.createElement('canvas');
                resizeArea.id = resizeAreaId;
                resizeArea.style.visibility = 'hidden';
                document.body.appendChild(resizeArea);
            }

            return resizeArea;
        }

        var resizeImage = function (origImage, options) {
            var maxHeight = options.resizeMaxHeight || 300;
            var maxWidth = options.resizeMaxWidth || 250;
            var quality = options.resizeQuality || 0.7;
            var type = options.resizeType || 'image/jpg';

            var canvas = getResizeArea();

            var height = origImage.height;
            var width = origImage.width;

            // calculate the width and height, constraining the proportions
            if (width > height) {
                if (width > maxWidth) {
                    height = Math.round(height *= maxWidth / width);
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width = Math.round(width *= maxHeight / height);
                    height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;

            //draw image on canvas
            var ctx = canvas.getContext("2d");
            ctx.drawImage(origImage, 0, 0, width, height);

            // get the data from canvas as 70% jpg (or specified type).
            return canvas.toDataURL(type, quality);
        };

        var createImage = function(url, callback) {
            var image = new Image();
            image.onload = function() {
                callback(image);
            };
            image.src = url;
        };

        var fileToDataURL = function (file) {
            var deferred = $q.defer();
            var reader = new FileReader();
            reader.onload = function (e) {
                deferred.resolve(e.target.result);
            };
            reader.readAsDataURL(file);
            return deferred.promise;
        };


        return {
            restrict: 'A',
            scope: {
                image: '=',
                resizeMaxHeight: '@?',
                resizeMaxWidth: '@?',
                resizeQuality: '@?',
                resizeType: '@?',
            },
            link: function postLink(scope, element, attrs, ctrl) {

                var doResizing = function(imageResult, callback) {
                    createImage(imageResult.url, function(image) {
                        var dataURL = resizeImage(image, scope);
                        imageResult.resized = {
                            dataURL: dataURL,
                            type: dataURL.match(/:(.+\/.+);/)[1],
                        };
                        callback(imageResult);
                    });
                };

                var applyScope = function(imageResult) {
                    scope.$apply(function() {
                        //console.log(imageResult);
                        if(attrs.multiple)
                            scope.image.push(imageResult);
                        else
                            scope.image = imageResult; 
                    });
                };


                element.bind('change', function (evt) {
                    //when multiple always return an array of images
                    if(attrs.multiple)
                        scope.image = [];

                    var files = evt.target.files;
                    for(var i = 0; i < files.length; i++) {
                        //create a result object for each file in files
                        var imageResult = {
                            file: files[i],
                            url: URL.createObjectURL(files[i])
                        };

                        fileToDataURL(files[i]).then(function (dataURL) {
                            imageResult.dataURL = dataURL;
                        });

                        if(scope.resizeMaxHeight || scope.resizeMaxWidth) { //resize image
                            doResizing(imageResult, function(imageResult) {
                                applyScope(imageResult);
                            });
                        }
                        else { //no resizing
                            applyScope(imageResult);
                        }
                    }
                });
            }
        };
    });
app.controller('XeditableCtrl', ['$scope', '$filter', '$http', 'editableOptions', 'editableThemes', 
  function($scope, $filter, $http, editableOptions, editableThemes){
    editableThemes.bs3.inputClass = 'input-sm';
    editableThemes.bs3.buttonsClass = 'btn-sm';
    editableOptions.theme = 'bs3';

    $scope.html5 = {
      email: 'email@example.com',
      tel: '123-45-67',
      number: 29,
      range: 10,
      url: 'http://example.com',
      search: 'blabla',
      color: '#6a4415',
      date: null,
      time: '12:30',
      datetime: null,
      month: null,
      week: null
    };

    $scope.user = {
    	name: 'awesome',
    	desc: 'Awesome user \ndescription!',
      status: 2,
      agenda: 1,
      remember: false
    }; 

    $scope.statuses = [
      {value: 1, text: 'status1'},
      {value: 2, text: 'status2'},
      {value: 3, text: 'status3'}
    ];

    $scope.agenda = [
      {value: 1, text: 'male'},
      {value: 2, text: 'female'}
    ];

    $scope.showStatus = function() {
      var selected = $filter('filter')($scope.statuses, {value: $scope.user.status});
      return ($scope.user.status && selected.length) ? selected[0].text : 'Not set';
    };

    $scope.showAgenda = function() {
      var selected = $filter('filter')($scope.agenda, {value: $scope.user.agenda});
      return ($scope.user.agenda && selected.length) ? selected[0].text : 'Not set';
    };

    // editable table
    $scope.users = [
      {id: 1, name: 'awesome user1', status: 2, group: 4, groupName: 'admin'},
      {id: 2, name: 'awesome user2', status: undefined, group: 3, groupName: 'vip'},
      {id: 3, name: 'awesome user3', status: 2, group: null}
    ];

    $scope.groups = [];
    $scope.loadGroups = function() {
      return $scope.groups.length ? null : $http.get('api/groups').success(function(data) {
        $scope.groups = data;
      });
    };

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else {
        return user.groupName || 'Not set';
      }
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user && user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };

    $scope.checkName = function(data, id) {
      if (id === 2 && data !== 'awesome') {
        return "Username 2 should be `awesome`";
      }
    };

    $scope.saveUser = function(data, id) {
      //$scope.user not updated yet
      angular.extend(data, {id: id});
      // return $http.post('api/saveUser', data);
    };

    // remove user
    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    // add user
    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null 
      };
      $scope.users.push($scope.inserted);
    };

}]);

app.controller('VectorMapCtrl', ['$scope', function ($scope) {
    $scope.world_markers = [
      {latLng: [41.90, 12.45], name: 'Vatican City'},
      {latLng: [43.93, 12.46], name: 'San Marino'},
      {latLng: [47.14, 9.52], name: 'Liechtenstein'},
      {latLng: [7.11, 171.06], name: 'Marshall Islands'},
      {latLng: [17.3, -62.73], name: 'Saint Kitts and Nevis'},
      {latLng: [3.2, 73.22], name: 'Maldives'},
      {latLng: [35.88, 14.5], name: 'Malta'},
      {latLng: [12.05, -61.75], name: 'Grenada'},
      {latLng: [13.16, -61.23], name: 'Saint Vincent and the Grenadines'},
      {latLng: [13.16, -59.55], name: 'Barbados'},
      {latLng: [17.11, -61.85], name: 'Antigua and Barbuda'},
      {latLng: [-4.61, 55.45], name: 'Seychelles'},
      {latLng: [7.35, 134.46], name: 'Palau'},
      {latLng: [42.5, 1.51], name: 'Andorra'}
    ];

    $scope.usa_markers = [
      {latLng: [40.71, -74.00], name: 'New York'},
      {latLng: [34.05, -118.24], name: 'Los Angeles'},
      {latLng: [41.87, -87.62], name: 'Chicago'},
      {latLng: [29.76, -95.36], name: 'Houston'},
      {latLng: [39.95, -75.16], name: 'Philadelphia'},
      {latLng: [38.90, -77.03], name: 'Washington'},
      {latLng: [37.36, -122.03], name: 'Silicon Valley'}
    ];

    $scope.cityAreaData = [      
      605.16,
      310.69,
      405.17,
      248.31,
      207.35,
      217.22,
      137.70,
      280.71,
      210.32,
      325.42
    ]

}]);
app.controller('UploadCtrl', ['$scope', 'FileUploader', function($scope, FileUploader) {
    var uploader = $scope.uploader = new FileUploader({
        url: 'scripts/controllers/upload.php'
    });

    // FILTERS

    uploader.filters.push({
        name: 'customFilter',
        fn: function(item /*{File|FileLikeObject}*/, options) {
            return this.queue.length < 10;
        }
    });

    // CALLBACKS

    uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
        console.info('onWhenAddingFileFailed', item, filter, options);
    };
    uploader.onAfterAddingFile = function(fileItem) {
        console.info('onAfterAddingFile', fileItem);
    };
    uploader.onAfterAddingAll = function(addedFileItems) {
        console.info('onAfterAddingAll', addedFileItems);
    };
    uploader.onBeforeUploadItem = function(item) {
        console.info('onBeforeUploadItem', item);
    };
    uploader.onProgressItem = function(fileItem, progress) {
        console.info('onProgressItem', fileItem, progress);
    };
    uploader.onProgressAll = function(progress) {
        console.info('onProgressAll', progress);
    };
    uploader.onSuccessItem = function(fileItem, response, status, headers) {
        console.info('onSuccessItem', fileItem, response, status, headers);
    };
    uploader.onErrorItem = function(fileItem, response, status, headers) {
        console.info('onErrorItem', fileItem, response, status, headers);
    };
    uploader.onCancelItem = function(fileItem, response, status, headers) {
        console.info('onCancelItem', fileItem, response, status, headers);
    };
    uploader.onCompleteItem = function(fileItem, response, status, headers) {
        console.info('onCompleteItem', fileItem, response, status, headers);
    };
    uploader.onCompleteAll = function() {
        console.info('onCompleteAll');
    };

    console.info('uploader', uploader);
}]);
app.controller('UiGridCtrl', ['$scope', 'uiGridConstants', function($scope, uiGridConstants) {
    $scope.gridOptionsSimple = {
        rowHeight: 36,
        data: [
          {
              "name": "Ethel Price",
              "gender": "female",
              "company": "Enersol"
          },
          {
              "name": "Claudine Neal",
              "gender": "female",
              "company": "Sealoud"
          },
          {
              "name": "Beryl Rice",
              "gender": "female",
              "company": "Velity"
          },
          {
              "name": "Wilder Gonzales",
              "gender": "male",
              "company": "Geekko"
          },
          {
              "name": "Georgina Schultz",
              "gender": "female",
              "company": "Suretech"
          },
          {
              "name": "Carroll Buchanan",
              "gender": "male",
              "company": "Ecosys"
          },
          {
              "name": "Valarie Atkinson",
              "gender": "female",
              "company": "Hopeli"
          },
          {
              "name": "Schroeder Mathews",
              "gender": "male",
              "company": "Polarium"
          },
          {
              "name": "Lynda Mendoza",
              "gender": "female",
              "company": "Dogspa"
          },
          {
              "name": "Sarah Massey",
              "gender": "female",
              "company": "Bisba"
          },
          {
              "name": "Robles Boyle",
              "gender": "male",
              "company": "Comtract"
          },
          {
              "name": "Evans Hickman",
              "gender": "male",
              "company": "Parleynet"
          },
          {
              "name": "Dawson Barber",
              "gender": "male",
              "company": "Dymi"
          },
          {
              "name": "Bruce Strong",
              "gender": "male",
              "company": "Xyqag"
          },
          {
              "name": "Nellie Whitfield",
              "gender": "female",
              "company": "Exospace"
          },
          {
              "name": "Jackson Macias",
              "gender": "male",
              "company": "Aquamate"
          },
          {
              "name": "Pena Pena",
              "gender": "male",
              "company": "Quarx"
          },
          {
              "name": "Lelia Gates",
              "gender": "female",
              "company": "Proxsoft"
          },
          {
              "name": "Letitia Vasquez",
              "gender": "female",
              "company": "Slumberia"
          },
          {
              "name": "Trevino Moreno",
              "gender": "male",
              "company": "Conjurica"
          }
        ]
      };
      
      $scope.gridOptionsComplex = {
        enableFiltering: true,
        showFooter: true,
        rowHeight: 36,
        columnDefs: [
          { name: 'name', aggregationType: uiGridConstants.aggregationTypes.count, width: 150 },
          { name: 'gender', filter: { term: 'male' }, width: 150, enableCellEdit: false, 
            cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) {
              if (grid.getCellValue(row,col) === 'male') {
                return 'blue';
              } else if (grid.getCellValue(row,col) === 'female') {
                return 'pink';
              }
            } 
          },
          { name: 'age', aggregationType: uiGridConstants.aggregationTypes.avg, width: 100 },
          { name: 'company', enableFiltering: false, width: 200 }
        ],
        data: [
          {
              "name": "Ethel Price",
              "gender": "female",
              "company": "Enersol",
              "age": 25
          },
          {
              "name": "Claudine Neal",
              "gender": "female",
              "company": "Sealoud",
              "age": 19
          },
          {
              "name": "Beryl Rice",
              "gender": "female",
              "company": "Velity",
              "age": 44
          },
          {
              "name": "Wilder Gonzales",
              "gender": "male",
              "company": "Geekko",
              "age": 26
          },
          {
              "name": "Georgina Schultz",
              "gender": "female",
              "company": "Suretech",
              "age": 53
          },
          {
              "name": "Carroll Buchanan",
              "gender": "male",
              "company": "Ecosys",
              "age": 64
          },
          {
              "name": "Valarie Atkinson",
              "gender": "female",
              "company": "Hopeli",
              "age": 35
          },
          {
              "name": "Schroeder Mathews",
              "gender": "male",
              "company": "Polarium",
              "age": 29
          },
          {
              "name": "Lynda Mendoza",
              "gender": "female",
              "company": "Dogspa",
              "age": 49
          },
          {
              "name": "Sarah Massey",
              "gender": "female",
              "company": "Bisba",
              "age": 40
          },
          {
              "name": "Robles Boyle",
              "gender": "male",
              "company": "Comtract",
              "age": 32
          },
          {
              "name": "Evans Hickman",
              "gender": "male",
              "company": "Parleynet",
              "age": 38
          },
          {
              "name": "Dawson Barber",
              "gender": "male",
              "company": "Dymi",
              "age": 21
          },
          {
              "name": "Bruce Strong",
              "gender": "male",
              "company": "Xyqag",
              "age": 61
          },
          {
              "name": "Nellie Whitfield",
              "gender": "female",
              "company": "Exospace",
              "age": 54
          },
          {
              "name": "Jackson Macias",
              "gender": "male",
              "company": "Aquamate",
              "age": 49
          },
          {
              "name": "Pena Pena",
              "gender": "male",
              "company": "Quarx",
              "age": 25
          },
          {
              "name": "Lelia Gates",
              "gender": "female",
              "company": "Proxsoft",
              "age": 54
          },
          {
              "name": "Alfred Oscar",
              "gender": "male",
              "company": "Transprop",
              "age": 34
          },
          {
              "name": "John Alfred",
              "gender": "male",
              "company": "Haymans",
              "age": 70
          },
          {
              "name": "Leonie Warren",
              "gender": "female",
              "company": "Hilltop",
              "age": 25
          },
          {
              "name": "Belinda Gosford",
              "gender": "female",
              "company": "Archison",
              "age": 42
          },
          {
              "name": "Tracey Misoni",
              "gender": "female",
              "company": "Verizona",
              "age": 34
          },
          {
              "name": "Trevino Moreno",
              "gender": "male",
              "company": "Conjurica",
              "age": 31
          }
        ]
      };
}]);

app.controller('TreeCtrl', ['$scope', '$timeout', function($scope, $timeout) {
  var apple_selected, tree, treedata_avm, treedata_geography;
  $scope.my_tree_handler = function(branch) {
    var _ref;
    $scope.output = "You selected: " + branch.label;
    if ((_ref = branch.data) != null ? _ref.description : void 0) {
      return $scope.output += '(' + branch.data.description + ')';
    }
  };
  apple_selected = function(branch) {
    return $scope.output = "APPLE! : " + branch.label;
  };
  treedata_avm = [
    {
      label: 'Animal',
      children: [
        {
          label: 'Dog',
          data: {
            description: "man's best friend"
          }
        }, {
          label: 'Cat',
          data: {
            description: "Felis catus"
          }
        }, {
          label: 'Hippopotamus',
          data: {
            description: "hungry, hungry"
          }
        }, {
          label: 'Chicken',
          children: ['White Leghorn', 'Rhode Island Red', 'Jersey Giant']
        }
      ]
    }, {
      label: 'Vegetable',
      data: {
        definition: "A plant or part of a plant used as food, typically as accompaniment to meat or fish, such as a cabbage, potato, carrot, or bean.",
        data_can_contain_anything: true
      },
      onSelect: function(branch) {
        return $scope.output = "Vegetable: " + branch.data.definition;
      },
      children: [
        {
          label: 'Oranges'
        }, {
          label: 'Apples',
          children: [
            {
              label: 'Granny Smith',
              onSelect: apple_selected
            }, {
              label: 'Red Delicous',
              onSelect: apple_selected
            }, {
              label: 'Fuji',
              onSelect: apple_selected
            }
          ]
        }
      ]
    }, {
      label: 'Mineral',
      children: [
        {
          label: 'Rock',
          children: ['Igneous', 'Sedimentary', 'Metamorphic']
        }, {
          label: 'Metal',
          children: ['Aluminum', 'Steel', 'Copper']
        }, {
          label: 'Plastic',
          children: [
            {
              label: 'Thermoplastic',
              children: ['polyethylene', 'polypropylene', 'polystyrene', ' polyvinyl chloride']
            }, {
              label: 'Thermosetting Polymer',
              children: ['polyester', 'polyurethane', 'vulcanized rubber', 'bakelite', 'urea-formaldehyde']
            }
          ]
        }
      ]
    }
  ];
  treedata_geography = [
    {
      label: 'North America',
      children: [
        {
          label: 'Canada',
          children: ['Toronto', 'Vancouver']
        }, {
          label: 'USA',
          children: ['New York', 'Los Angeles']
        }, {
          label: 'Mexico',
          children: ['Mexico City', 'Guadalajara']
        }
      ]
    }, {
      label: 'South America',
      children: [
        {
          label: 'Venezuela',
          children: ['Caracas', 'Maracaibo']
        }, {
          label: 'Brazil',
          children: ['Sao Paulo', 'Rio de Janeiro']
        }, {
          label: 'Argentina',
          children: ['Buenos Aires', 'Cordoba']
        }
      ]
    }
  ];
  $scope.my_data = treedata_avm;
  $scope.try_changing_the_tree_data = function() {
    if ($scope.my_data === treedata_avm) {
      return $scope.my_data = treedata_geography;
    } else {
      return $scope.my_data = treedata_avm;
    }
  };
  $scope.my_tree = tree = {};
  $scope.try_async_load = function() {
    $scope.my_data = [];
    $scope.doing_async = true;
    return $timeout(function() {
      if (Math.random() < 0.5) {
        $scope.my_data = treedata_avm;
      } else {
        $scope.my_data = treedata_geography;
      }
      $scope.doing_async = false;
      return tree.expand_all();
    }, 1000);
  };
  return $scope.try_adding_a_branch = function() {
    var b;
    b = tree.get_selected_branch();
    return tree.add_branch(b, {
      label: 'New Branch',
      data: {
        something: 42,
        "else": 43
      }
    });
  };
}]);
app.controller('TableCtrl', ['$scope', '$timeout', function($scope, $timeout) {
  $scope.rowCollectionBasic = [
      {firstName: 'Laurent', lastName: 'Renard', birthDate: new Date('1987-05-21'), balance: 102, email: 'whatever@gmail.com'},
      {firstName: 'Blandine', lastName: 'Faivre', birthDate: new Date('1987-04-25'), balance: -2323.22, email: 'oufblandou@gmail.com'},
      {firstName: 'Francoise', lastName: 'Frere', birthDate: new Date('1955-08-27'), balance: 42343, email: 'raymondef@gmail.com'}
  ];

  $scope.removeRow = function(row) {
      var index = $scope.rowCollectionBasic.indexOf(row);
      if (index !== -1) {
          $scope.rowCollectionBasic.splice(index, 1);
      }
  };

  $scope.predicates = ['firstName', 'lastName', 'birthDate', 'balance', 'email'];
  $scope.selectedPredicate = $scope.predicates[0];

  var firstnames = ['Laurent', 'Blandine', 'Olivier', 'Max'];
  var lastnames = ['Renard', 'Faivre', 'Frere', 'Eponge'];
  var dates = ['1987-05-21', '1987-04-25', '1955-08-27', '1966-06-06'];
  var id = 1;

  function generateRandomItem(id) {

      var firstname = firstnames[Math.floor(Math.random() * 3)];
      var lastname = lastnames[Math.floor(Math.random() * 3)];
      var birthdate = dates[Math.floor(Math.random() * 3)];
      var balance = Math.floor(Math.random() * 2000);

      return {
          id: id,
          firstName: firstname,
          lastName: lastname,
          birthDate: new Date(birthdate),
          balance: balance
      }
  }

  $scope.rowCollection = [];

  for (id; id < 5; id++) {
      $scope.rowCollection.push(generateRandomItem(id));
  }

  //copy the references (you could clone ie angular.copy but then have to go through a dirty checking for the matches)
  $scope.displayedCollection = [].concat($scope.rowCollection);

  //add to the real data holder
  $scope.addRandomItem = function addRandomItem() {
      $scope.rowCollection.push(generateRandomItem(id));
      id++;
  };

  //remove to the real data holder
  $scope.removeItem = function(row) {
      var index = $scope.rowCollection.indexOf(row);
      if (index !== -1) {
          $scope.rowCollection.splice(index, 1);
      }
  }

  //  pagination
  $scope.itemsByPage=10;

  $scope.rowCollectionPage = [];
  for (var j = 0; j < 200; j++) {
    $scope.rowCollectionPage.push(generateRandomItem(j));
  }

  // pip
  var promise = null;
  $scope.isLoading = false;
  $scope.rowCollectionPip = [];
  $scope.getPage = function() {
    $scope.rowCollectionPip=[];
    for (var j = 0; j < 20; j++) {
      $scope.rowCollectionPip.push(generateRandomItem(j));
    }
  }

  $scope.callServer = function getData(tableState) {
      //here you could create a query string from tableState
      //fake ajax call
      $scope.isLoading = true;

      $timeout(function () {
          $scope.getPage();
          $scope.isLoading = false;
      }, 2000);
  };

 $scope.getPage();

}]);
app.controller('SliderCtrl', function($scope) {
  $scope.cost = 40;
  $scope.range = {
    min: 30,
    max: 60
  };
  $scope.currencyFormatting = function(value) { 
    return"$"+value.toString();
  }
});
// this is a lazy load controller, 
// so start with "app." to register this controller

app.filter('propsFilter', function() {
    return function(items, props) {
        var out = [];

        if (angular.isArray(items)) {
          items.forEach(function(item) {
            var itemMatches = false;

            var keys = Object.keys(props);
            for (var i = 0; i < keys.length; i++) {
              var prop = keys[i];
              var text = props[prop].toLowerCase();
              if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                itemMatches = true;
                break;
              }
            }

            if (itemMatches) {
              out.push(item);
            }
          });
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
    };
});
app.controller('SelectCtrl', function($scope, $http, $timeout) {
        $scope.disabled = undefined;
        $scope.searchEnabled = undefined;

        $scope.enable = function() {
        $scope.disabled = false;
        };

        $scope.disable = function() {
        $scope.disabled = true;
        };

        $scope.enableSearch = function() {
        $scope.searchEnabled = true;
        }

        $scope.disableSearch = function() {
        $scope.searchEnabled = false;
        }

        $scope.clear = function() {
        $scope.person.selected = undefined;
        $scope.address.selected = undefined;
        $scope.country.selected = undefined;
        };

        $scope.someGroupFn = function (item){

        if (item.name[0] >= 'A' && item.name[0] <= 'M')
            return 'From A - M';

        if (item.name[0] >= 'N' && item.name[0] <= 'Z')
            return 'From N - Z';

        };

        $scope.personAsync = {selected : "wladimir@email.com"};
        $scope.peopleAsync = [];

        $timeout(function(){
        $scope.peopleAsync = [
            { name: 'Adam',      email: 'adam@email.com',      age: 12, country: 'United States' },
            { name: 'Amalie',    email: 'amalie@email.com',    age: 12, country: 'Argentina' },
            { name: 'Estefanía', email: 'estefania@email.com', age: 21, country: 'Argentina' },
            { name: 'Adrian',    email: 'adrian@email.com',    age: 21, country: 'Ecuador' },
            { name: 'Wladimir',  email: 'wladimir@email.com',  age: 30, country: 'Ecuador' },
            { name: 'Samantha',  email: 'samantha@email.com',  age: 30, country: 'United States' },
            { name: 'Nicole',    email: 'nicole@email.com',    age: 43, country: 'Colombia' },
            { name: 'Natasha',   email: 'natasha@email.com',   age: 54, country: 'Ecuador' },
            { name: 'Michael',   email: 'michael@email.com',   age: 15, country: 'Colombia' },
            { name: 'Nicolás',   email: 'nicole@email.com',    age: 43, country: 'Colombia' }
          ];
        },3000);

        $scope.counter = 0;
        $scope.someFunction = function (item, model){
        $scope.counter++;
        $scope.eventResult = {item: item, model: model};
        };

        $scope.removed = function (item, model) {
        $scope.lastRemoved = {
            item: item,
            model: model
        };
        };

        $scope.person = {};
        $scope.people = [
        { name: 'Adam',      email: 'adam@email.com',      age: 12, country: 'United States' },
        { name: 'Amalie',    email: 'amalie@email.com',    age: 12, country: 'Argentina' },
        { name: 'Estefanía', email: 'estefania@email.com', age: 21, country: 'Argentina' },
        { name: 'Adrian',    email: 'adrian@email.com',    age: 21, country: 'Ecuador' },
        { name: 'Wladimir',  email: 'wladimir@email.com',  age: 30, country: 'Ecuador' },
        { name: 'Samantha',  email: 'samantha@email.com',  age: 30, country: 'United States' },
        { name: 'Nicole',    email: 'nicole@email.com',    age: 43, country: 'Colombia' },
        { name: 'Natasha',   email: 'natasha@email.com',   age: 54, country: 'Ecuador' },
        { name: 'Michael',   email: 'michael@email.com',   age: 15, country: 'Colombia' },
        { name: 'Nicolás',   email: 'nicolas@email.com',    age: 43, country: 'Colombia' }
        ];

        $scope.availableColors = ['Red','Green','Blue','Yellow','Magenta','Maroon','Umbra','Turquoise'];

        $scope.multipleDemo = {};
        $scope.multipleDemo.colors = ['Blue','Red'];
        $scope.multipleDemo.selectedPeople = [$scope.people[5], $scope.people[4]];
        $scope.multipleDemo.selectedPeopleWithGroupBy = [$scope.people[8], $scope.people[6]];
        $scope.multipleDemo.selectedPeopleSimple = ['samantha@email.com','wladimir@email.com'];


        $scope.address = {};
        $scope.refreshAddresses = function(address) {
            var params = {address: address, sensor: false};
            return $http.get(
              'http://maps.googleapis.com/maps/api/geocode/json',
              {params: params}
            ).then(function(response) {
              $scope.addresses = response.data.results;
            });
        };

        $scope.country = {};
        $scope.countries = [ // Taken from https://gist.github.com/unceus/6501985
        {name: 'Afghanistan', code: 'AF'},
        {name: 'Åland Islands', code: 'AX'},
        {name: 'Albania', code: 'AL'},
        {name: 'Algeria', code: 'DZ'},
        {name: 'American Samoa', code: 'AS'},
        {name: 'Andorra', code: 'AD'},
        {name: 'Angola', code: 'AO'},
        {name: 'Anguilla', code: 'AI'},
        {name: 'Antarctica', code: 'AQ'},
        {name: 'Antigua and Barbuda', code: 'AG'},
        {name: 'Argentina', code: 'AR'},
        {name: 'Armenia', code: 'AM'},
        {name: 'Aruba', code: 'AW'},
        {name: 'Australia', code: 'AU'},
        {name: 'Austria', code: 'AT'},
        {name: 'Azerbaijan', code: 'AZ'},
        {name: 'Bahamas', code: 'BS'},
        {name: 'Bahrain', code: 'BH'},
        {name: 'Bangladesh', code: 'BD'},
        {name: 'Barbados', code: 'BB'},
        {name: 'Belarus', code: 'BY'},
        {name: 'Belgium', code: 'BE'},
        {name: 'Belize', code: 'BZ'},
        {name: 'Benin', code: 'BJ'},
        {name: 'Bermuda', code: 'BM'},
        {name: 'Bhutan', code: 'BT'},
        {name: 'Bolivia', code: 'BO'},
        {name: 'Bosnia and Herzegovina', code: 'BA'},
        {name: 'Botswana', code: 'BW'},
        {name: 'Bouvet Island', code: 'BV'},
        {name: 'Brazil', code: 'BR'},
        {name: 'British Indian Ocean Territory', code: 'IO'},
        {name: 'Brunei Darussalam', code: 'BN'},
        {name: 'Bulgaria', code: 'BG'},
        {name: 'Burkina Faso', code: 'BF'},
        {name: 'Burundi', code: 'BI'},
        {name: 'Cambodia', code: 'KH'},
        {name: 'Cameroon', code: 'CM'},
        {name: 'Canada', code: 'CA'},
        {name: 'Cape Verde', code: 'CV'},
        {name: 'Cayman Islands', code: 'KY'},
        {name: 'Central African Republic', code: 'CF'},
        {name: 'Chad', code: 'TD'},
        {name: 'Chile', code: 'CL'},
        {name: 'China', code: 'CN'},
        {name: 'Christmas Island', code: 'CX'},
        {name: 'Cocos (Keeling) Islands', code: 'CC'},
        {name: 'Colombia', code: 'CO'},
        {name: 'Comoros', code: 'KM'},
        {name: 'Congo', code: 'CG'},
        {name: 'Congo, The Democratic Republic of the', code: 'CD'},
        {name: 'Cook Islands', code: 'CK'},
        {name: 'Costa Rica', code: 'CR'},
        {name: 'Cote D\'Ivoire', code: 'CI'},
        {name: 'Croatia', code: 'HR'},
        {name: 'Cuba', code: 'CU'},
        {name: 'Cyprus', code: 'CY'},
        {name: 'Czech Republic', code: 'CZ'},
        {name: 'Denmark', code: 'DK'},
        {name: 'Djibouti', code: 'DJ'},
        {name: 'Dominica', code: 'DM'},
        {name: 'Dominican Republic', code: 'DO'},
        {name: 'Ecuador', code: 'EC'},
        {name: 'Egypt', code: 'EG'},
        {name: 'El Salvador', code: 'SV'},
        {name: 'Equatorial Guinea', code: 'GQ'},
        {name: 'Eritrea', code: 'ER'},
        {name: 'Estonia', code: 'EE'},
        {name: 'Ethiopia', code: 'ET'},
        {name: 'Falkland Islands (Malvinas)', code: 'FK'},
        {name: 'Faroe Islands', code: 'FO'},
        {name: 'Fiji', code: 'FJ'},
        {name: 'Finland', code: 'FI'},
        {name: 'France', code: 'FR'},
        {name: 'French Guiana', code: 'GF'},
        {name: 'French Polynesia', code: 'PF'},
        {name: 'French Southern Territories', code: 'TF'},
        {name: 'Gabon', code: 'GA'},
        {name: 'Gambia', code: 'GM'},
        {name: 'Georgia', code: 'GE'},
        {name: 'Germany', code: 'DE'},
        {name: 'Ghana', code: 'GH'},
        {name: 'Gibraltar', code: 'GI'},
        {name: 'Greece', code: 'GR'},
        {name: 'Greenland', code: 'GL'},
        {name: 'Grenada', code: 'GD'},
        {name: 'Guadeloupe', code: 'GP'},
        {name: 'Guam', code: 'GU'},
        {name: 'Guatemala', code: 'GT'},
        {name: 'Guernsey', code: 'GG'},
        {name: 'Guinea', code: 'GN'},
        {name: 'Guinea-Bissau', code: 'GW'},
        {name: 'Guyana', code: 'GY'},
        {name: 'Haiti', code: 'HT'},
        {name: 'Heard Island and Mcdonald Islands', code: 'HM'},
        {name: 'Holy See (Vatican City State)', code: 'VA'},
        {name: 'Honduras', code: 'HN'},
        {name: 'Hong Kong', code: 'HK'},
        {name: 'Hungary', code: 'HU'},
        {name: 'Iceland', code: 'IS'},
        {name: 'India', code: 'IN'},
        {name: 'Indonesia', code: 'ID'},
        {name: 'Iran, Islamic Republic Of', code: 'IR'},
        {name: 'Iraq', code: 'IQ'},
        {name: 'Ireland', code: 'IE'},
        {name: 'Isle of Man', code: 'IM'},
        {name: 'Israel', code: 'IL'},
        {name: 'Italy', code: 'IT'},
        {name: 'Jamaica', code: 'JM'},
        {name: 'Japan', code: 'JP'},
        {name: 'Jersey', code: 'JE'},
        {name: 'Jordan', code: 'JO'},
        {name: 'Kazakhstan', code: 'KZ'},
        {name: 'Kenya', code: 'KE'},
        {name: 'Kiribati', code: 'KI'},
        {name: 'Korea, Democratic People\'s Republic of', code: 'KP'},
        {name: 'Korea, Republic of', code: 'KR'},
        {name: 'Kuwait', code: 'KW'},
        {name: 'Kyrgyzstan', code: 'KG'},
        {name: 'Lao People\'s Democratic Republic', code: 'LA'},
        {name: 'Latvia', code: 'LV'},
        {name: 'Lebanon', code: 'LB'},
        {name: 'Lesotho', code: 'LS'},
        {name: 'Liberia', code: 'LR'},
        {name: 'Libyan Arab Jamahiriya', code: 'LY'},
        {name: 'Liechtenstein', code: 'LI'},
        {name: 'Lithuania', code: 'LT'},
        {name: 'Luxembourg', code: 'LU'},
        {name: 'Macao', code: 'MO'},
        {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
        {name: 'Madagascar', code: 'MG'},
        {name: 'Malawi', code: 'MW'},
        {name: 'Malaysia', code: 'MY'},
        {name: 'Maldives', code: 'MV'},
        {name: 'Mali', code: 'ML'},
        {name: 'Malta', code: 'MT'},
        {name: 'Marshall Islands', code: 'MH'},
        {name: 'Martinique', code: 'MQ'},
        {name: 'Mauritania', code: 'MR'},
        {name: 'Mauritius', code: 'MU'},
        {name: 'Mayotte', code: 'YT'},
        {name: 'Mexico', code: 'MX'},
        {name: 'Micronesia, Federated States of', code: 'FM'},
        {name: 'Moldova, Republic of', code: 'MD'},
        {name: 'Monaco', code: 'MC'},
        {name: 'Mongolia', code: 'MN'},
        {name: 'Montserrat', code: 'MS'},
        {name: 'Morocco', code: 'MA'},
        {name: 'Mozambique', code: 'MZ'},
        {name: 'Myanmar', code: 'MM'},
        {name: 'Namibia', code: 'NA'},
        {name: 'Nauru', code: 'NR'},
        {name: 'Nepal', code: 'NP'},
        {name: 'Netherlands', code: 'NL'},
        {name: 'Netherlands Antilles', code: 'AN'},
        {name: 'New Caledonia', code: 'NC'},
        {name: 'New Zealand', code: 'NZ'},
        {name: 'Nicaragua', code: 'NI'},
        {name: 'Niger', code: 'NE'},
        {name: 'Nigeria', code: 'NG'},
        {name: 'Niue', code: 'NU'},
        {name: 'Norfolk Island', code: 'NF'},
        {name: 'Northern Mariana Islands', code: 'MP'},
        {name: 'Norway', code: 'NO'},
        {name: 'Oman', code: 'OM'},
        {name: 'Pakistan', code: 'PK'},
        {name: 'Palau', code: 'PW'},
        {name: 'Palestinian Territory, Occupied', code: 'PS'},
        {name: 'Panama', code: 'PA'},
        {name: 'Papua New Guinea', code: 'PG'},
        {name: 'Paraguay', code: 'PY'},
        {name: 'Peru', code: 'PE'},
        {name: 'Philippines', code: 'PH'},
        {name: 'Pitcairn', code: 'PN'},
        {name: 'Poland', code: 'PL'},
        {name: 'Portugal', code: 'PT'},
        {name: 'Puerto Rico', code: 'PR'},
        {name: 'Qatar', code: 'QA'},
        {name: 'Reunion', code: 'RE'},
        {name: 'Romania', code: 'RO'},
        {name: 'Russian Federation', code: 'RU'},
        {name: 'Rwanda', code: 'RW'},
        {name: 'Saint Helena', code: 'SH'},
        {name: 'Saint Kitts and Nevis', code: 'KN'},
        {name: 'Saint Lucia', code: 'LC'},
        {name: 'Saint Pierre and Miquelon', code: 'PM'},
        {name: 'Saint Vincent and the Grenadines', code: 'VC'},
        {name: 'Samoa', code: 'WS'},
        {name: 'San Marino', code: 'SM'},
        {name: 'Sao Tome and Principe', code: 'ST'},
        {name: 'Saudi Arabia', code: 'SA'},
        {name: 'Senegal', code: 'SN'},
        {name: 'Serbia and Montenegro', code: 'CS'},
        {name: 'Seychelles', code: 'SC'},
        {name: 'Sierra Leone', code: 'SL'},
        {name: 'Singapore', code: 'SG'},
        {name: 'Slovakia', code: 'SK'},
        {name: 'Slovenia', code: 'SI'},
        {name: 'Solomon Islands', code: 'SB'},
        {name: 'Somalia', code: 'SO'},
        {name: 'South Africa', code: 'ZA'},
        {name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
        {name: 'Spain', code: 'ES'},
        {name: 'Sri Lanka', code: 'LK'},
        {name: 'Sudan', code: 'SD'},
        {name: 'Suriname', code: 'SR'},
        {name: 'Svalbard and Jan Mayen', code: 'SJ'},
        {name: 'Swaziland', code: 'SZ'},
        {name: 'Sweden', code: 'SE'},
        {name: 'Switzerland', code: 'CH'},
        {name: 'Syrian Arab Republic', code: 'SY'},
        {name: 'Taiwan, Province of China', code: 'TW'},
        {name: 'Tajikistan', code: 'TJ'},
        {name: 'Tanzania, United Republic of', code: 'TZ'},
        {name: 'Thailand', code: 'TH'},
        {name: 'Timor-Leste', code: 'TL'},
        {name: 'Togo', code: 'TG'},
        {name: 'Tokelau', code: 'TK'},
        {name: 'Tonga', code: 'TO'},
        {name: 'Trinidad and Tobago', code: 'TT'},
        {name: 'Tunisia', code: 'TN'},
        {name: 'Turkey', code: 'TR'},
        {name: 'Turkmenistan', code: 'TM'},
        {name: 'Turks and Caicos Islands', code: 'TC'},
        {name: 'Tuvalu', code: 'TV'},
        {name: 'Uganda', code: 'UG'},
        {name: 'Ukraine', code: 'UA'},
        {name: 'United Arab Emirates', code: 'AE'},
        {name: 'United Kingdom', code: 'GB'},
        {name: 'United States', code: 'US'},
        {name: 'United States Minor Outlying Islands', code: 'UM'},
        {name: 'Uruguay', code: 'UY'},
        {name: 'Uzbekistan', code: 'UZ'},
        {name: 'Vanuatu', code: 'VU'},
        {name: 'Venezuela', code: 'VE'},
        {name: 'Vietnam', code: 'VN'},
        {name: 'Virgin Islands, British', code: 'VG'},
        {name: 'Virgin Islands, U.S.', code: 'VI'},
        {name: 'Wallis and Futuna', code: 'WF'},
        {name: 'Western Sahara', code: 'EH'},
        {name: 'Yemen', code: 'YE'},
        {name: 'Zambia', code: 'ZM'},
        {name: 'Zimbabwe', code: 'ZW'}
        ];
});

app.controller('NGGridCtrl', ['$scope', '$http', function($scope, $http) {
    $scope.filterOptions = {
        filterText: "",
        useExternalFilter: true
    }; 
    $scope.totalServerItems = 0;
    $scope.pagingOptions = {
        pageSizes: [250, 500, 1000],
        pageSize: 250,
        currentPage: 1
    };  
    $scope.setPagingData = function(data, page, pageSize){  
        var pagedData = data.slice((page - 1) * pageSize, page * pageSize);
        $scope.myData = pagedData;
        $scope.totalServerItems = data.length;
        if (!$scope.$$phase) {
            $scope.$apply();
        }
    };
    $scope.getPagedDataAsync = function (pageSize, page, searchText) {
        setTimeout(function () {
            var data;
            if (searchText) {
                var ft = searchText.toLowerCase();
                $http.get('scripts/controllers/largeLoad.json').success(function (largeLoad) {    
                    data = largeLoad.filter(function(item) {
                        return JSON.stringify(item).toLowerCase().indexOf(ft) != -1;
                    });
                    $scope.setPagingData(data,page,pageSize);
                });            
            } else {
                $http.get('scripts/controllers/largeLoad.json').success(function (largeLoad) {
                    $scope.setPagingData(largeLoad,page,pageSize);
                });
            }
        }, 100);
    };

    $scope.getPagedDataAsync($scope.pagingOptions.pageSize, $scope.pagingOptions.currentPage);

    $scope.$watch('pagingOptions', function (newVal, oldVal) {
        if (newVal !== oldVal && newVal.currentPage !== oldVal.currentPage) {
          $scope.getPagedDataAsync($scope.pagingOptions.pageSize, $scope.pagingOptions.currentPage, $scope.filterOptions.filterText);
        }
    }, true);
    $scope.$watch('filterOptions', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          $scope.getPagedDataAsync($scope.pagingOptions.pageSize, $scope.pagingOptions.currentPage, $scope.filterOptions.filterText);
        }
    }, true);

    $scope.gridOptions = {
        data: 'myData',
        enablePaging: true,
        showFooter: true,
        rowHeight: 36,
        headerRowHeight: 36,
        totalServerItems: 'totalServerItems',
        pagingOptions: $scope.pagingOptions,
        filterOptions: $scope.filterOptions
    };
}]);

app.controller('MDAutocompleteCtrl', function($scope, $timeout, $q) {
  var self = this;

  // list of `state` value/display objects
  self.states        = loadAll();
  self.selectedItem  = null;
  self.searchText    = null;
  self.querySearch   = querySearch;
  self.simulateQuery = false;
  self.isDisabled    = false;

  // ******************************
  // Internal methods
  // ******************************

  /**
   * Search for states... use $timeout to simulate
   * remote dataservice call.
   */
  function querySearch (query) {
    var results = query ? self.states.filter( createFilterFor(query) ) : [],
        deferred;
    if (self.simulateQuery) {
      deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    } else {
      return results;
    }
  }

  /**
   * Build `states` list of key/value pairs
   */
  function loadAll() {
    var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
            Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
            Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
            Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
            North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
            South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
            Wisconsin, Wyoming';

    return allStates.split(/, +/g).map( function (state) {
      return {
        value: state.toLowerCase(),
        display: state
      };
    });
  }

  /**
   * Create filter function for a query string
   */
  function createFilterFor(query) {
    var lowercaseQuery = angular.lowercase(query);

    return function filterFn(state) {
      return (state.value.indexOf(lowercaseQuery) === 0);
    };

  }
});

app.controller('MDBottomSheetCtrl', function($scope, $timeout, $mdBottomSheet) {
  $scope.alert = '';

  $scope.showListBottomSheet = function($event) {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-list-template.html',
      controller: 'ListBottomSheetCtrl',
      targetEvent: $event
    }).then(function(clickedItem) {
      $scope.alert = clickedItem.name + ' clicked!';
    });
  };

  $scope.showGridBottomSheet = function($event) {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-grid-template.html',
      controller: 'GridBottomSheetCtrl',
      targetEvent: $event
    }).then(function(clickedItem) {
      $scope.alert = clickedItem.name + ' clicked!';
    });
  };
});

app.controller('MDListBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Share', icon: 'share' },
    { name: 'Upload', icon: 'upload' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Print this page', icon: 'print' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
});

app.controller('MDGridBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Hangout', icon: 'hangout' },
    { name: 'Mail', icon: 'mail' },
    { name: 'Message', icon: 'message' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Facebook', icon: 'facebook' },
    { name: 'Twitter', icon: 'twitter' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
});

app.controller('MDCheckboxCtrl', function($scope) {

  $scope.data = {};
  $scope.data.cb1 = true;
  $scope.data.cb2 = false;
  $scope.data.cb3 = false;
  $scope.data.cb4 = false;
  $scope.data.cb5 = false;

});

app.controller('MDRadioCtrl', function($scope) {

    $scope.data = {
      group1 : 'Banana',
      group2 : '2',
      group3 : 'avatar-1'
    };

    $scope.avatarData = [{
        id: "svg-1",
        title: 'avatar 1',
        value: 'avatar-1'
      },{
        id: "svg-2",
        title: 'avatar 2',
        value: 'avatar-2'
      },{
        id: "svg-3",
        title: 'avatar 3',
        value: 'avatar-3'
    }];

    $scope.radioData = [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: '3', isDisabled: true },
      { label: '4', value: '4' }
    ];


    $scope.submit = function() {
      alert('submit');
    };

    $scope.addItem = function() {
      var r = Math.ceil(Math.random() * 1000);
      $scope.radioData.push({ label: r, value: r });
    };

    $scope.removeItem = function() {
      $scope.radioData.pop();
    };

});

app.controller('MDSwitchCtrl', function($scope) {
  $scope.data = {
    cb1: true,
    cb4: true
  };
  
  $scope.onChange = function(cbState){
     $scope.message = "The switch is now: " + cbState;
  };
});

app.controller('MDDialogCtrl', function($scope, $mdDialog) {
  $scope.alert = '';

  $scope.showAlert = function(ev) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('This is an alert title')
        .content('You can specify some description text in here.')
        .ariaLabel('Password notification')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    var confirm = $mdDialog.confirm()
      .title('Would you like to delete your debt?')
      .content('All of the banks have agreed to forgive you your debts.')
      .ariaLabel('Lucky day')
      .ok('Please do it!')
      .cancel('Sounds like a scam')
      .targetEvent(ev);

    $mdDialog.show(confirm).then(function() {
      $scope.alert = 'You decided to get rid of your debt.';
    }, function() {
      $scope.alert = 'You decided to keep your debt.';
    });
  };

  $scope.showAdvanced = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'views/ui/material/dialog.tmpl.html',
      targetEvent: ev,
    })
    .then(function(answer) {
      $scope.alert = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.alert = 'You cancelled the dialog.';
    });
  };
});

function DialogController($scope, $mdDialog) {
  $scope.hide = function() {
    $mdDialog.hide();
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
};

app.controller('MDSliderCtrl', function($scope) {

  $scope.color = {
    red: Math.floor(Math.random() * 255),
    green: Math.floor(Math.random() * 255),
    blue: Math.floor(Math.random() * 255)
  };

  $scope.rating1 = 3;
  $scope.rating2 = 2;
  $scope.rating3 = 4;

  $scope.disabled1 = 0;
  $scope.disabled2 = 70;

});



app.controller('MDSelectCtrl', function($timeout, $scope) {
  $scope.neighborhoods = ['Chelsea', 'Financial District', 'Midtown', 'West Village', 'Williamsburg'];

  $scope.toppings = [
    { category: 'meat', name: 'Pepperoni' },
    { category: 'meat', name: 'Sausage' },
    { category: 'meat', name: 'Ground Beef' },
    { category: 'meat', name: 'Bacon' },
    { category: 'veg', name: 'Mushrooms' },
    { category: 'veg', name: 'Onion' },
    { category: 'veg', name: 'Green Pepper' },
    { category: 'veg', name: 'Green Olives' },
  ];

  $scope.loadUsers = function() {
    // Use timeout to simulate a 650ms request.
    $scope.users = [];
    return $timeout(function() {
      $scope.users = [
        { id: 1, name: 'Scooby Doo' },
        { id: 2, name: 'Shaggy Rodgers' },
        { id: 3, name: 'Fred Jones' },
        { id: 4, name: 'Daphne Blake' },
        { id: 5, name: 'Velma Dinkley' },
      ];
    }, 650);
  };
});

app.controller('MDInputCtrl', function($scope) {
  $scope.user = {
    title: 'Developer',
    email: 'ipsum@lorem.com',
    firstName: '',
    lastName: '' ,
    company: 'Google' ,
    address: '1600 Amphitheatre Pkwy' ,
    city: 'Mountain View' ,
    state: 'CA' ,
    biography: 'Loves kittens, snowboarding, and can type at 130 WPM.\n\nAnd rumor has it she bouldered up Castle Craig!',
    postalCode : '94043'
  };
  $scope.project = {
    description: 'Nuclear Missile Defense System',
    clientName: 'Bill Clinton',
    rate: 500
  };
});

app.controller('MDProgressCtrl', ['$scope', '$interval', function($scope, $interval) {
    $scope.mode = 'query';
    $scope.determinateValue = 30;
    $scope.determinateValue2 = 30;

    $interval(function() {
      $scope.determinateValue += 1;
      $scope.determinateValue2 += 1.5;
      if ($scope.determinateValue > 100) {
        $scope.determinateValue = 30;
        $scope.determinateValue2 = 30;
      }
    }, 100, 0, true);

    $interval(function() {
      $scope.mode = ($scope.mode == 'query' ? 'determinate' : 'query');
    }, 7200, 0, true);
}]);

app.controller('MDSidenavCtrl', function($scope, $timeout, $mdSidenav, $log) {
  $scope.toggleLeft = function() {
    $mdSidenav('left').toggle()
                      .then(function(){
                          $log.debug("toggle left is done");
                      });
  };
  $scope.toggleRight = function() {
    $mdSidenav('right').toggle()
                        .then(function(){
                          $log.debug("toggle RIGHT is done");
                        });
  };
  $scope.closeLeft = function() {
    $mdSidenav('left').close()
                      .then(function(){
                        $log.debug("close LEFT is done");
                      });

  };
  $scope.closeRight = function() {
    $mdSidenav('right').close()
                        .then(function(){
                          $log.debug("close RIGHT is done");
                        });
  };
});

app.controller('MDSubheaderCtrl', function($scope) {
    $scope.messages = [
      {
        face : 'images/a0.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a1.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a2.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a3.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a4.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a5.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a6.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a7.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a8.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a9.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : 'images/a0.jpg',
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});

app.controller('MDTabCtrl', function( $scope ) {

    $scope.data = {
      selectedIndex : 0,
      secondLocked : true,
      secondLabel : "Item Two"
    };

    $scope.next = function() {
      $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
    };

    $scope.previous = function() {
      $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
    };

    var tabs = [
      { title: 'One', content: "Tabs will become paginated if there isn't enough room for them."},
      { title: 'Two', content: "You can swipe left and right on a mobile device to change tabs."},
      { title: 'Three', content: "You can bind the selected tab via the selected attribute on the md-tabs element."},
      { title: 'Four', content: "If you set the selected tab binding to -1, it will leave no tab selected."},
      { title: 'Five', content: "If you remove a tab, it will try to select a new one."},
      { title: 'Six', content: "There's an ink bar that follows the selected tab, you can turn it off if you want."},
      { title: 'Seven', content: "If you set ng-disabled on a tab, it becomes unselectable. If the currently selected tab becomes disabled, it will try to select the next tab."},
      { title: 'Eight', content: "If you look at the source, you're using tabs to look at a demo for tabs. Recursion!"},
      { title: 'Nine', content: "If you set md-theme=\"green\" on the md-tabs element, you'll get green tabs."},
      { title: 'Ten', content: "If you're still reading this, you should just go check out the API docs for tabs!"}
    ];

    $scope.tabs = tabs;
    $scope.selectedIndex = 2;

    $scope.addTab = function (title, view) {
      view = view || title + " Content View";
      tabs.push({ title: title, content: view, disabled: false});
    };

    $scope.removeTab = function (tab) {
      for (var j = 0; j < tabs.length; j++) {
        if (tab.title == tabs[j].title) {
          $scope.tabs.splice(j, 1);
          break;
        }
      }
    };
    
});

app.controller('MDToastCtrl', function($scope, $mdToast, $animate) {

  $scope.toastPosition = {
    bottom: false,
    top: true,
    left: false,
    right: true
  };

  $scope.getToastPosition = function() {
    return Object.keys($scope.toastPosition)
      .filter(function(pos) { return $scope.toastPosition[pos]; })
      .join(' ');
  };

  $scope.showCustomToast = function() {
    $mdToast.show({
      controller: 'ToastCtrl',
      templateUrl: 'views/ui/material/toast.tmpl.html',
      hideDelay: 6000,
      parent:'#toast',
      position: $scope.getToastPosition()
    });
  };

  $scope.showSimpleToast = function() {
    $mdToast.show(
      $mdToast.simple()
        .content('Simple Toast!')
        .position($scope.getToastPosition())
        .hideDelay(3000)
    );
  };

  $scope.showActionToast = function() {
    var toast = $mdToast.simple()
          .content('Action Toast!')
          .action('OK')
          .highlightAction(false)
          .position($scope.getToastPosition());

    $mdToast.show(toast).then(function() {
      alert('You clicked \'OK\'.');
    });
  };

})

app.controller('ToastCtrl', function($scope, $mdToast) {
  $scope.closeToast = function() {
    $mdToast.hide();
  };
});

app.controller('MDTooltipCtrl', function($scope) {
  $scope.demo = {};
});

/*!
 * JavaScript - loadGoogleMaps( version, apiKey, language )
 *
 * - Load Google Maps API using jQuery Deferred. 
 *   Useful if you want to only load the Google Maps API on-demand.
 * - Requires jQuery 1.5
 * 
 * Copyright (c) 2011 Glenn Baker
 * Dual licensed under the MIT and GPL licenses.
 */
/*globals window, google, jQuery*/
var loadGoogleMaps = (function($) {
	
	var now = $.now(),
	
		promise;
	
	return function( version, apiKey, language ) {
		
		if( promise ) { return promise; }
		
			//Create a Deferred Object
		var	deferred = $.Deferred(),
		
			//Declare a resolve function, pass google.maps for the done functions
			resolve = function () {
				deferred.resolve( window.google && google.maps ? google.maps : false );
			},
			
			//global callback name
			callbackName = "loadGoogleMaps_" + ( now++ ),
			
			// Default Parameters
			params = $.extend(
			 {'sensor': false}
			 , apiKey ? {"key": apiKey} : {}
			 , language ? {"language": language} : {} 
			);;
		
		//If google.maps exists, then Google Maps API was probably loaded with the <script> tag
		if( window.google && google.maps ) {
			
			resolve();
		
		//If the google.load method exists, lets load the Google Maps API in Async.
		} else if ( window.google && google.load ) {
		
			google.load("maps", version || 3, {"other_params": $.param(params) , "callback" : resolve});

		//Last, try pure jQuery Ajax technique to load the Google Maps API in Async.
		} else {
			
			//Ajax URL params
			params = $.extend( params, {
				'v': version || 3,
				'callback': callbackName
			});
			
			//Declare the global callback
			window[callbackName] = function( ) {
				
				resolve();
				
				//Delete callback
				setTimeout(function() {
					try{
						delete window[callbackName];
					} catch( e ) {}
				}, 20);
			};
			
			//Can't use the jXHR promise because 'script' doesn't support 'callback=?'
			$.ajax({
				dataType: 'script',
				data: params,
				url: 'http://maps.google.com/maps/api/js'				
			});
			
		}
	
		promise = deferred.promise(); 
		
		return promise;
	};
	
}(jQuery));

app.controller('ImgCropCtrl', ['$scope', function($scope) {
    $scope.myImage='';
    $scope.myCroppedImage='';
    $scope.cropType="circle";

    var handleFileSelect=function(evt) {
      var file=evt.currentTarget.files[0];
      var reader = new FileReader();
      reader.onload = function (evt) {
        $scope.$apply(function($scope){
          $scope.myImage=evt.target.result;
        });
      };
      reader.readAsDataURL(file);
    };
    angular.element(document.querySelector('#fileInput')).on('change',handleFileSelect);
}]);
app.controller('GoogleMapCtrl', ['$scope', function ($scope) {

    $scope.myMarkers = [];

    $scope.mapOptions = {
      center: new google.maps.LatLng(35.784, -98.670),
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    $scope.addMarker = function ($event, $params) {
      $scope.myMarkers.push(new google.maps.Marker({
        map: $scope.myMap,
        position: $params[0].latLng
      }));
    };

    $scope.setZoomMessage = function (zoom) {
      $scope.zoomMessage = 'You just zoomed to ' + zoom + '!';
    };

    $scope.openMarkerInfo = function (marker) {
      $scope.currentMarker = marker;
      $scope.currentMarkerLat = marker.getPosition().lat();
      $scope.currentMarkerLng = marker.getPosition().lng();
      $scope.myInfoWindow.open($scope.myMap, marker);
    };

    $scope.setMarkerPosition = function (marker, lat, lng) {
      marker.setPosition(new google.maps.LatLng(lat, lng));
    };
}]);
app.controller('EditorCtrl', function($scope) {
  $scope.htmlVariable = '<h3>Try me!</h3><p>textAngular is a super cool WYSIWYG Text Editor directive for AngularJS</p><p><b>Features:</b></p><ol><li>Automatic Seamless Two-Way-Binding</li><li style="color: blue;">Super Easy <b>Theming</b> Options</li><li>Simple Editor Instance Creation</li><li>Safely Parses Html for Custom Toolbar Icons</li><li>Doesn&apos;t Use an iFrame</li><li>Works with Firefox, Chrome, and IE8+</li></ol><p><b>Code at GitHub:</b> <a href="https://github.com/fraywing/textAngular">Here</a> </p>';
});
app.controller('ChartCtrl', ['$scope', function($scope) {
  $scope.plot_pie = [];
  var series = Math.floor(Math.random() * 4) + 3;

  for (var i = 0; i < series; i++) {
    $scope.plot_pie[i] = {
      label: "Series" + (i + 1),
      data: Math.floor(Math.random() * 100) + 1
    }
  }

  $scope.plot_line = [[1, 7.5], [2, 7.5], [3, 5.7], [4, 8.9], [5, 10], [6, 7], [7, 9], [8, 6], [9, 8], [10, 9]];
  $scope.plot_line_1 = [[1, 9.5], [2, 9.4], [3, 9.5], [4, 9.5], [5, 9.7], [6, 9.5], [7, 9], [8, 9.9], [9, 9.6], [10, 9.3]];
  $scope.plot_line_2 = [[1, 4.5], [2, 4.2], [3, 4.5], [4, 4.3], [5, 4.5], [6, 4.7], [7, 4.6], [8, 4.8], [9, 4.6], [10, 4.5]];
  $scope.plot_line_3 = [[1, 14], [2, 5.7], [3, 9.6], [4, 7.8], [5, 6.6], [6, 10.5]];
}]);

'use strict';

/* Controllers */

  // bootstrap controller
  app.controller('AccordionDemoCtrl', ['$scope', function($scope) {
    $scope.oneAtATime = true;

    $scope.groups = [
      {
        title: 'Accordion group header - #1',
        content: 'Dynamic group body - #1'
      },
      {
        title: 'Accordion group header - #2',
        content: 'Dynamic group body - #2'
      }
    ];

    $scope.items = ['Item 1', 'Item 2', 'Item 3'];

    $scope.addItem = function() {
      var newItemNo = $scope.items.length + 1;
      $scope.items.push('Item ' + newItemNo);
    };

    $scope.status = {
      isFirstOpen: true,
      isFirstDisabled: false
    };
  }])
  ; 
  app.controller('AlertDemoCtrl', ['$scope', function($scope) {
    $scope.alerts = [
      { type: 'success', msg: 'Well done! You successfully read this important alert message.' },
      { type: 'info', msg: 'Heads up! This alert needs your attention, but it is not super important.' },
      { type: 'warning', msg: 'Warning! Best check yo self, you are not looking too good...' }
    ];

    $scope.addAlert = function() {
      $scope.alerts.push({type: 'danger', msg: 'Oh snap! Change a few things up and try submitting again.'});
    };

    $scope.closeAlert = function(index) {
      $scope.alerts.splice(index, 1);
    };
  }])
  ; 
  app.controller('ButtonsDemoCtrl', ['$scope', function($scope) {
    $scope.singleModel = 1;

    $scope.radioModel = 'Middle';

    $scope.checkModel = {
      left: false,
      middle: true,
      right: false
    };
  }])
  ; 
  app.controller('CarouselDemoCtrl', ['$scope', function($scope) {
    $scope.myInterval = 5000;
    var slides = $scope.slides = [];
    $scope.addSlide = function() {
      slides.push({
        image: 'images/c' + slides.length + '.jpg',
        text: ['Carousel text #0','Carousel text #1','Carousel text #2','Carousel text #3'][slides.length % 4]
      });
    };
    for (var i=0; i<4; i++) {
      $scope.addSlide();
    }
  }])
  ; 
  app.controller('DropdownDemoCtrl', ['$scope', function($scope) {
    $scope.items = [
      'The first choice!',
      'And another choice for you.',
      'but wait! A third!'
    ];

    $scope.status = {
      isopen: false
    };

    $scope.toggled = function(open) {
      //console.log('Dropdown is now: ', open);
    };

    $scope.toggleDropdown = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.status.isopen = !$scope.status.isopen;
    };
  }])
  ; 
  app.controller('ModalInstanceCtrl', ['$scope', '$modalInstance', 'items', function($scope, $modalInstance, items) {
    $scope.items = items;
    $scope.selected = {
      item: $scope.items[0]
    };

    $scope.ok = function () {
      $modalInstance.close($scope.selected.item);
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }])
  ; 
  app.controller('ModalDemoCtrl', ['$scope', '$modal', '$log', function($scope, $modal, $log) {
    $scope.items = ['item1', 'item2', 'item3'];
    $scope.open = function (size) {
      var modalInstance = $modal.open({
        templateUrl: 'myModalContent.html',
        controller: 'ModalInstanceCtrl',
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });

      modalInstance.result.then(function (selectedItem) {
        $scope.selected = selectedItem;
      }, function () {
        $log.info('Modal dismissed at: ' + new Date());
      });
    };
  }])
  ; 
  app.controller('PaginationDemoCtrl', ['$scope', '$log', function($scope, $log) {
    $scope.totalItems = 64;
    $scope.currentPage = 4;

    $scope.setPage = function (pageNo) {
      $scope.currentPage = pageNo;
    };

    $scope.pageChanged = function() {
      $log.info('Page changed to: ' + $scope.currentPage);
    };

    $scope.maxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;
  }])
  ; 
  app.controller('PopoverDemoCtrl', ['$scope', function($scope) {
    $scope.dynamicPopover = 'Hello, World!';
    $scope.dynamicPopoverTitle = 'Title';
  }])
  ; 
  app.controller('ProgressDemoCtrl', ['$scope', function($scope) {
    $scope.max = 200;

    $scope.random = function() {
      var value = Math.floor((Math.random() * 100) + 1);
      var type;

      if (value < 25) {
        type = 'success';
      } else if (value < 50) {
        type = 'info';
      } else if (value < 75) {
        type = 'warning';
      } else {
        type = 'danger';
      }

      $scope.showWarning = (type === 'danger' || type === 'warning');

      $scope.dynamic = value;
      $scope.type = type;
    };
    $scope.random();

    $scope.randomStacked = function() {
      $scope.stacked = [];
      var types = ['success', 'info', 'warning', 'danger'];

      for (var i = 0, n = Math.floor((Math.random() * 4) + 1); i < n; i++) {
          var index = Math.floor((Math.random() * 4));
          $scope.stacked.push({
            value: Math.floor((Math.random() * 30) + 1),
            type: types[index]
          });
      }
    };
    $scope.randomStacked();
  }])
  ; 
  app.controller('TabsDemoCtrl', ['$scope', function($scope) {
    $scope.tabs = [
      { title:'Dynamic Title 1', content:'Dynamic content 1' },
      { title:'Dynamic Title 2', content:'Dynamic content 2', disabled: true }
    ];
  }])
  ; 
  app.controller('RatingDemoCtrl', ['$scope', function($scope) {
    $scope.rate = 7;
    $scope.max = 10;
    $scope.isReadonly = false;

    $scope.hoveringOver = function(value) {
      $scope.overStar = value;
      $scope.percent = 100 * (value / $scope.max);
    };
  }])
  ; 
  app.controller('TooltipDemoCtrl', ['$scope', function($scope) {
    $scope.dynamicTooltip = 'Hello, World!';
    $scope.dynamicTooltipText = 'dynamic';
    $scope.htmlTooltip = 'I\'ve been made <b>bold</b>!';
  }])
  ; 
  app.controller('TypeaheadDemoCtrl', ['$scope', '$http', function($scope, $http) {
    $scope.selected = undefined;
    $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
    // Any function returning a promise object can be used to load values asynchronously
    $scope.getLocation = function(val) {
      return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: val,
          sensor: false
        }
      }).then(function(res){
        var addresses = [];
        angular.forEach(res.data.results, function(item){
          addresses.push(item.formatted_address);
        });
        return addresses;
      });
    };
  }])
  ; 
  app.controller('DatepickerDemoCtrl', ['$scope', function($scope) {
    $scope.today = function() {
      $scope.dt = new Date();
    };
    $scope.today();

    $scope.clear = function () {
      $scope.dt = null;
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
      return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.toggleMin = function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    };
    $scope.toggleMin();

    $scope.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 1,
      class: 'datepicker'
    };

    $scope.initDate = new Date('2016-15-20');
    $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];
  }])
  ; 
  app.controller('TimepickerDemoCtrl', ['$scope', function($scope) {
    $scope.mytime = new Date();

    $scope.hstep = 1;
    $scope.mstep = 15;

    $scope.options = {
      hstep: [1, 2, 3],
      mstep: [1, 5, 10, 15, 25, 30]
    };

    $scope.ismeridian = true;
    $scope.toggleMode = function() {
      $scope.ismeridian = ! $scope.ismeridian;
    };

    $scope.update = function() {
      var d = new Date();
      d.setHours( 14 );
      d.setMinutes( 0 );
      $scope.mytime = d;
    };

    $scope.changed = function () {
      //console.log('Time changed to: ' + $scope.mytime);
    };

    $scope.clear = function() {
      $scope.mytime = null;
    };
  }]);

  app.directive('setNgAnimate', ['$animate', function ($animate) {
    return {
        link: function ($scope, $element, $attrs) {
            $scope.$watch( function() {
                return $scope.$eval($attrs.setNgAnimate, $scope);
            }, function(valnew, valold){
                $animate.enabled(!!valnew, $element);
            });
        }
    };
  }]);

'use strict';

/**
 * @ngdoc function
 * @name 
 * @description
 * # Demo controller for angular strap
 * Controller of the angular-strap
 */

  app.controller('AlertDemoCtrl', function($scope, $templateCache, $timeout, $alert) {
    $scope.alert = {title: 'Holy guacamole!', content: 'Best check yo self, you\'re not looking too good.', type: 'info'};

    // Service usage
    var myAlert = $alert({title: 'Holy guacamole!', content: 'Best check yo self, you\'re not looking too good.', placement: 'top', type: 'info', keyboard: true, show: false});
    $scope.showAlert = function() {
      myAlert.show(); // or myAlert.$promise.then(myAlert.show) if you use an external html template
    };

  });

  app.controller('AsideDemoCtrl', function($scope) {
    $scope.aside = {title: 'Title', content: 'Hello Aside<br />This is a multiline message!'};
  });

  app.controller('ButtonDemoCtrl', function($scope) {
    $scope.button = {
      toggle: false,
      checkbox: {left: false, middle: true, right: false},
      radio: 'left'
    };
  });

  app.controller('DropdownDemoCtrl', function($scope, $alert) {
    $scope.dropdown = [
      {text: '<i class="fa fa-fw fa-download"></i>&nbsp;Another action', href: '#anotherAction'},
      {text: '<i class="fa fa-fw fa-globe"></i>&nbsp;Display an alert', click: '$alert("Holy guacamole!")'},
      {text: '<i class="fa fa-fw fa-external-link"></i>&nbsp;External link', href: '/auth/facebook', target: '_self'},
      {divider: true},
      {text: 'Separated link', href: '#separatedLink'}
    ];

    $scope.$alert = function(title) {
      $alert({title: title, content: 'Best check yo self, you\'re not looking too good.', placement: 'top', type: 'info', keyboard: true, show: true});
    };

  });

  app.controller('CollapseDemoCtrl', function($scope, $templateCache) {
    $scope.panels = [
      {title:'Collapsible Group Item #1', body: 'Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.'},
      {title:'Collapsible Group Item #2', body: 'Food truck fixie locavore, accusamus mcsweeney\'s marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee.'},
      {title:'Collapsible Group Item #3', body: 'Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney\'s organic lomo retro fanny pack lo-fi farm-to-table readymade.'}
    ];

    $scope.panels.activePanel = 1;

    $scope.pushPanel = function() {
      $scope.panels.push({title: 'Collapsible Group Item #4', body: 'Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid.'});
    };

  });

  app.controller('DatepickerDemoCtrl', function($scope, $http) {
    $scope.selectedDate = new Date();
    $scope.selectedDateAsNumber = Date.UTC(1986, 1, 22);
    // $scope.fromDate = new Date();
    // $scope.untilDate = new Date();
    $scope.getType = function(key) {
      return Object.prototype.toString.call($scope[key]);
    };

    $scope.clearDates = function() {
      $scope.selectedDate = null;
    };
  });

  app.controller('TimepickerDemoCtrl', function($scope, $http) {
    $scope.time = new Date(1970, 0, 1, 10, 30);
    $scope.selectedTimeAsNumber = 10 * 36e5;
    $scope.selectedTimeAsString = '10:00';
    $scope.sharedDate = new Date(new Date().setMinutes(0));
  });


  app.controller('ModalDemoCtrl', function($scope, $modal) {
    $scope.modal = {title: 'Title', content: 'Hello Modal<br />This is a multiline message!'};

    // Controller usage example
    //
    // var myModal = $modal({title: 'Title', content: 'Hello Modal<br />This is a multiline message!', show: false});
    // $scope.showModal = function() {
    //   myModal.$promise.then(myModal.show);
    // };
    // $scope.hideModal = function() {
    //   myModal.$promise.then(myModal.hide);
    // };

  });

  app.controller('SelectDemoCtrl', function($scope, $http) {

    $scope.selectedIcon = '';
    $scope.selectedIcons = ['Globe', 'Heart'];
    $scope.icons = [
      {value: 'Gear', label: '<i class="fa fa-gear"></i> Gear'},
      {value: 'Globe', label: '<i class="fa fa-globe"></i> Globe'},
      {value: 'Heart', label: '<i class="fa fa-heart"></i> Heart'},
      {value: 'Camera', label: '<i class="fa fa-camera"></i> Camera'}
    ];

    $scope.selectedMonth = 0;
    $scope.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  });

  app.controller('TabDemoCtrl', function($scope, $templateCache) {

    $scope.tabs = [
      {title:'Home', content: 'Raw denim you probably haven\'t heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica.'},
      {title:'Profile', content: 'Food truck fixie locavore, accusamus mcsweeney\'s marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee.'},
      {title:'About', content: 'Etsy mixtape wayfarers, ethical wes anderson tofu before they sold out mcsweeney\'s organic lomo retro fanny pack lo-fi farm-to-table readymade.'}
    ];

    $scope.tabs.activeTab = 1;

    $scope.pushTab = function() {
      $scope.tabs.push({title: 'Contact', content: 'Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid.'});
    };

  });


  app.controller('TooltipDemoCtrl', function($scope, $q, $sce, $tooltip) {

    $scope.tooltip = {title: 'Hello Tooltip<br />This is a multiline message!', checked: false};

    // Controller usage example
    /*
    var myTooltip = $tooltip(angular.element(document.querySelector('#test')), {title: 'Hello tooltip', placement: 'right'});
    $scope.showTooltip = function() {
      myTooltip.$promise.then(myTooltip.show);
    };
    $scope.hideTooltip = function() {
      myTooltip.$promise.then(myTooltip.hide);
    };
    */

  });



  app.controller('PopoverDemoCtrl', function($scope) {

    $scope.popover = {title: 'Title', content: 'Hello Popover<br />This is a multiline message!'};

    // Controller usage example
    /*
    var myPopover = $popover(angular.element(document.querySelector('#test')), {title: 'Title', content: 'Hello Popover<br />This is a multiline message!', placement: 'right'});
    $scope.showTooltip = function() {
      myPopover.$promise.then(myPopover.show);
    };
    $scope.hideTooltip = function() {
      myPopover.$promise.then(myPopover.hide);
    };
    */

  });

  app.controller('TypeaheadDemoCtrl', function($scope, $templateCache, $http) {

    $scope.selectedState = '';
    $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

    $scope.selectedIcon = '';
    $scope.icons = [
      {value: 'Gear', label: '<i class="fa fa-gear"></i> Gear'},
      {value: 'Globe', label: '<i class="fa fa-globe"></i> Globe'},
      {value: 'Heart', label: '<i class="fa fa-heart"></i> Heart'},
      {value: 'Camera', label: '<i class="fa fa-camera"></i> Camera'}
    ];

    $scope.selectedAddress = '';
    $scope.getAddress = function(viewValue) {
      var params = {address: viewValue, sensor: false};
      return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {params: params})
      .then(function(res) {
        return res.data.results;
      });
    };

  });

'use strict';
/**
 * @ngdoc function
 * @name app.config:uiRouter
 * @description
 * # Config
 * Config for the router
 */
angular.module('app')
  .run(
    [           '$rootScope', '$state', '$stateParams',
      function ( $rootScope,   $state,   $stateParams ) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
      }
    ]
  )
  .config(
    [          '$stateProvider', '$urlRouterProvider', '$locationProvider', 
      function ( $stateProvider,   $urlRouterProvider, $locationProvider,  MODULE_CONFIG ) {
        $locationProvider.html5Mode(true);
        $urlRouterProvider
          .otherwise('auth/signin');
        $stateProvider

            /* Dashboard Page List*/

          .state('app', {
              abstract: true,
              url: '/app',
              views: {
                '': {
                  templateUrl: 'app/views/partials/layout.html'
                },
                'aside': {
                  templateUrl: 'app/views/partials/aside.html'
                },
                'content': {
                  templateUrl: 'app/views/partials/content.html'
                }
              },
              authenticate: true
          })
            .state('app.dashboard', {
              url: '/dashboard',
              templateUrl: 'app/views/dashboard.html',
              data : { title: 'Dashboard', folded: false },
              authenticate: true
            })
          ;
      }
    ]
  );
(function () {
  'use strict';
  var otBypass = true;
  var lgBypass = true;
  //test upload
  angular
    .module('app')
    .run(hostBlockSettings)
    .run(runBlockSettings);

  /** @ngInject */
  function runBlockSettings($rootScope, $timeout, $state, $interval, $window, getServer, toastShow, $location, $mdDialog, postServer) {

    $rootScope.projectInfo = {
      windowTitle: 'rCloud',
      projectTitle: 'rCloud',
      projectHint: 'r',
      companyName: 'rCloud',
      logoDarkSVG: 'images/logo-dark.svg',
      logoLightSVG: 'images/logo.svg',
      loginPageBG: 'images/logo.svg',
      loginPage: 'auth/signin',
      loginModel: 'auth.signin',
      apiServer: "//localhost/rcappphp/",
      // apiServer: "//rcappphp.co:8080/",
      loginServerURL: "https://login.rcloudsoftwares.com",
      majorURL: "rcloudsoftwares.com",
      projectCode: '512eec8d1573bc74ea62db530091b7c2',
      runningMode: 'development',
      flagData: {},
      debugger: false,
      autoLogoutMin: 60,
      runningprojectSetup: {}
    };

    $rootScope.changeHosts();

    // console.log('t');

    // var host = window.location.hostname;

    // var hostConfList = [
    //   {
    //     apiServer: '//api01.rcloudsoft.app/',
    //     loginServerURL: "https://login.rcloudsoft.app",
    //     majorURL: "rcloudsoft.app",
    //     host_list: [
    //       'rcloud-apps.web.app',
    //       'rcloud-apps.firebaseapp.com',
    //       'rcloudsoft.app',
    //       'apps.rcloudsoft.app',
    //       'www.rcloudsoft.app',
    //       'apps.rcloudsoftwares.com',
    //       'in.rcloudsoftwares.com',
    //       'rcappjs.rcloudsoftwares.com',

    //       'rcloud-dairyfarm.web.app',
    //       'rcloud-dairyfarm.firebaseapp.com',
    //       'dairyfarm.rcloudsoft.app',
    //       'dairyfarm.rcloudsoftwares.com',

    //       'rcloud-manage.web.app',
    //       'rcloud-manage.firebaseapp.com',
    //       'manage.rcloudsoft.app',
    //       'admin.rcloudsoft.app',
    //       'console.rcloudsoftwares.com',
    //       'manage.rcloudsoftwares.com',

    //       'rcloud-login.web.app',
    //       'rcloud-login.firebaseapp.com',
    //       'login.rcloudsoft.app',
    //       'login.rcloudsoftwares.com',

    //       'login.rcloudsoftwares.com',
    //       'rcloud-logistics.firebaseapp.com',
    //       'logistics.rcloudsoft.app'
    //     ]
    //   }
    // ];

    // hostConfList.forEach(function(conf){
    //   if(conf.host_list.indexOf(host) >= 0)
    //   {
    //     $rootScope.projectInfo.apiServer = conf.apiServer;
    //     $rootScope.projectInfo.loginServerURL = conf.loginServerURL;
    //     $rootScope.projectInfo.majorURL = conf.majorURL;
    //   }
    // },this);

    // if(host === 'apps.rcloudsoftwares.com' || host === 'apps.rcloudsof.app' || host === 'rcloudsoft.app' || host === 'www.rcloudsoft.app')
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }
    // else if(host === 'console.rcloudsoftwares.com' || host === 'console.rcloudsoftwares.com')
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }
    // else if(host === 'manage.rcloudsoftwares.com')
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }
    // else if(host === 'dairyfarm.rcloudsoftwares.com')
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }
    // else if(host === 'login.rcloudsoftwares.com')
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }
    // else if(host === 'rcloud-logistics.firebaseapp.com' || host === 'logistics.rcloudsoftwares.com')
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }
    // else
    // {
    //   $rootScope.projectInfo.apiServer = "//rcappapi.rcloudsoftwares.com/";
    // }

    $rootScope.defaultSetup = {
      homePage: '/app/home',
      homeModel: 'app.home',
      accBlockPage: '/app/access-denied',
      accBlockModel: 'app.access-denied',

      sync: true,

      syncTime: 10000,
      syncCheckTime: 5000,
      networkReloadtime: 50000,
      cloudSync: true,
      autoLogoutMin: 60,
      screenLockTime: 3,
      toastData: {
        position: 'bottom right',
        delay: 3000
      },
      datePicker: {
        format: 'DD-MM-YYYY',
        mask: '99-99-9999',
        dbformat: 'YYYY-MM-DD'
      },
      timePicker: {
        format: 'HH:mm:ss',
        mask: '99:99:99',
        dbformat: 'HH:mm:ss'
      },
      monthPicker: {
        format: 'YYYY-MM',
        mask: '9999-99',
        dbformat: 'YYYY-MM-DD'
      },
      yearPicker: {
        format: 'YYYY',
        mask: '9999',
        dbformat: 'YYYY'
      },
      numberInput: {
        min: -1000000000000,
        max: 1000000000000,
        step: 0.1,
        decimals: 2,
        boostat: 5,
        maxboostedstep: 10,
        verticalbuttons: true
      }
    };

    $rootScope.menu_settings = [];

    $rootScope.datepickerformats = [{
        name: '06-12-1996',
        format: 'DD-MM-YYYY',
        mask: '99-99-9999',
        dbformat: 'YYYY-MM-DD',
      },
      {
        name: '12-06-1996',
        format: 'MM-DD-YYYY',
        mask: '99-99-9999',
        dbformat: 'YYYY-MM-DD',
      },
      {
        name: '1996-12-06',
        format: 'YYYY-MM-DD',
        mask: '9999-99-99',
        dbformat: 'YYYY-MM-DD',
      },
      {
        name: '06-DEC-2017',
        format: 'DD-MMM-YYYY',
        mask: '99-aaa-9999',
        dbformat: 'YYYY-MM-DD',
      }
    ];

    $rootScope.timepickerformats = [{
        name: '21:30:00',
        format: 'HH:mm:ss',
        mask: '99:99:99',
        dbformat: 'HH:mm:ss',
      },
      {
        name: '09:30 PM',
        format: 'hh:mm A',
        mask: '99:99 XX',
        dbformat: 'HH:mm:ss',
      }
    ];

    $rootScope.monthpickerformats = [{
        name: '1996-12',
        format: 'YYYY-MM',
        mask: '9999-99',
        dbformat: 'YYYY-MM-DD',
      },
      {
        name: '12-1996',
        format: 'MM-YYYY',
        mask: '99-9999',
        dbformat: 'YYYY-MM-DD',
      }
    ];


    var logger = {};
    var oldConsoleLog = null;
    logger.enableLogger = function enableLogger() {
      if (oldConsoleLog == null)
        return;

      window['console']['log'] = oldConsoleLog;
    };

    logger.disableLogger = function disableLogger() {
      oldConsoleLog = console.log;
      window['console']['log'] = function () {};
    };


    $rootScope.changeRunningMode = function (mode) {
      if ($rootScope.defaultSetup) {
        if ($rootScope.projectInfo.runningMode) {
          if ($rootScope.projectInfo.runningMode !== mode) {
            $rootScope.projectInfo.runningMode = mode;
            if ($rootScope.projectInfo.runningMode === 'production') {
              logger.disableLogger();
            } else {
              logger.enableLogger();
            }
          }
        } else {
          logger.disableLogger();
        }
      } else {
        logger.disableLogger();
      }
    };



  }

})();
(function () {
    'use strict';
    var otBypass = true;
    var lgBypass = true;
    //test upload
    angular
      .module('app')
      .run(runBlockSessionSettings);
  
    /** @ngInject */
    function runBlockSessionSettings($rootScope, $timeout, $state, $interval, $window, getServer, toastShow, $location, $mdDialog, postServer) {

      $rootScope.allowedprojects = [];
      // $rootScope.allowedDefaultModules = "auth.signin,load.app,auth.lockme,auth.forgot-password,manage.profile,manage.settings,app.home";
      $rootScope.allowedDefaultModules = false;
      $rootScope.allowedModules = [];
      $rootScope.selectedProject = 0;
      $rootScope.selectedProjectName = 'Home';
      $rootScope.selectedIndex = 0;
      $rootScope.selectedMIndex = 0;
  
      $rootScope.menuitemClicked = function ($index) {
        $rootScope.selectedIndex = ($rootScope.selectedIndex === $index) ? "" : $index;
      };
  
      $rootScope.menumodelClicked = function ($index) {
        $rootScope.selectedMIndex = $index;
      }
  
      $rootScope.gotoLink = function (uref) {
        $state.go(uref);
      }
  
      //For Picto Gram
  
      $rootScope.selectPictoGroup = function (group) {
        $rootScope.selectedPictoGroup = group;
      }
  
      //For Picto Gram
  
      if (sessionStorage.userProject !== 0) {
        $rootScope.selectedProject = sessionStorage.userProject;
        $rootScope.selectedProjectName = sessionStorage.userProjectName;
      }
  
      // Temp Data
      $rootScope.tempData = {
        apiFailGet: 0,
        apiFailPost: 0,
        Sync: 0,
        loginPage: false,
        stateChangeCount: 0,
        previousState: '',
        currentState: '',
        toState: '',
        history: [],
        fbuilderSelectQuery: {},
        tempCount: 0
      };
  
      // Data
      $rootScope.userSession = {};
      $rootScope.puserSession = {};
  
      if (sessionStorage.userService === undefined || sessionStorage.userService === "") {
        $rootScope.userSession.data = false;
        sessionStorage.userService = angular.toJson({
          data: false
        });
      } else {
        $rootScope.userSession = angular.fromJson(sessionStorage.userService);
      }
  
      if (sessionStorage.userSession === undefined || sessionStorage.userSession === "") {
        $rootScope.userSession.session = false;
        sessionStorage.userSession = false;
      } else {
        $rootScope.userSession.session = sessionStorage.userSession ? angular.fromJson(sessionStorage.userSession) : false;
      }
  
      //Login Sessions
      sessionData();
      var source;
      var serverLinkedCloud = false;
  
      function sessionData() {
        if ($rootScope.defaultSetup.sync) {
          if (navigator.onLine || $rootScope.projectInfo.runningMode === 'development') {
            if ($rootScope.defaultSetup.cloudSync) {
              //Cloud Sync
              if (typeof (EventSource) !== "undefined") {
                function processGetSyncURL(url,cprotocol)
                {
                  var newUrl = cprotocol + url;
                  return newUrl;
                }
                var headers = {
                  'rCloudKey': 'rCloudKEY',
                  'rCloudFE': 'JS',
                };

                if(sessionStorage.selected_project_pid !== undefined && sessionStorage.selected_project_pid !== '')
                {
                  headers['rCloudProject'] = sessionStorage.selected_project_pid;
                }

                var url = processGetSyncURL($rootScope.projectInfo.apiServer,window.location.protocol)
                source = new EventSource(url + "rcloudsys/login/cloudSync", {
                  headers: headers,
                  withCredentials: true
                });
                source.onmessage = function (event) {
                  serverLinkedCloud = true;
                  $rootScope.tempData.cloudSync = true;
                  var d = event.data;
                  var djson = angular.fromJson(d);

                  $rootScope.changeRunningMode(djson.mode);
  
                  if(djson.updating === 'true')
                  {
                    $rootScope.initUpdate();
                  }
                  else
                  {
                    $rootScope.closeUpdate();
                  }
  
                  updateSession(djson.isLogin, djson.rc_session, false);

                  $rootScope.networkStatus.networkConnectedSession = false;
                  if (!$rootScope.defaultSetup.cloudSync) {
                    sessionData();
                    source.close();
                  }
                  if (!navigator.onLine && $rootScope.projectInfo.runningMode !== 'development') {
                    updateSession(false, false, false);
                    source.close();
                  }
                };
                source.onclose = function (event) {
                  serverLinkedCloud = false;
                }
              } else {
                $rootScope.defaultSetup.cloudSync = false;
                toastShow.show('info', '', 'cloud_sync_not_supported');
                sessionData();
              }
            } else {
              getServer.getData('rcloudsys/login/isLogin').then(
                function (data) {
                  updateSession(data.isLogin, data.rc_session,false);
                  $rootScope.changeRunningMode(data.mode);
                  $rootScope.networkStatus.networkConnectedSession = false;
                });
              $timeout(sessionData, $rootScope.defaultSetup.syncTime);
            }
          } else {
            if (!$rootScope.tempData.loginPage) {
              toastShow.show('info', '', 'network_problem_reload');
              $timeout(function () {
                toastShow.show('info', '', 'network_auto_reload');
                $timeout(sessionData, $rootScope.defaultSetup.networkReloadtime);
              }, 3000);
            }
          }
        } else {
          $timeout(sessionData, $rootScope.defaultSetup.syncTime);
        }
        // getsessionData();
      }
  
      function getsessionData() {
        $rootScope.userSession = angular.fromJson(sessionStorage.userService);
        $rootScope.userSession.session = angular.fromJson(sessionStorage.userSession);

        //change settings while session changers
        if($rootScope.userSession.data === true)
        {
          if($rootScope.userSession.session.user_settings !== "same")
          {
            // console.log("setting updated");
            angular.extend($rootScope.defaultSetup,$rootScope.userSession.session.user_settings);
          }
        }
        //change settings while session changers

        //change menu while session changers
        if($rootScope.userSession.data === true)
        {
          if($rootScope.userSession.session.menu_settings !== "same")
          {
            // console.log("setting updated");
            angular.extend($rootScope.menu_settings,$rootScope.userSession.session.menu_settings);
          }
        }
        //change menu while session changers

        return $rootScope.userSession;
      }
  
      function updateSession(isLogin, session, postGet) {
        sessionStorage.userService = angular.toJson({
          data: isLogin
        });
        sessionStorage.userSession = angular.toJson(session);
        if(postGet === true)
        {
          sessionStorage.puserSession = angular.toJson(session);
          $rootScope.puserSession = {
            session: session
          };
        }
        sessionStorage.userServiceUpdated = 1;
        sessionStorage.syncStarted = 1;
        getsessionData();
      }
  
      $rootScope.updateSession = function (isLogin, session) {
        updateSession(isLogin, session, true);
      }
  
      //Check Live Login Status


      
      checkLogin();



  
      function checkLogin() {
  
        if ($rootScope.defaultSetup.sync || $rootScope.tempData.loginPage) {
          if (sessionStorage.userServiceUpdated == 0) {
            $rootScope.tempData.Sync += 1;
          } else {
            $rootScope.tempData.Sync = 0;
          }
          if ($rootScope.tempData.Sync === 7 || $rootScope.tempData.Sync === 13) {
            if ($rootScope.defaultSetup.cloudSync) {
              if (serverLinkedCloud) {
                source.close();
              }
            }
            sessionData();
          }
          sessionStorage.userServiceUpdated = 0;
          if ($rootScope.userSession.data !== "undefined") {
            if ($rootScope.userSession.data === false) {
              if ($state.current.authenticate) {
                toastShow.show('info', '', 'session_expired');
                $rootScope.gotoLoginPage();
              }
            } else {
              if ($state.current.notAuthenticate) {
                toastShow.show('info', '', 'already_logged_in');
                $location.path($rootScope.defaultSetup.homePage);
              }
            }
  
            if ($rootScope.tempData.apiFailPost >= 10 || $rootScope.tempData.apiFailGet >= 10 || $rootScope.tempData.Sync >= 16) {
              $rootScope.userSession.data = false;
              sessionStorage.userService = angular.toJson({
                data: false
              });
              $rootScope.gotoLoginPage();
            }
          }
          $timeout(checkLogin, $rootScope.defaultSetup.syncCheckTime);
        } else {
          if ($rootScope.userSession.data !== "undefined") {
            if ($rootScope.userSession.data === false) {
              if ($state.current.authenticate) {
                toastShow.show('info', '', 'session_expired');
                $rootScope.gotoLoginPage();
              }
            } else {
              if ($state.current.notAuthenticate) {
                toastShow.show('info', '', 'already_logged_in');
                $location.path($rootScope.defaultSetup.homePage);
              }
            }
  
            if ($rootScope.tempData.apiFailPost >= 10 || $rootScope.tempData.apiFailGet >= 10 || $rootScope.tempData.Sync >= 16) {
              $rootScope.userSession.data = false;
              sessionStorage.userService = angular.toJson({
                data: false
              });
              $rootScope.gotoLoginPage();
            }
          }
          $timeout(checkLogin, $rootScope.defaultSetup.syncCheckTime);
        }
      }
  
      sessionStorage.needtoUpdate = 'false';
  
      $rootScope.initUpdate = function() {
        $rootScope.networkStatus.networkDisconnected = false;
        $rootScope.networkStatus.networkConnectedSession = false;
        $rootScope.networkStatus.blurBlock = true;
        $rootScope.networkStatus.blurClass = 'blurBlock';
        $rootScope.networkStatus.networkSessionUpdating = true;
        $mdDialog.cancel();
        sessionStorage.needtoUpdate = 'true';
      };
  
      $rootScope.closeUpdate = function() {
        $rootScope.networkStatus.networkDisconnected = false;
        $rootScope.networkStatus.networkConnectedSession = false;
        $rootScope.networkStatus.networkSessionUpdating = false;
        $rootScope.networkStatus.blurBlock = false;
        $rootScope.networkStatus.blurClass = '';
        if(sessionStorage.needtoUpdate === 'true')
        {
          sessionStorage.needtoUpdate = 'false';
          location.reload(true);
        }
      };

      $rootScope.getModelListforAccess = function() {
        var models = [];

        if($rootScope.menu_settings.project)
        {
          $rootScope.menu_settings.modelgroups.forEach(function(mg){
            mg.models.forEach(function(m){
              models.push(m.uref);
              var l = m.submodules;
              if(l)
              {
                l = l.toString().split(',');
                l.forEach(function(li){
                  models.push(li);
                });
              }
            });
          });
        }

        if(models.length > 0)
        {
          sessionStorage.modelList = models.join();
        }

        return models;
      };

      $rootScope.getModels = function() {
        var models = [];
        if($rootScope.menu_settings.project)
        {
          $rootScope.menu_settings.modelgroups.forEach(function(mg){
            mg.models.forEach(function(m){
              models.push(m);
            });
          });
        }
        return models;
      };

      $rootScope.getModelAccess = function() {
        
        var list = $rootScope.getModels();
        var cs = $rootScope.tempData.currentState.name;
        var f = {};
        var find = false;

        list.forEach(function(l){
          if(l.uref.toLowerCase() === cs.toLowerCase())
          {
            f = l;
          }
          if(l.submodules)
          {
            l.submodules = l.submodules.toString().split(',');
            var fl = l.submodules.indexOf(cs.toLowerCase());
            if(l.uref.toLowerCase() === cs.toLowerCase() || fl >= 0)
            {
              f = l;
              // console.log(l);
            }
            find = true;
          }
        });

        var d = {
          create: false,
          delete: false,
          edit: false,
          view: true,
        };

        if(find)
        {
          d = {
            create: Boolean(f.m_create),
            delete: Boolean(f.m_delete),
            edit: Boolean(f.m_edit),
            view: Boolean(f.m_view)
          };
        }
        return d;
      };

      $rootScope.menuAccess = {
        createAccess: function() {
          return $rootScope.allowedDefaultModules === false ? true : $rootScope.getModelAccess().create;
        },
        deleteAccess: function() {
          return $rootScope.allowedDefaultModules === false ? true : $rootScope.getModelAccess().delete;
        },
        editAccess: function() {
          return $rootScope.allowedDefaultModules === false ? true : $rootScope.getModelAccess().edit;
        },
        viewAccess: function() {
          return $rootScope.allowedDefaultModules === false ? true : $rootScope.getModelAccess().view;
        }
      };
  
  
      $rootScope.accessPages = {
        accessBlock: function (s) {
          if($rootScope.allowedDefaultModules === false)
          {
            return true;
          }
          $rootScope.getModelListforAccess();
          var ms = sessionStorage.modelList;
          var list = [];
          
          if(ms)
          {
            list = ms.toString().split(',')
          }

          if(list.length > 0)
          {
            var r = list.indexOf(s.toLowerCase());
            if(r >= 0)
            {
              return true;
            }
            else
            {
              return false;
            }
          }
          else
          {
              return false;
          }
        },
        defaultBlock: function (s) {
          if($rootScope.allowedDefaultModules === false)
          {
            return true;
          }
          var ms = $rootScope.allowedDefaultModules;
          var list = ms.split(',');

          if(list.length > 0)
          {
            var r = list.indexOf(s.toLowerCase());
            if(r >= 0)
            {
              return true;
            }
            else
            {
              return false;
            }
          }
          else
          {
              return false;
          }
        },
        visibleBlock: function () {
          return false;
        }
      };
  
    }
  
  })();
  
(function () {
  'use strict';
  var otBypass = true;
  var lgBypass = true;
  //test upload
  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state, $interval, $window, $location, getServer, toastShow, $mdDialog, postServer, $http) {
    

    var ua = window.navigator.userAgent;
    $rootScope.isMobileAppUser = false;
    if(ua.toLowerCase() === 'rcloudandroidframework' || ua.toLowerCase() === 'rcloudiosframework')
    {
      $rootScope.isMobileAppUser = true;
    }

    function request_all_permissions() {
      if ('Notification' in window) {
        // API supported 
        if ($window.Notification.permission !== "granted") {
          $window.Notification.requestPermission();
        }
      }
    }

    request_all_permissions();

    $rootScope.productVersion = "0.0.0";

    $http.get('/rcloud-v.json').then(function(data){
      // console.log(data.data);
      $rootScope.productVersion = data.data.version;
    });

    $rootScope.loadedProject = false;
    $http.get('/rcloud-project.json').then(function(data){
      // console.log(data.data);
      $rootScope.loadedProject = data.data.rcloud_project_id;
      if($rootScope.loadedProject !== false && $rootScope.loadedProject !== 'login')
      {
        loadjscssfile("stimulsoft/stimulsoft.reports.js", "js");
      }
      if($rootScope.loadedProject !== false && $rootScope.loadedProject !== 'login' && $rootScope.loadedProject !== 'all')
      {
        $rootScope.loadDominProject();
      }
    });

    $rootScope.projectDomain = false;
    $rootScope.loadDominProject = function() {
      var project = _.where($rootScope.userSession.session.projects,{projectid: $rootScope.loadedProject});
      if(project.length > 0)
      {
        $rootScope.projectDomain = true;
        $rootScope.selectIfProjectAlreadySelected(project[0].projectid);
      }
    };

    $interval(function(){
      if($rootScope.projectDomain === false && $rootScope.loadedProject !== false)
      {
        $rootScope.loadDominProject();
      }
    },2000);

    $rootScope.gotoLoginPage = function() {
      // console.log('Login Page Called!',$rootScope.projectInfo.loginPage);
      if($rootScope.loadedProject !== false && $rootScope.loadedProject !== 'login' && $rootScope.loadedProject !== 'all')
      {
        // window.location = $rootScope.projectInfo.loginServerURL;
        // $location.path($rootScope.projectInfo.loginPage);
        $state.go($rootScope.projectInfo.loginModel);
      }
      else
      {
        $state.go($rootScope.projectInfo.loginModel);
      }
    };


    //   loadjscssfile("stimulsoft/stimulsoft.reports.js", "js");
    //   loadjscssfile("stimulsoft/stimulsoft.viewer.js", "js");
    //   loadjscssfile("stimulsoft/stimulsoft.designer.js", "js");
    //   loadjscssfile("stimulsoft/stimulsoft.dashboards.js", "js");
    //   loadjscssfile("stimulsoft/stimulsoft.designer.office2013.lightgraygreen.css", "css");
    //   loadjscssfile("stimulsoft/stimulsoft.viewer.office2013.whitegreen.css", "css");

  }

})();

(function () {
    'use strict';
    var otBypass = true;
    var lgBypass = true;
    //test upload
    angular
      .module('app')
      .run(runBlockProjectSettings);
  
    /** @ngInject */
    function runBlockProjectSettings($rootScope, $timeout, $state, $interval, $window, getServer, toastShow, $location, $mdDialog, postServer) {

      $rootScope.selectIfProjectAlreadySelected = function(pid) {
        if($rootScope.userSession.session.projects !== undefined && Array.isArray($rootScope.userSession.session.projects))
        {
          $rootScope.userSession.session.projects.forEach(function(crp){
            if(crp.projectid === pid)
            {
              if(Boolean(Number(crp.expired)))
              {
                $rootScope.menu_settings = [];
                toastShow.show('warning','Project Expired!','');
              }
              else
              {
                getServer.getData('rcloudsys/login/selectProject/0/'+pid).then(function(data){
                  if(data.msg.type === 'warning')
                  {
                    $rootScope.menu_settings = [];
                  }
                  else
                  {
                    var pr = {
                      projectid: crp.projectid,
                      project_fw: crp.project_fw,
                      project_main_url: project.project_main_url,
                      project_other_url: project.project_other_url
                    };
                    sessionStorage.rcloud_project = JSON.stringify(pr);
                  }
                });
              }
            }
          });        
        }
      };

      
      if(sessionStorage.rcloud_project !== undefined)
      {
        var project = JSON.parse(sessionStorage.rcloud_project);
        $rootScope.selectIfProjectAlreadySelected(project.projectid);
      }    
      
  
      $rootScope.checkCurrentProjectAccess = function () {
        var currentP = $rootScope.selectedProject;
        var allowedprojects = $rootScope.userSession.session.plist;
        var currentTime = $rootScope.userSession.session.currenttime;
  
        var result = "Home";
  
        if (currentP !== "" && currentP !== undefined) {
          if (allowedprojects !== undefined && allowedprojects !== "") {
            for (var a = 0; a < allowedprojects.length; a++) {
              var selectedP = angular.copy(allowedprojects[a]);
              if (selectedP.id === currentP) {
                var valid = moment().isSameOrBefore(selectedP.validtill);
                if (valid) {
                  result = true;
                } else {
                  toastShow.show('warning', selectedP.name + ' License is Expired!', '');
                  $rootScope.selectedProject = 0;
                  $rootScope.selectedProjectName = 'Home';
                  sessionStorage.userProject = 0;
                  result = false;
                }
              }
            }
          }
        }
  
        if (result === true || result === "Home") {
          return true;
        } else {
          return false;
        }
      }
  
      $rootScope.changePSettings = function() {
        $mdDialog.show({
          locals: {},
          controller: changeProjectSettingsController,
          scope: $rootScope,
          preserveScope: true,
          templateUrl: 'app/views/partials/projectsettings.html',
          parent: angular.element(document.body),
          targetEvent: '',
          // clickOutsideToClose: true,
          fullscreen: true
        });
      };
  
      $rootScope.projectSettingsButton = function() {
        var settings = $rootScope.getProjectSettings();
        if(settings !== "")
        {
          return true;
        }
        else
        {
          return false;
        }
      };
  
      $rootScope.getProjectSettings = function() {
        if($rootScope.userSession.data === true)
        {
          if($rootScope.puserSession.session)
          {
            if($rootScope.puserSession.session.current_project !== undefined)
            {
              return $rootScope.puserSession.session.current_project.settings;
            }
            else
            {
              return '';
            }
          }
          else
          {
            return '';
          }
        }
        else
        {
          return '';
        }
      };

      $rootScope.getCurrentProjectSettingValues = function() {
        if($rootScope.userSession.data === true)
        {
          if($rootScope.puserSession.session.current_project !== undefined)
          {
            return $rootScope.puserSession.session.current_project.setting_values;
          }
          else
          {
            return {};
          }
        }
        else
        {
          return {};
        }
      };
  
      function changeProjectSettingsController($rootScope, $scope, $state, $mdDialog, postServer) {
        $rootScope.theme = $rootScope.getThemeColor();
  
        // console.log($rootScope.theme);
  
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
  
        if($rootScope.userSession.data === true)
        {
          $scope.runningSettingsData = $rootScope.puserSession.session.current_project.setting_values;
        }
        else
        {
          $scope.runningSettingsData = {};
        }
  
        $rootScope.saveProjectSettings = function() {
          var d = {};
          d.val = angular.toJson($scope.runningSettingsData);
          postServer.postData('rcloudsys/login/saveCurrentProjectSettings',d).then(function(data) {
            $state.reload();
            $scope.cancel();
          });
        };  
        
      };
      
      // $rootScope.postHeaders = { 'Content-Type': 'application/x-www-form-urlencoded', "RamDesigners-APP-Code": $rootScope.projectInfo.projectCode, "RamDesigners-APP-Response-Type": 'json', "RamDesigners-APP-State": $rootScope.tempData.toState.name };  // set the headers so angular passing info as form data (not request payload)
      $rootScope.postHeaders = { 'Content-Type': 'application/x-www-form-urlencoded' };  // set the headers so angular passing info as form data (not request payload)
      $rootScope.postHeadersDT = { 'Content-Type': 'application/x-www-form-urlencoded', 'rCloudKey' : 'rCloudKEY' };  // set the headers so angular passing info as form data (not request payload)
  
      
      
      $rootScope.processPostServerURL = function ()
      {
        var url = $rootScope.projectInfo.apiServer;
        var cprotocol = window.location.protocol;
        var newUrl = cprotocol + url;
        return newUrl;
      }
  
      $rootScope.getManagementAccessProjects = function() {
        var a = [];
        $rootScope.userSession.session.plist.forEach(function(p){
          if(Number(p.id) === 2)
          {
            a = p.map ? p.map.projects ? p.map.projects : [] : [];
          }
        },this);
        return a;
      };
  
      // $timeout(function(){
      //   $rootScope.showScreenSaver();
      // },1000);
  
      $rootScope.getAllProjectsSettingsonLogin = function() {
      };
      
  
      $rootScope.$watch('selectedProject',function(n,o){
        $rootScope.getAllProjectsSettingsonLogin();
      });
  
      getServer.getData('rcloudsys/countrysetting/flag').then(function(data){
        $rootScope.projectInfo.flagData = data.result;
      });
  
    }
  
  })();
  
(function () {
    'use strict';
    var otBypass = true;
    var lgBypass = true;
    //test upload
    angular
      .module('app')
      .run(runBlockPlugins);
  
    /** @ngInject */
    function runBlockPlugins($rootScope, $timeout, $state, $interval, $window, getServer, toastShow, $location, $mdDialog, postServer, $sce) {
      
        $rootScope.trustRCURL = function(src) {
          var rcurl = $sce.trustAsResourceUrl(src);
          return rcurl;
        }

      //For Disable Errors in Datatables
      $.fn.dataTable.ext.errMode = 'none';
      //For Disable Errors in Datatables
        

      $rootScope.tinymceOptions = {
        inline: false,
        plugins: 'advlist autolink link image lists charmap table autoresize searchreplace textcolor contextmenu emoticons',
        table_toolbar: "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
        skin: 'lightgray',
        theme: 'modern',
        autoresize_bottom_margin: 50,
        file_browser_callback: function(field_name, url, type, win) {
          win.document.getElementById(field_name).value = '';
        },
        file_browser_callback_types: 'file image media',
        images_upload_url: $rootScope.projectInfo.apiServer + 'Tinymce_files/upload',
        images_upload_handler: function (blobInfo, success, failure) {
          var xhr, formData;    
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', $rootScope.projectInfo.apiServer + 'Tinymce_files/upload');
          
          _.each($rootScope.postHeaders, function(value, key, obj) {
            if(key !== "Content-Type")
            {
              xhr.setRequestHeader(key, value);
            }
          });
  
          xhr.onload = function() {
            var json;    
            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }    
            json = JSON.parse(xhr.responseText);    
            if (!json || typeof json.location != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }    
            success(json.location);
          };    
          formData = new FormData();
          formData.append('file', blobInfo.blob(), blobInfo.filename());    
          xhr.send(formData);
        },
        automatic_uploads: true
      };
  
      $rootScope.stimulReport = function($design,$strviewer,$no,$viewer,$getVars,$curstomVars,$mailSett,$copies,$reportInfo) {
        // console.log('Loading Viewer view');
        
        try {
          var test = new Stimulsoft.Viewer.StiViewerOptions;
        }
        catch(e) {
          document.getElementById($viewer).innerHTML = '<center><h4>Report Loading Please Wait!....</h4><br><br><br><h6>There May be a Problem in Report Loading, Please Wait!...</h6></center>';
          $timeout(function(){
            $state.reload();
          },5000);
        }

        
        // Stimulsoft Licence
        Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkkIWHKZyw5v/a/adOMgM+8E5eZG9UZG/owOriMz+Jfc/5vwh" + 
        "14CPdixpFHHPcoEQg1KwKZNDFzXmK6/o5GtQYYX7YK1RbhQGQQpH2qjgDL+EidKAXtbtXq4bkPRX0I++bzs/jBhsUy" + 
        "B9BAi0dPSFmDoXKpmkWA7QSxu8U0vXocfC+z9ng7g3VBR7e9hONIbETizmbdaIUNoAsmt8u6fa4JM712SdRQLuXUqF" + 
        "zUFrp9J2jui892FcDiI78MN0iEHrxej6N/uL/j+QB6Y+HfKO4sQik1njw59fiitHc1RmE85Oqi3O9bIZ1rMS23ye00" + 
        "vAnaBNJY/+cpB3zfPaIYqrwTk7V0UNtBivIgXRSWM5U5EPsBrYpI8XKMZJP0HDssn0ysxAom2gJ3pv9tzW6Em9eDAJ" + 
        "WPkfWwjLfqjLaakIaIoDPbES/nnWLrgb0cFDyA7qc3P7BC8ZyLgFsClVI88HEeFDquLDhQYWWcHZmzrQb36lcQ1ROP" + 
        "J1SECY++QqLbtEdJU2cCu2ghnpIZl0uGCyYw";        
        // Stimulsoft Licence

        var eset = $mailSett ? $mailSett : false;
      
        // for loading options
        var options = new Stimulsoft.Viewer.StiViewerOptions;
        options.toolbar.viewMode = Stimulsoft.Viewer.StiWebViewMode.MultiplePages;
    
        options.appearance.showTooltips = false;
    
        options.toolbar.showDesignButton = false;
    
        options.toolbar.showAboutButton = false;

        if(eset !== false)
        { 
          options.toolbar.showSendEmailButton = true;

          options.email.defaultEmailAddress = eset.default_email_address ? eset.default_email_address : '';
          options.email.defaultEmailMessage = eset.default_email_message ? eset.default_email_message : '';
          options.email.defaultEmailSubject = eset.default_email_subject ? eset.default_email_subject : '';

        }

        options.toolbar.printDestination = Stimulsoft.Viewer.StiPrintDestination.Default;

        options.toolbar.showOpenButton = false;

        options.exports.showExportDialog = false;

        options.exports.showExportToHtml = false;
        options.exports.showExportToHtml5 = false;
        options.exports.showExportToCsv = false;
        options.exports.showExportToDocument = false;

        options.exports.showExportToPowerPoint = true;
        options.exports.showExportToImageJpeg = true;
        options.exports.showExportToImagePng = true;

        options.email.showEmailDialog = false;
        // options.email.showExportDialog = false;

        // options.appearance.scrollbarsMode = true;
        // options.appearance.fullScreenMode = true;

        options.appearance.interfaceType = Stimulsoft.Viewer.StiInterfaceType.Auto;

        // console.log(options);
    
        // console.log('Creating the report viewer with default options');
        // 
        var viewer = new $window.Stimulsoft.Viewer.StiViewer(options, $strviewer, false);
    
        // console.log('Creating a new report instance');
        var report = new $window.Stimulsoft.Report.StiReport();
    
        // var data = $rootScope.designData;
        report.load($design);
    
        // Send exported report to Email
        viewer.onEmailReport = function (event) {

          event.data = Stimulsoft.System.Convert.toBase64String(event.data);

          var email_sett = {
            custom_list: eset !== false ? true : false,
            custom_list_url: eset.email_list_url ? eset.email_list_url : ''
          };

          $mdDialog.show({
            locals: {
              event: event,
              email_sett: email_sett
            },
            controller: sendEmailrCloudSysController,
            scope: $rootScope,
            preserveScope: true,
            templateUrl: 'app/views/partials/email_sender.html',
            parent: angular.element(document.body),
            targetEvent: '',
            // clickOutsideToClose: true,
            fullscreen: true
          });
        };
    
        // console.log('Load report from url');
        // report.loadFile('/reports/common/invoice.mrt');
    
        function processGetServerURL(url,cprotocol)
        {
          var newUrl = cprotocol + url;
          return newUrl;
        }
        
        // Get variable by name
        var URI = report.dictionary.variables.getByName("URI");
        // Set variable value
        URI.value = processGetServerURL($rootScope.projectInfo.apiServer,window.location.protocol);
        // console.log(URI.value);
        
        // Get variable by name
        var PASS = report.dictionary.variables.getByName("PASS");
        // Set variable value
        
        if(typeof $no === 'object')
        {
          PASS.value = $no.pass + ($getVars ? $getVars : '');
        }
        else
        {
          PASS.value = $no+'/'+$rootScope.userSession.session.company_info.uniquename+'/'+$rootScope.userSession.session.username + ($getVars ? $getVars : '');
        }
    
    
        //custom variables
        $curstomVars = $curstomVars ? $curstomVars : [];
        var reportVars = [];
        var r = 0;
        $curstomVars.forEach(function(cvar){
          reportVars[r] = report.dictionary.variables.getByName(cvar.title);
          reportVars[r].value = cvar.value;
          r++;
        });
        //custom variables

        if($reportInfo)
        {
          if($reportInfo.report_name)
          {
            if($reportInfo.report_name !== '')
            {
              report.reportName = $reportInfo.report_name;
              report.reportAlias = $reportInfo.report_name;
            }
          }

          if($reportInfo.report_author)
          {
            if($reportInfo.report_author !== '')
            {
              report.reportAuthor = $reportInfo.report_author;
            }
          }
        }


        // var testName = report.dictionary.variables.getByName('ReportName');
        // testName.value = 'TestName';
        
        // console.log(PASS.value);

        var cps = issetnotempty($copies) && $copies > 0 ? $copies : 1;
        if(report.pages.getByIndex(0).numberOfCopies)
        {
          report.pages.getByIndex(0).numberOfCopies = cps;
        }
    
        // console.log('Assigning report to the viewer, the report will be built automatically after rendering the viewer');
        viewer.report = report;
    
        // console.log('Rendering the viewer to selected element');
        viewer.renderHtml($viewer);

        // Print report using web browser
        // report.print();
    
        // console.log('Loading completed successfully!');
      };

      function sendEmailrCloudSysController($rootScope, $scope, $state, $mdDialog, postServer, event, email_sett) {
        $rootScope.theme = $rootScope.getThemeColor();

        $scope.emailHubData = event;

        $scope.toAddressBox = function() {
          if(email_sett.custom_list && email_sett.custom_list_url !== '' && email_sett.custom_list_url !== undefined)
          {
            var url = email_sett.custom_list_url;
            return '<selectbox quickattrs="email_address_list" dataapiurl="'+ url +'" size="col-md-12" itemtype="private" modelname="emailHubData.settings.email"></selectbox>';
          }
          else
          {
            return '<textbox quickattrs="emailsender" itemid="toaddress" size="col-md-12" itemtype="private" modelname="emailHubData.settings.email"></textbox>';
          }
        };

        $scope.sendEmail = function() {
          var da = angular.copy($scope.emailHubData);
          da.settings.email = $rootScope.processMultiSelectValue(da.settings.email);
          var d = {};
          d.value = angular.toJson(da);
          postServer.postData('rcloudsys/companies/sendReporttoMail',d).then(function(data){
            $scope.cancel();
          });
        };
  
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        
      };

      
    }
  
  })();
  
(function () {
    'use strict';
    var otBypass = true;
    var lgBypass = true;
    //test upload
    angular
      .module('app')
      .run(function ($rootScope, $state, getServer, toastShow, $timeout, $location) {
        $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
  
          $rootScope.tempData.toState = toState;
  
          $rootScope.loadingProgress = true;
  
          console.log($rootScope.checkCurrentProjectAccess());
          
          if (!$rootScope.checkCurrentProjectAccess()) {
            event.preventDefault();
            $state.transitionTo($rootScope.defaultSetup.homeModel);
          }

          var acc = true;
          if($rootScope.defaultSetup.homeModel.toLowerCase() !== toState.name.toLowerCase())
          {
            acc = ($rootScope.accessPages.accessBlock(toState.name) || $rootScope.accessPages.defaultBlock(toState.name)) ? true : false;
          }
          // console.log(toState.name,$rootScope.accessPages.accessBlock(toState.name),$rootScope.accessPages.defaultBlock(toState.name));
  
          if (!acc) {
            event.preventDefault();
            toastShow.show('warning', '', 'access_not_allowed');
            // $state.transitionTo($rootScope.defaultSetup.homeModel);
            if(fromState.name !== '' && fromState.name !== undefined)
            {
              $state.transitionTo(fromState.name);
            }
            else
            {
              $state.transitionTo($rootScope.defaultSetup.homeModel);
            }
          } else {
            if (toState.authenticate) {
              if (otBypass) {
                if (toState.authenticate) {
                  if (!$rootScope.userSession.data && toState.authenticate) {
                    sessionStorage.userDirectPage = $location.path();
                    event.preventDefault();
                    lgBypass = false;
                    toastShow.show('info', '', 'not_logged_in');
                    $rootScope.gotoLoginPage();
                  }
                }
              } else {
                otBypass = true;
              }
            }
  
  
            if (toState.notAuthenticate) {
              if (lgBypass) {
                if (toState.notAuthenticate) {
                  if ($rootScope.userSession.data && toState.notAuthenticate) {
                    event.preventDefault();
                    otBypass = false;
                    $rootScope.loadingProgress = true;
                    toastShow.show('info', '', 'already_logged_in');
                    $timeout(function () {
                      $rootScope.loadingProgress = false;
                    }, 800);
                    $state.transitionTo(fromState.name ? fromState.name : $rootScope.defaultSetup.homeModel);
                  }
                }
              } else {
                lgBypass = true;
              }
            }
          }
        });
      })
      .run(function ($rootScope, $state, getServer, toastShow, $timeout, $mdDialog, $window, $location) {
        $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams, $mdDialog) {

          // console.log(toState);

          dataTableClear();
          
          $window.ga('create', 'UA-113293403-3', 'auto');
          var set = {page:$location.path(), title:$state.current.data.title, location: $location.path()};
  
          // User ID
          var useridhits = ($rootScope.userSession.data === false) ? 'Not_Logged_In' : ($rootScope.userSession.session.display_name + ' (' + $rootScope.userSession.session.user_id + ')');
          // User ID
  
          // User Id Hits
          $window.ga('set', 'dimension1', useridhits);
          // User Id Hits
  
          //User Id Session
          $window.ga('set', 'dimension2', useridhits);
          //User Id Session
  
  
          // Company
          var companieshits = ($rootScope.userSession.data === false) ? 'Not_Logged_In' : ($rootScope.userSession.session.company_info.cmp_name + ' (' + $rootScope.userSession.session.company_info.id + ')');
          // Company
  
          //Companies (Hits)
          $window.ga('set', 'dimension3', companieshits);
          //Companies (Hits)
  
          // Companies (Session)
          $window.ga('set', 'dimension4', companieshits);
          // Companies (Session)
  
          // Companies (Users)
          $window.ga('set', 'dimension5', companieshits);
          // Companies (Users)
  
          // Project
          var projecthits = ($rootScope.userSession.data === false) ? 'Not_Logged_In' : ( (sessionStorage.selected_project_pid) ? sessionStorage.selected_project_pid : 'Home');
          // Project
  
          // Project (Hits)
          $window.ga('set', 'dimension6', projecthits);
          // Project (Hits)
  
          // Project (Sessions)
          $window.ga('set', 'dimension7', projecthits);
          // Project (Sessions)
  
          // Project (Users)
          $window.ga('set', 'dimension8', projecthits);
          // Project (Users)
  
          $window.ga('send', 'pageview', set);
  
          $rootScope.accessPages.visibleBlock();
          $rootScope.tempData.previousState = fromState;
          $rootScope.tempData.currentState = toState;
          var a = fromState;
          if($rootScope.tempData.history.length > 0)
          {
            if($rootScope.tempData.history[0].furl !== $location.url())
            {
              a.furl = $location.url();
              $rootScope.tempData.history.unshift(a);
            }
          }
          else
          {
            a.furl = $location.url();
            $rootScope.tempData.history.unshift(a);
          }
  
          $rootScope.setTitle($state.current.data.title);
          $rootScope.tempData.loginPage = $state.current.name === $rootScope.projectInfo.loginModel ? true : false;
          $timeout(function () {
            $rootScope.loadingProgress = false;
          }, 1000);
  
          $rootScope.select2LoadedItems = [];
  
          var a = $mdDialog ? $mdDialog.hide() : '';
  
          //For focus initial element
          iniFirstFocus();
          //For focus initial element
        });
      });
  
  })();
  
(function () {
  'use strict';
  var otBypass = true;
  var lgBypass = true;
  //test upload
  angular
    .module('app')
    .run(runBlockLockSettings);

  /** @ngInject */
  function runBlockLockSettings($rootScope, $timeout, $state, $interval, $window, getServer, toastShow, $location, $mdDialog, postServer) {


    var idleTime = 0;
    $(document).ready(function () {
      //Increment the idle time counter every minute.
      var idleInterval = setInterval(timerIncrement, 60000); // 1 minute

      //Zero the idle timer on mouse movement.
      $(this).mousemove(function (e) {
        idleTime = 0;
      });
      $(this).keypress(function (e) {
        idleTime = 0;
      });
    });

    $rootScope.screenSaverOpened = false;

    function timerIncrement() {
      idleTime = idleTime + 1;

      if (idleTime > $rootScope.defaultSetup.screenLockTime) {
        if (!$rootScope.screenSaverOpened) {
          if($rootScope.isMobileAppUser === false)
          {
            $rootScope.screenSaverOpened = true;
            $rootScope.showScreenSaver();
          }
        }
      } else {
        $rootScope.screenSaverOpened = false;
      }

      if (idleTime > $rootScope.defaultSetup.autoLogoutMin) { // 5 minutes
        if ($rootScope.tempData.loginPage !== true) {
          $rootScope.doLogoutOneTime();
        }
      }
    }


    $rootScope.showScreenSaver = function () {
      $mdDialog.show({
        locals: {},
        controller: showScreenSaverController,
        scope: $rootScope,
        preserveScope: true,
        templateUrl: 'app/views/partials/screen_saver.html',
        parent: angular.element(document.body),
        targetEvent: '',
        // clickOutsideToClose: true,
        fullscreen: true
      });
    };

    // $rootScope.showScreenSaver();

    function showScreenSaverController($scope, $mdDialog) {

      $scope.bgImage = "background-image : url(../images/" + $rootScope.loadedProject + ".jpg);";

      // console.log($scope.bgImage);

      $scope.ctime = $rootScope.userSession.session.currenttime;
      $scope.time = moment($scope.ctime).format('h:mm:ss a');
      $scope.date = moment($scope.ctime).format('Do MMMM YYYY');

      setInterval(function () {
        $scope.time = moment($rootScope.userSession.session.currenttime).format('h:mm a');
        $scope.date = moment($rootScope.userSession.session.currenttime).format('Do MMMM YYYY');
      }, 500);

      var handler = function () {
        $scope.cancel();
      };

      $(document).bind("mousemove keypress", handler);
      $scope.cancel = function () {
        $mdDialog.cancel();
        $rootScope.screenSaverOpened = false;
        $(document).unbind("mousemove keypress", handler);
      };


    }

    // $rootScope.showScreenSaver();


    $rootScope.shortCutFunction = function (char) {
      if (char === "ctrl+alt+shift+68") {
        $rootScope.projectInfo.debugger = $rootScope.projectInfo.debugger ? false : true;
      }
      if (char === "ctrl+116" || char === "116") {
        $state.reload();
      }
      // console.log(char);
    };

  }

})();
(function () {
  'use strict';
  var otBypass = true;
  var lgBypass = true;
  //test upload
  angular
    .module('app')
    .run(runBlockFuncSettings);

  /** @ngInject */
  function runBlockFuncSettings($rootScope, $timeout, $state, $interval, $window, getServer, toastShow, $location, $mdDialog, postServer, $http) {

    $rootScope.select2LoadedItems = [];


    $rootScope.shortCutFunction = function (char) {
      if (char === "ctrl+alt+shift+68") {
        $rootScope.projectInfo.debugger = $rootScope.projectInfo.debugger ? false : true;
      }
      if (char === "ctrl+116" || char === "116") {
        $state.reload();
      }
      // console.log(char);
    };

    $rootScope.getDFormat = function (t, format) {
      if (t === "date") {
        var dbformat = $rootScope.defaultSetup.datePicker.dbformat;
        var nformat = $rootScope.defaultSetup.datePicker.format;
        var f = format ? nformat : dbformat;
        return f;
      } else if (t === "datetime") {
        var dbformat = $rootScope.defaultSetup.datePicker.dbformat + " " + $rootScope.defaultSetup.timePicker.dbformat;
        var nformat = $rootScope.defaultSetup.datePicker.format + " " + $rootScope.defaultSetup.timePicker.format;
        var f = format ? nformat : dbformat;
        return f;
      } else if (t === "time") {
        var dbformat = $rootScope.defaultSetup.timePicker.dbformat;
        var nformat = $rootScope.defaultSetup.timePicker.format;
        var f = format ? nformat : dbformat;
        return f;
      } else if (t === "month") {
        var dbformat = $rootScope.defaultSetup.monthPicker.dbformat;
        var nformat = $rootScope.defaultSetup.monthPicker.format;
        var f = format ? nformat : dbformat;
        return f;
      } else if (t === "year") {
        var dbformat = $rootScope.defaultSetup.yearPicker.dbformat;
        var nformat = $rootScope.defaultSetup.yearPicker.format;
        var f = format ? nformat : dbformat;
        return f;
      }
    };

    $rootScope.dateToDbDate = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('date', false);
        var format = $rootScope.getDFormat('date', true);
        var dbdate = moment(val, format).format(dbformat);
        return dbdate;
      }
    };

    $rootScope.dbDateToDate = function (val) {
      if (val !== "" && val !== undefined && val !== 'nodate') {
        var dbformat = $rootScope.getDFormat('date', false);
        var format = $rootScope.getDFormat('date', true);
        var date = moment(val, dbformat).format(format);
        if (date !== "Invalid date") {
          return date;
        } else {
          return "";
        }
      } else {
        return '';
      }
    };

    $rootScope.dbDateToDate4Dt = function (val, c) {
      var d = $rootScope.dbDateToDate(val).toString();
      var f = val.replace(/\-/g, "");
      return '<span style="display: none;">' + f + c + '</span>' + d;
    };

    $rootScope.datetimeToDbDatetime = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('datetime', false);
        var format = $rootScope.getDFormat('datetime', true);
        var dbdatetime = moment(val, format).format(dbformat);
        return dbdatetime;
      }
    };

    $rootScope.dbDatetimeToDatetime = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('datetime', false);
        var format = $rootScope.getDFormat('datetime', true);
        var datetime = moment(val, dbformat).format(format);
        if (datetime !== "Invalid date") {
          return datetime;
        } else {
          return "";
        }
      }
    };

    $rootScope.timeToDbTime = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('time', false);
        var format = $rootScope.getDFormat('time', true);
        var dbtime = moment(val, format).format(dbformat);
        return dbtime;
      }
    };

    $rootScope.dbTimeToTime = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('time', false);
        var format = $rootScope.getDFormat('time', true);
        var time = moment(val, dbformat).format(format);
        return time;
      }
    };

    $rootScope.monthToDbMonth = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('month', false);
        var format = $rootScope.getDFormat('month', true);
        var dbmonth = moment(val, format).format(dbformat);
        return dbmonth;
      }
    };

    $rootScope.dbMonthToMonth = function (val) {
      if (val !== "" && val !== undefined) {
        var dbformat = $rootScope.getDFormat('month', false);
        var format = $rootScope.getDFormat('month', true);
        var month = moment(val, dbformat).format(format);
        return month;
      }
    };

    $rootScope.getCDate = function () {
      var ctime = $rootScope.userSession.session.currenttime;
      var dbformat = $rootScope.getDFormat('datetime', false);
      var format = $rootScope.getDFormat('date', true);
      var date = moment(ctime, dbformat).format(format);
      return date;
    }

    $rootScope.getCDateTime = function () {
      var ctime = $rootScope.userSession.session.currenttime;
      var dbformat = $rootScope.getDFormat('datetime', false);
      var dbformat = $rootScope.getDFormat('date', false);
      var date = moment(ctime, dbformat).format(dbformat);
      return date;
    }

    $rootScope.getCDbDate = function () {
      var ctime = $rootScope.userSession.session.currenttime;
      var dbformat = $rootScope.getDFormat('date', false);
      var date = moment(ctime, dbformat).format(dbformat);
      return date;
    };

    $rootScope.getCMonthStartDbDate = function () {
      var ctime = $rootScope.userSession.session.currenttime;
      var dbformat = $rootScope.getDFormat('date', false);
      var date = moment(ctime).startOf('month').format(dbformat);
      return date;
    };

    $rootScope.getCDbDateTime = function () {
      var ctime = $rootScope.userSession.session.currenttime;
      var dbformat = $rootScope.getDFormat('datetime', false);
      var date = moment(ctime, dbformat).format(dbformat);
      return date;
    };

    $rootScope.getCDbTime = function () {
      var ctime = $rootScope.userSession.session.currenttime;
      var dbformat = $rootScope.getDFormat('time', false);
      var date = moment(ctime).format(dbformat);
      return date;
    };

    $rootScope.subractDate = function (date, number, type, fromformat, toformat) {
      var dmom = moment(date, fromformat).subtract(number, type).format(toformat);
      return dmom;
    };

    $rootScope.addDate = function (date, number, type, fromformat, toformat) {
      var dmom = moment(date, fromformat).add(number, type).format(toformat);
      return dmom;
    };

    $rootScope.getCDbDateLess = function (number, type) {
      var cDate = $rootScope.getCDbDate();
      var dbformat = $rootScope.getDFormat('date', false);
      return $rootScope.subractDate(cDate, number, type, dbformat, dbformat);
    };

    $rootScope.getCDbDateAdd = function (number, type) {
      var cDate = $rootScope.getCDbDate();
      var dbformat = $rootScope.getDFormat('date', false);
      return $rootScope.addDate(cDate, number, type, dbformat, dbformat);
    };

    $rootScope.timeVarient = function () {

      $('time.time').each(function (i, obj) {
        var date = moment(new Date($(this).attr('datetime')));
        $(this).attr('title', $rootScope.dbDatetimeToDatetime(date));
        $(this).html(date.fromNow());
      });

      $('time.titletime').each(function (i, obj) {
        var date = moment(new Date($(this).attr('datetime')));
        $(this).attr('title', date.fromNow());
      });

      $('time.fromnowvalue').each(function (i, obj) {
        var date = moment(new Date($(this).attr('datetime')));
        $(this).attr('title', date.fromNow());
        $(this).html(date.fromNow());
      });

    }


    //For Auto Time Varient Calculation
    $interval(function () {
      $rootScope.timeVarient();
      lableTitle();
    }, 500);
    //For Auto Time Varient Calculation 


    //History Function
    $rootScope.history = {
      goBack: function (pos) {
        // console.log(pos);
        var pos = pos == undefined || pos == null || pos == "" ? 1 : pos;
        // console.log($rootScope.tempData.history[pos].furl);
        $timeout(function () {
          $location.path($rootScope.tempData.history[pos].furl);
        }, 1);
        return $rootScope.tempData.history[pos].furl;
      }
    };

    $rootScope.doReloadState = function () {
      angular.element('#stateReload').toggleClass('stateReload');
      angular.element('#stateReload').toggleClass('stateReload');
      $state.reload();
    }

    /* Functions */

    $rootScope.removeObjAttr = function (arr, attr) {
      var i = arr.length;
      if (arr.hasOwnProperty(attr)) {
        delete arr[attr];
      }
      return arr;
    }

    $rootScope.removeObjAttrs = function (arr, attrs) {
      var attr = attrs.split(",");
      var k = attr.length;
      for (var l = 0; l < k; l++) {
        if (arr.hasOwnProperty(attr[l])) {
          delete arr[attr[l]];
        }
      }
      return arr;
    }

    $rootScope.removeByAttr = function (arr, attr) {
      var i = arr.length;
      for (var j = 0; j < i; j++) {
        if (arr[j].hasOwnProperty(attr)) {
          delete arr[j][attr];
          // arr.splice(j,1);
        }
      }
      return arr;
    }

    $rootScope.removeByAttrs = function (arr, attrs) {
      var attr = attrs.split(",");
      var k = attr.length;
      var i = arr.length;
      for (var j = 0; j < i; j++) {
        for (var l = 0; l < k; l++) {
          if (arr[j].hasOwnProperty(attr[l])) {
            delete arr[j][attr[l]];
          }
        }
      }
      return arr;
    }

    $rootScope.processMultiSelectValue = function (arr) {
      if (typeof arr === 'string') {
        arr = angular.toJson(arr);
      }
      if (arr !== "") {
        var s = angular.fromJson(arr);
        s = s ? s.toString() : '';
        var res = s.replace("[", '').replace("]", '').replace('"', '');
        return res;
      } else {
        return "";
      }
    };

    $rootScope.processMultiSelectObjectValue = function (arr, key) {
      var d = [];
      arr.forEach(function (a) {
        var na = _.pairs(a);
        na.forEach(function (v) {
          if (v[0] === key) {
            d.push(v[1]);
          }
        });
      });
      return $rootScope.processMultiSelectValue(d);
    };


    $rootScope.processMultiSelectValueString = function (arr) {
      var s = angular.fromJson(arr);
      s = s ? s.toString() : '';
      var res = s.replace("[", '').replace("]", '').replace('"', '');
      var a = res.split(',');
      var string = "";
      for (var i = 0; i < a.length; i++) {
        string += "'" + a[i] + "'";
        if (i !== a.length - 1) {
          string += ',';
        }
      }
      return string;
    };

    $rootScope.copyClipboard = function (data) {
      // Create a dummy input to copy the string array inside it
      var dummy = document.createElement("input");
      // Add it to the document
      document.body.appendChild(dummy);
      // Set its ID
      dummy.setAttribute("id", "dummy_id");
      // Output the array into it  
      document.getElementById("dummy_id").value = data;
      // Select it
      dummy.select();
      // Copy its contents
      document.execCommand("copy");
      // Remove it as its not needed anymore
      document.body.removeChild(dummy);
      toastShow.show('info', 'Copied to Clipboard!', '');
    };

    $rootScope.fromatGetVars = function (obj) {
      var a = '?' + Object.keys(obj).map(function (key) {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
      }).join('&');
      return a;
    }




    $rootScope.pw_prompt = function (options, $scope) {
      $mdDialog.show({
        locals: {
          options: options,
        },
        controller: pwPromptController,
        scope: $scope,
        preserveScope: true,
        templateUrl: 'app/views/pw_prompt/pw_prompt.html',
        parent: angular.element(document.body),
        targetEvent: '',
        // clickOutsideToClose: true,
        fullscreen: true
      });
    };

    $rootScope.splitArray = function (arr, size) {
      // var d = _.chunk(ar, size);
      // // console.log(d);
      // return d;
      var newArr = [];
      for (var i = 0; i < arr.length; i += size) {
        newArr.push(arr.slice(i, i + size));
      }
      return newArr;
    };



    $rootScope.reqErrorFound = function (d, from) {
      if (issetnotempty(d.rc_error)) {
        if (Boolean(d.rc_error) === true) {
          console.log('rc_error', d);
          toastShow.show('warning', '', 'get_data_server_error');
        }
      } else if (issetnotempty(d.data) && d.data !== null && d.data !== '') {
        if (issetnotempty(d.data.rc_error)) {
          if (Boolean(d.data.rc_error) === true) {
            console.log('rc_error', d);
            toastShow.show('warning', '', 'get_data_server_error');
          }
        } else {
          // console.log('rc_ok');
        }
      } else {
        console.log('rc_error', d);
        toastShow.show('warning', '', 'get_data_server_error');
      }
    };

    $rootScope.rcValidateFrom = function (f) {
      f.$error = {};
      angular.forEach(f, function (value, key) {
        if (typeof value === 'object' && value.hasOwnProperty('$modelValue'))
          value.$validate();
      });
    };

    $rootScope.removeFromControl = function (f, cn) {
      var cns = cn.split(',');
      f.$error = {};
      angular.forEach(cns, function (v, k) {
        if (f.hasOwnProperty(v)) {
          f.$removeControl(f[v]);
        }
      });
      angular.forEach(f, function (value, key) {
        if (typeof value === 'object' && value.hasOwnProperty('$modelValue'))
          value.$validate();
      });
    };


    // Download File using Link By Function
    // Download File using Link By Function
    // Download File using Link By Function

    $rootScope.downloadURI = function (uri, name, apiserver) {
      var url = apiserver === true ? $rootScope.projectInfo.apiServer + uri : uri;
      var link = document.createElement("a");
      link.download = name;
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // delete link;
    }

    // Download File using Link By Function
    // Download File using Link By Function
    // Download File using Link By Function


    $rootScope.getStimulReportLocalKey = function (key, link) {
      var str = key + "##" + link;
      var encodedString = btoa(str);
      return "rcloudprint://" + encodedString + "/";
    };

    $rootScope.getStimulReportLocalUrl = function ($no, $getVars, $link) {
      function processGetServerURL(url, cprotocol) {
        var newUrl = cprotocol + url;
        return newUrl;
      }
      var uri = processGetServerURL($rootScope.projectInfo.apiServer, window.location.protocol);
      var pass = '';
      if (typeof $no === 'object') {
        pass = $no.pass + ($getVars ? $getVars : '');
      } else {
        pass = $no + '/' + $rootScope.userSession.session.company_info.uniquename + '/' + $rootScope.userSession.session.username + ($getVars ? $getVars : '');
      }
      return uri + $link + pass;
    };

    $rootScope.rcCurrencyConverter = function (from, to, callback) {
      var ccapi = '93f1b1f1f4f3901e03e3';
      var ccurl = 'https://free.currconv.com/api/v7/convert?q=' + from + '_' + to + '&compact=ultra&apiKey=' + ccapi;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', ccurl, true);
      xhr.responseType = 'json';
      xhr.onload = function () {
        var status = xhr.status;
        if (status === 200) {
          callback(xhr.response,null);
        } else {
          callback(xhr.response,status);
        }
      };
      xhr.send();
    };

    $rootScope.getCurrentProject = function() {
      var d = false;
      if(sessionStorage.rcloud_project !== undefined)
      {
        var p = JSON.parse(sessionStorage.rcloud_project);
        if(p.projectid)
        {
          d = p.projectid;
        }
      }
      return d;
    }


  }

})();
'use strict';

/**
 * @ngdoc function
 * @name app.controller:AppCtrl
 * @description
 * # MainCtrl
 * Controller of the app
 */
angular.module('app')  
  .controller('AppCtrl', [ '$scope', '$translate', '$localStorage', '$window', '$document', '$location', '$rootScope', '$timeout', '$mdSidenav', '$mdColorPalette', '$anchorScroll', '$http', 'postServer', 'getServer', '$mdToast', 'toastShow',
    function (            $scope,   $translate,   $localStorage,   $window,   $document,   $location,   $rootScope,   $timeout,   $mdSidenav,   $mdColorPalette,   $anchorScroll, $http, postServer, getServer, $mdToast, toastShow) {
      // add 'ie' classes to html
      var isIE = !!navigator.userAgent.match(/MSIE/i) || !!navigator.userAgent.match(/Trident.*rv:11\./);
      isIE && angular.element($window.document.body).addClass('ie');
      isSmartDevice( $window ) && angular.element($window.document.body).addClass('smart');
      // config
      $scope.app = {
        name: 'rCloud Softwares',
        version: '1.0.0',
        logoDarkSVG: 'images/logo-dark.svg',
        logoLightSVG: 'images/logo.svg',
        // for chart colors
        color: {
          primary: '#3f51b5',
          info:    '#2196f3',
          success: '#4caf50',
          warning: '#ffc107',
          danger:  '#f44336',
          accent:  '#7e57c2',
          white:   '#ffffff',
          light:   '#f1f2f3',
          dark:    '#475069'
        },
        setting: {
          theme: {
            primary: 'blue',
            accent: 'indigo',
            warn: 'amber'
          },
          asideFolded: false,
          nightMode: false,
          compactMode: true
        },
        search: {
          content: '',
          show: false
        }
      }

      $scope.$watch('app.setting.nightMode',function(n,o){
        if(n === true)
        {
          angular.element(document.body).addClass('night_mode');
        }
        else
        {
          angular.element(document.body).removeClass('night_mode');
        }
      });

      $scope.$watch('app.setting.compactMode',function(n,o){
        if(n === true)
        {
          angular.element(document.body).addClass('compact-mode');
        }
        else
        {
          angular.element(document.body).removeClass('compact-mode');
        }
      });

      $rootScope.getThemeColor = function()
      {
        return $scope.app.setting.theme.primary;
      }

      $rootScope.setTitle = function(title)
      {
        var n = $scope.app.name;
        document.title = title+" | "+n;
      }

      $scope.setTheme = function(theme){
        $scope.app.setting.theme = theme;
      }

      // save settings to local storage
      if ( angular.isDefined($localStorage.appSetting) ) {
        $scope.app.setting = $localStorage.appSetting;
      } else {
        $localStorage.appSetting = $scope.app.setting;
      }
      $scope.$watch('app.setting', function(){
        $localStorage.appSetting = $scope.app.setting;
      }, true);

      // angular translate
      $scope.langs = {en:'English'};
      $scope.selectLang = $scope.langs[$translate.proposedLanguage()] || "English";
      // console.log('pl',$translate.proposedLanguage());
      // console.log('sl',$scope.selectLang);
      $scope.setLang = function(langKey) {
        // set the current lang
        $scope.selectLang = $scope.langs[langKey];
        // You can change the language during runtime
        $translate.use(langKey);
      };

      function isSmartDevice( $window ) {
        // Adapted from http://www.detectmobilebrowsers.com
        var ua = $window['navigator']['userAgent'] || $window['navigator']['vendor'] || $window['opera'];
        // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
        return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);
      };

      $scope.getColor = function(color, hue){
        if(color == "bg-dark" || color == "bg-white") return $scope.app.color[ color.substr(3, color.length) ];
        return rgb2hex($mdColorPalette[color][hue]['value']);
      }

      //Function to convert hex format to a rgb color
      function rgb2hex(rgb) {
        return "#" + hex(rgb[0]) + hex(rgb[1]) + hex(rgb[2]);
      }

      function hex(x) {
        var hexDigits = new Array("0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f"); 
        return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
      }

      $rootScope.$on('$stateChangeSuccess', openPage);

      function openPage() {
        $scope.app.search.content = '';
        $scope.app.search.show = false;
        $scope.closeAside();
        // goto top
        $location.hash('view');
        $anchorScroll();
        $location.hash('');
      }

      $scope.goBack = function () {
        $window.history.back();
      }

      $scope.openAside = function () {
        $timeout(function() { $mdSidenav('aside').open(); });
      }
      $scope.closeAside = function () {
        $timeout(function() { $document.find('#aside').length && $mdSidenav('aside').close(); });
      }


      var vms = this;


      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */

      $rootScope.vm = {};

      $scope.doLogout = function() {
        // Do logout here..
        getServer.getData('rcloudsys/login/logout').then(function(data){
          if(data.type === 'success')
          {
            $rootScope.userSession.data = false;
            $rootScope.gotoLoginPage();
          }
        });
      }

      $rootScope.doLogoutOneTime = function() {
        $scope.doLogout();
      };

      $rootScope.rcHardReload = function() {
        location.reload(true);
      };



      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */
      /* ------------------------------ DO STUFF ---------------------------------- */


      try {
        $rootScope.getLatestControlUrls($scope);
      }
      catch(e) {

      }


    }
  ]);


// config


angular.module('app')
  .config(
    [        '$controllerProvider', '$compileProvider', '$filterProvider', '$provide',
    function ($controllerProvider,   $compileProvider,   $filterProvider,   $provide) {
        
        // lazy controller, directive and service
        app.controller = $controllerProvider.register;
        app.directive  = $compileProvider.directive;
        app.filter     = $filterProvider.register;
        app.factory    = $provide.factory;
        app.service    = $provide.service;
        app.constant   = $provide.constant;
        app.value      = $provide.value;
    }
  ])
  .config(['$translateProvider','$translatePartialLoaderProvider', '$qProvider', function($translateProvider,$translatePartialLoaderProvider, $qProvider){

    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
    $translatePartialLoaderProvider.addPart('app');

    // $qProvider.errorOnUnhandledRejections(false);

    // // Register a loader for the static files
    // // So, the module will search missing translation tables under the specified urls.
    // // Those urls are [prefix][langKey][suffix].
    // $translateProvider.useStaticFilesLoader({
    //   prefix: 'app/i18n/',
    //   suffix: '.json'
    // });
    // // Tell the module what language to use by default
    // $translateProvider.preferredLanguage('en');
    // // Tell the module to store the language in the local storage
    $translateProvider.useLocalStorage();

    

  }]);

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/partials/aside.html","<div class=\"box bg-white\"><div class=\"navbar md-whiteframe-z1 no-radius\" \nng-class=\"$state.current.data.theme ? $state.current.data.theme.primary : app.setting.theme.primary\"><a \nclass=\"navbar-brand\"><img src=\"{{app.logoLightSVG}}\" class=\"header-logo\"></a></div><div class=\"box-row\"><div \nclass=\"box-cell scrollable hover\"><div class=\"nav-box-inner box-inner\"><div class=\"p hidden-folded\" \nng-class=\"$state.current.data.theme ? $state.current.data.theme.primary+\'-50\' : app.setting.theme.primary+\'-50\'\" \nstyle=\"background-image:url(images/bg.png); background-size:cover\"><a class=\"block m-t-sm\" \nui-toggle-class=\"hide, show\" target=\"#nav, #account\"><span class=\"block font-bold\">\n{{ userSession.session.display_name }}</span> <span class=\"pull-right auto\"><i class=\"fa inline fa-caret-down\"></i> <i \nclass=\"fa none fa-caret-up\"></i> </span>{{ userSession.session.emailid }}<br><span class=\"font-bold\" \nstyle=\"margin-top: 5px\"><img ng-src=\"{{ projectInfo.flagData.url }}\" width=\"20\"> {{ projectInfo.flagData.name }}</span>\n</a></div><div id=\"nav\" ng-include=\"\'app/views/partials/aside.nav.uikit.html\'\"></div><div id=\"account\" \nclass=\"hide m-v-xs\"><nav><ul class=\"nav\"><li><a md-ink-ripple ui-sref=\"manage.profile\"><i \nclass=\"icon mdi-action-perm-contact-cal i-20\"></i> <span>My Profile</span></a></li><li><a md-ink-ripple \nui-sref=\"manage.settings\"><i class=\"icon mdi-action-settings i-20\"></i> <span>Settings</span></a></li><li><a \nmd-ink-ripple href ng-click=\"doLogout()\"><i class=\"icon mdi-action-exit-to-app i-20\"></i> <span>Logout</span></a></li>\n<li class=\"m-v-sm b-b b\"></li><li><a md-ink-ripple ui-fullscreen><i class=\"icon mdi-navigation-fullscreen i-24\"></i> \n<span>Fullscreen</span></a></li><li><div class=\"nav-item\"><label class=\"md-check\"><input type=\"checkbox\" \nng-model=\"app.setting.asideFolded\"> <i class=\"{{app.setting.theme.accent}} no-icon\"></i> <span class=\"hidden-folded\">\nFolded aside</span></label></div><div class=\"nav-item\"><label class=\"md-check\"><input type=\"checkbox\" \nng-model=\"app.setting.nightMode\"> <i class=\"{{app.setting.theme.accent}} no-icon\"></i> <span class=\"hidden-folded\">\nNight Mode</span></label></div><div class=\"nav-item\"><label class=\"md-check\"><input type=\"checkbox\" \nng-model=\"app.setting.compactMode\"> <i class=\"{{app.setting.theme.accent}} no-icon\"></i> <span class=\"hidden-folded\">\nCompact Mode</span></label></div></li><li class=\"p p-v-sm hidden-folded\"><div class=\"m-b-sm\">Theming:</div><div><div \nclass=\"pointer box pull-left m-r-sm m-b-sm\" style=\"width:32px;height:16px\" \nng-click=\"app.setting.theme = {primary: \'blue\', accent: \'indigo\', warn: \'amber\'}\"><span class=\"blue col-xs-4 box-col\">\n</span> <span class=\"indigo col-xs-4 box-col\"></span> <span class=\"amber col-xs-4 box-col\"></span></div><div \nclass=\"pointer box pull-left m-r-sm m-b-sm\" style=\"width:32px;height:16px\" \nng-click=\"app.setting.theme = {primary: \'indigo\', accent: \'green\', warn: \'amber\'}\"><span \nclass=\"indigo col-xs-4 box-col\"></span> <span class=\"green col-xs-4 box-col\"></span> <span \nclass=\"amber col-xs-4 box-col\"></span></div><div class=\"pointer box pull-left m-r-sm m-b-sm\" \nstyle=\"width:32px;height:16px\" ng-click=\"app.setting.theme = {primary: \'green\', accent: \'light-green\', warn: \'lime\'}\">\n<span class=\"green col-xs-4 box-col\"></span> <span class=\"light-green col-xs-4 box-col\"></span> <span \nclass=\"lime col-xs-4 box-col\"></span></div><div class=\"pointer box pull-left m-r-sm m-b-sm\" \nstyle=\"width:32px;height:16px\" \nng-click=\"app.setting.theme = {primary: \'deep-purple\', accent: \'blue\', warn: \'light-blue\'}\"><span \nclass=\"deep-purple col-xs-4 box-col\"></span> <span class=\"blue col-xs-4 box-col\"></span> <span \nclass=\"light-blue col-xs-4 box-col\"></span></div><div class=\"pointer box pull-left m-r-sm m-b-sm\" \nstyle=\"width:32px;height:16px\" ng-click=\"app.setting.theme = {primary: \'cyan\', accent: \'teal\', warn: \'green\'}\"><span \nclass=\"cyan col-xs-4 box-col\"></span> <span class=\"teal col-xs-4 box-col\"></span> <span class=\"green col-xs-4 box-col\">\n</span></div><div class=\"pointer box pull-left m-r-sm m-b-sm\" style=\"width:32px;height:16px\" \nng-click=\"app.setting.theme = {primary: \'pink\', accent: \'deep-purple\', warn: \'purple\'}\"><span \nclass=\"pink col-xs-4 box-col\"></span> <span class=\"deep-purple col-xs-4 box-col\"></span> <span \nclass=\"purple col-xs-4 box-col\"></span></div><div class=\"pointer box pull-left m-r-sm m-b-sm\" \nstyle=\"width:32px;height:16px\" ng-click=\"app.setting.theme = {primary: \'blue-grey\', accent: \'teal-200\', warn: \'lime\'}\">\n<span class=\"blue-grey col-xs-4 box-col\"></span> <span class=\"teal-200 col-xs-4 box-col\"></span> <span \nclass=\"lime col-xs-4 box-col\"></span></div><div class=\"pointer box pull-left m-r-sm m-b-sm\" \nstyle=\"width:32px;height:16px\" \nng-click=\"app.setting.theme = {primary: \'bg-dark\', accent: \'green-300\', warn: \'amber-300\'}\"><span \nclass=\"bg-dark col-xs-4 box-col\"></span> <span class=\"green-300 col-xs-4 box-col\"></span> <span \nclass=\"amber-300 col-xs-4 box-col\"></span></div></div></li></ul></nav></div></div></div></div><nav><ul \nclass=\"nav b-t b\" ng-click=\"rcHardReload()\"><li><a href=\"\" target=\"_blank\" tabindex=\"-1\" md-ink-ripple><i \nclass=\"icon mdi-notification-system-update i-20\"></i> <span>Get Latest Updates!</span></a></li></ul></nav></div>");
$templateCache.put("app/views/partials/aside.nav.uikit.html","<nav ui-nav><ul class=\"nav\"><li class=\"m-v-sm\"></li><li><a md-ink-ripple ui-sref=\"app.home\" tabindex=\"-1\"><i \nclass=\"fa fa-home\"></i> Home</a></li><li class=\"b-b b m-v-sm\"></li></ul><ul class=\"nav\"><li><input type=\"text\" \nng-model=\"psearch\" style=\"margin-left: 10px; width: 90%; border: none; border-bottom: 1px solid lightgrey\" \nplaceholder=\"Enter to Search in Menu\"></li><li class=\"b-b b m-v-sm\"></li></ul><ul class=\"nav\" \nng-if=\"!menu_settings.project\"><li class=\"nav-header m-v-sm hidden-folded\"><i class=\"fa fa-clock-o\"></i>\n Select a Project!</li></ul><ul class=\"nav\" ng-if=\"menu_settings.project\"><li class=\"nav-header m-v-sm hidden-folded\">\n<i class=\"{{ menu_settings.project.icon }}\"></i> {{ menu_settings.project.name }}</li><li \nng-repeat=\"group in menu_settings.modelgroups | orderBy : group.show_order | filter:psearch track by $index\" \nng-class=\"{ \'active\': group.mod_group_id == selectedIndex || psearch }\" class=\"fadeInUp animated delay{{$index}}\"><a \nmd-ink-ripple ng-click=\"menuitemClicked(group.mod_group_id)\"><span class=\"pull-right text-muted\"><i \nclass=\"fa fa-caret-down\"></i> </span><i class=\"{{ group.icon }}\"></i> <span class=\"font-normal\">{{ group.name }}</span>\n</a><ul class=\"nav nav-sub\" \nng-repeat=\"model in group.models | orderBy : model.show_order | filter:psearch track by $index\" \nng-class=\"{ \'active\': model.model_id == selectedMIndex }\" ng-click=\"menumodelClicked(model.model_id)\" \nclass=\"fadeInUp animated delay{{$index}}\"><li ng-click=\"gotoLink(model.uref)\"><a md-ink-ripple><i \nclass=\"{{ model.icon }}\"></i> {{ model.name }}</a></li></ul></li></ul></nav>");
$templateCache.put("app/views/partials/content.html","<div class=\"box\"><div class=\"navbar md-whiteframe-z1 no-radius\" \nng-class=\"$state.current.data.theme ? $state.current.data.theme.primary : app.setting.theme.primary\"><a md-ink-ripple \nng-click=\"openAside()\" ng-hide=\"$state.current.data.child\" class=\"navbar-item pull-left visible-xs visible-sm\"><i \nclass=\"mdi-navigation-menu i-24\"></i> </a><a md-ink-ripple class=\"navbar-item pull-left\" ng-click=\"goBack()\" \nng-show=\"$state.current.data.child\"><i class=\"mdi-navigation-arrow-back i-24\"></i></a><div \nclass=\"navbar-item pull-left h4 pageTitle bsTooltipBottom\" title=\"{{ $state.current.data.title }}\" \nng-bind=\"$state.current.data.title\"></div><a md-ink-ripple class=\"navbar-item pull-left stateReload pctabonly\" \nid=\"stateReload\" title=\"Reload\" tabindex=\"-1\" href ng-click=\"doReloadState()\"><i class=\"mdi-av-replay i-24\"></i> </a><a\n md-ink-ripple href=\"app/home\" class=\"navbar-item pull-left\" tabindex=\"-1\" title=\"Home\" href><i \nclass=\"mdi-action-home i-24\"></i></a><ul class=\"nav nav-sm navbar-tool pull-right\" ng-hide=\"$state.current.data.child\">\n<li><div class=\"loadspinner pctabonly\" ng-if=\"loadingProgress\"><div class=\"spinner-icon\"></div></div></li><li \nng-if=\"projectSettingsButton()\"><a md-ink-ripple class=\"navbar-item pull-right\" ng-click=\"changePSettings()\" \ntabindex=\"-1\" title=\"Settings\" href><i class=\"mdi-action-assignment i-24\"></i></a></li><li \nng-if=\"menu_settings.project.name\"><a md-ink-ripple title=\"Apps\" tabindex=\"-1\" class=\"pictoButton\" href><i \nclass=\"mdi-navigation-apps i-24\"></i></a><div class=\"picto pictoNaviMenu pictoMenu animated fadeIn\"><div \nstyle=\"padding: 0; margin:0\"><div class=\"row\" align=\"center\"><i class=\"{{ menu_settings.project.icon }}\"></i>\n {{ menu_settings.project.name }}</div><div class=\"row\" style=\"margin-top: 15px; margin-bottom: 15px\" align=\"center\">\n<input type=\"text\" ng-model=\"psearch\" \nstyle=\"margin-left: 10px; width: 90%; border: none; border-bottom: 1px solid lightgrey\" \nplaceholder=\"Enter to Search in Items\"></div><div class=\"row\" \nng-repeat=\"group in menu_settings.modelgroups | orderBy : \'group.show_order\' | filter:psearch track by $index\" \nng-if=\"psearch\" style=\"margin-top: 25px\"><div class=\"row\" \nstyle=\"cursor:pointer; width: 100%; height: 35px; background-color: rgba(0,0,0,0.1); padding: 10px\"><div \nstyle=\"float: left; font-size: 15px; width: 100%\" align=\"center\">{{ group.name }}</div></div><div class=\"row flex-row\" \nstyle=\"margin-top: 25px\"><div class=\"col-md-4 col-xs-6\" ng-click=\"gotoLink(model.uref)\" style=\"margin-bottom: 15px\" \nalign=\"center\" ng-repeat=\"model in group.models | orderBy : \'model.show_order\' | filter:psearch track by $index\"><a \nhref class=\"{{app.setting.theme.primary}}projectbutton pictoitembut pictoLink\"><i class=\"{{ model.icon }}\" \nstyle=\"font-size: 40px\"></i><p><b style=\"font-size: 12px\">{{ model.name }}</b></p></a></div></div></div><div \nng-if=\"!psearch\" class=\"row flex-row modelsGroupPicto\" style=\"margin-top: 25px\"><div \nng-repeat=\"group in menu_settings.modelgroups track by group.mod_group_id | orderBy : \'group.show_order\'\" class=\"\"><div\n class=\"clearfix\" ng-if=\"$index % 3 == 0\"></div><div ng-click=\"selectPictoGroup(group)\" \nclass=\"col-md-4 col-xs-6 animated fadeIn\" style=\"margin-bottom: 15px\" align=\"center\"><a href \nclass=\"{{app.setting.theme.primary}}projectbutton pictoGroupButton\"><i class=\"{{ group.icon }}\" \nstyle=\"font-size: 40px\"></i><p><b style=\"font-size: 12px\">{{ group.name }}</b></p></a></div></div></div><div \nclass=\"row modelsPicto\" style=\"margin-top: 25px\" ng-if=\"!psearch\"><div class=\"row modelBackButton\" \nstyle=\"cursor:pointer; width: 100%; height: 35px; background-color: rgba(0,0,0,0.1); padding: 10px\"><a href \nstyle=\"float: left; width: 10%\" class=\"\"><i class=\"fa fa-chevron-left\" style=\"font-size: 15px; float: left\"></i></a>\n<div style=\"float: left; font-size: 15px; width: 90%; margin-left: -15px\" align=\"center\">{{ selectedPictoGroup.name }}\n</div></div><div class=\"row flex-row\" style=\"margin-top: 25px\"><div class=\"clearfix\" ng-if=\"$index % 3 == 0\"></div><div\n class=\"col-md-4 col-xs-6\" ng-click=\"gotoLink(model.uref)\" style=\"margin-bottom: 15px\" align=\"center\" \nng-repeat=\"model in selectedPictoGroup.models track by model.model_id | orderBy : \'model.show_order\'\"><a href \nclass=\"{{app.setting.theme.primary}}projectbutton pictoitembut pictoLink\"><i class=\"{{ model.icon }}\" \nstyle=\"font-size: 40px\"></i><p><b style=\"font-size: 12px\">{{ model.name }}</b></p></a></div></div></div></div></div>\n</li><li><a md-ink-ripple title=\"Logout\" tabindex=\"-1\" href ng-click=\"doLogout()\"><i \nclass=\"mdi-action-exit-to-app i-24\"></i></a></li></ul><div class=\"pull-right\" ui-view=\"navbar@\"></div></div><div \nclass=\"box-row {{ $state.current.data.bgclass }}\" \nng-class=\"$state.current.data.theme && $state.current.data.bgclass ? $state.current.data.theme.primary+\'-50\' : ( $state.current.data.bgclass ? app.setting.theme.primary+\'-50\' : \'\' ) \">\n<div class=\"box-cell\"><div class=\"box-inner padding animated bounceInUp\" \nng-class=\"{ \'noMarginPage\': $state.current.data.nomargin }\" ui-view id=\"view\"></div></div></div></div>");
$templateCache.put("app/views/partials/email_sender.html","<md-dialog aria-label=\"Send Email\" style=\"width: 60%\" tabindex=\"1\"><md-toolbar class=\"{{getThemeColor()}}\"><div \nclass=\"md-toolbar-tools\"><h3>Send E-Mail</h3><span flex></span><md-button class=\"md-icon-button\" \nng-disabled=\"runningSettings.$invalid\" tabindex=\"-1\" ng-click=\"cancel()\"><i class=\"fa fa-close\" tabindex=\"-1\" \naria-label=\"Close dialog\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"row\" style=\"margin: 15px\">\n<form name=\"emailHub\" id=\"emailHub\"><div class=\"row\"><div bind-html-compile=\"toAddressBox()\"></div><textbox \nquickattrs=\"subject\" itemtype=\"private\" modelname=\"emailHubData.settings.subject\"></textbox></div><div class=\"row\"><div\n class=\"col-md-12\"><label for=\"mail\">Message</label><textarea ui-tinymce=\"tinymceOptions\" \nng-model=\"emailHubData.settings.message\"></textarea><br></div></div><div class=\"row\"><div class=\"col-md-12\"><p><i>\n* Report File is Automatically Attached to this E-Mail!</i></p></div></div><div class=\"row\"><div class=\"col-md-12\" \nalign=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"emailHub.$invalid\" ng-click=\"sendEmail()\">\nSend E-Mail</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nForm Live Value</h4><pre>{{ emailHubData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ emailHub | json }}</pre></div></div></div></md-dialog-content></md-dialog>\"");
$templateCache.put("app/views/partials/full_screen_content.html","<div class=\"box\"><div class=\"box-row {{ $state.current.data.bgclass }}\"><div class=\"box-cell\"><div \nclass=\"box-inner padding animated bounceInUp\" ng-class=\"{ \'noMarginPage\': $state.current.data.nomargin }\" ui-view \nid=\"view\"></div></div></div></div>");
$templateCache.put("app/views/partials/full_screen_layout.html","<div id=\"content\" class=\"app-content\" role=\"main\" ui-view=\"content@\"></div>");
$templateCache.put("app/views/partials/layout.html","<md-sidenav id=\"aside\" class=\"app-aside md-sidenav-left\" \nng-class=\"{\'folded\': app.setting.asideFolded || $state.current.data.folded}\" ui-view=\"aside@\" md-component-id=\"aside\">\n</md-sidenav><div id=\"content\" class=\"app-content\" role=\"main\" ui-view=\"content@\"></div>");
$templateCache.put("app/views/partials/projectsettings.html","<md-dialog aria-label=\"Project Settings\" style=\"width: 40%; overflow: hidden\" tabindex=\"1\"><md-toolbar \nclass=\"{{getThemeColor()}}\"><div class=\"md-toolbar-tools\"><h3>Change Settings</h3><span flex></span><md-button \nclass=\"md-icon-button\" ng-disabled=\"runningSettings.$invalid\" tabindex=\"-1\" ng-click=\"cancel()\"><i class=\"fa fa-close\" \ntabindex=\"-1\" aria-label=\"Close dialog\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"row\" \nstyle=\"margin: 15px\"><form name=\"runningSettings\" id=\"runningSettings\"><div bind-html-compile=\"getProjectSettings()\">\n</div></form><div class=\"row\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><button \nclass=\"btn btn-primary\" ng-disabled=\"runningSettings.$invalid\" ng-click=\"saveProjectSettings()\">Save</button></div>\n</div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><pre>{{ runningSettings | json }}</pre></div>\n<div class=\"col-md-6\"><pre>{{ runningSettingsData | json }}</pre></div></div></div></md-dialog-content></md-dialog>\"");
$templateCache.put("app/views/partials/screen_saver.html","<md-dialog aria-label=\"Remarks\" class=\"fullscreen-sc-saver\" style=\"overflow: hidden\" tabindex=\"1\"><div \nclass=\"screensaver\"><div class=\"container\" ng-style=\"bgImage\" style=\"{{ bgImage }}\"><center style=\"position: absolute\">\n<h2 style=\"font-family: \'Audiowide\', cursive\">{{ time }}</h2><h4 style=\"font-family: \'Audiowide\', cursive\">{{ date }}\n</h4><h6 class=\"animated infinite fadeIn\">Move Mouse or Click Any Button Close Screen Saver</h6></center><br><div \nclass=\"bird-container bird-container--one\"><div class=\"bird bird--one\"></div></div><div \nclass=\"bird-container bird-container--two\"><div class=\"bird bird--two\"></div></div><div \nclass=\"bird-container bird-container--three\"><div class=\"bird bird--three\"></div></div><div \nclass=\"bird-container bird-container--four\"><div class=\"bird bird--four\"></div></div><div class=\"row\" id=\"youtubeDiv\">\n<div id=\"ytplayer\"></div></div><marquee direction=\"down\" style=\"width: 100vw; height: 100vh\" behavior=\"alternate\" \nscrollamount=\"12\"><marquee behavior=\"alternate\" scrollamount=\"12\"><h1 style=\"font-family: \'Kaushan Script\', cursive\">\n<span style=\"color:rgb(0, 162, 255)\">{{ projectInfo.projectTitle }}</span></h1></marquee></marquee></div></div>\n</md-dialog>");
$templateCache.put("app/views/pw_prompt/pw_prompt.html","<md-dialog md-theme=\"default\" aria-label=\"Password\" class=\"_md md-default-theme md-transition-in\" role=\"dialog\">\n<md-dialog-content class=\"md-dialog-content\" role=\"document\" tabindex=\"-1\"><h4>{{ options.lm }}</h4><form \nname=\"pw_prmt\" id=\"pw_prmt\"><md-input-container class=\"md-prompt-input-container\"><input type=\"password\" \nng-model=\"del_password\" ng-required=\"true\" name=\"delete_pass_pw\" id=\"delete_pass_pw\" required=\"required\" \naria-label=\"Password\"></md-input-container></form><div class=\"row\" align=\"right\"><button \nclass=\"md-primary md-confirm-button md-button md-ink-ripple md-default-theme\" type=\"button\" \nng-disabled=\"pw_prmt.$invalid\" ng-click=\"submit()\">Submit</button> <button \nclass=\"md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"cancel()\" tabindex=\"-1\">Cancel</button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/projects/rcloudsys/installation_report/listcompaniesdetail.html","<div class=\"row no-print\" style=\"padding-top: 25px\"><rd-window header=\"View & Print Machine Calender\" \nfooter=\"View & Print Machine Calender\" wcollaspeable=\"true\"><form name=\"viewCard\" id=\"viewCard\"><div class=\"row\">\n<selectbox required=\"true\" quickattrs=\"project\" size=\"col-md-3\"></selectbox><selectbox required=\"true\" \nquickattrs=\"statusrunning\" size=\"col-md-3\"></selectbox></div><div class=\"row\"><div class=\"col-md-12\" align=\"right\">\n<button type=\"button\" ng-disabled=\"viewCard.$invalid\" class=\"btn btn-info\" ng-click=\"showPrint()\">Print</button></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Validation</h4><pre>\n{{ viewCard | json }}</pre></div><div class=\"col-md-6\"><h4>Live Data</h4><pre>{{ viewCardData | json }}</pre></div>\n</div></rd-window></div><div bind-html-compile=\"reportViewer\"></div>");
$templateCache.put("app/projects/rcloudsys/st_designer/st_designer.html","<a \nstyle=\"position: absolute; top: 3px; left: 95vw; z-index: 9999999; color: #ffffff !important;    background: none; color: #ffffff !important; border: none; padding: 8px; font-weight: 400\" \nng-click=\"history.goBack()\" ng-if=\"cid\"><i class=\"fa fa-step-backward\"></i> <b>Back</b></a> <a \nstyle=\"position: absolute; top: 3px; left: 93vw; z-index: 9999999; color: #ffffff !important;    background: none; color: #ffffff !important; border: none; padding: 8px; font-weight: 400\" \nhref=\"app/home\" ng-if=\"!cid\"><i class=\"fa fa-home\"></i> <b>Home</b></a><div ng-init=\"init()\"><div id=\"designer\"></div>\n</div>");
$templateCache.put("app/projects/rcloudsys/tester/tester.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"></div>\n</div><div class=\"row\"><rd-window header=\"Test API URL\" footer=\"Test API URL\" size=\"col-md-12\"><form name=\"tester\" \nid=\"tester\"><div class=\"row\"><textbox quickattrs=\"testerurl\"></textbox></div><div class=\"row\"><div class=\"col-md-6\">\n<button type=\"submit\" ng-disabled=\"tester.$invalid\" class=\"btn btn-info m-t\" ng-click=\"result(\'result\')\">Result\n</button> <button type=\"submit\" ng-disabled=\"tester.$invalid\" class=\"btn btn-info m-t\" ng-click=\"result(\'complete\')\">\nComplete Data</button></div></div><br><br><div class=\"row\"><div class=\"col-md-12\"><h4>Form Live Value</h4><pre>\n{{ data | json }}</pre></div></div></form></rd-window></div>");
$templateCache.put("app/views/auth/forgot-password/forgot-password.html","<div class=\"center-block w-xxl w-auto-xs p-v-md\"><div class=\"navbar\"><div \nclass=\"navbar-brand m-t-lg text-center m-b-md\"><img src=\"{{app.logoDarkSVG}}\" class=\"logo\"></div></div><div \nclass=\"p-lg panel md-whiteframe-z1 text-color m\" ng-if=\"vm.fogetPassword\"><div class=\"m-b\">Forgot your password?<p \nclass=\"text-xs m-t\">Enter your email id below and we will send you instructions on how to change your password.</p>\n</div><form name=\"forgetPassword\" id=\"forgetPassword\"><div class=\"row rownopadding\"><textbox quickattrs=\"loginEmail\">\n</textbox></div><br><button md-ink-ripple type=\"submit\" class=\"md-btn md-raised pink btn-block p-h-md\" \ntitle=\"Forget Password\" data-content=\"Instructions sent to your email.\" data-type=\"info\" \ndata-container=\"#alerts-container\" bs-alert ng-disabled=\"forgetPassword.$invalid\" ng-click=\"doForgetPassword()\">\nForget Password</button></form></div><div class=\"p-lg panel md-whiteframe-z1 text-color m\" ng-if=\"vm.resetPassword\">\n<div class=\"m-b\">Enter OTP to Reset Password?<p class=\"text-xs m-t\">\nEnter One Time Password recived to your registred mobile no below and we will send you reset and sent you a new Password.\n</p><p>Your Mobile No:</p><p>+{{ vm.fpass.mobile }}</p></div><form name=\"reset\" id=\"reset\"><div \nclass=\"row rownopadding\"><textbox quickattrs=\"oneTimePassword\"></textbox></div><br><button md-ink-ripple type=\"submit\" \nclass=\"md-btn md-raised pink btn-block p-h-md\" title=\"Hey!\" ng-disabled=\"reset.$invalid\" ng-click=\"doResetPassword()\">\nReset Password</button></form><div ng-if=\"vm.resetPassResentOTP\"><p>&nbsp;</p><p>I am not Recived OTP till now!</p>\n<button md-ink-ripple type=\"button\" class=\"md-btn md-raised pink btn-block p-h-md\" title=\"Resent OTP\" \nng-click=\"doResendOTP()\">Resend OTP</button></div><div ng-if=\"vm.resetPassResentOTPLimit\"><p>&nbsp;</p><p>\nMaximum OTP Limit Reached Try after sometime!..</p></div></div><div class=\"p-lg panel md-whiteframe-z1 text-color m\" \nng-if=\"vm.resetNewPassword\"><div class=\"m-b\">Reset Your Password!<p class=\"text-xs m-t\">\nNew Password and Confirm Password should be same</p></div><form name=\"resetPassword\" id=\"resetPassword\"><div \nclass=\"row rownopadding\"><textbox quickattrs=\"loginPassword\"></textbox><textbox quickattrs=\"loginPassword\" \nmodelname=\"conformpassword\" itemid=\"conformpassword\"></textbox></div><br><button md-ink-ripple type=\"submit\" \nclass=\"md-btn md-raised pink btn-block p-h-md\" title=\"Forget Password\" data-content=\"Instructions sent to your email.\" \ndata-type=\"info\" data-container=\"#alerts-container\" bs-alert \nng-disabled=\"(resetPasswordData.password === resetPasswordData.conformpassword) ? resetPassword.$invalid : true\" \nng-click=\"doResetNewPassword()\">Change Password</button></form></div><div \nclass=\"p-lg panel md-whiteframe-z1 text-color m\" ng-if=\"vm.resetPasswordSuccess\"><div class=\"m-b\">\nPassword Reseted Successfully!<p class=\"text-xs m-t\">Sign in Using a New Password</p></div><button \nui-sref=\"auth.signin\" md-ink-ripple type=\"button\" class=\"md-btn md-raised pink btn-block p-h-md\" title=\"Sign In\">\nSign In</button></div><p id=\"alerts-container\"></p><div class=\"p-v-lg text-center\" ng-if=\"vm.fogetPassword\" \nstyle=\"color: white\">Return to <button ui-sref=\"auth.signin\" style=\"color: white\" class=\"md-btn\">sign in</button></div>\n</div>");
$templateCache.put("app/views/auth/load/load.html","<style type=\"text/css\">\n#rcloud-splash-screen-load {\r\n        display: block;\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        background-color: #2D323D;\r\n        z-index: 99999;\r\n        pointer-events: none;\r\n    }\r\n\r\n    #rcloud-splash-screen-load .center {\r\n        display: block;\r\n        width: 100%;\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n    }\r\n\r\n    #rcloud-splash-screen-load .logo {\r\n        width: 128px;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    #rcloud-splash-screen-load .logo img {\r\n        filter: drop-shadow(0px 10px 6px rgba(0, 0, 0, 0.2))\r\n    }\r\n\r\n    .spinner-wrapper {\r\n        display: block;\r\n        position: relative;\r\n        width: 100%;\r\n        min-height: 100px;\r\n        height: 100px;\r\n    }\r\n\r\n    .spinner-wrapper .spinner {\r\n        position: absolute;\r\n        overflow: hidden;\r\n        left: 50%;\r\n        margin-left: -50px;\r\n        animation: outer-rotate 2.91667s linear infinite;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner {\r\n        width: 100px;\r\n        height: 100px;\r\n        position: relative;\r\n        animation: sporadic-rotate 5.25s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .gap {\r\n        position: absolute;\r\n        left: 49px;\r\n        right: 49px;\r\n        top: 0;\r\n        bottom: 0;\r\n        border-top: 10px solid;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .left,\r\n    .spinner-wrapper .spinner .inner .right {\r\n        position: absolute;\r\n        top: 0;\r\n        height: 100px;\r\n        width: 50px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .left .half-circle {\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100px;\r\n        height: 100px;\r\n        box-sizing: border-box;\r\n        border: 10px solid rgb(88, 252, 101);\r\n        border-bottom-color: transparent;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .right .half-circle {\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100px;\r\n        height: 100px;\r\n        box-sizing: border-box;\r\n        border: 10px solid #4285F4;\r\n        border-bottom-color: transparent;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .left {\r\n        left: 0;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .left .half-circle {\r\n        left: 0;\r\n        border-right-color: transparent;\r\n        animation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n        -webkit-animation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .right {\r\n        right: 0;\r\n    }\r\n\r\n    .spinner-wrapper .spinner .inner .right .half-circle {\r\n        right: 0;\r\n        border-left-color: transparent;\r\n        animation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n        -webkit-animation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n    }\r\n\r\n    @keyframes outer-rotate {\r\n        0% {\r\n            transform: rotate(0deg) scale(0.5);\r\n        }\r\n\r\n        100% {\r\n            transform: rotate(360deg) scale(0.5);\r\n        }\r\n    }\r\n\r\n    @keyframes left-wobble {\r\n\r\n        0%,\r\n        100% {\r\n            transform: rotate(130deg);\r\n        }\r\n\r\n        50% {\r\n            transform: rotate(-5deg);\r\n        }\r\n    }\r\n\r\n    @keyframes right-wobble {\r\n\r\n        0%,\r\n        100% {\r\n            transform: rotate(-130deg);\r\n        }\r\n\r\n        50% {\r\n            transform: rotate(5deg);\r\n        }\r\n    }\r\n\r\n    @keyframes sporadic-rotate {\r\n        12.5% {\r\n            transform: rotate(135deg);\r\n        }\r\n\r\n        25% {\r\n            transform: rotate(270deg);\r\n        }\r\n\r\n        37.5% {\r\n            transform: rotate(405deg);\r\n        }\r\n\r\n        50% {\r\n            transform: rotate(540deg);\r\n        }\r\n\r\n        62.5% {\r\n            transform: rotate(675deg);\r\n        }\r\n\r\n        75% {\r\n            transform: rotate(810deg);\r\n        }\r\n\r\n        87.5% {\r\n            transform: rotate(945deg);\r\n        }\r\n\r\n        100% {\r\n            transform: rotate(1080deg);\r\n        }\r\n    }\r\n\r\n    .adBanner {\r\n        background-color: transparent;\r\n        height: 1px;\r\n        width: 1px;\r\n    }\r\n\r\n    .addBlockerMessage {\r\n        display: none;\r\n    }\r\n\r\n    body.no-add-block>.addBlockerMessage {\r\n        z-index: -1;\r\n        display: none;\r\n    }\r\n\r\n    body.add-block-found>.addBlockerMessage {\r\n        display: block;\r\n        z-index: 99;\r\n        width: 100%;\r\n        position: absolute;\r\n        bottom: 0;\r\n        padding: 10px;\r\n        background-color: white;\r\n        border-top: 1px solid gray;\r\n    }\n</style><div id=\"rcloud-splash-screen-load\"><div class=\"center\"><div class=\"logo\"><img width=\"128\" \nsrc=\"images/logos/rcloud.svg\"></div><div class=\"spinner-wrapper\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div><p style=\"color: white\" align=\"center\">Starting Your Application!..</p></div></div>");
$templateCache.put("app/views/auth/lockme/lockme.html","<div class=\"modal-over login-bg\"><div class=\"modal-center text-center animated fadeInUp\" \nstyle=\"width:240px;margin:-120px 0 0 -120px\"><div class=\"m-b\"><div class=\"m-t-md font-bold\">\n{{ userSession.session.display_name }}</div></div><div class=\"md-form-group\"><input type=\"password\" minlength=\"4\" \nclass=\"md-input text-center\"><label class=\"block w-full\">Enter Your Password to Unlock this Session</label></div><div \nclass=\"m-t\"><a href=\"#/\" class=\"md-btn md-raised pink p-h-md\">Unlock</a></div></div></div>");
$templateCache.put("app/views/auth/signin/signin.html","<div class=\"center-block w-xxl w-auto-xs p-v-md\"><div class=\"navbar\"><div class=\"m-t-lg text-center m-b-md\"><img \nsrc=\"{{app.logoDarkSVG}}\" class=\"logo login-page-logo\"></div></div><div \nclass=\"p-lg panel md-whiteframe-z1 text-color m\" ng-show=\"!showLoading\"><div class=\"m-b text-sm\">\nSign in with your {{app.name}} Account</div><form id=\"loginForm\" name=\"loginForm\"><div class=\"row rownopadding\">\n<textbox quickattrs=\"loginEmail\"></textbox><textbox quickattrs=\"loginPassword\"></textbox></div><div \nclass=\"row rownopadding\" ng-show=\"showTwoFact\"><textbox quickattrs=\"twofactcode\" rdrequired=\"showTwoFact\"></textbox>\n</div><br><button md-ink-ripple type=\"submit\" class=\"md-btn md-raised pink btn-block p-h-md\" \nng-disabled=\"loginForm.$invalid\" ng-click=\"doLogin()\">Sign in</button><br><br><div class=\"m-b text-sm\" align=\"center\">\n<img ng-src=\"{{ projectInfo.flagData.url }}\" width=\"20\"> {{ projectInfo.flagData.name }}</div></form></div><div \nclass=\"p-v-lg text-center\" ng-show=\"!showLoading\"><div class=\"m-b\"><button ui-sref=\"auth.forgot-password\" \nclass=\"md-btn\" style=\"color: white\">Forgot password?</button></div></div><div ng-show=\"showLoading\"><div \nclass=\"spinner-wrapper\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div><p \nid=\"systemStatus\" style=\"color: white\" align=\"center\">Checking your account...</p></div></div><style type=\"text/css\">\n#rcloud-splash-screen-load {\r\n      display: block;\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      background-color: #2D323D;\r\n      z-index: 99999;\r\n      pointer-events: none;\r\n  }\r\n\r\n  #rcloud-splash-screen-load .center {\r\n      display: block;\r\n      width: 100%;\r\n      position: absolute;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n  }\r\n\r\n  #rcloud-splash-screen-load .logo {\r\n      width: 128px;\r\n      margin: 0 auto;\r\n  }\r\n\r\n  #rcloud-splash-screen-load .logo img {\r\n      filter: drop-shadow(0px 10px 6px rgba(0, 0, 0, 0.2))\r\n  }\r\n\r\n  .spinner-wrapper {\r\n      display: block;\r\n      position: relative;\r\n      width: 100%;\r\n      min-height: 100px;\r\n      height: 100px;\r\n  }\r\n\r\n  .spinner-wrapper .spinner {\r\n      position: absolute;\r\n      overflow: hidden;\r\n      left: 50%;\r\n      margin-left: -50px;\r\n      animation: outer-rotate 2.91667s linear infinite;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner {\r\n      width: 100px;\r\n      height: 100px;\r\n      position: relative;\r\n      animation: sporadic-rotate 5.25s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .gap {\r\n      position: absolute;\r\n      left: 49px;\r\n      right: 49px;\r\n      top: 0;\r\n      bottom: 0;\r\n      border-top: 10px solid;\r\n      box-sizing: border-box;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .left,\r\n  .spinner-wrapper .spinner .inner .right {\r\n      position: absolute;\r\n      top: 0;\r\n      height: 100px;\r\n      width: 50px;\r\n      overflow: hidden;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .left .half-circle {\r\n      position: absolute;\r\n      top: 0;\r\n      width: 100px;\r\n      height: 100px;\r\n      box-sizing: border-box;\r\n      border: 10px solid rgb(88, 252, 101);\r\n      border-bottom-color: transparent;\r\n      border-radius: 50%;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .right .half-circle {\r\n      position: absolute;\r\n      top: 0;\r\n      width: 100px;\r\n      height: 100px;\r\n      box-sizing: border-box;\r\n      border: 10px solid #4285F4;\r\n      border-bottom-color: transparent;\r\n      border-radius: 50%;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .left {\r\n      left: 0;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .left .half-circle {\r\n      left: 0;\r\n      border-right-color: transparent;\r\n      animation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n      -webkit-animation: left-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .right {\r\n      right: 0;\r\n  }\r\n\r\n  .spinner-wrapper .spinner .inner .right .half-circle {\r\n      right: 0;\r\n      border-left-color: transparent;\r\n      animation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n      -webkit-animation: right-wobble 1.3125s cubic-bezier(0.35, 0, 0.25, 1) infinite;\r\n  }\r\n\r\n  @keyframes outer-rotate {\r\n      0% {\r\n          transform: rotate(0deg) scale(0.5);\r\n      }\r\n\r\n      100% {\r\n          transform: rotate(360deg) scale(0.5);\r\n      }\r\n  }\r\n\r\n  @keyframes left-wobble {\r\n\r\n      0%,\r\n      100% {\r\n          transform: rotate(130deg);\r\n      }\r\n\r\n      50% {\r\n          transform: rotate(-5deg);\r\n      }\r\n  }\r\n\r\n  @keyframes right-wobble {\r\n\r\n      0%,\r\n      100% {\r\n          transform: rotate(-130deg);\r\n      }\r\n\r\n      50% {\r\n          transform: rotate(5deg);\r\n      }\r\n  }\r\n\r\n  @keyframes sporadic-rotate {\r\n      12.5% {\r\n          transform: rotate(135deg);\r\n      }\r\n\r\n      25% {\r\n          transform: rotate(270deg);\r\n      }\r\n\r\n      37.5% {\r\n          transform: rotate(405deg);\r\n      }\r\n\r\n      50% {\r\n          transform: rotate(540deg);\r\n      }\r\n\r\n      62.5% {\r\n          transform: rotate(675deg);\r\n      }\r\n\r\n      75% {\r\n          transform: rotate(810deg);\r\n      }\r\n\r\n      87.5% {\r\n          transform: rotate(945deg);\r\n      }\r\n\r\n      100% {\r\n          transform: rotate(1080deg);\r\n      }\r\n  }\r\n\r\n  .adBanner {\r\n      background-color: transparent;\r\n      height: 1px;\r\n      width: 1px;\r\n  }\r\n\r\n  .addBlockerMessage {\r\n      display: none;\r\n  }\r\n\r\n  body.no-add-block>.addBlockerMessage {\r\n      z-index: -1;\r\n      display: none;\r\n  }\r\n\r\n  body.add-block-found>.addBlockerMessage {\r\n      display: block;\r\n      z-index: 99;\r\n      width: 100%;\r\n      position: absolute;\r\n      bottom: 0;\r\n      padding: 10px;\r\n      background-color: white;\r\n      border-top: 1px solid gray;\r\n  }\n</style><div class=\"rcloud-splash-screen-load\" id=\"rcloud-splash-screen-load\" ng-if=\"!signinTimeoutDone\"><div \nclass=\"center\"><div class=\"logo\"><img width=\"128\" src=\"images/logos/rcloud.svg\"></div><div class=\"spinner-wrapper\"><div\n class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div><p style=\"color: white\" align=\"center\">\n{{ appStatus }}!..</p></div></div>");
$templateCache.put("app/views/rcloud/home/home.html","<div class=\"row\"><div class=\"col-md-12\" align=\"center\" bind-html-compile=\"getHtmlWishes\"></div></div><div class=\"row\">\n<div class=\"col-lg-6 col-md-6 col-sm-6 col-md-offset-3\"><div class=\"row no-gutter\"><div class=\"col-xs-12\"><div \nclass=\"card\" style=\"margin-top: 5%\"><div class=\"card-heading\" align=\"center\"><img src=\"{{app.logoDarkSVG}}\" \nclass=\"logo login-page-logo\"> <small>Welcome to rCloud Softwares, Kindly Select a Product your going to use...</small>\n</div><div class=\"card-body\"><div class=\"row\" id=\"youtubeDiv\" align=\"center\" style=\"padding-bottom: 20px\"><div \nid=\"ytplayer\"></div></div><div class=\"row\"><div class=\"col-sm-4\" style=\"margin-bottom: 30px\" align=\"center\" \nng-repeat=\"project in getAllowedProjects(allowedprojects)\"><a \nclass=\"{{app.setting.theme.primary}}projectbutton projectselectbutton\" \nng-class=\"{ \'project-selected\' : ifSelected(project) }\" ng-click=\"selectProject(project)\" \nng-mouseenter=\"hovering=true\" ng-mouseleave=\"hovering=false\"><i ng-if=\"project.project_fw === \'js\'\" \nclass=\"{{ project.icon }}\" style=\"font-size: 45px\" ng-class=\"{ \'animated flipInX\' : hovering }\"></i> <i \nng-if=\"project.project_fw === \'ts\'\" class=\"material-icons\" style=\"font-size: 45px\" \nng-class=\"{ \'animated flipInX\' : hovering }\">{{ project.icon }}</i><p style=\"font-size: 11px\"><b>{{ project.name }}</b>\n</p></a></div></div></div></div></div></div></div></div>");
$templateCache.put("app/projects/rcloudsys/commhub/email/email.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">Back</a></div></div><div \nclass=\"row\"><rd-window header=\"Email Settings\" footer=\"Add or Edit Email Settings\" size=\"col-md-12\"><form \nname=\"emailSettings\" id=\"emailSettings\"><div class=\"row\"><selectbox quickattrs=\"status\" modelname=\"mail_enabled\">\n</selectbox></div><div class=\"row\" bind-html-compile=\"getSettingsBox()\"></div><div class=\"row\"><div class=\"col-md-12\" \nalign=\"right\"><button type=\"button\" class=\"btn btn-info m-t\" \nng-show=\"emailSettingsData.email_server === \'smtp\' || emailSettingsData.email_server === \'rcloudsmtp\'\" \nng-disabled=\"emailSettings.$invalid\" ng-click=\"emailHubTestSettings()\">Test Settings</button> <button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"emailSettings.$invalid\" ng-click=\"saveEmailHubSettings()\">Save Settings</button>\n</div></div><div class=\"row\" ng-if=\"showMailDebug\"><div class=\"col-md-12\" bind-html-compile=\"mailDebugData.msg\"></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ emailSettingsData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ emailSettings | json }}</pre></div></div></rd-window></div><div class=\"row\" ng-show=\"checkStatus\"><rd-window \nheader=\"Email Hub\" footer=\"Email Hub\" size=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\" align=\"right\"><h3>\n{{ usedCount }} of {{ totalCount }} Email\'s Used</h3><br></div></div><form name=\"emailHub\" id=\"emailHub\"><div \nclass=\"row\"><textbox quickattrs=\"emailsender\" itemid=\"toaddress\" modelname=\"toaddress\" size=\"col-md-12\"></textbox>\n<textbox quickattrs=\"subject\"></textbox></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"mail\">Message</label>\n<textarea ui-tinymce=\"tinymceOptions\" ng-model=\"emailHubData.mail\"></textarea><br></div></div><div class=\"row\"><div \nclass=\"col-md-12\" align=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"emailHub.$invalid\" \nng-click=\"emailHubSettings()\">Check</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ emailHubData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ emailHub | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/commhub/sms/sms.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nng-show=\"!self_page\" align=\"right\"><a href=\"companies/list\" class=\"btn btn-info m-t\">Back</a></div></div><div \nclass=\"row\"><rd-window header=\"SMS Settings\" footer=\"Add or Edit SMS Settings\" size=\"col-md-12\"><form \nname=\"smsSettings\" id=\"smsSettings\"><div class=\"row\"><selectbox quickattrs=\"status\" modelname=\"sms_enabled\">\n</selectbox></div><div class=\"row\" bind-html-compile=\"getSettingsBox()\"></div><div class=\"row\"><div class=\"col-md-12\" \nalign=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"smsSettings.$invalid\" \nng-click=\"saveSMSHubSettings()\">Save Settings</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\">\n<div class=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ smsSettingsData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ smsSettings | json }}</pre></div></div></rd-window></div><div class=\"row\" \nng-show=\"checkStatus\"><rd-window header=\"SMS Hub\" footer=\"SMS Hub\" size=\"col-md-12\"><div class=\"row\"><div \nclass=\"col-md-12\" align=\"right\"><h3>{{ availableBalance }} SMS Credits Available</h3><br></div></div><form \nname=\"smsHub\" id=\"smsHub\"><div class=\"row\"><textbox quickattrs=\"companymobile\" itemid=\"tmobileno\" \nmodelname=\"companymobile\"></textbox><textbox quickattrs=\"textmsg\" modelname=\"smskey\"></textbox></div><div class=\"row\">\n<div class=\"col-md-12\" align=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"smsHub.$invalid\" \nng-click=\"smsHubSettings()\">Check</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ smsHubData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ smsHub | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/add_companies/add_companies.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><rd-window \nheader=\"Create a Company\" footer=\"Add Your Company and Control your Company with the Users.\" size=\"col-md-12\"><form \nrole=\"form\" name=\"addcompany\" id=\"addcompany\"><div class=\"row\"><textbox quickattrs=\"companyname\"></textbox><textbox \nquickattrs=\"companyuniquename\"></textbox></div><div class=\"row\"><textbox quickattrs=\"companydisc\"></textbox><textbox \nquickattrs=\"address\"></textbox></div><div class=\"row\"><textbox quickattrs=\"companyemail\"></textbox><textbox \nquickattrs=\"companyphone\"></textbox></div><div class=\"row\"><textbox quickattrs=\"companymobile\"></textbox><textbox \nquickattrs=\"companystaticiplist\"></textbox></div><div class=\"row\"><selectbox quickattrs=\"projectstatus\" \nitemid=\"companystatus\"></selectbox><selectbox quickattrs=\"listprojects\"></selectbox></div><div class=\"row\"><datebox \nquickattrs=\"validtill\"></datebox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"addcompany.$invalid\" ng-click=\"addCompany()\">Add Company</button></div></div>\n</form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ addcompanyData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ addcompany | json }}\n</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/add_user/add_user.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ companyData.name }}</h3>\n</div><div class=\"col-md-6\" align=\"right\"><a href=\"{{ self ? \'companies/manage_self\' : \'companies/manage/\'+cid }}\" \nclass=\"btn btn-info m-t\">Back to Manage Company</a></div></div><rd-window header=\"Create a Users\" \nfooter=\"Create a User for Your Company.\" size=\"col-md-12\"><form role=\"form\" name=\"addUser\" id=\"addUser\"><div \nclass=\"row\"><textbox quickattrs=\"displayname\" size=\"col-md-6\"></textbox><textbox quickattrs=\"loginEmail\" \nsize=\"col-md-6\" geturlcheck=\"rcloudsys/users/uEmailDupCheck/\"></textbox></div><div class=\"row\"><textbox \nquickattrs=\"mobileno\" size=\"col-md-6\" geturlcheck=\"rcloudsys/users/uMobileDupCheck/\"></textbox><selectbox \nquickattrs=\"gender\" size=\"col-md-6\"></selectbox></div><div class=\"row\"><datebox quickattrs=\"dob\" size=\"col-md-6\">\n</datebox><textbox quickattrs=\"userrole\" size=\"col-md-6\"></textbox></div><div class=\"row\"><textbox \nquickattrs=\"loginPassword\" size=\"col-md-6\"></textbox><textbox quickattrs=\"loginPassword\" modelname=\"conformpassword\" \nitemid=\"conformpassword\" size=\"col-md-6\"></textbox></div><div class=\"row\"><selectbox quickattrs=\"pripubuser\" \nsize=\"col-md-6\"></selectbox><div bind-html-compile=\"projectBox()\"></div></div><div class=\"row\" \nng-if=\"addUserData.password !== addUserData.conformpassword\"><div class=\"col-md-6\"><h5 style=\"color: red\">\n* Password are Not Matched</h5></div></div><div class=\"row\" \nng-show=\"addUserData.password === addUserData.conformpassword\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"addUser.$invalid\" ng-click=\"createUser()\">Add User</button></div></div></form>\n<div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ addUserData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ addUser | json }}</pre>\n</div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/edit_companies/edit_companies.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><rd-window \nheader=\"Edit Company\" footer=\"Edit a Current Company\" size=\"col-md-12\"><form role=\"form\" name=\"editcompany\" \nid=\"editcompany\"><div class=\"row\"><textbox quickattrs=\"companyname\"></textbox><textbox quickattrs=\"companyuniquename\" \ngeturlcheck=\"false\" readonly=\"true\"></textbox></div><div class=\"row\"><textbox quickattrs=\"companydisc\"></textbox>\n<textbox quickattrs=\"address\"></textbox></div><div class=\"row\"><textbox quickattrs=\"companyemail\"></textbox><textbox \nquickattrs=\"companyphone\"></textbox></div><div class=\"row\"><textbox quickattrs=\"companymobile\"></textbox><textbox \nquickattrs=\"companystaticiplist\"></textbox></div><div class=\"row\"><selectbox quickattrs=\"projectstatus\" \nitemid=\"companystatus\"></selectbox><selectbox quickattrs=\"listprojects\"></selectbox></div><div class=\"row\"><datebox \nquickattrs=\"validtill\"></datebox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"editcompany.$invalid\" ng-click=\"updateCompany()\">Update Company</button></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ editcompanyData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ editcompany | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/edit_user/edit_user.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"{{ self ? \'companies/manage_self\' : \'companies/manage/\'+cid }}\" class=\"btn btn-info m-t\">\nBack to Manage Company</a></div></div><rd-window header=\"Update a User\" footer=\"Update a User for Your Company.\" \nsize=\"col-md-12\"><form role=\"form\" name=\"editUser\" id=\"editUser\"><div class=\"row\"><textbox quickattrs=\"displayname\" \nsize=\"col-md-6\"></textbox><textbox quickattrs=\"loginEmail\" size=\"col-md-6\" readonly=\"true\"></textbox></div><div \nclass=\"row\"><textbox quickattrs=\"mobileno\" size=\"col-md-6\" readonly=\"true\"></textbox><selectbox quickattrs=\"gender\" \nsize=\"col-md-6\"></selectbox></div><div class=\"row\"><datebox quickattrs=\"dob\" size=\"col-md-6\"></datebox><textbox \nquickattrs=\"userrole\" size=\"col-md-6\"></textbox></div><div class=\"row\"><selectbox quickattrs=\"pripubuser\" \nsize=\"col-md-6\"></selectbox><div bind-html-compile=\"projectBox()\"></div></div><div class=\"row\"><div class=\"col-md-6\">\n<button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editUser.$invalid\" ng-click=\"updateUser()\">Update User\n</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value\n</h4><pre>{{ editUserData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ editUser | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/list_companies/list_companies.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"companies/add\" class=\"btn btn-primary m-t\">Create Company</a></div></div><rd-window \nheader=\"Companies List\" footer=\"Shows a Companies List & Edit or Remove Companies\" size=\"col-md-12\"><div \nclass=\"row rownopadding\"><div class=\"table-responsive\" width=\"100%\"><table \nclass=\"table table-striped b-t b-b dt-responsive\" id=\"companieslisttable\"><thead></thead><tbody></tbody><tfoot></tfoot>\n</table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data from Server</h4>\n<pre>{{ companieslst | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/login_details/log_details.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><span></span> <a href=\"companies/list_user_log/{{cid}}\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">\nBack to Log Page</a></div></div><div class=\"row\"><div class=\"col-md-4\"><h4>{{ userInfo.username }}</h4></div><div \nclass=\"col-md-4\"><h4>{{ userInfo.login_time }}</h4></div><div class=\"col-md-4\"><h4>{{ userInfo.logout_time }}</h4>\n</div></div><div class=\"row\"><rd-window header=\"List User Log\" footer=\"Shows a List in User Log\" size=\"col-md-12\"><div \nclass=\"row rownopadding\"><div class=\"table-responsive\" width=\"100%\"><table \nclass=\"table table-striped b-t b-b dt-responsive\" id=\"userlist\"><thead></thead><tbody></tbody><tfoot></tfoot></table>\n</div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data fromServer</h4><pre>\n{{ View | json }}</pre><pre>{{ ViewData | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/manage_companies/manage_companies.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpanyData.company.name }}\n</h3></div><div class=\"col-md-6\" align=\"right\"><a href=\"{{ self ? \'users/add_self\' : \'users/add/\'+cid }}\" \nclass=\"btn btn-primary m-t\">Create User</a> <a ng-if=\"!self\" href=\"companies/list\" class=\"btn btn-info m-t\">\nBack to Companies List</a></div></div></div><div class=\"row\"><rd-window header=\"Manage Company Users\" \nfooter=\"Manage Your Company Users\" size=\"col-md-12\"><div class=\"row rownopadding\"><div width=\"100%\"><table \nclass=\"table table-striped b-t b-b dt-responsive\" id=\"userslisttable\"><thead></thead><tbody></tbody><tfoot></tfoot>\n</table></div></div></rd-window><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nForm Data Send to Server</h4><pre>{{ cmpanyData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation\n</h4><pre>{{ managecompany | json }}</pre></div></div></div>");
$templateCache.put("app/projects/rcloudsys/companies/manage_company/manage_company.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h4>Company : <strong>\n{{ package.company.name }}</strong></h4><h4>Project : <strong><i class=\"{{ package.project.icon }}\"></i>\n {{ package.project.name }}</strong></h4></div><div class=\"col-md-6\" align=\"right\"><a href=\"companies/list\" \nclass=\"btn btn-primary m-t\">Back to Companies List</a></div></div><rd-window header=\"Company Settings\" \nfooter=\"Change Company Settings\" ng-show=\"package.user_sett.html !== \'\'\"><form name=\"companySett\" id=\"companySett\" \nprivatedata=\"package.user_sett.values\"><div bind-html-compile=\"package.user_sett.html\"></div></form><div class=\"row\" \nstyle=\"margin-top: 40px\" align=\"right\"><div class=\"col-md-12\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-click=\"updateSettings()\">Update Company Settings</button></div></div></rd-window></div><style>\n.modelgrouprow {\r\n        border-top: 1.5px solid grey;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .modelrow {\r\n        border-top: 0.5px solid grey;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .modelrow:hover, .modelgrouprow:hover {\r\n        background-color: rgba(0,0,0,0.1);\r\n    }\r\n\r\n    .modelcolmain {\r\n        padding-left: 50px;\r\n    }\n</style>");
$templateCache.put("app/projects/rcloudsys/companies/manage_project_companies/manage_project_companies.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ projectData.company.name }}\n</h3></div><div class=\"col-md-6\" align=\"right\"><a ng-if=\"!self\" href=\"companies/list\" class=\"btn btn-info m-t\">\nBack to Companies List</a></div></div></div><div ng-if=\"!self\" class=\"row\"><rd-window header=\"Server Configuration\" \nfooter=\"Check Your Connection and Complete the Project Dataservers\" size=\"col-md-12\"><div class=\"row\"><div \nclass=\"col-md-6\"><h4 ng-if=\"projectData.company.settingStatus\" style=\"color: darkgreen\">Server Configuration Ok!</h4>\n<h4 ng-if=\"!projectData.company.settingStatus\" style=\"color: red\">Server Configuration Faild!</h4></div><div \nclass=\"col-md-6\" align=\"right\"><a href=\"companies/manageserver/{{ cid }}\" class=\"btn btn-primary m-t\">\nManage Server Configuration</a></div></div></rd-window></div><div class=\"row\"><rd-window header=\"Project Information\" \nfooter=\"Check Your Project Information with Validity and Alloted Users\" size=\"col-md-12\"><div class=\"row rownopadding\">\n<div width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"projectslisttable\"><thead></thead>\n<tbody></tbody><tfoot></tfoot></table></div></div></rd-window><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Company Data</h4><pre>{{ projectData.projects | json }}</pre></div><div class=\"col-md-6\">\n</div></div></div>");
$templateCache.put("app/projects/rcloudsys/companies/manage_user/manage_user.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>\nUser : {{ package.user_info.display_name }}</h3><h4>Company : <strong>{{ package.company.name }}</strong></h4><h4>\nProject : <strong><i class=\"{{ package.project.icon }}\"></i> {{ package.project.name }}</strong></h4></div><div \nclass=\"col-md-6\" align=\"right\"><a href=\"{{ self ? \'companies/manage_self\' : \'companies/manage/\'+cid }}\" \nclass=\"btn btn-primary m-t\">Back to Manage Company</a></div></div><rd-window header=\"Manage {{ package.name}} Package\" \nfooter=\"Manage Current Package\" size=\"col-md-12\"><form role=\"form\" name=\"managepackage\" id=\"managepackage\"><div \nclass=\"row\" style=\"margin-bottom: 40px\" align=\"right\"><div class=\"col-md-12\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-click=\"updatePackage()\">Update Package</button></div></div><div class=\"row\"><div \nclass=\"col-md-3\"><md-checkbox ng-checked=\"isWholeProjectChecked()\" ng-click=\"toggleWholeProjectAll()\"><i>\n* Over All {{ package.project.name }} Models</i></md-checkbox></div><div class=\"col-md-2\"><md-checkbox \nng-checked=\"package.project.whole_view\" ng-disabled=\"isDisabledOverAllView()\" \nng-click=\"package.project.whole_view = !package.project.whole_view\"><i>* View Over All</i></md-checkbox></div><div \nclass=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_create\" ng-disabled=\"isDisabledOverAllCreate()\" \nng-click=\"package.project.whole_create = !package.project.whole_create\"><i>* Create Over All</i></md-checkbox></div>\n<div class=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_edit\" ng-disabled=\"isDisabledOverAllEdit()\" \nng-click=\"package.project.whole_edit = !package.project.whole_edit\"><i>* Edit Over All</i></md-checkbox></div><div \nclass=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_delete\" ng-disabled=\"isDisabledOverAllDelete()\" \nng-click=\"package.project.whole_delete = !package.project.whole_delete\"><i>* Delete Over All</i></md-checkbox></div>\n</div><div class=\"row\" ng-show=\"!package.project.whole_models\"><div><div class=\"row\" \nng-repeat=\"group in package.modelgroups\"><div class=\"row modelgrouprow\"><div class=\"col-md-3\"><md-checkbox \nng-checked=\"isChecked(group)\" md-indeterminate=\"isIndeterminate(group)\" ng-click=\"toggleAll(group)\"><i \nclass=\"{{ group.icon }}\"></i> {{ group.name }}</md-checkbox><md-checkbox ng-checked=\"isWholeChecked(group)\" \nng-click=\"toggleWholeAll(group)\"><i>* All {{ group.name }} Models</i></md-checkbox></div><div class=\"col-md-2\">\n<md-checkbox ng-checked=\"isViewChecked(group)\" ng-disabled=\"isGroupViewDisabled(group)\" \nmd-indeterminate=\"isViewIndeterminate(group)\" ng-click=\"toggleViewAll(group)\">View</md-checkbox><md-checkbox \nng-checked=\"group.whole_view\" ng-disabled=\"isGroupViewDisabled(group)\" ng-click=\"group.whole_view = !group.whole_view\">\n<i>* View All</i></md-checkbox></div><div class=\"col-md-2\"><md-checkbox ng-checked=\"isCreateChecked(group)\" \nng-disabled=\"isGroupCreateDisabled(group)\" md-indeterminate=\"isCreateIndeterminate(group)\" \nng-click=\"toggleCreateAll(group)\">Create</md-checkbox><md-checkbox ng-checked=\"group.whole_create\" \nng-disabled=\"isGroupCreateDisabled(group)\" ng-click=\"group.whole_create = !group.whole_create\"><i>* Create All</i>\n</md-checkbox></div><div class=\"col-md-2\"><md-checkbox ng-checked=\"isEditChecked(group)\" \nng-disabled=\"isGroupEditDisabled(group)\" md-indeterminate=\"isEditIndeterminate(group)\" ng-click=\"toggleEditAll(group)\">\nEdit</md-checkbox><md-checkbox ng-checked=\"group.whole_edit\" ng-disabled=\"isGroupEditDisabled(group)\" \nng-click=\"group.whole_edit = !group.whole_edit\"><i>* Edit All</i></md-checkbox></div><div class=\"col-md-2\"><md-checkbox\n ng-checked=\"isDeleteChecked(group)\" ng-disabled=\"isGroupDeleteDisabled(group)\" \nmd-indeterminate=\"isDeleteIndeterminate(group)\" ng-click=\"toggleDeleteAll(group)\">Delete</md-checkbox><md-checkbox \nng-checked=\"group.whole_delete\" ng-disabled=\"isGroupDeleteDisabled(group)\" \nng-click=\"group.whole_delete = !group.whole_delete\"><i>* Delete All</i></md-checkbox></div></div><div \nclass=\"row modelrow\" ng-show=\"(group.avail ? (group.avail === true) : false) && group.whole_models !== true\" \nng-repeat=\"model in group.models\"><div class=\"col-md-3 modelcolmain\"><md-checkbox class=\"md-primary\" \nng-checked=\"isModelChecked(model)\" ng-disabled=\"isModelDisabled(model)\" ng-click=\"toggleModel(model)\"><i \nclass=\"{{ model.icon }}\"></i> {{ model.name }}</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"model.m_view\" ng-disabled=\"isModelViewDisabled(model)\" \nng-click=\"toggleViewModel(model)\">View</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"model.m_create\" ng-disabled=\"isModelCreateDisabled(model)\" \nng-click=\"toggleCreateModel(model)\">Create</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"model.m_edit\" ng-disabled=\"isModelEditDisabled(model)\" \nng-click=\"toggleEditModel(model)\">Edit</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"model.m_delete\" ng-disabled=\"isModelDeleteDisabled(model)\" \nng-click=\"toggleDeleteModel(model)\">Delete</md-checkbox></div></div></div></div></div></form><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ package | json }}</pre></div><div \nclass=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ managepackage | json }}</pre></div></div></rd-window><rd-window \nheader=\"User Settings\" footer=\"Change User Settings\" ng-show=\"package.user_sett.html !== \'\'\"><form name=\"userSett\" \nid=\"userSett\" privatedata=\"package.user_sett.values\"><div bind-html-compile=\"package.user_sett.html\"></div></form><div \nclass=\"row\" style=\"margin-top: 40px\" align=\"right\"><div class=\"col-md-12\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-click=\"updatePackage()\">Update Package</button></div></div></rd-window></div><style>\n.modelgrouprow {\r\n        border-top: 1.5px solid grey;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .modelrow {\r\n        border-top: 0.5px solid grey;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .modelrow:hover, .modelgrouprow:hover {\r\n        background-color: rgba(0,0,0,0.1);\r\n    }\r\n\r\n    .modelcolmain {\r\n        padding-left: 50px;\r\n    }\n</style>");
$templateCache.put("app/projects/rcloudsys/companies/manageserver/manageserver_companies.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpanyData.name }}</h3>\n</div><div class=\"col-md-6\" align=\"right\"><a href=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a>\n</div></div><form name=\"managecompany\" novalidate id=\"managecompany\"><div \nng-repeat=\"project in cmpanyData.projects_list | orderBy: \'id\'\"><rd-window-box size=\"col-md-12\"><rd-window-box-header>\n<i class=\"{{ project.icon }}\"></i> {{ project.name }} Setup</rd-window-box-header><rd-window-box-body><ng-form \nname=\"managecompanyForm\"><div class=\"row\" bind-html-compile=\"getServerField(project.projectid,project)\"></div><div \nclass=\"row\"><div bind-html-compile=\"getPackageBox(project)\"></div><numberbox quickattrs=\"nofuser\" size=\"col-md-4\" \nitemtype=\"ngform\" minnumber2=\"project.setting.current_user\" modelname=\"project.setting.nofuser\"></numberbox><datebox \nquickattrs=\"validtill\" size=\"col-md-4\" itemtype=\"ngform\" maxdate=\"cmpanyData.valid_till\" \nmodelname=\"project.setting.validtill\"></datebox></div></ng-form></rd-window-box-body><rd-window-box-footer>\nSetup your {{ project.name }} project.</rd-window-box-footer></rd-window-box></div></form><rd-window \nheader=\"Complete Project Setup\" footer=\"Check Your Connection and Complete the Project Setup\" size=\"col-md-12\"><div \nclass=\"row\"><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"checkProjectSetup()\" \nng-click=\"saveSetup()\">Save this Project Setup</button></div></div></rd-window><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ cmpanyData | json }}</pre></div><div\n class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ managecompany | json }}</pre></div></div></div>");
$templateCache.put("app/projects/rcloudsys/companies/notify_sett/notify_sett.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><span>\n</span> <a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div>\n<rd-window header=\"Notification Settings\"><form name=\"notify_sett\" id=\"notify_sett\"><div class=\"row\"><textbox \nquickattrs=\"login_notify\" size=\"col-md-4\" readonly=\"true\"></textbox><selectbox quickattrs=\"status\" \nmodelname=\"login_notify_status\" rdchange=\"setLoginRequired()\" size=\"col-md-4\"></selectbox><textbox \nquickattrs=\"companymobile\" itemid=\"login_notify_num\" rdrequired=\"loginNumberRequired\" modelname=\"login_notify_number\" \nsize=\"col-md-4\"></textbox></div><div class=\"row\"><textbox quickattrs=\"password_notify\" size=\"col-md-4\" readonly=\"true\">\n</textbox><selectbox quickattrs=\"status\" rdchange=\"setPassRequired()\" modelname=\"password_notify_status\" \nsize=\"col-md-4\"></selectbox><textbox quickattrs=\"companymobile\" itemid=\"pass_notify_num\" \nrdrequired=\"passNumberRequired\" modelname=\"password_notify_number\" size=\"col-md-4\"></textbox></div><div class=\"row\">\n<div class=\"col-md-12\" align=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"notify_sett.$invalid\" \nng-click=\"addNotification()\">Save</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ notify_settData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ notify_sett | json }}</pre></div></div></rd-window>");
$templateCache.put("app/projects/rcloudsys/companies/server_status/server_status.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpData.name }}</h3></div>\n<div class=\"col-md-6\" align=\"right\"><a ng-if=\"!self\" href=\"companies/list\" class=\"btn btn-info m-t\">Back</a></div>\n</div></div><div class=\"row\"><rd-window header=\"Database Storage Status\" \nfooter=\"Check Your Server Database Storage Status\" size=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><h4>\nTotal Storage Available from Current Month : {{ cmpData.limits.storage }}GB</h4></div></div><div class=\"row\" \nng-repeat=\"cmp in cmpData.projects track by $index\"><div class=\"col-md-6\"><h3><i class=\"fa fa-database\"></i>\n {{ cmp.name }}</h3></div><div class=\"col-md-6\" align=\"right\"><h3>{{ cmp.size }}GB / {{ cmp.storage_limit }}GB</h3>\n</div><div class=\"col-md-12\"><div class=\"progress\" style=\"height: 12px\" \nbind-html-compile=\"getProgress(cmp.size,cmp.storage_limit)\"></div></div></div></rd-window><rd-window \nheader=\"Data Transfer Status\" footer=\"Check Your Server Data Transfer Status\" size=\"col-md-12\"><div class=\"row\"><div \nclass=\"col-md-12\"><h4>Total Transfer Available from Current Month : {{ cmpData.limits.transfer }}GB</h4></div></div>\n<div class=\"row\" ng-repeat=\"tra in cmpData.transfers track by $index\"><div class=\"col-md-6\"><h3>{{ tra.month }}</h3>\n</div><div class=\"col-md-6\" align=\"right\"><h3>{{ tra.total_transfer }}GB / {{ tra.transfer_limit }}GB</h3></div><div \nclass=\"col-md-12\"><div class=\"progress\" style=\"height: 12px\" \nbind-html-compile=\"getProgress(tra.total_transfer,tra.transfer_limit)\"></div></div></div></rd-window><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Company Data</h4><pre>{{ cmpData | json }}</pre></div>\n</div></div>");
$templateCache.put("app/projects/rcloudsys/companies/user_log/user_log.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><span></span> <a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">\nBack to Companies List</a></div></div><div class=\"row\"><form name=\"View\" id=\"View\"><div bind-html-compile=\"UserBox()\">\n</div><button type=\"submit\" style=\"margin-top :24px\" class=\"btn btn-info m-t\" ng-disabled=\"notify_sett.$invalid\" \nng-click=\"userFilter()\">Filter</button></form></div><div class=\"row\"><rd-window header=\"List User Log\" \nfooter=\"Shows a List in User Log\" size=\"col-md-12\"><div class=\"row rownopadding\"><div class=\"table-responsive\" \nwidth=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"userlist\"><thead></thead><tbody></tbody>\n<tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nLive Data fromServer</h4><pre>{{ View | json }}</pre><pre>{{ ViewData | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companies/viewreports/viewreports.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"></div></div><rd-window header=\"Overall Report List\" \nfooter=\"Shows a Overall Report List & Edit or Remove Companies\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"viewreporttable\">\n<thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Live Data from Server</h4><pre>{{ companieslst | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companyreport/add_companyreport/add_companyreport.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"companyreport/list/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Create Company Report\" footer=\"Create a Company Report\" size=\"col-md-12\"><form name=\"addcompanyreport\" \nid=\"addcompanyreport\"><div class=\"row\"><textbox quickattrs=\"report_name\" size=\"col-md-6\"></textbox><textbox \nquickattrs=\"report_id\" size=\"col-md-6\"></textbox></div><div class=\"row\"><textbox quickattrs=\"report_type\" \nsize=\"col-md-6\"></textbox><div bind-html-compile=\"getProjectBox()\"></div></div><div class=\"row\"><selectbox \nquickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"addcompanyreport.$invalid\" ng-click=\"addCompanyReport()\">Submit</button></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ addcompanyreportData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ addcompanyreport | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companyreport/edit_companyreport/edit_companyreport.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"companyreport/list/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Edit Company Report\" footer=\"Edit a Company Report\" size=\"col-md-12\"><form name=\"editcompanyreport\" \nid=\"editcompanyreport\"><div class=\"row\"><textbox quickattrs=\"report_name\" size=\"col-md-6\"></textbox><textbox \nquickattrs=\"report_id\" size=\"col-md-6\" readonly=\"true\"></textbox></div><div class=\"row\"><textbox \nquickattrs=\"report_type\" size=\"col-md-6\"></textbox><div bind-html-compile=\"getProjectBox()\"></div></div><div \nclass=\"row\"><selectbox quickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\"><div class=\"col-md-6\">\n<button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editcompanyreport.$invalid\" ng-click=\"editCompanyReport()\">\nUpdate Report</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nForm Live Value</h4><pre>{{ editcompanyreportData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation\n</h4><pre>{{ editcompanyreport | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/companyreport/list_companyreport/list_companyreport.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"companyreport/add/{{ cid }}\" class=\"btn btn-primary m-t\">Create Report</a> <a \nhref=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><div class=\"row\"><rd-window \nheader=\"List Company Report\" footer=\"Shows a List in Company Report\" size=\"col-md-12\"><div class=\"row rownopadding\">\n<div class=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" \nid=\"listreporttable\"><thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ reportlist | json }}</pre>\n</div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/dbupdates/list_dbupdates.html","<div class=\"col-md-12\" ng-show=\"checkingGoingon\"><div class=\"progress\"><div \nclass=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" \naria-valuemax=\"100\" style=\"width:100%\"><b>Fetching Data..</b></div></div></div><div class=\"row\" \nstyle=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"></div></div><div \nclass=\"row\"><rd-window header=\"Scheme Selection\" footer=\"Select a Schemes to Updates its Database\" size=\"col-md-12\">\n<form role=\"form\" name=\"scheme_selection\" id=\"scheme_selection\"><div class=\"row\"><selectbox quickattrs=\"dbtype\">\n</selectbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-disabled=\"scheme_selection.$invalid\" ng-click=\"getDBList()\">Submit</button></div></div></form></rd-window><rd-window\n header=\"List Databases\" footer=\"Shows a List in Databases\" size=\"col-md-12\" ng-show=\"showList\"><div class=\"row\"><div \nclass=\"col-md-12\" align=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"scheme_selection.$invalid\" \nng-click=\"updateAllDatabases(event)\">Update All</button><br><br><button class=\"btn btn-info m-t\" \nng-disabled=\"scheme_selection.$invalid\" ng-click=\"backupAll(event)\">Backup All</button><br><br></div></div><div \nclass=\"row rownopadding\"><div class=\"table-responsive\" width=\"100%\"><table \nclass=\"table table-striped b-t b-b dt-responsive\" id=\"listquerytable\"><thead></thead><tbody></tbody><tfoot></tfoot>\n</table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data fromServer</h4>\n<pre>{{ querylist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/dbupdates/updater.html","<md-dialog aria-label=\"Updating\" style=\"width: 60%; overflow: hidden\" tabindex=\"1\"><md-toolbar class=\"{{theme}}\"><div \nclass=\"md-toolbar-tools\"><h3>Updating Database...</h3><span flex></span></div></md-toolbar><md-dialog-content><div \nclass=\"col-md-12\" ng-show=\"loading\"><div class=\"progress\"><div class=\"progress-bar progress-bar-striped active\" \nrole=\"progressbar\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:100%\"><b>Fetching Data...</b>\n</div></div></div><br><br><div class=\"col-md-12\" align=\"center\" ng-show=\"updateStarted\"><h2>\n{{ needtoUpdate }} Updates Available!..</h2><br><br><h3>{{ currentlyUpdating }} of {{ needtoUpdate }} is Updating...\n</h3><br><br><div class=\"progress\"><div class=\"progress-bar progress-bar-striped active\" role=\"progressbar\" \naria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:100%\"><b>\nNo. {{ currentlyUpdating }} Update {{ currentStatus }}...</b></div></div></div></md-dialog-content></md-dialog>\"");
$templateCache.put("app/projects/rcloudsys/emailtemplate/add_emailtemplate/add_emailtemplate.html","<rd-window ng-show=\"cloneShow\" header=\"Clone Template\"><form name=\"cloneTemp\" id=\"cloneTemp\"><div class=\"row\"><div \nbind-html-compile=\"getProjectBox()\"></div><div bind-html-compile=\"getTempBox()\"></div><div class=\"col-md-2\" \nstyle=\"margin-top: 6px\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"cloneTemp.$invalid\" \nng-click=\"getDataForClone()\">Clone</button></div></div></form></rd-window><div class=\"row\" style=\"margin-bottom: 15px\">\n<div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a href=\"emailtemplate/list/{{ cid }}\" \nclass=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window header=\"Create Template\" \nfooter=\"Create a Template\" size=\"col-md-12\"><form name=\"addtemplateB\" id=\"addtemplateB\"><div class=\"row\"><div \nbind-html-compile=\"getProjectBox()\"></div><textbox quickattrs=\"templatename\" size=\"col-md-6\"></textbox></div><div \nclass=\"row\"><textbox modelname=\"email_desc\" quickattrs=\"description\" size=\"col-md-12\"></textbox></div><div class=\"row\">\n<div bind-html-compile=\"getAccVarBox()\"></div><selectbox quickattrs=\"temptype\" size=\"col-md-6\"></selectbox></div><div \nclass=\"row\"><selectbox quickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\"><textbox \nquickattrs=\"subject\"></textbox></div><div class=\"row\" ng-show=\"addtemplateBData.temptype === \'schedule\'\"><textbox \nquickattrs=\"user_info_query\" required=\"false\" size=\"col-md-12\"></textbox></div><div class=\"forEvent\" \nng-show=\"addtemplateBData.temptype === \'event\'\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"mail\">Mail Template\n</label><textarea ui-tinymce=\"tinymceOptions\" ng-model=\"addtemplateBData.mail\"></textarea><br></div></div><div \nclass=\"row\"><div class=\"col-md-12\"><label for=\"emailquery\">Email Query</label><textarea \nng-model=\"addtemplateBData.emailquery\" rows=\"4\" style=\"width: 100%; resize: none\" ;></textarea></div></div></div><div \nclass=\"forSchedule\" ng-show=\"addtemplateBData.temptype === \'schedule\'\"><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"mail\">Header Template</label><textarea ui-tinymce=\"tinymceOptions\" ng-model=\"addtemplateBData.headertemp\">\n</textarea><br></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"mail\">Footer Template</label><textarea \nui-tinymce=\"tinymceOptions\" ng-model=\"addtemplateBData.footertemp\"></textarea><br></div></div><div class=\"row\"><div \nclass=\"col-md-12\"><label for=\"mail\">Mail Template</label><textarea ui-tinymce=\"tinymceOptions\" \nng-model=\"addtemplateBData.mail\"></textarea><br></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button \ntype=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"addtemplateB.$invalid\" ng-click=\"addEmailTemplate()\">Submit\n</button></div></div></form><br><br><div class=\"row\" \nng-if=\"addtemplateBData.projectid === \'5\' && addtemplateBData.temptype === \'event\'\"><div class=\"col-md-12\"><h3 \nalign=\"center\">Knitpack</h3><hr><h4>Yarn Grn Create</h4></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ addtemplateBData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ addtemplateB | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/emailtemplate/edit_emailtemplate/edit_emailtemplate.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"emailtemplate/list/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Edit Template\" footer=\"Edit a Template\" size=\"col-md-12\"><form name=\"edittemplateB\" id=\"edittemplateB\"><div \nclass=\"row\"><div bind-html-compile=\"getProjectBox()\"></div><textbox quickattrs=\"templatename\" size=\"col-md-6\">\n</textbox></div><div class=\"row\"><textbox modelname=\"email_desc\" quickattrs=\"description\" size=\"col-md-12\"></textbox>\n</div><div class=\"row\"><div bind-html-compile=\"getAccVarBox()\"></div><selectbox quickattrs=\"temptype\" size=\"col-md-6\">\n</selectbox></div><div class=\"row\"><selectbox quickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\">\n<textbox quickattrs=\"subject\"></textbox></div><div class=\"row\" ng-show=\"edittemplateBData.temptype === \'schedule\'\">\n<textbox quickattrs=\"user_info_query\" required=\"false\" size=\"col-md-12\"></textbox></div><div class=\"forEvent\" \nng-show=\"edittemplateBData.temptype === \'event\'\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"mail\">\nMail Template</label><textarea ui-tinymce=\"tinymceOptions\" ng-model=\"edittemplateBData.mail\"></textarea><br></div>\n</div><div class=\"row\"><div class=\"col-md-12\"><label for=\"emailquery\">Email Query</label><textarea \nng-model=\"edittemplateBData.emailquery\" rows=\"4\" style=\"width: 100%; resize: none\" ;></textarea></div></div></div><div \nclass=\"forSchedule\" ng-show=\"edittemplateBData.temptype === \'schedule\'\"><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"mail\">Header Template</label><textarea ui-tinymce=\"tinymceOptions\" ng-model=\"edittemplateBData.headertemp\">\n</textarea><br></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"mail\">Footer Template</label><textarea \nui-tinymce=\"tinymceOptions\" ng-model=\"edittemplateBData.footertemp\"></textarea><br></div></div><div class=\"row\"><div \nclass=\"col-md-12\"><label for=\"mail\">Mail Template</label><textarea ui-tinymce=\"tinymceOptions\" \nng-model=\"edittemplateBData.mail\"></textarea><br></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button \ntype=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"edittemplateB.$invalid\" ng-click=\"editEmailTemplate()\">\nUpdate Template</button></div></div></form><br><br><div class=\"row\" \nng-if=\"edittemplateBData.projectid === \'5\' && edittemplateBData.temptype === \'event\'\"><div class=\"col-md-12\"><h3 \nalign=\"center\">Knitpack</h3><hr><h4>Yarn Grn Create</h4></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ edittemplateBData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ edittemplateB | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/emailtemplate/list_email_log/email_log.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><span></span> <a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">\nBack to Companies List</a></div></div><div class=\"row\"><rd-window header=\"List Email Log\" \nfooter=\"Shows a List in Email Lof\" size=\"col-md-12\"><div class=\"row rownopadding\"><div class=\"table-responsive\" \nwidth=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"email_list\"><thead></thead><tbody></tbody>\n<tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nLive Data fromServer</h4><pre>{{ templatelist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/emailtemplate/list_emailtemplate/list_emailtemplate.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"emailtemplate/add/{{ cid }}\" class=\"btn btn-primary m-t\">Create Template</a> <a \nhref=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><div class=\"row\"><rd-window \nheader=\"List Template\" footer=\"Shows a List in Template\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"listtemplatetable\">\n<thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ templatelist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/emailtemplate/temp_sett/temp_sett.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><span>\n</span> <a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div>\n<rd-window header=\"Template Settings\"><form name=\"temp_sett\" id=\"temp_sett\"><ng-form name=\"Ngtemp_sett\" \nid=\"Ngtemp_sett\" ng-repeat=\"sett in temp_settData.setting track by $index\"><div class=\"row\"><div class=\"col-md-3\"><h4>\n{{ sett.project_name }}</h4></div><div class=\"col-md-3\"><h5>{{ sett.templatename }}</h5></div><div class=\"col-md-3\">\n<h5>{{ sett.email_desc }}</h5></div><selectbox quickattrs=\"status\" modelname=\"sett.status\" itemtype=\"ngform\" \nmodelname=\"password_notify_status\" size=\"col-md-3\"></selectbox></div><div class=\"row\"><hr></div></ng-form><div \nclass=\"row\"><div class=\"col-md-12\" align=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-disabled=\"temp_sett.$invalid\" ng-click=\"addEmailTempSett()\">Save</button></div></div></form><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ temp_settData | json }}</pre></div>\n<div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ temp_sett | json }}</pre></div></div></rd-window>");
$templateCache.put("app/projects/rcloudsys/smstemplate/add_smstemplate/add_smstemplate.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"smstemplate/list/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><rd-window ng-show=\"cloneShow\" \nheader=\"Clone Template\"><form name=\"cloneTemp\" id=\"cloneTemp\"><div class=\"row\"><div \nbind-html-compile=\"getProjectBox()\"></div><div bind-html-compile=\"getTempBox()\"></div><div class=\"col-md-2\" \nstyle=\"margin-top: 6px\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"cloneTemp.$invalid\" \nng-click=\"getDataForClone()\">Clone</button></div></div></form></rd-window><div class=\"row\"><rd-window \nheader=\"Create Template\" footer=\"Create a Template\" size=\"col-md-12\"><form name=\"addtemplateB\" id=\"addtemplateB\"><div \nclass=\"row\"><div bind-html-compile=\"getProjectBox()\"></div><textbox quickattrs=\"templatename\" \nrdreadonly=\"cloneReadonly\" size=\"col-md-6\"></textbox></div><div class=\"row\"><textbox modelname=\"sms_desc\" \nrdreadonly=\"cloneReadonly\" quickattrs=\"description\" size=\"col-md-12\"></textbox></div><div class=\"row\"><div \nbind-html-compile=\"getAccVarBox()\"></div><selectbox quickattrs=\"temptype\" rdreadonly=\"cloneReadonly\" size=\"col-md-6\">\n</selectbox></div><div class=\"row\"><selectbox quickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\" \nng-show=\"addtemplateBData.temptype === \'schedule\'\"><textbox quickattrs=\"user_info_query\" required=\"false\" \nmodelname=\"user_info_query\" size=\"col-md-12\"></textbox></div><div class=\"forEvent\" \nng-show=\"addtemplateBData.temptype === \'event\'\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"smstemplate\">\nSMS Template</label><textarea ng-model=\"addtemplateBData.smstemplate\" rows=\"4\" style=\"width: 100%; resize: none\" ;>\n</textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"smsquery\">SMS Query</label><textarea \nng-model=\"addtemplateBData.smsquery\" rows=\"4\" style=\"width: 100%; resize: none\" ;></textarea></div></div></div><div \nclass=\"forSchudle\" ng-show=\"addtemplateBData.temptype === \'schedule\'\"><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"smstemplate\">Header Template</label><textarea ng-model=\"addtemplateBData.smsheadertemplate\" rows=\"4\" \nstyle=\"width: 100%; resize: none\" ;></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"smstemplate\">Footer Template</label><textarea ng-model=\"addtemplateBData.smsfootertemplate\" rows=\"4\" \nstyle=\"width: 100%; resize: none\" ;></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"smstemplate\">Content Template</label><textarea ng-model=\"addtemplateBData.smstemplate\" rows=\"4\" \nstyle=\"width: 100%; resize: none\" ;></textarea></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button \ntype=\"submit\" class=\"btn btn-info m-t\" minlength=\"10\" ng-disabled=\"addtemplateB.$invalid\" ng-click=\"addSmsTemplate()\">\nSubmit</button></div></div></form><br><br><div class=\"row\"><h3 align=\"center\">Common</h3><hr><h5>\n%company_name% - Company Name</h5><h5>%party_name% - Party Name</h5><h5>%cdate% - Current Date</h5><br></div><div \nclass=\"row\" ng-if=\"addtemplateBData.projectid === \'5\' && addtemplateBData.temptype === \'event\'\"><div class=\"col-md-12\">\n<h3 align=\"center\">Knitpack</h3><hr><h4>Yarn Grn Create (yarn_grn_create)</h4><h5>%party_dc_no% - Party Dc No</h5><h5>\n%party_dc_date% - Party Dc Date</h5><h5>%our_grn_no% - Our GRN No</h5><h5>%our_grn_date% - Our GRN Date</h5><h5>\n%no_of_bags% - Total No of Bags</h5><h5>%total_net_kgs% - Total Net Kgs</h5><br><h4>\nYarn Return Create (yarn_return_create)</h4><h5>%our_dc_no% - Our Dc No</h5><h5>%our_dc_date% - Our Dc Date</h5><h5>\n%no_of_bags% - Total No of Bags</h5><h5>%total_net_kgs% - Total Net Kgs</h5><h5>%order_ref_no% - Order Ref No</h5><br>\n<h4>Fabric DC Create (fabric_dc_create)</h4><h5>%our_dc_no% - Our Dc No</h5><h5>%our_dc_date% - Our Dc Date</h5><h5>\n%no_of_rolls_pcs% - Total No of Rolls or Pcs</h5><h5>%total_net_kgs% - Total Net Kgs</h5><h5>\n%order_ref_no% - Order Ref No</h5><br></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\">\n<h4>Form Live Value</h4><pre>{{ addtemplateBData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Value</h4>\n<pre>{{ cloneTempData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ addtemplateB | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/projectsettings/projectsettings.html","<md-dialog aria-label=\"Project Settings\" style=\"width: 40%; overflow: hidden\" tabindex=\"1\"><md-toolbar \nclass=\"{{getThemeColor()}}\"><div class=\"md-toolbar-tools\"><h3>Change Settings</h3><span flex></span><md-button \nclass=\"md-icon-button\" ng-disabled=\"runningSettings.$invalid\" tabindex=\"-1\" ng-click=\"cancel()\"><i class=\"fa fa-close\" \ntabindex=\"-1\" aria-label=\"Close dialog\"></i></md-button></div></md-toolbar><md-dialog-content><div class=\"row\" \nstyle=\"margin: 15px\"><form name=\"runningSettings\" id=\"runningSettings\" \nbind-html-compile=\"getProjectSettings(selectedProject)\"></form><div class=\"row\"><div class=\"col-md-6\"></div><div \nclass=\"col-md-6\" align=\"right\"><button class=\"btn btn-primary\" ng-disabled=\"runningSettings.$invalid\" \nng-click=\"saveProjectSettings()\">Save</button></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><pre>{{ runningSettings | json }}</pre></div><div class=\"col-md-6\"><pre>\n{{ runningSettingsData | json }}</pre></div></div></div></md-dialog-content></md-dialog>\"");
$templateCache.put("app/projects/rcloudsys/smstemplate/edit_smstemplate/edit_smstemplate.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"smstemplate/list/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Edit Template\" footer=\"Edit a Template\" size=\"col-md-12\"><form name=\"edittemplateB\" id=\"edittemplateB\"><div \nclass=\"row\"><div bind-html-compile=\"getProjectBox()\"></div><textbox quickattrs=\"templatename\" size=\"col-md-6\">\n</textbox></div><div class=\"row\"><textbox modelname=\"sms_desc\" quickattrs=\"description\" size=\"col-md-12\"></textbox>\n</div><div class=\"row\"><div bind-html-compile=\"getAccVarBox()\"></div><selectbox quickattrs=\"temptype\" size=\"col-md-6\">\n</selectbox></div><div class=\"row\"><selectbox quickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\" \nng-show=\"edittemplateBData.temptype === \'schedule\'\"><textbox quickattrs=\"user_info_query\" required=\"false\" \nsize=\"col-md-12\"></textbox></div><div class=\"forEvent\" ng-show=\"edittemplateBData.temptype === \'event\'\"><div \nclass=\"row\"><div class=\"col-md-12\"><label for=\"smstemplate\">SMS Template</label><textarea \nng-model=\"edittemplateBData.smstemplate\" rows=\"4\" style=\"width: 100%; resize: none\" ;></textarea></div></div><div \nclass=\"row\"><div class=\"col-md-12\"><label for=\"smsquery\">SMS Query</label><textarea \nng-model=\"edittemplateBData.smsquery\" rows=\"4\" style=\"width: 100%; resize: none\" ;></textarea></div></div></div><div \nclass=\"forSchudle\" ng-show=\"edittemplateBData.temptype === \'schedule\'\"><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"smstemplate\">Header Template</label><textarea ng-model=\"edittemplateBData.smsheadertemplate\" rows=\"4\" \nstyle=\"width: 100%; resize: none\" ;></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"smstemplate\">Footer Template</label><textarea ng-model=\"edittemplateBData.smsfootertemplate\" rows=\"4\" \nstyle=\"width: 100%; resize: none\" ;></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><label \nfor=\"smstemplate\">Content Template</label><textarea ng-model=\"edittemplateBData.smstemplate\" rows=\"4\" \nstyle=\"width: 100%; resize: none\" ;></textarea></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button \ntype=\"submit\" class=\"btn btn-info m-t\" minlength=\"10\" ng-disabled=\"edittemplateB.$invalid\" \nng-click=\"editSmsTemplate()\">Submit</button></div></div></form><br><br><div class=\"row\"><h3 align=\"center\">Common</h3>\n<hr><h5>%company_name% - Company Name</h5><h5>%party_name% - Party Name</h5><h5>%cdate% - Current Date</h5><br></div>\n<div class=\"row\" ng-if=\"edittemplateBData.projectid === \'5\' && edittemplateBData.temptype === \'event\'\"><div \nclass=\"col-md-12\"><h3 align=\"center\">Knitpack</h3><hr><h4>Yarn Grn Create (yarn_grn_create)</h4><h5>\n%party_dc_no% - Party Dc No</h5><h5>%party_dc_date% - Party Dc Date</h5><h5>%our_grn_no% - Our GRN No</h5><h5>\n%our_grn_date% - Our GRN Date</h5><h5>%no_of_bags% - Total No of Bags</h5><h5>%total_net_kgs% - Total Net Kgs</h5><br>\n<h4>Yarn Return Create (yarn_return_create)</h4><h5>%our_dc_no% - Our Dc No</h5><h5>%our_dc_date% - Our Dc Date</h5>\n<h5>%no_of_bags% - Total No of Bags</h5><h5>%total_net_kgs% - Total Net Kgs</h5><h5>%order_ref_no% - Order Ref No</h5>\n<br><h4>Fabric DC Create (fabric_dc_create)</h4><h5>%our_dc_no% - Our Dc No</h5><h5>%our_dc_date% - Our Dc Date</h5>\n<h5>%no_of_rolls_pcs% - Total No of Rolls or Pcs</h5><h5>%total_net_kgs% - Total Net Kgs</h5><h5>\n%order_ref_no% - Order Ref No</h5><br></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\">\n<h4>Form Live Value</h4><pre>{{ edittemplateBData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation\n</h4><pre>{{ edittemplateB | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/smstemplate/list_sms_log/sms_log.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><span></span> <a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">\nBack to Companies List</a></div></div><div class=\"row\"><rd-window header=\"List Sms Log\" \nfooter=\"Shows a List in Sms Log\" size=\"col-md-12\"><div class=\"row rownopadding\"><div class=\"table-responsive\" \nwidth=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"smslist\"><thead></thead><tbody></tbody>\n<tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nLive Data fromServer</h4><pre>{{ templatelist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/smstemplate/list_smstemplate/list_smstemplate.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"smstemplate/add/{{ cid }}\" class=\"btn btn-primary m-t\">Create Template</a> <a \nhref=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><div class=\"row\"><rd-window \nheader=\"List Template\" footer=\"Shows a List in Template\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"listtemplatetable\">\n<thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ templatelist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/smstemplate/temp_sett/temp_sett.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><span>\n</span> <a href=\"companies/list\" ng-show=\"!self_page\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div>\n<rd-window header=\"Notification Settings\"><form name=\"temp_sett\" id=\"temp_sett\"><ng-form name=\"Ngtemp_sett\" \nid=\"Ngtemp_sett\" ng-repeat=\"sett in temp_settData.setting track by $index\"><div class=\"row\"><div class=\"col-md-3\"><h4>\n{{ sett.project_name }}</h4></div><div class=\"col-md-3\"><h5>{{ sett.templatename }}</h5></div><div class=\"col-md-3\">\n<h5>{{ sett.sms_desc }}</h5></div><selectbox quickattrs=\"status\" modelname=\"sett.status\" itemtype=\"ngform\" \nmodelname=\"password_notify_status\" size=\"col-md-3\"></selectbox></div><div class=\"row\"><hr></div></ng-form><div \nclass=\"row\"><div class=\"col-md-12\" align=\"right\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-disabled=\"temp_sett.$invalid\" ng-click=\"addSetting()\">Save</button></div></div></form><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ temp_settData | json }}</pre></div>\n<div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ temp_sett | json }}</pre></div></div></rd-window>");
$templateCache.put("app/views/rcloud/manage/profile/profile.html","<div class=\"row\"><rd-window header=\"Your Information\" footer=\"This above information is stored in server about you.\" \nsize=\"col-md-4\"><div class=\"row\"><h2 align=\"center\">{{userSession.session.display_name}}</h2><br><br><br><div \nclass=\"row\"><div class=\"col-md-5\"><p>rCloud User Id:</p></div><div class=\"col-md-7\"><p><strong>\nRCLOUD{{userSession.session.user_id}}</strong></p></div></div><div class=\"row\"><div class=\"col-md-5\"><p>\nEmail (Username):</p></div><div class=\"col-md-7\"><p><strong><a href=\"mailto:{{userSession.session.username}}\" \ntarget=\"_blank\">{{userSession.session.username}}</a></strong></p></div></div><div class=\"row\"><div class=\"col-md-5\"><p>\nGender:</p></div><div class=\"col-md-7\"><p ng-if=\"userSession.session.gender === \'m\'\"><strong>Male</strong></p><p \nng-if=\"userSession.session.gender === \'f\'\"><strong>Female</strong></p></div></div><div class=\"row\"><div \nclass=\"col-md-5\"><p>DOB:</p></div><div class=\"col-md-7\"><p><strong>\n{{userSession.session.dob | amDateFormat: \'ddd, Do MMM YYYY\'}}</strong></p></div></div><div class=\"row\"><div \nclass=\"col-md-5\"><p>Mobile No:</p></div><div class=\"col-md-7\"><p><strong><a \nhref=\"tel:+{{userSession.session.mobileno}}\" target=\"_blank\">+{{userSession.session.mobileno}}</a></strong></p></div>\n</div><div class=\"row\"><div class=\"col-md-5\"><p>User Role:</p></div><div class=\"col-md-7\"><p><strong>\n{{userSession.session.user_role}}</strong></p></div></div><hr><div class=\"row\"><div class=\"col-md-5\"><p>\nCompany rCloud ID:</p></div><div class=\"col-md-7\"><p><strong>RCLOUDCMP{{userSession.session.company_info.id}}</strong>\n</p></div></div><div class=\"row\"><div class=\"col-md-5\"><p>Company Name:</p></div><div class=\"col-md-7\"><p><strong>\n{{userSession.session.company_info.cmp_name}} - #{{userSession.session.company_info.uniquename}}</strong></p></div>\n</div><div class=\"row\"><div class=\"col-md-5\"><p>Lisence Expire :</p></div><div class=\"col-md-7\"><p><strong><time \nam-time-ago=\"userSession.session.company_info.valid_till\" \ntitle=\"{{ userSession.session.company_info.valid_till | amDateFormat: \'dddd, MMMM Do YYYY, h:mm a\' }}\"></time></strong>\n</p></div></div><hr><div class=\"row\"><div class=\"col-md-5\"><p>Last Updated:</p></div><div class=\"col-md-7\"><p><strong>\n<time am-time-ago=\"userSession.session.updated_time\" \ntitle=\"{{ userSession.session.updated_time | amDateFormat: \'dddd, MMMM Do YYYY, h:mm a\' }}\"></time></strong></p></div>\n</div><hr><div class=\"row\"><div class=\"col-md-5\"><p>Last Password Changed:</p></div><div class=\"col-md-7\"><p><strong>\n<time am-time-ago=\"userSession.session.password_change\" \ntitle=\"{{ userSession.session.password_change | amDateFormat: \'dddd, MMMM Do YYYY, h:mm a\' }}\"></time></strong></p>\n</div></div></div><div class=\"row\"><div ng-if=\"projectInfo.debugger\"><h4>Info From Server</h4><pre>\n{{ userSession.session | json }}</pre></div></div></rd-window><rd-window header=\"Update Your Information\" \nfooter=\"Update your information is stored in server.\" size=\"col-md-8\"><form role=\"form\" name=\"profile_form\" \nid=\"profile_form\"><div class=\"row\"><textbox quickattrs=\"displayname\" size=\"col-md-6\"></textbox><textbox \nquickattrs=\"loginEmail\" size=\"col-md-6\" posturlcheck=\"rcloudsys/users/uEmailChangeCheck\"></textbox></div><div \nclass=\"row\"><textbox quickattrs=\"mobileno\" size=\"col-md-6\" posturlcheck=\"rcloudsys/users/uMobileChangeCheck\"></textbox>\n<selectbox quickattrs=\"gender\" size=\"col-md-6\"></selectbox></div><div class=\"row\"><datebox quickattrs=\"dob\" \nsize=\"col-md-6\"></datebox></div><div class=\"row\"><div class=\"col-md-12\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>From Data Updated</h4><pre>{{ profile_formData | json }}</pre></div><div class=\"col-md-6\"><h4>\nFrom Live Validaton</h4><pre>{{ profile_form | json }}</pre></div></div></div><div class=\"row\"><div class=\"col-md-6\">\n<button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"profile_form.$invalid\" ng-click=\"updateInfo()\">\nUpdate Profile Information</button></div></div></form></rd-window><rd-window header=\"Change Account Password\" \nfooter=\"Change your pasword used for login.\" size=\"col-md-8\"><form role=\"form\" name=\"password_change\" \nid=\"password_change\"><div class=\"row\"><textbox quickattrs=\"loginPassword\" size=\"col-md-6\"></textbox><textbox \nquickattrs=\"loginPassword\" modelname=\"conformpassword\" itemid=\"conformpassword\" size=\"col-md-6\"></textbox></div><div \nclass=\"row\"><div class=\"col-md-12\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>From Data Updated</h4><pre>\n{{ password_changeData | json }}</pre></div><div class=\"col-md-6\"><h4>From Live Validaton</h4><pre>\n{{ password_change | json }}</pre></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nng-click=\"updatePassword()\" class=\"btn btn-info m-t\" \nng-disabled=\"(password_changeData.password === password_changeData.conformpassword) ? password_change.$invalid : true\">\nChange Password</button></div></div></form></rd-window><rd-window header=\"Two Factor Authentication\" \nfooter=\"Change your Two Factor Authentication\" size=\"col-md-8\"><form role=\"form\" name=\"tow_fact\" id=\"tow_fact\"><div \nclass=\"row\"><selectbox quickattrs=\"twofact_auth\" rdchange=\"getTwoFactCode()\" size=\"col-md-6\"></selectbox><div \nclass=\"col-md-6\"><h4 style=\"margin-top: 25px\"><a \nhref=\"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN\" target=\"_blank\" \nstyle=\"color: blue; text-decoration: underline\">Download Google Authenticator</a></h4></div></div><div class=\"row\" \nng-show=\"codeURL\"><div class=\"col-md-6\"><img ng-src=\"{{ codeURL }}\"></div></div><div class=\"row\" ng-show=\"codeURL\" \nstyle=\"margin-top: 20px\"><div bind-html-compile=\"getReqCodBox()\"></div></div><div class=\"row\" ng-show=\"codeReq\"><div \nclass=\"col-md-6\"><p style=\"color: red\" ng-show=\"!codeResult\">Invalid Auth Code..</p></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" ng-click=\"saveTwoFact()\" class=\"btn btn-info m-t\" \nng-disabled=\"tow_fact.$invalid || !codeResult\">Save Auth Method</button></div></div><div class=\"row\"><div \nclass=\"col-md-12\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>From Data Updated</h4><pre>\n{{ tow_factData | json }}</pre></div><div class=\"col-md-6\"><h4>From Live Validaton</h4><pre>{{ tow_fact | json }}</pre>\n</div></div></div></form></rd-window></div>");
$templateCache.put("app/views/rcloud/manage/settings/settings.html","<div class=\"row\"><rd-window header=\"User Settings\" \nfooter=\"Control Your Settings for this session or For Every Session.\" size=\"col-md-12\"><form name=\"settingsForm\" \nid=\"settingsForm\"><div class=\"row\"><h5>Notification Settings</h5><br></div><div class=\"row\"><selectbox \nquickattrs=\"toastposition\"></selectbox><numberbox quickattrs=\"toasttiming\"></numberbox></div><hr><div class=\"row\"><h5>\nScreen Lock Settings</h5><br></div><div class=\"row\"><numberbox quickattrs=\"screenlocktiming\"></numberbox><numberbox \nquickattrs=\"autoLogoutTime\"></numberbox></div><hr><div class=\"row\"><h5>Date Time Picker Settings</h5><br></div><div \nclass=\"row\"><selectbox quickattrs=\"datepickerSetting\"></selectbox><selectbox quickattrs=\"timepickerSetting\">\n</selectbox></div><div class=\"row\"><selectbox quickattrs=\"monthpickerSetting\"></selectbox></div><div class=\"row\"><div \nclass=\"col-md-12\" align=\"right\"><button type=\"button\" class=\"btn btn-info m-t\" ng-disabled=\"settingsForm.$invalid\" \nng-click=\"updateThisSession()\">Temp Update</button> <button type=\"button\" class=\"btn btn-info m-t\" \nng-disabled=\"settingsForm.$invalid\" ng-click=\"updateSettings()\">Save Settings</button></div></div></form><div \nclass=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ settingsFormData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ settingsForm | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/communicationscheduler/email_scheduler/add_emailscheduler/add_emailscheduler.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"communicationscheduler/listemail/{{ id }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\">\n<rd-window header=\"Create Email Scheduler\" footer=\"Create a Email Scheduler\" size=\"col-md-12\"><form \nname=\"addscheduler\" id=\"addscheduler\"><div class=\"row\"><textbox quickattrs=\"eventname\"></textbox><div \nbind-html-compile=\"getProjectBox()\"></div></div><div class=\"row\"><div bind-html-compile=\"getTemplateBox()\"></div>\n<selectbox quickattrs=\"status\" size=\"col-md-6\"></selectbox></div><div class=\"row\"><selectbox quickattrs=\"schtype\">\n</selectbox></div><div class=\"row\"><div bind-html-compile=\"getLev1Box()\"></div><div bind-html-compile=\"getLev2Box()\">\n</div></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-disabled=\"addscheduler.$invalid\" ng-click=\"addEmailScheduler()\">Submit</button></div></div></form><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ addschedulerData | json }}</pre>\n</div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ addscheduler | json }}</pre></div></div></rd-window>\n</div>");
$templateCache.put("app/projects/rcloudsys/communicationscheduler/email_scheduler/edit_emailscheduler/edit_emailscheduler.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"communicationscheduler/listemail/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\">\n<rd-window header=\"Edit Email Scheduler\" footer=\"Edit a Email Scheduler\" size=\"col-md-12\"><form name=\"editscheduler\" \nid=\"editscheduler\"><div class=\"row\"><textbox quickattrs=\"eventname\"></textbox><div bind-html-compile=\"getProjectBox()\">\n</div></div><div class=\"row\"><div bind-html-compile=\"getTemplateBox()\"></div><selectbox quickattrs=\"status\" \nsize=\"col-md-6\"></selectbox></div><div class=\"row\"><selectbox quickattrs=\"schtype\"></selectbox></div><div class=\"row\">\n<div bind-html-compile=\"getLev1Box()\"></div><div bind-html-compile=\"getLev2Box()\"></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editscheduler.$invalid\" \nng-click=\"editEmailScheduler()\">Update</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ editschedulerData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ editscheduler | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/communicationscheduler/email_scheduler/list_emailscheduler/list_emailscheduler.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"communicationscheduler/addemail/{{ id }}\" class=\"btn btn-primary m-t\">Create Email Scheduler</a>\n <a href=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><div class=\"row\"><rd-window \nheader=\"List Email Scheduler\" footer=\"Shows a List in Email Scheduler\" size=\"col-md-12\"><div class=\"row rownopadding\">\n<div class=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" \nid=\"listschedulertable\"><thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ schedulerlist | json }}</pre>\n</div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/communicationscheduler/sms_scheduler/add_smsscheduler/add_smsscheduler.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"communicationscheduler/listsms/{{ id }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\">\n<rd-window header=\"Create Sms Scheduler\" footer=\"Create a Sms Scheduler\" size=\"col-md-12\"><form name=\"addscheduler\" \nid=\"addscheduler\"><div class=\"row\"><textbox quickattrs=\"eventname\"></textbox><div bind-html-compile=\"getProjectBox()\">\n</div></div><div class=\"row\"><div bind-html-compile=\"getTemplateBox()\"></div><selectbox quickattrs=\"status\" \nsize=\"col-md-6\"></selectbox></div><div class=\"row\"><selectbox quickattrs=\"schtype\"></selectbox></div><div class=\"row\">\n<div bind-html-compile=\"getLev1Box()\"></div><div bind-html-compile=\"getLev2Box()\"></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"addscheduler.$invalid\" \nng-click=\"addSmsScheduler()\">Submit</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ addschedulerData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ addscheduler | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/communicationscheduler/sms_scheduler/edit_smsscheduler/edit_smsscheduler.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"communicationscheduler/listsms/{{ cid }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\">\n<rd-window header=\"Edit Sms Scheduler\" footer=\"Edit a Sms Scheduler\" size=\"col-md-12\"><form name=\"editscheduler\" \nid=\"editscheduler\"><div class=\"row\"><textbox quickattrs=\"eventname\"></textbox><div bind-html-compile=\"getProjectBox()\">\n</div></div><div class=\"row\"><div bind-html-compile=\"getTemplateBox()\"></div><selectbox quickattrs=\"status\" \nsize=\"col-md-6\"></selectbox></div><div class=\"row\"><selectbox quickattrs=\"schtype\"></selectbox></div><div class=\"row\">\n<div bind-html-compile=\"getLev1Box()\"></div><div bind-html-compile=\"getLev2Box()\"></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editscheduler.$invalid\" \nng-click=\"editSmsScheduler()\">Update</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ editschedulerData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ editscheduler | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/communicationscheduler/sms_scheduler/list_smsscheduler/list_smsscheduler.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>{{ cmpName }}</h3></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"communicationscheduler/addsms/{{ id }}\" class=\"btn btn-primary m-t\">Create Sms Scheduler</a> <a \nhref=\"companies/list\" class=\"btn btn-info m-t\">Back to Companies List</a></div></div><div class=\"row\"><rd-window \nheader=\"List Sms Scheduler\" footer=\"Shows a List in Sms Scheduler\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"listschedulertable\">\n<thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ schedulerlist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/databasetype/add_databasetype/add_databasetype.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/listdbtype\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Create Database Type\" footer=\"Create a Database Type for Different Products\" size=\"col-md-12\"><form \nname=\"adddatabasetype\" id=\"adddatabasetype\"><div class=\"row\"><textbox quickattrs=\"dbtypename\"></textbox><textbox \nquickattrs=\"shortcode\"></textbox></div><div class=\"row\"><selectbox quickattrs=\"listprojects\" multiple=\"false\" \nmodelname=\"project_id\"></selectbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"adddatabasetype.$invalid\" ng-click=\"adddbtype()\">Submit</button></div></div>\n</form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ adddatabasetypeData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ adddatabasetype | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/databasetype/list_databasetype/list_databasetype.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><a ng-click=\"backupProjects()\" \nclass=\"btn btn-primary m-t\" style=\"float: left; margin-right: 25px\">Backup DBTypes</a><form name=\"importProjectsForm\" \nid=\"importProjectsForm\"><input ng-show=\"backupDone\" type=\"file\" style=\"float: left; margin-top: 17px\" \nname=\"import_file\" id=\"import_file\" fileread=\"importProjectsFormData.import_file\" accept=\".rcloud\"></form><button \nng-show=\"backupDone\" ng-click=\"importProjects()\" ng-disabled=\"!importProjectsFormData.import_file\" \nclass=\"btn btn-info m-t\">Import DBTypes</button></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/adddbtype\" class=\"btn btn-primary m-t\">Create Database Type</a></div></div><div class=\"row\"><rd-window \nheader=\"List Database Type\" footer=\"Shows a List in Database Type\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" \nid=\"listdatabasetypetable\"><thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ databasetypelist | json }}\n</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/database/edit_database/edit_database.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/listdatabase\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Edit Database\" footer=\"Edit a Database\" size=\"col-md-12\"><form name=\"editdatabase\" id=\"editdatabase\"><div \nclass=\"row\"><selectbox quickattrs=\"companyid\"></selectbox><textbox quickattrs=\"dbname\" readonly=\"true\"></textbox></div>\n<div class=\"row\"><textbox quickattrs=\"username\" readonly=\"true\"></textbox><textbox quickattrs=\"password\" \npattern=\"/(?=^.{8,15}$)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&])(?!.*\\s).*$/\"></textbox></div><div class=\"row\">\n<selectbox quickattrs=\"dbtype\"></selectbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"editdatabase.$invalid\" ng-click=\"editDatabase()\">Update Database</button></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ editdatabaseData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ editdatabase | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/database/list_database/list_database.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/adddatabase\" class=\"btn btn-primary m-t\">Create Database</a></div></div><div class=\"row\"><rd-window \nheader=\"List Database\" footer=\"Shows a List in Database\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"listdatabasetable\">\n<thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Live Data fromServer</h4><pre>{{ databaselist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/database/add_database/add_database.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/listdatabase\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Create Database\" footer=\"Create a Database\" size=\"col-md-12\"><form name=\"adddatabase\" id=\"adddatabase\"><div \nclass=\"row\"><selectbox quickattrs=\"companyid\"></selectbox><textbox quickattrs=\"dbname\" maxlength=\"11\"></textbox></div>\n<div class=\"row\"><textbox quickattrs=\"username\" maxlength=\"11\"></textbox><textbox quickattrs=\"password\" \npattern=\"/(?=^.{8,15}$)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&])(?!.*\\s).*$/\"></textbox></div><div class=\"row\">\n<selectbox quickattrs=\"dbtype\"></selectbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"adddatabase.$invalid\" ng-click=\"addDatabase()\">Submit</button></div></div></form>\n<div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ adddatabaseData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ adddatabase | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/dbquery/add_query/add_query.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/listquery/{{ code }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Create Query\" footer=\"Create a Query\" size=\"col-md-12\"><form name=\"addquery\" id=\"addquery\"><div class=\"row\">\n<textbox quickattrs=\"name\" size=\"col-md-6\"></textbox><numberbox quickattrs=\"version\" minnumber=\"{{ minVersion }}\" \nreadonly=\"true\"></numberbox><div class=\"col-md-12\"><textarea ng-model=\"addqueryData.query\" required=\"required\" \nstyle=\"width: 100%; max-width: 100%; min-width: 100%; height: 300px\"></textarea></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"addquery.$invalid\" \nng-click=\"addNewQuery()\">Submit</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ addqueryData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ addquery | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/dbquery/edit_query/edit_query.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/listquery/{{ code }}\" class=\"btn btn-primary m-t\">Back</a></div></div><div class=\"row\"><rd-window \nheader=\"Edit Query\" footer=\"Edit a Query\" size=\"col-md-12\"><form name=\"editquery\" id=\"editquery\"><div class=\"row\">\n<textbox quickattrs=\"name\" size=\"col-md-6\"></textbox><numberbox quickattrs=\"version\" readonly=\"true\"></numberbox><div \nclass=\"col-md-12\"><textarea ng-model=\"editqueryData.query\" required=\"required\" \nstyle=\"width: 100%; max-width: 100%;  min-width: 100%; height: 300px\"></textarea></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editquery.$invalid\" \nng-click=\"editAQuery()\">Update Database</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ editqueryData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ editquery | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/dbschemes/dbquery/list_query/list_query.html","<div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"dbschemes/addquery/{{ code }}\" class=\"btn btn-primary m-t\">Create Query</a> <a href=\"dbschemes/listdbtype\" \nclass=\"btn btn-info m-t\">Back to DB Schemes</a></div></div><div class=\"row\"><rd-window header=\"List Query\" \nfooter=\"Shows a List in Query\" size=\"col-md-12\"><div class=\"row rownopadding\"><div class=\"table-responsive\" \nwidth=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"listquerytable\"><thead></thead><tbody>\n</tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nLive Data fromServer</h4><pre>{{ querylist | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/modelgroups/add_modgroups/add_modgroups.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3><i class=\"{{ cproject.icon }}\">\n</i> {{ cproject.name }} ({{ cproject.projectid }})</h3></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"modgroups/list/{{ cproject.id }}\" class=\"btn btn-primary m-t\">Back to Models Group List</a></div></div><rd-window\n header=\"Create a Model Group\" footer=\"Add Your Model Group and Control your Model Group with the Users.\" \nsize=\"col-md-12\"><form role=\"form\" name=\"addmodgroup\" id=\"addmodgroup\"><div class=\"row\"><textbox \nquickattrs=\"projectname\" itemid=\"modelgroupname\"></textbox><textbox quickattrs=\"projectid\" itemid=\"modelgroupid\" \nmodelname=\"modgrpid\" geturlcheck=\"rcloudsys/modgroups/mgrpDupCheck/\"></textbox></div><div class=\"row\"><selectbox \nquickattrs=\"projectstatus\" itemid=\"modelgroupstatus\"></selectbox><div bind-html-compile=\"getIConBox()\"></div></div><div\n class=\"row\"><numberbox quickattrs=\"show_order\"></numberbox></div><div class=\"row\"><div class=\"col-md-6\"><b>Preview</b>\n<p><b><i ng-if=\"cproject.project_fw === \'js\'\" class=\"{{ addprojectData.icon }}\"></i> <i \nng-if=\"cproject.project_fw === \'ts\'\" class=\"tiny material-icons\">{{ addprojectData.icon }}</i>\n {{ addmodgroupData.name }}</b></p></div></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"addmodgroup.$invalid\" ng-click=\"addModgroup()\">Add Model Group</button></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ addmodgroupData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ addmodgroup | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/modelgroups/edit_modgroups/edit_modgroups.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"modgroups/list/{{ editmodelgroupData.project_id }}\" class=\"btn btn-primary m-t\">\nBack to Models Group List</a></div></div><rd-window header=\"Edit Project\" footer=\"Edit a Current Project\" \nsize=\"col-md-12\"><form role=\"form\" name=\"editmodelgroup\" id=\"editmodelgroup\"><div class=\"row\"><textbox \nquickattrs=\"projectname\" itemid=\"modelgroupname\"></textbox><textbox quickattrs=\"projectid\" itemid=\"modelgroupid\" \nmodelname=\"modgrpid\" geturlcheck=\"false\" readonly=\"true\"></textbox></div><div class=\"row\"><selectbox \nquickattrs=\"projectstatus\" itemid=\"modelgroupstatus\"></selectbox><div bind-html-compile=\"getIConBox()\"></div></div><div\n class=\"row\"><numberbox quickattrs=\"show_order\"></numberbox></div><div class=\"row\"><div class=\"col-md-6\"><button \ntype=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editmodelgroup.$invalid\" ng-click=\"updateModelgroup()\">\nUpdate Model Group</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>\nForm Live Value</h4><pre>{{ editmodelgroupData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4>\n<pre>{{ editmodelgroup | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/modelgroups/list_modgroups/list_modgroups.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3><i class=\"{{ cproject.icon }}\">\n</i> {{ cproject.name }} ({{ cproject.projectid }})</h3></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"modgroups/add/{{ cproject.id }}\" class=\"btn btn-info m-t\">Create Model Group</a> <a href=\"projects/list\" \nclass=\"btn btn-primary m-t\">Back to Projects List</a></div></div><rd-window header=\"Models Group List\" \nfooter=\"Shows a Models Group List & Edit or Remove Models Group\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" \nid=\"modelsgrouplisttable\"><thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" \nng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data from Server</h4><pre>{{ projectlst | json }}</pre>\n</div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/model/add_model/add_model.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3><i class=\"{{ cmgroup.icon }}\">\n</i> {{ cmgroup.name }} ({{ cmgroup.modgrpid }})</h3></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"models/list/{{ cmgroup.id }}\" class=\"btn btn-primary m-t\">Back to Models List</a></div></div><rd-window \nheader=\"Create a Model\" footer=\"Add Your Model and Control your Model with the Users.\" size=\"col-md-12\"><form \nrole=\"form\" name=\"addmodel\" id=\"addmodel\"><div class=\"row\"><textbox quickattrs=\"projectname\" itemid=\"modelname\">\n</textbox><textbox quickattrs=\"projectid\" itemid=\"modelid\" modelname=\"modid\" \ngeturlcheck=\"rcloudsys/pmodel/pmodDupCheck/\"></textbox></div><div class=\"row\"><selectbox quickattrs=\"projectstatus\" \nitemid=\"modelstatus\"></selectbox><div bind-html-compile=\"getIConBox()\"></div></div><div class=\"row\"><numberbox \nquickattrs=\"show_order\"></numberbox><textbox quickattrs=\"uref\"></textbox></div><div class=\"row\"><textbox \nquickattrs=\"href\"></textbox><textbox quickattrs=\"submodules\"></textbox></div><div class=\"row\"><div class=\"col-md-6\"><b>\nPreview</b><p><b><i class=\"{{ addmodelData.icon }}\"></i> {{ addmodelData.name }}</b></p></div></div><div class=\"row\">\n<div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"addmodel.$invalid\" \nng-click=\"addModel()\">Add Model</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ addmodelData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ addmodel | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/model/edit_model/edit_model.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"models/list/{{ editmodelData.modgrp_id }}\" class=\"btn btn-primary m-t\">Back to Models List</a>\n</div></div><rd-window header=\"Edit Model\" footer=\"Edit a Current Model\" size=\"col-md-12\"><form role=\"form\" \nname=\"editmodel\" id=\"editmodel\"><div class=\"row\"><textbox quickattrs=\"projectname\" itemid=\"modelname\"></textbox>\n<textbox quickattrs=\"projectid\" itemid=\"modelid\" modelname=\"modid\" geturlcheck=\"false\" readonly=\"true\"></textbox></div>\n<div class=\"row\"><selectbox quickattrs=\"projectstatus\" itemid=\"modelstatus\"></selectbox><div \nbind-html-compile=\"getIConBox()\"></div></div><div class=\"row\"><numberbox quickattrs=\"show_order\"></numberbox><textbox \nquickattrs=\"uref\"></textbox></div><div class=\"row\"><textbox quickattrs=\"href\"></textbox><textbox \nquickattrs=\"submodules\"></textbox></div><div class=\"row\"><div class=\"col-md-6\"><b>Preview</b><p><b><i \nng-if=\"cproject.project_fw === \'js\'\" class=\"{{ addprojectData.icon }}\"></i> <i ng-if=\"cproject.project_fw === \'ts\'\" \nclass=\"tiny material-icons\">{{ addprojectData.icon }}</i> {{ editmodelData.name }}</b></p></div></div><div class=\"row\">\n<div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"editmodel.$invalid\" \nng-click=\"updateModel()\">Update Model</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ editmodelData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ editmodel | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/model/list_model/list_model.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3><i class=\"{{ cmgroup.icon }}\">\n</i> {{ cmgroup.name }} ({{ cmgroup.modgrpid }})</h3></div><div class=\"col-md-6\" align=\"right\"><a \nhref=\"models/add/{{ cmgroup.id }}\" class=\"btn btn-info m-t\">Create Model</a> <a \nhref=\"modgroups/list/{{ cmgroup.project_id }}\" class=\"btn btn-primary m-t\">Back to Model Group List</a></div></div>\n<rd-window header=\"Models List\" footer=\"Shows a Models List & Edit or Remove Models\" size=\"col-md-12\"><div \nclass=\"row rownopadding\"><div class=\"table-responsive\" width=\"100%\"><table \nclass=\"table table-striped b-t b-b dt-responsive\" id=\"modelslisttable\"><thead></thead><tbody></tbody><tfoot></tfoot>\n</table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data from Server</h4>\n<pre>{{ modLst | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/packages/add_package/add.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"packages/list/{{ projectID }}\" class=\"btn btn-primary m-t\">Back to Packages List</a></div></div>\n<rd-window header=\"Create a Package\" footer=\"Add Your Package and Control your Package with the Users.\" \nsize=\"col-md-12\"><form role=\"form\" name=\"addpackage\" id=\"addpackage\"><div class=\"row\"><textbox \nquickattrs=\"packagename\"></textbox><textbox quickattrs=\"packageid\"></textbox></div><div class=\"row\"><div \nclass=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-disabled=\"addpackage.$invalid\" \nng-click=\"addPackage()\">Add Package</button></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Form Live Value</h4><pre>{{ addpackageData | json }}</pre></div><div class=\"col-md-6\"><h4>\nForm Live Validation</h4><pre>{{ addpackage | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/packages/edit_package/edit.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"packages/list/{{ projectID }}\" class=\"btn btn-primary m-t\">Back to Packages List</a></div></div>\n<rd-window header=\"Edit Package\" footer=\"Edit a Current Package\" size=\"col-md-12\"><form role=\"form\" name=\"editpackage\" \nid=\"editpackage\"><div class=\"row\"><textbox quickattrs=\"packagename\"></textbox><textbox quickattrs=\"packageid\" \ngeturlcheck=\"false\" readonly=\"true\"></textbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"editpackage.$invalid\" ng-click=\"updatePackage()\">Update Package</button></div>\n</div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ editpackageData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ editpackage | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/packages/list_package/list.html","<div class=\"row\"></div><div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div \nclass=\"col-md-6\" align=\"right\"><a href=\"packages/add/{{ projectID }}\" class=\"btn btn-info m-t\">Create Package</a> <a \nhref=\"projects/list\" class=\"btn btn-primary m-t\">Back to Projects List</a></div></div></div><div class=\"row\"><rd-window\n header=\"Packages List\" footer=\"Shows a Package List & Edit or Remove Package\" size=\"col-md-12\"><div \nclass=\"row rownopadding\"><div class=\"table-responsive\" width=\"100%\"><table \nclass=\"table table-striped b-t b-b dt-responsive\" id=\"packagelisttable\"><thead></thead><tbody></tbody><tfoot></tfoot>\n</table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Data from Server</h4>\n<pre>{{ packagelst | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/packages/manage_package/manage_package.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><h3>Package : {{ package.name}}\n</h3><h4>Project : <strong><i class=\"{{ package.project.icon }}\"></i> {{ package.project.name }}</strong></h4></div>\n<div class=\"col-md-6\" align=\"right\"><a href=\"packages/list/{{ projectID }}\" class=\"btn btn-primary m-t\">\nBack to Packages List</a></div></div><rd-window header=\"Manage {{ package.name}} Package\" \nfooter=\"Manage Current Package\" size=\"col-md-12\"><form role=\"form\" name=\"managepackage\" id=\"managepackage\"><div \nclass=\"row\" style=\"margin-bottom: 40px\" align=\"right\"><div class=\"col-md-12\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-click=\"updatePackage()\">Update Package</button></div></div><div class=\"row\" \nstyle=\"margin-bottom: 60px\"><numberbox quickattrs=\"data_transfer_limit\" itemtype=\"private\" \nmodelname=\"package.project.transfer_limit\"></numberbox><numberbox quickattrs=\"storage_transfer_limit\" \nitemtype=\"private\" modelname=\"package.project.storage_limit\"></numberbox></div><div class=\"row\" \nstyle=\"margin-bottom: 60px\"><numberbox quickattrs=\"email_transfer_limit\" itemtype=\"private\" \nmodelname=\"package.project.email_limit\"></numberbox></div><div class=\"row\"><div class=\"col-md-3\"><md-checkbox \nng-checked=\"isWholeProjectChecked()\" ng-click=\"toggleWholeProjectAll()\"><i>* Over All {{ package.project.name }} Models\n</i></md-checkbox></div><div class=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_view\" \nng-click=\"package.project.whole_view = !package.project.whole_view\"><i>* View Over All</i></md-checkbox></div><div \nclass=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_create\" \nng-click=\"package.project.whole_create = !package.project.whole_create\"><i>* Create Over All</i></md-checkbox></div>\n<div class=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_edit\" \nng-click=\"package.project.whole_edit = !package.project.whole_edit\"><i>* Edit Over All</i></md-checkbox></div><div \nclass=\"col-md-2\"><md-checkbox ng-checked=\"package.project.whole_delete\" \nng-click=\"package.project.whole_delete = !package.project.whole_delete\"><i>* Delete Over All</i></md-checkbox></div>\n</div><div class=\"row\" ng-show=\"!package.project.whole_models\"><div><div class=\"row\" \nng-repeat=\"group in package.modelgroups\"><div class=\"row modelgrouprow\"><div class=\"col-md-3\"><md-checkbox \nng-checked=\"isChecked(group)\" md-indeterminate=\"isIndeterminate(group)\" ng-click=\"toggleAll(group)\"><i \nclass=\"{{ group.icon }}\"></i> {{ group.name }}</md-checkbox><md-checkbox ng-checked=\"isWholeChecked(group)\" \nng-click=\"toggleWholeAll(group)\"><i>* All {{ group.name }} Models</i></md-checkbox></div><div class=\"col-md-2\">\n<md-checkbox ng-checked=\"isViewChecked(group)\" md-indeterminate=\"isViewIndeterminate(group)\" \nng-click=\"toggleViewAll(group)\">View</md-checkbox><md-checkbox ng-checked=\"group.whole_view\" \nng-click=\"group.whole_view = !group.whole_view\"><i>* View All</i></md-checkbox></div><div class=\"col-md-2\"><md-checkbox\n ng-checked=\"isCreateChecked(group)\" md-indeterminate=\"isCreateIndeterminate(group)\" ng-click=\"toggleCreateAll(group)\">\nCreate</md-checkbox><md-checkbox ng-checked=\"group.whole_create\" ng-click=\"group.whole_create = !group.whole_create\">\n<i>* Create All</i></md-checkbox></div><div class=\"col-md-2\"><md-checkbox ng-checked=\"isEditChecked(group)\" \nmd-indeterminate=\"isEditIndeterminate(group)\" ng-click=\"toggleEditAll(group)\">Edit</md-checkbox><md-checkbox \nng-checked=\"group.whole_edit\" ng-click=\"group.whole_edit = !group.whole_edit\"><i>* Edit All</i></md-checkbox></div><div\n class=\"col-md-2\"><md-checkbox ng-checked=\"isDeleteChecked(group)\" md-indeterminate=\"isDeleteIndeterminate(group)\" \nng-click=\"toggleDeleteAll(group)\">Delete</md-checkbox><md-checkbox ng-checked=\"group.whole_delete\" \nng-click=\"group.whole_delete = !group.whole_delete\"><i>* Delete All</i></md-checkbox></div></div><div \nclass=\"row modelrow\" ng-show=\"(group.avail ? (group.avail === true) : false) && group.whole_models !== true\" \nng-repeat=\"model in group.models\"><div class=\"col-md-3 modelcolmain\"><md-checkbox class=\"md-primary\" \nng-checked=\"isModelChecked(model)\" ng-click=\"toggleModel(model)\"><i class=\"{{ model.icon }}\"></i> {{ model.name }}\n</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox class=\"md-primary\" ng-checked=\"model.m_view\" \nng-click=\"toggleViewModel(model)\">View</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"model.m_create\" ng-click=\"toggleCreateModel(model)\">Create</md-checkbox></div><div \nclass=\"col-md-2 modelcolsub\"><md-checkbox class=\"md-primary\" ng-checked=\"model.m_edit\" \nng-click=\"toggleEditModel(model)\">Edit</md-checkbox></div><div class=\"col-md-2 modelcolsub\"><md-checkbox \nclass=\"md-primary\" ng-checked=\"model.m_delete\" ng-click=\"toggleDeleteModel(model)\">Delete</md-checkbox></div></div>\n</div></div></div></form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4>\n<pre>{{ package | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ managepackage | json }}\n</pre></div></div></rd-window><rd-window header=\"Package Settings\" ng-show=\"package.package_sett.html !== \'\'\" \nfooter=\"Change Package Settings\"><form name=\"pkgSettings\" id=\"pkgSettings\" privatedata=\"package.package_sett.values\">\n<div bind-html-compile=\"package.package_sett.html\"></div></form><div class=\"row\" style=\"margin-top: 40px\" \nalign=\"right\"><div class=\"col-md-12\"><button type=\"submit\" class=\"btn btn-info m-t\" ng-click=\"updatePackage()\">\nUpdate Package</button></div></div></rd-window></div><style>\n.modelgrouprow {\r\n        border-top: 1.5px solid grey;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .modelrow {\r\n        border-top: 0.5px solid grey;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .modelrow:hover, .modelgrouprow:hover {\r\n        background-color: rgba(0,0,0,0.1);\r\n    }\r\n\r\n    .modelcolmain {\r\n        padding-left: 50px;\r\n    }\n</style>");
$templateCache.put("app/projects/rcloudsys/projects/projects/add_project/add_project.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"projects/list\" class=\"btn btn-primary m-t\">Back to Projects List</a></div></div><rd-window \nheader=\"Create a Project\" footer=\"Add Your Project and Control your Project with the Users.\" size=\"col-md-12\"><form \nrole=\"form\" name=\"addproject\" id=\"addproject\"><div class=\"row\"><selectbox quickattrs=\"product_fw\"></selectbox></div>\n<div class=\"row\"><textbox quickattrs=\"projectname\"></textbox><textbox quickattrs=\"projectid\"></textbox></div><div \nclass=\"row\"><textbox quickattrs=\"projecturl\" modelname=\"project_main_url\"></textbox><textbox quickattrs=\"projecturl\" \nitemid=\"projectotherurl\" modelname=\"project_other_url\"></textbox></div><div class=\"row\"><selectbox \nquickattrs=\"projectstatus\"></selectbox><div bind-html-compile=\"getIConBox()\"></div></div><div class=\"row\"><selectbox \nquickattrs=\"projectype\"></selectbox><selectbox quickattrs=\"projectstatus\" itemid=\"faq_required\" \nmodelname=\"faq_required\"></selectbox></div><div class=\"row\"><selectbox quickattrs=\"projectstatus\" \nitemid=\"support_required\" modelname=\"support_required\"></selectbox><selectbox quickattrs=\"product_category\">\n</selectbox></div><div class=\"row\"><div class=\"col-md-6\"><b>Preview</b><p><b><i \nng-if=\"addprojectData.project_fw === \'js\'\" class=\"{{ addprojectData.icon }}\"></i> <i \nng-if=\"addprojectData.project_fw === \'ts\'\" class=\"tiny material-icons\">{{ addprojectData.icon }}</i>\n {{ addprojectData.name }}</b></p></div></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" \nclass=\"btn btn-info m-t\" ng-disabled=\"addproject.$invalid\" ng-click=\"addProject()\">Add Project</button></div></div>\n</form><div class=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ addprojectData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>{{ addproject | json }}\n</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/projects/edit_project/edit_project.html","<div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"></div><div class=\"col-md-6\" \nalign=\"right\"><a href=\"projects/list\" class=\"btn btn-primary m-t\">Back to Projects List</a></div></div><rd-window \nheader=\"Edit Project\" footer=\"Edit a Current Project\" size=\"col-md-12\"><form role=\"form\" name=\"editproject\" \nid=\"editproject\"><div class=\"row\"><selectbox quickattrs=\"product_fw\"></selectbox></div><div class=\"row\"><textbox \nquickattrs=\"projectname\"></textbox><textbox quickattrs=\"projectid\" geturlcheck=\"false\" readonly=\"true\"></textbox></div>\n<div class=\"row\"><textbox quickattrs=\"projecturl\" modelname=\"project_main_url\"></textbox><textbox \nquickattrs=\"projecturl\" itemid=\"projectotherurl\" modelname=\"project_other_url\"></textbox></div><div class=\"row\">\n<selectbox quickattrs=\"projectstatus\"></selectbox><div bind-html-compile=\"getIConBox()\"></div></div><div class=\"row\">\n<selectbox quickattrs=\"projectype\"></selectbox><selectbox quickattrs=\"projectstatus\" itemid=\"faq_required\" \nmodelname=\"faq_required\"></selectbox></div><div class=\"row\"><selectbox quickattrs=\"projectstatus\" \nitemid=\"support_required\" modelname=\"support_required\"></selectbox><selectbox quickattrs=\"product_category\">\n</selectbox></div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-disabled=\"editproject.$invalid\" ng-click=\"updateProject()\">Update Project</button></div></div></form><div \nclass=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Form Live Value</h4><pre>\n{{ editprojectData | json }}</pre></div><div class=\"col-md-6\"><h4>Form Live Validation</h4><pre>\n{{ editproject | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/projects/list_project/list_project.html","<div class=\"row\"></div><div class=\"row\"><div class=\"row\" style=\"margin-bottom: 15px\"><div class=\"col-md-6\"><a \nng-click=\"backupProjects()\" class=\"btn btn-primary m-t\" style=\"float: left; margin-right: 25px\">Backup Projects</a>\n<form name=\"importProjectsForm\" id=\"importProjectsForm\"><input ng-show=\"backupDone\" type=\"file\" \nstyle=\"float: left; margin-top: 17px\" name=\"import_file\" id=\"import_file\" \nfileread=\"importProjectsFormData.import_file\" accept=\".rcloud\"></form><button ng-show=\"backupDone\" \nng-click=\"importProjects()\" ng-disabled=\"!importProjectsFormData.import_file\" class=\"btn btn-info m-t\">Import Projects\n</button></div><div class=\"col-md-6\" align=\"right\"><a href=\"projects/add\" class=\"btn btn-info m-t\">Create Project</a>\n</div></div></div><div class=\"row\"><rd-window header=\"Projects List\" \nfooter=\"Shows a Project List & Edit or Remove Project\" size=\"col-md-12\"><div class=\"row rownopadding\"><div \nclass=\"table-responsive\" width=\"100%\"><table class=\"table table-striped b-t b-b dt-responsive\" id=\"projectlisttable\">\n<thead></thead><tbody></tbody><tfoot></tfoot></table></div></div><div class=\"row\" ng-if=\"projectInfo.debugger\"><div \nclass=\"col-md-6\"><h4>Live Data from Server</h4><pre>{{ projectlst | json }}</pre></div></div></rd-window></div>");
$templateCache.put("app/projects/rcloudsys/projects/projects/project_tree/project_tree.html","<div class=\"row\"><rd-window header=\"Projects Tree View\" footer=\"Shows a Project in a Tree View\" size=\"col-md-12\"><form \nrole=\"form\" name=\"projecttree\" id=\"projecttree\"><div class=\"row\"><selectbox quickattrs=\"listprojects\"></selectbox>\n</div><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-info m-t\" \nng-disabled=\"projecttree.$invalid\" ng-click=\"getProjectTree()\">Get Project Tree</button></div></div></form><div \nclass=\"row\" ng-if=\"projectInfo.debugger\"><div class=\"col-md-6\"><h4>Live Form Data</h4><pre>{{ projecttreeData | json }}\n</pre><h4>Live Form Send Data</h4><pre>{{ treeData | json }}</pre></div><div class=\"col-md-6\"><h4>Live Form Validation\n</h4><pre>{{ projecttree | json }}</pre></div></div></rd-window></div><div class=\"row\"><rd-window \nheader=\"Complete Projects Tree\" footer=\"Shows a Project in a Tree View\" size=\"col-md-6\"><ul class=\"rdlist\" \nng-repeat=\"project in rData\"><li class=\"rditem\"><i class=\"{{ project.icon }}\"></i>{{ project.name }} <span>\n({{ project.projectid }})</span></li><ul class=\"rdlist\" ng-repeat=\"group in project.model_groups\"><li class=\"rditem\"><i\n class=\"{{ group.icon }}\"></i>{{ group.name }} <span>({{ group.modgrpid }})</span></li><ul class=\"rdlist\" \nng-repeat=\"model in group.models\"><li class=\"rditem\"><i class=\"{{ model.icon }}\"></i>{{ model.name }} <span>\n({{ model.modid }})</span></li></ul></ul></ul></rd-window><rd-window header=\"Complete Projects Data\" \nfooter=\"Shows a Project Data\" size=\"col-md-6\"><div class=\"row\"><pre>{{ rData | json }}</pre></div></rd-window></div>");}]);